class pb extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    this.innerHTML = String.raw`
    <div class="modal" tabindex="-1" id="project-yes-no-modal">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id='project-yes-no-modal-title'></h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body" id='project-yes-no-modal-body'></div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">No</button>
            <button type="button" class="btn btn-primary" data-bs-dismiss="modal" id="project-yes-no-modal-yes-button">Yes</button>
          </div>
        </div>
      </div>
    </div>

    <div class="modal" tabindex="-1" id="project-warning-modal">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id='project-warning-modal-title'><span class="fa fa-warning"></span> Warning</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body"><span id='project-warning-modal-body'></span></div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
          </div>
        </div>
      </div>
    </div>

    <div class="modal" tabindex="-1" id="modal-fullscreen-wait" data-bs-backdrop="static" data-bs-keyboard="false">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-body">
            <div class="d-flex justify-content-center">
              <span class="spinner-border" role="status"></span>
              <div id="modal-fullscreen-wait-message" class="mx-2 d-flex align-items-center">Loading...</div>
            </div>
          </div>
        </div>
      </div>
    </div>
      `;
  }
}
customElements.define("app-modal-component", pb);
class fb extends HTMLElement {
  connectedCallback() {
    this.innerHTML = String.raw`
  <footer class="py-5" style="background:#f7fbfe;">
    <div class="row" style="padding:20px;">
      <div class="col-6 col-md-2 mb-3">
        <p><a class="d-flex align-items-center mb-3 link-dark text-decoration-none" href="account.html">My Account</a></p>    
        <p><a class="d-flex align-items-center mb-3 link-dark text-decoration-none" href="about.html">About</a></p>
        <p><a class="d-flex align-items-center mb-3 link-dark text-decoration-none" href="eula.html">Terms of Service</a></p>
        <p><a class="d-flex align-items-center mb-3 link-dark text-decoration-none" href="mailto:jeff@webstructural.com">Support</a></p>
        <p class="text-muted">&copy; <strong><span>WebStructural 2024</span></strong></p>
      </div>

      <div class="col mb-3"></div>

      <div class="col mb-3">
        <h5>Software & Tools</h5>
        <ul class="nav flex-column">
        <li class="nav-item mb-2"><a class="nav-link p-0 text-muted" href="beam-designer.html">Beam Designer</a></li>
        <li class="nav-item mb-2"><a class="nav-link p-0 text-muted" href="anchor-bolt-designer.html">Anchor Bolt Designer</a></li>
        <li class="nav-item mb-2"><a class="nav-link p-0 text-muted" href="footing-designer.html">Concrete Footing Designer</a></li>
        <li class="nav-item mb-2"><a class="nav-link p-0 text-muted" href="shear-and-moment-diagram.html">Shear and Moment Diagrams</a></li>
        <li class="nav-item mb-2"><a class="nav-link p-0 text-muted" href="beam-calculator.html">Beam Calculator</a></li>
        <li class="nav-item mb-2"><a class="nav-link p-0 text-muted" href="cross-section-calculator.html">Shape Calculator</a></li>
        </ul>
      </div>

      <div class="col mb-3">
        <h5>Tutorials</h5>
        <ul class="nav flex-column">
          <li class="nav-item mb-2"><a class="nav-link p-0 text-muted" href="steel-beam-how-to.html">How to Design a Steel Beam</a></li>
          <li class="nav-item mb-2"><a class="nav-link p-0 text-muted" href="flitch-beam-how-to.html">How to Design a Wood Flitch Beam</a></li>
          <li class="nav-item mb-2"><a class="nav-link p-0 text-muted" href="save-steel-and-wood-beam-designs.html">How to Save a Beam Design</a></li>
          <li class="nav-item mb-2"><a class="nav-link p-0 text-muted" href="load-cases-and-load-combinations.html">Load Cases and Combinations</a></li>
          <li class="nav-item mb-2"><a class="nav-link p-0 text-muted" href="#">How to Design an Anchor Bolt - Coming Soon</a></li>
        </ul>
      </div>
    </div>
  </footer>
      `;
  }
}
customElements.define("footer-component", fb);
var je = "top", it = "bottom", ot = "right", We = "left", rc = "auto", Gr = [je, it, ot, We], gs = "start", mr = "end", Xm = "clippingParents", Vd = "viewport", Xs = "popper", Jm = "reference", Rl = /* @__PURE__ */ Gr.reduce(function(t, e) {
  return t.concat([e + "-" + gs, e + "-" + mr]);
}, []), Ud = /* @__PURE__ */ [].concat(Gr, [rc]).reduce(function(t, e) {
  return t.concat([e, e + "-" + gs, e + "-" + mr]);
}, []), Qm = "beforeRead", Zm = "read", e0 = "afterRead", t0 = "beforeMain", n0 = "main", s0 = "afterMain", r0 = "beforeWrite", i0 = "write", o0 = "afterWrite", a0 = [Qm, Zm, e0, t0, n0, s0, r0, i0, o0];
function Bt(t) {
  return t ? (t.nodeName || "").toLowerCase() : null;
}
function at(t) {
  if (t == null)
    return window;
  if (t.toString() !== "[object Window]") {
    var e = t.ownerDocument;
    return e && e.defaultView || window;
  }
  return t;
}
function _s(t) {
  var e = at(t).Element;
  return t instanceof e || t instanceof Element;
}
function ht(t) {
  var e = at(t).HTMLElement;
  return t instanceof e || t instanceof HTMLElement;
}
function Hd(t) {
  if (typeof ShadowRoot > "u")
    return !1;
  var e = at(t).ShadowRoot;
  return t instanceof e || t instanceof ShadowRoot;
}
function mb(t) {
  var e = t.state;
  Object.keys(e.elements).forEach(function(n) {
    var s = e.styles[n] || {}, r = e.attributes[n] || {}, i = e.elements[n];
    !ht(i) || !Bt(i) || (Object.assign(i.style, s), Object.keys(r).forEach(function(o) {
      var a = r[o];
      a === !1 ? i.removeAttribute(o) : i.setAttribute(o, a === !0 ? "" : a);
    }));
  });
}
function gb(t) {
  var e = t.state, n = {
    popper: {
      position: e.options.strategy,
      left: "0",
      top: "0",
      margin: "0"
    },
    arrow: {
      position: "absolute"
    },
    reference: {}
  };
  return Object.assign(e.elements.popper.style, n.popper), e.styles = n, e.elements.arrow && Object.assign(e.elements.arrow.style, n.arrow), function() {
    Object.keys(e.elements).forEach(function(s) {
      var r = e.elements[s], i = e.attributes[s] || {}, o = Object.keys(e.styles.hasOwnProperty(s) ? e.styles[s] : n[s]), a = o.reduce(function(c, l) {
        return c[l] = "", c;
      }, {});
      !ht(r) || !Bt(r) || (Object.assign(r.style, a), Object.keys(i).forEach(function(c) {
        r.removeAttribute(c);
      }));
    });
  };
}
const jd = {
  name: "applyStyles",
  enabled: !0,
  phase: "write",
  fn: mb,
  effect: gb,
  requires: ["computeStyles"]
};
function Pt(t) {
  return t.split("-")[0];
}
var ds = Math.max, ua = Math.min, gr = Math.round;
function xl() {
  var t = navigator.userAgentData;
  return t != null && t.brands && Array.isArray(t.brands) ? t.brands.map(function(e) {
    return e.brand + "/" + e.version;
  }).join(" ") : navigator.userAgent;
}
function c0() {
  return !/^((?!chrome|android).)*safari/i.test(xl());
}
function _r(t, e, n) {
  e === void 0 && (e = !1), n === void 0 && (n = !1);
  var s = t.getBoundingClientRect(), r = 1, i = 1;
  e && ht(t) && (r = t.offsetWidth > 0 && gr(s.width) / t.offsetWidth || 1, i = t.offsetHeight > 0 && gr(s.height) / t.offsetHeight || 1);
  var o = _s(t) ? at(t) : window, a = o.visualViewport, c = !c0() && n, l = (s.left + (c && a ? a.offsetLeft : 0)) / r, d = (s.top + (c && a ? a.offsetTop : 0)) / i, u = s.width / r, h = s.height / i;
  return {
    width: u,
    height: h,
    top: d,
    right: l + u,
    bottom: d + h,
    left: l,
    x: l,
    y: d
  };
}
function Wd(t) {
  var e = _r(t), n = t.offsetWidth, s = t.offsetHeight;
  return Math.abs(e.width - n) <= 1 && (n = e.width), Math.abs(e.height - s) <= 1 && (s = e.height), {
    x: t.offsetLeft,
    y: t.offsetTop,
    width: n,
    height: s
  };
}
function l0(t, e) {
  var n = e.getRootNode && e.getRootNode();
  if (t.contains(e))
    return !0;
  if (n && Hd(n)) {
    var s = e;
    do {
      if (s && t.isSameNode(s))
        return !0;
      s = s.parentNode || s.host;
    } while (s);
  }
  return !1;
}
function rn(t) {
  return at(t).getComputedStyle(t);
}
function _b(t) {
  return ["table", "td", "th"].indexOf(Bt(t)) >= 0;
}
function zn(t) {
  return ((_s(t) ? t.ownerDocument : (
    // $FlowFixMe[prop-missing]
    t.document
  )) || window.document).documentElement;
}
function ic(t) {
  return Bt(t) === "html" ? t : (
    // this is a quicker (but less type safe) way to save quite some bytes from the bundle
    // $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    t.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    t.parentNode || // DOM Element detected
    (Hd(t) ? t.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    zn(t)
  );
}
function Gh(t) {
  return !ht(t) || // https://github.com/popperjs/popper-core/issues/837
  rn(t).position === "fixed" ? null : t.offsetParent;
}
function yb(t) {
  var e = /firefox/i.test(xl()), n = /Trident/i.test(xl());
  if (n && ht(t)) {
    var s = rn(t);
    if (s.position === "fixed")
      return null;
  }
  var r = ic(t);
  for (Hd(r) && (r = r.host); ht(r) && ["html", "body"].indexOf(Bt(r)) < 0; ) {
    var i = rn(r);
    if (i.transform !== "none" || i.perspective !== "none" || i.contain === "paint" || ["transform", "perspective"].indexOf(i.willChange) !== -1 || e && i.willChange === "filter" || e && i.filter && i.filter !== "none")
      return r;
    r = r.parentNode;
  }
  return null;
}
function Yi(t) {
  for (var e = at(t), n = Gh(t); n && _b(n) && rn(n).position === "static"; )
    n = Gh(n);
  return n && (Bt(n) === "html" || Bt(n) === "body" && rn(n).position === "static") ? e : n || yb(t) || e;
}
function zd(t) {
  return ["top", "bottom"].indexOf(t) >= 0 ? "x" : "y";
}
function pi(t, e, n) {
  return ds(t, ua(e, n));
}
function Eb(t, e, n) {
  var s = pi(t, e, n);
  return s > n ? n : s;
}
function d0() {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  };
}
function u0(t) {
  return Object.assign({}, d0(), t);
}
function h0(t, e) {
  return e.reduce(function(n, s) {
    return n[s] = t, n;
  }, {});
}
var bb = function(e, n) {
  return e = typeof e == "function" ? e(Object.assign({}, n.rects, {
    placement: n.placement
  })) : e, u0(typeof e != "number" ? e : h0(e, Gr));
};
function vb(t) {
  var e, n = t.state, s = t.name, r = t.options, i = n.elements.arrow, o = n.modifiersData.popperOffsets, a = Pt(n.placement), c = zd(a), l = [We, ot].indexOf(a) >= 0, d = l ? "height" : "width";
  if (!(!i || !o)) {
    var u = bb(r.padding, n), h = Wd(i), p = c === "y" ? je : We, f = c === "y" ? it : ot, m = n.rects.reference[d] + n.rects.reference[c] - o[c] - n.rects.popper[d], g = o[c] - n.rects.reference[c], y = Yi(i), I = y ? c === "y" ? y.clientHeight || 0 : y.clientWidth || 0 : 0, A = m / 2 - g / 2, T = u[p], F = I - h[d] - u[f], _ = I / 2 - h[d] / 2 + A, E = pi(T, _, F), C = c;
    n.modifiersData[s] = (e = {}, e[C] = E, e.centerOffset = E - _, e);
  }
}
function Sb(t) {
  var e = t.state, n = t.options, s = n.element, r = s === void 0 ? "[data-popper-arrow]" : s;
  r != null && (typeof r == "string" && (r = e.elements.popper.querySelector(r), !r) || l0(e.elements.popper, r) && (e.elements.arrow = r));
}
const p0 = {
  name: "arrow",
  enabled: !0,
  phase: "main",
  fn: vb,
  effect: Sb,
  requires: ["popperOffsets"],
  requiresIfExists: ["preventOverflow"]
};
function yr(t) {
  return t.split("-")[1];
}
var wb = {
  top: "auto",
  right: "auto",
  bottom: "auto",
  left: "auto"
};
function Tb(t, e) {
  var n = t.x, s = t.y, r = e.devicePixelRatio || 1;
  return {
    x: gr(n * r) / r || 0,
    y: gr(s * r) / r || 0
  };
}
function Bh(t) {
  var e, n = t.popper, s = t.popperRect, r = t.placement, i = t.variation, o = t.offsets, a = t.position, c = t.gpuAcceleration, l = t.adaptive, d = t.roundOffsets, u = t.isFixed, h = o.x, p = h === void 0 ? 0 : h, f = o.y, m = f === void 0 ? 0 : f, g = typeof d == "function" ? d({
    x: p,
    y: m
  }) : {
    x: p,
    y: m
  };
  p = g.x, m = g.y;
  var y = o.hasOwnProperty("x"), I = o.hasOwnProperty("y"), A = We, T = je, F = window;
  if (l) {
    var _ = Yi(n), E = "clientHeight", C = "clientWidth";
    if (_ === at(n) && (_ = zn(n), rn(_).position !== "static" && a === "absolute" && (E = "scrollHeight", C = "scrollWidth")), _ = _, r === je || (r === We || r === ot) && i === mr) {
      T = it;
      var N = u && _ === F && F.visualViewport ? F.visualViewport.height : (
        // $FlowFixMe[prop-missing]
        _[E]
      );
      m -= N - s.height, m *= c ? 1 : -1;
    }
    if (r === We || (r === je || r === it) && i === mr) {
      A = ot;
      var v = u && _ === F && F.visualViewport ? F.visualViewport.width : (
        // $FlowFixMe[prop-missing]
        _[C]
      );
      p -= v - s.width, p *= c ? 1 : -1;
    }
  }
  var k = Object.assign({
    position: a
  }, l && wb), L = d === !0 ? Tb({
    x: p,
    y: m
  }, at(n)) : {
    x: p,
    y: m
  };
  if (p = L.x, m = L.y, c) {
    var $;
    return Object.assign({}, k, ($ = {}, $[T] = I ? "0" : "", $[A] = y ? "0" : "", $.transform = (F.devicePixelRatio || 1) <= 1 ? "translate(" + p + "px, " + m + "px)" : "translate3d(" + p + "px, " + m + "px, 0)", $));
  }
  return Object.assign({}, k, (e = {}, e[T] = I ? m + "px" : "", e[A] = y ? p + "px" : "", e.transform = "", e));
}
function Ib(t) {
  var e = t.state, n = t.options, s = n.gpuAcceleration, r = s === void 0 ? !0 : s, i = n.adaptive, o = i === void 0 ? !0 : i, a = n.roundOffsets, c = a === void 0 ? !0 : a, l = {
    placement: Pt(e.placement),
    variation: yr(e.placement),
    popper: e.elements.popper,
    popperRect: e.rects.popper,
    gpuAcceleration: r,
    isFixed: e.options.strategy === "fixed"
  };
  e.modifiersData.popperOffsets != null && (e.styles.popper = Object.assign({}, e.styles.popper, Bh(Object.assign({}, l, {
    offsets: e.modifiersData.popperOffsets,
    position: e.options.strategy,
    adaptive: o,
    roundOffsets: c
  })))), e.modifiersData.arrow != null && (e.styles.arrow = Object.assign({}, e.styles.arrow, Bh(Object.assign({}, l, {
    offsets: e.modifiersData.arrow,
    position: "absolute",
    adaptive: !1,
    roundOffsets: c
  })))), e.attributes.popper = Object.assign({}, e.attributes.popper, {
    "data-popper-placement": e.placement
  });
}
const qd = {
  name: "computeStyles",
  enabled: !0,
  phase: "beforeWrite",
  fn: Ib,
  data: {}
};
var Io = {
  passive: !0
};
function Cb(t) {
  var e = t.state, n = t.instance, s = t.options, r = s.scroll, i = r === void 0 ? !0 : r, o = s.resize, a = o === void 0 ? !0 : o, c = at(e.elements.popper), l = [].concat(e.scrollParents.reference, e.scrollParents.popper);
  return i && l.forEach(function(d) {
    d.addEventListener("scroll", n.update, Io);
  }), a && c.addEventListener("resize", n.update, Io), function() {
    i && l.forEach(function(d) {
      d.removeEventListener("scroll", n.update, Io);
    }), a && c.removeEventListener("resize", n.update, Io);
  };
}
const Yd = {
  name: "eventListeners",
  enabled: !0,
  phase: "write",
  fn: function() {
  },
  effect: Cb,
  data: {}
};
var Fb = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
};
function Ko(t) {
  return t.replace(/left|right|bottom|top/g, function(e) {
    return Fb[e];
  });
}
var kb = {
  start: "end",
  end: "start"
};
function $h(t) {
  return t.replace(/start|end/g, function(e) {
    return kb[e];
  });
}
function Kd(t) {
  var e = at(t), n = e.pageXOffset, s = e.pageYOffset;
  return {
    scrollLeft: n,
    scrollTop: s
  };
}
function Xd(t) {
  return _r(zn(t)).left + Kd(t).scrollLeft;
}
function Ab(t, e) {
  var n = at(t), s = zn(t), r = n.visualViewport, i = s.clientWidth, o = s.clientHeight, a = 0, c = 0;
  if (r) {
    i = r.width, o = r.height;
    var l = c0();
    (l || !l && e === "fixed") && (a = r.offsetLeft, c = r.offsetTop);
  }
  return {
    width: i,
    height: o,
    x: a + Xd(t),
    y: c
  };
}
function Nb(t) {
  var e, n = zn(t), s = Kd(t), r = (e = t.ownerDocument) == null ? void 0 : e.body, i = ds(n.scrollWidth, n.clientWidth, r ? r.scrollWidth : 0, r ? r.clientWidth : 0), o = ds(n.scrollHeight, n.clientHeight, r ? r.scrollHeight : 0, r ? r.clientHeight : 0), a = -s.scrollLeft + Xd(t), c = -s.scrollTop;
  return rn(r || n).direction === "rtl" && (a += ds(n.clientWidth, r ? r.clientWidth : 0) - i), {
    width: i,
    height: o,
    x: a,
    y: c
  };
}
function Jd(t) {
  var e = rn(t), n = e.overflow, s = e.overflowX, r = e.overflowY;
  return /auto|scroll|overlay|hidden/.test(n + r + s);
}
function f0(t) {
  return ["html", "body", "#document"].indexOf(Bt(t)) >= 0 ? t.ownerDocument.body : ht(t) && Jd(t) ? t : f0(ic(t));
}
function fi(t, e) {
  var n;
  e === void 0 && (e = []);
  var s = f0(t), r = s === ((n = t.ownerDocument) == null ? void 0 : n.body), i = at(s), o = r ? [i].concat(i.visualViewport || [], Jd(s) ? s : []) : s, a = e.concat(o);
  return r ? a : (
    // $FlowFixMe[incompatible-call]: isBody tells us target will be an HTMLElement here
    a.concat(fi(ic(o)))
  );
}
function Ol(t) {
  return Object.assign({}, t, {
    left: t.x,
    top: t.y,
    right: t.x + t.width,
    bottom: t.y + t.height
  });
}
function Lb(t, e) {
  var n = _r(t, !1, e === "fixed");
  return n.top = n.top + t.clientTop, n.left = n.left + t.clientLeft, n.bottom = n.top + t.clientHeight, n.right = n.left + t.clientWidth, n.width = t.clientWidth, n.height = t.clientHeight, n.x = n.left, n.y = n.top, n;
}
function Vh(t, e, n) {
  return e === Vd ? Ol(Ab(t, n)) : _s(e) ? Lb(e, n) : Ol(Nb(zn(t)));
}
function Rb(t) {
  var e = fi(ic(t)), n = ["absolute", "fixed"].indexOf(rn(t).position) >= 0, s = n && ht(t) ? Yi(t) : t;
  return _s(s) ? e.filter(function(r) {
    return _s(r) && l0(r, s) && Bt(r) !== "body";
  }) : [];
}
function xb(t, e, n, s) {
  var r = e === "clippingParents" ? Rb(t) : [].concat(e), i = [].concat(r, [n]), o = i[0], a = i.reduce(function(c, l) {
    var d = Vh(t, l, s);
    return c.top = ds(d.top, c.top), c.right = ua(d.right, c.right), c.bottom = ua(d.bottom, c.bottom), c.left = ds(d.left, c.left), c;
  }, Vh(t, o, s));
  return a.width = a.right - a.left, a.height = a.bottom - a.top, a.x = a.left, a.y = a.top, a;
}
function m0(t) {
  var e = t.reference, n = t.element, s = t.placement, r = s ? Pt(s) : null, i = s ? yr(s) : null, o = e.x + e.width / 2 - n.width / 2, a = e.y + e.height / 2 - n.height / 2, c;
  switch (r) {
    case je:
      c = {
        x: o,
        y: e.y - n.height
      };
      break;
    case it:
      c = {
        x: o,
        y: e.y + e.height
      };
      break;
    case ot:
      c = {
        x: e.x + e.width,
        y: a
      };
      break;
    case We:
      c = {
        x: e.x - n.width,
        y: a
      };
      break;
    default:
      c = {
        x: e.x,
        y: e.y
      };
  }
  var l = r ? zd(r) : null;
  if (l != null) {
    var d = l === "y" ? "height" : "width";
    switch (i) {
      case gs:
        c[l] = c[l] - (e[d] / 2 - n[d] / 2);
        break;
      case mr:
        c[l] = c[l] + (e[d] / 2 - n[d] / 2);
        break;
    }
  }
  return c;
}
function Er(t, e) {
  e === void 0 && (e = {});
  var n = e, s = n.placement, r = s === void 0 ? t.placement : s, i = n.strategy, o = i === void 0 ? t.strategy : i, a = n.boundary, c = a === void 0 ? Xm : a, l = n.rootBoundary, d = l === void 0 ? Vd : l, u = n.elementContext, h = u === void 0 ? Xs : u, p = n.altBoundary, f = p === void 0 ? !1 : p, m = n.padding, g = m === void 0 ? 0 : m, y = u0(typeof g != "number" ? g : h0(g, Gr)), I = h === Xs ? Jm : Xs, A = t.rects.popper, T = t.elements[f ? I : h], F = xb(_s(T) ? T : T.contextElement || zn(t.elements.popper), c, d, o), _ = _r(t.elements.reference), E = m0({
    reference: _,
    element: A,
    strategy: "absolute",
    placement: r
  }), C = Ol(Object.assign({}, A, E)), N = h === Xs ? C : _, v = {
    top: F.top - N.top + y.top,
    bottom: N.bottom - F.bottom + y.bottom,
    left: F.left - N.left + y.left,
    right: N.right - F.right + y.right
  }, k = t.modifiersData.offset;
  if (h === Xs && k) {
    var L = k[r];
    Object.keys(v).forEach(function($) {
      var ee = [ot, it].indexOf($) >= 0 ? 1 : -1, pe = [je, it].indexOf($) >= 0 ? "y" : "x";
      v[$] += L[pe] * ee;
    });
  }
  return v;
}
function Ob(t, e) {
  e === void 0 && (e = {});
  var n = e, s = n.placement, r = n.boundary, i = n.rootBoundary, o = n.padding, a = n.flipVariations, c = n.allowedAutoPlacements, l = c === void 0 ? Ud : c, d = yr(s), u = d ? a ? Rl : Rl.filter(function(f) {
    return yr(f) === d;
  }) : Gr, h = u.filter(function(f) {
    return l.indexOf(f) >= 0;
  });
  h.length === 0 && (h = u);
  var p = h.reduce(function(f, m) {
    return f[m] = Er(t, {
      placement: m,
      boundary: r,
      rootBoundary: i,
      padding: o
    })[Pt(m)], f;
  }, {});
  return Object.keys(p).sort(function(f, m) {
    return p[f] - p[m];
  });
}
function Pb(t) {
  if (Pt(t) === rc)
    return [];
  var e = Ko(t);
  return [$h(t), e, $h(e)];
}
function Mb(t) {
  var e = t.state, n = t.options, s = t.name;
  if (!e.modifiersData[s]._skip) {
    for (var r = n.mainAxis, i = r === void 0 ? !0 : r, o = n.altAxis, a = o === void 0 ? !0 : o, c = n.fallbackPlacements, l = n.padding, d = n.boundary, u = n.rootBoundary, h = n.altBoundary, p = n.flipVariations, f = p === void 0 ? !0 : p, m = n.allowedAutoPlacements, g = e.options.placement, y = Pt(g), I = y === g, A = c || (I || !f ? [Ko(g)] : Pb(g)), T = [g].concat(A).reduce(function(ct, lt) {
      return ct.concat(Pt(lt) === rc ? Ob(e, {
        placement: lt,
        boundary: d,
        rootBoundary: u,
        padding: l,
        flipVariations: f,
        allowedAutoPlacements: m
      }) : lt);
    }, []), F = e.rects.reference, _ = e.rects.popper, E = /* @__PURE__ */ new Map(), C = !0, N = T[0], v = 0; v < T.length; v++) {
      var k = T[v], L = Pt(k), $ = yr(k) === gs, ee = [je, it].indexOf(L) >= 0, pe = ee ? "width" : "height", R = Er(e, {
        placement: k,
        boundary: d,
        rootBoundary: u,
        altBoundary: h,
        padding: l
      }), re = ee ? $ ? ot : We : $ ? it : je;
      F[pe] > _[pe] && (re = Ko(re));
      var q = Ko(re), ge = [];
      if (i && ge.push(R[L] <= 0), a && ge.push(R[re] <= 0, R[q] <= 0), ge.every(function(ct) {
        return ct;
      })) {
        N = k, C = !1;
        break;
      }
      E.set(k, ge);
    }
    if (C)
      for (var Xe = f ? 3 : 1, Bs = function(lt) {
        var Ut = T.find(function(yn) {
          var bt = E.get(yn);
          if (bt)
            return bt.slice(0, lt).every(function($s) {
              return $s;
            });
        });
        if (Ut)
          return N = Ut, "break";
      }, es = Xe; es > 0; es--) {
        var Vt = Bs(es);
        if (Vt === "break") break;
      }
    e.placement !== N && (e.modifiersData[s]._skip = !0, e.placement = N, e.reset = !0);
  }
}
const g0 = {
  name: "flip",
  enabled: !0,
  phase: "main",
  fn: Mb,
  requiresIfExists: ["offset"],
  data: {
    _skip: !1
  }
};
function Uh(t, e, n) {
  return n === void 0 && (n = {
    x: 0,
    y: 0
  }), {
    top: t.top - e.height - n.y,
    right: t.right - e.width + n.x,
    bottom: t.bottom - e.height + n.y,
    left: t.left - e.width - n.x
  };
}
function Hh(t) {
  return [je, ot, it, We].some(function(e) {
    return t[e] >= 0;
  });
}
function Db(t) {
  var e = t.state, n = t.name, s = e.rects.reference, r = e.rects.popper, i = e.modifiersData.preventOverflow, o = Er(e, {
    elementContext: "reference"
  }), a = Er(e, {
    altBoundary: !0
  }), c = Uh(o, s), l = Uh(a, r, i), d = Hh(c), u = Hh(l);
  e.modifiersData[n] = {
    referenceClippingOffsets: c,
    popperEscapeOffsets: l,
    isReferenceHidden: d,
    hasPopperEscaped: u
  }, e.attributes.popper = Object.assign({}, e.attributes.popper, {
    "data-popper-reference-hidden": d,
    "data-popper-escaped": u
  });
}
const _0 = {
  name: "hide",
  enabled: !0,
  phase: "main",
  requiresIfExists: ["preventOverflow"],
  fn: Db
};
function Gb(t, e, n) {
  var s = Pt(t), r = [We, je].indexOf(s) >= 0 ? -1 : 1, i = typeof n == "function" ? n(Object.assign({}, e, {
    placement: t
  })) : n, o = i[0], a = i[1];
  return o = o || 0, a = (a || 0) * r, [We, ot].indexOf(s) >= 0 ? {
    x: a,
    y: o
  } : {
    x: o,
    y: a
  };
}
function Bb(t) {
  var e = t.state, n = t.options, s = t.name, r = n.offset, i = r === void 0 ? [0, 0] : r, o = Ud.reduce(function(d, u) {
    return d[u] = Gb(u, e.rects, i), d;
  }, {}), a = o[e.placement], c = a.x, l = a.y;
  e.modifiersData.popperOffsets != null && (e.modifiersData.popperOffsets.x += c, e.modifiersData.popperOffsets.y += l), e.modifiersData[s] = o;
}
const y0 = {
  name: "offset",
  enabled: !0,
  phase: "main",
  requires: ["popperOffsets"],
  fn: Bb
};
function $b(t) {
  var e = t.state, n = t.name;
  e.modifiersData[n] = m0({
    reference: e.rects.reference,
    element: e.rects.popper,
    strategy: "absolute",
    placement: e.placement
  });
}
const Qd = {
  name: "popperOffsets",
  enabled: !0,
  phase: "read",
  fn: $b,
  data: {}
};
function Vb(t) {
  return t === "x" ? "y" : "x";
}
function Ub(t) {
  var e = t.state, n = t.options, s = t.name, r = n.mainAxis, i = r === void 0 ? !0 : r, o = n.altAxis, a = o === void 0 ? !1 : o, c = n.boundary, l = n.rootBoundary, d = n.altBoundary, u = n.padding, h = n.tether, p = h === void 0 ? !0 : h, f = n.tetherOffset, m = f === void 0 ? 0 : f, g = Er(e, {
    boundary: c,
    rootBoundary: l,
    padding: u,
    altBoundary: d
  }), y = Pt(e.placement), I = yr(e.placement), A = !I, T = zd(y), F = Vb(T), _ = e.modifiersData.popperOffsets, E = e.rects.reference, C = e.rects.popper, N = typeof m == "function" ? m(Object.assign({}, e.rects, {
    placement: e.placement
  })) : m, v = typeof N == "number" ? {
    mainAxis: N,
    altAxis: N
  } : Object.assign({
    mainAxis: 0,
    altAxis: 0
  }, N), k = e.modifiersData.offset ? e.modifiersData.offset[e.placement] : null, L = {
    x: 0,
    y: 0
  };
  if (_) {
    if (i) {
      var $, ee = T === "y" ? je : We, pe = T === "y" ? it : ot, R = T === "y" ? "height" : "width", re = _[T], q = re + g[ee], ge = re - g[pe], Xe = p ? -C[R] / 2 : 0, Bs = I === gs ? E[R] : C[R], es = I === gs ? -C[R] : -E[R], Vt = e.elements.arrow, ct = p && Vt ? Wd(Vt) : {
        width: 0,
        height: 0
      }, lt = e.modifiersData["arrow#persistent"] ? e.modifiersData["arrow#persistent"].padding : d0(), Ut = lt[ee], yn = lt[pe], bt = pi(0, E[R], ct[R]), $s = A ? E[R] / 2 - Xe - bt - Ut - v.mainAxis : Bs - bt - Ut - v.mainAxis, Vs = A ? -E[R] / 2 + Xe + bt + yn + v.mainAxis : es + bt + yn + v.mainAxis, Us = e.elements.arrow && Yi(e.elements.arrow), Vc = Us ? T === "y" ? Us.clientTop || 0 : Us.clientLeft || 0 : 0, wo = ($ = k == null ? void 0 : k[T]) != null ? $ : 0, Ht = re + $s - wo - Vc, jt = re + Vs - wo, Hs = pi(p ? ua(q, Ht) : q, re, p ? ds(ge, jt) : ge);
      _[T] = Hs, L[T] = Hs - re;
    }
    if (a) {
      var js, Ws = T === "x" ? je : We, ti = T === "x" ? it : ot, j = _[F], Ge = F === "y" ? "height" : "width", Y = j + g[Ws], ae = j - g[ti], Q = [je, We].indexOf(y) !== -1, At = (js = k == null ? void 0 : k[F]) != null ? js : 0, To = Q ? Y : j - E[Ge] - C[Ge] - At + v.altAxis, Mh = Q ? j + E[Ge] + C[Ge] - At - v.altAxis : ae, Dh = p && Q ? Eb(To, j, Mh) : pi(p ? To : Y, j, p ? Mh : ae);
      _[F] = Dh, L[F] = Dh - j;
    }
    e.modifiersData[s] = L;
  }
}
const E0 = {
  name: "preventOverflow",
  enabled: !0,
  phase: "main",
  fn: Ub,
  requiresIfExists: ["offset"]
};
function Hb(t) {
  return {
    scrollLeft: t.scrollLeft,
    scrollTop: t.scrollTop
  };
}
function jb(t) {
  return t === at(t) || !ht(t) ? Kd(t) : Hb(t);
}
function Wb(t) {
  var e = t.getBoundingClientRect(), n = gr(e.width) / t.offsetWidth || 1, s = gr(e.height) / t.offsetHeight || 1;
  return n !== 1 || s !== 1;
}
function zb(t, e, n) {
  n === void 0 && (n = !1);
  var s = ht(e), r = ht(e) && Wb(e), i = zn(e), o = _r(t, r, n), a = {
    scrollLeft: 0,
    scrollTop: 0
  }, c = {
    x: 0,
    y: 0
  };
  return (s || !s && !n) && ((Bt(e) !== "body" || // https://github.com/popperjs/popper-core/issues/1078
  Jd(i)) && (a = jb(e)), ht(e) ? (c = _r(e, !0), c.x += e.clientLeft, c.y += e.clientTop) : i && (c.x = Xd(i))), {
    x: o.left + a.scrollLeft - c.x,
    y: o.top + a.scrollTop - c.y,
    width: o.width,
    height: o.height
  };
}
function qb(t) {
  var e = /* @__PURE__ */ new Map(), n = /* @__PURE__ */ new Set(), s = [];
  t.forEach(function(i) {
    e.set(i.name, i);
  });
  function r(i) {
    n.add(i.name);
    var o = [].concat(i.requires || [], i.requiresIfExists || []);
    o.forEach(function(a) {
      if (!n.has(a)) {
        var c = e.get(a);
        c && r(c);
      }
    }), s.push(i);
  }
  return t.forEach(function(i) {
    n.has(i.name) || r(i);
  }), s;
}
function Yb(t) {
  var e = qb(t);
  return a0.reduce(function(n, s) {
    return n.concat(e.filter(function(r) {
      return r.phase === s;
    }));
  }, []);
}
function Kb(t) {
  var e;
  return function() {
    return e || (e = new Promise(function(n) {
      Promise.resolve().then(function() {
        e = void 0, n(t());
      });
    })), e;
  };
}
function Xb(t) {
  var e = t.reduce(function(n, s) {
    var r = n[s.name];
    return n[s.name] = r ? Object.assign({}, r, s, {
      options: Object.assign({}, r.options, s.options),
      data: Object.assign({}, r.data, s.data)
    }) : s, n;
  }, {});
  return Object.keys(e).map(function(n) {
    return e[n];
  });
}
var jh = {
  placement: "bottom",
  modifiers: [],
  strategy: "absolute"
};
function Wh() {
  for (var t = arguments.length, e = new Array(t), n = 0; n < t; n++)
    e[n] = arguments[n];
  return !e.some(function(s) {
    return !(s && typeof s.getBoundingClientRect == "function");
  });
}
function oc(t) {
  t === void 0 && (t = {});
  var e = t, n = e.defaultModifiers, s = n === void 0 ? [] : n, r = e.defaultOptions, i = r === void 0 ? jh : r;
  return function(a, c, l) {
    l === void 0 && (l = i);
    var d = {
      placement: "bottom",
      orderedModifiers: [],
      options: Object.assign({}, jh, i),
      modifiersData: {},
      elements: {
        reference: a,
        popper: c
      },
      attributes: {},
      styles: {}
    }, u = [], h = !1, p = {
      state: d,
      setOptions: function(y) {
        var I = typeof y == "function" ? y(d.options) : y;
        m(), d.options = Object.assign({}, i, d.options, I), d.scrollParents = {
          reference: _s(a) ? fi(a) : a.contextElement ? fi(a.contextElement) : [],
          popper: fi(c)
        };
        var A = Yb(Xb([].concat(s, d.options.modifiers)));
        return d.orderedModifiers = A.filter(function(T) {
          return T.enabled;
        }), f(), p.update();
      },
      // Sync update – it will always be executed, even if not necessary. This
      // is useful for low frequency updates where sync behavior simplifies the
      // logic.
      // For high frequency updates (e.g. `resize` and `scroll` events), always
      // prefer the async Popper#update method
      forceUpdate: function() {
        if (!h) {
          var y = d.elements, I = y.reference, A = y.popper;
          if (Wh(I, A)) {
            d.rects = {
              reference: zb(I, Yi(A), d.options.strategy === "fixed"),
              popper: Wd(A)
            }, d.reset = !1, d.placement = d.options.placement, d.orderedModifiers.forEach(function(v) {
              return d.modifiersData[v.name] = Object.assign({}, v.data);
            });
            for (var T = 0; T < d.orderedModifiers.length; T++) {
              if (d.reset === !0) {
                d.reset = !1, T = -1;
                continue;
              }
              var F = d.orderedModifiers[T], _ = F.fn, E = F.options, C = E === void 0 ? {} : E, N = F.name;
              typeof _ == "function" && (d = _({
                state: d,
                options: C,
                name: N,
                instance: p
              }) || d);
            }
          }
        }
      },
      // Async and optimistically optimized update – it will not be executed if
      // not necessary (debounced to run at most once-per-tick)
      update: Kb(function() {
        return new Promise(function(g) {
          p.forceUpdate(), g(d);
        });
      }),
      destroy: function() {
        m(), h = !0;
      }
    };
    if (!Wh(a, c))
      return p;
    p.setOptions(l).then(function(g) {
      !h && l.onFirstUpdate && l.onFirstUpdate(g);
    });
    function f() {
      d.orderedModifiers.forEach(function(g) {
        var y = g.name, I = g.options, A = I === void 0 ? {} : I, T = g.effect;
        if (typeof T == "function") {
          var F = T({
            state: d,
            name: y,
            instance: p,
            options: A
          }), _ = function() {
          };
          u.push(F || _);
        }
      });
    }
    function m() {
      u.forEach(function(g) {
        return g();
      }), u = [];
    }
    return p;
  };
}
var Jb = /* @__PURE__ */ oc(), Qb = [Yd, Qd, qd, jd], Zb = /* @__PURE__ */ oc({
  defaultModifiers: Qb
}), ev = [Yd, Qd, qd, jd, y0, g0, E0, p0, _0], Zd = /* @__PURE__ */ oc({
  defaultModifiers: ev
});
const b0 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  afterMain: s0,
  afterRead: e0,
  afterWrite: o0,
  applyStyles: jd,
  arrow: p0,
  auto: rc,
  basePlacements: Gr,
  beforeMain: t0,
  beforeRead: Qm,
  beforeWrite: r0,
  bottom: it,
  clippingParents: Xm,
  computeStyles: qd,
  createPopper: Zd,
  createPopperBase: Jb,
  createPopperLite: Zb,
  detectOverflow: Er,
  end: mr,
  eventListeners: Yd,
  flip: g0,
  hide: _0,
  left: We,
  main: n0,
  modifierPhases: a0,
  offset: y0,
  placements: Ud,
  popper: Xs,
  popperGenerator: oc,
  popperOffsets: Qd,
  preventOverflow: E0,
  read: Zm,
  reference: Jm,
  right: ot,
  start: gs,
  top: je,
  variationPlacements: Rl,
  viewport: Vd,
  write: i0
}, Symbol.toStringTag, { value: "Module" }));
/*!
  * Bootstrap v5.3.3 (https://getbootstrap.com/)
  * Copyright 2011-2024 The Bootstrap Authors (https://github.com/twbs/bootstrap/graphs/contributors)
  * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
  */
const En = /* @__PURE__ */ new Map(), Uc = {
  set(t, e, n) {
    En.has(t) || En.set(t, /* @__PURE__ */ new Map());
    const s = En.get(t);
    if (!s.has(e) && s.size !== 0) {
      console.error(`Bootstrap doesn't allow more than one instance per element. Bound instance: ${Array.from(s.keys())[0]}.`);
      return;
    }
    s.set(e, n);
  },
  get(t, e) {
    return En.has(t) && En.get(t).get(e) || null;
  },
  remove(t, e) {
    if (!En.has(t))
      return;
    const n = En.get(t);
    n.delete(e), n.size === 0 && En.delete(t);
  }
}, tv = 1e6, nv = 1e3, Pl = "transitionend", v0 = (t) => (t && window.CSS && window.CSS.escape && (t = t.replace(/#([^\s"#']+)/g, (e, n) => `#${CSS.escape(n)}`)), t), sv = (t) => t == null ? `${t}` : Object.prototype.toString.call(t).match(/\s([a-z]+)/i)[1].toLowerCase(), rv = (t) => {
  do
    t += Math.floor(Math.random() * tv);
  while (document.getElementById(t));
  return t;
}, iv = (t) => {
  if (!t)
    return 0;
  let {
    transitionDuration: e,
    transitionDelay: n
  } = window.getComputedStyle(t);
  const s = Number.parseFloat(e), r = Number.parseFloat(n);
  return !s && !r ? 0 : (e = e.split(",")[0], n = n.split(",")[0], (Number.parseFloat(e) + Number.parseFloat(n)) * nv);
}, S0 = (t) => {
  t.dispatchEvent(new Event(Pl));
}, Zt = (t) => !t || typeof t != "object" ? !1 : (typeof t.jquery < "u" && (t = t[0]), typeof t.nodeType < "u"), Bn = (t) => Zt(t) ? t.jquery ? t[0] : t : typeof t == "string" && t.length > 0 ? document.querySelector(v0(t)) : null, Br = (t) => {
  if (!Zt(t) || t.getClientRects().length === 0)
    return !1;
  const e = getComputedStyle(t).getPropertyValue("visibility") === "visible", n = t.closest("details:not([open])");
  if (!n)
    return e;
  if (n !== t) {
    const s = t.closest("summary");
    if (s && s.parentNode !== n || s === null)
      return !1;
  }
  return e;
}, $n = (t) => !t || t.nodeType !== Node.ELEMENT_NODE || t.classList.contains("disabled") ? !0 : typeof t.disabled < "u" ? t.disabled : t.hasAttribute("disabled") && t.getAttribute("disabled") !== "false", w0 = (t) => {
  if (!document.documentElement.attachShadow)
    return null;
  if (typeof t.getRootNode == "function") {
    const e = t.getRootNode();
    return e instanceof ShadowRoot ? e : null;
  }
  return t instanceof ShadowRoot ? t : t.parentNode ? w0(t.parentNode) : null;
}, ha = () => {
}, Ki = (t) => {
  t.offsetHeight;
}, T0 = () => window.jQuery && !document.body.hasAttribute("data-bs-no-jquery") ? window.jQuery : null, Hc = [], ov = (t) => {
  document.readyState === "loading" ? (Hc.length || document.addEventListener("DOMContentLoaded", () => {
    for (const e of Hc)
      e();
  }), Hc.push(t)) : t();
}, ft = () => document.documentElement.dir === "rtl", yt = (t) => {
  ov(() => {
    const e = T0();
    if (e) {
      const n = t.NAME, s = e.fn[n];
      e.fn[n] = t.jQueryInterface, e.fn[n].Constructor = t, e.fn[n].noConflict = () => (e.fn[n] = s, t.jQueryInterface);
    }
  });
}, Ze = (t, e = [], n = t) => typeof t == "function" ? t(...e) : n, I0 = (t, e, n = !0) => {
  if (!n) {
    Ze(t);
    return;
  }
  const r = iv(e) + 5;
  let i = !1;
  const o = ({
    target: a
  }) => {
    a === e && (i = !0, e.removeEventListener(Pl, o), Ze(t));
  };
  e.addEventListener(Pl, o), setTimeout(() => {
    i || S0(e);
  }, r);
}, eu = (t, e, n, s) => {
  const r = t.length;
  let i = t.indexOf(e);
  return i === -1 ? !n && s ? t[r - 1] : t[0] : (i += n ? 1 : -1, s && (i = (i + r) % r), t[Math.max(0, Math.min(i, r - 1))]);
}, av = /[^.]*(?=\..*)\.|.*/, cv = /\..*/, lv = /::\d+$/, jc = {};
let zh = 1;
const C0 = {
  mouseenter: "mouseover",
  mouseleave: "mouseout"
}, dv = /* @__PURE__ */ new Set(["click", "dblclick", "mouseup", "mousedown", "contextmenu", "mousewheel", "DOMMouseScroll", "mouseover", "mouseout", "mousemove", "selectstart", "selectend", "keydown", "keypress", "keyup", "orientationchange", "touchstart", "touchmove", "touchend", "touchcancel", "pointerdown", "pointermove", "pointerup", "pointerleave", "pointercancel", "gesturestart", "gesturechange", "gestureend", "focus", "blur", "change", "reset", "select", "submit", "focusin", "focusout", "load", "unload", "beforeunload", "resize", "move", "DOMContentLoaded", "readystatechange", "error", "abort", "scroll"]);
function F0(t, e) {
  return e && `${e}::${zh++}` || t.uidEvent || zh++;
}
function k0(t) {
  const e = F0(t);
  return t.uidEvent = e, jc[e] = jc[e] || {}, jc[e];
}
function uv(t, e) {
  return function n(s) {
    return tu(s, {
      delegateTarget: t
    }), n.oneOff && b.off(t, s.type, e), e.apply(t, [s]);
  };
}
function hv(t, e, n) {
  return function s(r) {
    const i = t.querySelectorAll(e);
    for (let {
      target: o
    } = r; o && o !== this; o = o.parentNode)
      for (const a of i)
        if (a === o)
          return tu(r, {
            delegateTarget: o
          }), s.oneOff && b.off(t, r.type, e, n), n.apply(o, [r]);
  };
}
function A0(t, e, n = null) {
  return Object.values(t).find((s) => s.callable === e && s.delegationSelector === n);
}
function N0(t, e, n) {
  const s = typeof e == "string", r = s ? n : e || n;
  let i = L0(t);
  return dv.has(i) || (i = t), [s, r, i];
}
function qh(t, e, n, s, r) {
  if (typeof e != "string" || !t)
    return;
  let [i, o, a] = N0(e, n, s);
  e in C0 && (o = ((f) => function(m) {
    if (!m.relatedTarget || m.relatedTarget !== m.delegateTarget && !m.delegateTarget.contains(m.relatedTarget))
      return f.call(this, m);
  })(o));
  const c = k0(t), l = c[a] || (c[a] = {}), d = A0(l, o, i ? n : null);
  if (d) {
    d.oneOff = d.oneOff && r;
    return;
  }
  const u = F0(o, e.replace(av, "")), h = i ? hv(t, n, o) : uv(t, o);
  h.delegationSelector = i ? n : null, h.callable = o, h.oneOff = r, h.uidEvent = u, l[u] = h, t.addEventListener(a, h, i);
}
function Ml(t, e, n, s, r) {
  const i = A0(e[n], s, r);
  i && (t.removeEventListener(n, i, !!r), delete e[n][i.uidEvent]);
}
function pv(t, e, n, s) {
  const r = e[n] || {};
  for (const [i, o] of Object.entries(r))
    i.includes(s) && Ml(t, e, n, o.callable, o.delegationSelector);
}
function L0(t) {
  return t = t.replace(cv, ""), C0[t] || t;
}
const b = {
  on(t, e, n, s) {
    qh(t, e, n, s, !1);
  },
  one(t, e, n, s) {
    qh(t, e, n, s, !0);
  },
  off(t, e, n, s) {
    if (typeof e != "string" || !t)
      return;
    const [r, i, o] = N0(e, n, s), a = o !== e, c = k0(t), l = c[o] || {}, d = e.startsWith(".");
    if (typeof i < "u") {
      if (!Object.keys(l).length)
        return;
      Ml(t, c, o, i, r ? n : null);
      return;
    }
    if (d)
      for (const u of Object.keys(c))
        pv(t, c, u, e.slice(1));
    for (const [u, h] of Object.entries(l)) {
      const p = u.replace(lv, "");
      (!a || e.includes(p)) && Ml(t, c, o, h.callable, h.delegationSelector);
    }
  },
  trigger(t, e, n) {
    if (typeof e != "string" || !t)
      return null;
    const s = T0(), r = L0(e), i = e !== r;
    let o = null, a = !0, c = !0, l = !1;
    i && s && (o = s.Event(e, n), s(t).trigger(o), a = !o.isPropagationStopped(), c = !o.isImmediatePropagationStopped(), l = o.isDefaultPrevented());
    const d = tu(new Event(e, {
      bubbles: a,
      cancelable: !0
    }), n);
    return l && d.preventDefault(), c && t.dispatchEvent(d), d.defaultPrevented && o && o.preventDefault(), d;
  }
};
function tu(t, e = {}) {
  for (const [n, s] of Object.entries(e))
    try {
      t[n] = s;
    } catch {
      Object.defineProperty(t, n, {
        configurable: !0,
        get() {
          return s;
        }
      });
    }
  return t;
}
function Yh(t) {
  if (t === "true")
    return !0;
  if (t === "false")
    return !1;
  if (t === Number(t).toString())
    return Number(t);
  if (t === "" || t === "null")
    return null;
  if (typeof t != "string")
    return t;
  try {
    return JSON.parse(decodeURIComponent(t));
  } catch {
    return t;
  }
}
function Wc(t) {
  return t.replace(/[A-Z]/g, (e) => `-${e.toLowerCase()}`);
}
const en = {
  setDataAttribute(t, e, n) {
    t.setAttribute(`data-bs-${Wc(e)}`, n);
  },
  removeDataAttribute(t, e) {
    t.removeAttribute(`data-bs-${Wc(e)}`);
  },
  getDataAttributes(t) {
    if (!t)
      return {};
    const e = {}, n = Object.keys(t.dataset).filter((s) => s.startsWith("bs") && !s.startsWith("bsConfig"));
    for (const s of n) {
      let r = s.replace(/^bs/, "");
      r = r.charAt(0).toLowerCase() + r.slice(1, r.length), e[r] = Yh(t.dataset[s]);
    }
    return e;
  },
  getDataAttribute(t, e) {
    return Yh(t.getAttribute(`data-bs-${Wc(e)}`));
  }
};
class Xi {
  // Getters
  static get Default() {
    return {};
  }
  static get DefaultType() {
    return {};
  }
  static get NAME() {
    throw new Error('You have to implement the static method "NAME", for each component!');
  }
  _getConfig(e) {
    return e = this._mergeConfigObj(e), e = this._configAfterMerge(e), this._typeCheckConfig(e), e;
  }
  _configAfterMerge(e) {
    return e;
  }
  _mergeConfigObj(e, n) {
    const s = Zt(n) ? en.getDataAttribute(n, "config") : {};
    return {
      ...this.constructor.Default,
      ...typeof s == "object" ? s : {},
      ...Zt(n) ? en.getDataAttributes(n) : {},
      ...typeof e == "object" ? e : {}
    };
  }
  _typeCheckConfig(e, n = this.constructor.DefaultType) {
    for (const [s, r] of Object.entries(n)) {
      const i = e[s], o = Zt(i) ? "element" : sv(i);
      if (!new RegExp(r).test(o))
        throw new TypeError(`${this.constructor.NAME.toUpperCase()}: Option "${s}" provided type "${o}" but expected type "${r}".`);
    }
  }
}
const fv = "5.3.3";
class kt extends Xi {
  constructor(e, n) {
    super(), e = Bn(e), e && (this._element = e, this._config = this._getConfig(n), Uc.set(this._element, this.constructor.DATA_KEY, this));
  }
  // Public
  dispose() {
    Uc.remove(this._element, this.constructor.DATA_KEY), b.off(this._element, this.constructor.EVENT_KEY);
    for (const e of Object.getOwnPropertyNames(this))
      this[e] = null;
  }
  _queueCallback(e, n, s = !0) {
    I0(e, n, s);
  }
  _getConfig(e) {
    return e = this._mergeConfigObj(e, this._element), e = this._configAfterMerge(e), this._typeCheckConfig(e), e;
  }
  // Static
  static getInstance(e) {
    return Uc.get(Bn(e), this.DATA_KEY);
  }
  static getOrCreateInstance(e, n = {}) {
    return this.getInstance(e) || new this(e, typeof n == "object" ? n : null);
  }
  static get VERSION() {
    return fv;
  }
  static get DATA_KEY() {
    return `bs.${this.NAME}`;
  }
  static get EVENT_KEY() {
    return `.${this.DATA_KEY}`;
  }
  static eventName(e) {
    return `${e}${this.EVENT_KEY}`;
  }
}
const zc = (t) => {
  let e = t.getAttribute("data-bs-target");
  if (!e || e === "#") {
    let n = t.getAttribute("href");
    if (!n || !n.includes("#") && !n.startsWith("."))
      return null;
    n.includes("#") && !n.startsWith("#") && (n = `#${n.split("#")[1]}`), e = n && n !== "#" ? n.trim() : null;
  }
  return e ? e.split(",").map((n) => v0(n)).join(",") : null;
}, x = {
  find(t, e = document.documentElement) {
    return [].concat(...Element.prototype.querySelectorAll.call(e, t));
  },
  findOne(t, e = document.documentElement) {
    return Element.prototype.querySelector.call(e, t);
  },
  children(t, e) {
    return [].concat(...t.children).filter((n) => n.matches(e));
  },
  parents(t, e) {
    const n = [];
    let s = t.parentNode.closest(e);
    for (; s; )
      n.push(s), s = s.parentNode.closest(e);
    return n;
  },
  prev(t, e) {
    let n = t.previousElementSibling;
    for (; n; ) {
      if (n.matches(e))
        return [n];
      n = n.previousElementSibling;
    }
    return [];
  },
  // TODO: this is now unused; remove later along with prev()
  next(t, e) {
    let n = t.nextElementSibling;
    for (; n; ) {
      if (n.matches(e))
        return [n];
      n = n.nextElementSibling;
    }
    return [];
  },
  focusableChildren(t) {
    const e = ["a", "button", "input", "textarea", "select", "details", "[tabindex]", '[contenteditable="true"]'].map((n) => `${n}:not([tabindex^="-"])`).join(",");
    return this.find(e, t).filter((n) => !$n(n) && Br(n));
  },
  getSelectorFromElement(t) {
    const e = zc(t);
    return e && x.findOne(e) ? e : null;
  },
  getElementFromSelector(t) {
    const e = zc(t);
    return e ? x.findOne(e) : null;
  },
  getMultipleElementsFromSelector(t) {
    const e = zc(t);
    return e ? x.find(e) : [];
  }
}, ac = (t, e = "hide") => {
  const n = `click.dismiss${t.EVENT_KEY}`, s = t.NAME;
  b.on(document, n, `[data-bs-dismiss="${s}"]`, function(r) {
    if (["A", "AREA"].includes(this.tagName) && r.preventDefault(), $n(this))
      return;
    const i = x.getElementFromSelector(this) || this.closest(`.${s}`);
    t.getOrCreateInstance(i)[e]();
  });
}, mv = "alert", gv = "bs.alert", R0 = `.${gv}`, _v = `close${R0}`, yv = `closed${R0}`, Ev = "fade", bv = "show";
class cc extends kt {
  // Getters
  static get NAME() {
    return mv;
  }
  // Public
  close() {
    if (b.trigger(this._element, _v).defaultPrevented)
      return;
    this._element.classList.remove(bv);
    const n = this._element.classList.contains(Ev);
    this._queueCallback(() => this._destroyElement(), this._element, n);
  }
  // Private
  _destroyElement() {
    this._element.remove(), b.trigger(this._element, yv), this.dispose();
  }
  // Static
  static jQueryInterface(e) {
    return this.each(function() {
      const n = cc.getOrCreateInstance(this);
      if (typeof e == "string") {
        if (n[e] === void 0 || e.startsWith("_") || e === "constructor")
          throw new TypeError(`No method named "${e}"`);
        n[e](this);
      }
    });
  }
}
ac(cc, "close");
yt(cc);
const vv = "button", Sv = "bs.button", wv = `.${Sv}`, Tv = ".data-api", Iv = "active", Kh = '[data-bs-toggle="button"]', Cv = `click${wv}${Tv}`;
class lc extends kt {
  // Getters
  static get NAME() {
    return vv;
  }
  // Public
  toggle() {
    this._element.setAttribute("aria-pressed", this._element.classList.toggle(Iv));
  }
  // Static
  static jQueryInterface(e) {
    return this.each(function() {
      const n = lc.getOrCreateInstance(this);
      e === "toggle" && n[e]();
    });
  }
}
b.on(document, Cv, Kh, (t) => {
  t.preventDefault();
  const e = t.target.closest(Kh);
  lc.getOrCreateInstance(e).toggle();
});
yt(lc);
const Fv = "swipe", $r = ".bs.swipe", kv = `touchstart${$r}`, Av = `touchmove${$r}`, Nv = `touchend${$r}`, Lv = `pointerdown${$r}`, Rv = `pointerup${$r}`, xv = "touch", Ov = "pen", Pv = "pointer-event", Mv = 40, Dv = {
  endCallback: null,
  leftCallback: null,
  rightCallback: null
}, Gv = {
  endCallback: "(function|null)",
  leftCallback: "(function|null)",
  rightCallback: "(function|null)"
};
class pa extends Xi {
  constructor(e, n) {
    super(), this._element = e, !(!e || !pa.isSupported()) && (this._config = this._getConfig(n), this._deltaX = 0, this._supportPointerEvents = !!window.PointerEvent, this._initEvents());
  }
  // Getters
  static get Default() {
    return Dv;
  }
  static get DefaultType() {
    return Gv;
  }
  static get NAME() {
    return Fv;
  }
  // Public
  dispose() {
    b.off(this._element, $r);
  }
  // Private
  _start(e) {
    if (!this._supportPointerEvents) {
      this._deltaX = e.touches[0].clientX;
      return;
    }
    this._eventIsPointerPenTouch(e) && (this._deltaX = e.clientX);
  }
  _end(e) {
    this._eventIsPointerPenTouch(e) && (this._deltaX = e.clientX - this._deltaX), this._handleSwipe(), Ze(this._config.endCallback);
  }
  _move(e) {
    this._deltaX = e.touches && e.touches.length > 1 ? 0 : e.touches[0].clientX - this._deltaX;
  }
  _handleSwipe() {
    const e = Math.abs(this._deltaX);
    if (e <= Mv)
      return;
    const n = e / this._deltaX;
    this._deltaX = 0, n && Ze(n > 0 ? this._config.rightCallback : this._config.leftCallback);
  }
  _initEvents() {
    this._supportPointerEvents ? (b.on(this._element, Lv, (e) => this._start(e)), b.on(this._element, Rv, (e) => this._end(e)), this._element.classList.add(Pv)) : (b.on(this._element, kv, (e) => this._start(e)), b.on(this._element, Av, (e) => this._move(e)), b.on(this._element, Nv, (e) => this._end(e)));
  }
  _eventIsPointerPenTouch(e) {
    return this._supportPointerEvents && (e.pointerType === Ov || e.pointerType === xv);
  }
  // Static
  static isSupported() {
    return "ontouchstart" in document.documentElement || navigator.maxTouchPoints > 0;
  }
}
const Bv = "carousel", $v = "bs.carousel", qn = `.${$v}`, x0 = ".data-api", Vv = "ArrowLeft", Uv = "ArrowRight", Hv = 500, ni = "next", zs = "prev", Js = "left", Xo = "right", jv = `slide${qn}`, qc = `slid${qn}`, Wv = `keydown${qn}`, zv = `mouseenter${qn}`, qv = `mouseleave${qn}`, Yv = `dragstart${qn}`, Kv = `load${qn}${x0}`, Xv = `click${qn}${x0}`, O0 = "carousel", Co = "active", Jv = "slide", Qv = "carousel-item-end", Zv = "carousel-item-start", eS = "carousel-item-next", tS = "carousel-item-prev", P0 = ".active", M0 = ".carousel-item", nS = P0 + M0, sS = ".carousel-item img", rS = ".carousel-indicators", iS = "[data-bs-slide], [data-bs-slide-to]", oS = '[data-bs-ride="carousel"]', aS = {
  [Vv]: Xo,
  [Uv]: Js
}, cS = {
  interval: 5e3,
  keyboard: !0,
  pause: "hover",
  ride: !1,
  touch: !0,
  wrap: !0
}, lS = {
  interval: "(number|boolean)",
  // TODO:v6 remove boolean support
  keyboard: "boolean",
  pause: "(string|boolean)",
  ride: "(boolean|string)",
  touch: "boolean",
  wrap: "boolean"
};
class Ji extends kt {
  constructor(e, n) {
    super(e, n), this._interval = null, this._activeElement = null, this._isSliding = !1, this.touchTimeout = null, this._swipeHelper = null, this._indicatorsElement = x.findOne(rS, this._element), this._addEventListeners(), this._config.ride === O0 && this.cycle();
  }
  // Getters
  static get Default() {
    return cS;
  }
  static get DefaultType() {
    return lS;
  }
  static get NAME() {
    return Bv;
  }
  // Public
  next() {
    this._slide(ni);
  }
  nextWhenVisible() {
    !document.hidden && Br(this._element) && this.next();
  }
  prev() {
    this._slide(zs);
  }
  pause() {
    this._isSliding && S0(this._element), this._clearInterval();
  }
  cycle() {
    this._clearInterval(), this._updateInterval(), this._interval = setInterval(() => this.nextWhenVisible(), this._config.interval);
  }
  _maybeEnableCycle() {
    if (this._config.ride) {
      if (this._isSliding) {
        b.one(this._element, qc, () => this.cycle());
        return;
      }
      this.cycle();
    }
  }
  to(e) {
    const n = this._getItems();
    if (e > n.length - 1 || e < 0)
      return;
    if (this._isSliding) {
      b.one(this._element, qc, () => this.to(e));
      return;
    }
    const s = this._getItemIndex(this._getActive());
    if (s === e)
      return;
    const r = e > s ? ni : zs;
    this._slide(r, n[e]);
  }
  dispose() {
    this._swipeHelper && this._swipeHelper.dispose(), super.dispose();
  }
  // Private
  _configAfterMerge(e) {
    return e.defaultInterval = e.interval, e;
  }
  _addEventListeners() {
    this._config.keyboard && b.on(this._element, Wv, (e) => this._keydown(e)), this._config.pause === "hover" && (b.on(this._element, zv, () => this.pause()), b.on(this._element, qv, () => this._maybeEnableCycle())), this._config.touch && pa.isSupported() && this._addTouchEventListeners();
  }
  _addTouchEventListeners() {
    for (const s of x.find(sS, this._element))
      b.on(s, Yv, (r) => r.preventDefault());
    const n = {
      leftCallback: () => this._slide(this._directionToOrder(Js)),
      rightCallback: () => this._slide(this._directionToOrder(Xo)),
      endCallback: () => {
        this._config.pause === "hover" && (this.pause(), this.touchTimeout && clearTimeout(this.touchTimeout), this.touchTimeout = setTimeout(() => this._maybeEnableCycle(), Hv + this._config.interval));
      }
    };
    this._swipeHelper = new pa(this._element, n);
  }
  _keydown(e) {
    if (/input|textarea/i.test(e.target.tagName))
      return;
    const n = aS[e.key];
    n && (e.preventDefault(), this._slide(this._directionToOrder(n)));
  }
  _getItemIndex(e) {
    return this._getItems().indexOf(e);
  }
  _setActiveIndicatorElement(e) {
    if (!this._indicatorsElement)
      return;
    const n = x.findOne(P0, this._indicatorsElement);
    n.classList.remove(Co), n.removeAttribute("aria-current");
    const s = x.findOne(`[data-bs-slide-to="${e}"]`, this._indicatorsElement);
    s && (s.classList.add(Co), s.setAttribute("aria-current", "true"));
  }
  _updateInterval() {
    const e = this._activeElement || this._getActive();
    if (!e)
      return;
    const n = Number.parseInt(e.getAttribute("data-bs-interval"), 10);
    this._config.interval = n || this._config.defaultInterval;
  }
  _slide(e, n = null) {
    if (this._isSliding)
      return;
    const s = this._getActive(), r = e === ni, i = n || eu(this._getItems(), s, r, this._config.wrap);
    if (i === s)
      return;
    const o = this._getItemIndex(i), a = (p) => b.trigger(this._element, p, {
      relatedTarget: i,
      direction: this._orderToDirection(e),
      from: this._getItemIndex(s),
      to: o
    });
    if (a(jv).defaultPrevented || !s || !i)
      return;
    const l = !!this._interval;
    this.pause(), this._isSliding = !0, this._setActiveIndicatorElement(o), this._activeElement = i;
    const d = r ? Zv : Qv, u = r ? eS : tS;
    i.classList.add(u), Ki(i), s.classList.add(d), i.classList.add(d);
    const h = () => {
      i.classList.remove(d, u), i.classList.add(Co), s.classList.remove(Co, u, d), this._isSliding = !1, a(qc);
    };
    this._queueCallback(h, s, this._isAnimated()), l && this.cycle();
  }
  _isAnimated() {
    return this._element.classList.contains(Jv);
  }
  _getActive() {
    return x.findOne(nS, this._element);
  }
  _getItems() {
    return x.find(M0, this._element);
  }
  _clearInterval() {
    this._interval && (clearInterval(this._interval), this._interval = null);
  }
  _directionToOrder(e) {
    return ft() ? e === Js ? zs : ni : e === Js ? ni : zs;
  }
  _orderToDirection(e) {
    return ft() ? e === zs ? Js : Xo : e === zs ? Xo : Js;
  }
  // Static
  static jQueryInterface(e) {
    return this.each(function() {
      const n = Ji.getOrCreateInstance(this, e);
      if (typeof e == "number") {
        n.to(e);
        return;
      }
      if (typeof e == "string") {
        if (n[e] === void 0 || e.startsWith("_") || e === "constructor")
          throw new TypeError(`No method named "${e}"`);
        n[e]();
      }
    });
  }
}
b.on(document, Xv, iS, function(t) {
  const e = x.getElementFromSelector(this);
  if (!e || !e.classList.contains(O0))
    return;
  t.preventDefault();
  const n = Ji.getOrCreateInstance(e), s = this.getAttribute("data-bs-slide-to");
  if (s) {
    n.to(s), n._maybeEnableCycle();
    return;
  }
  if (en.getDataAttribute(this, "slide") === "next") {
    n.next(), n._maybeEnableCycle();
    return;
  }
  n.prev(), n._maybeEnableCycle();
});
b.on(window, Kv, () => {
  const t = x.find(oS);
  for (const e of t)
    Ji.getOrCreateInstance(e);
});
yt(Ji);
const dS = "collapse", uS = "bs.collapse", Qi = `.${uS}`, hS = ".data-api", pS = `show${Qi}`, fS = `shown${Qi}`, mS = `hide${Qi}`, gS = `hidden${Qi}`, _S = `click${Qi}${hS}`, Yc = "show", nr = "collapse", Fo = "collapsing", yS = "collapsed", ES = `:scope .${nr} .${nr}`, bS = "collapse-horizontal", vS = "width", SS = "height", wS = ".collapse.show, .collapse.collapsing", Dl = '[data-bs-toggle="collapse"]', TS = {
  parent: null,
  toggle: !0
}, IS = {
  parent: "(null|element)",
  toggle: "boolean"
};
class Ci extends kt {
  constructor(e, n) {
    super(e, n), this._isTransitioning = !1, this._triggerArray = [];
    const s = x.find(Dl);
    for (const r of s) {
      const i = x.getSelectorFromElement(r), o = x.find(i).filter((a) => a === this._element);
      i !== null && o.length && this._triggerArray.push(r);
    }
    this._initializeChildren(), this._config.parent || this._addAriaAndCollapsedClass(this._triggerArray, this._isShown()), this._config.toggle && this.toggle();
  }
  // Getters
  static get Default() {
    return TS;
  }
  static get DefaultType() {
    return IS;
  }
  static get NAME() {
    return dS;
  }
  // Public
  toggle() {
    this._isShown() ? this.hide() : this.show();
  }
  show() {
    if (this._isTransitioning || this._isShown())
      return;
    let e = [];
    if (this._config.parent && (e = this._getFirstLevelChildren(wS).filter((a) => a !== this._element).map((a) => Ci.getOrCreateInstance(a, {
      toggle: !1
    }))), e.length && e[0]._isTransitioning || b.trigger(this._element, pS).defaultPrevented)
      return;
    for (const a of e)
      a.hide();
    const s = this._getDimension();
    this._element.classList.remove(nr), this._element.classList.add(Fo), this._element.style[s] = 0, this._addAriaAndCollapsedClass(this._triggerArray, !0), this._isTransitioning = !0;
    const r = () => {
      this._isTransitioning = !1, this._element.classList.remove(Fo), this._element.classList.add(nr, Yc), this._element.style[s] = "", b.trigger(this._element, fS);
    }, o = `scroll${s[0].toUpperCase() + s.slice(1)}`;
    this._queueCallback(r, this._element, !0), this._element.style[s] = `${this._element[o]}px`;
  }
  hide() {
    if (this._isTransitioning || !this._isShown() || b.trigger(this._element, mS).defaultPrevented)
      return;
    const n = this._getDimension();
    this._element.style[n] = `${this._element.getBoundingClientRect()[n]}px`, Ki(this._element), this._element.classList.add(Fo), this._element.classList.remove(nr, Yc);
    for (const r of this._triggerArray) {
      const i = x.getElementFromSelector(r);
      i && !this._isShown(i) && this._addAriaAndCollapsedClass([r], !1);
    }
    this._isTransitioning = !0;
    const s = () => {
      this._isTransitioning = !1, this._element.classList.remove(Fo), this._element.classList.add(nr), b.trigger(this._element, gS);
    };
    this._element.style[n] = "", this._queueCallback(s, this._element, !0);
  }
  _isShown(e = this._element) {
    return e.classList.contains(Yc);
  }
  // Private
  _configAfterMerge(e) {
    return e.toggle = !!e.toggle, e.parent = Bn(e.parent), e;
  }
  _getDimension() {
    return this._element.classList.contains(bS) ? vS : SS;
  }
  _initializeChildren() {
    if (!this._config.parent)
      return;
    const e = this._getFirstLevelChildren(Dl);
    for (const n of e) {
      const s = x.getElementFromSelector(n);
      s && this._addAriaAndCollapsedClass([n], this._isShown(s));
    }
  }
  _getFirstLevelChildren(e) {
    const n = x.find(ES, this._config.parent);
    return x.find(e, this._config.parent).filter((s) => !n.includes(s));
  }
  _addAriaAndCollapsedClass(e, n) {
    if (e.length)
      for (const s of e)
        s.classList.toggle(yS, !n), s.setAttribute("aria-expanded", n);
  }
  // Static
  static jQueryInterface(e) {
    const n = {};
    return typeof e == "string" && /show|hide/.test(e) && (n.toggle = !1), this.each(function() {
      const s = Ci.getOrCreateInstance(this, n);
      if (typeof e == "string") {
        if (typeof s[e] > "u")
          throw new TypeError(`No method named "${e}"`);
        s[e]();
      }
    });
  }
}
b.on(document, _S, Dl, function(t) {
  (t.target.tagName === "A" || t.delegateTarget && t.delegateTarget.tagName === "A") && t.preventDefault();
  for (const e of x.getMultipleElementsFromSelector(this))
    Ci.getOrCreateInstance(e, {
      toggle: !1
    }).toggle();
});
yt(Ci);
const Xh = "dropdown", CS = "bs.dropdown", As = `.${CS}`, nu = ".data-api", FS = "Escape", Jh = "Tab", kS = "ArrowUp", Qh = "ArrowDown", AS = 2, NS = `hide${As}`, LS = `hidden${As}`, RS = `show${As}`, xS = `shown${As}`, D0 = `click${As}${nu}`, G0 = `keydown${As}${nu}`, OS = `keyup${As}${nu}`, Qs = "show", PS = "dropup", MS = "dropend", DS = "dropstart", GS = "dropup-center", BS = "dropdown-center", is = '[data-bs-toggle="dropdown"]:not(.disabled):not(:disabled)', $S = `${is}.${Qs}`, Jo = ".dropdown-menu", VS = ".navbar", US = ".navbar-nav", HS = ".dropdown-menu .dropdown-item:not(.disabled):not(:disabled)", jS = ft() ? "top-end" : "top-start", WS = ft() ? "top-start" : "top-end", zS = ft() ? "bottom-end" : "bottom-start", qS = ft() ? "bottom-start" : "bottom-end", YS = ft() ? "left-start" : "right-start", KS = ft() ? "right-start" : "left-start", XS = "top", JS = "bottom", QS = {
  autoClose: !0,
  boundary: "clippingParents",
  display: "dynamic",
  offset: [0, 2],
  popperConfig: null,
  reference: "toggle"
}, ZS = {
  autoClose: "(boolean|string)",
  boundary: "(string|element)",
  display: "string",
  offset: "(array|string|function)",
  popperConfig: "(null|object|function)",
  reference: "(string|element|object)"
};
class Mt extends kt {
  constructor(e, n) {
    super(e, n), this._popper = null, this._parent = this._element.parentNode, this._menu = x.next(this._element, Jo)[0] || x.prev(this._element, Jo)[0] || x.findOne(Jo, this._parent), this._inNavbar = this._detectNavbar();
  }
  // Getters
  static get Default() {
    return QS;
  }
  static get DefaultType() {
    return ZS;
  }
  static get NAME() {
    return Xh;
  }
  // Public
  toggle() {
    return this._isShown() ? this.hide() : this.show();
  }
  show() {
    if ($n(this._element) || this._isShown())
      return;
    const e = {
      relatedTarget: this._element
    };
    if (!b.trigger(this._element, RS, e).defaultPrevented) {
      if (this._createPopper(), "ontouchstart" in document.documentElement && !this._parent.closest(US))
        for (const s of [].concat(...document.body.children))
          b.on(s, "mouseover", ha);
      this._element.focus(), this._element.setAttribute("aria-expanded", !0), this._menu.classList.add(Qs), this._element.classList.add(Qs), b.trigger(this._element, xS, e);
    }
  }
  hide() {
    if ($n(this._element) || !this._isShown())
      return;
    const e = {
      relatedTarget: this._element
    };
    this._completeHide(e);
  }
  dispose() {
    this._popper && this._popper.destroy(), super.dispose();
  }
  update() {
    this._inNavbar = this._detectNavbar(), this._popper && this._popper.update();
  }
  // Private
  _completeHide(e) {
    if (!b.trigger(this._element, NS, e).defaultPrevented) {
      if ("ontouchstart" in document.documentElement)
        for (const s of [].concat(...document.body.children))
          b.off(s, "mouseover", ha);
      this._popper && this._popper.destroy(), this._menu.classList.remove(Qs), this._element.classList.remove(Qs), this._element.setAttribute("aria-expanded", "false"), en.removeDataAttribute(this._menu, "popper"), b.trigger(this._element, LS, e);
    }
  }
  _getConfig(e) {
    if (e = super._getConfig(e), typeof e.reference == "object" && !Zt(e.reference) && typeof e.reference.getBoundingClientRect != "function")
      throw new TypeError(`${Xh.toUpperCase()}: Option "reference" provided type "object" without a required "getBoundingClientRect" method.`);
    return e;
  }
  _createPopper() {
    if (typeof b0 > "u")
      throw new TypeError("Bootstrap's dropdowns require Popper (https://popper.js.org)");
    let e = this._element;
    this._config.reference === "parent" ? e = this._parent : Zt(this._config.reference) ? e = Bn(this._config.reference) : typeof this._config.reference == "object" && (e = this._config.reference);
    const n = this._getPopperConfig();
    this._popper = Zd(e, this._menu, n);
  }
  _isShown() {
    return this._menu.classList.contains(Qs);
  }
  _getPlacement() {
    const e = this._parent;
    if (e.classList.contains(MS))
      return YS;
    if (e.classList.contains(DS))
      return KS;
    if (e.classList.contains(GS))
      return XS;
    if (e.classList.contains(BS))
      return JS;
    const n = getComputedStyle(this._menu).getPropertyValue("--bs-position").trim() === "end";
    return e.classList.contains(PS) ? n ? WS : jS : n ? qS : zS;
  }
  _detectNavbar() {
    return this._element.closest(VS) !== null;
  }
  _getOffset() {
    const {
      offset: e
    } = this._config;
    return typeof e == "string" ? e.split(",").map((n) => Number.parseInt(n, 10)) : typeof e == "function" ? (n) => e(n, this._element) : e;
  }
  _getPopperConfig() {
    const e = {
      placement: this._getPlacement(),
      modifiers: [{
        name: "preventOverflow",
        options: {
          boundary: this._config.boundary
        }
      }, {
        name: "offset",
        options: {
          offset: this._getOffset()
        }
      }]
    };
    return (this._inNavbar || this._config.display === "static") && (en.setDataAttribute(this._menu, "popper", "static"), e.modifiers = [{
      name: "applyStyles",
      enabled: !1
    }]), {
      ...e,
      ...Ze(this._config.popperConfig, [e])
    };
  }
  _selectMenuItem({
    key: e,
    target: n
  }) {
    const s = x.find(HS, this._menu).filter((r) => Br(r));
    s.length && eu(s, n, e === Qh, !s.includes(n)).focus();
  }
  // Static
  static jQueryInterface(e) {
    return this.each(function() {
      const n = Mt.getOrCreateInstance(this, e);
      if (typeof e == "string") {
        if (typeof n[e] > "u")
          throw new TypeError(`No method named "${e}"`);
        n[e]();
      }
    });
  }
  static clearMenus(e) {
    if (e.button === AS || e.type === "keyup" && e.key !== Jh)
      return;
    const n = x.find($S);
    for (const s of n) {
      const r = Mt.getInstance(s);
      if (!r || r._config.autoClose === !1)
        continue;
      const i = e.composedPath(), o = i.includes(r._menu);
      if (i.includes(r._element) || r._config.autoClose === "inside" && !o || r._config.autoClose === "outside" && o || r._menu.contains(e.target) && (e.type === "keyup" && e.key === Jh || /input|select|option|textarea|form/i.test(e.target.tagName)))
        continue;
      const a = {
        relatedTarget: r._element
      };
      e.type === "click" && (a.clickEvent = e), r._completeHide(a);
    }
  }
  static dataApiKeydownHandler(e) {
    const n = /input|textarea/i.test(e.target.tagName), s = e.key === FS, r = [kS, Qh].includes(e.key);
    if (!r && !s || n && !s)
      return;
    e.preventDefault();
    const i = this.matches(is) ? this : x.prev(this, is)[0] || x.next(this, is)[0] || x.findOne(is, e.delegateTarget.parentNode), o = Mt.getOrCreateInstance(i);
    if (r) {
      e.stopPropagation(), o.show(), o._selectMenuItem(e);
      return;
    }
    o._isShown() && (e.stopPropagation(), o.hide(), i.focus());
  }
}
b.on(document, G0, is, Mt.dataApiKeydownHandler);
b.on(document, G0, Jo, Mt.dataApiKeydownHandler);
b.on(document, D0, Mt.clearMenus);
b.on(document, OS, Mt.clearMenus);
b.on(document, D0, is, function(t) {
  t.preventDefault(), Mt.getOrCreateInstance(this).toggle();
});
yt(Mt);
const B0 = "backdrop", ew = "fade", Zh = "show", ep = `mousedown.bs.${B0}`, tw = {
  className: "modal-backdrop",
  clickCallback: null,
  isAnimated: !1,
  isVisible: !0,
  // if false, we use the backdrop helper without adding any element to the dom
  rootElement: "body"
  // give the choice to place backdrop under different elements
}, nw = {
  className: "string",
  clickCallback: "(function|null)",
  isAnimated: "boolean",
  isVisible: "boolean",
  rootElement: "(element|string)"
};
class $0 extends Xi {
  constructor(e) {
    super(), this._config = this._getConfig(e), this._isAppended = !1, this._element = null;
  }
  // Getters
  static get Default() {
    return tw;
  }
  static get DefaultType() {
    return nw;
  }
  static get NAME() {
    return B0;
  }
  // Public
  show(e) {
    if (!this._config.isVisible) {
      Ze(e);
      return;
    }
    this._append();
    const n = this._getElement();
    this._config.isAnimated && Ki(n), n.classList.add(Zh), this._emulateAnimation(() => {
      Ze(e);
    });
  }
  hide(e) {
    if (!this._config.isVisible) {
      Ze(e);
      return;
    }
    this._getElement().classList.remove(Zh), this._emulateAnimation(() => {
      this.dispose(), Ze(e);
    });
  }
  dispose() {
    this._isAppended && (b.off(this._element, ep), this._element.remove(), this._isAppended = !1);
  }
  // Private
  _getElement() {
    if (!this._element) {
      const e = document.createElement("div");
      e.className = this._config.className, this._config.isAnimated && e.classList.add(ew), this._element = e;
    }
    return this._element;
  }
  _configAfterMerge(e) {
    return e.rootElement = Bn(e.rootElement), e;
  }
  _append() {
    if (this._isAppended)
      return;
    const e = this._getElement();
    this._config.rootElement.append(e), b.on(e, ep, () => {
      Ze(this._config.clickCallback);
    }), this._isAppended = !0;
  }
  _emulateAnimation(e) {
    I0(e, this._getElement(), this._config.isAnimated);
  }
}
const sw = "focustrap", rw = "bs.focustrap", fa = `.${rw}`, iw = `focusin${fa}`, ow = `keydown.tab${fa}`, aw = "Tab", cw = "forward", tp = "backward", lw = {
  autofocus: !0,
  trapElement: null
  // The element to trap focus inside of
}, dw = {
  autofocus: "boolean",
  trapElement: "element"
};
class V0 extends Xi {
  constructor(e) {
    super(), this._config = this._getConfig(e), this._isActive = !1, this._lastTabNavDirection = null;
  }
  // Getters
  static get Default() {
    return lw;
  }
  static get DefaultType() {
    return dw;
  }
  static get NAME() {
    return sw;
  }
  // Public
  activate() {
    this._isActive || (this._config.autofocus && this._config.trapElement.focus(), b.off(document, fa), b.on(document, iw, (e) => this._handleFocusin(e)), b.on(document, ow, (e) => this._handleKeydown(e)), this._isActive = !0);
  }
  deactivate() {
    this._isActive && (this._isActive = !1, b.off(document, fa));
  }
  // Private
  _handleFocusin(e) {
    const {
      trapElement: n
    } = this._config;
    if (e.target === document || e.target === n || n.contains(e.target))
      return;
    const s = x.focusableChildren(n);
    s.length === 0 ? n.focus() : this._lastTabNavDirection === tp ? s[s.length - 1].focus() : s[0].focus();
  }
  _handleKeydown(e) {
    e.key === aw && (this._lastTabNavDirection = e.shiftKey ? tp : cw);
  }
}
const np = ".fixed-top, .fixed-bottom, .is-fixed, .sticky-top", sp = ".sticky-top", ko = "padding-right", rp = "margin-right";
class Gl {
  constructor() {
    this._element = document.body;
  }
  // Public
  getWidth() {
    const e = document.documentElement.clientWidth;
    return Math.abs(window.innerWidth - e);
  }
  hide() {
    const e = this.getWidth();
    this._disableOverFlow(), this._setElementAttributes(this._element, ko, (n) => n + e), this._setElementAttributes(np, ko, (n) => n + e), this._setElementAttributes(sp, rp, (n) => n - e);
  }
  reset() {
    this._resetElementAttributes(this._element, "overflow"), this._resetElementAttributes(this._element, ko), this._resetElementAttributes(np, ko), this._resetElementAttributes(sp, rp);
  }
  isOverflowing() {
    return this.getWidth() > 0;
  }
  // Private
  _disableOverFlow() {
    this._saveInitialAttribute(this._element, "overflow"), this._element.style.overflow = "hidden";
  }
  _setElementAttributes(e, n, s) {
    const r = this.getWidth(), i = (o) => {
      if (o !== this._element && window.innerWidth > o.clientWidth + r)
        return;
      this._saveInitialAttribute(o, n);
      const a = window.getComputedStyle(o).getPropertyValue(n);
      o.style.setProperty(n, `${s(Number.parseFloat(a))}px`);
    };
    this._applyManipulationCallback(e, i);
  }
  _saveInitialAttribute(e, n) {
    const s = e.style.getPropertyValue(n);
    s && en.setDataAttribute(e, n, s);
  }
  _resetElementAttributes(e, n) {
    const s = (r) => {
      const i = en.getDataAttribute(r, n);
      if (i === null) {
        r.style.removeProperty(n);
        return;
      }
      en.removeDataAttribute(r, n), r.style.setProperty(n, i);
    };
    this._applyManipulationCallback(e, s);
  }
  _applyManipulationCallback(e, n) {
    if (Zt(e)) {
      n(e);
      return;
    }
    for (const s of x.find(e, this._element))
      n(s);
  }
}
const uw = "modal", hw = "bs.modal", mt = `.${hw}`, pw = ".data-api", fw = "Escape", mw = `hide${mt}`, gw = `hidePrevented${mt}`, U0 = `hidden${mt}`, H0 = `show${mt}`, _w = `shown${mt}`, yw = `resize${mt}`, Ew = `click.dismiss${mt}`, bw = `mousedown.dismiss${mt}`, vw = `keydown.dismiss${mt}`, Sw = `click${mt}${pw}`, ip = "modal-open", ww = "fade", op = "show", Kc = "modal-static", Tw = ".modal.show", Iw = ".modal-dialog", Cw = ".modal-body", Fw = '[data-bs-toggle="modal"]', kw = {
  backdrop: !0,
  focus: !0,
  keyboard: !0
}, Aw = {
  backdrop: "(boolean|string)",
  focus: "boolean",
  keyboard: "boolean"
};
class M extends kt {
  constructor(e, n) {
    super(e, n), this._dialog = x.findOne(Iw, this._element), this._backdrop = this._initializeBackDrop(), this._focustrap = this._initializeFocusTrap(), this._isShown = !1, this._isTransitioning = !1, this._scrollBar = new Gl(), this._addEventListeners();
  }
  // Getters
  static get Default() {
    return kw;
  }
  static get DefaultType() {
    return Aw;
  }
  static get NAME() {
    return uw;
  }
  // Public
  toggle(e) {
    return this._isShown ? this.hide() : this.show(e);
  }
  show(e) {
    this._isShown || this._isTransitioning || b.trigger(this._element, H0, {
      relatedTarget: e
    }).defaultPrevented || (this._isShown = !0, this._isTransitioning = !0, this._scrollBar.hide(), document.body.classList.add(ip), this._adjustDialog(), this._backdrop.show(() => this._showElement(e)));
  }
  hide() {
    !this._isShown || this._isTransitioning || b.trigger(this._element, mw).defaultPrevented || (this._isShown = !1, this._isTransitioning = !0, this._focustrap.deactivate(), this._element.classList.remove(op), this._queueCallback(() => this._hideModal(), this._element, this._isAnimated()));
  }
  dispose() {
    b.off(window, mt), b.off(this._dialog, mt), this._backdrop.dispose(), this._focustrap.deactivate(), super.dispose();
  }
  handleUpdate() {
    this._adjustDialog();
  }
  // Private
  _initializeBackDrop() {
    return new $0({
      isVisible: !!this._config.backdrop,
      // 'static' option will be translated to true, and booleans will keep their value,
      isAnimated: this._isAnimated()
    });
  }
  _initializeFocusTrap() {
    return new V0({
      trapElement: this._element
    });
  }
  _showElement(e) {
    document.body.contains(this._element) || document.body.append(this._element), this._element.style.display = "block", this._element.removeAttribute("aria-hidden"), this._element.setAttribute("aria-modal", !0), this._element.setAttribute("role", "dialog"), this._element.scrollTop = 0;
    const n = x.findOne(Cw, this._dialog);
    n && (n.scrollTop = 0), Ki(this._element), this._element.classList.add(op);
    const s = () => {
      this._config.focus && this._focustrap.activate(), this._isTransitioning = !1, b.trigger(this._element, _w, {
        relatedTarget: e
      });
    };
    this._queueCallback(s, this._dialog, this._isAnimated());
  }
  _addEventListeners() {
    b.on(this._element, vw, (e) => {
      if (e.key === fw) {
        if (this._config.keyboard) {
          this.hide();
          return;
        }
        this._triggerBackdropTransition();
      }
    }), b.on(window, yw, () => {
      this._isShown && !this._isTransitioning && this._adjustDialog();
    }), b.on(this._element, bw, (e) => {
      b.one(this._element, Ew, (n) => {
        if (!(this._element !== e.target || this._element !== n.target)) {
          if (this._config.backdrop === "static") {
            this._triggerBackdropTransition();
            return;
          }
          this._config.backdrop && this.hide();
        }
      });
    });
  }
  _hideModal() {
    this._element.style.display = "none", this._element.setAttribute("aria-hidden", !0), this._element.removeAttribute("aria-modal"), this._element.removeAttribute("role"), this._isTransitioning = !1, this._backdrop.hide(() => {
      document.body.classList.remove(ip), this._resetAdjustments(), this._scrollBar.reset(), b.trigger(this._element, U0);
    });
  }
  _isAnimated() {
    return this._element.classList.contains(ww);
  }
  _triggerBackdropTransition() {
    if (b.trigger(this._element, gw).defaultPrevented)
      return;
    const n = this._element.scrollHeight > document.documentElement.clientHeight, s = this._element.style.overflowY;
    s === "hidden" || this._element.classList.contains(Kc) || (n || (this._element.style.overflowY = "hidden"), this._element.classList.add(Kc), this._queueCallback(() => {
      this._element.classList.remove(Kc), this._queueCallback(() => {
        this._element.style.overflowY = s;
      }, this._dialog);
    }, this._dialog), this._element.focus());
  }
  /**
   * The following methods are used to handle overflowing modals
   */
  _adjustDialog() {
    const e = this._element.scrollHeight > document.documentElement.clientHeight, n = this._scrollBar.getWidth(), s = n > 0;
    if (s && !e) {
      const r = ft() ? "paddingLeft" : "paddingRight";
      this._element.style[r] = `${n}px`;
    }
    if (!s && e) {
      const r = ft() ? "paddingRight" : "paddingLeft";
      this._element.style[r] = `${n}px`;
    }
  }
  _resetAdjustments() {
    this._element.style.paddingLeft = "", this._element.style.paddingRight = "";
  }
  // Static
  static jQueryInterface(e, n) {
    return this.each(function() {
      const s = M.getOrCreateInstance(this, e);
      if (typeof e == "string") {
        if (typeof s[e] > "u")
          throw new TypeError(`No method named "${e}"`);
        s[e](n);
      }
    });
  }
}
b.on(document, Sw, Fw, function(t) {
  const e = x.getElementFromSelector(this);
  ["A", "AREA"].includes(this.tagName) && t.preventDefault(), b.one(e, H0, (r) => {
    r.defaultPrevented || b.one(e, U0, () => {
      Br(this) && this.focus();
    });
  });
  const n = x.findOne(Tw);
  n && M.getInstance(n).hide(), M.getOrCreateInstance(e).toggle(this);
});
ac(M);
yt(M);
const Nw = "offcanvas", Lw = "bs.offcanvas", fn = `.${Lw}`, j0 = ".data-api", Rw = `load${fn}${j0}`, xw = "Escape", ap = "show", cp = "showing", lp = "hiding", Ow = "offcanvas-backdrop", W0 = ".offcanvas.show", Pw = `show${fn}`, Mw = `shown${fn}`, Dw = `hide${fn}`, dp = `hidePrevented${fn}`, z0 = `hidden${fn}`, Gw = `resize${fn}`, Bw = `click${fn}${j0}`, $w = `keydown.dismiss${fn}`, Vw = '[data-bs-toggle="offcanvas"]', Uw = {
  backdrop: !0,
  keyboard: !0,
  scroll: !1
}, Hw = {
  backdrop: "(boolean|string)",
  keyboard: "boolean",
  scroll: "boolean"
};
class Vn extends kt {
  constructor(e, n) {
    super(e, n), this._isShown = !1, this._backdrop = this._initializeBackDrop(), this._focustrap = this._initializeFocusTrap(), this._addEventListeners();
  }
  // Getters
  static get Default() {
    return Uw;
  }
  static get DefaultType() {
    return Hw;
  }
  static get NAME() {
    return Nw;
  }
  // Public
  toggle(e) {
    return this._isShown ? this.hide() : this.show(e);
  }
  show(e) {
    if (this._isShown || b.trigger(this._element, Pw, {
      relatedTarget: e
    }).defaultPrevented)
      return;
    this._isShown = !0, this._backdrop.show(), this._config.scroll || new Gl().hide(), this._element.setAttribute("aria-modal", !0), this._element.setAttribute("role", "dialog"), this._element.classList.add(cp);
    const s = () => {
      (!this._config.scroll || this._config.backdrop) && this._focustrap.activate(), this._element.classList.add(ap), this._element.classList.remove(cp), b.trigger(this._element, Mw, {
        relatedTarget: e
      });
    };
    this._queueCallback(s, this._element, !0);
  }
  hide() {
    if (!this._isShown || b.trigger(this._element, Dw).defaultPrevented)
      return;
    this._focustrap.deactivate(), this._element.blur(), this._isShown = !1, this._element.classList.add(lp), this._backdrop.hide();
    const n = () => {
      this._element.classList.remove(ap, lp), this._element.removeAttribute("aria-modal"), this._element.removeAttribute("role"), this._config.scroll || new Gl().reset(), b.trigger(this._element, z0);
    };
    this._queueCallback(n, this._element, !0);
  }
  dispose() {
    this._backdrop.dispose(), this._focustrap.deactivate(), super.dispose();
  }
  // Private
  _initializeBackDrop() {
    const e = () => {
      if (this._config.backdrop === "static") {
        b.trigger(this._element, dp);
        return;
      }
      this.hide();
    }, n = !!this._config.backdrop;
    return new $0({
      className: Ow,
      isVisible: n,
      isAnimated: !0,
      rootElement: this._element.parentNode,
      clickCallback: n ? e : null
    });
  }
  _initializeFocusTrap() {
    return new V0({
      trapElement: this._element
    });
  }
  _addEventListeners() {
    b.on(this._element, $w, (e) => {
      if (e.key === xw) {
        if (this._config.keyboard) {
          this.hide();
          return;
        }
        b.trigger(this._element, dp);
      }
    });
  }
  // Static
  static jQueryInterface(e) {
    return this.each(function() {
      const n = Vn.getOrCreateInstance(this, e);
      if (typeof e == "string") {
        if (n[e] === void 0 || e.startsWith("_") || e === "constructor")
          throw new TypeError(`No method named "${e}"`);
        n[e](this);
      }
    });
  }
}
b.on(document, Bw, Vw, function(t) {
  const e = x.getElementFromSelector(this);
  if (["A", "AREA"].includes(this.tagName) && t.preventDefault(), $n(this))
    return;
  b.one(e, z0, () => {
    Br(this) && this.focus();
  });
  const n = x.findOne(W0);
  n && n !== e && Vn.getInstance(n).hide(), Vn.getOrCreateInstance(e).toggle(this);
});
b.on(window, Rw, () => {
  for (const t of x.find(W0))
    Vn.getOrCreateInstance(t).show();
});
b.on(window, Gw, () => {
  for (const t of x.find("[aria-modal][class*=show][class*=offcanvas-]"))
    getComputedStyle(t).position !== "fixed" && Vn.getOrCreateInstance(t).hide();
});
ac(Vn);
yt(Vn);
const jw = /^aria-[\w-]*$/i, q0 = {
  // Global attributes allowed on any supplied element below.
  "*": ["class", "dir", "id", "lang", "role", jw],
  a: ["target", "href", "title", "rel"],
  area: [],
  b: [],
  br: [],
  col: [],
  code: [],
  dd: [],
  div: [],
  dl: [],
  dt: [],
  em: [],
  hr: [],
  h1: [],
  h2: [],
  h3: [],
  h4: [],
  h5: [],
  h6: [],
  i: [],
  img: ["src", "srcset", "alt", "title", "width", "height"],
  li: [],
  ol: [],
  p: [],
  pre: [],
  s: [],
  small: [],
  span: [],
  sub: [],
  sup: [],
  strong: [],
  u: [],
  ul: []
}, Ww = /* @__PURE__ */ new Set(["background", "cite", "href", "itemtype", "longdesc", "poster", "src", "xlink:href"]), zw = /^(?!javascript:)(?:[a-z0-9+.-]+:|[^&:/?#]*(?:[/?#]|$))/i, qw = (t, e) => {
  const n = t.nodeName.toLowerCase();
  return e.includes(n) ? Ww.has(n) ? !!zw.test(t.nodeValue) : !0 : e.filter((s) => s instanceof RegExp).some((s) => s.test(n));
};
function Yw(t, e, n) {
  if (!t.length)
    return t;
  if (n && typeof n == "function")
    return n(t);
  const r = new window.DOMParser().parseFromString(t, "text/html"), i = [].concat(...r.body.querySelectorAll("*"));
  for (const o of i) {
    const a = o.nodeName.toLowerCase();
    if (!Object.keys(e).includes(a)) {
      o.remove();
      continue;
    }
    const c = [].concat(...o.attributes), l = [].concat(e["*"] || [], e[a] || []);
    for (const d of c)
      qw(d, l) || o.removeAttribute(d.nodeName);
  }
  return r.body.innerHTML;
}
const Kw = "TemplateFactory", Xw = {
  allowList: q0,
  content: {},
  // { selector : text ,  selector2 : text2 , }
  extraClass: "",
  html: !1,
  sanitize: !0,
  sanitizeFn: null,
  template: "<div></div>"
}, Jw = {
  allowList: "object",
  content: "object",
  extraClass: "(string|function)",
  html: "boolean",
  sanitize: "boolean",
  sanitizeFn: "(null|function)",
  template: "string"
}, Qw = {
  entry: "(string|element|function|null)",
  selector: "(string|element)"
};
class Zw extends Xi {
  constructor(e) {
    super(), this._config = this._getConfig(e);
  }
  // Getters
  static get Default() {
    return Xw;
  }
  static get DefaultType() {
    return Jw;
  }
  static get NAME() {
    return Kw;
  }
  // Public
  getContent() {
    return Object.values(this._config.content).map((e) => this._resolvePossibleFunction(e)).filter(Boolean);
  }
  hasContent() {
    return this.getContent().length > 0;
  }
  changeContent(e) {
    return this._checkContent(e), this._config.content = {
      ...this._config.content,
      ...e
    }, this;
  }
  toHtml() {
    const e = document.createElement("div");
    e.innerHTML = this._maybeSanitize(this._config.template);
    for (const [r, i] of Object.entries(this._config.content))
      this._setContent(e, i, r);
    const n = e.children[0], s = this._resolvePossibleFunction(this._config.extraClass);
    return s && n.classList.add(...s.split(" ")), n;
  }
  // Private
  _typeCheckConfig(e) {
    super._typeCheckConfig(e), this._checkContent(e.content);
  }
  _checkContent(e) {
    for (const [n, s] of Object.entries(e))
      super._typeCheckConfig({
        selector: n,
        entry: s
      }, Qw);
  }
  _setContent(e, n, s) {
    const r = x.findOne(s, e);
    if (r) {
      if (n = this._resolvePossibleFunction(n), !n) {
        r.remove();
        return;
      }
      if (Zt(n)) {
        this._putElementInTemplate(Bn(n), r);
        return;
      }
      if (this._config.html) {
        r.innerHTML = this._maybeSanitize(n);
        return;
      }
      r.textContent = n;
    }
  }
  _maybeSanitize(e) {
    return this._config.sanitize ? Yw(e, this._config.allowList, this._config.sanitizeFn) : e;
  }
  _resolvePossibleFunction(e) {
    return Ze(e, [this]);
  }
  _putElementInTemplate(e, n) {
    if (this._config.html) {
      n.innerHTML = "", n.append(e);
      return;
    }
    n.textContent = e.textContent;
  }
}
const eT = "tooltip", tT = /* @__PURE__ */ new Set(["sanitize", "allowList", "sanitizeFn"]), Xc = "fade", nT = "modal", Ao = "show", sT = ".tooltip-inner", up = `.${nT}`, hp = "hide.bs.modal", si = "hover", Jc = "focus", rT = "click", iT = "manual", oT = "hide", aT = "hidden", cT = "show", lT = "shown", dT = "inserted", uT = "click", hT = "focusin", pT = "focusout", fT = "mouseenter", mT = "mouseleave", gT = {
  AUTO: "auto",
  TOP: "top",
  RIGHT: ft() ? "left" : "right",
  BOTTOM: "bottom",
  LEFT: ft() ? "right" : "left"
}, _T = {
  allowList: q0,
  animation: !0,
  boundary: "clippingParents",
  container: !1,
  customClass: "",
  delay: 0,
  fallbackPlacements: ["top", "right", "bottom", "left"],
  html: !1,
  offset: [0, 6],
  placement: "top",
  popperConfig: null,
  sanitize: !0,
  sanitizeFn: null,
  selector: !1,
  template: '<div class="tooltip" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>',
  title: "",
  trigger: "hover focus"
}, yT = {
  allowList: "object",
  animation: "boolean",
  boundary: "(string|element)",
  container: "(string|element|boolean)",
  customClass: "(string|function)",
  delay: "(number|object)",
  fallbackPlacements: "array",
  html: "boolean",
  offset: "(array|string|function)",
  placement: "(string|function)",
  popperConfig: "(null|object|function)",
  sanitize: "boolean",
  sanitizeFn: "(null|function)",
  selector: "(string|boolean)",
  template: "string",
  title: "(string|element|function)",
  trigger: "string"
};
class Ns extends kt {
  constructor(e, n) {
    if (typeof b0 > "u")
      throw new TypeError("Bootstrap's tooltips require Popper (https://popper.js.org)");
    super(e, n), this._isEnabled = !0, this._timeout = 0, this._isHovered = null, this._activeTrigger = {}, this._popper = null, this._templateFactory = null, this._newContent = null, this.tip = null, this._setListeners(), this._config.selector || this._fixTitle();
  }
  // Getters
  static get Default() {
    return _T;
  }
  static get DefaultType() {
    return yT;
  }
  static get NAME() {
    return eT;
  }
  // Public
  enable() {
    this._isEnabled = !0;
  }
  disable() {
    this._isEnabled = !1;
  }
  toggleEnabled() {
    this._isEnabled = !this._isEnabled;
  }
  toggle() {
    if (this._isEnabled) {
      if (this._activeTrigger.click = !this._activeTrigger.click, this._isShown()) {
        this._leave();
        return;
      }
      this._enter();
    }
  }
  dispose() {
    clearTimeout(this._timeout), b.off(this._element.closest(up), hp, this._hideModalHandler), this._element.getAttribute("data-bs-original-title") && this._element.setAttribute("title", this._element.getAttribute("data-bs-original-title")), this._disposePopper(), super.dispose();
  }
  show() {
    if (this._element.style.display === "none")
      throw new Error("Please use show on visible elements");
    if (!(this._isWithContent() && this._isEnabled))
      return;
    const e = b.trigger(this._element, this.constructor.eventName(cT)), s = (w0(this._element) || this._element.ownerDocument.documentElement).contains(this._element);
    if (e.defaultPrevented || !s)
      return;
    this._disposePopper();
    const r = this._getTipElement();
    this._element.setAttribute("aria-describedby", r.getAttribute("id"));
    const {
      container: i
    } = this._config;
    if (this._element.ownerDocument.documentElement.contains(this.tip) || (i.append(r), b.trigger(this._element, this.constructor.eventName(dT))), this._popper = this._createPopper(r), r.classList.add(Ao), "ontouchstart" in document.documentElement)
      for (const a of [].concat(...document.body.children))
        b.on(a, "mouseover", ha);
    const o = () => {
      b.trigger(this._element, this.constructor.eventName(lT)), this._isHovered === !1 && this._leave(), this._isHovered = !1;
    };
    this._queueCallback(o, this.tip, this._isAnimated());
  }
  hide() {
    if (!this._isShown() || b.trigger(this._element, this.constructor.eventName(oT)).defaultPrevented)
      return;
    if (this._getTipElement().classList.remove(Ao), "ontouchstart" in document.documentElement)
      for (const r of [].concat(...document.body.children))
        b.off(r, "mouseover", ha);
    this._activeTrigger[rT] = !1, this._activeTrigger[Jc] = !1, this._activeTrigger[si] = !1, this._isHovered = null;
    const s = () => {
      this._isWithActiveTrigger() || (this._isHovered || this._disposePopper(), this._element.removeAttribute("aria-describedby"), b.trigger(this._element, this.constructor.eventName(aT)));
    };
    this._queueCallback(s, this.tip, this._isAnimated());
  }
  update() {
    this._popper && this._popper.update();
  }
  // Protected
  _isWithContent() {
    return !!this._getTitle();
  }
  _getTipElement() {
    return this.tip || (this.tip = this._createTipElement(this._newContent || this._getContentForTemplate())), this.tip;
  }
  _createTipElement(e) {
    const n = this._getTemplateFactory(e).toHtml();
    if (!n)
      return null;
    n.classList.remove(Xc, Ao), n.classList.add(`bs-${this.constructor.NAME}-auto`);
    const s = rv(this.constructor.NAME).toString();
    return n.setAttribute("id", s), this._isAnimated() && n.classList.add(Xc), n;
  }
  setContent(e) {
    this._newContent = e, this._isShown() && (this._disposePopper(), this.show());
  }
  _getTemplateFactory(e) {
    return this._templateFactory ? this._templateFactory.changeContent(e) : this._templateFactory = new Zw({
      ...this._config,
      // the `content` var has to be after `this._config`
      // to override config.content in case of popover
      content: e,
      extraClass: this._resolvePossibleFunction(this._config.customClass)
    }), this._templateFactory;
  }
  _getContentForTemplate() {
    return {
      [sT]: this._getTitle()
    };
  }
  _getTitle() {
    return this._resolvePossibleFunction(this._config.title) || this._element.getAttribute("data-bs-original-title");
  }
  // Private
  _initializeOnDelegatedTarget(e) {
    return this.constructor.getOrCreateInstance(e.delegateTarget, this._getDelegateConfig());
  }
  _isAnimated() {
    return this._config.animation || this.tip && this.tip.classList.contains(Xc);
  }
  _isShown() {
    return this.tip && this.tip.classList.contains(Ao);
  }
  _createPopper(e) {
    const n = Ze(this._config.placement, [this, e, this._element]), s = gT[n.toUpperCase()];
    return Zd(this._element, e, this._getPopperConfig(s));
  }
  _getOffset() {
    const {
      offset: e
    } = this._config;
    return typeof e == "string" ? e.split(",").map((n) => Number.parseInt(n, 10)) : typeof e == "function" ? (n) => e(n, this._element) : e;
  }
  _resolvePossibleFunction(e) {
    return Ze(e, [this._element]);
  }
  _getPopperConfig(e) {
    const n = {
      placement: e,
      modifiers: [{
        name: "flip",
        options: {
          fallbackPlacements: this._config.fallbackPlacements
        }
      }, {
        name: "offset",
        options: {
          offset: this._getOffset()
        }
      }, {
        name: "preventOverflow",
        options: {
          boundary: this._config.boundary
        }
      }, {
        name: "arrow",
        options: {
          element: `.${this.constructor.NAME}-arrow`
        }
      }, {
        name: "preSetPlacement",
        enabled: !0,
        phase: "beforeMain",
        fn: (s) => {
          this._getTipElement().setAttribute("data-popper-placement", s.state.placement);
        }
      }]
    };
    return {
      ...n,
      ...Ze(this._config.popperConfig, [n])
    };
  }
  _setListeners() {
    const e = this._config.trigger.split(" ");
    for (const n of e)
      if (n === "click")
        b.on(this._element, this.constructor.eventName(uT), this._config.selector, (s) => {
          this._initializeOnDelegatedTarget(s).toggle();
        });
      else if (n !== iT) {
        const s = n === si ? this.constructor.eventName(fT) : this.constructor.eventName(hT), r = n === si ? this.constructor.eventName(mT) : this.constructor.eventName(pT);
        b.on(this._element, s, this._config.selector, (i) => {
          const o = this._initializeOnDelegatedTarget(i);
          o._activeTrigger[i.type === "focusin" ? Jc : si] = !0, o._enter();
        }), b.on(this._element, r, this._config.selector, (i) => {
          const o = this._initializeOnDelegatedTarget(i);
          o._activeTrigger[i.type === "focusout" ? Jc : si] = o._element.contains(i.relatedTarget), o._leave();
        });
      }
    this._hideModalHandler = () => {
      this._element && this.hide();
    }, b.on(this._element.closest(up), hp, this._hideModalHandler);
  }
  _fixTitle() {
    const e = this._element.getAttribute("title");
    e && (!this._element.getAttribute("aria-label") && !this._element.textContent.trim() && this._element.setAttribute("aria-label", e), this._element.setAttribute("data-bs-original-title", e), this._element.removeAttribute("title"));
  }
  _enter() {
    if (this._isShown() || this._isHovered) {
      this._isHovered = !0;
      return;
    }
    this._isHovered = !0, this._setTimeout(() => {
      this._isHovered && this.show();
    }, this._config.delay.show);
  }
  _leave() {
    this._isWithActiveTrigger() || (this._isHovered = !1, this._setTimeout(() => {
      this._isHovered || this.hide();
    }, this._config.delay.hide));
  }
  _setTimeout(e, n) {
    clearTimeout(this._timeout), this._timeout = setTimeout(e, n);
  }
  _isWithActiveTrigger() {
    return Object.values(this._activeTrigger).includes(!0);
  }
  _getConfig(e) {
    const n = en.getDataAttributes(this._element);
    for (const s of Object.keys(n))
      tT.has(s) && delete n[s];
    return e = {
      ...n,
      ...typeof e == "object" && e ? e : {}
    }, e = this._mergeConfigObj(e), e = this._configAfterMerge(e), this._typeCheckConfig(e), e;
  }
  _configAfterMerge(e) {
    return e.container = e.container === !1 ? document.body : Bn(e.container), typeof e.delay == "number" && (e.delay = {
      show: e.delay,
      hide: e.delay
    }), typeof e.title == "number" && (e.title = e.title.toString()), typeof e.content == "number" && (e.content = e.content.toString()), e;
  }
  _getDelegateConfig() {
    const e = {};
    for (const [n, s] of Object.entries(this._config))
      this.constructor.Default[n] !== s && (e[n] = s);
    return e.selector = !1, e.trigger = "manual", e;
  }
  _disposePopper() {
    this._popper && (this._popper.destroy(), this._popper = null), this.tip && (this.tip.remove(), this.tip = null);
  }
  // Static
  static jQueryInterface(e) {
    return this.each(function() {
      const n = Ns.getOrCreateInstance(this, e);
      if (typeof e == "string") {
        if (typeof n[e] > "u")
          throw new TypeError(`No method named "${e}"`);
        n[e]();
      }
    });
  }
}
yt(Ns);
const ET = "popover", bT = ".popover-header", vT = ".popover-body", ST = {
  ...Ns.Default,
  content: "",
  offset: [0, 8],
  placement: "right",
  template: '<div class="popover" role="tooltip"><div class="popover-arrow"></div><h3 class="popover-header"></h3><div class="popover-body"></div></div>',
  trigger: "click"
}, wT = {
  ...Ns.DefaultType,
  content: "(null|string|element|function)"
};
class su extends Ns {
  // Getters
  static get Default() {
    return ST;
  }
  static get DefaultType() {
    return wT;
  }
  static get NAME() {
    return ET;
  }
  // Overrides
  _isWithContent() {
    return this._getTitle() || this._getContent();
  }
  // Private
  _getContentForTemplate() {
    return {
      [bT]: this._getTitle(),
      [vT]: this._getContent()
    };
  }
  _getContent() {
    return this._resolvePossibleFunction(this._config.content);
  }
  // Static
  static jQueryInterface(e) {
    return this.each(function() {
      const n = su.getOrCreateInstance(this, e);
      if (typeof e == "string") {
        if (typeof n[e] > "u")
          throw new TypeError(`No method named "${e}"`);
        n[e]();
      }
    });
  }
}
yt(su);
const TT = "scrollspy", IT = "bs.scrollspy", ru = `.${IT}`, CT = ".data-api", FT = `activate${ru}`, pp = `click${ru}`, kT = `load${ru}${CT}`, AT = "dropdown-item", qs = "active", NT = '[data-bs-spy="scroll"]', Qc = "[href]", LT = ".nav, .list-group", fp = ".nav-link", RT = ".nav-item", xT = ".list-group-item", OT = `${fp}, ${RT} > ${fp}, ${xT}`, PT = ".dropdown", MT = ".dropdown-toggle", DT = {
  offset: null,
  // TODO: v6 @deprecated, keep it for backwards compatibility reasons
  rootMargin: "0px 0px -25%",
  smoothScroll: !1,
  target: null,
  threshold: [0.1, 0.5, 1]
}, GT = {
  offset: "(number|null)",
  // TODO v6 @deprecated, keep it for backwards compatibility reasons
  rootMargin: "string",
  smoothScroll: "boolean",
  target: "element",
  threshold: "array"
};
class dc extends kt {
  constructor(e, n) {
    super(e, n), this._targetLinks = /* @__PURE__ */ new Map(), this._observableSections = /* @__PURE__ */ new Map(), this._rootElement = getComputedStyle(this._element).overflowY === "visible" ? null : this._element, this._activeTarget = null, this._observer = null, this._previousScrollData = {
      visibleEntryTop: 0,
      parentScrollTop: 0
    }, this.refresh();
  }
  // Getters
  static get Default() {
    return DT;
  }
  static get DefaultType() {
    return GT;
  }
  static get NAME() {
    return TT;
  }
  // Public
  refresh() {
    this._initializeTargetsAndObservables(), this._maybeEnableSmoothScroll(), this._observer ? this._observer.disconnect() : this._observer = this._getNewObserver();
    for (const e of this._observableSections.values())
      this._observer.observe(e);
  }
  dispose() {
    this._observer.disconnect(), super.dispose();
  }
  // Private
  _configAfterMerge(e) {
    return e.target = Bn(e.target) || document.body, e.rootMargin = e.offset ? `${e.offset}px 0px -30%` : e.rootMargin, typeof e.threshold == "string" && (e.threshold = e.threshold.split(",").map((n) => Number.parseFloat(n))), e;
  }
  _maybeEnableSmoothScroll() {
    this._config.smoothScroll && (b.off(this._config.target, pp), b.on(this._config.target, pp, Qc, (e) => {
      const n = this._observableSections.get(e.target.hash);
      if (n) {
        e.preventDefault();
        const s = this._rootElement || window, r = n.offsetTop - this._element.offsetTop;
        if (s.scrollTo) {
          s.scrollTo({
            top: r,
            behavior: "smooth"
          });
          return;
        }
        s.scrollTop = r;
      }
    }));
  }
  _getNewObserver() {
    const e = {
      root: this._rootElement,
      threshold: this._config.threshold,
      rootMargin: this._config.rootMargin
    };
    return new IntersectionObserver((n) => this._observerCallback(n), e);
  }
  // The logic of selection
  _observerCallback(e) {
    const n = (o) => this._targetLinks.get(`#${o.target.id}`), s = (o) => {
      this._previousScrollData.visibleEntryTop = o.target.offsetTop, this._process(n(o));
    }, r = (this._rootElement || document.documentElement).scrollTop, i = r >= this._previousScrollData.parentScrollTop;
    this._previousScrollData.parentScrollTop = r;
    for (const o of e) {
      if (!o.isIntersecting) {
        this._activeTarget = null, this._clearActiveClass(n(o));
        continue;
      }
      const a = o.target.offsetTop >= this._previousScrollData.visibleEntryTop;
      if (i && a) {
        if (s(o), !r)
          return;
        continue;
      }
      !i && !a && s(o);
    }
  }
  _initializeTargetsAndObservables() {
    this._targetLinks = /* @__PURE__ */ new Map(), this._observableSections = /* @__PURE__ */ new Map();
    const e = x.find(Qc, this._config.target);
    for (const n of e) {
      if (!n.hash || $n(n))
        continue;
      const s = x.findOne(decodeURI(n.hash), this._element);
      Br(s) && (this._targetLinks.set(decodeURI(n.hash), n), this._observableSections.set(n.hash, s));
    }
  }
  _process(e) {
    this._activeTarget !== e && (this._clearActiveClass(this._config.target), this._activeTarget = e, e.classList.add(qs), this._activateParents(e), b.trigger(this._element, FT, {
      relatedTarget: e
    }));
  }
  _activateParents(e) {
    if (e.classList.contains(AT)) {
      x.findOne(MT, e.closest(PT)).classList.add(qs);
      return;
    }
    for (const n of x.parents(e, LT))
      for (const s of x.prev(n, OT))
        s.classList.add(qs);
  }
  _clearActiveClass(e) {
    e.classList.remove(qs);
    const n = x.find(`${Qc}.${qs}`, e);
    for (const s of n)
      s.classList.remove(qs);
  }
  // Static
  static jQueryInterface(e) {
    return this.each(function() {
      const n = dc.getOrCreateInstance(this, e);
      if (typeof e == "string") {
        if (n[e] === void 0 || e.startsWith("_") || e === "constructor")
          throw new TypeError(`No method named "${e}"`);
        n[e]();
      }
    });
  }
}
b.on(window, kT, () => {
  for (const t of x.find(NT))
    dc.getOrCreateInstance(t);
});
yt(dc);
const BT = "tab", $T = "bs.tab", Ls = `.${$T}`, VT = `hide${Ls}`, UT = `hidden${Ls}`, HT = `show${Ls}`, jT = `shown${Ls}`, WT = `click${Ls}`, zT = `keydown${Ls}`, qT = `load${Ls}`, YT = "ArrowLeft", mp = "ArrowRight", KT = "ArrowUp", gp = "ArrowDown", Zc = "Home", _p = "End", os = "active", yp = "fade", el = "show", XT = "dropdown", Y0 = ".dropdown-toggle", JT = ".dropdown-menu", tl = `:not(${Y0})`, QT = '.list-group, .nav, [role="tablist"]', ZT = ".nav-item, .list-group-item", eI = `.nav-link${tl}, .list-group-item${tl}, [role="tab"]${tl}`, K0 = '[data-bs-toggle="tab"], [data-bs-toggle="pill"], [data-bs-toggle="list"]', nl = `${eI}, ${K0}`, tI = `.${os}[data-bs-toggle="tab"], .${os}[data-bs-toggle="pill"], .${os}[data-bs-toggle="list"]`;
class on extends kt {
  constructor(e) {
    super(e), this._parent = this._element.closest(QT), this._parent && (this._setInitialAttributes(this._parent, this._getChildren()), b.on(this._element, zT, (n) => this._keydown(n)));
  }
  // Getters
  static get NAME() {
    return BT;
  }
  // Public
  show() {
    const e = this._element;
    if (this._elemIsActive(e))
      return;
    const n = this._getActiveElem(), s = n ? b.trigger(n, VT, {
      relatedTarget: e
    }) : null;
    b.trigger(e, HT, {
      relatedTarget: n
    }).defaultPrevented || s && s.defaultPrevented || (this._deactivate(n, e), this._activate(e, n));
  }
  // Private
  _activate(e, n) {
    if (!e)
      return;
    e.classList.add(os), this._activate(x.getElementFromSelector(e));
    const s = () => {
      if (e.getAttribute("role") !== "tab") {
        e.classList.add(el);
        return;
      }
      e.removeAttribute("tabindex"), e.setAttribute("aria-selected", !0), this._toggleDropDown(e, !0), b.trigger(e, jT, {
        relatedTarget: n
      });
    };
    this._queueCallback(s, e, e.classList.contains(yp));
  }
  _deactivate(e, n) {
    if (!e)
      return;
    e.classList.remove(os), e.blur(), this._deactivate(x.getElementFromSelector(e));
    const s = () => {
      if (e.getAttribute("role") !== "tab") {
        e.classList.remove(el);
        return;
      }
      e.setAttribute("aria-selected", !1), e.setAttribute("tabindex", "-1"), this._toggleDropDown(e, !1), b.trigger(e, UT, {
        relatedTarget: n
      });
    };
    this._queueCallback(s, e, e.classList.contains(yp));
  }
  _keydown(e) {
    if (![YT, mp, KT, gp, Zc, _p].includes(e.key))
      return;
    e.stopPropagation(), e.preventDefault();
    const n = this._getChildren().filter((r) => !$n(r));
    let s;
    if ([Zc, _p].includes(e.key))
      s = n[e.key === Zc ? 0 : n.length - 1];
    else {
      const r = [mp, gp].includes(e.key);
      s = eu(n, e.target, r, !0);
    }
    s && (s.focus({
      preventScroll: !0
    }), on.getOrCreateInstance(s).show());
  }
  _getChildren() {
    return x.find(nl, this._parent);
  }
  _getActiveElem() {
    return this._getChildren().find((e) => this._elemIsActive(e)) || null;
  }
  _setInitialAttributes(e, n) {
    this._setAttributeIfNotExists(e, "role", "tablist");
    for (const s of n)
      this._setInitialAttributesOnChild(s);
  }
  _setInitialAttributesOnChild(e) {
    e = this._getInnerElement(e);
    const n = this._elemIsActive(e), s = this._getOuterElement(e);
    e.setAttribute("aria-selected", n), s !== e && this._setAttributeIfNotExists(s, "role", "presentation"), n || e.setAttribute("tabindex", "-1"), this._setAttributeIfNotExists(e, "role", "tab"), this._setInitialAttributesOnTargetPanel(e);
  }
  _setInitialAttributesOnTargetPanel(e) {
    const n = x.getElementFromSelector(e);
    n && (this._setAttributeIfNotExists(n, "role", "tabpanel"), e.id && this._setAttributeIfNotExists(n, "aria-labelledby", `${e.id}`));
  }
  _toggleDropDown(e, n) {
    const s = this._getOuterElement(e);
    if (!s.classList.contains(XT))
      return;
    const r = (i, o) => {
      const a = x.findOne(i, s);
      a && a.classList.toggle(o, n);
    };
    r(Y0, os), r(JT, el), s.setAttribute("aria-expanded", n);
  }
  _setAttributeIfNotExists(e, n, s) {
    e.hasAttribute(n) || e.setAttribute(n, s);
  }
  _elemIsActive(e) {
    return e.classList.contains(os);
  }
  // Try to get the inner element (usually the .nav-link)
  _getInnerElement(e) {
    return e.matches(nl) ? e : x.findOne(nl, e);
  }
  // Try to get the outer element (usually the .nav-item)
  _getOuterElement(e) {
    return e.closest(ZT) || e;
  }
  // Static
  static jQueryInterface(e) {
    return this.each(function() {
      const n = on.getOrCreateInstance(this);
      if (typeof e == "string") {
        if (n[e] === void 0 || e.startsWith("_") || e === "constructor")
          throw new TypeError(`No method named "${e}"`);
        n[e]();
      }
    });
  }
}
b.on(document, WT, K0, function(t) {
  ["A", "AREA"].includes(this.tagName) && t.preventDefault(), !$n(this) && on.getOrCreateInstance(this).show();
});
b.on(window, qT, () => {
  for (const t of x.find(tI))
    on.getOrCreateInstance(t);
});
yt(on);
const nI = "toast", sI = "bs.toast", Yn = `.${sI}`, rI = `mouseover${Yn}`, iI = `mouseout${Yn}`, oI = `focusin${Yn}`, aI = `focusout${Yn}`, cI = `hide${Yn}`, lI = `hidden${Yn}`, dI = `show${Yn}`, uI = `shown${Yn}`, hI = "fade", Ep = "hide", No = "show", Lo = "showing", pI = {
  animation: "boolean",
  autohide: "boolean",
  delay: "number"
}, fI = {
  animation: !0,
  autohide: !0,
  delay: 5e3
};
class uc extends kt {
  constructor(e, n) {
    super(e, n), this._timeout = null, this._hasMouseInteraction = !1, this._hasKeyboardInteraction = !1, this._setListeners();
  }
  // Getters
  static get Default() {
    return fI;
  }
  static get DefaultType() {
    return pI;
  }
  static get NAME() {
    return nI;
  }
  // Public
  show() {
    if (b.trigger(this._element, dI).defaultPrevented)
      return;
    this._clearTimeout(), this._config.animation && this._element.classList.add(hI);
    const n = () => {
      this._element.classList.remove(Lo), b.trigger(this._element, uI), this._maybeScheduleHide();
    };
    this._element.classList.remove(Ep), Ki(this._element), this._element.classList.add(No, Lo), this._queueCallback(n, this._element, this._config.animation);
  }
  hide() {
    if (!this.isShown() || b.trigger(this._element, cI).defaultPrevented)
      return;
    const n = () => {
      this._element.classList.add(Ep), this._element.classList.remove(Lo, No), b.trigger(this._element, lI);
    };
    this._element.classList.add(Lo), this._queueCallback(n, this._element, this._config.animation);
  }
  dispose() {
    this._clearTimeout(), this.isShown() && this._element.classList.remove(No), super.dispose();
  }
  isShown() {
    return this._element.classList.contains(No);
  }
  // Private
  _maybeScheduleHide() {
    this._config.autohide && (this._hasMouseInteraction || this._hasKeyboardInteraction || (this._timeout = setTimeout(() => {
      this.hide();
    }, this._config.delay)));
  }
  _onInteraction(e, n) {
    switch (e.type) {
      case "mouseover":
      case "mouseout": {
        this._hasMouseInteraction = n;
        break;
      }
      case "focusin":
      case "focusout": {
        this._hasKeyboardInteraction = n;
        break;
      }
    }
    if (n) {
      this._clearTimeout();
      return;
    }
    const s = e.relatedTarget;
    this._element === s || this._element.contains(s) || this._maybeScheduleHide();
  }
  _setListeners() {
    b.on(this._element, rI, (e) => this._onInteraction(e, !0)), b.on(this._element, iI, (e) => this._onInteraction(e, !1)), b.on(this._element, oI, (e) => this._onInteraction(e, !0)), b.on(this._element, aI, (e) => this._onInteraction(e, !1));
  }
  _clearTimeout() {
    clearTimeout(this._timeout), this._timeout = null;
  }
  // Static
  static jQueryInterface(e) {
    return this.each(function() {
      const n = uc.getOrCreateInstance(this, e);
      if (typeof e == "string") {
        if (typeof n[e] > "u")
          throw new TypeError(`No method named "${e}"`);
        n[e](this);
      }
    });
  }
}
ac(uc);
yt(uc);
class mI extends HTMLElement {
  constructor() {
    super(), document.addEventListener("customer-logged-in", (e) => {
      document.getElementById("signed-in-as").innerHTML = e.detail.email ?? "Signed in as Pro Customer", document.getElementById("visitor-nav-buttons").classList.add("d-none"), document.getElementById("customer-nav-buttons").classList.remove("d-none");
    }), document.addEventListener("customer-logged-out", () => {
      document.getElementById("signed-in-as").innerHTML = "Signed in as Pro Customer", document.getElementById("visitor-nav-buttons").classList.remove("d-none"), document.getElementById("customer-nav-buttons").classList.add("d-none"), document.querySelector("#brand-version-badge").classList.innerHTML = "Basic";
    });
  }
  connectedCallback() {
    this.innerHTML = String.raw`
      <!-- *** Visitor *** -->
      <ul class="navbar-nav d-flex" id="visitor-nav-buttons">
        <li class="nav-item mx-1">
          <button type="button" class="btn btn-primary" data-bs-toggle="modal" data-bs-target="#modal-sign-up-form">
            Create an Account
          </button>
        </li>

        <li class="nav-item">
          <button type="button" class="btn btn-outline-secondary hidden-print" data-bs-toggle="modal" data-bs-target="#modal-login-form">
            Login
          </button>
        </li>
      </ul>

      <!-- *** Customer *** -->
      <ul class="navbar-nav d-flex d-none" id="customer-nav-buttons">  
        <li class="nav-item dropdown no-arrow mx-1">
          <a class="nav-link" href="#" role="button" data-bs-toggle="dropdown" aria-expanded="false">
          <svg xmlns="http://www.w3.org/2000/svg" width="14px" height="14px" viewBox="0 0 512 512"><!--!Font Awesome Free 6.6.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.--><path d="M399 384.2C376.9 345.8 335.4 320 288 320l-64 0c-47.4 0-88.9 25.8-111 64.2c35.2 39.2 86.2 63.8 143 63.8s107.8-24.7 143-63.8zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm256 16a72 72 0 1 0 0-144 72 72 0 1 0 0 144z"/></svg>
          <span id="signed-in-as">Signed in as Pro Customer</span>
          </a>
          <ul class="dropdown-menu">
            <li><a class="dropdown-item text-muted" href="account.html" class="navbar-link">My Account</a></li>
            <li><a class="dropdown-item text-muted" href="#" data-bs-toggle="modal" data-bs-target="#modal-sign-out-form">Logout</a></li>
          </ul>
        </li>
      </ul>
    `;
  }
}
customElements.define("nav-bar-login-buttons", mI);
class gI extends HTMLElement {
  constructor() {
    super(), document.addEventListener("customer-logged-in-and-upgraded", (e) => {
      document.getElementById("brand-version-badge").innerHTML = "Pro";
    }), document.addEventListener("customer-logged-out", () => {
      document.getElementById("brand-version-badge").innerHTML = "Basic";
    });
  }
  connectedCallback() {
    this.innerHTML = String.raw`
      <a class="navbar-brand" href="index.html">
        <!-- <img src="./simple-webstructural-cropped.png" width="40px">  -->
        WebStructural <span id="brand-version-badge" class="badge rounded-pill badge-green">Basic</span>
      </a>
    `;
  }
}
customElements.define("nav-bar-logo", gI);
class _I extends HTMLElement {
  constructor() {
    super(), document.addEventListener("processing-payment", () => {
      document.getElementById("submit-payment-spinner").classList.remove("d-none"), document.getElementById("submit-payment-button").disabled = !0;
    }), document.addEventListener("payment-succeeded", () => {
      document.getElementById("submit-payment-spinner").classList.add("d-none"), document.getElementById("submit-payment-button").disabled = !1, document.getElementById("subscribe-response-error").classList.add("d-none"), document.getElementById("subscribe-response-error").innerHTML = "", M.getOrCreateInstance("#modal-finish-upgrade").hide(), M.getOrCreateInstance("#modal-upgrade-complete").show();
    }), document.addEventListener("payment-failed", (e) => {
      document.getElementById("submit-payment-spinner").classList.add("d-none"), document.getElementById("submit-payment-button").disabled = !1, document.getElementById("subscribe-response-error").classList.remove("d-none"), document.getElementById("subscribe-response-error").innerHTML = e.detail;
    });
  }
  connectedCallback() {
    this.innerHTML = String.raw`
    <div class="modal fade" id="modal-finish-upgrade" tabindex="-1">
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-body">
            <div class="text-center">
              <h2 class="mb-4">Start Your Subscription</h2>
            </div>

            <div class="table-responsive">
              <table class="table">
                <thead>
                  <tr>
                    <th></th>
                    <th class="text-center">
                      <h4>Basic</h4>
                    </th>
                    <th class="text-center">
                      <h4>Pro</h4>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td><i class="fa fa-save fa-fw"></i> Save Projects</td>
                    <td class="text-center"><i class="fa fa-remove text-danger"></i></td>
                    <td class="text-center"><i class="fa fa-check text-success"></i></td>
                  </tr>
                  <tr>
                    <td><i class="fa fa-print fa-fw"></i> Print Results</td>
                    <td class="text-center"><i class="fa fa-remove text-danger"></i></td>
                    <td class="text-center"><i class="fa fa-check text-success"></i></td>
                  </tr>
                  <tr>
                    <td><i class="fa fa-ellipsis-h fa-fw"></i> Bigger Models (up to 50 joints)</td>
                    <td class="text-center"><i class="fa fa-remove text-danger"></i></td>
                    <td class="text-center"><i class="fa fa-check text-success"></i></td>
                  </tr>
                  <tr>
                    <td></td>
                    <td class="text-center">Free</td>
                    <td class="text-center" id="pro-price-table">$19 monthly</td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div class="row m-2 p-3 border border-success-subtle rounded-3">
              <div class="text-center mb-3">
                <div class="btn-group" role="group" aria-label="Plan duration">
                  <input type="radio" class="btn-check" name="plan" id="monthly-plan" value="price_1PDRg8B4xJc3X2gYk9f6A1a2" autocomplete="off" checked>
                  <label class="btn btn-outline-primary" for="monthly-plan">Monthly</label>
                  <!-- Test price - replace with actual price for production -->
                  <input type="radio" class="btn-check" name="plan" id="yearly-plan" value="price_1Sf8HrJ1scEMm3u6vQDCy9Fp" autocomplete="off">
                  <!-- <input type="radio" class="btn-check" name="plan" id="yearly-plan" value="price_1SeoEdJ1scEMm3u66Kdz7hz8" autocomplete="off"> -->
                  <label class="btn btn-outline-primary" for="yearly-plan">Yearly</label>
                </div>
              </div>
              <div class="row">
                <div class="col-md-2 text-center text-primary">
                  <h1 id="price-amount">$19</h1>
                  <p id="price-period">monthly</p>
                </div>
                <div class="col-md-10">
                  <form action="/charge" method="post" id="payment-form" role="form">

                    <div class="form-group">
                      <h4 style="margin-bottom:5px;" class="text-left">
                        Enter Credit or Debit Card Information to Upgrade 
                      </h4>
                      <p class="pb-2 text-muted fw-lighter text-secondary">
                        Checkout Powered by Stripe
                      </p>
                      <div id="card-element" class="py-3 form-control rounded-3">
                        <!-- A Stripe Element will be inserted here. -->
                      </div>
  
                      <!-- Used to display Element errors. -->
                      <div id="card-errors" role="alert"></div>
  
                    </div>

                    <div id="subscribe-response-error" class="alert alert-danger my-2 d-none"></div>

                    <button id="submit-payment-button" type="button" class="w-100 btn btn-primary btn-lg my-2">
                      <span id="submit-payment-spinner" class="d-none"><i class="fa fa-spinner fa-spin"></i></span>
                      Submit Payment
                    </button>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="modal fade" id="modal-upgrade-complete" tabindex="-1">
      <div class="modal-dialog modal-sm">
        <div class="modal-content">
          <div class="modal-body">
            <div class="text-center">
              <h3><i class="fa fa-check fa-3x"></i></h3>
              <h2 class="text-center">You're all set!</h2>
              <p>Your subscription was successfully started.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    `;
    const e = this.querySelector("#monthly-plan"), n = this.querySelector("#yearly-plan"), s = this.querySelector("#price-amount"), r = this.querySelector("#price-period"), i = this.querySelector("#pro-price-table");
    e.addEventListener("change", () => {
      e.checked && (s.textContent = "$19", r.textContent = "monthly", i.textContent = "$19 monthly");
    }), n.addEventListener("change", () => {
      n.checked && (s.textContent = "$199", r.textContent = "yearly", i.textContent = "$199 yearly");
    });
  }
}
customElements.define("finish-upgrade-modal-component", _I);
class yI extends HTMLElement {
  constructor() {
    super(), document.addEventListener("sending-forgot-password-link", () => {
      document.getElementById("forgot-password-spinner").classList.remove("d-none"), document.getElementById("modal-forgot-password-error").innerHTML = "", document.getElementById("modal-forgot-password-error").classList.add("d-none");
    }), document.addEventListener("forgot-password-link-sent", () => {
      document.getElementById("forgot-password-spinner").classList.add("d-none"), document.getElementById("modal-forgot-password-error").innerHTML = "", document.getElementById("modal-forgot-password-error").classList.add("d-none"), M.getOrCreateInstance(document.getElementById("modal-forgot-password-form")).hide(), M.getOrCreateInstance(document.getElementById("modal-forgot-password-email-sent")).show();
    }), document.addEventListener("forgot-password-link-failed", (e) => {
      document.getElementById("forgot-password-spinner").classList.add("d-none"), document.getElementById("modal-forgot-password-error").classList.remove("d-none"), document.getElementById("modal-forgot-password-error").innerHTML = e.detail;
    });
  }
  connectedCallback() {
    this.innerHTML = String.raw`

    <div class="modal fade py-5" id="modal-forgot-password-form" tabindex="-1" role="dialog">
      <div class="modal-dialog" role="document">
        <div class="modal-content rounded-4 shadow">
          <div class="modal-header p-5 pb-4 border-bottom-0">
            <h1 class="fw-bold mb-0 fs-2">Forgot Password?</h1>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body p-5 pt-0">
            <div class="">  
              <div id="modal-forgot-password-error" class="alert alert-danger d-none"></div>
    
              <div class="form-floating mb-3">
                <input type="email" class="form-control rounded-3" id="forgot-password-email" placeholder="name@example.com" autocomplete="email">
                <label for="forgot-password-email">Email address</label>
              </div>
                
              <button class="w-100 mb-2 btn btn-lg rounded-3 btn-primary" id="send-forgot-password-email-button" >
                Reset Password
                <span id="forgot-password-spinner" class="spinner-border  spinner-border-sm d-none" role="status"></span>  
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    
    <div class="modal fade py-5" id="modal-forgot-password-email-sent" tabindex="-1" role="dialog">
      <div class="modal-dialog" role="document">
        <div class="modal-content rounded-4 shadow">
          <div class="modal-header p-5 pb-4 border-bottom-0">
            <h1 class="fw-bold mb-0 fs-3">Password reset email sent.</h1>
            <!-- <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button> -->
          </div>
          <div class="modal-body p-5 pt-0">
            <p>Check your email for the link.</p>
          </div>
        </div>
      </div>
    </div>
    `, document.getElementById("send-forgot-password-email-button").addEventListener("click", ML);
  }
}
customElements.define("forgot-password-modal-component", yI);
class EI extends HTMLElement {
  constructor() {
    super(), document.addEventListener("logging-in", () => {
      document.getElementById("modal-sign-in-spinner").classList.remove("d-none"), document.getElementById("modal-sign-in-error").innerHTML = "", document.getElementById("modal-sign-in-error").classList.add("d-none");
    }), document.addEventListener("login-succeeded", () => {
      document.getElementById("modal-sign-in-spinner").classList.add("d-none"), document.getElementById("modal-sign-in-error").innerHTML = "", document.getElementById("modal-sign-in-error").classList.add("d-none"), M.getOrCreateInstance(document.getElementById("modal-login-form")).hide();
    }), document.addEventListener("login-failed", (e) => {
      document.getElementById("modal-sign-in-spinner").classList.add("d-none"), document.getElementById("modal-sign-in-error").innerHTML = e.detail, document.getElementById("modal-sign-in-error").classList.remove("d-none");
    });
  }
  connectedCallback() {
    this.innerHTML = String.raw`
    <div class="modal fade py-5" id="modal-login-form" tabindex="-1" aria-labelledby="myModalLabel">
      <div class="modal-dialog">
        <div class="modal-content rounded-4 shadow">
          <div class="modal-header p-5 pb-4 border-bottom-0">
            <h1 class="fw-bold mb-0 fs-2">Sign In</h1>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>

          <div class="modal-body p-5 pt-0">

            <div id="modal-sign-in-error" class="alert alert-danger d-none"></div>


            <div class="form-floating mb-3">
              <input type="email" class="form-control rounded-3" id="sign-in-email" placeholder="name@example.com" autocomplete="email">
              <label for="sign-in-email">Email address</label>
            </div>
            <div class="form-floating mb-3">
              <input type="password" class="form-control rounded-3" id="sign-in-password" autocomplete="password" placeholder="current-password">
              <label for="sign-in-password">Password</label>
            </div>
            <button class="w-100 mb-2 btn btn-lg rounded-3 btn-primary" id="modal-sign-in-button" >
              Sign In
              <span id="modal-sign-in-spinner" class="spinner-border  spinner-border-sm d-none" role="status"></span>  
            </button>
            <a href="#" class="btn btn-sm btn-default btn-block fw-light text-secondary" data-bs-dismiss="modal" 
              id="modal-sign-in-forgot-password-button" data-bs-toggle="modal" data-bs-target="#modal-forgot-password-form">
              Forgot password
            </a>

            <a href="#" class="btn btn-sm btn-default btn-block fw-light text-secondary float-end" data-bs-dismiss="modal" 
              data-bs-toggle="modal" data-bs-target="#modal-sign-up-form" >
              Create an account
            </a>
          </div>
        </div>
      </div>
    </div>`, document.getElementById("modal-sign-in-button").addEventListener("click", PL);
  }
}
customElements.define("login-modal-component", EI);
class bI extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    this.innerHTML = String.raw`

    <div class="modal fade modal-signin py-5 modal-sheet" tabindex="-1" role="dialog" id="modal-sign-out-form">
      <div class="modal-dialog" role="document">
        <div class="modal-content rounded-4 shadow">
          <div class="modal-footer flex-column border-top-0">
            <button type="button" id="modal-sign-out-button" data-bs-dismiss="modal" class="btn btn-lg btn-primary w-100 mx-0 mb-2">Sign Out</button>
            <button type="button" class="btn btn-lg btn-light w-100 mx-0" data-bs-dismiss="modal">Cancel</button>
          </div>
        </div>
      </div>
    </div>
    `, document.getElementById("modal-sign-out-button").addEventListener("click", OL);
  }
}
customElements.define("logout-modal-component", bI);
class vI extends HTMLElement {
  constructor() {
    super(), document.addEventListener("signing-up", () => {
      document.getElementById("modal-sign-up-error").innerHTML = "", document.getElementById("modal-sign-up-error").classList.add("d-none"), document.getElementById("sign-up-wait-spinner").classList.remove("d-none"), document.getElementById("modal-sign-up-button").disabled = !0;
    }), document.addEventListener("sign-up-succeeded", () => {
      M.getOrCreateInstance(document.getElementById("modal-sign-up-form")).hide(), M.getOrCreateInstance(document.getElementById("modal-finish-upgrade")).show();
    }), document.addEventListener("sign-up-failed", (e) => {
      document.getElementById("modal-sign-up-error").classList.remove("d-none"), document.getElementById("modal-sign-up-error").innerHTML = e.detail, document.getElementById("sign-up-wait-spinner").classList.add("d-none"), document.getElementById("modal-sign-up-button").disabled = !1;
    });
  }
  makeRow(e, n) {
    return String.raw`
      <tr>
        <td><i class="fa ${e} fa-fw"></i> ${n}</td>
        <td class="text-center"><i class="fa fa-remove text-danger"></i></td>
        <td class="text-center"><i class="fa fa-check text-success"></i></td>
      </tr>`;
  }
  connectedCallback() {
    this.getAttribute("features").split(",").map((s) => {
      const r = s.split(":");
      return this.makeRow(r[0], r[1]);
    }), this.innerHTML = String.raw`
    <div class="modal fade py-5" id="modal-sign-up-form" tabindex="-1">
      <div class="modal-dialog">
        <div class="modal-content rounded-4 shadow">
          <div class="modal-body p-5">

          <h1 class="h2 mb-2 fw-normal">Create an Account</h1>  

                <div id="modal-sign-up-error" class="form-floating alert alert-danger d-none">
                  Errors here
                </div>
            
                <div class="form-floating py-2">
                  <input type="name" class="form-control" id="sign-up-first-last" autocomplete="name" placeholder="First Last">
                  <label for="sign-up-first-last">Name</label>
                </div>

                <div class="form-floating py-2">
                  <input type="email" class="form-control" id="sign-up-email" autocomplete="email" placeholder="name@example.com">
                  <label for="sign-up-email">Email address</label>
                </div>

                <div class="form-floating py-2">
                  <input type="password" class="form-control" id="sign-up-password" autocomplete="password" placeholder="current-password">
                  <label for="sign-up-password">Password</label>
                </div>
            
                <button id='modal-sign-up-button' class="w-100 btn btn-lg btn-primary" type="submit">
                  Sign Up
                  <span id='sign-up-wait-spinner' class="spinner-border spinner-border-sm d-none" role="status"></span>  
                </button>
                
                <div class="form-group text-center pt-2">
                  <a href="#" class="btn btn-sm btn-default btn-block fw-light text-secondary text-center" 
                  data-bs-toggle="modal" data-bs-target="#modal-login-form">Already have an account? Login</a>
                </div>

                <div class="form-group text-center pt-2">
                  <a href="eula.html" target="_blank" class="btn btn-sm btn-default btn-block fw-light text-secondary text-center">
                    By creating an account you agree to our Terms of Service
                  </a>
                </div>

            
            <form role="form">
              <fieldset>
                

                <div class="d-grid gap-2">
                  
                </div>

                <div class="text-center my-2">
                  
                </div>
              </fieldset>
            </form>
          </div>
        </div>
      </div>
    </div>
    `, document.getElementById("modal-sign-up-button").addEventListener("click", GL);
  }
}
customElements.define("sign-up-modal-component", vI);
class SI extends HTMLElement {
  constructor() {
    super(), document.addEventListener("customer-logged-in-and-upgraded", () => {
      document.getElementById("upgrade-now-row").classList.add("d-none"), document.getElementById("resubscribe-row").classList.add("d-none"), document.getElementById("payment-failed-row").classList.add("d-none");
    }), document.addEventListener("customer-logged-in-not-upgraded", async () => {
      document.getElementById("upgrade-now-row").classList.remove("d-none"), document.getElementById("resubscribe-row").classList.add("d-none"), document.getElementById("payment-failed-row").classList.add("d-none");
    }), document.addEventListener("recurring-payment-failed", () => {
      document.getElementById("upgrade-now-row").classList.add("d-none"), document.getElementById("resubscribe-row").classList.add("d-none"), document.getElementById("payment-failed-row").classList.remove("d-none");
    }), document.addEventListener("subscription-previously-canceled", () => {
      document.getElementById("upgrade-now-row").classList.add("d-none"), document.getElementById("resubscribe-row").classList.remove("d-none"), document.getElementById("payment-failed-row").classList.add("d-none");
    }), document.addEventListener("customer-logged-out", () => {
      document.getElementById("upgrade-now-row").classList.add("d-none"), document.getElementById("resubscribe-row").classList.add("d-none"), document.getElementById("payment-failed-row").classList.add("d-none");
    }), document.addEventListener("redirecting-to-customer-portal", () => {
      document.getElementById("payment-failed-row-error").classList.add("d-none"), document.getElementById("resubscribe-row-error").classList.add("d-none");
    }), document.addEventListener("redirect-to-customer-portal-failed", () => {
      document.getElementById("payment-failed-row-error").classList.remove("d-none"), document.getElementById("resubscribe-row-error").classList.remove("d-none");
    });
  }
  connectedCallback() {
    this.innerHTML = String.raw`
    <!-- finish upgrading row -->
    <div id="upgrade-now-row" class="row my-2 d-none">  
      <div class="col" style="cursor:pointer;" data-bs-toggle="modal" data-bs-target="#modal-finish-upgrade">
        <div class="row p-3 ws-design-succeeded border border-success-subtle rounded-3">
          <div class="col-1 m-2">
            <h3>
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><!--!Font Awesome Free 6.6.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.--><path d="M400 480H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48v352c0 26.5-21.5 48-48 48zm-204.7-98.1l184-184c6.2-6.2 6.2-16.4 0-22.6l-22.6-22.6c-6.2-6.2-16.4-6.2-22.6 0L184 302.7l-70.1-70.1c-6.2-6.2-16.4-6.2-22.6 0l-22.6 22.6c-6.2 6.2-6.2 16.4 0 22.6l104 104c6.2 6.3 16.4 6.3 22.6 0z"/></svg>
            </h3>
          </div>
          <div class="col-10">
            <h3>You're almost done!</h3>
            <h4>Start your subscription to save & print projects for $19/month or $199/year</h4>
          </div>
        </div>
      </div>
    </div>

    <!-- payment failed row -->
    <div id="payment-failed-row" class="row my-2 d-none">
      <div class="col" style="cursor:pointer;">
        <div class="row p-3 ws-warning border border-warning rounded-3">
          <div class="col-1 m-2">
            <h3><i class="fa fa-warning fa-2x"></i></h3>
          </div>
          <div class="col-10">
            <h3>We're having trouble processing your last payment.</h3>
            <h4>Click here to manage your payment information.</h4>
            <div id="payment-failed-row-error" class="alert alert-danger d-none">
              There was a problem getting your subscription information. Please contact support.
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- resubscribe row -->
    <div id="resubscribe-row" class="row my-2 d-none">
      <div class="col" style="cursor:pointer;" data-bs-toggle="modal" data-bs-target="#modal-finish-upgrade">
        <div class="row p-3 text-warning-emphasis bg-warning-subtle border border-warning rounded-3">
          <div class="col-1 m-2">
            <h3><i class="fa fa-warning fa-2x"></i></h3>
          </div>
          <div class="col-10">
            <h3>Your subscription was canceled or it has expired.</h3>
            <h4>Click here to renew it.</h4>
            <div id="resubscribe-row-error" class="alert alert-danger d-none">
              There was a problem getting your subscription information. Please contact support.
            </div>
          </div>
        </div>
      </div>
    </div>
    `, document.getElementById("payment-failed-row").addEventListener("click", Ga);
  }
}
customElements.define("upgrade-info-component", SI);
class wI extends HTMLElement {
  constructor() {
    super(), document.addEventListener("verify-email-link-sent", () => {
      M.getOrCreateInstance(document.getElementById("modal-verify-email")).hide(), M.getOrCreateInstance(document.getElementById("modal-verify-email-sent")).show();
    });
  }
  connectedCallback() {
    this.innerHTML = String.raw`
      <!-- email verification -->
      <div class="modal fade py-5" id="modal-verify-email" tabindex="-1">
        <div class="modal-dialog">
          <div class="modal-content rounded-4 shadow">
            <div class="modal-header p-5 pb-4 border-bottom-0">
              <h1 class="fw-bold mb-0 fs-2">Don't forget to verify your email.</h1>
            </div>
            <div class="modal-body p-5 pt-0">
              <p>We sent you a verification link when you signed up.
                Please verify your email address by following the link we emailed to you.</p>
              <small>
                <a href="#" data-bs-dismiss="modal" id="resend-verify-email-button">
                  <span id="resend-verify-email-wait-spinner" class="d-none"><i class="fa fa-spinner fa-spin"></i></span>
                  Resend verification link
                </a>
              </small>
            </div>
          </div>
        </div>
      </div>
      
      <!-- email verification reminder -->
      <div class="modal fade py-5" id="modal-verify-email-sent" tabindex="-1">
        <div class="modal-dialog">
          <div class="modal-content rounded-4 shadow">
            <div class="modal-body p-5">
              <div class="text-center">
                <h3><i class="fa fa-envelope fa-3x"></i></h3>
                <h2 class="text-center">Verification email sent.</h2>
                <p>Please check your email for the link.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    `, document.getElementById("resend-verify-email-button").addEventListener("click", DL);
  }
}
customElements.define("verify-email-modal-component", wI);
class TI extends HTMLElement {
  constructor() {
    super(), document.addEventListener("customer-logged-out", () => {
      document.getElementById("current-plan").classList.add("d-none"), document.getElementById("select-a-plan").classList.remove("d-none");
    }, !0), document.addEventListener("customer-logged-in-and-upgraded", () => {
      document.getElementById("current-plan").classList.remove("d-none"), document.getElementById("select-a-plan").classList.add("d-none"), document.getElementById("basic-plan").classList.add("d-none"), document.getElementById("pro-plan").classList.remove("d-none");
    }, !0), document.addEventListener("recurring-payment-failed", () => {
      document.getElementById("current-plan").classList.remove("d-none"), document.getElementById("select-a-plan").classList.add("d-none"), document.getElementById("basic-plan").classList.remove("d-none"), document.getElementById("pro-plan").classList.add("d-none"), document.getElementById("create-account-plan-button").classList.add("d-none"), document.getElementById("start-subscription-plan-button").classList.remove("d-none");
    }, !0), document.addEventListener("subscription-previously-canceled", () => {
      document.getElementById("current-plan").classList.remove("d-none"), document.getElementById("select-a-plan").classList.add("d-none"), document.getElementById("basic-plan").classList.remove("d-none"), document.getElementById("pro-plan").classList.add("d-none"), document.getElementById("create-account-plan-button").classList.add("d-none"), document.getElementById("start-subscription-plan-button").classList.remove("d-none");
    }, !0), document.addEventListener("customer-logged-in-not-upgraded", () => {
      document.getElementById("current-plan").classList.remove("d-none"), document.getElementById("select-a-plan").classList.add("d-none"), document.getElementById("basic-plan").classList.remove("d-none"), document.getElementById("pro-plan").classList.add("d-none"), document.getElementById("create-account-plan-button").classList.add("d-none"), document.getElementById("start-subscription-plan-button").classList.remove("d-none");
    }, !0), document.addEventListener("redirecting-to-customer-portal", () => {
      document.getElementById("manage-subscription-error").classList.add("d-none"), document.getElementById("manage-subscription-error-2").classList.add("d-none");
    }, !0), document.addEventListener("redirect-to-customer-portal-failed", () => {
      document.getElementById("manage-subscription-error").classList.add("d-none"), document.getElementById("manage-subscription-error-2").classList.remove("d-none");
    }, !0);
  }
  connectedCallback() {
    this.innerHTML = String.raw`
      <div id="select-a-plan" class="px-3 py-3 my-4 text-center">
        <h2 class="display-6 pb-2 fw-bold">Select a Plan</h2>
        <div class="row row-cols-1 row-cols-md-3 mb-3 text-center">
          <div class="col">
            <div class="card mb-4 rounded-3 shadow-sm">
              <div class="card-header py-3">
                <h4 class="my-0 fw-normal">Basic</h4>
              </div>
              <div class="card-body">
                <h1 class="card-title pricing-card-title">$0<small class="text-body-secondary fw-light">/mo</small></h1>
                <ul class="list-unstyled mt-3 mb-4">
                  <li>Steel and Wood Beam Design</li>
                  <li>AISC and NDS Specifications</li>
                  <li>LRFD and ASD Load Combinations</li>
                  <li>2 Span Limit</li>
                </ul>
                <button type="button" class="w-100 btn btn-lg btn-outline-primary" data-bs-toggle="modal" data-bs-target="#modal-sign-up-form">Sign up for free</button>
              </div>
            </div>
          </div>
          <div class="col">
            <div class="card mb-4 rounded-3 shadow-sm">
              <div class="card-header py-3 text-bg-primary border-primary">
                <h4 class="my-0 fw-normal">Pro Monthly</h4>
              </div>
              <div class="card-body">
                <h1 class="card-title pricing-card-title">$19<small class="text-body-secondary fw-light">/mo</small></h1>
                <ul class="list-unstyled mt-3 mb-4">
                  <li>Save and Print Designs</li>
                  <li>Multi Ply Lumber</li>
                  <li>LVL and PSL Engineered Lumber</li>
                  <li>Up to 10 Spans</li>
                </ul>
                <button type="button" class="w-100 btn btn-lg btn-primary" data-bs-toggle="modal" data-bs-target="#modal-sign-up-form">Get started</button>
              </div>
            </div>
          </div>
          <div class="col">
            <div class="card mb-4 rounded-3 shadow-sm border-primary">
              <div class="card-header py-3 text-bg-primary border-primary">
                <h4 class="my-0 fw-normal">Pro Yearly</h4>
              </div>
              <div class="card-body">
                <h1 class="card-title pricing-card-title">$199<small class="text-body-secondary fw-light">/yr</small></h1>
                <ul class="list-unstyled mt-3 mb-4">
                  <li>Save and Print Designs</li>
                  <li>Multi Ply Lumber</li>
                  <li>LVL and PSL Engineered Lumber</li>
                  <li>Up to 10 Spans</li>
                </ul>
                <!-- <button type="button" class="w-100 btn btn-lg btn-primary" data-bs-toggle="modal" data-bs-target="#modal-sign-up-form">Get started</button> -->
                <button type="button" class="w-100 btn btn-lg btn-primary" disabled>Coming Soon</button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div id="current-plan" class="px-3 py-3 my-4 text-center d-none">
        <h2 id="current-plan-title" class="display-6 pb-2 fw-bold">Your Current Plan</h2>  
        
        <div id="basic-plan" class="col-4 mx-auto">
          <div class="card mb-4 rounded-3 shadow-sm">
            <div class="card-header py-3">
              <h4 class="my-0 fw-normal">Basic</h4>
            </div>
            
            <div class="card-body">
              <h1 class="card-title pricing-card-title">Free</small></h1>
              <ul class="list-unstyled mt-3 mb-4">
                <li>Steel and Wood Beam Design</li>
                <li>AISC and NDS Specifications</li>
                <li>LRFD and ASD Load Combinations</li>
                <li>2 Span Limit</li>
              </ul>
              
              <div id="manage-subscription-error" class="alert alert-danger d-none">There was a problem getting your subscription. Please try again later or contact support.</div>
              
              <div id="create-account-plan-button">
                <button type="button" class="w-100 btn btn-lg btn-primary" data-bs-toggle="modal" data-bs-target="#modal-sign-up-form">
                  Create Account
                </button>
              </div>

              <div id="start-subscription-plan-button" class="d-none">
                <button type="button" class="w-100 btn btn-lg btn-primary" data-bs-toggle="modal" data-bs-target="#modal-finish-upgrade">
                  Start Your Subscription
                </button>

                <div class="form-group text-center pt-2">
                  <a href="#" id="manage-subscription-button" class="btn btn-sm btn-default btn-block fw-light text-secondary text-center" >
                    Manage Payment Method
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div> 

        <div id="pro-plan" class="col-4  mx-auto d-none">
          <div class="card mb-4 rounded-3 shadow-sm border-primary">
            <div class="card-header py-3 text-bg-primary border-primary">
              <h4 class="my-0 fw-normal">Pro</h4>
              <p class="my-0 fw-normal">Your account is up to date.</p>
            </div>
            <div class="card-body">
              <h1 class="card-title pricing-card-title">$19<small class="text-muted fw-light">/mo</small></h1>
              <ul class="list-unstyled mt-3 mb-4">
                <li>Save and Print Designs</li>
                <li>Multi Ply Lumber</li>
                <li>LVL and PSL Engineered Lumber</li>
                <li>Up to 10 Spans</li>
              </ul>
              <div id="manage-subscription-error-2" class="alert alert-danger d-none">There was a problem getting your subscription. Please try again later or contact support.</div>
              <a href="#" id="manage-subscription-button-2" class="w-100 btn btn-lg btn-primary">
                Manage Your Subscription
              </a>       
            </div>
          </div>
        </div>
      </div>
      `, document.getElementById("manage-subscription-button").addEventListener("click", Ga), document.getElementById("manage-subscription-button-2").addEventListener("click", Ga);
  }
}
customElements.define("current-plan-component", TI);
class II extends HTMLElement {
  constructor() {
    super(), document.addEventListener("customer-logged-in-and-upgraded", () => {
      document.getElementById("upgrade-info").classList.add("d-none");
    }), document.addEventListener("customer-logged-in-not-upgraded", () => {
      document.getElementById("upgrade-info").classList.add("d-none");
    }), document.addEventListener("customer-logged-out", () => {
      document.getElementById("upgrade-info").classList.remove("d-none");
    });
  }
  connectedCallback() {
    this.innerHTML = String.raw`
      <div id="upgrade-info">
        <div class="row my-3" >
          <div class="col">
          <div class="card">
            <div class="card-body text-center">
              <h3>Finish your projects faster with WebStructural <a href="#" data-bs-toggle="modal" data-bs-target="#modal-sign-up-form">Upgrade now</a></h3>
            </div>
          </div>
        </div>
        
        <div class="row my-3">
          <div class="col">
            <a href="beam-designer.html" style="text-decoration: none; color:inherit;">
              <div class="h-100 p-4 bg-body-tertiary border rounded-3">
                <h2>Multi-span Beam Design</h2>
                <p>Design multi-span beams with complex loads with WebStructural's intuitive
                interface. An interactive drawing area allows you to design complex, multi-span beams in minutes.</p>
              </div>
            </a>
          </div>

          <div class="col">
            <a href="beam-designer.html" style="text-decoration: none; color:inherit;">
              <div class="h-100 p-4 bg-body-tertiary border rounded-3">
                <h2>Comprehensive Reports</h2>
                <p>Easy to read, printable and comprehensive design reports.
                AISC 360-16 Steel and NDS Wood Design LRFD and ASD Design Checks and Load Combinations.</p>
              </div>
            </a>
          </div>
        </div>
        
        <div class="row my-3">
          <div class="col">
            <div class="card">
              <div class="card-body text-left">
                <h3>About our Structural Analysis Software</h3>
                <div class="col-md-10">

                  <p>WebStructural is optimized for mobile and powered by cloud computing to deliver highly accurate 
                    structural analysis. Built on the finite element method (FEM) and advanced beam theory, our platform 
                    combines cutting-edge technology with an intuitive interface to make structural design fast, simple, 
                    and precise.
                  </p>


                  <h4 class="py-3">Free AISC Steel and NDS Wood Beam Design</h4>
                  Use WebStructural for free, as long as you like. There's nothing to install, simply navigate to
                  a calculator and start designing. If you like the tool and want to <strong>save</strong> and 
                  <strong>print</strong> projects you can <a href="account.html">upgrade for $19 monthly</a>. 
                  There's no long-term contract. Cancel anytime, we'll save your projects and you can resubscribe later to access them.

                  <h4 class="py-3">More Free Online Calculators</h4>

                  <p>We make easy to use, powerful structural engineering and structural analysis
                      software. Try some of
                      our
                      other free tools:</p>

                  <p><a class="btn btn-outline-primary" href="beam-designer.html">Steel and Wood Beam Design</a>
                  <p><a class="btn btn-outline-primary" href="anchor-bolt-designer.html">Anchor Bolt Designer</a>
                  <p><a class="btn btn-outline-primary" href="footing-designer.html">Concrete Spread Footing Designer</a>
                  <p><a class="btn btn-outline-primary" href="shear-and-moment-diagram.html">Shear and Moment Calculator</a>
                  <p><a class="btn btn-outline-primary" href="beam-calculator.html">Beam Calculator</a>
                  <p><a class="btn btn-outline-primary" href="cross-section-calculator.html">Shape Calculator</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>`;
  }
}
customElements.define("about-structural-analysis-component", II);
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const X0 = {
  /**
   * @define {boolean} Whether this is the client Node.js SDK.
   */
  NODE_CLIENT: !1,
  /**
   * @define {boolean} Whether this is the Admin Node.js SDK.
   */
  NODE_ADMIN: !1,
  /**
   * Firebase SDK Version
   */
  SDK_VERSION: "${JSCORE_VERSION}"
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const S = function(t, e) {
  if (!t)
    throw Vr(e);
}, Vr = function(t) {
  return new Error("Firebase Database (" + X0.SDK_VERSION + ") INTERNAL ASSERT FAILED: " + t);
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const J0 = function(t) {
  const e = [];
  let n = 0;
  for (let s = 0; s < t.length; s++) {
    let r = t.charCodeAt(s);
    r < 128 ? e[n++] = r : r < 2048 ? (e[n++] = r >> 6 | 192, e[n++] = r & 63 | 128) : (r & 64512) === 55296 && s + 1 < t.length && (t.charCodeAt(s + 1) & 64512) === 56320 ? (r = 65536 + ((r & 1023) << 10) + (t.charCodeAt(++s) & 1023), e[n++] = r >> 18 | 240, e[n++] = r >> 12 & 63 | 128, e[n++] = r >> 6 & 63 | 128, e[n++] = r & 63 | 128) : (e[n++] = r >> 12 | 224, e[n++] = r >> 6 & 63 | 128, e[n++] = r & 63 | 128);
  }
  return e;
}, CI = function(t) {
  const e = [];
  let n = 0, s = 0;
  for (; n < t.length; ) {
    const r = t[n++];
    if (r < 128)
      e[s++] = String.fromCharCode(r);
    else if (r > 191 && r < 224) {
      const i = t[n++];
      e[s++] = String.fromCharCode((r & 31) << 6 | i & 63);
    } else if (r > 239 && r < 365) {
      const i = t[n++], o = t[n++], a = t[n++], c = ((r & 7) << 18 | (i & 63) << 12 | (o & 63) << 6 | a & 63) - 65536;
      e[s++] = String.fromCharCode(55296 + (c >> 10)), e[s++] = String.fromCharCode(56320 + (c & 1023));
    } else {
      const i = t[n++], o = t[n++];
      e[s++] = String.fromCharCode((r & 15) << 12 | (i & 63) << 6 | o & 63);
    }
  }
  return e.join("");
}, iu = {
  /**
   * Maps bytes to characters.
   */
  byteToCharMap_: null,
  /**
   * Maps characters to bytes.
   */
  charToByteMap_: null,
  /**
   * Maps bytes to websafe characters.
   * @private
   */
  byteToCharMapWebSafe_: null,
  /**
   * Maps websafe characters to bytes.
   * @private
   */
  charToByteMapWebSafe_: null,
  /**
   * Our default alphabet, shared between
   * ENCODED_VALS and ENCODED_VALS_WEBSAFE
   */
  ENCODED_VALS_BASE: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789",
  /**
   * Our default alphabet. Value 64 (=) is special; it means "nothing."
   */
  get ENCODED_VALS() {
    return this.ENCODED_VALS_BASE + "+/=";
  },
  /**
   * Our websafe alphabet.
   */
  get ENCODED_VALS_WEBSAFE() {
    return this.ENCODED_VALS_BASE + "-_.";
  },
  /**
   * Whether this browser supports the atob and btoa functions. This extension
   * started at Mozilla but is now implemented by many browsers. We use the
   * ASSUME_* variables to avoid pulling in the full useragent detection library
   * but still allowing the standard per-browser compilations.
   *
   */
  HAS_NATIVE_SUPPORT: typeof atob == "function",
  /**
   * Base64-encode an array of bytes.
   *
   * @param input An array of bytes (numbers with
   *     value in [0, 255]) to encode.
   * @param webSafe Boolean indicating we should use the
   *     alternative alphabet.
   * @return The base64 encoded string.
   */
  encodeByteArray(t, e) {
    if (!Array.isArray(t))
      throw Error("encodeByteArray takes an array as a parameter");
    this.init_();
    const n = e ? this.byteToCharMapWebSafe_ : this.byteToCharMap_, s = [];
    for (let r = 0; r < t.length; r += 3) {
      const i = t[r], o = r + 1 < t.length, a = o ? t[r + 1] : 0, c = r + 2 < t.length, l = c ? t[r + 2] : 0, d = i >> 2, u = (i & 3) << 4 | a >> 4;
      let h = (a & 15) << 2 | l >> 6, p = l & 63;
      c || (p = 64, o || (h = 64)), s.push(n[d], n[u], n[h], n[p]);
    }
    return s.join("");
  },
  /**
   * Base64-encode a string.
   *
   * @param input A string to encode.
   * @param webSafe If true, we should use the
   *     alternative alphabet.
   * @return The base64 encoded string.
   */
  encodeString(t, e) {
    return this.HAS_NATIVE_SUPPORT && !e ? btoa(t) : this.encodeByteArray(J0(t), e);
  },
  /**
   * Base64-decode a string.
   *
   * @param input to decode.
   * @param webSafe True if we should use the
   *     alternative alphabet.
   * @return string representing the decoded value.
   */
  decodeString(t, e) {
    return this.HAS_NATIVE_SUPPORT && !e ? atob(t) : CI(this.decodeStringToByteArray(t, e));
  },
  /**
   * Base64-decode a string.
   *
   * In base-64 decoding, groups of four characters are converted into three
   * bytes.  If the encoder did not apply padding, the input length may not
   * be a multiple of 4.
   *
   * In this case, the last group will have fewer than 4 characters, and
   * padding will be inferred.  If the group has one or two characters, it decodes
   * to one byte.  If the group has three characters, it decodes to two bytes.
   *
   * @param input Input to decode.
   * @param webSafe True if we should use the web-safe alphabet.
   * @return bytes representing the decoded value.
   */
  decodeStringToByteArray(t, e) {
    this.init_();
    const n = e ? this.charToByteMapWebSafe_ : this.charToByteMap_, s = [];
    for (let r = 0; r < t.length; ) {
      const i = n[t.charAt(r++)], a = r < t.length ? n[t.charAt(r)] : 0;
      ++r;
      const l = r < t.length ? n[t.charAt(r)] : 64;
      ++r;
      const u = r < t.length ? n[t.charAt(r)] : 64;
      if (++r, i == null || a == null || l == null || u == null)
        throw new FI();
      const h = i << 2 | a >> 4;
      if (s.push(h), l !== 64) {
        const p = a << 4 & 240 | l >> 2;
        if (s.push(p), u !== 64) {
          const f = l << 6 & 192 | u;
          s.push(f);
        }
      }
    }
    return s;
  },
  /**
   * Lazy static initialization function. Called before
   * accessing any of the static map variables.
   * @private
   */
  init_() {
    if (!this.byteToCharMap_) {
      this.byteToCharMap_ = {}, this.charToByteMap_ = {}, this.byteToCharMapWebSafe_ = {}, this.charToByteMapWebSafe_ = {};
      for (let t = 0; t < this.ENCODED_VALS.length; t++)
        this.byteToCharMap_[t] = this.ENCODED_VALS.charAt(t), this.charToByteMap_[this.byteToCharMap_[t]] = t, this.byteToCharMapWebSafe_[t] = this.ENCODED_VALS_WEBSAFE.charAt(t), this.charToByteMapWebSafe_[this.byteToCharMapWebSafe_[t]] = t, t >= this.ENCODED_VALS_BASE.length && (this.charToByteMap_[this.ENCODED_VALS_WEBSAFE.charAt(t)] = t, this.charToByteMapWebSafe_[this.ENCODED_VALS.charAt(t)] = t);
    }
  }
};
class FI extends Error {
  constructor() {
    super(...arguments), this.name = "DecodeBase64StringError";
  }
}
const Q0 = function(t) {
  const e = J0(t);
  return iu.encodeByteArray(e, !0);
}, ma = function(t) {
  return Q0(t).replace(/\./g, "");
}, ga = function(t) {
  try {
    return iu.decodeString(t, !0);
  } catch (e) {
    console.error("base64Decode failed: ", e);
  }
  return null;
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function kI(t) {
  return Z0(void 0, t);
}
function Z0(t, e) {
  if (!(e instanceof Object))
    return e;
  switch (e.constructor) {
    case Date:
      const n = e;
      return new Date(n.getTime());
    case Object:
      t === void 0 && (t = {});
      break;
    case Array:
      t = [];
      break;
    default:
      return e;
  }
  for (const n in e)
    !e.hasOwnProperty(n) || !AI(n) || (t[n] = Z0(t[n], e[n]));
  return t;
}
function AI(t) {
  return t !== "__proto__";
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function NI() {
  if (typeof self < "u")
    return self;
  if (typeof window < "u")
    return window;
  if (typeof global < "u")
    return global;
  throw new Error("Unable to locate global object.");
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const LI = () => NI().__FIREBASE_DEFAULTS__, RI = () => {
  if (typeof process > "u" || typeof process.env > "u")
    return;
  const t = process.env.__FIREBASE_DEFAULTS__;
  if (t)
    return JSON.parse(t);
}, xI = () => {
  if (typeof document > "u")
    return;
  let t;
  try {
    t = document.cookie.match(/__FIREBASE_DEFAULTS__=([^;]+)/);
  } catch {
    return;
  }
  const e = t && ga(t[1]);
  return e && JSON.parse(e);
}, ou = () => {
  try {
    return LI() || RI() || xI();
  } catch (t) {
    console.info(`Unable to get __FIREBASE_DEFAULTS__ due to: ${t}`);
    return;
  }
}, eg = (t) => {
  var e, n;
  return (n = (e = ou()) === null || e === void 0 ? void 0 : e.emulatorHosts) === null || n === void 0 ? void 0 : n[t];
}, OI = (t) => {
  const e = eg(t);
  if (!e)
    return;
  const n = e.lastIndexOf(":");
  if (n <= 0 || n + 1 === e.length)
    throw new Error(`Invalid host ${e} with no separate hostname and port!`);
  const s = parseInt(e.substring(n + 1), 10);
  return e[0] === "[" ? [e.substring(1, n - 1), s] : [e.substring(0, n), s];
}, tg = () => {
  var t;
  return (t = ou()) === null || t === void 0 ? void 0 : t.config;
}, ng = (t) => {
  var e;
  return (e = ou()) === null || e === void 0 ? void 0 : e[`_${t}`];
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class Zi {
  constructor() {
    this.reject = () => {
    }, this.resolve = () => {
    }, this.promise = new Promise((e, n) => {
      this.resolve = e, this.reject = n;
    });
  }
  /**
   * Our API internals are not promiseified and cannot because our callback APIs have subtle expectations around
   * invoking promises inline, which Promises are forbidden to do. This method accepts an optional node-style callback
   * and returns a node-style callback which will resolve or reject the Deferred's promise.
   */
  wrapCallback(e) {
    return (n, s) => {
      n ? this.reject(n) : this.resolve(s), typeof e == "function" && (this.promise.catch(() => {
      }), e.length === 1 ? e(n) : e(n, s));
    };
  }
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function PI(t, e) {
  if (t.uid)
    throw new Error('The "uid" field is no longer supported by mockUserToken. Please use "sub" instead for Firebase Auth User ID.');
  const n = {
    alg: "none",
    type: "JWT"
  }, s = e || "demo-project", r = t.iat || 0, i = t.sub || t.user_id;
  if (!i)
    throw new Error("mockUserToken must contain 'sub' or 'user_id' field!");
  const o = Object.assign({
    // Set all required fields to decent defaults
    iss: `https://securetoken.google.com/${s}`,
    aud: s,
    iat: r,
    exp: r + 3600,
    auth_time: r,
    sub: i,
    user_id: i,
    firebase: {
      sign_in_provider: "custom",
      identities: {}
    }
  }, t);
  return [
    ma(JSON.stringify(n)),
    ma(JSON.stringify(o)),
    ""
  ].join(".");
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function $e() {
  return typeof navigator < "u" && typeof navigator.userAgent == "string" ? navigator.userAgent : "";
}
function au() {
  return typeof window < "u" && // @ts-ignore Setting up an broadly applicable index signature for Window
  // just to deal with this case would probably be a bad idea.
  !!(window.cordova || window.phonegap || window.PhoneGap) && /ios|iphone|ipod|ipad|android|blackberry|iemobile/i.test($e());
}
function MI() {
  const t = typeof chrome == "object" ? chrome.runtime : typeof browser == "object" ? browser.runtime : void 0;
  return typeof t == "object" && t.id !== void 0;
}
function sg() {
  return typeof navigator == "object" && navigator.product === "ReactNative";
}
function DI() {
  const t = $e();
  return t.indexOf("MSIE ") >= 0 || t.indexOf("Trident/") >= 0;
}
function rg() {
  return X0.NODE_ADMIN === !0;
}
function GI() {
  try {
    return typeof indexedDB == "object";
  } catch {
    return !1;
  }
}
function BI() {
  return new Promise((t, e) => {
    try {
      let n = !0;
      const s = "validate-browser-context-for-indexeddb-analytics-module", r = self.indexedDB.open(s);
      r.onsuccess = () => {
        r.result.close(), n || self.indexedDB.deleteDatabase(s), t(!0);
      }, r.onupgradeneeded = () => {
        n = !1;
      }, r.onerror = () => {
        var i;
        e(((i = r.error) === null || i === void 0 ? void 0 : i.message) || "");
      };
    } catch (n) {
      e(n);
    }
  });
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const $I = "FirebaseError";
class Kn extends Error {
  constructor(e, n, s) {
    super(n), this.code = e, this.customData = s, this.name = $I, Object.setPrototypeOf(this, Kn.prototype), Error.captureStackTrace && Error.captureStackTrace(this, eo.prototype.create);
  }
}
class eo {
  constructor(e, n, s) {
    this.service = e, this.serviceName = n, this.errors = s;
  }
  create(e, ...n) {
    const s = n[0] || {}, r = `${this.service}/${e}`, i = this.errors[e], o = i ? VI(i, s) : "Error", a = `${this.serviceName}: ${o} (${r}).`;
    return new Kn(r, a, s);
  }
}
function VI(t, e) {
  return t.replace(UI, (n, s) => {
    const r = e[s];
    return r != null ? String(r) : `<${s}?>`;
  });
}
const UI = /\{\$([^}]+)}/g;
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function Fi(t) {
  return JSON.parse(t);
}
function Ie(t) {
  return JSON.stringify(t);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const ig = function(t) {
  let e = {}, n = {}, s = {}, r = "";
  try {
    const i = t.split(".");
    e = Fi(ga(i[0]) || ""), n = Fi(ga(i[1]) || ""), r = i[2], s = n.d || {}, delete n.d;
  } catch {
  }
  return {
    header: e,
    claims: n,
    data: s,
    signature: r
  };
}, HI = function(t) {
  const e = ig(t), n = e.claims;
  return !!n && typeof n == "object" && n.hasOwnProperty("iat");
}, jI = function(t) {
  const e = ig(t).claims;
  return typeof e == "object" && e.admin === !0;
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function $t(t, e) {
  return Object.prototype.hasOwnProperty.call(t, e);
}
function br(t, e) {
  if (Object.prototype.hasOwnProperty.call(t, e))
    return t[e];
}
function Bl(t) {
  for (const e in t)
    if (Object.prototype.hasOwnProperty.call(t, e))
      return !1;
  return !0;
}
function _a(t, e, n) {
  const s = {};
  for (const r in t)
    Object.prototype.hasOwnProperty.call(t, r) && (s[r] = e.call(n, t[r], r, t));
  return s;
}
function ya(t, e) {
  if (t === e)
    return !0;
  const n = Object.keys(t), s = Object.keys(e);
  for (const r of n) {
    if (!s.includes(r))
      return !1;
    const i = t[r], o = e[r];
    if (bp(i) && bp(o)) {
      if (!ya(i, o))
        return !1;
    } else if (i !== o)
      return !1;
  }
  for (const r of s)
    if (!n.includes(r))
      return !1;
  return !0;
}
function bp(t) {
  return t !== null && typeof t == "object";
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function Ur(t) {
  const e = [];
  for (const [n, s] of Object.entries(t))
    Array.isArray(s) ? s.forEach((r) => {
      e.push(encodeURIComponent(n) + "=" + encodeURIComponent(r));
    }) : e.push(encodeURIComponent(n) + "=" + encodeURIComponent(s));
  return e.length ? "&" + e.join("&") : "";
}
function di(t) {
  const e = {};
  return t.replace(/^\?/, "").split("&").forEach((s) => {
    if (s) {
      const [r, i] = s.split("=");
      e[decodeURIComponent(r)] = decodeURIComponent(i);
    }
  }), e;
}
function ui(t) {
  const e = t.indexOf("?");
  if (!e)
    return "";
  const n = t.indexOf("#", e);
  return t.substring(e, n > 0 ? n : void 0);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class WI {
  constructor() {
    this.chain_ = [], this.buf_ = [], this.W_ = [], this.pad_ = [], this.inbuf_ = 0, this.total_ = 0, this.blockSize = 512 / 8, this.pad_[0] = 128;
    for (let e = 1; e < this.blockSize; ++e)
      this.pad_[e] = 0;
    this.reset();
  }
  reset() {
    this.chain_[0] = 1732584193, this.chain_[1] = 4023233417, this.chain_[2] = 2562383102, this.chain_[3] = 271733878, this.chain_[4] = 3285377520, this.inbuf_ = 0, this.total_ = 0;
  }
  /**
   * Internal compress helper function.
   * @param buf Block to compress.
   * @param offset Offset of the block in the buffer.
   * @private
   */
  compress_(e, n) {
    n || (n = 0);
    const s = this.W_;
    if (typeof e == "string")
      for (let u = 0; u < 16; u++)
        s[u] = e.charCodeAt(n) << 24 | e.charCodeAt(n + 1) << 16 | e.charCodeAt(n + 2) << 8 | e.charCodeAt(n + 3), n += 4;
    else
      for (let u = 0; u < 16; u++)
        s[u] = e[n] << 24 | e[n + 1] << 16 | e[n + 2] << 8 | e[n + 3], n += 4;
    for (let u = 16; u < 80; u++) {
      const h = s[u - 3] ^ s[u - 8] ^ s[u - 14] ^ s[u - 16];
      s[u] = (h << 1 | h >>> 31) & 4294967295;
    }
    let r = this.chain_[0], i = this.chain_[1], o = this.chain_[2], a = this.chain_[3], c = this.chain_[4], l, d;
    for (let u = 0; u < 80; u++) {
      u < 40 ? u < 20 ? (l = a ^ i & (o ^ a), d = 1518500249) : (l = i ^ o ^ a, d = 1859775393) : u < 60 ? (l = i & o | a & (i | o), d = 2400959708) : (l = i ^ o ^ a, d = 3395469782);
      const h = (r << 5 | r >>> 27) + l + c + d + s[u] & 4294967295;
      c = a, a = o, o = (i << 30 | i >>> 2) & 4294967295, i = r, r = h;
    }
    this.chain_[0] = this.chain_[0] + r & 4294967295, this.chain_[1] = this.chain_[1] + i & 4294967295, this.chain_[2] = this.chain_[2] + o & 4294967295, this.chain_[3] = this.chain_[3] + a & 4294967295, this.chain_[4] = this.chain_[4] + c & 4294967295;
  }
  update(e, n) {
    if (e == null)
      return;
    n === void 0 && (n = e.length);
    const s = n - this.blockSize;
    let r = 0;
    const i = this.buf_;
    let o = this.inbuf_;
    for (; r < n; ) {
      if (o === 0)
        for (; r <= s; )
          this.compress_(e, r), r += this.blockSize;
      if (typeof e == "string") {
        for (; r < n; )
          if (i[o] = e.charCodeAt(r), ++o, ++r, o === this.blockSize) {
            this.compress_(i), o = 0;
            break;
          }
      } else
        for (; r < n; )
          if (i[o] = e[r], ++o, ++r, o === this.blockSize) {
            this.compress_(i), o = 0;
            break;
          }
    }
    this.inbuf_ = o, this.total_ += n;
  }
  /** @override */
  digest() {
    const e = [];
    let n = this.total_ * 8;
    this.inbuf_ < 56 ? this.update(this.pad_, 56 - this.inbuf_) : this.update(this.pad_, this.blockSize - (this.inbuf_ - 56));
    for (let r = this.blockSize - 1; r >= 56; r--)
      this.buf_[r] = n & 255, n /= 256;
    this.compress_(this.buf_);
    let s = 0;
    for (let r = 0; r < 5; r++)
      for (let i = 24; i >= 0; i -= 8)
        e[s] = this.chain_[r] >> i & 255, ++s;
    return e;
  }
}
function zI(t, e) {
  const n = new qI(t, e);
  return n.subscribe.bind(n);
}
class qI {
  /**
   * @param executor Function which can make calls to a single Observer
   *     as a proxy.
   * @param onNoObservers Callback when count of Observers goes to zero.
   */
  constructor(e, n) {
    this.observers = [], this.unsubscribes = [], this.observerCount = 0, this.task = Promise.resolve(), this.finalized = !1, this.onNoObservers = n, this.task.then(() => {
      e(this);
    }).catch((s) => {
      this.error(s);
    });
  }
  next(e) {
    this.forEachObserver((n) => {
      n.next(e);
    });
  }
  error(e) {
    this.forEachObserver((n) => {
      n.error(e);
    }), this.close(e);
  }
  complete() {
    this.forEachObserver((e) => {
      e.complete();
    }), this.close();
  }
  /**
   * Subscribe function that can be used to add an Observer to the fan-out list.
   *
   * - We require that no event is sent to a subscriber sychronously to their
   *   call to subscribe().
   */
  subscribe(e, n, s) {
    let r;
    if (e === void 0 && n === void 0 && s === void 0)
      throw new Error("Missing Observer.");
    YI(e, [
      "next",
      "error",
      "complete"
    ]) ? r = e : r = {
      next: e,
      error: n,
      complete: s
    }, r.next === void 0 && (r.next = sl), r.error === void 0 && (r.error = sl), r.complete === void 0 && (r.complete = sl);
    const i = this.unsubscribeOne.bind(this, this.observers.length);
    return this.finalized && this.task.then(() => {
      try {
        this.finalError ? r.error(this.finalError) : r.complete();
      } catch {
      }
    }), this.observers.push(r), i;
  }
  // Unsubscribe is synchronous - we guarantee that no events are sent to
  // any unsubscribed Observer.
  unsubscribeOne(e) {
    this.observers === void 0 || this.observers[e] === void 0 || (delete this.observers[e], this.observerCount -= 1, this.observerCount === 0 && this.onNoObservers !== void 0 && this.onNoObservers(this));
  }
  forEachObserver(e) {
    if (!this.finalized)
      for (let n = 0; n < this.observers.length; n++)
        this.sendOne(n, e);
  }
  // Call the Observer via one of it's callback function. We are careful to
  // confirm that the observe has not been unsubscribed since this asynchronous
  // function had been queued.
  sendOne(e, n) {
    this.task.then(() => {
      if (this.observers !== void 0 && this.observers[e] !== void 0)
        try {
          n(this.observers[e]);
        } catch (s) {
          typeof console < "u" && console.error && console.error(s);
        }
    });
  }
  close(e) {
    this.finalized || (this.finalized = !0, e !== void 0 && (this.finalError = e), this.task.then(() => {
      this.observers = void 0, this.onNoObservers = void 0;
    }));
  }
}
function YI(t, e) {
  if (typeof t != "object" || t === null)
    return !1;
  for (const n of e)
    if (n in t && typeof t[n] == "function")
      return !0;
  return !1;
}
function sl() {
}
function hc(t, e) {
  return `${t} failed: ${e} argument `;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const KI = function(t) {
  const e = [];
  let n = 0;
  for (let s = 0; s < t.length; s++) {
    let r = t.charCodeAt(s);
    if (r >= 55296 && r <= 56319) {
      const i = r - 55296;
      s++, S(s < t.length, "Surrogate pair missing trail surrogate.");
      const o = t.charCodeAt(s) - 56320;
      r = 65536 + (i << 10) + o;
    }
    r < 128 ? e[n++] = r : r < 2048 ? (e[n++] = r >> 6 | 192, e[n++] = r & 63 | 128) : r < 65536 ? (e[n++] = r >> 12 | 224, e[n++] = r >> 6 & 63 | 128, e[n++] = r & 63 | 128) : (e[n++] = r >> 18 | 240, e[n++] = r >> 12 & 63 | 128, e[n++] = r >> 6 & 63 | 128, e[n++] = r & 63 | 128);
  }
  return e;
}, pc = function(t) {
  let e = 0;
  for (let n = 0; n < t.length; n++) {
    const s = t.charCodeAt(n);
    s < 128 ? e++ : s < 2048 ? e += 2 : s >= 55296 && s <= 56319 ? (e += 4, n++) : e += 3;
  }
  return e;
};
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function Ke(t) {
  return t && t._delegate ? t._delegate : t;
}
class ys {
  /**
   *
   * @param name The public service name, e.g. app, auth, firestore, database
   * @param instanceFactory Service factory responsible for creating the public interface
   * @param type whether the service provided by the component is public or private
   */
  constructor(e, n, s) {
    this.name = e, this.instanceFactory = n, this.type = s, this.multipleInstances = !1, this.serviceProps = {}, this.instantiationMode = "LAZY", this.onInstanceCreated = null;
  }
  setInstantiationMode(e) {
    return this.instantiationMode = e, this;
  }
  setMultipleInstances(e) {
    return this.multipleInstances = e, this;
  }
  setServiceProps(e) {
    return this.serviceProps = e, this;
  }
  setInstanceCreatedCallback(e) {
    return this.onInstanceCreated = e, this;
  }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const ns = "[DEFAULT]";
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class XI {
  constructor(e, n) {
    this.name = e, this.container = n, this.component = null, this.instances = /* @__PURE__ */ new Map(), this.instancesDeferred = /* @__PURE__ */ new Map(), this.instancesOptions = /* @__PURE__ */ new Map(), this.onInitCallbacks = /* @__PURE__ */ new Map();
  }
  /**
   * @param identifier A provider can provide mulitple instances of a service
   * if this.component.multipleInstances is true.
   */
  get(e) {
    const n = this.normalizeInstanceIdentifier(e);
    if (!this.instancesDeferred.has(n)) {
      const s = new Zi();
      if (this.instancesDeferred.set(n, s), this.isInitialized(n) || this.shouldAutoInitialize())
        try {
          const r = this.getOrInitializeService({
            instanceIdentifier: n
          });
          r && s.resolve(r);
        } catch {
        }
    }
    return this.instancesDeferred.get(n).promise;
  }
  getImmediate(e) {
    var n;
    const s = this.normalizeInstanceIdentifier(e == null ? void 0 : e.identifier), r = (n = e == null ? void 0 : e.optional) !== null && n !== void 0 ? n : !1;
    if (this.isInitialized(s) || this.shouldAutoInitialize())
      try {
        return this.getOrInitializeService({
          instanceIdentifier: s
        });
      } catch (i) {
        if (r)
          return null;
        throw i;
      }
    else {
      if (r)
        return null;
      throw Error(`Service ${this.name} is not available`);
    }
  }
  getComponent() {
    return this.component;
  }
  setComponent(e) {
    if (e.name !== this.name)
      throw Error(`Mismatching Component ${e.name} for Provider ${this.name}.`);
    if (this.component)
      throw Error(`Component for ${this.name} has already been provided`);
    if (this.component = e, !!this.shouldAutoInitialize()) {
      if (QI(e))
        try {
          this.getOrInitializeService({ instanceIdentifier: ns });
        } catch {
        }
      for (const [n, s] of this.instancesDeferred.entries()) {
        const r = this.normalizeInstanceIdentifier(n);
        try {
          const i = this.getOrInitializeService({
            instanceIdentifier: r
          });
          s.resolve(i);
        } catch {
        }
      }
    }
  }
  clearInstance(e = ns) {
    this.instancesDeferred.delete(e), this.instancesOptions.delete(e), this.instances.delete(e);
  }
  // app.delete() will call this method on every provider to delete the services
  // TODO: should we mark the provider as deleted?
  async delete() {
    const e = Array.from(this.instances.values());
    await Promise.all([
      ...e.filter((n) => "INTERNAL" in n).map((n) => n.INTERNAL.delete()),
      ...e.filter((n) => "_delete" in n).map((n) => n._delete())
    ]);
  }
  isComponentSet() {
    return this.component != null;
  }
  isInitialized(e = ns) {
    return this.instances.has(e);
  }
  getOptions(e = ns) {
    return this.instancesOptions.get(e) || {};
  }
  initialize(e = {}) {
    const { options: n = {} } = e, s = this.normalizeInstanceIdentifier(e.instanceIdentifier);
    if (this.isInitialized(s))
      throw Error(`${this.name}(${s}) has already been initialized`);
    if (!this.isComponentSet())
      throw Error(`Component ${this.name} has not been registered yet`);
    const r = this.getOrInitializeService({
      instanceIdentifier: s,
      options: n
    });
    for (const [i, o] of this.instancesDeferred.entries()) {
      const a = this.normalizeInstanceIdentifier(i);
      s === a && o.resolve(r);
    }
    return r;
  }
  /**
   *
   * @param callback - a function that will be invoked  after the provider has been initialized by calling provider.initialize().
   * The function is invoked SYNCHRONOUSLY, so it should not execute any longrunning tasks in order to not block the program.
   *
   * @param identifier An optional instance identifier
   * @returns a function to unregister the callback
   */
  onInit(e, n) {
    var s;
    const r = this.normalizeInstanceIdentifier(n), i = (s = this.onInitCallbacks.get(r)) !== null && s !== void 0 ? s : /* @__PURE__ */ new Set();
    i.add(e), this.onInitCallbacks.set(r, i);
    const o = this.instances.get(r);
    return o && e(o, r), () => {
      i.delete(e);
    };
  }
  /**
   * Invoke onInit callbacks synchronously
   * @param instance the service instance`
   */
  invokeOnInitCallbacks(e, n) {
    const s = this.onInitCallbacks.get(n);
    if (s)
      for (const r of s)
        try {
          r(e, n);
        } catch {
        }
  }
  getOrInitializeService({ instanceIdentifier: e, options: n = {} }) {
    let s = this.instances.get(e);
    if (!s && this.component && (s = this.component.instanceFactory(this.container, {
      instanceIdentifier: JI(e),
      options: n
    }), this.instances.set(e, s), this.instancesOptions.set(e, n), this.invokeOnInitCallbacks(s, e), this.component.onInstanceCreated))
      try {
        this.component.onInstanceCreated(this.container, e, s);
      } catch {
      }
    return s || null;
  }
  normalizeInstanceIdentifier(e = ns) {
    return this.component ? this.component.multipleInstances ? e : ns : e;
  }
  shouldAutoInitialize() {
    return !!this.component && this.component.instantiationMode !== "EXPLICIT";
  }
}
function JI(t) {
  return t === ns ? void 0 : t;
}
function QI(t) {
  return t.instantiationMode === "EAGER";
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class ZI {
  constructor(e) {
    this.name = e, this.providers = /* @__PURE__ */ new Map();
  }
  /**
   *
   * @param component Component being added
   * @param overwrite When a component with the same name has already been registered,
   * if overwrite is true: overwrite the existing component with the new component and create a new
   * provider with the new component. It can be useful in tests where you want to use different mocks
   * for different tests.
   * if overwrite is false: throw an exception
   */
  addComponent(e) {
    const n = this.getProvider(e.name);
    if (n.isComponentSet())
      throw new Error(`Component ${e.name} has already been registered with ${this.name}`);
    n.setComponent(e);
  }
  addOrOverwriteComponent(e) {
    this.getProvider(e.name).isComponentSet() && this.providers.delete(e.name), this.addComponent(e);
  }
  /**
   * getProvider provides a type safe interface where it can only be called with a field name
   * present in NameServiceMapping interface.
   *
   * Firebase SDKs providing services should extend NameServiceMapping interface to register
   * themselves.
   */
  getProvider(e) {
    if (this.providers.has(e))
      return this.providers.get(e);
    const n = new XI(e, this);
    return this.providers.set(e, n), n;
  }
  getProviders() {
    return Array.from(this.providers.values());
  }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var ie;
(function(t) {
  t[t.DEBUG = 0] = "DEBUG", t[t.VERBOSE = 1] = "VERBOSE", t[t.INFO = 2] = "INFO", t[t.WARN = 3] = "WARN", t[t.ERROR = 4] = "ERROR", t[t.SILENT = 5] = "SILENT";
})(ie || (ie = {}));
const eC = {
  debug: ie.DEBUG,
  verbose: ie.VERBOSE,
  info: ie.INFO,
  warn: ie.WARN,
  error: ie.ERROR,
  silent: ie.SILENT
}, tC = ie.INFO, nC = {
  [ie.DEBUG]: "log",
  [ie.VERBOSE]: "log",
  [ie.INFO]: "info",
  [ie.WARN]: "warn",
  [ie.ERROR]: "error"
}, sC = (t, e, ...n) => {
  if (e < t.logLevel)
    return;
  const s = (/* @__PURE__ */ new Date()).toISOString(), r = nC[e];
  if (r)
    console[r](`[${s}]  ${t.name}:`, ...n);
  else
    throw new Error(`Attempted to log a message with an invalid logType (value: ${e})`);
};
class cu {
  /**
   * Gives you an instance of a Logger to capture messages according to
   * Firebase's logging scheme.
   *
   * @param name The name that the logs will be associated with
   */
  constructor(e) {
    this.name = e, this._logLevel = tC, this._logHandler = sC, this._userLogHandler = null;
  }
  get logLevel() {
    return this._logLevel;
  }
  set logLevel(e) {
    if (!(e in ie))
      throw new TypeError(`Invalid value "${e}" assigned to \`logLevel\``);
    this._logLevel = e;
  }
  // Workaround for setter/getter having to be the same type.
  setLogLevel(e) {
    this._logLevel = typeof e == "string" ? eC[e] : e;
  }
  get logHandler() {
    return this._logHandler;
  }
  set logHandler(e) {
    if (typeof e != "function")
      throw new TypeError("Value assigned to `logHandler` must be a function");
    this._logHandler = e;
  }
  get userLogHandler() {
    return this._userLogHandler;
  }
  set userLogHandler(e) {
    this._userLogHandler = e;
  }
  /**
   * The functions below are all based on the `console` interface
   */
  debug(...e) {
    this._userLogHandler && this._userLogHandler(this, ie.DEBUG, ...e), this._logHandler(this, ie.DEBUG, ...e);
  }
  log(...e) {
    this._userLogHandler && this._userLogHandler(this, ie.VERBOSE, ...e), this._logHandler(this, ie.VERBOSE, ...e);
  }
  info(...e) {
    this._userLogHandler && this._userLogHandler(this, ie.INFO, ...e), this._logHandler(this, ie.INFO, ...e);
  }
  warn(...e) {
    this._userLogHandler && this._userLogHandler(this, ie.WARN, ...e), this._logHandler(this, ie.WARN, ...e);
  }
  error(...e) {
    this._userLogHandler && this._userLogHandler(this, ie.ERROR, ...e), this._logHandler(this, ie.ERROR, ...e);
  }
}
const rC = (t, e) => e.some((n) => t instanceof n);
let vp, Sp;
function iC() {
  return vp || (vp = [
    IDBDatabase,
    IDBObjectStore,
    IDBIndex,
    IDBCursor,
    IDBTransaction
  ]);
}
function oC() {
  return Sp || (Sp = [
    IDBCursor.prototype.advance,
    IDBCursor.prototype.continue,
    IDBCursor.prototype.continuePrimaryKey
  ]);
}
const og = /* @__PURE__ */ new WeakMap(), $l = /* @__PURE__ */ new WeakMap(), ag = /* @__PURE__ */ new WeakMap(), rl = /* @__PURE__ */ new WeakMap(), lu = /* @__PURE__ */ new WeakMap();
function aC(t) {
  const e = new Promise((n, s) => {
    const r = () => {
      t.removeEventListener("success", i), t.removeEventListener("error", o);
    }, i = () => {
      n(Ln(t.result)), r();
    }, o = () => {
      s(t.error), r();
    };
    t.addEventListener("success", i), t.addEventListener("error", o);
  });
  return e.then((n) => {
    n instanceof IDBCursor && og.set(n, t);
  }).catch(() => {
  }), lu.set(e, t), e;
}
function cC(t) {
  if ($l.has(t))
    return;
  const e = new Promise((n, s) => {
    const r = () => {
      t.removeEventListener("complete", i), t.removeEventListener("error", o), t.removeEventListener("abort", o);
    }, i = () => {
      n(), r();
    }, o = () => {
      s(t.error || new DOMException("AbortError", "AbortError")), r();
    };
    t.addEventListener("complete", i), t.addEventListener("error", o), t.addEventListener("abort", o);
  });
  $l.set(t, e);
}
let Vl = {
  get(t, e, n) {
    if (t instanceof IDBTransaction) {
      if (e === "done")
        return $l.get(t);
      if (e === "objectStoreNames")
        return t.objectStoreNames || ag.get(t);
      if (e === "store")
        return n.objectStoreNames[1] ? void 0 : n.objectStore(n.objectStoreNames[0]);
    }
    return Ln(t[e]);
  },
  set(t, e, n) {
    return t[e] = n, !0;
  },
  has(t, e) {
    return t instanceof IDBTransaction && (e === "done" || e === "store") ? !0 : e in t;
  }
};
function lC(t) {
  Vl = t(Vl);
}
function dC(t) {
  return t === IDBDatabase.prototype.transaction && !("objectStoreNames" in IDBTransaction.prototype) ? function(e, ...n) {
    const s = t.call(il(this), e, ...n);
    return ag.set(s, e.sort ? e.sort() : [e]), Ln(s);
  } : oC().includes(t) ? function(...e) {
    return t.apply(il(this), e), Ln(og.get(this));
  } : function(...e) {
    return Ln(t.apply(il(this), e));
  };
}
function uC(t) {
  return typeof t == "function" ? dC(t) : (t instanceof IDBTransaction && cC(t), rC(t, iC()) ? new Proxy(t, Vl) : t);
}
function Ln(t) {
  if (t instanceof IDBRequest)
    return aC(t);
  if (rl.has(t))
    return rl.get(t);
  const e = uC(t);
  return e !== t && (rl.set(t, e), lu.set(e, t)), e;
}
const il = (t) => lu.get(t);
function hC(t, e, { blocked: n, upgrade: s, blocking: r, terminated: i } = {}) {
  const o = indexedDB.open(t, e), a = Ln(o);
  return s && o.addEventListener("upgradeneeded", (c) => {
    s(Ln(o.result), c.oldVersion, c.newVersion, Ln(o.transaction), c);
  }), n && o.addEventListener("blocked", (c) => n(
    // Casting due to https://github.com/microsoft/TypeScript-DOM-lib-generator/pull/1405
    c.oldVersion,
    c.newVersion,
    c
  )), a.then((c) => {
    i && c.addEventListener("close", () => i()), r && c.addEventListener("versionchange", (l) => r(l.oldVersion, l.newVersion, l));
  }).catch(() => {
  }), a;
}
const pC = ["get", "getKey", "getAll", "getAllKeys", "count"], fC = ["put", "add", "delete", "clear"], ol = /* @__PURE__ */ new Map();
function wp(t, e) {
  if (!(t instanceof IDBDatabase && !(e in t) && typeof e == "string"))
    return;
  if (ol.get(e))
    return ol.get(e);
  const n = e.replace(/FromIndex$/, ""), s = e !== n, r = fC.includes(n);
  if (
    // Bail if the target doesn't exist on the target. Eg, getAll isn't in Edge.
    !(n in (s ? IDBIndex : IDBObjectStore).prototype) || !(r || pC.includes(n))
  )
    return;
  const i = async function(o, ...a) {
    const c = this.transaction(o, r ? "readwrite" : "readonly");
    let l = c.store;
    return s && (l = l.index(a.shift())), (await Promise.all([
      l[n](...a),
      r && c.done
    ]))[0];
  };
  return ol.set(e, i), i;
}
lC((t) => ({
  ...t,
  get: (e, n, s) => wp(e, n) || t.get(e, n, s),
  has: (e, n) => !!wp(e, n) || t.has(e, n)
}));
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class mC {
  constructor(e) {
    this.container = e;
  }
  // In initial implementation, this will be called by installations on
  // auth token refresh, and installations will send this string.
  getPlatformInfoString() {
    return this.container.getProviders().map((n) => {
      if (gC(n)) {
        const s = n.getImmediate();
        return `${s.library}/${s.version}`;
      } else
        return null;
    }).filter((n) => n).join(" ");
  }
}
function gC(t) {
  const e = t.getComponent();
  return (e == null ? void 0 : e.type) === "VERSION";
}
const Ul = "@firebase/app", Tp = "0.9.25";
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const Es = new cu("@firebase/app"), _C = "@firebase/app-compat", yC = "@firebase/analytics-compat", EC = "@firebase/analytics", bC = "@firebase/app-check-compat", vC = "@firebase/app-check", SC = "@firebase/auth", wC = "@firebase/auth-compat", TC = "@firebase/database", IC = "@firebase/database-compat", CC = "@firebase/functions", FC = "@firebase/functions-compat", kC = "@firebase/installations", AC = "@firebase/installations-compat", NC = "@firebase/messaging", LC = "@firebase/messaging-compat", RC = "@firebase/performance", xC = "@firebase/performance-compat", OC = "@firebase/remote-config", PC = "@firebase/remote-config-compat", MC = "@firebase/storage", DC = "@firebase/storage-compat", GC = "@firebase/firestore", BC = "@firebase/firestore-compat", $C = "firebase", VC = "10.7.1";
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const Hl = "[DEFAULT]", UC = {
  [Ul]: "fire-core",
  [_C]: "fire-core-compat",
  [EC]: "fire-analytics",
  [yC]: "fire-analytics-compat",
  [vC]: "fire-app-check",
  [bC]: "fire-app-check-compat",
  [SC]: "fire-auth",
  [wC]: "fire-auth-compat",
  [TC]: "fire-rtdb",
  [IC]: "fire-rtdb-compat",
  [CC]: "fire-fn",
  [FC]: "fire-fn-compat",
  [kC]: "fire-iid",
  [AC]: "fire-iid-compat",
  [NC]: "fire-fcm",
  [LC]: "fire-fcm-compat",
  [RC]: "fire-perf",
  [xC]: "fire-perf-compat",
  [OC]: "fire-rc",
  [PC]: "fire-rc-compat",
  [MC]: "fire-gcs",
  [DC]: "fire-gcs-compat",
  [GC]: "fire-fst",
  [BC]: "fire-fst-compat",
  "fire-js": "fire-js",
  [$C]: "fire-js-all"
};
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const Ea = /* @__PURE__ */ new Map(), jl = /* @__PURE__ */ new Map();
function HC(t, e) {
  try {
    t.container.addComponent(e);
  } catch (n) {
    Es.debug(`Component ${e.name} failed to register with FirebaseApp ${t.name}`, n);
  }
}
function vr(t) {
  const e = t.name;
  if (jl.has(e))
    return Es.debug(`There were multiple attempts to register component ${e}.`), !1;
  jl.set(e, t);
  for (const n of Ea.values())
    HC(n, t);
  return !0;
}
function du(t, e) {
  const n = t.container.getProvider("heartbeat").getImmediate({ optional: !0 });
  return n && n.triggerHeartbeat(), t.container.getProvider(e);
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const jC = {
  "no-app": "No Firebase App '{$appName}' has been created - call initializeApp() first",
  "bad-app-name": "Illegal App name: '{$appName}",
  "duplicate-app": "Firebase App named '{$appName}' already exists with different options or config",
  "app-deleted": "Firebase App named '{$appName}' already deleted",
  "no-options": "Need to provide options, when not being deployed to hosting via source.",
  "invalid-app-argument": "firebase.{$appName}() takes either no argument or a Firebase App instance.",
  "invalid-log-argument": "First argument to `onLog` must be null or a function.",
  "idb-open": "Error thrown when opening IndexedDB. Original error: {$originalErrorMessage}.",
  "idb-get": "Error thrown when reading from IndexedDB. Original error: {$originalErrorMessage}.",
  "idb-set": "Error thrown when writing to IndexedDB. Original error: {$originalErrorMessage}.",
  "idb-delete": "Error thrown when deleting from IndexedDB. Original error: {$originalErrorMessage}."
}, Rn = new eo("app", "Firebase", jC);
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class WC {
  constructor(e, n, s) {
    this._isDeleted = !1, this._options = Object.assign({}, e), this._config = Object.assign({}, n), this._name = n.name, this._automaticDataCollectionEnabled = n.automaticDataCollectionEnabled, this._container = s, this.container.addComponent(new ys(
      "app",
      () => this,
      "PUBLIC"
      /* ComponentType.PUBLIC */
    ));
  }
  get automaticDataCollectionEnabled() {
    return this.checkDestroyed(), this._automaticDataCollectionEnabled;
  }
  set automaticDataCollectionEnabled(e) {
    this.checkDestroyed(), this._automaticDataCollectionEnabled = e;
  }
  get name() {
    return this.checkDestroyed(), this._name;
  }
  get options() {
    return this.checkDestroyed(), this._options;
  }
  get config() {
    return this.checkDestroyed(), this._config;
  }
  get container() {
    return this._container;
  }
  get isDeleted() {
    return this._isDeleted;
  }
  set isDeleted(e) {
    this._isDeleted = e;
  }
  /**
   * This function will throw an Error if the App has already been deleted -
   * use before performing API actions on the App.
   */
  checkDestroyed() {
    if (this.isDeleted)
      throw Rn.create("app-deleted", { appName: this._name });
  }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const Hr = VC;
function uu(t, e = {}) {
  let n = t;
  typeof e != "object" && (e = { name: e });
  const s = Object.assign({ name: Hl, automaticDataCollectionEnabled: !1 }, e), r = s.name;
  if (typeof r != "string" || !r)
    throw Rn.create("bad-app-name", {
      appName: String(r)
    });
  if (n || (n = tg()), !n)
    throw Rn.create(
      "no-options"
      /* AppError.NO_OPTIONS */
    );
  const i = Ea.get(r);
  if (i) {
    if (ya(n, i.options) && ya(s, i.config))
      return i;
    throw Rn.create("duplicate-app", { appName: r });
  }
  const o = new ZI(r);
  for (const c of jl.values())
    o.addComponent(c);
  const a = new WC(n, s, o);
  return Ea.set(r, a), a;
}
function cg(t = Hl) {
  const e = Ea.get(t);
  if (!e && t === Hl && tg())
    return uu();
  if (!e)
    throw Rn.create("no-app", { appName: t });
  return e;
}
function xn(t, e, n) {
  var s;
  let r = (s = UC[t]) !== null && s !== void 0 ? s : t;
  n && (r += `-${n}`);
  const i = r.match(/\s|\//), o = e.match(/\s|\//);
  if (i || o) {
    const a = [
      `Unable to register library "${r}" with version "${e}":`
    ];
    i && a.push(`library name "${r}" contains illegal characters (whitespace or "/")`), i && o && a.push("and"), o && a.push(`version name "${e}" contains illegal characters (whitespace or "/")`), Es.warn(a.join(" "));
    return;
  }
  vr(new ys(
    `${r}-version`,
    () => ({ library: r, version: e }),
    "VERSION"
    /* ComponentType.VERSION */
  ));
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const zC = "firebase-heartbeat-database", qC = 1, ki = "firebase-heartbeat-store";
let al = null;
function lg() {
  return al || (al = hC(zC, qC, {
    upgrade: (t, e) => {
      switch (e) {
        case 0:
          t.createObjectStore(ki);
      }
    }
  }).catch((t) => {
    throw Rn.create("idb-open", {
      originalErrorMessage: t.message
    });
  })), al;
}
async function YC(t) {
  try {
    return await (await lg()).transaction(ki).objectStore(ki).get(dg(t));
  } catch (e) {
    if (e instanceof Kn)
      Es.warn(e.message);
    else {
      const n = Rn.create("idb-get", {
        originalErrorMessage: e == null ? void 0 : e.message
      });
      Es.warn(n.message);
    }
  }
}
async function Ip(t, e) {
  try {
    const s = (await lg()).transaction(ki, "readwrite");
    await s.objectStore(ki).put(e, dg(t)), await s.done;
  } catch (n) {
    if (n instanceof Kn)
      Es.warn(n.message);
    else {
      const s = Rn.create("idb-set", {
        originalErrorMessage: n == null ? void 0 : n.message
      });
      Es.warn(s.message);
    }
  }
}
function dg(t) {
  return `${t.name}!${t.options.appId}`;
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const KC = 1024, XC = 30 * 24 * 60 * 60 * 1e3;
class JC {
  constructor(e) {
    this.container = e, this._heartbeatsCache = null;
    const n = this.container.getProvider("app").getImmediate();
    this._storage = new ZC(n), this._heartbeatsCachePromise = this._storage.read().then((s) => (this._heartbeatsCache = s, s));
  }
  /**
   * Called to report a heartbeat. The function will generate
   * a HeartbeatsByUserAgent object, update heartbeatsCache, and persist it
   * to IndexedDB.
   * Note that we only store one heartbeat per day. So if a heartbeat for today is
   * already logged, subsequent calls to this function in the same day will be ignored.
   */
  async triggerHeartbeat() {
    var e, n;
    const r = this.container.getProvider("platform-logger").getImmediate().getPlatformInfoString(), i = Cp();
    if (!(((e = this._heartbeatsCache) === null || e === void 0 ? void 0 : e.heartbeats) == null && (this._heartbeatsCache = await this._heartbeatsCachePromise, ((n = this._heartbeatsCache) === null || n === void 0 ? void 0 : n.heartbeats) == null)) && !(this._heartbeatsCache.lastSentHeartbeatDate === i || this._heartbeatsCache.heartbeats.some((o) => o.date === i)))
      return this._heartbeatsCache.heartbeats.push({ date: i, agent: r }), this._heartbeatsCache.heartbeats = this._heartbeatsCache.heartbeats.filter((o) => {
        const a = new Date(o.date).valueOf();
        return Date.now() - a <= XC;
      }), this._storage.overwrite(this._heartbeatsCache);
  }
  /**
   * Returns a base64 encoded string which can be attached to the heartbeat-specific header directly.
   * It also clears all heartbeats from memory as well as in IndexedDB.
   *
   * NOTE: Consuming product SDKs should not send the header if this method
   * returns an empty string.
   */
  async getHeartbeatsHeader() {
    var e;
    if (this._heartbeatsCache === null && await this._heartbeatsCachePromise, ((e = this._heartbeatsCache) === null || e === void 0 ? void 0 : e.heartbeats) == null || this._heartbeatsCache.heartbeats.length === 0)
      return "";
    const n = Cp(), { heartbeatsToSend: s, unsentEntries: r } = QC(this._heartbeatsCache.heartbeats), i = ma(JSON.stringify({ version: 2, heartbeats: s }));
    return this._heartbeatsCache.lastSentHeartbeatDate = n, r.length > 0 ? (this._heartbeatsCache.heartbeats = r, await this._storage.overwrite(this._heartbeatsCache)) : (this._heartbeatsCache.heartbeats = [], this._storage.overwrite(this._heartbeatsCache)), i;
  }
}
function Cp() {
  return (/* @__PURE__ */ new Date()).toISOString().substring(0, 10);
}
function QC(t, e = KC) {
  const n = [];
  let s = t.slice();
  for (const r of t) {
    const i = n.find((o) => o.agent === r.agent);
    if (i) {
      if (i.dates.push(r.date), Fp(n) > e) {
        i.dates.pop();
        break;
      }
    } else if (n.push({
      agent: r.agent,
      dates: [r.date]
    }), Fp(n) > e) {
      n.pop();
      break;
    }
    s = s.slice(1);
  }
  return {
    heartbeatsToSend: n,
    unsentEntries: s
  };
}
class ZC {
  constructor(e) {
    this.app = e, this._canUseIndexedDBPromise = this.runIndexedDBEnvironmentCheck();
  }
  async runIndexedDBEnvironmentCheck() {
    return GI() ? BI().then(() => !0).catch(() => !1) : !1;
  }
  /**
   * Read all heartbeats.
   */
  async read() {
    if (await this._canUseIndexedDBPromise) {
      const n = await YC(this.app);
      return n != null && n.heartbeats ? n : { heartbeats: [] };
    } else
      return { heartbeats: [] };
  }
  // overwrite the storage with the provided heartbeats
  async overwrite(e) {
    var n;
    if (await this._canUseIndexedDBPromise) {
      const r = await this.read();
      return Ip(this.app, {
        lastSentHeartbeatDate: (n = e.lastSentHeartbeatDate) !== null && n !== void 0 ? n : r.lastSentHeartbeatDate,
        heartbeats: e.heartbeats
      });
    } else
      return;
  }
  // add heartbeats
  async add(e) {
    var n;
    if (await this._canUseIndexedDBPromise) {
      const r = await this.read();
      return Ip(this.app, {
        lastSentHeartbeatDate: (n = e.lastSentHeartbeatDate) !== null && n !== void 0 ? n : r.lastSentHeartbeatDate,
        heartbeats: [
          ...r.heartbeats,
          ...e.heartbeats
        ]
      });
    } else
      return;
  }
}
function Fp(t) {
  return ma(
    // heartbeatsCache wrapper properties
    JSON.stringify({ version: 2, heartbeats: t })
  ).length;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function eF(t) {
  vr(new ys(
    "platform-logger",
    (e) => new mC(e),
    "PRIVATE"
    /* ComponentType.PRIVATE */
  )), vr(new ys(
    "heartbeat",
    (e) => new JC(e),
    "PRIVATE"
    /* ComponentType.PRIVATE */
  )), xn(Ul, Tp, t), xn(Ul, Tp, "esm2017"), xn("fire-js", "");
}
eF("");
function hu(t, e) {
  var n = {};
  for (var s in t) Object.prototype.hasOwnProperty.call(t, s) && e.indexOf(s) < 0 && (n[s] = t[s]);
  if (t != null && typeof Object.getOwnPropertySymbols == "function")
    for (var r = 0, s = Object.getOwnPropertySymbols(t); r < s.length; r++)
      e.indexOf(s[r]) < 0 && Object.prototype.propertyIsEnumerable.call(t, s[r]) && (n[s[r]] = t[s[r]]);
  return n;
}
function ug() {
  return {
    "dependent-sdk-initialized-before-auth": "Another Firebase SDK was initialized and is trying to use Auth before Auth is initialized. Please be sure to call `initializeAuth` or `getAuth` before starting any other Firebase SDK."
  };
}
const tF = ug, hg = new eo("auth", "Firebase", ug());
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const ba = new cu("@firebase/auth");
function nF(t, ...e) {
  ba.logLevel <= ie.WARN && ba.warn(`Auth (${Hr}): ${t}`, ...e);
}
function Qo(t, ...e) {
  ba.logLevel <= ie.ERROR && ba.error(`Auth (${Hr}): ${t}`, ...e);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function Ct(t, ...e) {
  throw pu(t, ...e);
}
function Dt(t, ...e) {
  return pu(t, ...e);
}
function sF(t, e, n) {
  const s = Object.assign(Object.assign({}, tF()), { [e]: n });
  return new eo("auth", "Firebase", s).create(e, {
    appName: t.name
  });
}
function pu(t, ...e) {
  if (typeof t != "string") {
    const n = e[0], s = [...e.slice(1)];
    return s[0] && (s[0].appName = t.name), t._errorFactory.create(n, ...s);
  }
  return hg.create(t, ...e);
}
function G(t, e, ...n) {
  if (!t)
    throw pu(e, ...n);
}
function Kt(t) {
  const e = "INTERNAL ASSERTION FAILED: " + t;
  throw Qo(e), new Error(e);
}
function an(t, e) {
  t || Kt(e);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function Wl() {
  var t;
  return typeof self < "u" && ((t = self.location) === null || t === void 0 ? void 0 : t.href) || "";
}
function rF() {
  return kp() === "http:" || kp() === "https:";
}
function kp() {
  var t;
  return typeof self < "u" && ((t = self.location) === null || t === void 0 ? void 0 : t.protocol) || null;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function iF() {
  return typeof navigator < "u" && navigator && "onLine" in navigator && typeof navigator.onLine == "boolean" && // Apply only for traditional web apps and Chrome extensions.
  // This is especially true for Cordova apps which have unreliable
  // navigator.onLine behavior unless cordova-plugin-network-information is
  // installed which overwrites the native navigator.onLine value and
  // defines navigator.connection.
  (rF() || MI() || "connection" in navigator) ? navigator.onLine : !0;
}
function oF() {
  if (typeof navigator > "u")
    return null;
  const t = navigator;
  return (
    // Most reliable, but only supported in Chrome/Firefox.
    t.languages && t.languages[0] || // Supported in most browsers, but returns the language of the browser
    // UI, not the language set in browser settings.
    t.language || // Couldn't determine language.
    null
  );
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class to {
  constructor(e, n) {
    this.shortDelay = e, this.longDelay = n, an(n > e, "Short delay should be less than long delay!"), this.isMobile = au() || sg();
  }
  get() {
    return iF() ? this.isMobile ? this.longDelay : this.shortDelay : Math.min(5e3, this.shortDelay);
  }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function fu(t, e) {
  an(t.emulator, "Emulator should always be set here");
  const { url: n } = t.emulator;
  return e ? `${n}${e.startsWith("/") ? e.slice(1) : e}` : n;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class pg {
  static initialize(e, n, s) {
    this.fetchImpl = e, n && (this.headersImpl = n), s && (this.responseImpl = s);
  }
  static fetch() {
    if (this.fetchImpl)
      return this.fetchImpl;
    if (typeof self < "u" && "fetch" in self)
      return self.fetch;
    if (typeof globalThis < "u" && globalThis.fetch)
      return globalThis.fetch;
    if (typeof fetch < "u")
      return fetch;
    Kt("Could not find fetch implementation, make sure you call FetchProvider.initialize() with an appropriate polyfill");
  }
  static headers() {
    if (this.headersImpl)
      return this.headersImpl;
    if (typeof self < "u" && "Headers" in self)
      return self.Headers;
    if (typeof globalThis < "u" && globalThis.Headers)
      return globalThis.Headers;
    if (typeof Headers < "u")
      return Headers;
    Kt("Could not find Headers implementation, make sure you call FetchProvider.initialize() with an appropriate polyfill");
  }
  static response() {
    if (this.responseImpl)
      return this.responseImpl;
    if (typeof self < "u" && "Response" in self)
      return self.Response;
    if (typeof globalThis < "u" && globalThis.Response)
      return globalThis.Response;
    if (typeof Response < "u")
      return Response;
    Kt("Could not find Response implementation, make sure you call FetchProvider.initialize() with an appropriate polyfill");
  }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const aF = {
  // Custom token errors.
  CREDENTIAL_MISMATCH: "custom-token-mismatch",
  // This can only happen if the SDK sends a bad request.
  MISSING_CUSTOM_TOKEN: "internal-error",
  // Create Auth URI errors.
  INVALID_IDENTIFIER: "invalid-email",
  // This can only happen if the SDK sends a bad request.
  MISSING_CONTINUE_URI: "internal-error",
  // Sign in with email and password errors (some apply to sign up too).
  INVALID_PASSWORD: "wrong-password",
  // This can only happen if the SDK sends a bad request.
  MISSING_PASSWORD: "missing-password",
  // Thrown if Email Enumeration Protection is enabled in the project and the email or password is
  // invalid.
  INVALID_LOGIN_CREDENTIALS: "invalid-credential",
  // Sign up with email and password errors.
  EMAIL_EXISTS: "email-already-in-use",
  PASSWORD_LOGIN_DISABLED: "operation-not-allowed",
  // Verify assertion for sign in with credential errors:
  INVALID_IDP_RESPONSE: "invalid-credential",
  INVALID_PENDING_TOKEN: "invalid-credential",
  FEDERATED_USER_ID_ALREADY_LINKED: "credential-already-in-use",
  // This can only happen if the SDK sends a bad request.
  MISSING_REQ_TYPE: "internal-error",
  // Send Password reset email errors:
  EMAIL_NOT_FOUND: "user-not-found",
  RESET_PASSWORD_EXCEED_LIMIT: "too-many-requests",
  EXPIRED_OOB_CODE: "expired-action-code",
  INVALID_OOB_CODE: "invalid-action-code",
  // This can only happen if the SDK sends a bad request.
  MISSING_OOB_CODE: "internal-error",
  // Operations that require ID token in request:
  CREDENTIAL_TOO_OLD_LOGIN_AGAIN: "requires-recent-login",
  INVALID_ID_TOKEN: "invalid-user-token",
  TOKEN_EXPIRED: "user-token-expired",
  USER_NOT_FOUND: "user-token-expired",
  // Other errors.
  TOO_MANY_ATTEMPTS_TRY_LATER: "too-many-requests",
  PASSWORD_DOES_NOT_MEET_REQUIREMENTS: "password-does-not-meet-requirements",
  // Phone Auth related errors.
  INVALID_CODE: "invalid-verification-code",
  INVALID_SESSION_INFO: "invalid-verification-id",
  INVALID_TEMPORARY_PROOF: "invalid-credential",
  MISSING_SESSION_INFO: "missing-verification-id",
  SESSION_EXPIRED: "code-expired",
  // Other action code errors when additional settings passed.
  // MISSING_CONTINUE_URI is getting mapped to INTERNAL_ERROR above.
  // This is OK as this error will be caught by client side validation.
  MISSING_ANDROID_PACKAGE_NAME: "missing-android-pkg-name",
  UNAUTHORIZED_DOMAIN: "unauthorized-continue-uri",
  // getProjectConfig errors when clientId is passed.
  INVALID_OAUTH_CLIENT_ID: "invalid-oauth-client-id",
  // User actions (sign-up or deletion) disabled errors.
  ADMIN_ONLY_OPERATION: "admin-restricted-operation",
  // Multi factor related errors.
  INVALID_MFA_PENDING_CREDENTIAL: "invalid-multi-factor-session",
  MFA_ENROLLMENT_NOT_FOUND: "multi-factor-info-not-found",
  MISSING_MFA_ENROLLMENT_ID: "missing-multi-factor-info",
  MISSING_MFA_PENDING_CREDENTIAL: "missing-multi-factor-session",
  SECOND_FACTOR_EXISTS: "second-factor-already-in-use",
  SECOND_FACTOR_LIMIT_EXCEEDED: "maximum-second-factor-count-exceeded",
  // Blocking functions related errors.
  BLOCKING_FUNCTION_ERROR_RESPONSE: "internal-error",
  // Recaptcha related errors.
  RECAPTCHA_NOT_ENABLED: "recaptcha-not-enabled",
  MISSING_RECAPTCHA_TOKEN: "missing-recaptcha-token",
  INVALID_RECAPTCHA_TOKEN: "invalid-recaptcha-token",
  INVALID_RECAPTCHA_ACTION: "invalid-recaptcha-action",
  MISSING_CLIENT_TYPE: "missing-client-type",
  MISSING_RECAPTCHA_VERSION: "missing-recaptcha-version",
  INVALID_RECAPTCHA_VERSION: "invalid-recaptcha-version",
  INVALID_REQ_TYPE: "invalid-req-type"
  /* AuthErrorCode.INVALID_REQ_TYPE */
};
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const cF = new to(3e4, 6e4);
function mn(t, e) {
  return t.tenantId && !e.tenantId ? Object.assign(Object.assign({}, e), { tenantId: t.tenantId }) : e;
}
async function gn(t, e, n, s, r = {}) {
  return fg(t, r, async () => {
    let i = {}, o = {};
    s && (e === "GET" ? o = s : i = {
      body: JSON.stringify(s)
    });
    const a = Ur(Object.assign({ key: t.config.apiKey }, o)).slice(1), c = await t._getAdditionalHeaders();
    return c[
      "Content-Type"
      /* HttpHeader.CONTENT_TYPE */
    ] = "application/json", t.languageCode && (c[
      "X-Firebase-Locale"
      /* HttpHeader.X_FIREBASE_LOCALE */
    ] = t.languageCode), pg.fetch()(mg(t, t.config.apiHost, n, a), Object.assign({
      method: e,
      headers: c,
      referrerPolicy: "no-referrer"
    }, i));
  });
}
async function fg(t, e, n) {
  t._canInitEmulator = !1;
  const s = Object.assign(Object.assign({}, aF), e);
  try {
    const r = new dF(t), i = await Promise.race([
      n(),
      r.promise
    ]);
    r.clearNetworkTimeout();
    const o = await i.json();
    if ("needConfirmation" in o)
      throw Ro(t, "account-exists-with-different-credential", o);
    if (i.ok && !("errorMessage" in o))
      return o;
    {
      const a = i.ok ? o.errorMessage : o.error.message, [c, l] = a.split(" : ");
      if (c === "FEDERATED_USER_ID_ALREADY_LINKED")
        throw Ro(t, "credential-already-in-use", o);
      if (c === "EMAIL_EXISTS")
        throw Ro(t, "email-already-in-use", o);
      if (c === "USER_DISABLED")
        throw Ro(t, "user-disabled", o);
      const d = s[c] || c.toLowerCase().replace(/[_\s]+/g, "-");
      if (l)
        throw sF(t, d, l);
      Ct(t, d);
    }
  } catch (r) {
    if (r instanceof Kn)
      throw r;
    Ct(t, "network-request-failed", { message: String(r) });
  }
}
async function no(t, e, n, s, r = {}) {
  const i = await gn(t, e, n, s, r);
  return "mfaPendingCredential" in i && Ct(t, "multi-factor-auth-required", {
    _serverResponse: i
  }), i;
}
function mg(t, e, n, s) {
  const r = `${e}${n}?${s}`;
  return t.config.emulator ? fu(t.config, r) : `${t.config.apiScheme}://${r}`;
}
function lF(t) {
  switch (t) {
    case "ENFORCE":
      return "ENFORCE";
    case "AUDIT":
      return "AUDIT";
    case "OFF":
      return "OFF";
    default:
      return "ENFORCEMENT_STATE_UNSPECIFIED";
  }
}
class dF {
  constructor(e) {
    this.auth = e, this.timer = null, this.promise = new Promise((n, s) => {
      this.timer = setTimeout(() => s(Dt(
        this.auth,
        "network-request-failed"
        /* AuthErrorCode.NETWORK_REQUEST_FAILED */
      )), cF.get());
    });
  }
  clearNetworkTimeout() {
    clearTimeout(this.timer);
  }
}
function Ro(t, e, n) {
  const s = {
    appName: t.name
  };
  n.email && (s.email = n.email), n.phoneNumber && (s.phoneNumber = n.phoneNumber);
  const r = Dt(t, e, s);
  return r.customData._tokenResponse = n, r;
}
function Ap(t) {
  return t !== void 0 && t.enterprise !== void 0;
}
class uF {
  constructor(e) {
    if (this.siteKey = "", this.recaptchaEnforcementState = [], e.recaptchaKey === void 0)
      throw new Error("recaptchaKey undefined");
    this.siteKey = e.recaptchaKey.split("/")[3], this.recaptchaEnforcementState = e.recaptchaEnforcementState;
  }
  /**
   * Returns the reCAPTCHA Enterprise enforcement state for the given provider.
   *
   * @param providerStr - The provider whose enforcement state is to be returned.
   * @returns The reCAPTCHA Enterprise enforcement state for the given provider.
   */
  getProviderEnforcementState(e) {
    if (!this.recaptchaEnforcementState || this.recaptchaEnforcementState.length === 0)
      return null;
    for (const n of this.recaptchaEnforcementState)
      if (n.provider && n.provider === e)
        return lF(n.enforcementState);
    return null;
  }
  /**
   * Returns true if the reCAPTCHA Enterprise enforcement state for the provider is set to ENFORCE or AUDIT.
   *
   * @param providerStr - The provider whose enablement state is to be returned.
   * @returns Whether or not reCAPTCHA Enterprise protection is enabled for the given provider.
   */
  isProviderEnabled(e) {
    return this.getProviderEnforcementState(e) === "ENFORCE" || this.getProviderEnforcementState(e) === "AUDIT";
  }
}
async function hF(t, e) {
  return gn(t, "GET", "/v2/recaptchaConfig", mn(t, e));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
async function pF(t, e) {
  return gn(t, "POST", "/v1/accounts:delete", e);
}
async function fF(t, e) {
  return gn(t, "POST", "/v1/accounts:lookup", e);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function mi(t) {
  if (t)
    try {
      const e = new Date(Number(t));
      if (!isNaN(e.getTime()))
        return e.toUTCString();
    } catch {
    }
}
async function mF(t, e = !1) {
  const n = Ke(t), s = await n.getIdToken(e), r = mu(s);
  G(
    r && r.exp && r.auth_time && r.iat,
    n.auth,
    "internal-error"
    /* AuthErrorCode.INTERNAL_ERROR */
  );
  const i = typeof r.firebase == "object" ? r.firebase : void 0, o = i == null ? void 0 : i.sign_in_provider;
  return {
    claims: r,
    token: s,
    authTime: mi(cl(r.auth_time)),
    issuedAtTime: mi(cl(r.iat)),
    expirationTime: mi(cl(r.exp)),
    signInProvider: o || null,
    signInSecondFactor: (i == null ? void 0 : i.sign_in_second_factor) || null
  };
}
function cl(t) {
  return Number(t) * 1e3;
}
function mu(t) {
  const [e, n, s] = t.split(".");
  if (e === void 0 || n === void 0 || s === void 0)
    return Qo("JWT malformed, contained fewer than 3 sections"), null;
  try {
    const r = ga(n);
    return r ? JSON.parse(r) : (Qo("Failed to decode base64 JWT payload"), null);
  } catch (r) {
    return Qo("Caught error parsing JWT payload as JSON", r == null ? void 0 : r.toString()), null;
  }
}
function gF(t) {
  const e = mu(t);
  return G(
    e,
    "internal-error"
    /* AuthErrorCode.INTERNAL_ERROR */
  ), G(
    typeof e.exp < "u",
    "internal-error"
    /* AuthErrorCode.INTERNAL_ERROR */
  ), G(
    typeof e.iat < "u",
    "internal-error"
    /* AuthErrorCode.INTERNAL_ERROR */
  ), Number(e.exp) - Number(e.iat);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
async function Ai(t, e, n = !1) {
  if (n)
    return e;
  try {
    return await e;
  } catch (s) {
    throw s instanceof Kn && _F(s) && t.auth.currentUser === t && await t.auth.signOut(), s;
  }
}
function _F({ code: t }) {
  return t === "auth/user-disabled" || t === "auth/user-token-expired";
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class yF {
  constructor(e) {
    this.user = e, this.isRunning = !1, this.timerId = null, this.errorBackoff = 3e4;
  }
  _start() {
    this.isRunning || (this.isRunning = !0, this.schedule());
  }
  _stop() {
    this.isRunning && (this.isRunning = !1, this.timerId !== null && clearTimeout(this.timerId));
  }
  getInterval(e) {
    var n;
    if (e) {
      const s = this.errorBackoff;
      return this.errorBackoff = Math.min(
        this.errorBackoff * 2,
        96e4
        /* Duration.RETRY_BACKOFF_MAX */
      ), s;
    } else {
      this.errorBackoff = 3e4;
      const r = ((n = this.user.stsTokenManager.expirationTime) !== null && n !== void 0 ? n : 0) - Date.now() - 3e5;
      return Math.max(0, r);
    }
  }
  schedule(e = !1) {
    if (!this.isRunning)
      return;
    const n = this.getInterval(e);
    this.timerId = setTimeout(async () => {
      await this.iteration();
    }, n);
  }
  async iteration() {
    try {
      await this.user.getIdToken(!0);
    } catch (e) {
      (e == null ? void 0 : e.code) === "auth/network-request-failed" && this.schedule(
        /* wasError */
        !0
      );
      return;
    }
    this.schedule();
  }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class gg {
  constructor(e, n) {
    this.createdAt = e, this.lastLoginAt = n, this._initializeTime();
  }
  _initializeTime() {
    this.lastSignInTime = mi(this.lastLoginAt), this.creationTime = mi(this.createdAt);
  }
  _copy(e) {
    this.createdAt = e.createdAt, this.lastLoginAt = e.lastLoginAt, this._initializeTime();
  }
  toJSON() {
    return {
      createdAt: this.createdAt,
      lastLoginAt: this.lastLoginAt
    };
  }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
async function va(t) {
  var e;
  const n = t.auth, s = await t.getIdToken(), r = await Ai(t, fF(n, { idToken: s }));
  G(
    r == null ? void 0 : r.users.length,
    n,
    "internal-error"
    /* AuthErrorCode.INTERNAL_ERROR */
  );
  const i = r.users[0];
  t._notifyReloadListener(i);
  const o = !((e = i.providerUserInfo) === null || e === void 0) && e.length ? vF(i.providerUserInfo) : [], a = bF(t.providerData, o), c = t.isAnonymous, l = !(t.email && i.passwordHash) && !(a != null && a.length), d = c ? l : !1, u = {
    uid: i.localId,
    displayName: i.displayName || null,
    photoURL: i.photoUrl || null,
    email: i.email || null,
    emailVerified: i.emailVerified || !1,
    phoneNumber: i.phoneNumber || null,
    tenantId: i.tenantId || null,
    providerData: a,
    metadata: new gg(i.createdAt, i.lastLoginAt),
    isAnonymous: d
  };
  Object.assign(t, u);
}
async function EF(t) {
  const e = Ke(t);
  await va(e), await e.auth._persistUserIfCurrent(e), e.auth._notifyListenersIfCurrent(e);
}
function bF(t, e) {
  return [...t.filter((s) => !e.some((r) => r.providerId === s.providerId)), ...e];
}
function vF(t) {
  return t.map((e) => {
    var { providerId: n } = e, s = hu(e, ["providerId"]);
    return {
      providerId: n,
      uid: s.rawId || "",
      displayName: s.displayName || null,
      email: s.email || null,
      phoneNumber: s.phoneNumber || null,
      photoURL: s.photoUrl || null
    };
  });
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
async function SF(t, e) {
  const n = await fg(t, {}, async () => {
    const s = Ur({
      grant_type: "refresh_token",
      refresh_token: e
    }).slice(1), { tokenApiHost: r, apiKey: i } = t.config, o = mg(t, r, "/v1/token", `key=${i}`), a = await t._getAdditionalHeaders();
    return a[
      "Content-Type"
      /* HttpHeader.CONTENT_TYPE */
    ] = "application/x-www-form-urlencoded", pg.fetch()(o, {
      method: "POST",
      headers: a,
      body: s
    });
  });
  return {
    accessToken: n.access_token,
    expiresIn: n.expires_in,
    refreshToken: n.refresh_token
  };
}
async function wF(t, e) {
  return gn(t, "POST", "/v2/accounts:revokeToken", mn(t, e));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class Ni {
  constructor() {
    this.refreshToken = null, this.accessToken = null, this.expirationTime = null;
  }
  get isExpired() {
    return !this.expirationTime || Date.now() > this.expirationTime - 3e4;
  }
  updateFromServerResponse(e) {
    G(
      e.idToken,
      "internal-error"
      /* AuthErrorCode.INTERNAL_ERROR */
    ), G(
      typeof e.idToken < "u",
      "internal-error"
      /* AuthErrorCode.INTERNAL_ERROR */
    ), G(
      typeof e.refreshToken < "u",
      "internal-error"
      /* AuthErrorCode.INTERNAL_ERROR */
    );
    const n = "expiresIn" in e && typeof e.expiresIn < "u" ? Number(e.expiresIn) : gF(e.idToken);
    this.updateTokensAndExpiration(e.idToken, e.refreshToken, n);
  }
  async getToken(e, n = !1) {
    return G(
      !this.accessToken || this.refreshToken,
      e,
      "user-token-expired"
      /* AuthErrorCode.TOKEN_EXPIRED */
    ), !n && this.accessToken && !this.isExpired ? this.accessToken : this.refreshToken ? (await this.refresh(e, this.refreshToken), this.accessToken) : null;
  }
  clearRefreshToken() {
    this.refreshToken = null;
  }
  async refresh(e, n) {
    const { accessToken: s, refreshToken: r, expiresIn: i } = await SF(e, n);
    this.updateTokensAndExpiration(s, r, Number(i));
  }
  updateTokensAndExpiration(e, n, s) {
    this.refreshToken = n || null, this.accessToken = e || null, this.expirationTime = Date.now() + s * 1e3;
  }
  static fromJSON(e, n) {
    const { refreshToken: s, accessToken: r, expirationTime: i } = n, o = new Ni();
    return s && (G(typeof s == "string", "internal-error", {
      appName: e
    }), o.refreshToken = s), r && (G(typeof r == "string", "internal-error", {
      appName: e
    }), o.accessToken = r), i && (G(typeof i == "number", "internal-error", {
      appName: e
    }), o.expirationTime = i), o;
  }
  toJSON() {
    return {
      refreshToken: this.refreshToken,
      accessToken: this.accessToken,
      expirationTime: this.expirationTime
    };
  }
  _assign(e) {
    this.accessToken = e.accessToken, this.refreshToken = e.refreshToken, this.expirationTime = e.expirationTime;
  }
  _clone() {
    return Object.assign(new Ni(), this.toJSON());
  }
  _performRefresh() {
    return Kt("not implemented");
  }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function bn(t, e) {
  G(typeof t == "string" || typeof t > "u", "internal-error", { appName: e });
}
class us {
  constructor(e) {
    var { uid: n, auth: s, stsTokenManager: r } = e, i = hu(e, ["uid", "auth", "stsTokenManager"]);
    this.providerId = "firebase", this.proactiveRefresh = new yF(this), this.reloadUserInfo = null, this.reloadListener = null, this.uid = n, this.auth = s, this.stsTokenManager = r, this.accessToken = r.accessToken, this.displayName = i.displayName || null, this.email = i.email || null, this.emailVerified = i.emailVerified || !1, this.phoneNumber = i.phoneNumber || null, this.photoURL = i.photoURL || null, this.isAnonymous = i.isAnonymous || !1, this.tenantId = i.tenantId || null, this.providerData = i.providerData ? [...i.providerData] : [], this.metadata = new gg(i.createdAt || void 0, i.lastLoginAt || void 0);
  }
  async getIdToken(e) {
    const n = await Ai(this, this.stsTokenManager.getToken(this.auth, e));
    return G(
      n,
      this.auth,
      "internal-error"
      /* AuthErrorCode.INTERNAL_ERROR */
    ), this.accessToken !== n && (this.accessToken = n, await this.auth._persistUserIfCurrent(this), this.auth._notifyListenersIfCurrent(this)), n;
  }
  getIdTokenResult(e) {
    return mF(this, e);
  }
  reload() {
    return EF(this);
  }
  _assign(e) {
    this !== e && (G(
      this.uid === e.uid,
      this.auth,
      "internal-error"
      /* AuthErrorCode.INTERNAL_ERROR */
    ), this.displayName = e.displayName, this.photoURL = e.photoURL, this.email = e.email, this.emailVerified = e.emailVerified, this.phoneNumber = e.phoneNumber, this.isAnonymous = e.isAnonymous, this.tenantId = e.tenantId, this.providerData = e.providerData.map((n) => Object.assign({}, n)), this.metadata._copy(e.metadata), this.stsTokenManager._assign(e.stsTokenManager));
  }
  _clone(e) {
    const n = new us(Object.assign(Object.assign({}, this), { auth: e, stsTokenManager: this.stsTokenManager._clone() }));
    return n.metadata._copy(this.metadata), n;
  }
  _onReload(e) {
    G(
      !this.reloadListener,
      this.auth,
      "internal-error"
      /* AuthErrorCode.INTERNAL_ERROR */
    ), this.reloadListener = e, this.reloadUserInfo && (this._notifyReloadListener(this.reloadUserInfo), this.reloadUserInfo = null);
  }
  _notifyReloadListener(e) {
    this.reloadListener ? this.reloadListener(e) : this.reloadUserInfo = e;
  }
  _startProactiveRefresh() {
    this.proactiveRefresh._start();
  }
  _stopProactiveRefresh() {
    this.proactiveRefresh._stop();
  }
  async _updateTokensIfNecessary(e, n = !1) {
    let s = !1;
    e.idToken && e.idToken !== this.stsTokenManager.accessToken && (this.stsTokenManager.updateFromServerResponse(e), s = !0), n && await va(this), await this.auth._persistUserIfCurrent(this), s && this.auth._notifyListenersIfCurrent(this);
  }
  async delete() {
    const e = await this.getIdToken();
    return await Ai(this, pF(this.auth, { idToken: e })), this.stsTokenManager.clearRefreshToken(), this.auth.signOut();
  }
  toJSON() {
    return Object.assign(Object.assign({
      uid: this.uid,
      email: this.email || void 0,
      emailVerified: this.emailVerified,
      displayName: this.displayName || void 0,
      isAnonymous: this.isAnonymous,
      photoURL: this.photoURL || void 0,
      phoneNumber: this.phoneNumber || void 0,
      tenantId: this.tenantId || void 0,
      providerData: this.providerData.map((e) => Object.assign({}, e)),
      stsTokenManager: this.stsTokenManager.toJSON(),
      // Redirect event ID must be maintained in case there is a pending
      // redirect event.
      _redirectEventId: this._redirectEventId
    }, this.metadata.toJSON()), {
      // Required for compatibility with the legacy SDK (go/firebase-auth-sdk-persistence-parsing):
      apiKey: this.auth.config.apiKey,
      appName: this.auth.name
    });
  }
  get refreshToken() {
    return this.stsTokenManager.refreshToken || "";
  }
  static _fromJSON(e, n) {
    var s, r, i, o, a, c, l, d;
    const u = (s = n.displayName) !== null && s !== void 0 ? s : void 0, h = (r = n.email) !== null && r !== void 0 ? r : void 0, p = (i = n.phoneNumber) !== null && i !== void 0 ? i : void 0, f = (o = n.photoURL) !== null && o !== void 0 ? o : void 0, m = (a = n.tenantId) !== null && a !== void 0 ? a : void 0, g = (c = n._redirectEventId) !== null && c !== void 0 ? c : void 0, y = (l = n.createdAt) !== null && l !== void 0 ? l : void 0, I = (d = n.lastLoginAt) !== null && d !== void 0 ? d : void 0, { uid: A, emailVerified: T, isAnonymous: F, providerData: _, stsTokenManager: E } = n;
    G(
      A && E,
      e,
      "internal-error"
      /* AuthErrorCode.INTERNAL_ERROR */
    );
    const C = Ni.fromJSON(this.name, E);
    G(
      typeof A == "string",
      e,
      "internal-error"
      /* AuthErrorCode.INTERNAL_ERROR */
    ), bn(u, e.name), bn(h, e.name), G(
      typeof T == "boolean",
      e,
      "internal-error"
      /* AuthErrorCode.INTERNAL_ERROR */
    ), G(
      typeof F == "boolean",
      e,
      "internal-error"
      /* AuthErrorCode.INTERNAL_ERROR */
    ), bn(p, e.name), bn(f, e.name), bn(m, e.name), bn(g, e.name), bn(y, e.name), bn(I, e.name);
    const N = new us({
      uid: A,
      auth: e,
      email: h,
      emailVerified: T,
      displayName: u,
      isAnonymous: F,
      photoURL: f,
      phoneNumber: p,
      tenantId: m,
      stsTokenManager: C,
      createdAt: y,
      lastLoginAt: I
    });
    return _ && Array.isArray(_) && (N.providerData = _.map((v) => Object.assign({}, v))), g && (N._redirectEventId = g), N;
  }
  /**
   * Initialize a User from an idToken server response
   * @param auth
   * @param idTokenResponse
   */
  static async _fromIdTokenResponse(e, n, s = !1) {
    const r = new Ni();
    r.updateFromServerResponse(n);
    const i = new us({
      uid: n.localId,
      auth: e,
      stsTokenManager: r,
      isAnonymous: s
    });
    return await va(i), i;
  }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const Np = /* @__PURE__ */ new Map();
function Xt(t) {
  an(t instanceof Function, "Expected a class definition");
  let e = Np.get(t);
  return e ? (an(e instanceof t, "Instance stored in cache mismatched with class"), e) : (e = new t(), Np.set(t, e), e);
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class _g {
  constructor() {
    this.type = "NONE", this.storage = {};
  }
  async _isAvailable() {
    return !0;
  }
  async _set(e, n) {
    this.storage[e] = n;
  }
  async _get(e) {
    const n = this.storage[e];
    return n === void 0 ? null : n;
  }
  async _remove(e) {
    delete this.storage[e];
  }
  _addListener(e, n) {
  }
  _removeListener(e, n) {
  }
}
_g.type = "NONE";
const Lp = _g;
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function Zo(t, e, n) {
  return `firebase:${t}:${e}:${n}`;
}
class lr {
  constructor(e, n, s) {
    this.persistence = e, this.auth = n, this.userKey = s;
    const { config: r, name: i } = this.auth;
    this.fullUserKey = Zo(this.userKey, r.apiKey, i), this.fullPersistenceKey = Zo("persistence", r.apiKey, i), this.boundEventHandler = n._onStorageEvent.bind(n), this.persistence._addListener(this.fullUserKey, this.boundEventHandler);
  }
  setCurrentUser(e) {
    return this.persistence._set(this.fullUserKey, e.toJSON());
  }
  async getCurrentUser() {
    const e = await this.persistence._get(this.fullUserKey);
    return e ? us._fromJSON(this.auth, e) : null;
  }
  removeCurrentUser() {
    return this.persistence._remove(this.fullUserKey);
  }
  savePersistenceForRedirect() {
    return this.persistence._set(this.fullPersistenceKey, this.persistence.type);
  }
  async setPersistence(e) {
    if (this.persistence === e)
      return;
    const n = await this.getCurrentUser();
    if (await this.removeCurrentUser(), this.persistence = e, n)
      return this.setCurrentUser(n);
  }
  delete() {
    this.persistence._removeListener(this.fullUserKey, this.boundEventHandler);
  }
  static async create(e, n, s = "authUser") {
    if (!n.length)
      return new lr(Xt(Lp), e, s);
    const r = (await Promise.all(n.map(async (l) => {
      if (await l._isAvailable())
        return l;
    }))).filter((l) => l);
    let i = r[0] || Xt(Lp);
    const o = Zo(s, e.config.apiKey, e.name);
    let a = null;
    for (const l of n)
      try {
        const d = await l._get(o);
        if (d) {
          const u = us._fromJSON(e, d);
          l !== i && (a = u), i = l;
          break;
        }
      } catch {
      }
    const c = r.filter((l) => l._shouldAllowMigration);
    return !i._shouldAllowMigration || !c.length ? new lr(i, e, s) : (i = c[0], a && await i._set(o, a.toJSON()), await Promise.all(n.map(async (l) => {
      if (l !== i)
        try {
          await l._remove(o);
        } catch {
        }
    })), new lr(i, e, s));
  }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function Rp(t) {
  const e = t.toLowerCase();
  if (e.includes("opera/") || e.includes("opr/") || e.includes("opios/"))
    return "Opera";
  if (bg(e))
    return "IEMobile";
  if (e.includes("msie") || e.includes("trident/"))
    return "IE";
  if (e.includes("edge/"))
    return "Edge";
  if (yg(e))
    return "Firefox";
  if (e.includes("silk/"))
    return "Silk";
  if (Sg(e))
    return "Blackberry";
  if (wg(e))
    return "Webos";
  if (gu(e))
    return "Safari";
  if ((e.includes("chrome/") || Eg(e)) && !e.includes("edge/"))
    return "Chrome";
  if (vg(e))
    return "Android";
  {
    const n = /([a-zA-Z\d\.]+)\/[a-zA-Z\d\.]*$/, s = t.match(n);
    if ((s == null ? void 0 : s.length) === 2)
      return s[1];
  }
  return "Other";
}
function yg(t = $e()) {
  return /firefox\//i.test(t);
}
function gu(t = $e()) {
  const e = t.toLowerCase();
  return e.includes("safari/") && !e.includes("chrome/") && !e.includes("crios/") && !e.includes("android");
}
function Eg(t = $e()) {
  return /crios\//i.test(t);
}
function bg(t = $e()) {
  return /iemobile/i.test(t);
}
function vg(t = $e()) {
  return /android/i.test(t);
}
function Sg(t = $e()) {
  return /blackberry/i.test(t);
}
function wg(t = $e()) {
  return /webos/i.test(t);
}
function fc(t = $e()) {
  return /iphone|ipad|ipod/i.test(t) || /macintosh/i.test(t) && /mobile/i.test(t);
}
function TF(t = $e()) {
  var e;
  return fc(t) && !!(!((e = window.navigator) === null || e === void 0) && e.standalone);
}
function IF() {
  return DI() && document.documentMode === 10;
}
function Tg(t = $e()) {
  return fc(t) || vg(t) || wg(t) || Sg(t) || /windows phone/i.test(t) || bg(t);
}
function CF() {
  try {
    return !!(window && window !== window.top);
  } catch {
    return !1;
  }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function Ig(t, e = []) {
  let n;
  switch (t) {
    case "Browser":
      n = Rp($e());
      break;
    case "Worker":
      n = `${Rp($e())}-${t}`;
      break;
    default:
      n = t;
  }
  const s = e.length ? e.join(",") : "FirebaseCore-web";
  return `${n}/JsCore/${Hr}/${s}`;
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class FF {
  constructor(e) {
    this.auth = e, this.queue = [];
  }
  pushCallback(e, n) {
    const s = (i) => new Promise((o, a) => {
      try {
        const c = e(i);
        o(c);
      } catch (c) {
        a(c);
      }
    });
    s.onAbort = n, this.queue.push(s);
    const r = this.queue.length - 1;
    return () => {
      this.queue[r] = () => Promise.resolve();
    };
  }
  async runMiddleware(e) {
    if (this.auth.currentUser === e)
      return;
    const n = [];
    try {
      for (const s of this.queue)
        await s(e), s.onAbort && n.push(s.onAbort);
    } catch (s) {
      n.reverse();
      for (const r of n)
        try {
          r();
        } catch {
        }
      throw this.auth._errorFactory.create("login-blocked", {
        originalMessage: s == null ? void 0 : s.message
      });
    }
  }
}
/**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
async function kF(t, e = {}) {
  return gn(t, "GET", "/v2/passwordPolicy", mn(t, e));
}
/**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const AF = 6;
class NF {
  constructor(e) {
    var n, s, r, i;
    const o = e.customStrengthOptions;
    this.customStrengthOptions = {}, this.customStrengthOptions.minPasswordLength = (n = o.minPasswordLength) !== null && n !== void 0 ? n : AF, o.maxPasswordLength && (this.customStrengthOptions.maxPasswordLength = o.maxPasswordLength), o.containsLowercaseCharacter !== void 0 && (this.customStrengthOptions.containsLowercaseLetter = o.containsLowercaseCharacter), o.containsUppercaseCharacter !== void 0 && (this.customStrengthOptions.containsUppercaseLetter = o.containsUppercaseCharacter), o.containsNumericCharacter !== void 0 && (this.customStrengthOptions.containsNumericCharacter = o.containsNumericCharacter), o.containsNonAlphanumericCharacter !== void 0 && (this.customStrengthOptions.containsNonAlphanumericCharacter = o.containsNonAlphanumericCharacter), this.enforcementState = e.enforcementState, this.enforcementState === "ENFORCEMENT_STATE_UNSPECIFIED" && (this.enforcementState = "OFF"), this.allowedNonAlphanumericCharacters = (r = (s = e.allowedNonAlphanumericCharacters) === null || s === void 0 ? void 0 : s.join("")) !== null && r !== void 0 ? r : "", this.forceUpgradeOnSignin = (i = e.forceUpgradeOnSignin) !== null && i !== void 0 ? i : !1, this.schemaVersion = e.schemaVersion;
  }
  validatePassword(e) {
    var n, s, r, i, o, a;
    const c = {
      isValid: !0,
      passwordPolicy: this
    };
    return this.validatePasswordLengthOptions(e, c), this.validatePasswordCharacterOptions(e, c), c.isValid && (c.isValid = (n = c.meetsMinPasswordLength) !== null && n !== void 0 ? n : !0), c.isValid && (c.isValid = (s = c.meetsMaxPasswordLength) !== null && s !== void 0 ? s : !0), c.isValid && (c.isValid = (r = c.containsLowercaseLetter) !== null && r !== void 0 ? r : !0), c.isValid && (c.isValid = (i = c.containsUppercaseLetter) !== null && i !== void 0 ? i : !0), c.isValid && (c.isValid = (o = c.containsNumericCharacter) !== null && o !== void 0 ? o : !0), c.isValid && (c.isValid = (a = c.containsNonAlphanumericCharacter) !== null && a !== void 0 ? a : !0), c;
  }
  /**
   * Validates that the password meets the length options for the policy.
   *
   * @param password Password to validate.
   * @param status Validation status.
   */
  validatePasswordLengthOptions(e, n) {
    const s = this.customStrengthOptions.minPasswordLength, r = this.customStrengthOptions.maxPasswordLength;
    s && (n.meetsMinPasswordLength = e.length >= s), r && (n.meetsMaxPasswordLength = e.length <= r);
  }
  /**
   * Validates that the password meets the character options for the policy.
   *
   * @param password Password to validate.
   * @param status Validation status.
   */
  validatePasswordCharacterOptions(e, n) {
    this.updatePasswordCharacterOptionsStatuses(
      n,
      /* containsLowercaseCharacter= */
      !1,
      /* containsUppercaseCharacter= */
      !1,
      /* containsNumericCharacter= */
      !1,
      /* containsNonAlphanumericCharacter= */
      !1
    );
    let s;
    for (let r = 0; r < e.length; r++)
      s = e.charAt(r), this.updatePasswordCharacterOptionsStatuses(
        n,
        /* containsLowercaseCharacter= */
        s >= "a" && s <= "z",
        /* containsUppercaseCharacter= */
        s >= "A" && s <= "Z",
        /* containsNumericCharacter= */
        s >= "0" && s <= "9",
        /* containsNonAlphanumericCharacter= */
        this.allowedNonAlphanumericCharacters.includes(s)
      );
  }
  /**
   * Updates the running validation status with the statuses for the character options.
   * Expected to be called each time a character is processed to update each option status
   * based on the current character.
   *
   * @param status Validation status.
   * @param containsLowercaseCharacter Whether the character is a lowercase letter.
   * @param containsUppercaseCharacter Whether the character is an uppercase letter.
   * @param containsNumericCharacter Whether the character is a numeric character.
   * @param containsNonAlphanumericCharacter Whether the character is a non-alphanumeric character.
   */
  updatePasswordCharacterOptionsStatuses(e, n, s, r, i) {
    this.customStrengthOptions.containsLowercaseLetter && (e.containsLowercaseLetter || (e.containsLowercaseLetter = n)), this.customStrengthOptions.containsUppercaseLetter && (e.containsUppercaseLetter || (e.containsUppercaseLetter = s)), this.customStrengthOptions.containsNumericCharacter && (e.containsNumericCharacter || (e.containsNumericCharacter = r)), this.customStrengthOptions.containsNonAlphanumericCharacter && (e.containsNonAlphanumericCharacter || (e.containsNonAlphanumericCharacter = i));
  }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class LF {
  constructor(e, n, s, r) {
    this.app = e, this.heartbeatServiceProvider = n, this.appCheckServiceProvider = s, this.config = r, this.currentUser = null, this.emulatorConfig = null, this.operations = Promise.resolve(), this.authStateSubscription = new xp(this), this.idTokenSubscription = new xp(this), this.beforeStateQueue = new FF(this), this.redirectUser = null, this.isProactiveRefreshEnabled = !1, this.EXPECTED_PASSWORD_POLICY_SCHEMA_VERSION = 1, this._canInitEmulator = !0, this._isInitialized = !1, this._deleted = !1, this._initializationPromise = null, this._popupRedirectResolver = null, this._errorFactory = hg, this._agentRecaptchaConfig = null, this._tenantRecaptchaConfigs = {}, this._projectPasswordPolicy = null, this._tenantPasswordPolicies = {}, this.lastNotifiedUid = void 0, this.languageCode = null, this.tenantId = null, this.settings = { appVerificationDisabledForTesting: !1 }, this.frameworks = [], this.name = e.name, this.clientVersion = r.sdkClientVersion;
  }
  _initializeWithPersistence(e, n) {
    return n && (this._popupRedirectResolver = Xt(n)), this._initializationPromise = this.queue(async () => {
      var s, r;
      if (!this._deleted && (this.persistenceManager = await lr.create(this, e), !this._deleted)) {
        if (!((s = this._popupRedirectResolver) === null || s === void 0) && s._shouldInitProactively)
          try {
            await this._popupRedirectResolver._initialize(this);
          } catch {
          }
        await this.initializeCurrentUser(n), this.lastNotifiedUid = ((r = this.currentUser) === null || r === void 0 ? void 0 : r.uid) || null, !this._deleted && (this._isInitialized = !0);
      }
    }), this._initializationPromise;
  }
  /**
   * If the persistence is changed in another window, the user manager will let us know
   */
  async _onStorageEvent() {
    if (this._deleted)
      return;
    const e = await this.assertedPersistence.getCurrentUser();
    if (!(!this.currentUser && !e)) {
      if (this.currentUser && e && this.currentUser.uid === e.uid) {
        this._currentUser._assign(e), await this.currentUser.getIdToken();
        return;
      }
      await this._updateCurrentUser(
        e,
        /* skipBeforeStateCallbacks */
        !0
      );
    }
  }
  async initializeCurrentUser(e) {
    var n;
    const s = await this.assertedPersistence.getCurrentUser();
    let r = s, i = !1;
    if (e && this.config.authDomain) {
      await this.getOrInitRedirectPersistenceManager();
      const o = (n = this.redirectUser) === null || n === void 0 ? void 0 : n._redirectEventId, a = r == null ? void 0 : r._redirectEventId, c = await this.tryRedirectSignIn(e);
      (!o || o === a) && (c != null && c.user) && (r = c.user, i = !0);
    }
    if (!r)
      return this.directlySetCurrentUser(null);
    if (!r._redirectEventId) {
      if (i)
        try {
          await this.beforeStateQueue.runMiddleware(r);
        } catch (o) {
          r = s, this._popupRedirectResolver._overrideRedirectResult(this, () => Promise.reject(o));
        }
      return r ? this.reloadAndSetCurrentUserOrClear(r) : this.directlySetCurrentUser(null);
    }
    return G(
      this._popupRedirectResolver,
      this,
      "argument-error"
      /* AuthErrorCode.ARGUMENT_ERROR */
    ), await this.getOrInitRedirectPersistenceManager(), this.redirectUser && this.redirectUser._redirectEventId === r._redirectEventId ? this.directlySetCurrentUser(r) : this.reloadAndSetCurrentUserOrClear(r);
  }
  async tryRedirectSignIn(e) {
    let n = null;
    try {
      n = await this._popupRedirectResolver._completeRedirectFn(this, e, !0);
    } catch {
      await this._setRedirectUser(null);
    }
    return n;
  }
  async reloadAndSetCurrentUserOrClear(e) {
    try {
      await va(e);
    } catch (n) {
      if ((n == null ? void 0 : n.code) !== "auth/network-request-failed")
        return this.directlySetCurrentUser(null);
    }
    return this.directlySetCurrentUser(e);
  }
  useDeviceLanguage() {
    this.languageCode = oF();
  }
  async _delete() {
    this._deleted = !0;
  }
  async updateCurrentUser(e) {
    const n = e ? Ke(e) : null;
    return n && G(
      n.auth.config.apiKey === this.config.apiKey,
      this,
      "invalid-user-token"
      /* AuthErrorCode.INVALID_AUTH */
    ), this._updateCurrentUser(n && n._clone(this));
  }
  async _updateCurrentUser(e, n = !1) {
    if (!this._deleted)
      return e && G(
        this.tenantId === e.tenantId,
        this,
        "tenant-id-mismatch"
        /* AuthErrorCode.TENANT_ID_MISMATCH */
      ), n || await this.beforeStateQueue.runMiddleware(e), this.queue(async () => {
        await this.directlySetCurrentUser(e), this.notifyAuthListeners();
      });
  }
  async signOut() {
    return await this.beforeStateQueue.runMiddleware(null), (this.redirectPersistenceManager || this._popupRedirectResolver) && await this._setRedirectUser(null), this._updateCurrentUser(
      null,
      /* skipBeforeStateCallbacks */
      !0
    );
  }
  setPersistence(e) {
    return this.queue(async () => {
      await this.assertedPersistence.setPersistence(Xt(e));
    });
  }
  _getRecaptchaConfig() {
    return this.tenantId == null ? this._agentRecaptchaConfig : this._tenantRecaptchaConfigs[this.tenantId];
  }
  async validatePassword(e) {
    this._getPasswordPolicyInternal() || await this._updatePasswordPolicy();
    const n = this._getPasswordPolicyInternal();
    return n.schemaVersion !== this.EXPECTED_PASSWORD_POLICY_SCHEMA_VERSION ? Promise.reject(this._errorFactory.create("unsupported-password-policy-schema-version", {})) : n.validatePassword(e);
  }
  _getPasswordPolicyInternal() {
    return this.tenantId === null ? this._projectPasswordPolicy : this._tenantPasswordPolicies[this.tenantId];
  }
  async _updatePasswordPolicy() {
    const e = await kF(this), n = new NF(e);
    this.tenantId === null ? this._projectPasswordPolicy = n : this._tenantPasswordPolicies[this.tenantId] = n;
  }
  _getPersistence() {
    return this.assertedPersistence.persistence.type;
  }
  _updateErrorMap(e) {
    this._errorFactory = new eo("auth", "Firebase", e());
  }
  onAuthStateChanged(e, n, s) {
    return this.registerStateListener(this.authStateSubscription, e, n, s);
  }
  beforeAuthStateChanged(e, n) {
    return this.beforeStateQueue.pushCallback(e, n);
  }
  onIdTokenChanged(e, n, s) {
    return this.registerStateListener(this.idTokenSubscription, e, n, s);
  }
  authStateReady() {
    return new Promise((e, n) => {
      if (this.currentUser)
        e();
      else {
        const s = this.onAuthStateChanged(() => {
          s(), e();
        }, n);
      }
    });
  }
  /**
   * Revokes the given access token. Currently only supports Apple OAuth access tokens.
   */
  async revokeAccessToken(e) {
    if (this.currentUser) {
      const n = await this.currentUser.getIdToken(), s = {
        providerId: "apple.com",
        tokenType: "ACCESS_TOKEN",
        token: e,
        idToken: n
      };
      this.tenantId != null && (s.tenantId = this.tenantId), await wF(this, s);
    }
  }
  toJSON() {
    var e;
    return {
      apiKey: this.config.apiKey,
      authDomain: this.config.authDomain,
      appName: this.name,
      currentUser: (e = this._currentUser) === null || e === void 0 ? void 0 : e.toJSON()
    };
  }
  async _setRedirectUser(e, n) {
    const s = await this.getOrInitRedirectPersistenceManager(n);
    return e === null ? s.removeCurrentUser() : s.setCurrentUser(e);
  }
  async getOrInitRedirectPersistenceManager(e) {
    if (!this.redirectPersistenceManager) {
      const n = e && Xt(e) || this._popupRedirectResolver;
      G(
        n,
        this,
        "argument-error"
        /* AuthErrorCode.ARGUMENT_ERROR */
      ), this.redirectPersistenceManager = await lr.create(
        this,
        [Xt(n._redirectPersistence)],
        "redirectUser"
        /* KeyName.REDIRECT_USER */
      ), this.redirectUser = await this.redirectPersistenceManager.getCurrentUser();
    }
    return this.redirectPersistenceManager;
  }
  async _redirectUserForId(e) {
    var n, s;
    return this._isInitialized && await this.queue(async () => {
    }), ((n = this._currentUser) === null || n === void 0 ? void 0 : n._redirectEventId) === e ? this._currentUser : ((s = this.redirectUser) === null || s === void 0 ? void 0 : s._redirectEventId) === e ? this.redirectUser : null;
  }
  async _persistUserIfCurrent(e) {
    if (e === this.currentUser)
      return this.queue(async () => this.directlySetCurrentUser(e));
  }
  /** Notifies listeners only if the user is current */
  _notifyListenersIfCurrent(e) {
    e === this.currentUser && this.notifyAuthListeners();
  }
  _key() {
    return `${this.config.authDomain}:${this.config.apiKey}:${this.name}`;
  }
  _startProactiveRefresh() {
    this.isProactiveRefreshEnabled = !0, this.currentUser && this._currentUser._startProactiveRefresh();
  }
  _stopProactiveRefresh() {
    this.isProactiveRefreshEnabled = !1, this.currentUser && this._currentUser._stopProactiveRefresh();
  }
  /** Returns the current user cast as the internal type */
  get _currentUser() {
    return this.currentUser;
  }
  notifyAuthListeners() {
    var e, n;
    if (!this._isInitialized)
      return;
    this.idTokenSubscription.next(this.currentUser);
    const s = (n = (e = this.currentUser) === null || e === void 0 ? void 0 : e.uid) !== null && n !== void 0 ? n : null;
    this.lastNotifiedUid !== s && (this.lastNotifiedUid = s, this.authStateSubscription.next(this.currentUser));
  }
  registerStateListener(e, n, s, r) {
    if (this._deleted)
      return () => {
      };
    const i = typeof n == "function" ? n : n.next.bind(n);
    let o = !1;
    const a = this._isInitialized ? Promise.resolve() : this._initializationPromise;
    if (G(
      a,
      this,
      "internal-error"
      /* AuthErrorCode.INTERNAL_ERROR */
    ), a.then(() => {
      o || i(this.currentUser);
    }), typeof n == "function") {
      const c = e.addObserver(n, s, r);
      return () => {
        o = !0, c();
      };
    } else {
      const c = e.addObserver(n);
      return () => {
        o = !0, c();
      };
    }
  }
  /**
   * Unprotected (from race conditions) method to set the current user. This
   * should only be called from within a queued callback. This is necessary
   * because the queue shouldn't rely on another queued callback.
   */
  async directlySetCurrentUser(e) {
    this.currentUser && this.currentUser !== e && this._currentUser._stopProactiveRefresh(), e && this.isProactiveRefreshEnabled && e._startProactiveRefresh(), this.currentUser = e, e ? await this.assertedPersistence.setCurrentUser(e) : await this.assertedPersistence.removeCurrentUser();
  }
  queue(e) {
    return this.operations = this.operations.then(e, e), this.operations;
  }
  get assertedPersistence() {
    return G(
      this.persistenceManager,
      this,
      "internal-error"
      /* AuthErrorCode.INTERNAL_ERROR */
    ), this.persistenceManager;
  }
  _logFramework(e) {
    !e || this.frameworks.includes(e) || (this.frameworks.push(e), this.frameworks.sort(), this.clientVersion = Ig(this.config.clientPlatform, this._getFrameworks()));
  }
  _getFrameworks() {
    return this.frameworks;
  }
  async _getAdditionalHeaders() {
    var e;
    const n = {
      "X-Client-Version": this.clientVersion
    };
    this.app.options.appId && (n[
      "X-Firebase-gmpid"
      /* HttpHeader.X_FIREBASE_GMPID */
    ] = this.app.options.appId);
    const s = await ((e = this.heartbeatServiceProvider.getImmediate({
      optional: !0
    })) === null || e === void 0 ? void 0 : e.getHeartbeatsHeader());
    s && (n[
      "X-Firebase-Client"
      /* HttpHeader.X_FIREBASE_CLIENT */
    ] = s);
    const r = await this._getAppCheckToken();
    return r && (n[
      "X-Firebase-AppCheck"
      /* HttpHeader.X_FIREBASE_APP_CHECK */
    ] = r), n;
  }
  async _getAppCheckToken() {
    var e;
    const n = await ((e = this.appCheckServiceProvider.getImmediate({ optional: !0 })) === null || e === void 0 ? void 0 : e.getToken());
    return n != null && n.error && nF(`Error while retrieving App Check token: ${n.error}`), n == null ? void 0 : n.token;
  }
}
function Xn(t) {
  return Ke(t);
}
class xp {
  constructor(e) {
    this.auth = e, this.observer = null, this.addObserver = zI((n) => this.observer = n);
  }
  get next() {
    return G(
      this.observer,
      this.auth,
      "internal-error"
      /* AuthErrorCode.INTERNAL_ERROR */
    ), this.observer.next.bind(this.observer);
  }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function RF() {
  var t, e;
  return (e = (t = document.getElementsByTagName("head")) === null || t === void 0 ? void 0 : t[0]) !== null && e !== void 0 ? e : document;
}
function Cg(t) {
  return new Promise((e, n) => {
    const s = document.createElement("script");
    s.setAttribute("src", t), s.onload = e, s.onerror = (r) => {
      const i = Dt(
        "internal-error"
        /* AuthErrorCode.INTERNAL_ERROR */
      );
      i.customData = r, n(i);
    }, s.type = "text/javascript", s.charset = "UTF-8", RF().appendChild(s);
  });
}
function xF(t) {
  return `__${t}${Math.floor(Math.random() * 1e6)}`;
}
const OF = "https://www.google.com/recaptcha/enterprise.js?render=", PF = "recaptcha-enterprise", MF = "NO_RECAPTCHA";
class DF {
  /**
   *
   * @param authExtern - The corresponding Firebase {@link Auth} instance.
   *
   */
  constructor(e) {
    this.type = PF, this.auth = Xn(e);
  }
  /**
   * Executes the verification process.
   *
   * @returns A Promise for a token that can be used to assert the validity of a request.
   */
  async verify(e = "verify", n = !1) {
    async function s(i) {
      if (!n) {
        if (i.tenantId == null && i._agentRecaptchaConfig != null)
          return i._agentRecaptchaConfig.siteKey;
        if (i.tenantId != null && i._tenantRecaptchaConfigs[i.tenantId] !== void 0)
          return i._tenantRecaptchaConfigs[i.tenantId].siteKey;
      }
      return new Promise(async (o, a) => {
        hF(i, {
          clientType: "CLIENT_TYPE_WEB",
          version: "RECAPTCHA_ENTERPRISE"
          /* RecaptchaVersion.ENTERPRISE */
        }).then((c) => {
          if (c.recaptchaKey === void 0)
            a(new Error("recaptcha Enterprise site key undefined"));
          else {
            const l = new uF(c);
            return i.tenantId == null ? i._agentRecaptchaConfig = l : i._tenantRecaptchaConfigs[i.tenantId] = l, o(l.siteKey);
          }
        }).catch((c) => {
          a(c);
        });
      });
    }
    function r(i, o, a) {
      const c = window.grecaptcha;
      Ap(c) ? c.enterprise.ready(() => {
        c.enterprise.execute(i, { action: e }).then((l) => {
          o(l);
        }).catch(() => {
          o(MF);
        });
      }) : a(Error("No reCAPTCHA enterprise script loaded."));
    }
    return new Promise((i, o) => {
      s(this.auth).then((a) => {
        if (!n && Ap(window.grecaptcha))
          r(a, i, o);
        else {
          if (typeof window > "u") {
            o(new Error("RecaptchaVerifier is only supported in browser"));
            return;
          }
          Cg(OF + a).then(() => {
            r(a, i, o);
          }).catch((c) => {
            o(c);
          });
        }
      }).catch((a) => {
        o(a);
      });
    });
  }
}
async function Op(t, e, n, s = !1) {
  const r = new DF(t);
  let i;
  try {
    i = await r.verify(n);
  } catch {
    i = await r.verify(n, !0);
  }
  const o = Object.assign({}, e);
  return s ? Object.assign(o, { captchaResp: i }) : Object.assign(o, { captchaResponse: i }), Object.assign(o, {
    clientType: "CLIENT_TYPE_WEB"
    /* RecaptchaClientType.WEB */
  }), Object.assign(o, {
    recaptchaVersion: "RECAPTCHA_ENTERPRISE"
    /* RecaptchaVersion.ENTERPRISE */
  }), o;
}
async function Sa(t, e, n, s) {
  var r;
  if (!((r = t._getRecaptchaConfig()) === null || r === void 0) && r.isProviderEnabled(
    "EMAIL_PASSWORD_PROVIDER"
    /* RecaptchaProvider.EMAIL_PASSWORD_PROVIDER */
  )) {
    const i = await Op(
      t,
      e,
      n,
      n === "getOobCode"
      /* RecaptchaActionName.GET_OOB_CODE */
    );
    return s(t, i);
  } else
    return s(t, e).catch(async (i) => {
      if (i.code === "auth/missing-recaptcha-token") {
        console.log(`${n} is protected by reCAPTCHA Enterprise for this project. Automatically triggering the reCAPTCHA flow and restarting the flow.`);
        const o = await Op(
          t,
          e,
          n,
          n === "getOobCode"
          /* RecaptchaActionName.GET_OOB_CODE */
        );
        return s(t, o);
      } else
        return Promise.reject(i);
    });
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function GF(t, e) {
  const n = du(t, "auth");
  if (n.isInitialized()) {
    const r = n.getImmediate(), i = n.getOptions();
    if (ya(i, e ?? {}))
      return r;
    Ct(
      r,
      "already-initialized"
      /* AuthErrorCode.ALREADY_INITIALIZED */
    );
  }
  return n.initialize({ options: e });
}
function BF(t, e) {
  const n = (e == null ? void 0 : e.persistence) || [], s = (Array.isArray(n) ? n : [n]).map(Xt);
  e != null && e.errorMap && t._updateErrorMap(e.errorMap), t._initializeWithPersistence(s, e == null ? void 0 : e.popupRedirectResolver);
}
function $F(t, e, n) {
  const s = Xn(t);
  G(
    s._canInitEmulator,
    s,
    "emulator-config-failed"
    /* AuthErrorCode.EMULATOR_CONFIG_FAILED */
  ), G(
    /^https?:\/\//.test(e),
    s,
    "invalid-emulator-scheme"
    /* AuthErrorCode.INVALID_EMULATOR_SCHEME */
  );
  const r = !1, i = Fg(e), { host: o, port: a } = VF(e), c = a === null ? "" : `:${a}`;
  s.config.emulator = { url: `${i}//${o}${c}/` }, s.settings.appVerificationDisabledForTesting = !0, s.emulatorConfig = Object.freeze({
    host: o,
    port: a,
    protocol: i.replace(":", ""),
    options: Object.freeze({ disableWarnings: r })
  }), UF();
}
function Fg(t) {
  const e = t.indexOf(":");
  return e < 0 ? "" : t.substr(0, e + 1);
}
function VF(t) {
  const e = Fg(t), n = /(\/\/)?([^?#/]+)/.exec(t.substr(e.length));
  if (!n)
    return { host: "", port: null };
  const s = n[2].split("@").pop() || "", r = /^(\[[^\]]+\])(:|$)/.exec(s);
  if (r) {
    const i = r[1];
    return { host: i, port: Pp(s.substr(i.length + 1)) };
  } else {
    const [i, o] = s.split(":");
    return { host: i, port: Pp(o) };
  }
}
function Pp(t) {
  if (!t)
    return null;
  const e = Number(t);
  return isNaN(e) ? null : e;
}
function UF() {
  function t() {
    const e = document.createElement("p"), n = e.style;
    e.innerText = "Running in emulator mode. Do not use with production credentials.", n.position = "fixed", n.width = "100%", n.backgroundColor = "#ffffff", n.border = ".1em solid #000000", n.color = "#b50000", n.bottom = "0px", n.left = "0px", n.margin = "0px", n.zIndex = "10000", n.textAlign = "center", e.classList.add("firebase-emulator-warning"), document.body.appendChild(e);
  }
  typeof console < "u" && typeof console.info == "function" && console.info("WARNING: You are using the Auth Emulator, which is intended for local testing only.  Do not use with production credentials."), typeof window < "u" && typeof document < "u" && (document.readyState === "loading" ? window.addEventListener("DOMContentLoaded", t) : t());
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class _u {
  /** @internal */
  constructor(e, n) {
    this.providerId = e, this.signInMethod = n;
  }
  /**
   * Returns a JSON-serializable representation of this object.
   *
   * @returns a JSON-serializable representation of this object.
   */
  toJSON() {
    return Kt("not implemented");
  }
  /** @internal */
  _getIdTokenResponse(e) {
    return Kt("not implemented");
  }
  /** @internal */
  _linkToIdToken(e, n) {
    return Kt("not implemented");
  }
  /** @internal */
  _getReauthenticationResolver(e) {
    return Kt("not implemented");
  }
}
async function HF(t, e) {
  return gn(t, "POST", "/v1/accounts:signUp", e);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
async function jF(t, e) {
  return no(t, "POST", "/v1/accounts:signInWithPassword", mn(t, e));
}
async function kg(t, e) {
  return gn(t, "POST", "/v1/accounts:sendOobCode", mn(t, e));
}
async function WF(t, e) {
  return kg(t, e);
}
async function zF(t, e) {
  return kg(t, e);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
async function qF(t, e) {
  return no(t, "POST", "/v1/accounts:signInWithEmailLink", mn(t, e));
}
async function YF(t, e) {
  return no(t, "POST", "/v1/accounts:signInWithEmailLink", mn(t, e));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class Li extends _u {
  /** @internal */
  constructor(e, n, s, r = null) {
    super("password", s), this._email = e, this._password = n, this._tenantId = r;
  }
  /** @internal */
  static _fromEmailAndPassword(e, n) {
    return new Li(
      e,
      n,
      "password"
      /* SignInMethod.EMAIL_PASSWORD */
    );
  }
  /** @internal */
  static _fromEmailAndCode(e, n, s = null) {
    return new Li(e, n, "emailLink", s);
  }
  /** {@inheritdoc AuthCredential.toJSON} */
  toJSON() {
    return {
      email: this._email,
      password: this._password,
      signInMethod: this.signInMethod,
      tenantId: this._tenantId
    };
  }
  /**
   * Static method to deserialize a JSON representation of an object into an {@link  AuthCredential}.
   *
   * @param json - Either `object` or the stringified representation of the object. When string is
   * provided, `JSON.parse` would be called first.
   *
   * @returns If the JSON input does not represent an {@link AuthCredential}, null is returned.
   */
  static fromJSON(e) {
    const n = typeof e == "string" ? JSON.parse(e) : e;
    if (n != null && n.email && (n != null && n.password)) {
      if (n.signInMethod === "password")
        return this._fromEmailAndPassword(n.email, n.password);
      if (n.signInMethod === "emailLink")
        return this._fromEmailAndCode(n.email, n.password, n.tenantId);
    }
    return null;
  }
  /** @internal */
  async _getIdTokenResponse(e) {
    switch (this.signInMethod) {
      case "password":
        const n = {
          returnSecureToken: !0,
          email: this._email,
          password: this._password,
          clientType: "CLIENT_TYPE_WEB"
          /* RecaptchaClientType.WEB */
        };
        return Sa(e, n, "signInWithPassword", jF);
      case "emailLink":
        return qF(e, {
          email: this._email,
          oobCode: this._password
        });
      default:
        Ct(
          e,
          "internal-error"
          /* AuthErrorCode.INTERNAL_ERROR */
        );
    }
  }
  /** @internal */
  async _linkToIdToken(e, n) {
    switch (this.signInMethod) {
      case "password":
        const s = {
          idToken: n,
          returnSecureToken: !0,
          email: this._email,
          password: this._password,
          clientType: "CLIENT_TYPE_WEB"
          /* RecaptchaClientType.WEB */
        };
        return Sa(e, s, "signUpPassword", HF);
      case "emailLink":
        return YF(e, {
          idToken: n,
          email: this._email,
          oobCode: this._password
        });
      default:
        Ct(
          e,
          "internal-error"
          /* AuthErrorCode.INTERNAL_ERROR */
        );
    }
  }
  /** @internal */
  _getReauthenticationResolver(e) {
    return this._getIdTokenResponse(e);
  }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
async function dr(t, e) {
  return no(t, "POST", "/v1/accounts:signInWithIdp", mn(t, e));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const KF = "http://localhost";
class bs extends _u {
  constructor() {
    super(...arguments), this.pendingToken = null;
  }
  /** @internal */
  static _fromParams(e) {
    const n = new bs(e.providerId, e.signInMethod);
    return e.idToken || e.accessToken ? (e.idToken && (n.idToken = e.idToken), e.accessToken && (n.accessToken = e.accessToken), e.nonce && !e.pendingToken && (n.nonce = e.nonce), e.pendingToken && (n.pendingToken = e.pendingToken)) : e.oauthToken && e.oauthTokenSecret ? (n.accessToken = e.oauthToken, n.secret = e.oauthTokenSecret) : Ct(
      "argument-error"
      /* AuthErrorCode.ARGUMENT_ERROR */
    ), n;
  }
  /** {@inheritdoc AuthCredential.toJSON}  */
  toJSON() {
    return {
      idToken: this.idToken,
      accessToken: this.accessToken,
      secret: this.secret,
      nonce: this.nonce,
      pendingToken: this.pendingToken,
      providerId: this.providerId,
      signInMethod: this.signInMethod
    };
  }
  /**
   * Static method to deserialize a JSON representation of an object into an
   * {@link  AuthCredential}.
   *
   * @param json - Input can be either Object or the stringified representation of the object.
   * When string is provided, JSON.parse would be called first.
   *
   * @returns If the JSON input does not represent an {@link  AuthCredential}, null is returned.
   */
  static fromJSON(e) {
    const n = typeof e == "string" ? JSON.parse(e) : e, { providerId: s, signInMethod: r } = n, i = hu(n, ["providerId", "signInMethod"]);
    if (!s || !r)
      return null;
    const o = new bs(s, r);
    return o.idToken = i.idToken || void 0, o.accessToken = i.accessToken || void 0, o.secret = i.secret, o.nonce = i.nonce, o.pendingToken = i.pendingToken || null, o;
  }
  /** @internal */
  _getIdTokenResponse(e) {
    const n = this.buildRequest();
    return dr(e, n);
  }
  /** @internal */
  _linkToIdToken(e, n) {
    const s = this.buildRequest();
    return s.idToken = n, dr(e, s);
  }
  /** @internal */
  _getReauthenticationResolver(e) {
    const n = this.buildRequest();
    return n.autoCreate = !1, dr(e, n);
  }
  buildRequest() {
    const e = {
      requestUri: KF,
      returnSecureToken: !0
    };
    if (this.pendingToken)
      e.pendingToken = this.pendingToken;
    else {
      const n = {};
      this.idToken && (n.id_token = this.idToken), this.accessToken && (n.access_token = this.accessToken), this.secret && (n.oauth_token_secret = this.secret), n.providerId = this.providerId, this.nonce && !this.pendingToken && (n.nonce = this.nonce), e.postBody = Ur(n);
    }
    return e;
  }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function XF(t) {
  switch (t) {
    case "recoverEmail":
      return "RECOVER_EMAIL";
    case "resetPassword":
      return "PASSWORD_RESET";
    case "signIn":
      return "EMAIL_SIGNIN";
    case "verifyEmail":
      return "VERIFY_EMAIL";
    case "verifyAndChangeEmail":
      return "VERIFY_AND_CHANGE_EMAIL";
    case "revertSecondFactorAddition":
      return "REVERT_SECOND_FACTOR_ADDITION";
    default:
      return null;
  }
}
function JF(t) {
  const e = di(ui(t)).link, n = e ? di(ui(e)).deep_link_id : null, s = di(ui(t)).deep_link_id;
  return (s ? di(ui(s)).link : null) || s || n || e || t;
}
class yu {
  /**
   * @param actionLink - The link from which to extract the URL.
   * @returns The {@link ActionCodeURL} object, or null if the link is invalid.
   *
   * @internal
   */
  constructor(e) {
    var n, s, r, i, o, a;
    const c = di(ui(e)), l = (n = c.apiKey) !== null && n !== void 0 ? n : null, d = (s = c.oobCode) !== null && s !== void 0 ? s : null, u = XF((r = c.mode) !== null && r !== void 0 ? r : null);
    G(
      l && d && u,
      "argument-error"
      /* AuthErrorCode.ARGUMENT_ERROR */
    ), this.apiKey = l, this.operation = u, this.code = d, this.continueUrl = (i = c.continueUrl) !== null && i !== void 0 ? i : null, this.languageCode = (o = c.languageCode) !== null && o !== void 0 ? o : null, this.tenantId = (a = c.tenantId) !== null && a !== void 0 ? a : null;
  }
  /**
   * Parses the email action link string and returns an {@link ActionCodeURL} if the link is valid,
   * otherwise returns null.
   *
   * @param link  - The email action link string.
   * @returns The {@link ActionCodeURL} object, or null if the link is invalid.
   *
   * @public
   */
  static parseLink(e) {
    const n = JF(e);
    try {
      return new yu(n);
    } catch {
      return null;
    }
  }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class jr {
  constructor() {
    this.providerId = jr.PROVIDER_ID;
  }
  /**
   * Initialize an {@link AuthCredential} using an email and password.
   *
   * @example
   * ```javascript
   * const authCredential = EmailAuthProvider.credential(email, password);
   * const userCredential = await signInWithCredential(auth, authCredential);
   * ```
   *
   * @example
   * ```javascript
   * const userCredential = await signInWithEmailAndPassword(auth, email, password);
   * ```
   *
   * @param email - Email address.
   * @param password - User account password.
   * @returns The auth provider credential.
   */
  static credential(e, n) {
    return Li._fromEmailAndPassword(e, n);
  }
  /**
   * Initialize an {@link AuthCredential} using an email and an email link after a sign in with
   * email link operation.
   *
   * @example
   * ```javascript
   * const authCredential = EmailAuthProvider.credentialWithLink(auth, email, emailLink);
   * const userCredential = await signInWithCredential(auth, authCredential);
   * ```
   *
   * @example
   * ```javascript
   * await sendSignInLinkToEmail(auth, email);
   * // Obtain emailLink from user.
   * const userCredential = await signInWithEmailLink(auth, email, emailLink);
   * ```
   *
   * @param auth - The {@link Auth} instance used to verify the link.
   * @param email - Email address.
   * @param emailLink - Sign-in email link.
   * @returns - The auth provider credential.
   */
  static credentialWithLink(e, n) {
    const s = yu.parseLink(n);
    return G(
      s,
      "argument-error"
      /* AuthErrorCode.ARGUMENT_ERROR */
    ), Li._fromEmailAndCode(e, s.code, s.tenantId);
  }
}
jr.PROVIDER_ID = "password";
jr.EMAIL_PASSWORD_SIGN_IN_METHOD = "password";
jr.EMAIL_LINK_SIGN_IN_METHOD = "emailLink";
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class Ag {
  /**
   * Constructor for generic OAuth providers.
   *
   * @param providerId - Provider for which credentials should be generated.
   */
  constructor(e) {
    this.providerId = e, this.defaultLanguageCode = null, this.customParameters = {};
  }
  /**
   * Set the language gode.
   *
   * @param languageCode - language code
   */
  setDefaultLanguage(e) {
    this.defaultLanguageCode = e;
  }
  /**
   * Sets the OAuth custom parameters to pass in an OAuth request for popup and redirect sign-in
   * operations.
   *
   * @remarks
   * For a detailed list, check the reserved required OAuth 2.0 parameters such as `client_id`,
   * `redirect_uri`, `scope`, `response_type`, and `state` are not allowed and will be ignored.
   *
   * @param customOAuthParameters - The custom OAuth parameters to pass in the OAuth request.
   */
  setCustomParameters(e) {
    return this.customParameters = e, this;
  }
  /**
   * Retrieve the current list of {@link CustomParameters}.
   */
  getCustomParameters() {
    return this.customParameters;
  }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class so extends Ag {
  constructor() {
    super(...arguments), this.scopes = [];
  }
  /**
   * Add an OAuth scope to the credential.
   *
   * @param scope - Provider OAuth scope to add.
   */
  addScope(e) {
    return this.scopes.includes(e) || this.scopes.push(e), this;
  }
  /**
   * Retrieve the current list of OAuth scopes.
   */
  getScopes() {
    return [...this.scopes];
  }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class Cn extends so {
  constructor() {
    super(
      "facebook.com"
      /* ProviderId.FACEBOOK */
    );
  }
  /**
   * Creates a credential for Facebook.
   *
   * @example
   * ```javascript
   * // `event` from the Facebook auth.authResponseChange callback.
   * const credential = FacebookAuthProvider.credential(event.authResponse.accessToken);
   * const result = await signInWithCredential(credential);
   * ```
   *
   * @param accessToken - Facebook access token.
   */
  static credential(e) {
    return bs._fromParams({
      providerId: Cn.PROVIDER_ID,
      signInMethod: Cn.FACEBOOK_SIGN_IN_METHOD,
      accessToken: e
    });
  }
  /**
   * Used to extract the underlying {@link OAuthCredential} from a {@link UserCredential}.
   *
   * @param userCredential - The user credential.
   */
  static credentialFromResult(e) {
    return Cn.credentialFromTaggedObject(e);
  }
  /**
   * Used to extract the underlying {@link OAuthCredential} from a {@link AuthError} which was
   * thrown during a sign-in, link, or reauthenticate operation.
   *
   * @param userCredential - The user credential.
   */
  static credentialFromError(e) {
    return Cn.credentialFromTaggedObject(e.customData || {});
  }
  static credentialFromTaggedObject({ _tokenResponse: e }) {
    if (!e || !("oauthAccessToken" in e) || !e.oauthAccessToken)
      return null;
    try {
      return Cn.credential(e.oauthAccessToken);
    } catch {
      return null;
    }
  }
}
Cn.FACEBOOK_SIGN_IN_METHOD = "facebook.com";
Cn.PROVIDER_ID = "facebook.com";
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class Fn extends so {
  constructor() {
    super(
      "google.com"
      /* ProviderId.GOOGLE */
    ), this.addScope("profile");
  }
  /**
   * Creates a credential for Google. At least one of ID token and access token is required.
   *
   * @example
   * ```javascript
   * // \`googleUser\` from the onsuccess Google Sign In callback.
   * const credential = GoogleAuthProvider.credential(googleUser.getAuthResponse().id_token);
   * const result = await signInWithCredential(credential);
   * ```
   *
   * @param idToken - Google ID token.
   * @param accessToken - Google access token.
   */
  static credential(e, n) {
    return bs._fromParams({
      providerId: Fn.PROVIDER_ID,
      signInMethod: Fn.GOOGLE_SIGN_IN_METHOD,
      idToken: e,
      accessToken: n
    });
  }
  /**
   * Used to extract the underlying {@link OAuthCredential} from a {@link UserCredential}.
   *
   * @param userCredential - The user credential.
   */
  static credentialFromResult(e) {
    return Fn.credentialFromTaggedObject(e);
  }
  /**
   * Used to extract the underlying {@link OAuthCredential} from a {@link AuthError} which was
   * thrown during a sign-in, link, or reauthenticate operation.
   *
   * @param userCredential - The user credential.
   */
  static credentialFromError(e) {
    return Fn.credentialFromTaggedObject(e.customData || {});
  }
  static credentialFromTaggedObject({ _tokenResponse: e }) {
    if (!e)
      return null;
    const { oauthIdToken: n, oauthAccessToken: s } = e;
    if (!n && !s)
      return null;
    try {
      return Fn.credential(n, s);
    } catch {
      return null;
    }
  }
}
Fn.GOOGLE_SIGN_IN_METHOD = "google.com";
Fn.PROVIDER_ID = "google.com";
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class kn extends so {
  constructor() {
    super(
      "github.com"
      /* ProviderId.GITHUB */
    );
  }
  /**
   * Creates a credential for Github.
   *
   * @param accessToken - Github access token.
   */
  static credential(e) {
    return bs._fromParams({
      providerId: kn.PROVIDER_ID,
      signInMethod: kn.GITHUB_SIGN_IN_METHOD,
      accessToken: e
    });
  }
  /**
   * Used to extract the underlying {@link OAuthCredential} from a {@link UserCredential}.
   *
   * @param userCredential - The user credential.
   */
  static credentialFromResult(e) {
    return kn.credentialFromTaggedObject(e);
  }
  /**
   * Used to extract the underlying {@link OAuthCredential} from a {@link AuthError} which was
   * thrown during a sign-in, link, or reauthenticate operation.
   *
   * @param userCredential - The user credential.
   */
  static credentialFromError(e) {
    return kn.credentialFromTaggedObject(e.customData || {});
  }
  static credentialFromTaggedObject({ _tokenResponse: e }) {
    if (!e || !("oauthAccessToken" in e) || !e.oauthAccessToken)
      return null;
    try {
      return kn.credential(e.oauthAccessToken);
    } catch {
      return null;
    }
  }
}
kn.GITHUB_SIGN_IN_METHOD = "github.com";
kn.PROVIDER_ID = "github.com";
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class An extends so {
  constructor() {
    super(
      "twitter.com"
      /* ProviderId.TWITTER */
    );
  }
  /**
   * Creates a credential for Twitter.
   *
   * @param token - Twitter access token.
   * @param secret - Twitter secret.
   */
  static credential(e, n) {
    return bs._fromParams({
      providerId: An.PROVIDER_ID,
      signInMethod: An.TWITTER_SIGN_IN_METHOD,
      oauthToken: e,
      oauthTokenSecret: n
    });
  }
  /**
   * Used to extract the underlying {@link OAuthCredential} from a {@link UserCredential}.
   *
   * @param userCredential - The user credential.
   */
  static credentialFromResult(e) {
    return An.credentialFromTaggedObject(e);
  }
  /**
   * Used to extract the underlying {@link OAuthCredential} from a {@link AuthError} which was
   * thrown during a sign-in, link, or reauthenticate operation.
   *
   * @param userCredential - The user credential.
   */
  static credentialFromError(e) {
    return An.credentialFromTaggedObject(e.customData || {});
  }
  static credentialFromTaggedObject({ _tokenResponse: e }) {
    if (!e)
      return null;
    const { oauthAccessToken: n, oauthTokenSecret: s } = e;
    if (!n || !s)
      return null;
    try {
      return An.credential(n, s);
    } catch {
      return null;
    }
  }
}
An.TWITTER_SIGN_IN_METHOD = "twitter.com";
An.PROVIDER_ID = "twitter.com";
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
async function QF(t, e) {
  return no(t, "POST", "/v1/accounts:signUp", mn(t, e));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class vs {
  constructor(e) {
    this.user = e.user, this.providerId = e.providerId, this._tokenResponse = e._tokenResponse, this.operationType = e.operationType;
  }
  static async _fromIdTokenResponse(e, n, s, r = !1) {
    const i = await us._fromIdTokenResponse(e, s, r), o = Mp(s);
    return new vs({
      user: i,
      providerId: o,
      _tokenResponse: s,
      operationType: n
    });
  }
  static async _forOperation(e, n, s) {
    await e._updateTokensIfNecessary(
      s,
      /* reload */
      !0
    );
    const r = Mp(s);
    return new vs({
      user: e,
      providerId: r,
      _tokenResponse: s,
      operationType: n
    });
  }
}
function Mp(t) {
  return t.providerId ? t.providerId : "phoneNumber" in t ? "phone" : null;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class wa extends Kn {
  constructor(e, n, s, r) {
    var i;
    super(n.code, n.message), this.operationType = s, this.user = r, Object.setPrototypeOf(this, wa.prototype), this.customData = {
      appName: e.name,
      tenantId: (i = e.tenantId) !== null && i !== void 0 ? i : void 0,
      _serverResponse: n.customData._serverResponse,
      operationType: s
    };
  }
  static _fromErrorAndOperation(e, n, s, r) {
    return new wa(e, n, s, r);
  }
}
function Ng(t, e, n, s) {
  return (e === "reauthenticate" ? n._getReauthenticationResolver(t) : n._getIdTokenResponse(t)).catch((i) => {
    throw i.code === "auth/multi-factor-auth-required" ? wa._fromErrorAndOperation(t, i, e, s) : i;
  });
}
async function ZF(t, e, n = !1) {
  const s = await Ai(t, e._linkToIdToken(t.auth, await t.getIdToken()), n);
  return vs._forOperation(t, "link", s);
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
async function e1(t, e, n = !1) {
  const { auth: s } = t, r = "reauthenticate";
  try {
    const i = await Ai(t, Ng(s, r, e, t), n);
    G(
      i.idToken,
      s,
      "internal-error"
      /* AuthErrorCode.INTERNAL_ERROR */
    );
    const o = mu(i.idToken);
    G(
      o,
      s,
      "internal-error"
      /* AuthErrorCode.INTERNAL_ERROR */
    );
    const { sub: a } = o;
    return G(
      t.uid === a,
      s,
      "user-mismatch"
      /* AuthErrorCode.USER_MISMATCH */
    ), vs._forOperation(t, r, i);
  } catch (i) {
    throw (i == null ? void 0 : i.code) === "auth/user-not-found" && Ct(
      s,
      "user-mismatch"
      /* AuthErrorCode.USER_MISMATCH */
    ), i;
  }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
async function Lg(t, e, n = !1) {
  const s = "signIn", r = await Ng(t, s, e), i = await vs._fromIdTokenResponse(t, s, r);
  return n || await t._updateCurrentUser(i.user), i;
}
async function t1(t, e) {
  return Lg(Xn(t), e);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
async function Rg(t) {
  const e = Xn(t);
  e._getPasswordPolicyInternal() && await e._updatePasswordPolicy();
}
async function n1(t, e, n) {
  const s = Xn(t);
  await Sa(s, {
    requestType: "PASSWORD_RESET",
    email: e,
    clientType: "CLIENT_TYPE_WEB"
    /* RecaptchaClientType.WEB */
  }, "getOobCode", zF);
}
async function s1(t, e, n) {
  const s = Xn(t), o = await Sa(s, {
    returnSecureToken: !0,
    email: e,
    password: n,
    clientType: "CLIENT_TYPE_WEB"
    /* RecaptchaClientType.WEB */
  }, "signUpPassword", QF).catch((c) => {
    throw c.code === "auth/password-does-not-meet-requirements" && Rg(t), c;
  }), a = await vs._fromIdTokenResponse(s, "signIn", o);
  return await s._updateCurrentUser(a.user), a;
}
function r1(t, e, n) {
  return t1(Ke(t), jr.credential(e, n)).catch(async (s) => {
    throw s.code === "auth/password-does-not-meet-requirements" && Rg(t), s;
  });
}
async function xg(t, e) {
  const n = Ke(t), r = {
    requestType: "VERIFY_EMAIL",
    idToken: await t.getIdToken()
  }, { email: i } = await WF(n.auth, r);
  i !== t.email && await t.reload();
}
function i1(t, e, n, s) {
  return Ke(t).onIdTokenChanged(e, n, s);
}
function o1(t, e, n) {
  return Ke(t).beforeAuthStateChanged(e, n);
}
const Ta = "__sak";
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class Og {
  constructor(e, n) {
    this.storageRetriever = e, this.type = n;
  }
  _isAvailable() {
    try {
      return this.storage ? (this.storage.setItem(Ta, "1"), this.storage.removeItem(Ta), Promise.resolve(!0)) : Promise.resolve(!1);
    } catch {
      return Promise.resolve(!1);
    }
  }
  _set(e, n) {
    return this.storage.setItem(e, JSON.stringify(n)), Promise.resolve();
  }
  _get(e) {
    const n = this.storage.getItem(e);
    return Promise.resolve(n ? JSON.parse(n) : null);
  }
  _remove(e) {
    return this.storage.removeItem(e), Promise.resolve();
  }
  get storage() {
    return this.storageRetriever();
  }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function a1() {
  const t = $e();
  return gu(t) || fc(t);
}
const c1 = 1e3, l1 = 10;
class Pg extends Og {
  constructor() {
    super(
      () => window.localStorage,
      "LOCAL"
      /* PersistenceType.LOCAL */
    ), this.boundEventHandler = (e, n) => this.onStorageEvent(e, n), this.listeners = {}, this.localCache = {}, this.pollTimer = null, this.safariLocalStorageNotSynced = a1() && CF(), this.fallbackToPolling = Tg(), this._shouldAllowMigration = !0;
  }
  forAllChangedKeys(e) {
    for (const n of Object.keys(this.listeners)) {
      const s = this.storage.getItem(n), r = this.localCache[n];
      s !== r && e(n, r, s);
    }
  }
  onStorageEvent(e, n = !1) {
    if (!e.key) {
      this.forAllChangedKeys((o, a, c) => {
        this.notifyListeners(o, c);
      });
      return;
    }
    const s = e.key;
    if (n ? this.detachListener() : this.stopPolling(), this.safariLocalStorageNotSynced) {
      const o = this.storage.getItem(s);
      if (e.newValue !== o)
        e.newValue !== null ? this.storage.setItem(s, e.newValue) : this.storage.removeItem(s);
      else if (this.localCache[s] === e.newValue && !n)
        return;
    }
    const r = () => {
      const o = this.storage.getItem(s);
      !n && this.localCache[s] === o || this.notifyListeners(s, o);
    }, i = this.storage.getItem(s);
    IF() && i !== e.newValue && e.newValue !== e.oldValue ? setTimeout(r, l1) : r();
  }
  notifyListeners(e, n) {
    this.localCache[e] = n;
    const s = this.listeners[e];
    if (s)
      for (const r of Array.from(s))
        r(n && JSON.parse(n));
  }
  startPolling() {
    this.stopPolling(), this.pollTimer = setInterval(() => {
      this.forAllChangedKeys((e, n, s) => {
        this.onStorageEvent(
          new StorageEvent("storage", {
            key: e,
            oldValue: n,
            newValue: s
          }),
          /* poll */
          !0
        );
      });
    }, c1);
  }
  stopPolling() {
    this.pollTimer && (clearInterval(this.pollTimer), this.pollTimer = null);
  }
  attachListener() {
    window.addEventListener("storage", this.boundEventHandler);
  }
  detachListener() {
    window.removeEventListener("storage", this.boundEventHandler);
  }
  _addListener(e, n) {
    Object.keys(this.listeners).length === 0 && (this.fallbackToPolling ? this.startPolling() : this.attachListener()), this.listeners[e] || (this.listeners[e] = /* @__PURE__ */ new Set(), this.localCache[e] = this.storage.getItem(e)), this.listeners[e].add(n);
  }
  _removeListener(e, n) {
    this.listeners[e] && (this.listeners[e].delete(n), this.listeners[e].size === 0 && delete this.listeners[e]), Object.keys(this.listeners).length === 0 && (this.detachListener(), this.stopPolling());
  }
  // Update local cache on base operations:
  async _set(e, n) {
    await super._set(e, n), this.localCache[e] = JSON.stringify(n);
  }
  async _get(e) {
    const n = await super._get(e);
    return this.localCache[e] = JSON.stringify(n), n;
  }
  async _remove(e) {
    await super._remove(e), delete this.localCache[e];
  }
}
Pg.type = "LOCAL";
const Mg = Pg;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class Dg extends Og {
  constructor() {
    super(
      () => window.sessionStorage,
      "SESSION"
      /* PersistenceType.SESSION */
    );
  }
  _addListener(e, n) {
  }
  _removeListener(e, n) {
  }
}
Dg.type = "SESSION";
const Gg = Dg;
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function d1(t) {
  return Promise.all(t.map(async (e) => {
    try {
      return {
        fulfilled: !0,
        value: await e
      };
    } catch (n) {
      return {
        fulfilled: !1,
        reason: n
      };
    }
  }));
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class mc {
  constructor(e) {
    this.eventTarget = e, this.handlersMap = {}, this.boundEventHandler = this.handleEvent.bind(this);
  }
  /**
   * Obtain an instance of a Receiver for a given event target, if none exists it will be created.
   *
   * @param eventTarget - An event target (such as window or self) through which the underlying
   * messages will be received.
   */
  static _getInstance(e) {
    const n = this.receivers.find((r) => r.isListeningto(e));
    if (n)
      return n;
    const s = new mc(e);
    return this.receivers.push(s), s;
  }
  isListeningto(e) {
    return this.eventTarget === e;
  }
  /**
   * Fans out a MessageEvent to the appropriate listeners.
   *
   * @remarks
   * Sends an {@link Status.ACK} upon receipt and a {@link Status.DONE} once all handlers have
   * finished processing.
   *
   * @param event - The MessageEvent.
   *
   */
  async handleEvent(e) {
    const n = e, { eventId: s, eventType: r, data: i } = n.data, o = this.handlersMap[r];
    if (!(o != null && o.size))
      return;
    n.ports[0].postMessage({
      status: "ack",
      eventId: s,
      eventType: r
    });
    const a = Array.from(o).map(async (l) => l(n.origin, i)), c = await d1(a);
    n.ports[0].postMessage({
      status: "done",
      eventId: s,
      eventType: r,
      response: c
    });
  }
  /**
   * Subscribe an event handler for a particular event.
   *
   * @param eventType - Event name to subscribe to.
   * @param eventHandler - The event handler which should receive the events.
   *
   */
  _subscribe(e, n) {
    Object.keys(this.handlersMap).length === 0 && this.eventTarget.addEventListener("message", this.boundEventHandler), this.handlersMap[e] || (this.handlersMap[e] = /* @__PURE__ */ new Set()), this.handlersMap[e].add(n);
  }
  /**
   * Unsubscribe an event handler from a particular event.
   *
   * @param eventType - Event name to unsubscribe from.
   * @param eventHandler - Optinoal event handler, if none provided, unsubscribe all handlers on this event.
   *
   */
  _unsubscribe(e, n) {
    this.handlersMap[e] && n && this.handlersMap[e].delete(n), (!n || this.handlersMap[e].size === 0) && delete this.handlersMap[e], Object.keys(this.handlersMap).length === 0 && this.eventTarget.removeEventListener("message", this.boundEventHandler);
  }
}
mc.receivers = [];
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function Eu(t = "", e = 10) {
  let n = "";
  for (let s = 0; s < e; s++)
    n += Math.floor(Math.random() * 10);
  return t + n;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class u1 {
  constructor(e) {
    this.target = e, this.handlers = /* @__PURE__ */ new Set();
  }
  /**
   * Unsubscribe the handler and remove it from our tracking Set.
   *
   * @param handler - The handler to unsubscribe.
   */
  removeMessageHandler(e) {
    e.messageChannel && (e.messageChannel.port1.removeEventListener("message", e.onMessage), e.messageChannel.port1.close()), this.handlers.delete(e);
  }
  /**
   * Send a message to the Receiver located at {@link target}.
   *
   * @remarks
   * We'll first wait a bit for an ACK , if we get one we will wait significantly longer until the
   * receiver has had a chance to fully process the event.
   *
   * @param eventType - Type of event to send.
   * @param data - The payload of the event.
   * @param timeout - Timeout for waiting on an ACK from the receiver.
   *
   * @returns An array of settled promises from all the handlers that were listening on the receiver.
   */
  async _send(e, n, s = 50) {
    const r = typeof MessageChannel < "u" ? new MessageChannel() : null;
    if (!r)
      throw new Error(
        "connection_unavailable"
        /* _MessageError.CONNECTION_UNAVAILABLE */
      );
    let i, o;
    return new Promise((a, c) => {
      const l = Eu("", 20);
      r.port1.start();
      const d = setTimeout(() => {
        c(new Error(
          "unsupported_event"
          /* _MessageError.UNSUPPORTED_EVENT */
        ));
      }, s);
      o = {
        messageChannel: r,
        onMessage(u) {
          const h = u;
          if (h.data.eventId === l)
            switch (h.data.status) {
              case "ack":
                clearTimeout(d), i = setTimeout(
                  () => {
                    c(new Error(
                      "timeout"
                      /* _MessageError.TIMEOUT */
                    ));
                  },
                  3e3
                  /* _TimeoutDuration.COMPLETION */
                );
                break;
              case "done":
                clearTimeout(i), a(h.data.response);
                break;
              default:
                clearTimeout(d), clearTimeout(i), c(new Error(
                  "invalid_response"
                  /* _MessageError.INVALID_RESPONSE */
                ));
                break;
            }
        }
      }, this.handlers.add(o), r.port1.addEventListener("message", o.onMessage), this.target.postMessage({
        eventType: e,
        eventId: l,
        data: n
      }, [r.port2]);
    }).finally(() => {
      o && this.removeMessageHandler(o);
    });
  }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function Gt() {
  return window;
}
function h1(t) {
  Gt().location.href = t;
}
/**
 * @license
 * Copyright 2020 Google LLC.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function Bg() {
  return typeof Gt().WorkerGlobalScope < "u" && typeof Gt().importScripts == "function";
}
async function p1() {
  if (!(navigator != null && navigator.serviceWorker))
    return null;
  try {
    return (await navigator.serviceWorker.ready).active;
  } catch {
    return null;
  }
}
function f1() {
  var t;
  return ((t = navigator == null ? void 0 : navigator.serviceWorker) === null || t === void 0 ? void 0 : t.controller) || null;
}
function m1() {
  return Bg() ? self : null;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const $g = "firebaseLocalStorageDb", g1 = 1, Ia = "firebaseLocalStorage", Vg = "fbase_key";
class ro {
  constructor(e) {
    this.request = e;
  }
  toPromise() {
    return new Promise((e, n) => {
      this.request.addEventListener("success", () => {
        e(this.request.result);
      }), this.request.addEventListener("error", () => {
        n(this.request.error);
      });
    });
  }
}
function gc(t, e) {
  return t.transaction([Ia], e ? "readwrite" : "readonly").objectStore(Ia);
}
function _1() {
  const t = indexedDB.deleteDatabase($g);
  return new ro(t).toPromise();
}
function zl() {
  const t = indexedDB.open($g, g1);
  return new Promise((e, n) => {
    t.addEventListener("error", () => {
      n(t.error);
    }), t.addEventListener("upgradeneeded", () => {
      const s = t.result;
      try {
        s.createObjectStore(Ia, { keyPath: Vg });
      } catch (r) {
        n(r);
      }
    }), t.addEventListener("success", async () => {
      const s = t.result;
      s.objectStoreNames.contains(Ia) ? e(s) : (s.close(), await _1(), e(await zl()));
    });
  });
}
async function Dp(t, e, n) {
  const s = gc(t, !0).put({
    [Vg]: e,
    value: n
  });
  return new ro(s).toPromise();
}
async function y1(t, e) {
  const n = gc(t, !1).get(e), s = await new ro(n).toPromise();
  return s === void 0 ? null : s.value;
}
function Gp(t, e) {
  const n = gc(t, !0).delete(e);
  return new ro(n).toPromise();
}
const E1 = 800, b1 = 3;
class Ug {
  constructor() {
    this.type = "LOCAL", this._shouldAllowMigration = !0, this.listeners = {}, this.localCache = {}, this.pollTimer = null, this.pendingWrites = 0, this.receiver = null, this.sender = null, this.serviceWorkerReceiverAvailable = !1, this.activeServiceWorker = null, this._workerInitializationPromise = this.initializeServiceWorkerMessaging().then(() => {
    }, () => {
    });
  }
  async _openDb() {
    return this.db ? this.db : (this.db = await zl(), this.db);
  }
  async _withRetries(e) {
    let n = 0;
    for (; ; )
      try {
        const s = await this._openDb();
        return await e(s);
      } catch (s) {
        if (n++ > b1)
          throw s;
        this.db && (this.db.close(), this.db = void 0);
      }
  }
  /**
   * IndexedDB events do not propagate from the main window to the worker context.  We rely on a
   * postMessage interface to send these events to the worker ourselves.
   */
  async initializeServiceWorkerMessaging() {
    return Bg() ? this.initializeReceiver() : this.initializeSender();
  }
  /**
   * As the worker we should listen to events from the main window.
   */
  async initializeReceiver() {
    this.receiver = mc._getInstance(m1()), this.receiver._subscribe("keyChanged", async (e, n) => ({
      keyProcessed: (await this._poll()).includes(n.key)
    })), this.receiver._subscribe("ping", async (e, n) => [
      "keyChanged"
      /* _EventType.KEY_CHANGED */
    ]);
  }
  /**
   * As the main window, we should let the worker know when keys change (set and remove).
   *
   * @remarks
   * {@link https://developer.mozilla.org/en-US/docs/Web/API/ServiceWorkerContainer/ready | ServiceWorkerContainer.ready}
   * may not resolve.
   */
  async initializeSender() {
    var e, n;
    if (this.activeServiceWorker = await p1(), !this.activeServiceWorker)
      return;
    this.sender = new u1(this.activeServiceWorker);
    const s = await this.sender._send(
      "ping",
      {},
      800
      /* _TimeoutDuration.LONG_ACK */
    );
    s && !((e = s[0]) === null || e === void 0) && e.fulfilled && !((n = s[0]) === null || n === void 0) && n.value.includes(
      "keyChanged"
      /* _EventType.KEY_CHANGED */
    ) && (this.serviceWorkerReceiverAvailable = !0);
  }
  /**
   * Let the worker know about a changed key, the exact key doesn't technically matter since the
   * worker will just trigger a full sync anyway.
   *
   * @remarks
   * For now, we only support one service worker per page.
   *
   * @param key - Storage key which changed.
   */
  async notifyServiceWorker(e) {
    if (!(!this.sender || !this.activeServiceWorker || f1() !== this.activeServiceWorker))
      try {
        await this.sender._send(
          "keyChanged",
          { key: e },
          // Use long timeout if receiver has previously responded to a ping from us.
          this.serviceWorkerReceiverAvailable ? 800 : 50
          /* _TimeoutDuration.ACK */
        );
      } catch {
      }
  }
  async _isAvailable() {
    try {
      if (!indexedDB)
        return !1;
      const e = await zl();
      return await Dp(e, Ta, "1"), await Gp(e, Ta), !0;
    } catch {
    }
    return !1;
  }
  async _withPendingWrite(e) {
    this.pendingWrites++;
    try {
      await e();
    } finally {
      this.pendingWrites--;
    }
  }
  async _set(e, n) {
    return this._withPendingWrite(async () => (await this._withRetries((s) => Dp(s, e, n)), this.localCache[e] = n, this.notifyServiceWorker(e)));
  }
  async _get(e) {
    const n = await this._withRetries((s) => y1(s, e));
    return this.localCache[e] = n, n;
  }
  async _remove(e) {
    return this._withPendingWrite(async () => (await this._withRetries((n) => Gp(n, e)), delete this.localCache[e], this.notifyServiceWorker(e)));
  }
  async _poll() {
    const e = await this._withRetries((r) => {
      const i = gc(r, !1).getAll();
      return new ro(i).toPromise();
    });
    if (!e)
      return [];
    if (this.pendingWrites !== 0)
      return [];
    const n = [], s = /* @__PURE__ */ new Set();
    if (e.length !== 0)
      for (const { fbase_key: r, value: i } of e)
        s.add(r), JSON.stringify(this.localCache[r]) !== JSON.stringify(i) && (this.notifyListeners(r, i), n.push(r));
    for (const r of Object.keys(this.localCache))
      this.localCache[r] && !s.has(r) && (this.notifyListeners(r, null), n.push(r));
    return n;
  }
  notifyListeners(e, n) {
    this.localCache[e] = n;
    const s = this.listeners[e];
    if (s)
      for (const r of Array.from(s))
        r(n);
  }
  startPolling() {
    this.stopPolling(), this.pollTimer = setInterval(async () => this._poll(), E1);
  }
  stopPolling() {
    this.pollTimer && (clearInterval(this.pollTimer), this.pollTimer = null);
  }
  _addListener(e, n) {
    Object.keys(this.listeners).length === 0 && this.startPolling(), this.listeners[e] || (this.listeners[e] = /* @__PURE__ */ new Set(), this._get(e)), this.listeners[e].add(n);
  }
  _removeListener(e, n) {
    this.listeners[e] && (this.listeners[e].delete(n), this.listeners[e].size === 0 && delete this.listeners[e]), Object.keys(this.listeners).length === 0 && this.stopPolling();
  }
}
Ug.type = "LOCAL";
const v1 = Ug;
new to(3e4, 6e4);
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function S1(t, e) {
  return e ? Xt(e) : (G(
    t._popupRedirectResolver,
    t,
    "argument-error"
    /* AuthErrorCode.ARGUMENT_ERROR */
  ), t._popupRedirectResolver);
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class bu extends _u {
  constructor(e) {
    super(
      "custom",
      "custom"
      /* ProviderId.CUSTOM */
    ), this.params = e;
  }
  _getIdTokenResponse(e) {
    return dr(e, this._buildIdpRequest());
  }
  _linkToIdToken(e, n) {
    return dr(e, this._buildIdpRequest(n));
  }
  _getReauthenticationResolver(e) {
    return dr(e, this._buildIdpRequest());
  }
  _buildIdpRequest(e) {
    const n = {
      requestUri: this.params.requestUri,
      sessionId: this.params.sessionId,
      postBody: this.params.postBody,
      tenantId: this.params.tenantId,
      pendingToken: this.params.pendingToken,
      returnSecureToken: !0,
      returnIdpCredential: !0
    };
    return e && (n.idToken = e), n;
  }
}
function w1(t) {
  return Lg(t.auth, new bu(t), t.bypassAuthState);
}
function T1(t) {
  const { auth: e, user: n } = t;
  return G(
    n,
    e,
    "internal-error"
    /* AuthErrorCode.INTERNAL_ERROR */
  ), e1(n, new bu(t), t.bypassAuthState);
}
async function I1(t) {
  const { auth: e, user: n } = t;
  return G(
    n,
    e,
    "internal-error"
    /* AuthErrorCode.INTERNAL_ERROR */
  ), ZF(n, new bu(t), t.bypassAuthState);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class Hg {
  constructor(e, n, s, r, i = !1) {
    this.auth = e, this.resolver = s, this.user = r, this.bypassAuthState = i, this.pendingPromise = null, this.eventManager = null, this.filter = Array.isArray(n) ? n : [n];
  }
  execute() {
    return new Promise(async (e, n) => {
      this.pendingPromise = { resolve: e, reject: n };
      try {
        this.eventManager = await this.resolver._initialize(this.auth), await this.onExecution(), this.eventManager.registerConsumer(this);
      } catch (s) {
        this.reject(s);
      }
    });
  }
  async onAuthEvent(e) {
    const { urlResponse: n, sessionId: s, postBody: r, tenantId: i, error: o, type: a } = e;
    if (o) {
      this.reject(o);
      return;
    }
    const c = {
      auth: this.auth,
      requestUri: n,
      sessionId: s,
      tenantId: i || void 0,
      postBody: r || void 0,
      user: this.user,
      bypassAuthState: this.bypassAuthState
    };
    try {
      this.resolve(await this.getIdpTask(a)(c));
    } catch (l) {
      this.reject(l);
    }
  }
  onError(e) {
    this.reject(e);
  }
  getIdpTask(e) {
    switch (e) {
      case "signInViaPopup":
      case "signInViaRedirect":
        return w1;
      case "linkViaPopup":
      case "linkViaRedirect":
        return I1;
      case "reauthViaPopup":
      case "reauthViaRedirect":
        return T1;
      default:
        Ct(
          this.auth,
          "internal-error"
          /* AuthErrorCode.INTERNAL_ERROR */
        );
    }
  }
  resolve(e) {
    an(this.pendingPromise, "Pending promise was never set"), this.pendingPromise.resolve(e), this.unregisterAndCleanUp();
  }
  reject(e) {
    an(this.pendingPromise, "Pending promise was never set"), this.pendingPromise.reject(e), this.unregisterAndCleanUp();
  }
  unregisterAndCleanUp() {
    this.eventManager && this.eventManager.unregisterConsumer(this), this.pendingPromise = null, this.cleanUp();
  }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const C1 = new to(2e3, 1e4);
class sr extends Hg {
  constructor(e, n, s, r, i) {
    super(e, n, r, i), this.provider = s, this.authWindow = null, this.pollId = null, sr.currentPopupAction && sr.currentPopupAction.cancel(), sr.currentPopupAction = this;
  }
  async executeNotNull() {
    const e = await this.execute();
    return G(
      e,
      this.auth,
      "internal-error"
      /* AuthErrorCode.INTERNAL_ERROR */
    ), e;
  }
  async onExecution() {
    an(this.filter.length === 1, "Popup operations only handle one event");
    const e = Eu();
    this.authWindow = await this.resolver._openPopup(
      this.auth,
      this.provider,
      this.filter[0],
      // There's always one, see constructor
      e
    ), this.authWindow.associatedEvent = e, this.resolver._originValidation(this.auth).catch((n) => {
      this.reject(n);
    }), this.resolver._isIframeWebStorageSupported(this.auth, (n) => {
      n || this.reject(Dt(
        this.auth,
        "web-storage-unsupported"
        /* AuthErrorCode.WEB_STORAGE_UNSUPPORTED */
      ));
    }), this.pollUserCancellation();
  }
  get eventId() {
    var e;
    return ((e = this.authWindow) === null || e === void 0 ? void 0 : e.associatedEvent) || null;
  }
  cancel() {
    this.reject(Dt(
      this.auth,
      "cancelled-popup-request"
      /* AuthErrorCode.EXPIRED_POPUP_REQUEST */
    ));
  }
  cleanUp() {
    this.authWindow && this.authWindow.close(), this.pollId && window.clearTimeout(this.pollId), this.authWindow = null, this.pollId = null, sr.currentPopupAction = null;
  }
  pollUserCancellation() {
    const e = () => {
      var n, s;
      if (!((s = (n = this.authWindow) === null || n === void 0 ? void 0 : n.window) === null || s === void 0) && s.closed) {
        this.pollId = window.setTimeout(
          () => {
            this.pollId = null, this.reject(Dt(
              this.auth,
              "popup-closed-by-user"
              /* AuthErrorCode.POPUP_CLOSED_BY_USER */
            ));
          },
          8e3
          /* _Timeout.AUTH_EVENT */
        );
        return;
      }
      this.pollId = window.setTimeout(e, C1.get());
    };
    e();
  }
}
sr.currentPopupAction = null;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const F1 = "pendingRedirect", ea = /* @__PURE__ */ new Map();
class k1 extends Hg {
  constructor(e, n, s = !1) {
    super(e, [
      "signInViaRedirect",
      "linkViaRedirect",
      "reauthViaRedirect",
      "unknown"
      /* AuthEventType.UNKNOWN */
    ], n, void 0, s), this.eventId = null;
  }
  /**
   * Override the execute function; if we already have a redirect result, then
   * just return it.
   */
  async execute() {
    let e = ea.get(this.auth._key());
    if (!e) {
      try {
        const s = await A1(this.resolver, this.auth) ? await super.execute() : null;
        e = () => Promise.resolve(s);
      } catch (n) {
        e = () => Promise.reject(n);
      }
      ea.set(this.auth._key(), e);
    }
    return this.bypassAuthState || ea.set(this.auth._key(), () => Promise.resolve(null)), e();
  }
  async onAuthEvent(e) {
    if (e.type === "signInViaRedirect")
      return super.onAuthEvent(e);
    if (e.type === "unknown") {
      this.resolve(null);
      return;
    }
    if (e.eventId) {
      const n = await this.auth._redirectUserForId(e.eventId);
      if (n)
        return this.user = n, super.onAuthEvent(e);
      this.resolve(null);
    }
  }
  async onExecution() {
  }
  cleanUp() {
  }
}
async function A1(t, e) {
  const n = R1(e), s = L1(t);
  if (!await s._isAvailable())
    return !1;
  const r = await s._get(n) === "true";
  return await s._remove(n), r;
}
function N1(t, e) {
  ea.set(t._key(), e);
}
function L1(t) {
  return Xt(t._redirectPersistence);
}
function R1(t) {
  return Zo(F1, t.config.apiKey, t.name);
}
async function x1(t, e, n = !1) {
  const s = Xn(t), r = S1(s, e), o = await new k1(s, r, n).execute();
  return o && !n && (delete o.user._redirectEventId, await s._persistUserIfCurrent(o.user), await s._setRedirectUser(null, e)), o;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const O1 = 10 * 60 * 1e3;
class P1 {
  constructor(e) {
    this.auth = e, this.cachedEventUids = /* @__PURE__ */ new Set(), this.consumers = /* @__PURE__ */ new Set(), this.queuedRedirectEvent = null, this.hasHandledPotentialRedirect = !1, this.lastProcessedEventTime = Date.now();
  }
  registerConsumer(e) {
    this.consumers.add(e), this.queuedRedirectEvent && this.isEventForConsumer(this.queuedRedirectEvent, e) && (this.sendToConsumer(this.queuedRedirectEvent, e), this.saveEventToCache(this.queuedRedirectEvent), this.queuedRedirectEvent = null);
  }
  unregisterConsumer(e) {
    this.consumers.delete(e);
  }
  onEvent(e) {
    if (this.hasEventBeenHandled(e))
      return !1;
    let n = !1;
    return this.consumers.forEach((s) => {
      this.isEventForConsumer(e, s) && (n = !0, this.sendToConsumer(e, s), this.saveEventToCache(e));
    }), this.hasHandledPotentialRedirect || !M1(e) || (this.hasHandledPotentialRedirect = !0, n || (this.queuedRedirectEvent = e, n = !0)), n;
  }
  sendToConsumer(e, n) {
    var s;
    if (e.error && !jg(e)) {
      const r = ((s = e.error.code) === null || s === void 0 ? void 0 : s.split("auth/")[1]) || "internal-error";
      n.onError(Dt(this.auth, r));
    } else
      n.onAuthEvent(e);
  }
  isEventForConsumer(e, n) {
    const s = n.eventId === null || !!e.eventId && e.eventId === n.eventId;
    return n.filter.includes(e.type) && s;
  }
  hasEventBeenHandled(e) {
    return Date.now() - this.lastProcessedEventTime >= O1 && this.cachedEventUids.clear(), this.cachedEventUids.has(Bp(e));
  }
  saveEventToCache(e) {
    this.cachedEventUids.add(Bp(e)), this.lastProcessedEventTime = Date.now();
  }
}
function Bp(t) {
  return [t.type, t.eventId, t.sessionId, t.tenantId].filter((e) => e).join("-");
}
function jg({ type: t, error: e }) {
  return t === "unknown" && (e == null ? void 0 : e.code) === "auth/no-auth-event";
}
function M1(t) {
  switch (t.type) {
    case "signInViaRedirect":
    case "linkViaRedirect":
    case "reauthViaRedirect":
      return !0;
    case "unknown":
      return jg(t);
    default:
      return !1;
  }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
async function D1(t, e = {}) {
  return gn(t, "GET", "/v1/projects", e);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const G1 = /^\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}$/, B1 = /^https?/;
async function $1(t) {
  if (t.config.emulator)
    return;
  const { authorizedDomains: e } = await D1(t);
  for (const n of e)
    try {
      if (V1(n))
        return;
    } catch {
    }
  Ct(
    t,
    "unauthorized-domain"
    /* AuthErrorCode.INVALID_ORIGIN */
  );
}
function V1(t) {
  const e = Wl(), { protocol: n, hostname: s } = new URL(e);
  if (t.startsWith("chrome-extension://")) {
    const o = new URL(t);
    return o.hostname === "" && s === "" ? n === "chrome-extension:" && t.replace("chrome-extension://", "") === e.replace("chrome-extension://", "") : n === "chrome-extension:" && o.hostname === s;
  }
  if (!B1.test(n))
    return !1;
  if (G1.test(t))
    return s === t;
  const r = t.replace(/\./g, "\\.");
  return new RegExp("^(.+\\." + r + "|" + r + ")$", "i").test(s);
}
/**
 * @license
 * Copyright 2020 Google LLC.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const U1 = new to(3e4, 6e4);
function $p() {
  const t = Gt().___jsl;
  if (t != null && t.H) {
    for (const e of Object.keys(t.H))
      if (t.H[e].r = t.H[e].r || [], t.H[e].L = t.H[e].L || [], t.H[e].r = [...t.H[e].L], t.CP)
        for (let n = 0; n < t.CP.length; n++)
          t.CP[n] = null;
  }
}
function H1(t) {
  return new Promise((e, n) => {
    var s, r, i;
    function o() {
      $p(), gapi.load("gapi.iframes", {
        callback: () => {
          e(gapi.iframes.getContext());
        },
        ontimeout: () => {
          $p(), n(Dt(
            t,
            "network-request-failed"
            /* AuthErrorCode.NETWORK_REQUEST_FAILED */
          ));
        },
        timeout: U1.get()
      });
    }
    if (!((r = (s = Gt().gapi) === null || s === void 0 ? void 0 : s.iframes) === null || r === void 0) && r.Iframe)
      e(gapi.iframes.getContext());
    else if (!((i = Gt().gapi) === null || i === void 0) && i.load)
      o();
    else {
      const a = xF("iframefcb");
      return Gt()[a] = () => {
        gapi.load ? o() : n(Dt(
          t,
          "network-request-failed"
          /* AuthErrorCode.NETWORK_REQUEST_FAILED */
        ));
      }, Cg(`https://apis.google.com/js/api.js?onload=${a}`).catch((c) => n(c));
    }
  }).catch((e) => {
    throw ta = null, e;
  });
}
let ta = null;
function j1(t) {
  return ta = ta || H1(t), ta;
}
/**
 * @license
 * Copyright 2020 Google LLC.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const W1 = new to(5e3, 15e3), z1 = "__/auth/iframe", q1 = "emulator/auth/iframe", Y1 = {
  style: {
    position: "absolute",
    top: "-100px",
    width: "1px",
    height: "1px"
  },
  "aria-hidden": "true",
  tabindex: "-1"
}, K1 = /* @__PURE__ */ new Map([
  ["identitytoolkit.googleapis.com", "p"],
  ["staging-identitytoolkit.sandbox.googleapis.com", "s"],
  ["test-identitytoolkit.sandbox.googleapis.com", "t"]
  // test
]);
function X1(t) {
  const e = t.config;
  G(
    e.authDomain,
    t,
    "auth-domain-config-required"
    /* AuthErrorCode.MISSING_AUTH_DOMAIN */
  );
  const n = e.emulator ? fu(e, q1) : `https://${t.config.authDomain}/${z1}`, s = {
    apiKey: e.apiKey,
    appName: t.name,
    v: Hr
  }, r = K1.get(t.config.apiHost);
  r && (s.eid = r);
  const i = t._getFrameworks();
  return i.length && (s.fw = i.join(",")), `${n}?${Ur(s).slice(1)}`;
}
async function J1(t) {
  const e = await j1(t), n = Gt().gapi;
  return G(
    n,
    t,
    "internal-error"
    /* AuthErrorCode.INTERNAL_ERROR */
  ), e.open({
    where: document.body,
    url: X1(t),
    messageHandlersFilter: n.iframes.CROSS_ORIGIN_IFRAMES_FILTER,
    attributes: Y1,
    dontclear: !0
  }, (s) => new Promise(async (r, i) => {
    await s.restyle({
      // Prevent iframe from closing on mouse out.
      setHideOnLeave: !1
    });
    const o = Dt(
      t,
      "network-request-failed"
      /* AuthErrorCode.NETWORK_REQUEST_FAILED */
    ), a = Gt().setTimeout(() => {
      i(o);
    }, W1.get());
    function c() {
      Gt().clearTimeout(a), r(s);
    }
    s.ping(c).then(c, () => {
      i(o);
    });
  }));
}
/**
 * @license
 * Copyright 2020 Google LLC.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const Q1 = {
  location: "yes",
  resizable: "yes",
  statusbar: "yes",
  toolbar: "no"
}, Z1 = 500, ek = 600, tk = "_blank", nk = "http://localhost";
class Vp {
  constructor(e) {
    this.window = e, this.associatedEvent = null;
  }
  close() {
    if (this.window)
      try {
        this.window.close();
      } catch {
      }
  }
}
function sk(t, e, n, s = Z1, r = ek) {
  const i = Math.max((window.screen.availHeight - r) / 2, 0).toString(), o = Math.max((window.screen.availWidth - s) / 2, 0).toString();
  let a = "";
  const c = Object.assign(Object.assign({}, Q1), {
    width: s.toString(),
    height: r.toString(),
    top: i,
    left: o
  }), l = $e().toLowerCase();
  n && (a = Eg(l) ? tk : n), yg(l) && (e = e || nk, c.scrollbars = "yes");
  const d = Object.entries(c).reduce((h, [p, f]) => `${h}${p}=${f},`, "");
  if (TF(l) && a !== "_self")
    return rk(e || "", a), new Vp(null);
  const u = window.open(e || "", a, d);
  G(
    u,
    t,
    "popup-blocked"
    /* AuthErrorCode.POPUP_BLOCKED */
  );
  try {
    u.focus();
  } catch {
  }
  return new Vp(u);
}
function rk(t, e) {
  const n = document.createElement("a");
  n.href = t, n.target = e;
  const s = document.createEvent("MouseEvent");
  s.initMouseEvent("click", !0, !0, window, 1, 0, 0, 0, 0, !1, !1, !1, !1, 1, null), n.dispatchEvent(s);
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const ik = "__/auth/handler", ok = "emulator/auth/handler", ak = encodeURIComponent("fac");
async function Up(t, e, n, s, r, i) {
  G(
    t.config.authDomain,
    t,
    "auth-domain-config-required"
    /* AuthErrorCode.MISSING_AUTH_DOMAIN */
  ), G(
    t.config.apiKey,
    t,
    "invalid-api-key"
    /* AuthErrorCode.INVALID_API_KEY */
  );
  const o = {
    apiKey: t.config.apiKey,
    appName: t.name,
    authType: n,
    redirectUrl: s,
    v: Hr,
    eventId: r
  };
  if (e instanceof Ag) {
    e.setDefaultLanguage(t.languageCode), o.providerId = e.providerId || "", Bl(e.getCustomParameters()) || (o.customParameters = JSON.stringify(e.getCustomParameters()));
    for (const [d, u] of Object.entries({}))
      o[d] = u;
  }
  if (e instanceof so) {
    const d = e.getScopes().filter((u) => u !== "");
    d.length > 0 && (o.scopes = d.join(","));
  }
  t.tenantId && (o.tid = t.tenantId);
  const a = o;
  for (const d of Object.keys(a))
    a[d] === void 0 && delete a[d];
  const c = await t._getAppCheckToken(), l = c ? `#${ak}=${encodeURIComponent(c)}` : "";
  return `${ck(t)}?${Ur(a).slice(1)}${l}`;
}
function ck({ config: t }) {
  return t.emulator ? fu(t, ok) : `https://${t.authDomain}/${ik}`;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const ll = "webStorageSupport";
class lk {
  constructor() {
    this.eventManagers = {}, this.iframes = {}, this.originValidationPromises = {}, this._redirectPersistence = Gg, this._completeRedirectFn = x1, this._overrideRedirectResult = N1;
  }
  // Wrapping in async even though we don't await anywhere in order
  // to make sure errors are raised as promise rejections
  async _openPopup(e, n, s, r) {
    var i;
    an((i = this.eventManagers[e._key()]) === null || i === void 0 ? void 0 : i.manager, "_initialize() not called before _openPopup()");
    const o = await Up(e, n, s, Wl(), r);
    return sk(e, o, Eu());
  }
  async _openRedirect(e, n, s, r) {
    await this._originValidation(e);
    const i = await Up(e, n, s, Wl(), r);
    return h1(i), new Promise(() => {
    });
  }
  _initialize(e) {
    const n = e._key();
    if (this.eventManagers[n]) {
      const { manager: r, promise: i } = this.eventManagers[n];
      return r ? Promise.resolve(r) : (an(i, "If manager is not set, promise should be"), i);
    }
    const s = this.initAndGetManager(e);
    return this.eventManagers[n] = { promise: s }, s.catch(() => {
      delete this.eventManagers[n];
    }), s;
  }
  async initAndGetManager(e) {
    const n = await J1(e), s = new P1(e);
    return n.register("authEvent", (r) => (G(
      r == null ? void 0 : r.authEvent,
      e,
      "invalid-auth-event"
      /* AuthErrorCode.INVALID_AUTH_EVENT */
    ), {
      status: s.onEvent(r.authEvent) ? "ACK" : "ERROR"
      /* GapiOutcome.ERROR */
    }), gapi.iframes.CROSS_ORIGIN_IFRAMES_FILTER), this.eventManagers[e._key()] = { manager: s }, this.iframes[e._key()] = n, s;
  }
  _isIframeWebStorageSupported(e, n) {
    this.iframes[e._key()].send(ll, { type: ll }, (r) => {
      var i;
      const o = (i = r == null ? void 0 : r[0]) === null || i === void 0 ? void 0 : i[ll];
      o !== void 0 && n(!!o), Ct(
        e,
        "internal-error"
        /* AuthErrorCode.INTERNAL_ERROR */
      );
    }, gapi.iframes.CROSS_ORIGIN_IFRAMES_FILTER);
  }
  _originValidation(e) {
    const n = e._key();
    return this.originValidationPromises[n] || (this.originValidationPromises[n] = $1(e)), this.originValidationPromises[n];
  }
  get _shouldInitProactively() {
    return Tg() || gu() || fc();
  }
}
const dk = lk;
var Hp = "@firebase/auth", jp = "1.5.1";
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class uk {
  constructor(e) {
    this.auth = e, this.internalListeners = /* @__PURE__ */ new Map();
  }
  getUid() {
    var e;
    return this.assertAuthConfigured(), ((e = this.auth.currentUser) === null || e === void 0 ? void 0 : e.uid) || null;
  }
  async getToken(e) {
    return this.assertAuthConfigured(), await this.auth._initializationPromise, this.auth.currentUser ? { accessToken: await this.auth.currentUser.getIdToken(e) } : null;
  }
  addAuthTokenListener(e) {
    if (this.assertAuthConfigured(), this.internalListeners.has(e))
      return;
    const n = this.auth.onIdTokenChanged((s) => {
      e((s == null ? void 0 : s.stsTokenManager.accessToken) || null);
    });
    this.internalListeners.set(e, n), this.updateProactiveRefresh();
  }
  removeAuthTokenListener(e) {
    this.assertAuthConfigured();
    const n = this.internalListeners.get(e);
    n && (this.internalListeners.delete(e), n(), this.updateProactiveRefresh());
  }
  assertAuthConfigured() {
    G(
      this.auth._initializationPromise,
      "dependent-sdk-initialized-before-auth"
      /* AuthErrorCode.DEPENDENT_SDK_INIT_BEFORE_AUTH */
    );
  }
  updateProactiveRefresh() {
    this.internalListeners.size > 0 ? this.auth._startProactiveRefresh() : this.auth._stopProactiveRefresh();
  }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function hk(t) {
  switch (t) {
    case "Node":
      return "node";
    case "ReactNative":
      return "rn";
    case "Worker":
      return "webworker";
    case "Cordova":
      return "cordova";
    default:
      return;
  }
}
function pk(t) {
  vr(new ys(
    "auth",
    (e, { options: n }) => {
      const s = e.getProvider("app").getImmediate(), r = e.getProvider("heartbeat"), i = e.getProvider("app-check-internal"), { apiKey: o, authDomain: a } = s.options;
      G(o && !o.includes(":"), "invalid-api-key", { appName: s.name });
      const c = {
        apiKey: o,
        authDomain: a,
        clientPlatform: t,
        apiHost: "identitytoolkit.googleapis.com",
        tokenApiHost: "securetoken.googleapis.com",
        apiScheme: "https",
        sdkClientVersion: Ig(t)
      }, l = new LF(s, r, i, c);
      return BF(l, n), l;
    },
    "PUBLIC"
    /* ComponentType.PUBLIC */
  ).setInstantiationMode(
    "EXPLICIT"
    /* InstantiationMode.EXPLICIT */
  ).setInstanceCreatedCallback((e, n, s) => {
    e.getProvider(
      "auth-internal"
      /* _ComponentName.AUTH_INTERNAL */
    ).initialize();
  })), vr(new ys(
    "auth-internal",
    (e) => {
      const n = Xn(e.getProvider(
        "auth"
        /* _ComponentName.AUTH */
      ).getImmediate());
      return ((s) => new uk(s))(n);
    },
    "PRIVATE"
    /* ComponentType.PRIVATE */
  ).setInstantiationMode(
    "EXPLICIT"
    /* InstantiationMode.EXPLICIT */
  )), xn(Hp, jp, hk(t)), xn(Hp, jp, "esm2017");
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const fk = 5 * 60, mk = ng("authIdTokenMaxAge") || fk;
let Wp = null;
const gk = (t) => async (e) => {
  const n = e && await e.getIdTokenResult(), s = n && ((/* @__PURE__ */ new Date()).getTime() - Date.parse(n.issuedAtTime)) / 1e3;
  if (s && s > mk)
    return;
  const r = n == null ? void 0 : n.token;
  Wp !== r && (Wp = r, await fetch(t, {
    method: r ? "POST" : "DELETE",
    headers: r ? {
      Authorization: `Bearer ${r}`
    } : {}
  }));
};
function Be(t = cg()) {
  const e = du(t, "auth");
  if (e.isInitialized())
    return e.getImmediate();
  const n = GF(t, {
    popupRedirectResolver: dk,
    persistence: [
      v1,
      Mg,
      Gg
    ]
  }), s = ng("authTokenSyncURL");
  if (s) {
    const i = gk(s);
    o1(n, i, () => i(n.currentUser)), i1(n, (o) => i(o));
  }
  const r = eg("auth");
  return r && $F(n, `http://${r}`), n;
}
pk(
  "Browser"
  /* ClientPlatform.BROWSER */
);
const zp = "@firebase/database", qp = "1.0.2";
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
let Wg = "";
function _k(t) {
  Wg = t;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class yk {
  /**
   * @param domStorage_ - The underlying storage object (e.g. localStorage or sessionStorage)
   */
  constructor(e) {
    this.domStorage_ = e, this.prefix_ = "firebase:";
  }
  /**
   * @param key - The key to save the value under
   * @param value - The value being stored, or null to remove the key.
   */
  set(e, n) {
    n == null ? this.domStorage_.removeItem(this.prefixedName_(e)) : this.domStorage_.setItem(this.prefixedName_(e), Ie(n));
  }
  /**
   * @returns The value that was stored under this key, or null
   */
  get(e) {
    const n = this.domStorage_.getItem(this.prefixedName_(e));
    return n == null ? null : Fi(n);
  }
  remove(e) {
    this.domStorage_.removeItem(this.prefixedName_(e));
  }
  prefixedName_(e) {
    return this.prefix_ + e;
  }
  toString() {
    return this.domStorage_.toString();
  }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class Ek {
  constructor() {
    this.cache_ = {}, this.isInMemoryStorage = !0;
  }
  set(e, n) {
    n == null ? delete this.cache_[e] : this.cache_[e] = n;
  }
  get(e) {
    return $t(this.cache_, e) ? this.cache_[e] : null;
  }
  remove(e) {
    delete this.cache_[e];
  }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const zg = function(t) {
  try {
    if (typeof window < "u" && typeof window[t] < "u") {
      const e = window[t];
      return e.setItem("firebase:sentinel", "cache"), e.removeItem("firebase:sentinel"), new yk(e);
    }
  } catch {
  }
  return new Ek();
}, as = zg("localStorage"), bk = zg("sessionStorage");
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const ur = new cu("@firebase/database"), vk = /* @__PURE__ */ function() {
  let t = 1;
  return function() {
    return t++;
  };
}(), qg = function(t) {
  const e = KI(t), n = new WI();
  n.update(e);
  const s = n.digest();
  return iu.encodeByteArray(s);
}, io = function(...t) {
  let e = "";
  for (let n = 0; n < t.length; n++) {
    const s = t[n];
    Array.isArray(s) || s && typeof s == "object" && // eslint-disable-next-line @typescript-eslint/no-explicit-any
    typeof s.length == "number" ? e += io.apply(null, s) : typeof s == "object" ? e += Ie(s) : e += s, e += " ";
  }
  return e;
};
let gi = null, Yp = !0;
const Sk = function(t, e) {
  S(!e, "Can't turn on custom loggers persistently."), ur.logLevel = ie.VERBOSE, gi = ur.log.bind(ur);
}, Oe = function(...t) {
  if (Yp === !0 && (Yp = !1, gi === null && bk.get("logging_enabled") === !0 && Sk()), gi) {
    const e = io.apply(null, t);
    gi(e);
  }
}, oo = function(t) {
  return function(...e) {
    Oe(t, ...e);
  };
}, ql = function(...t) {
  const e = "FIREBASE INTERNAL ERROR: " + io(...t);
  ur.error(e);
}, cn = function(...t) {
  const e = `FIREBASE FATAL ERROR: ${io(...t)}`;
  throw ur.error(e), new Error(e);
}, ze = function(...t) {
  const e = "FIREBASE WARNING: " + io(...t);
  ur.warn(e);
}, wk = function() {
  typeof window < "u" && window.location && window.location.protocol && window.location.protocol.indexOf("https:") !== -1 && ze("Insecure Firebase access from a secure page. Please use https in calls to new Firebase().");
}, vu = function(t) {
  return typeof t == "number" && (t !== t || // NaN
  t === Number.POSITIVE_INFINITY || t === Number.NEGATIVE_INFINITY);
}, Tk = function(t) {
  if (document.readyState === "complete")
    t();
  else {
    let e = !1;
    const n = function() {
      if (!document.body) {
        setTimeout(n, Math.floor(10));
        return;
      }
      e || (e = !0, t());
    };
    document.addEventListener ? (document.addEventListener("DOMContentLoaded", n, !1), window.addEventListener("load", n, !1)) : document.attachEvent && (document.attachEvent("onreadystatechange", () => {
      document.readyState === "complete" && n();
    }), window.attachEvent("onload", n));
  }
}, Sr = "[MIN_NAME]", Ss = "[MAX_NAME]", Rs = function(t, e) {
  if (t === e)
    return 0;
  if (t === Sr || e === Ss)
    return -1;
  if (e === Sr || t === Ss)
    return 1;
  {
    const n = Kp(t), s = Kp(e);
    return n !== null ? s !== null ? n - s === 0 ? t.length - e.length : n - s : -1 : s !== null ? 1 : t < e ? -1 : 1;
  }
}, Ik = function(t, e) {
  return t === e ? 0 : t < e ? -1 : 1;
}, ri = function(t, e) {
  if (e && t in e)
    return e[t];
  throw new Error("Missing required key (" + t + ") in object: " + Ie(e));
}, Su = function(t) {
  if (typeof t != "object" || t === null)
    return Ie(t);
  const e = [];
  for (const s in t)
    e.push(s);
  e.sort();
  let n = "{";
  for (let s = 0; s < e.length; s++)
    s !== 0 && (n += ","), n += Ie(e[s]), n += ":", n += Su(t[e[s]]);
  return n += "}", n;
}, Yg = function(t, e) {
  const n = t.length;
  if (n <= e)
    return [t];
  const s = [];
  for (let r = 0; r < n; r += e)
    r + e > n ? s.push(t.substring(r, n)) : s.push(t.substring(r, r + e));
  return s;
};
function Me(t, e) {
  for (const n in t)
    t.hasOwnProperty(n) && e(n, t[n]);
}
const Kg = function(t) {
  S(!vu(t), "Invalid JSON number");
  const e = 11, n = 52, s = (1 << e - 1) - 1;
  let r, i, o, a, c;
  t === 0 ? (i = 0, o = 0, r = 1 / t === -1 / 0 ? 1 : 0) : (r = t < 0, t = Math.abs(t), t >= Math.pow(2, 1 - s) ? (a = Math.min(Math.floor(Math.log(t) / Math.LN2), s), i = a + s, o = Math.round(t * Math.pow(2, n - a) - Math.pow(2, n))) : (i = 0, o = Math.round(t / Math.pow(2, 1 - s - n))));
  const l = [];
  for (c = n; c; c -= 1)
    l.push(o % 2 ? 1 : 0), o = Math.floor(o / 2);
  for (c = e; c; c -= 1)
    l.push(i % 2 ? 1 : 0), i = Math.floor(i / 2);
  l.push(r ? 1 : 0), l.reverse();
  const d = l.join("");
  let u = "";
  for (c = 0; c < 64; c += 8) {
    let h = parseInt(d.substr(c, 8), 2).toString(16);
    h.length === 1 && (h = "0" + h), u = u + h;
  }
  return u.toLowerCase();
}, Ck = function() {
  return !!(typeof window == "object" && window.chrome && window.chrome.extension && !/^chrome/.test(window.location.href));
}, Fk = function() {
  return typeof Windows == "object" && typeof Windows.UI == "object";
};
function kk(t, e) {
  let n = "Unknown Error";
  t === "too_big" ? n = "The data requested exceeds the maximum size that can be accessed with a single request." : t === "permission_denied" ? n = "Client doesn't have permission to access the desired data." : t === "unavailable" && (n = "The service is unavailable");
  const s = new Error(t + " at " + e._path.toString() + ": " + n);
  return s.code = t.toUpperCase(), s;
}
const Ak = new RegExp("^-?(0*)\\d{1,10}$"), Nk = -2147483648, Lk = 2147483647, Kp = function(t) {
  if (Ak.test(t)) {
    const e = Number(t);
    if (e >= Nk && e <= Lk)
      return e;
  }
  return null;
}, Wr = function(t) {
  try {
    t();
  } catch (e) {
    setTimeout(() => {
      const n = e.stack || "";
      throw ze("Exception was thrown by user callback.", n), e;
    }, Math.floor(0));
  }
}, Rk = function() {
  return (typeof window == "object" && window.navigator && window.navigator.userAgent || "").search(/googlebot|google webmaster tools|bingbot|yahoo! slurp|baiduspider|yandexbot|duckduckbot/i) >= 0;
}, _i = function(t, e) {
  const n = setTimeout(t, e);
  return typeof n == "number" && // @ts-ignore Is only defined in Deno environments.
  typeof Deno < "u" && // @ts-ignore Deno and unrefTimer are only defined in Deno environments.
  Deno.unrefTimer ? Deno.unrefTimer(n) : typeof n == "object" && n.unref && n.unref(), n;
};
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class xk {
  constructor(e, n) {
    this.appName_ = e, this.appCheckProvider = n, this.appCheck = n == null ? void 0 : n.getImmediate({ optional: !0 }), this.appCheck || n == null || n.get().then((s) => this.appCheck = s);
  }
  getToken(e) {
    return this.appCheck ? this.appCheck.getToken(e) : new Promise((n, s) => {
      setTimeout(() => {
        this.appCheck ? this.getToken(e).then(n, s) : n(null);
      }, 0);
    });
  }
  addTokenChangeListener(e) {
    var n;
    (n = this.appCheckProvider) === null || n === void 0 || n.get().then((s) => s.addTokenListener(e));
  }
  notifyForInvalidToken() {
    ze(`Provided AppCheck credentials for the app named "${this.appName_}" are invalid. This usually indicates your app was not initialized correctly.`);
  }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class Ok {
  constructor(e, n, s) {
    this.appName_ = e, this.firebaseOptions_ = n, this.authProvider_ = s, this.auth_ = null, this.auth_ = s.getImmediate({ optional: !0 }), this.auth_ || s.onInit((r) => this.auth_ = r);
  }
  getToken(e) {
    return this.auth_ ? this.auth_.getToken(e).catch((n) => n && n.code === "auth/token-not-initialized" ? (Oe("Got auth/token-not-initialized error.  Treating as null token."), null) : Promise.reject(n)) : new Promise((n, s) => {
      setTimeout(() => {
        this.auth_ ? this.getToken(e).then(n, s) : n(null);
      }, 0);
    });
  }
  addTokenChangeListener(e) {
    this.auth_ ? this.auth_.addAuthTokenListener(e) : this.authProvider_.get().then((n) => n.addAuthTokenListener(e));
  }
  removeTokenChangeListener(e) {
    this.authProvider_.get().then((n) => n.removeAuthTokenListener(e));
  }
  notifyForInvalidToken() {
    let e = 'Provided authentication credentials for the app named "' + this.appName_ + '" are invalid. This usually indicates your app was not initialized correctly. ';
    "credential" in this.firebaseOptions_ ? e += 'Make sure the "credential" property provided to initializeApp() is authorized to access the specified "databaseURL" and is from the correct project.' : "serviceAccount" in this.firebaseOptions_ ? e += 'Make sure the "serviceAccount" property provided to initializeApp() is authorized to access the specified "databaseURL" and is from the correct project.' : e += 'Make sure the "apiKey" and "databaseURL" properties provided to initializeApp() match the values provided for your app at https://console.firebase.google.com/.', ze(e);
  }
}
class na {
  constructor(e) {
    this.accessToken = e;
  }
  getToken(e) {
    return Promise.resolve({
      accessToken: this.accessToken
    });
  }
  addTokenChangeListener(e) {
    e(this.accessToken);
  }
  removeTokenChangeListener(e) {
  }
  notifyForInvalidToken() {
  }
}
na.OWNER = "owner";
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const wu = "5", Xg = "v", Jg = "s", Qg = "r", Zg = "f", e_ = /(console\.firebase|firebase-console-\w+\.corp|firebase\.corp)\.google\.com/, t_ = "ls", n_ = "p", Yl = "ac", s_ = "websocket", r_ = "long_polling";
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class i_ {
  /**
   * @param host - Hostname portion of the url for the repo
   * @param secure - Whether or not this repo is accessed over ssl
   * @param namespace - The namespace represented by the repo
   * @param webSocketOnly - Whether to prefer websockets over all other transports (used by Nest).
   * @param nodeAdmin - Whether this instance uses Admin SDK credentials
   * @param persistenceKey - Override the default session persistence storage key
   */
  constructor(e, n, s, r, i = !1, o = "", a = !1, c = !1) {
    this.secure = n, this.namespace = s, this.webSocketOnly = r, this.nodeAdmin = i, this.persistenceKey = o, this.includeNamespaceInQueryParams = a, this.isUsingEmulator = c, this._host = e.toLowerCase(), this._domain = this._host.substr(this._host.indexOf(".") + 1), this.internalHost = as.get("host:" + e) || this._host;
  }
  isCacheableHost() {
    return this.internalHost.substr(0, 2) === "s-";
  }
  isCustomHost() {
    return this._domain !== "firebaseio.com" && this._domain !== "firebaseio-demo.com";
  }
  get host() {
    return this._host;
  }
  set host(e) {
    e !== this.internalHost && (this.internalHost = e, this.isCacheableHost() && as.set("host:" + this._host, this.internalHost));
  }
  toString() {
    let e = this.toURLString();
    return this.persistenceKey && (e += "<" + this.persistenceKey + ">"), e;
  }
  toURLString() {
    const e = this.secure ? "https://" : "http://", n = this.includeNamespaceInQueryParams ? `?ns=${this.namespace}` : "";
    return `${e}${this.host}/${n}`;
  }
}
function Pk(t) {
  return t.host !== t.internalHost || t.isCustomHost() || t.includeNamespaceInQueryParams;
}
function o_(t, e, n) {
  S(typeof e == "string", "typeof type must == string"), S(typeof n == "object", "typeof params must == object");
  let s;
  if (e === s_)
    s = (t.secure ? "wss://" : "ws://") + t.internalHost + "/.ws?";
  else if (e === r_)
    s = (t.secure ? "https://" : "http://") + t.internalHost + "/.lp?";
  else
    throw new Error("Unknown connection type: " + e);
  Pk(t) && (n.ns = t.namespace);
  const r = [];
  return Me(n, (i, o) => {
    r.push(i + "=" + o);
  }), s + r.join("&");
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class Mk {
  constructor() {
    this.counters_ = {};
  }
  incrementCounter(e, n = 1) {
    $t(this.counters_, e) || (this.counters_[e] = 0), this.counters_[e] += n;
  }
  get() {
    return kI(this.counters_);
  }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const dl = {}, ul = {};
function Tu(t) {
  const e = t.toString();
  return dl[e] || (dl[e] = new Mk()), dl[e];
}
function Dk(t, e) {
  const n = t.toString();
  return ul[n] || (ul[n] = e()), ul[n];
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class Gk {
  /**
   * @param onMessage_
   */
  constructor(e) {
    this.onMessage_ = e, this.pendingResponses = [], this.currentResponseNum = 0, this.closeAfterResponse = -1, this.onClose = null;
  }
  closeAfter(e, n) {
    this.closeAfterResponse = e, this.onClose = n, this.closeAfterResponse < this.currentResponseNum && (this.onClose(), this.onClose = null);
  }
  /**
   * Each message from the server comes with a response number, and an array of data. The responseNumber
   * allows us to ensure that we process them in the right order, since we can't be guaranteed that all
   * browsers will respond in the same order as the requests we sent
   */
  handleResponse(e, n) {
    for (this.pendingResponses[e] = n; this.pendingResponses[this.currentResponseNum]; ) {
      const s = this.pendingResponses[this.currentResponseNum];
      delete this.pendingResponses[this.currentResponseNum];
      for (let r = 0; r < s.length; ++r)
        s[r] && Wr(() => {
          this.onMessage_(s[r]);
        });
      if (this.currentResponseNum === this.closeAfterResponse) {
        this.onClose && (this.onClose(), this.onClose = null);
        break;
      }
      this.currentResponseNum++;
    }
  }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const Xp = "start", Bk = "close", $k = "pLPCommand", Vk = "pRTLPCB", a_ = "id", c_ = "pw", l_ = "ser", Uk = "cb", Hk = "seg", jk = "ts", Wk = "d", zk = "dframe", d_ = 1870, u_ = 30, qk = d_ - u_, Yk = 25e3, Kk = 3e4;
class rr {
  /**
   * @param connId An identifier for this connection, used for logging
   * @param repoInfo The info for the endpoint to send data to.
   * @param applicationId The Firebase App ID for this project.
   * @param appCheckToken The AppCheck token for this client.
   * @param authToken The AuthToken to use for this connection.
   * @param transportSessionId Optional transportSessionid if we are
   * reconnecting for an existing transport session
   * @param lastSessionId Optional lastSessionId if the PersistentConnection has
   * already created a connection previously
   */
  constructor(e, n, s, r, i, o, a) {
    this.connId = e, this.repoInfo = n, this.applicationId = s, this.appCheckToken = r, this.authToken = i, this.transportSessionId = o, this.lastSessionId = a, this.bytesSent = 0, this.bytesReceived = 0, this.everConnected_ = !1, this.log_ = oo(e), this.stats_ = Tu(n), this.urlFn = (c) => (this.appCheckToken && (c[Yl] = this.appCheckToken), o_(n, r_, c));
  }
  /**
   * @param onMessage - Callback when messages arrive
   * @param onDisconnect - Callback with connection lost.
   */
  open(e, n) {
    this.curSegmentNum = 0, this.onDisconnect_ = n, this.myPacketOrderer = new Gk(e), this.isClosed_ = !1, this.connectTimeoutTimer_ = setTimeout(() => {
      this.log_("Timed out trying to connect."), this.onClosed_(), this.connectTimeoutTimer_ = null;
    }, Math.floor(Kk)), Tk(() => {
      if (this.isClosed_)
        return;
      this.scriptTagHolder = new Iu((...i) => {
        const [o, a, c, l, d] = i;
        if (this.incrementIncomingBytes_(i), !!this.scriptTagHolder)
          if (this.connectTimeoutTimer_ && (clearTimeout(this.connectTimeoutTimer_), this.connectTimeoutTimer_ = null), this.everConnected_ = !0, o === Xp)
            this.id = a, this.password = c;
          else if (o === Bk)
            a ? (this.scriptTagHolder.sendNewPolls = !1, this.myPacketOrderer.closeAfter(a, () => {
              this.onClosed_();
            })) : this.onClosed_();
          else
            throw new Error("Unrecognized command received: " + o);
      }, (...i) => {
        const [o, a] = i;
        this.incrementIncomingBytes_(i), this.myPacketOrderer.handleResponse(o, a);
      }, () => {
        this.onClosed_();
      }, this.urlFn);
      const s = {};
      s[Xp] = "t", s[l_] = Math.floor(Math.random() * 1e8), this.scriptTagHolder.uniqueCallbackIdentifier && (s[Uk] = this.scriptTagHolder.uniqueCallbackIdentifier), s[Xg] = wu, this.transportSessionId && (s[Jg] = this.transportSessionId), this.lastSessionId && (s[t_] = this.lastSessionId), this.applicationId && (s[n_] = this.applicationId), this.appCheckToken && (s[Yl] = this.appCheckToken), typeof location < "u" && location.hostname && e_.test(location.hostname) && (s[Qg] = Zg);
      const r = this.urlFn(s);
      this.log_("Connecting via long-poll to " + r), this.scriptTagHolder.addTag(r, () => {
      });
    });
  }
  /**
   * Call this when a handshake has completed successfully and we want to consider the connection established
   */
  start() {
    this.scriptTagHolder.startLongPoll(this.id, this.password), this.addDisconnectPingFrame(this.id, this.password);
  }
  /**
   * Forces long polling to be considered as a potential transport
   */
  static forceAllow() {
    rr.forceAllow_ = !0;
  }
  /**
   * Forces longpolling to not be considered as a potential transport
   */
  static forceDisallow() {
    rr.forceDisallow_ = !0;
  }
  // Static method, use string literal so it can be accessed in a generic way
  static isAvailable() {
    return rr.forceAllow_ ? !0 : !rr.forceDisallow_ && typeof document < "u" && document.createElement != null && !Ck() && !Fk();
  }
  /**
   * No-op for polling
   */
  markConnectionHealthy() {
  }
  /**
   * Stops polling and cleans up the iframe
   */
  shutdown_() {
    this.isClosed_ = !0, this.scriptTagHolder && (this.scriptTagHolder.close(), this.scriptTagHolder = null), this.myDisconnFrame && (document.body.removeChild(this.myDisconnFrame), this.myDisconnFrame = null), this.connectTimeoutTimer_ && (clearTimeout(this.connectTimeoutTimer_), this.connectTimeoutTimer_ = null);
  }
  /**
   * Triggered when this transport is closed
   */
  onClosed_() {
    this.isClosed_ || (this.log_("Longpoll is closing itself"), this.shutdown_(), this.onDisconnect_ && (this.onDisconnect_(this.everConnected_), this.onDisconnect_ = null));
  }
  /**
   * External-facing close handler. RealTime has requested we shut down. Kill our connection and tell the server
   * that we've left.
   */
  close() {
    this.isClosed_ || (this.log_("Longpoll is being closed."), this.shutdown_());
  }
  /**
   * Send the JSON object down to the server. It will need to be stringified, base64 encoded, and then
   * broken into chunks (since URLs have a small maximum length).
   * @param data - The JSON data to transmit.
   */
  send(e) {
    const n = Ie(e);
    this.bytesSent += n.length, this.stats_.incrementCounter("bytes_sent", n.length);
    const s = Q0(n), r = Yg(s, qk);
    for (let i = 0; i < r.length; i++)
      this.scriptTagHolder.enqueueSegment(this.curSegmentNum, r.length, r[i]), this.curSegmentNum++;
  }
  /**
   * This is how we notify the server that we're leaving.
   * We aren't able to send requests with DHTML on a window close event, but we can
   * trigger XHR requests in some browsers (everything but Opera basically).
   */
  addDisconnectPingFrame(e, n) {
    this.myDisconnFrame = document.createElement("iframe");
    const s = {};
    s[zk] = "t", s[a_] = e, s[c_] = n, this.myDisconnFrame.src = this.urlFn(s), this.myDisconnFrame.style.display = "none", document.body.appendChild(this.myDisconnFrame);
  }
  /**
   * Used to track the bytes received by this client
   */
  incrementIncomingBytes_(e) {
    const n = Ie(e).length;
    this.bytesReceived += n, this.stats_.incrementCounter("bytes_received", n);
  }
}
class Iu {
  /**
   * @param commandCB - The callback to be called when control commands are recevied from the server.
   * @param onMessageCB - The callback to be triggered when responses arrive from the server.
   * @param onDisconnect - The callback to be triggered when this tag holder is closed
   * @param urlFn - A function that provides the URL of the endpoint to send data to.
   */
  constructor(e, n, s, r) {
    this.onDisconnect = s, this.urlFn = r, this.outstandingRequests = /* @__PURE__ */ new Set(), this.pendingSegs = [], this.currentSerial = Math.floor(Math.random() * 1e8), this.sendNewPolls = !0;
    {
      this.uniqueCallbackIdentifier = vk(), window[$k + this.uniqueCallbackIdentifier] = e, window[Vk + this.uniqueCallbackIdentifier] = n, this.myIFrame = Iu.createIFrame_();
      let i = "";
      this.myIFrame.src && this.myIFrame.src.substr(0, 11) === "javascript:" && (i = '<script>document.domain="' + document.domain + '";<\/script>');
      const o = "<html><body>" + i + "</body></html>";
      try {
        this.myIFrame.doc.open(), this.myIFrame.doc.write(o), this.myIFrame.doc.close();
      } catch (a) {
        Oe("frame writing exception"), a.stack && Oe(a.stack), Oe(a);
      }
    }
  }
  /**
   * Each browser has its own funny way to handle iframes. Here we mush them all together into one object that I can
   * actually use.
   */
  static createIFrame_() {
    const e = document.createElement("iframe");
    if (e.style.display = "none", document.body) {
      document.body.appendChild(e);
      try {
        e.contentWindow.document || Oe("No IE domain setting required");
      } catch {
        const s = document.domain;
        e.src = "javascript:void((function(){document.open();document.domain='" + s + "';document.close();})())";
      }
    } else
      throw "Document body has not initialized. Wait to initialize Firebase until after the document is ready.";
    return e.contentDocument ? e.doc = e.contentDocument : e.contentWindow ? e.doc = e.contentWindow.document : e.document && (e.doc = e.document), e;
  }
  /**
   * Cancel all outstanding queries and remove the frame.
   */
  close() {
    this.alive = !1, this.myIFrame && (this.myIFrame.doc.body.textContent = "", setTimeout(() => {
      this.myIFrame !== null && (document.body.removeChild(this.myIFrame), this.myIFrame = null);
    }, Math.floor(0)));
    const e = this.onDisconnect;
    e && (this.onDisconnect = null, e());
  }
  /**
   * Actually start the long-polling session by adding the first script tag(s) to the iframe.
   * @param id - The ID of this connection
   * @param pw - The password for this connection
   */
  startLongPoll(e, n) {
    for (this.myID = e, this.myPW = n, this.alive = !0; this.newRequest_(); )
      ;
  }
  /**
   * This is called any time someone might want a script tag to be added. It adds a script tag when there aren't
   * too many outstanding requests and we are still alive.
   *
   * If there are outstanding packet segments to send, it sends one. If there aren't, it sends a long-poll anyways if
   * needed.
   */
  newRequest_() {
    if (this.alive && this.sendNewPolls && this.outstandingRequests.size < (this.pendingSegs.length > 0 ? 2 : 1)) {
      this.currentSerial++;
      const e = {};
      e[a_] = this.myID, e[c_] = this.myPW, e[l_] = this.currentSerial;
      let n = this.urlFn(e), s = "", r = 0;
      for (; this.pendingSegs.length > 0 && this.pendingSegs[0].d.length + u_ + s.length <= d_; ) {
        const o = this.pendingSegs.shift();
        s = s + "&" + Hk + r + "=" + o.seg + "&" + jk + r + "=" + o.ts + "&" + Wk + r + "=" + o.d, r++;
      }
      return n = n + s, this.addLongPollTag_(n, this.currentSerial), !0;
    } else
      return !1;
  }
  /**
   * Queue a packet for transmission to the server.
   * @param segnum - A sequential id for this packet segment used for reassembly
   * @param totalsegs - The total number of segments in this packet
   * @param data - The data for this segment.
   */
  enqueueSegment(e, n, s) {
    this.pendingSegs.push({ seg: e, ts: n, d: s }), this.alive && this.newRequest_();
  }
  /**
   * Add a script tag for a regular long-poll request.
   * @param url - The URL of the script tag.
   * @param serial - The serial number of the request.
   */
  addLongPollTag_(e, n) {
    this.outstandingRequests.add(n);
    const s = () => {
      this.outstandingRequests.delete(n), this.newRequest_();
    }, r = setTimeout(s, Math.floor(Yk)), i = () => {
      clearTimeout(r), s();
    };
    this.addTag(e, i);
  }
  /**
   * Add an arbitrary script tag to the iframe.
   * @param url - The URL for the script tag source.
   * @param loadCB - A callback to be triggered once the script has loaded.
   */
  addTag(e, n) {
    setTimeout(() => {
      try {
        if (!this.sendNewPolls)
          return;
        const s = this.myIFrame.doc.createElement("script");
        s.type = "text/javascript", s.async = !0, s.src = e, s.onload = s.onreadystatechange = function() {
          const r = s.readyState;
          (!r || r === "loaded" || r === "complete") && (s.onload = s.onreadystatechange = null, s.parentNode && s.parentNode.removeChild(s), n());
        }, s.onerror = () => {
          Oe("Long-poll script failed to load: " + e), this.sendNewPolls = !1, this.close();
        }, this.myIFrame.doc.body.appendChild(s);
      } catch {
      }
    }, Math.floor(1));
  }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const Xk = 16384, Jk = 45e3;
let Ca = null;
typeof MozWebSocket < "u" ? Ca = MozWebSocket : typeof WebSocket < "u" && (Ca = WebSocket);
class wt {
  /**
   * @param connId identifier for this transport
   * @param repoInfo The info for the websocket endpoint.
   * @param applicationId The Firebase App ID for this project.
   * @param appCheckToken The App Check Token for this client.
   * @param authToken The Auth Token for this client.
   * @param transportSessionId Optional transportSessionId if this is connecting
   * to an existing transport session
   * @param lastSessionId Optional lastSessionId if there was a previous
   * connection
   */
  constructor(e, n, s, r, i, o, a) {
    this.connId = e, this.applicationId = s, this.appCheckToken = r, this.authToken = i, this.keepaliveTimer = null, this.frames = null, this.totalFrames = 0, this.bytesSent = 0, this.bytesReceived = 0, this.log_ = oo(this.connId), this.stats_ = Tu(n), this.connURL = wt.connectionURL_(n, o, a, r, s), this.nodeAdmin = n.nodeAdmin;
  }
  /**
   * @param repoInfo - The info for the websocket endpoint.
   * @param transportSessionId - Optional transportSessionId if this is connecting to an existing transport
   *                                         session
   * @param lastSessionId - Optional lastSessionId if there was a previous connection
   * @returns connection url
   */
  static connectionURL_(e, n, s, r, i) {
    const o = {};
    return o[Xg] = wu, typeof location < "u" && location.hostname && e_.test(location.hostname) && (o[Qg] = Zg), n && (o[Jg] = n), s && (o[t_] = s), r && (o[Yl] = r), i && (o[n_] = i), o_(e, s_, o);
  }
  /**
   * @param onMessage - Callback when messages arrive
   * @param onDisconnect - Callback with connection lost.
   */
  open(e, n) {
    this.onDisconnect = n, this.onMessage = e, this.log_("Websocket connecting to " + this.connURL), this.everConnected_ = !1, as.set("previous_websocket_failure", !0);
    try {
      let s;
      rg(), this.mySock = new Ca(this.connURL, [], s);
    } catch (s) {
      this.log_("Error instantiating WebSocket.");
      const r = s.message || s.data;
      r && this.log_(r), this.onClosed_();
      return;
    }
    this.mySock.onopen = () => {
      this.log_("Websocket connected."), this.everConnected_ = !0;
    }, this.mySock.onclose = () => {
      this.log_("Websocket connection was disconnected."), this.mySock = null, this.onClosed_();
    }, this.mySock.onmessage = (s) => {
      this.handleIncomingFrame(s);
    }, this.mySock.onerror = (s) => {
      this.log_("WebSocket error.  Closing connection.");
      const r = s.message || s.data;
      r && this.log_(r), this.onClosed_();
    };
  }
  /**
   * No-op for websockets, we don't need to do anything once the connection is confirmed as open
   */
  start() {
  }
  static forceDisallow() {
    wt.forceDisallow_ = !0;
  }
  static isAvailable() {
    let e = !1;
    if (typeof navigator < "u" && navigator.userAgent) {
      const n = /Android ([0-9]{0,}\.[0-9]{0,})/, s = navigator.userAgent.match(n);
      s && s.length > 1 && parseFloat(s[1]) < 4.4 && (e = !0);
    }
    return !e && Ca !== null && !wt.forceDisallow_;
  }
  /**
   * Returns true if we previously failed to connect with this transport.
   */
  static previouslyFailed() {
    return as.isInMemoryStorage || as.get("previous_websocket_failure") === !0;
  }
  markConnectionHealthy() {
    as.remove("previous_websocket_failure");
  }
  appendFrame_(e) {
    if (this.frames.push(e), this.frames.length === this.totalFrames) {
      const n = this.frames.join("");
      this.frames = null;
      const s = Fi(n);
      this.onMessage(s);
    }
  }
  /**
   * @param frameCount - The number of frames we are expecting from the server
   */
  handleNewFrameCount_(e) {
    this.totalFrames = e, this.frames = [];
  }
  /**
   * Attempts to parse a frame count out of some text. If it can't, assumes a value of 1
   * @returns Any remaining data to be process, or null if there is none
   */
  extractFrameCount_(e) {
    if (S(this.frames === null, "We already have a frame buffer"), e.length <= 6) {
      const n = Number(e);
      if (!isNaN(n))
        return this.handleNewFrameCount_(n), null;
    }
    return this.handleNewFrameCount_(1), e;
  }
  /**
   * Process a websocket frame that has arrived from the server.
   * @param mess - The frame data
   */
  handleIncomingFrame(e) {
    if (this.mySock === null)
      return;
    const n = e.data;
    if (this.bytesReceived += n.length, this.stats_.incrementCounter("bytes_received", n.length), this.resetKeepAlive(), this.frames !== null)
      this.appendFrame_(n);
    else {
      const s = this.extractFrameCount_(n);
      s !== null && this.appendFrame_(s);
    }
  }
  /**
   * Send a message to the server
   * @param data - The JSON object to transmit
   */
  send(e) {
    this.resetKeepAlive();
    const n = Ie(e);
    this.bytesSent += n.length, this.stats_.incrementCounter("bytes_sent", n.length);
    const s = Yg(n, Xk);
    s.length > 1 && this.sendString_(String(s.length));
    for (let r = 0; r < s.length; r++)
      this.sendString_(s[r]);
  }
  shutdown_() {
    this.isClosed_ = !0, this.keepaliveTimer && (clearInterval(this.keepaliveTimer), this.keepaliveTimer = null), this.mySock && (this.mySock.close(), this.mySock = null);
  }
  onClosed_() {
    this.isClosed_ || (this.log_("WebSocket is closing itself"), this.shutdown_(), this.onDisconnect && (this.onDisconnect(this.everConnected_), this.onDisconnect = null));
  }
  /**
   * External-facing close handler.
   * Close the websocket and kill the connection.
   */
  close() {
    this.isClosed_ || (this.log_("WebSocket is being closed"), this.shutdown_());
  }
  /**
   * Kill the current keepalive timer and start a new one, to ensure that it always fires N seconds after
   * the last activity.
   */
  resetKeepAlive() {
    clearInterval(this.keepaliveTimer), this.keepaliveTimer = setInterval(() => {
      this.mySock && this.sendString_("0"), this.resetKeepAlive();
    }, Math.floor(Jk));
  }
  /**
   * Send a string over the websocket.
   *
   * @param str - String to send.
   */
  sendString_(e) {
    try {
      this.mySock.send(e);
    } catch (n) {
      this.log_("Exception thrown from WebSocket.send():", n.message || n.data, "Closing connection."), setTimeout(this.onClosed_.bind(this), 0);
    }
  }
}
wt.responsesRequiredToBeHealthy = 2;
wt.healthyTimeout = 3e4;
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class Ri {
  /**
   * @param repoInfo - Metadata around the namespace we're connecting to
   */
  constructor(e) {
    this.initTransports_(e);
  }
  static get ALL_TRANSPORTS() {
    return [rr, wt];
  }
  /**
   * Returns whether transport has been selected to ensure WebSocketConnection or BrowserPollConnection are not called after
   * TransportManager has already set up transports_
   */
  static get IS_TRANSPORT_INITIALIZED() {
    return this.globalTransportInitialized_;
  }
  initTransports_(e) {
    const n = wt && wt.isAvailable();
    let s = n && !wt.previouslyFailed();
    if (e.webSocketOnly && (n || ze("wss:// URL used, but browser isn't known to support websockets.  Trying anyway."), s = !0), s)
      this.transports_ = [wt];
    else {
      const r = this.transports_ = [];
      for (const i of Ri.ALL_TRANSPORTS)
        i && i.isAvailable() && r.push(i);
      Ri.globalTransportInitialized_ = !0;
    }
  }
  /**
   * @returns The constructor for the initial transport to use
   */
  initialTransport() {
    if (this.transports_.length > 0)
      return this.transports_[0];
    throw new Error("No transports available");
  }
  /**
   * @returns The constructor for the next transport, or null
   */
  upgradeTransport() {
    return this.transports_.length > 1 ? this.transports_[1] : null;
  }
}
Ri.globalTransportInitialized_ = !1;
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const Qk = 6e4, Zk = 5e3, eA = 10 * 1024, tA = 100 * 1024, hl = "t", Jp = "d", nA = "s", Qp = "r", sA = "e", Zp = "o", ef = "a", tf = "n", nf = "p", rA = "h";
class iA {
  /**
   * @param id - an id for this connection
   * @param repoInfo_ - the info for the endpoint to connect to
   * @param applicationId_ - the Firebase App ID for this project
   * @param appCheckToken_ - The App Check Token for this device.
   * @param authToken_ - The auth token for this session.
   * @param onMessage_ - the callback to be triggered when a server-push message arrives
   * @param onReady_ - the callback to be triggered when this connection is ready to send messages.
   * @param onDisconnect_ - the callback to be triggered when a connection was lost
   * @param onKill_ - the callback to be triggered when this connection has permanently shut down.
   * @param lastSessionId - last session id in persistent connection. is used to clean up old session in real-time server
   */
  constructor(e, n, s, r, i, o, a, c, l, d) {
    this.id = e, this.repoInfo_ = n, this.applicationId_ = s, this.appCheckToken_ = r, this.authToken_ = i, this.onMessage_ = o, this.onReady_ = a, this.onDisconnect_ = c, this.onKill_ = l, this.lastSessionId = d, this.connectionCount = 0, this.pendingDataMessages = [], this.state_ = 0, this.log_ = oo("c:" + this.id + ":"), this.transportManager_ = new Ri(n), this.log_("Connection created"), this.start_();
  }
  /**
   * Starts a connection attempt
   */
  start_() {
    const e = this.transportManager_.initialTransport();
    this.conn_ = new e(this.nextTransportId_(), this.repoInfo_, this.applicationId_, this.appCheckToken_, this.authToken_, null, this.lastSessionId), this.primaryResponsesRequired_ = e.responsesRequiredToBeHealthy || 0;
    const n = this.connReceiver_(this.conn_), s = this.disconnReceiver_(this.conn_);
    this.tx_ = this.conn_, this.rx_ = this.conn_, this.secondaryConn_ = null, this.isHealthy_ = !1, setTimeout(() => {
      this.conn_ && this.conn_.open(n, s);
    }, Math.floor(0));
    const r = e.healthyTimeout || 0;
    r > 0 && (this.healthyTimeout_ = _i(() => {
      this.healthyTimeout_ = null, this.isHealthy_ || (this.conn_ && this.conn_.bytesReceived > tA ? (this.log_("Connection exceeded healthy timeout but has received " + this.conn_.bytesReceived + " bytes.  Marking connection healthy."), this.isHealthy_ = !0, this.conn_.markConnectionHealthy()) : this.conn_ && this.conn_.bytesSent > eA ? this.log_("Connection exceeded healthy timeout but has sent " + this.conn_.bytesSent + " bytes.  Leaving connection alive.") : (this.log_("Closing unhealthy connection after timeout."), this.close()));
    }, Math.floor(r)));
  }
  nextTransportId_() {
    return "c:" + this.id + ":" + this.connectionCount++;
  }
  disconnReceiver_(e) {
    return (n) => {
      e === this.conn_ ? this.onConnectionLost_(n) : e === this.secondaryConn_ ? (this.log_("Secondary connection lost."), this.onSecondaryConnectionLost_()) : this.log_("closing an old connection");
    };
  }
  connReceiver_(e) {
    return (n) => {
      this.state_ !== 2 && (e === this.rx_ ? this.onPrimaryMessageReceived_(n) : e === this.secondaryConn_ ? this.onSecondaryMessageReceived_(n) : this.log_("message on old connection"));
    };
  }
  /**
   * @param dataMsg - An arbitrary data message to be sent to the server
   */
  sendRequest(e) {
    const n = { t: "d", d: e };
    this.sendData_(n);
  }
  tryCleanupConnection() {
    this.tx_ === this.secondaryConn_ && this.rx_ === this.secondaryConn_ && (this.log_("cleaning up and promoting a connection: " + this.secondaryConn_.connId), this.conn_ = this.secondaryConn_, this.secondaryConn_ = null);
  }
  onSecondaryControl_(e) {
    if (hl in e) {
      const n = e[hl];
      n === ef ? this.upgradeIfSecondaryHealthy_() : n === Qp ? (this.log_("Got a reset on secondary, closing it"), this.secondaryConn_.close(), (this.tx_ === this.secondaryConn_ || this.rx_ === this.secondaryConn_) && this.close()) : n === Zp && (this.log_("got pong on secondary."), this.secondaryResponsesRequired_--, this.upgradeIfSecondaryHealthy_());
    }
  }
  onSecondaryMessageReceived_(e) {
    const n = ri("t", e), s = ri("d", e);
    if (n === "c")
      this.onSecondaryControl_(s);
    else if (n === "d")
      this.pendingDataMessages.push(s);
    else
      throw new Error("Unknown protocol layer: " + n);
  }
  upgradeIfSecondaryHealthy_() {
    this.secondaryResponsesRequired_ <= 0 ? (this.log_("Secondary connection is healthy."), this.isHealthy_ = !0, this.secondaryConn_.markConnectionHealthy(), this.proceedWithUpgrade_()) : (this.log_("sending ping on secondary."), this.secondaryConn_.send({ t: "c", d: { t: nf, d: {} } }));
  }
  proceedWithUpgrade_() {
    this.secondaryConn_.start(), this.log_("sending client ack on secondary"), this.secondaryConn_.send({ t: "c", d: { t: ef, d: {} } }), this.log_("Ending transmission on primary"), this.conn_.send({ t: "c", d: { t: tf, d: {} } }), this.tx_ = this.secondaryConn_, this.tryCleanupConnection();
  }
  onPrimaryMessageReceived_(e) {
    const n = ri("t", e), s = ri("d", e);
    n === "c" ? this.onControl_(s) : n === "d" && this.onDataMessage_(s);
  }
  onDataMessage_(e) {
    this.onPrimaryResponse_(), this.onMessage_(e);
  }
  onPrimaryResponse_() {
    this.isHealthy_ || (this.primaryResponsesRequired_--, this.primaryResponsesRequired_ <= 0 && (this.log_("Primary connection is healthy."), this.isHealthy_ = !0, this.conn_.markConnectionHealthy()));
  }
  onControl_(e) {
    const n = ri(hl, e);
    if (Jp in e) {
      const s = e[Jp];
      if (n === rA) {
        const r = Object.assign({}, s);
        this.repoInfo_.isUsingEmulator && (r.h = this.repoInfo_.host), this.onHandshake_(r);
      } else if (n === tf) {
        this.log_("recvd end transmission on primary"), this.rx_ = this.secondaryConn_;
        for (let r = 0; r < this.pendingDataMessages.length; ++r)
          this.onDataMessage_(this.pendingDataMessages[r]);
        this.pendingDataMessages = [], this.tryCleanupConnection();
      } else n === nA ? this.onConnectionShutdown_(s) : n === Qp ? this.onReset_(s) : n === sA ? ql("Server Error: " + s) : n === Zp ? (this.log_("got pong on primary."), this.onPrimaryResponse_(), this.sendPingOnPrimaryIfNecessary_()) : ql("Unknown control packet command: " + n);
    }
  }
  /**
   * @param handshake - The handshake data returned from the server
   */
  onHandshake_(e) {
    const n = e.ts, s = e.v, r = e.h;
    this.sessionId = e.s, this.repoInfo_.host = r, this.state_ === 0 && (this.conn_.start(), this.onConnectionEstablished_(this.conn_, n), wu !== s && ze("Protocol version mismatch detected"), this.tryStartUpgrade_());
  }
  tryStartUpgrade_() {
    const e = this.transportManager_.upgradeTransport();
    e && this.startUpgrade_(e);
  }
  startUpgrade_(e) {
    this.secondaryConn_ = new e(this.nextTransportId_(), this.repoInfo_, this.applicationId_, this.appCheckToken_, this.authToken_, this.sessionId), this.secondaryResponsesRequired_ = e.responsesRequiredToBeHealthy || 0;
    const n = this.connReceiver_(this.secondaryConn_), s = this.disconnReceiver_(this.secondaryConn_);
    this.secondaryConn_.open(n, s), _i(() => {
      this.secondaryConn_ && (this.log_("Timed out trying to upgrade."), this.secondaryConn_.close());
    }, Math.floor(Qk));
  }
  onReset_(e) {
    this.log_("Reset packet received.  New host: " + e), this.repoInfo_.host = e, this.state_ === 1 ? this.close() : (this.closeConnections_(), this.start_());
  }
  onConnectionEstablished_(e, n) {
    this.log_("Realtime connection established."), this.conn_ = e, this.state_ = 1, this.onReady_ && (this.onReady_(n, this.sessionId), this.onReady_ = null), this.primaryResponsesRequired_ === 0 ? (this.log_("Primary connection is healthy."), this.isHealthy_ = !0) : _i(() => {
      this.sendPingOnPrimaryIfNecessary_();
    }, Math.floor(Zk));
  }
  sendPingOnPrimaryIfNecessary_() {
    !this.isHealthy_ && this.state_ === 1 && (this.log_("sending ping on primary."), this.sendData_({ t: "c", d: { t: nf, d: {} } }));
  }
  onSecondaryConnectionLost_() {
    const e = this.secondaryConn_;
    this.secondaryConn_ = null, (this.tx_ === e || this.rx_ === e) && this.close();
  }
  /**
   * @param everConnected - Whether or not the connection ever reached a server. Used to determine if
   * we should flush the host cache
   */
  onConnectionLost_(e) {
    this.conn_ = null, !e && this.state_ === 0 ? (this.log_("Realtime connection failed."), this.repoInfo_.isCacheableHost() && (as.remove("host:" + this.repoInfo_.host), this.repoInfo_.internalHost = this.repoInfo_.host)) : this.state_ === 1 && this.log_("Realtime connection lost."), this.close();
  }
  onConnectionShutdown_(e) {
    this.log_("Connection shutdown command received. Shutting down..."), this.onKill_ && (this.onKill_(e), this.onKill_ = null), this.onDisconnect_ = null, this.close();
  }
  sendData_(e) {
    if (this.state_ !== 1)
      throw "Connection is not connected";
    this.tx_.send(e);
  }
  /**
   * Cleans up this connection, calling the appropriate callbacks
   */
  close() {
    this.state_ !== 2 && (this.log_("Closing realtime connection."), this.state_ = 2, this.closeConnections_(), this.onDisconnect_ && (this.onDisconnect_(), this.onDisconnect_ = null));
  }
  closeConnections_() {
    this.log_("Shutting down all connections"), this.conn_ && (this.conn_.close(), this.conn_ = null), this.secondaryConn_ && (this.secondaryConn_.close(), this.secondaryConn_ = null), this.healthyTimeout_ && (clearTimeout(this.healthyTimeout_), this.healthyTimeout_ = null);
  }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class h_ {
  put(e, n, s, r) {
  }
  merge(e, n, s, r) {
  }
  /**
   * Refreshes the auth token for the current connection.
   * @param token - The authentication token
   */
  refreshAuthToken(e) {
  }
  /**
   * Refreshes the app check token for the current connection.
   * @param token The app check token
   */
  refreshAppCheckToken(e) {
  }
  onDisconnectPut(e, n, s) {
  }
  onDisconnectMerge(e, n, s) {
  }
  onDisconnectCancel(e, n) {
  }
  reportStats(e) {
  }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class p_ {
  constructor(e) {
    this.allowedEvents_ = e, this.listeners_ = {}, S(Array.isArray(e) && e.length > 0, "Requires a non-empty array");
  }
  /**
   * To be called by derived classes to trigger events.
   */
  trigger(e, ...n) {
    if (Array.isArray(this.listeners_[e])) {
      const s = [...this.listeners_[e]];
      for (let r = 0; r < s.length; r++)
        s[r].callback.apply(s[r].context, n);
    }
  }
  on(e, n, s) {
    this.validateEventType_(e), this.listeners_[e] = this.listeners_[e] || [], this.listeners_[e].push({ callback: n, context: s });
    const r = this.getInitialEvent(e);
    r && n.apply(s, r);
  }
  off(e, n, s) {
    this.validateEventType_(e);
    const r = this.listeners_[e] || [];
    for (let i = 0; i < r.length; i++)
      if (r[i].callback === n && (!s || s === r[i].context)) {
        r.splice(i, 1);
        return;
      }
  }
  validateEventType_(e) {
    S(this.allowedEvents_.find((n) => n === e), "Unknown event: " + e);
  }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class Fa extends p_ {
  constructor() {
    super(["online"]), this.online_ = !0, typeof window < "u" && typeof window.addEventListener < "u" && !au() && (window.addEventListener("online", () => {
      this.online_ || (this.online_ = !0, this.trigger("online", !0));
    }, !1), window.addEventListener("offline", () => {
      this.online_ && (this.online_ = !1, this.trigger("online", !1));
    }, !1));
  }
  static getInstance() {
    return new Fa();
  }
  getInitialEvent(e) {
    return S(e === "online", "Unknown event type: " + e), [this.online_];
  }
  currentlyOnline() {
    return this.online_;
  }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const sf = 32, rf = 768;
class oe {
  /**
   * @param pathOrString - Path string to parse, or another path, or the raw
   * tokens array
   */
  constructor(e, n) {
    if (n === void 0) {
      this.pieces_ = e.split("/");
      let s = 0;
      for (let r = 0; r < this.pieces_.length; r++)
        this.pieces_[r].length > 0 && (this.pieces_[s] = this.pieces_[r], s++);
      this.pieces_.length = s, this.pieceNum_ = 0;
    } else
      this.pieces_ = e, this.pieceNum_ = n;
  }
  toString() {
    let e = "";
    for (let n = this.pieceNum_; n < this.pieces_.length; n++)
      this.pieces_[n] !== "" && (e += "/" + this.pieces_[n]);
    return e || "/";
  }
}
function se() {
  return new oe("");
}
function X(t) {
  return t.pieceNum_ >= t.pieces_.length ? null : t.pieces_[t.pieceNum_];
}
function Un(t) {
  return t.pieces_.length - t.pieceNum_;
}
function ue(t) {
  let e = t.pieceNum_;
  return e < t.pieces_.length && e++, new oe(t.pieces_, e);
}
function Cu(t) {
  return t.pieceNum_ < t.pieces_.length ? t.pieces_[t.pieces_.length - 1] : null;
}
function oA(t) {
  let e = "";
  for (let n = t.pieceNum_; n < t.pieces_.length; n++)
    t.pieces_[n] !== "" && (e += "/" + encodeURIComponent(String(t.pieces_[n])));
  return e || "/";
}
function xi(t, e = 0) {
  return t.pieces_.slice(t.pieceNum_ + e);
}
function f_(t) {
  if (t.pieceNum_ >= t.pieces_.length)
    return null;
  const e = [];
  for (let n = t.pieceNum_; n < t.pieces_.length - 1; n++)
    e.push(t.pieces_[n]);
  return new oe(e, 0);
}
function ye(t, e) {
  const n = [];
  for (let s = t.pieceNum_; s < t.pieces_.length; s++)
    n.push(t.pieces_[s]);
  if (e instanceof oe)
    for (let s = e.pieceNum_; s < e.pieces_.length; s++)
      n.push(e.pieces_[s]);
  else {
    const s = e.split("/");
    for (let r = 0; r < s.length; r++)
      s[r].length > 0 && n.push(s[r]);
  }
  return new oe(n, 0);
}
function K(t) {
  return t.pieceNum_ >= t.pieces_.length;
}
function He(t, e) {
  const n = X(t), s = X(e);
  if (n === null)
    return e;
  if (n === s)
    return He(ue(t), ue(e));
  throw new Error("INTERNAL ERROR: innerPath (" + e + ") is not within outerPath (" + t + ")");
}
function aA(t, e) {
  const n = xi(t, 0), s = xi(e, 0);
  for (let r = 0; r < n.length && r < s.length; r++) {
    const i = Rs(n[r], s[r]);
    if (i !== 0)
      return i;
  }
  return n.length === s.length ? 0 : n.length < s.length ? -1 : 1;
}
function m_(t, e) {
  if (Un(t) !== Un(e))
    return !1;
  for (let n = t.pieceNum_, s = e.pieceNum_; n <= t.pieces_.length; n++, s++)
    if (t.pieces_[n] !== e.pieces_[s])
      return !1;
  return !0;
}
function ut(t, e) {
  let n = t.pieceNum_, s = e.pieceNum_;
  if (Un(t) > Un(e))
    return !1;
  for (; n < t.pieces_.length; ) {
    if (t.pieces_[n] !== e.pieces_[s])
      return !1;
    ++n, ++s;
  }
  return !0;
}
class cA {
  /**
   * @param path - Initial Path.
   * @param errorPrefix_ - Prefix for any error messages.
   */
  constructor(e, n) {
    this.errorPrefix_ = n, this.parts_ = xi(e, 0), this.byteLength_ = Math.max(1, this.parts_.length);
    for (let s = 0; s < this.parts_.length; s++)
      this.byteLength_ += pc(this.parts_[s]);
    g_(this);
  }
}
function lA(t, e) {
  t.parts_.length > 0 && (t.byteLength_ += 1), t.parts_.push(e), t.byteLength_ += pc(e), g_(t);
}
function dA(t) {
  const e = t.parts_.pop();
  t.byteLength_ -= pc(e), t.parts_.length > 0 && (t.byteLength_ -= 1);
}
function g_(t) {
  if (t.byteLength_ > rf)
    throw new Error(t.errorPrefix_ + "has a key path longer than " + rf + " bytes (" + t.byteLength_ + ").");
  if (t.parts_.length > sf)
    throw new Error(t.errorPrefix_ + "path specified exceeds the maximum depth that can be written (" + sf + ") or object contains a cycle " + ss(t));
}
function ss(t) {
  return t.parts_.length === 0 ? "" : "in property '" + t.parts_.join(".") + "'";
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class Fu extends p_ {
  constructor() {
    super(["visible"]);
    let e, n;
    typeof document < "u" && typeof document.addEventListener < "u" && (typeof document.hidden < "u" ? (n = "visibilitychange", e = "hidden") : typeof document.mozHidden < "u" ? (n = "mozvisibilitychange", e = "mozHidden") : typeof document.msHidden < "u" ? (n = "msvisibilitychange", e = "msHidden") : typeof document.webkitHidden < "u" && (n = "webkitvisibilitychange", e = "webkitHidden")), this.visible_ = !0, n && document.addEventListener(n, () => {
      const s = !document[e];
      s !== this.visible_ && (this.visible_ = s, this.trigger("visible", s));
    }, !1);
  }
  static getInstance() {
    return new Fu();
  }
  getInitialEvent(e) {
    return S(e === "visible", "Unknown event type: " + e), [this.visible_];
  }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const ii = 1e3, uA = 60 * 5 * 1e3, of = 30 * 1e3, hA = 1.3, pA = 3e4, fA = "server_kill", af = 3;
class tn extends h_ {
  /**
   * @param repoInfo_ - Data about the namespace we are connecting to
   * @param applicationId_ - The Firebase App ID for this project
   * @param onDataUpdate_ - A callback for new data from the server
   */
  constructor(e, n, s, r, i, o, a, c) {
    if (super(), this.repoInfo_ = e, this.applicationId_ = n, this.onDataUpdate_ = s, this.onConnectStatus_ = r, this.onServerInfoUpdate_ = i, this.authTokenProvider_ = o, this.appCheckTokenProvider_ = a, this.authOverride_ = c, this.id = tn.nextPersistentConnectionId_++, this.log_ = oo("p:" + this.id + ":"), this.interruptReasons_ = {}, this.listens = /* @__PURE__ */ new Map(), this.outstandingPuts_ = [], this.outstandingGets_ = [], this.outstandingPutCount_ = 0, this.outstandingGetCount_ = 0, this.onDisconnectRequestQueue_ = [], this.connected_ = !1, this.reconnectDelay_ = ii, this.maxReconnectDelay_ = uA, this.securityDebugCallback_ = null, this.lastSessionId = null, this.establishConnectionTimer_ = null, this.visible_ = !1, this.requestCBHash_ = {}, this.requestNumber_ = 0, this.realtime_ = null, this.authToken_ = null, this.appCheckToken_ = null, this.forceTokenRefresh_ = !1, this.invalidAuthTokenCount_ = 0, this.invalidAppCheckTokenCount_ = 0, this.firstConnection_ = !0, this.lastConnectionAttemptTime_ = null, this.lastConnectionEstablishedTime_ = null, c && !rg())
      throw new Error("Auth override specified in options, but not supported on non Node.js platforms");
    Fu.getInstance().on("visible", this.onVisible_, this), e.host.indexOf("fblocal") === -1 && Fa.getInstance().on("online", this.onOnline_, this);
  }
  sendRequest(e, n, s) {
    const r = ++this.requestNumber_, i = { r, a: e, b: n };
    this.log_(Ie(i)), S(this.connected_, "sendRequest call when we're not connected not allowed."), this.realtime_.sendRequest(i), s && (this.requestCBHash_[r] = s);
  }
  get(e) {
    this.initConnection_();
    const n = new Zi(), r = {
      action: "g",
      request: {
        p: e._path.toString(),
        q: e._queryObject
      },
      onComplete: (o) => {
        const a = o.d;
        o.s === "ok" ? n.resolve(a) : n.reject(a);
      }
    };
    this.outstandingGets_.push(r), this.outstandingGetCount_++;
    const i = this.outstandingGets_.length - 1;
    return this.connected_ && this.sendGet_(i), n.promise;
  }
  listen(e, n, s, r) {
    this.initConnection_();
    const i = e._queryIdentifier, o = e._path.toString();
    this.log_("Listen called for " + o + " " + i), this.listens.has(o) || this.listens.set(o, /* @__PURE__ */ new Map()), S(e._queryParams.isDefault() || !e._queryParams.loadsAllData(), "listen() called for non-default but complete query"), S(!this.listens.get(o).has(i), "listen() called twice for same path/queryId.");
    const a = {
      onComplete: r,
      hashFn: n,
      query: e,
      tag: s
    };
    this.listens.get(o).set(i, a), this.connected_ && this.sendListen_(a);
  }
  sendGet_(e) {
    const n = this.outstandingGets_[e];
    this.sendRequest("g", n.request, (s) => {
      delete this.outstandingGets_[e], this.outstandingGetCount_--, this.outstandingGetCount_ === 0 && (this.outstandingGets_ = []), n.onComplete && n.onComplete(s);
    });
  }
  sendListen_(e) {
    const n = e.query, s = n._path.toString(), r = n._queryIdentifier;
    this.log_("Listen on " + s + " for " + r);
    const i = {
      /*path*/
      p: s
    }, o = "q";
    e.tag && (i.q = n._queryObject, i.t = e.tag), i.h = e.hashFn(), this.sendRequest(o, i, (a) => {
      const c = a.d, l = a.s;
      tn.warnOnListenWarnings_(c, n), (this.listens.get(s) && this.listens.get(s).get(r)) === e && (this.log_("listen response", a), l !== "ok" && this.removeListen_(s, r), e.onComplete && e.onComplete(l, c));
    });
  }
  static warnOnListenWarnings_(e, n) {
    if (e && typeof e == "object" && $t(e, "w")) {
      const s = br(e, "w");
      if (Array.isArray(s) && ~s.indexOf("no_index")) {
        const r = '".indexOn": "' + n._queryParams.getIndex().toString() + '"', i = n._path.toString();
        ze(`Using an unspecified index. Your data will be downloaded and filtered on the client. Consider adding ${r} at ${i} to your security rules for better performance.`);
      }
    }
  }
  refreshAuthToken(e) {
    this.authToken_ = e, this.log_("Auth token refreshed"), this.authToken_ ? this.tryAuth() : this.connected_ && this.sendRequest("unauth", {}, () => {
    }), this.reduceReconnectDelayIfAdminCredential_(e);
  }
  reduceReconnectDelayIfAdminCredential_(e) {
    (e && e.length === 40 || jI(e)) && (this.log_("Admin auth credential detected.  Reducing max reconnect time."), this.maxReconnectDelay_ = of);
  }
  refreshAppCheckToken(e) {
    this.appCheckToken_ = e, this.log_("App check token refreshed"), this.appCheckToken_ ? this.tryAppCheck() : this.connected_ && this.sendRequest("unappeck", {}, () => {
    });
  }
  /**
   * Attempts to authenticate with the given credentials. If the authentication attempt fails, it's triggered like
   * a auth revoked (the connection is closed).
   */
  tryAuth() {
    if (this.connected_ && this.authToken_) {
      const e = this.authToken_, n = HI(e) ? "auth" : "gauth", s = { cred: e };
      this.authOverride_ === null ? s.noauth = !0 : typeof this.authOverride_ == "object" && (s.authvar = this.authOverride_), this.sendRequest(n, s, (r) => {
        const i = r.s, o = r.d || "error";
        this.authToken_ === e && (i === "ok" ? this.invalidAuthTokenCount_ = 0 : this.onAuthRevoked_(i, o));
      });
    }
  }
  /**
   * Attempts to authenticate with the given token. If the authentication
   * attempt fails, it's triggered like the token was revoked (the connection is
   * closed).
   */
  tryAppCheck() {
    this.connected_ && this.appCheckToken_ && this.sendRequest("appcheck", { token: this.appCheckToken_ }, (e) => {
      const n = e.s, s = e.d || "error";
      n === "ok" ? this.invalidAppCheckTokenCount_ = 0 : this.onAppCheckRevoked_(n, s);
    });
  }
  /**
   * @inheritDoc
   */
  unlisten(e, n) {
    const s = e._path.toString(), r = e._queryIdentifier;
    this.log_("Unlisten called for " + s + " " + r), S(e._queryParams.isDefault() || !e._queryParams.loadsAllData(), "unlisten() called for non-default but complete query"), this.removeListen_(s, r) && this.connected_ && this.sendUnlisten_(s, r, e._queryObject, n);
  }
  sendUnlisten_(e, n, s, r) {
    this.log_("Unlisten on " + e + " for " + n);
    const i = {
      /*path*/
      p: e
    }, o = "n";
    r && (i.q = s, i.t = r), this.sendRequest(o, i);
  }
  onDisconnectPut(e, n, s) {
    this.initConnection_(), this.connected_ ? this.sendOnDisconnect_("o", e, n, s) : this.onDisconnectRequestQueue_.push({
      pathString: e,
      action: "o",
      data: n,
      onComplete: s
    });
  }
  onDisconnectMerge(e, n, s) {
    this.initConnection_(), this.connected_ ? this.sendOnDisconnect_("om", e, n, s) : this.onDisconnectRequestQueue_.push({
      pathString: e,
      action: "om",
      data: n,
      onComplete: s
    });
  }
  onDisconnectCancel(e, n) {
    this.initConnection_(), this.connected_ ? this.sendOnDisconnect_("oc", e, null, n) : this.onDisconnectRequestQueue_.push({
      pathString: e,
      action: "oc",
      data: null,
      onComplete: n
    });
  }
  sendOnDisconnect_(e, n, s, r) {
    const i = {
      /*path*/
      p: n,
      /*data*/
      d: s
    };
    this.log_("onDisconnect " + e, i), this.sendRequest(e, i, (o) => {
      r && setTimeout(() => {
        r(o.s, o.d);
      }, Math.floor(0));
    });
  }
  put(e, n, s, r) {
    this.putInternal("p", e, n, s, r);
  }
  merge(e, n, s, r) {
    this.putInternal("m", e, n, s, r);
  }
  putInternal(e, n, s, r, i) {
    this.initConnection_();
    const o = {
      /*path*/
      p: n,
      /*data*/
      d: s
    };
    i !== void 0 && (o.h = i), this.outstandingPuts_.push({
      action: e,
      request: o,
      onComplete: r
    }), this.outstandingPutCount_++;
    const a = this.outstandingPuts_.length - 1;
    this.connected_ ? this.sendPut_(a) : this.log_("Buffering put: " + n);
  }
  sendPut_(e) {
    const n = this.outstandingPuts_[e].action, s = this.outstandingPuts_[e].request, r = this.outstandingPuts_[e].onComplete;
    this.outstandingPuts_[e].queued = this.connected_, this.sendRequest(n, s, (i) => {
      this.log_(n + " response", i), delete this.outstandingPuts_[e], this.outstandingPutCount_--, this.outstandingPutCount_ === 0 && (this.outstandingPuts_ = []), r && r(i.s, i.d);
    });
  }
  reportStats(e) {
    if (this.connected_) {
      const n = {
        /*counters*/
        c: e
      };
      this.log_("reportStats", n), this.sendRequest(
        /*stats*/
        "s",
        n,
        (s) => {
          if (s.s !== "ok") {
            const i = s.d;
            this.log_("reportStats", "Error sending stats: " + i);
          }
        }
      );
    }
  }
  onDataMessage_(e) {
    if ("r" in e) {
      this.log_("from server: " + Ie(e));
      const n = e.r, s = this.requestCBHash_[n];
      s && (delete this.requestCBHash_[n], s(e.b));
    } else {
      if ("error" in e)
        throw "A server-side error has occurred: " + e.error;
      "a" in e && this.onDataPush_(e.a, e.b);
    }
  }
  onDataPush_(e, n) {
    this.log_("handleServerMessage", e, n), e === "d" ? this.onDataUpdate_(
      n.p,
      n.d,
      /*isMerge*/
      !1,
      n.t
    ) : e === "m" ? this.onDataUpdate_(
      n.p,
      n.d,
      /*isMerge=*/
      !0,
      n.t
    ) : e === "c" ? this.onListenRevoked_(n.p, n.q) : e === "ac" ? this.onAuthRevoked_(n.s, n.d) : e === "apc" ? this.onAppCheckRevoked_(n.s, n.d) : e === "sd" ? this.onSecurityDebugPacket_(n) : ql("Unrecognized action received from server: " + Ie(e) + `
Are you using the latest client?`);
  }
  onReady_(e, n) {
    this.log_("connection ready"), this.connected_ = !0, this.lastConnectionEstablishedTime_ = (/* @__PURE__ */ new Date()).getTime(), this.handleTimestamp_(e), this.lastSessionId = n, this.firstConnection_ && this.sendConnectStats_(), this.restoreState_(), this.firstConnection_ = !1, this.onConnectStatus_(!0);
  }
  scheduleConnect_(e) {
    S(!this.realtime_, "Scheduling a connect when we're already connected/ing?"), this.establishConnectionTimer_ && clearTimeout(this.establishConnectionTimer_), this.establishConnectionTimer_ = setTimeout(() => {
      this.establishConnectionTimer_ = null, this.establishConnection_();
    }, Math.floor(e));
  }
  initConnection_() {
    !this.realtime_ && this.firstConnection_ && this.scheduleConnect_(0);
  }
  onVisible_(e) {
    e && !this.visible_ && this.reconnectDelay_ === this.maxReconnectDelay_ && (this.log_("Window became visible.  Reducing delay."), this.reconnectDelay_ = ii, this.realtime_ || this.scheduleConnect_(0)), this.visible_ = e;
  }
  onOnline_(e) {
    e ? (this.log_("Browser went online."), this.reconnectDelay_ = ii, this.realtime_ || this.scheduleConnect_(0)) : (this.log_("Browser went offline.  Killing connection."), this.realtime_ && this.realtime_.close());
  }
  onRealtimeDisconnect_() {
    if (this.log_("data client disconnected"), this.connected_ = !1, this.realtime_ = null, this.cancelSentTransactions_(), this.requestCBHash_ = {}, this.shouldReconnect_()) {
      this.visible_ ? this.lastConnectionEstablishedTime_ && ((/* @__PURE__ */ new Date()).getTime() - this.lastConnectionEstablishedTime_ > pA && (this.reconnectDelay_ = ii), this.lastConnectionEstablishedTime_ = null) : (this.log_("Window isn't visible.  Delaying reconnect."), this.reconnectDelay_ = this.maxReconnectDelay_, this.lastConnectionAttemptTime_ = (/* @__PURE__ */ new Date()).getTime());
      const e = (/* @__PURE__ */ new Date()).getTime() - this.lastConnectionAttemptTime_;
      let n = Math.max(0, this.reconnectDelay_ - e);
      n = Math.random() * n, this.log_("Trying to reconnect in " + n + "ms"), this.scheduleConnect_(n), this.reconnectDelay_ = Math.min(this.maxReconnectDelay_, this.reconnectDelay_ * hA);
    }
    this.onConnectStatus_(!1);
  }
  async establishConnection_() {
    if (this.shouldReconnect_()) {
      this.log_("Making a connection attempt"), this.lastConnectionAttemptTime_ = (/* @__PURE__ */ new Date()).getTime(), this.lastConnectionEstablishedTime_ = null;
      const e = this.onDataMessage_.bind(this), n = this.onReady_.bind(this), s = this.onRealtimeDisconnect_.bind(this), r = this.id + ":" + tn.nextConnectionId_++, i = this.lastSessionId;
      let o = !1, a = null;
      const c = function() {
        a ? a.close() : (o = !0, s());
      }, l = function(u) {
        S(a, "sendRequest call when we're not connected not allowed."), a.sendRequest(u);
      };
      this.realtime_ = {
        close: c,
        sendRequest: l
      };
      const d = this.forceTokenRefresh_;
      this.forceTokenRefresh_ = !1;
      try {
        const [u, h] = await Promise.all([
          this.authTokenProvider_.getToken(d),
          this.appCheckTokenProvider_.getToken(d)
        ]);
        o ? Oe("getToken() completed but was canceled") : (Oe("getToken() completed. Creating connection."), this.authToken_ = u && u.accessToken, this.appCheckToken_ = h && h.token, a = new iA(
          r,
          this.repoInfo_,
          this.applicationId_,
          this.appCheckToken_,
          this.authToken_,
          e,
          n,
          s,
          /* onKill= */
          (p) => {
            ze(p + " (" + this.repoInfo_.toString() + ")"), this.interrupt(fA);
          },
          i
        ));
      } catch (u) {
        this.log_("Failed to get token: " + u), o || (this.repoInfo_.nodeAdmin && ze(u), c());
      }
    }
  }
  interrupt(e) {
    Oe("Interrupting connection for reason: " + e), this.interruptReasons_[e] = !0, this.realtime_ ? this.realtime_.close() : (this.establishConnectionTimer_ && (clearTimeout(this.establishConnectionTimer_), this.establishConnectionTimer_ = null), this.connected_ && this.onRealtimeDisconnect_());
  }
  resume(e) {
    Oe("Resuming connection for reason: " + e), delete this.interruptReasons_[e], Bl(this.interruptReasons_) && (this.reconnectDelay_ = ii, this.realtime_ || this.scheduleConnect_(0));
  }
  handleTimestamp_(e) {
    const n = e - (/* @__PURE__ */ new Date()).getTime();
    this.onServerInfoUpdate_({ serverTimeOffset: n });
  }
  cancelSentTransactions_() {
    for (let e = 0; e < this.outstandingPuts_.length; e++) {
      const n = this.outstandingPuts_[e];
      n && /*hash*/
      "h" in n.request && n.queued && (n.onComplete && n.onComplete("disconnect"), delete this.outstandingPuts_[e], this.outstandingPutCount_--);
    }
    this.outstandingPutCount_ === 0 && (this.outstandingPuts_ = []);
  }
  onListenRevoked_(e, n) {
    let s;
    n ? s = n.map((i) => Su(i)).join("$") : s = "default";
    const r = this.removeListen_(e, s);
    r && r.onComplete && r.onComplete("permission_denied");
  }
  removeListen_(e, n) {
    const s = new oe(e).toString();
    let r;
    if (this.listens.has(s)) {
      const i = this.listens.get(s);
      r = i.get(n), i.delete(n), i.size === 0 && this.listens.delete(s);
    } else
      r = void 0;
    return r;
  }
  onAuthRevoked_(e, n) {
    Oe("Auth token revoked: " + e + "/" + n), this.authToken_ = null, this.forceTokenRefresh_ = !0, this.realtime_.close(), (e === "invalid_token" || e === "permission_denied") && (this.invalidAuthTokenCount_++, this.invalidAuthTokenCount_ >= af && (this.reconnectDelay_ = of, this.authTokenProvider_.notifyForInvalidToken()));
  }
  onAppCheckRevoked_(e, n) {
    Oe("App check token revoked: " + e + "/" + n), this.appCheckToken_ = null, this.forceTokenRefresh_ = !0, (e === "invalid_token" || e === "permission_denied") && (this.invalidAppCheckTokenCount_++, this.invalidAppCheckTokenCount_ >= af && this.appCheckTokenProvider_.notifyForInvalidToken());
  }
  onSecurityDebugPacket_(e) {
    this.securityDebugCallback_ ? this.securityDebugCallback_(e) : "msg" in e && console.log("FIREBASE: " + e.msg.replace(`
`, `
FIREBASE: `));
  }
  restoreState_() {
    this.tryAuth(), this.tryAppCheck();
    for (const e of this.listens.values())
      for (const n of e.values())
        this.sendListen_(n);
    for (let e = 0; e < this.outstandingPuts_.length; e++)
      this.outstandingPuts_[e] && this.sendPut_(e);
    for (; this.onDisconnectRequestQueue_.length; ) {
      const e = this.onDisconnectRequestQueue_.shift();
      this.sendOnDisconnect_(e.action, e.pathString, e.data, e.onComplete);
    }
    for (let e = 0; e < this.outstandingGets_.length; e++)
      this.outstandingGets_[e] && this.sendGet_(e);
  }
  /**
   * Sends client stats for first connection
   */
  sendConnectStats_() {
    const e = {};
    let n = "js";
    e["sdk." + n + "." + Wg.replace(/\./g, "-")] = 1, au() ? e["framework.cordova"] = 1 : sg() && (e["framework.reactnative"] = 1), this.reportStats(e);
  }
  shouldReconnect_() {
    const e = Fa.getInstance().currentlyOnline();
    return Bl(this.interruptReasons_) && e;
  }
}
tn.nextPersistentConnectionId_ = 0;
tn.nextConnectionId_ = 0;
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class z {
  constructor(e, n) {
    this.name = e, this.node = n;
  }
  static Wrap(e, n) {
    return new z(e, n);
  }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class _c {
  /**
   * @returns A standalone comparison function for
   * this index
   */
  getCompare() {
    return this.compare.bind(this);
  }
  /**
   * Given a before and after value for a node, determine if the indexed value has changed. Even if they are different,
   * it's possible that the changes are isolated to parts of the snapshot that are not indexed.
   *
   *
   * @returns True if the portion of the snapshot being indexed changed between oldNode and newNode
   */
  indexedValueChanged(e, n) {
    const s = new z(Sr, e), r = new z(Sr, n);
    return this.compare(s, r) !== 0;
  }
  /**
   * @returns a node wrapper that will sort equal to or less than
   * any other node wrapper, using this index
   */
  minPost() {
    return z.MIN;
  }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
let xo;
class __ extends _c {
  static get __EMPTY_NODE() {
    return xo;
  }
  static set __EMPTY_NODE(e) {
    xo = e;
  }
  compare(e, n) {
    return Rs(e.name, n.name);
  }
  isDefinedOn(e) {
    throw Vr("KeyIndex.isDefinedOn not expected to be called.");
  }
  indexedValueChanged(e, n) {
    return !1;
  }
  minPost() {
    return z.MIN;
  }
  maxPost() {
    return new z(Ss, xo);
  }
  makePost(e, n) {
    return S(typeof e == "string", "KeyIndex indexValue must always be a string."), new z(e, xo);
  }
  /**
   * @returns String representation for inclusion in a query spec
   */
  toString() {
    return ".key";
  }
}
const hr = new __();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class Oo {
  /**
   * @param node - Node to iterate.
   * @param isReverse_ - Whether or not to iterate in reverse
   */
  constructor(e, n, s, r, i = null) {
    this.isReverse_ = r, this.resultGenerator_ = i, this.nodeStack_ = [];
    let o = 1;
    for (; !e.isEmpty(); )
      if (e = e, o = n ? s(e.key, n) : 1, r && (o *= -1), o < 0)
        this.isReverse_ ? e = e.left : e = e.right;
      else if (o === 0) {
        this.nodeStack_.push(e);
        break;
      } else
        this.nodeStack_.push(e), this.isReverse_ ? e = e.right : e = e.left;
  }
  getNext() {
    if (this.nodeStack_.length === 0)
      return null;
    let e = this.nodeStack_.pop(), n;
    if (this.resultGenerator_ ? n = this.resultGenerator_(e.key, e.value) : n = { key: e.key, value: e.value }, this.isReverse_)
      for (e = e.left; !e.isEmpty(); )
        this.nodeStack_.push(e), e = e.right;
    else
      for (e = e.right; !e.isEmpty(); )
        this.nodeStack_.push(e), e = e.left;
    return n;
  }
  hasNext() {
    return this.nodeStack_.length > 0;
  }
  peek() {
    if (this.nodeStack_.length === 0)
      return null;
    const e = this.nodeStack_[this.nodeStack_.length - 1];
    return this.resultGenerator_ ? this.resultGenerator_(e.key, e.value) : { key: e.key, value: e.value };
  }
}
class Ne {
  /**
   * @param key - Key associated with this node.
   * @param value - Value associated with this node.
   * @param color - Whether this node is red.
   * @param left - Left child.
   * @param right - Right child.
   */
  constructor(e, n, s, r, i) {
    this.key = e, this.value = n, this.color = s ?? Ne.RED, this.left = r ?? et.EMPTY_NODE, this.right = i ?? et.EMPTY_NODE;
  }
  /**
   * Returns a copy of the current node, optionally replacing pieces of it.
   *
   * @param key - New key for the node, or null.
   * @param value - New value for the node, or null.
   * @param color - New color for the node, or null.
   * @param left - New left child for the node, or null.
   * @param right - New right child for the node, or null.
   * @returns The node copy.
   */
  copy(e, n, s, r, i) {
    return new Ne(e ?? this.key, n ?? this.value, s ?? this.color, r ?? this.left, i ?? this.right);
  }
  /**
   * @returns The total number of nodes in the tree.
   */
  count() {
    return this.left.count() + 1 + this.right.count();
  }
  /**
   * @returns True if the tree is empty.
   */
  isEmpty() {
    return !1;
  }
  /**
   * Traverses the tree in key order and calls the specified action function
   * for each node.
   *
   * @param action - Callback function to be called for each
   *   node.  If it returns true, traversal is aborted.
   * @returns The first truthy value returned by action, or the last falsey
   *   value returned by action
   */
  inorderTraversal(e) {
    return this.left.inorderTraversal(e) || !!e(this.key, this.value) || this.right.inorderTraversal(e);
  }
  /**
   * Traverses the tree in reverse key order and calls the specified action function
   * for each node.
   *
   * @param action - Callback function to be called for each
   * node.  If it returns true, traversal is aborted.
   * @returns True if traversal was aborted.
   */
  reverseTraversal(e) {
    return this.right.reverseTraversal(e) || e(this.key, this.value) || this.left.reverseTraversal(e);
  }
  /**
   * @returns The minimum node in the tree.
   */
  min_() {
    return this.left.isEmpty() ? this : this.left.min_();
  }
  /**
   * @returns The maximum key in the tree.
   */
  minKey() {
    return this.min_().key;
  }
  /**
   * @returns The maximum key in the tree.
   */
  maxKey() {
    return this.right.isEmpty() ? this.key : this.right.maxKey();
  }
  /**
   * @param key - Key to insert.
   * @param value - Value to insert.
   * @param comparator - Comparator.
   * @returns New tree, with the key/value added.
   */
  insert(e, n, s) {
    let r = this;
    const i = s(e, r.key);
    return i < 0 ? r = r.copy(null, null, null, r.left.insert(e, n, s), null) : i === 0 ? r = r.copy(null, n, null, null, null) : r = r.copy(null, null, null, null, r.right.insert(e, n, s)), r.fixUp_();
  }
  /**
   * @returns New tree, with the minimum key removed.
   */
  removeMin_() {
    if (this.left.isEmpty())
      return et.EMPTY_NODE;
    let e = this;
    return !e.left.isRed_() && !e.left.left.isRed_() && (e = e.moveRedLeft_()), e = e.copy(null, null, null, e.left.removeMin_(), null), e.fixUp_();
  }
  /**
   * @param key - The key of the item to remove.
   * @param comparator - Comparator.
   * @returns New tree, with the specified item removed.
   */
  remove(e, n) {
    let s, r;
    if (s = this, n(e, s.key) < 0)
      !s.left.isEmpty() && !s.left.isRed_() && !s.left.left.isRed_() && (s = s.moveRedLeft_()), s = s.copy(null, null, null, s.left.remove(e, n), null);
    else {
      if (s.left.isRed_() && (s = s.rotateRight_()), !s.right.isEmpty() && !s.right.isRed_() && !s.right.left.isRed_() && (s = s.moveRedRight_()), n(e, s.key) === 0) {
        if (s.right.isEmpty())
          return et.EMPTY_NODE;
        r = s.right.min_(), s = s.copy(r.key, r.value, null, null, s.right.removeMin_());
      }
      s = s.copy(null, null, null, null, s.right.remove(e, n));
    }
    return s.fixUp_();
  }
  /**
   * @returns Whether this is a RED node.
   */
  isRed_() {
    return this.color;
  }
  /**
   * @returns New tree after performing any needed rotations.
   */
  fixUp_() {
    let e = this;
    return e.right.isRed_() && !e.left.isRed_() && (e = e.rotateLeft_()), e.left.isRed_() && e.left.left.isRed_() && (e = e.rotateRight_()), e.left.isRed_() && e.right.isRed_() && (e = e.colorFlip_()), e;
  }
  /**
   * @returns New tree, after moveRedLeft.
   */
  moveRedLeft_() {
    let e = this.colorFlip_();
    return e.right.left.isRed_() && (e = e.copy(null, null, null, null, e.right.rotateRight_()), e = e.rotateLeft_(), e = e.colorFlip_()), e;
  }
  /**
   * @returns New tree, after moveRedRight.
   */
  moveRedRight_() {
    let e = this.colorFlip_();
    return e.left.left.isRed_() && (e = e.rotateRight_(), e = e.colorFlip_()), e;
  }
  /**
   * @returns New tree, after rotateLeft.
   */
  rotateLeft_() {
    const e = this.copy(null, null, Ne.RED, null, this.right.left);
    return this.right.copy(null, null, this.color, e, null);
  }
  /**
   * @returns New tree, after rotateRight.
   */
  rotateRight_() {
    const e = this.copy(null, null, Ne.RED, this.left.right, null);
    return this.left.copy(null, null, this.color, null, e);
  }
  /**
   * @returns Newt ree, after colorFlip.
   */
  colorFlip_() {
    const e = this.left.copy(null, null, !this.left.color, null, null), n = this.right.copy(null, null, !this.right.color, null, null);
    return this.copy(null, null, !this.color, e, n);
  }
  /**
   * For testing.
   *
   * @returns True if all is well.
   */
  checkMaxDepth_() {
    const e = this.check_();
    return Math.pow(2, e) <= this.count() + 1;
  }
  check_() {
    if (this.isRed_() && this.left.isRed_())
      throw new Error("Red node has red child(" + this.key + "," + this.value + ")");
    if (this.right.isRed_())
      throw new Error("Right child of (" + this.key + "," + this.value + ") is red");
    const e = this.left.check_();
    if (e !== this.right.check_())
      throw new Error("Black depths differ");
    return e + (this.isRed_() ? 0 : 1);
  }
}
Ne.RED = !0;
Ne.BLACK = !1;
class mA {
  /**
   * Returns a copy of the current node.
   *
   * @returns The node copy.
   */
  copy(e, n, s, r, i) {
    return this;
  }
  /**
   * Returns a copy of the tree, with the specified key/value added.
   *
   * @param key - Key to be added.
   * @param value - Value to be added.
   * @param comparator - Comparator.
   * @returns New tree, with item added.
   */
  insert(e, n, s) {
    return new Ne(e, n, null);
  }
  /**
   * Returns a copy of the tree, with the specified key removed.
   *
   * @param key - The key to remove.
   * @param comparator - Comparator.
   * @returns New tree, with item removed.
   */
  remove(e, n) {
    return this;
  }
  /**
   * @returns The total number of nodes in the tree.
   */
  count() {
    return 0;
  }
  /**
   * @returns True if the tree is empty.
   */
  isEmpty() {
    return !0;
  }
  /**
   * Traverses the tree in key order and calls the specified action function
   * for each node.
   *
   * @param action - Callback function to be called for each
   * node.  If it returns true, traversal is aborted.
   * @returns True if traversal was aborted.
   */
  inorderTraversal(e) {
    return !1;
  }
  /**
   * Traverses the tree in reverse key order and calls the specified action function
   * for each node.
   *
   * @param action - Callback function to be called for each
   * node.  If it returns true, traversal is aborted.
   * @returns True if traversal was aborted.
   */
  reverseTraversal(e) {
    return !1;
  }
  minKey() {
    return null;
  }
  maxKey() {
    return null;
  }
  check_() {
    return 0;
  }
  /**
   * @returns Whether this node is red.
   */
  isRed_() {
    return !1;
  }
}
class et {
  /**
   * @param comparator_ - Key comparator.
   * @param root_ - Optional root node for the map.
   */
  constructor(e, n = et.EMPTY_NODE) {
    this.comparator_ = e, this.root_ = n;
  }
  /**
   * Returns a copy of the map, with the specified key/value added or replaced.
   * (TODO: We should perhaps rename this method to 'put')
   *
   * @param key - Key to be added.
   * @param value - Value to be added.
   * @returns New map, with item added.
   */
  insert(e, n) {
    return new et(this.comparator_, this.root_.insert(e, n, this.comparator_).copy(null, null, Ne.BLACK, null, null));
  }
  /**
   * Returns a copy of the map, with the specified key removed.
   *
   * @param key - The key to remove.
   * @returns New map, with item removed.
   */
  remove(e) {
    return new et(this.comparator_, this.root_.remove(e, this.comparator_).copy(null, null, Ne.BLACK, null, null));
  }
  /**
   * Returns the value of the node with the given key, or null.
   *
   * @param key - The key to look up.
   * @returns The value of the node with the given key, or null if the
   * key doesn't exist.
   */
  get(e) {
    let n, s = this.root_;
    for (; !s.isEmpty(); ) {
      if (n = this.comparator_(e, s.key), n === 0)
        return s.value;
      n < 0 ? s = s.left : n > 0 && (s = s.right);
    }
    return null;
  }
  /**
   * Returns the key of the item *before* the specified key, or null if key is the first item.
   * @param key - The key to find the predecessor of
   * @returns The predecessor key.
   */
  getPredecessorKey(e) {
    let n, s = this.root_, r = null;
    for (; !s.isEmpty(); )
      if (n = this.comparator_(e, s.key), n === 0) {
        if (s.left.isEmpty())
          return r ? r.key : null;
        for (s = s.left; !s.right.isEmpty(); )
          s = s.right;
        return s.key;
      } else n < 0 ? s = s.left : n > 0 && (r = s, s = s.right);
    throw new Error("Attempted to find predecessor key for a nonexistent key.  What gives?");
  }
  /**
   * @returns True if the map is empty.
   */
  isEmpty() {
    return this.root_.isEmpty();
  }
  /**
   * @returns The total number of nodes in the map.
   */
  count() {
    return this.root_.count();
  }
  /**
   * @returns The minimum key in the map.
   */
  minKey() {
    return this.root_.minKey();
  }
  /**
   * @returns The maximum key in the map.
   */
  maxKey() {
    return this.root_.maxKey();
  }
  /**
   * Traverses the map in key order and calls the specified action function
   * for each key/value pair.
   *
   * @param action - Callback function to be called
   * for each key/value pair.  If action returns true, traversal is aborted.
   * @returns The first truthy value returned by action, or the last falsey
   *   value returned by action
   */
  inorderTraversal(e) {
    return this.root_.inorderTraversal(e);
  }
  /**
   * Traverses the map in reverse key order and calls the specified action function
   * for each key/value pair.
   *
   * @param action - Callback function to be called
   * for each key/value pair.  If action returns true, traversal is aborted.
   * @returns True if the traversal was aborted.
   */
  reverseTraversal(e) {
    return this.root_.reverseTraversal(e);
  }
  /**
   * Returns an iterator over the SortedMap.
   * @returns The iterator.
   */
  getIterator(e) {
    return new Oo(this.root_, null, this.comparator_, !1, e);
  }
  getIteratorFrom(e, n) {
    return new Oo(this.root_, e, this.comparator_, !1, n);
  }
  getReverseIteratorFrom(e, n) {
    return new Oo(this.root_, e, this.comparator_, !0, n);
  }
  getReverseIterator(e) {
    return new Oo(this.root_, null, this.comparator_, !0, e);
  }
}
et.EMPTY_NODE = new mA();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function gA(t, e) {
  return Rs(t.name, e.name);
}
function ku(t, e) {
  return Rs(t, e);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
let Kl;
function _A(t) {
  Kl = t;
}
const y_ = function(t) {
  return typeof t == "number" ? "number:" + Kg(t) : "string:" + t;
}, E_ = function(t) {
  if (t.isLeafNode()) {
    const e = t.val();
    S(typeof e == "string" || typeof e == "number" || typeof e == "object" && $t(e, ".sv"), "Priority must be a string or number.");
  } else
    S(t === Kl || t.isEmpty(), "priority of unexpected type.");
  S(t === Kl || t.getPriority().isEmpty(), "Priority nodes can't have a priority of their own.");
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
let cf;
class Ae {
  /**
   * @param value_ - The value to store in this leaf node. The object type is
   * possible in the event of a deferred value
   * @param priorityNode_ - The priority of this node.
   */
  constructor(e, n = Ae.__childrenNodeConstructor.EMPTY_NODE) {
    this.value_ = e, this.priorityNode_ = n, this.lazyHash_ = null, S(this.value_ !== void 0 && this.value_ !== null, "LeafNode shouldn't be created with null/undefined value."), E_(this.priorityNode_);
  }
  static set __childrenNodeConstructor(e) {
    cf = e;
  }
  static get __childrenNodeConstructor() {
    return cf;
  }
  /** @inheritDoc */
  isLeafNode() {
    return !0;
  }
  /** @inheritDoc */
  getPriority() {
    return this.priorityNode_;
  }
  /** @inheritDoc */
  updatePriority(e) {
    return new Ae(this.value_, e);
  }
  /** @inheritDoc */
  getImmediateChild(e) {
    return e === ".priority" ? this.priorityNode_ : Ae.__childrenNodeConstructor.EMPTY_NODE;
  }
  /** @inheritDoc */
  getChild(e) {
    return K(e) ? this : X(e) === ".priority" ? this.priorityNode_ : Ae.__childrenNodeConstructor.EMPTY_NODE;
  }
  hasChild() {
    return !1;
  }
  /** @inheritDoc */
  getPredecessorChildName(e, n) {
    return null;
  }
  /** @inheritDoc */
  updateImmediateChild(e, n) {
    return e === ".priority" ? this.updatePriority(n) : n.isEmpty() && e !== ".priority" ? this : Ae.__childrenNodeConstructor.EMPTY_NODE.updateImmediateChild(e, n).updatePriority(this.priorityNode_);
  }
  /** @inheritDoc */
  updateChild(e, n) {
    const s = X(e);
    return s === null ? n : n.isEmpty() && s !== ".priority" ? this : (S(s !== ".priority" || Un(e) === 1, ".priority must be the last token in a path"), this.updateImmediateChild(s, Ae.__childrenNodeConstructor.EMPTY_NODE.updateChild(ue(e), n)));
  }
  /** @inheritDoc */
  isEmpty() {
    return !1;
  }
  /** @inheritDoc */
  numChildren() {
    return 0;
  }
  /** @inheritDoc */
  forEachChild(e, n) {
    return !1;
  }
  val(e) {
    return e && !this.getPriority().isEmpty() ? {
      ".value": this.getValue(),
      ".priority": this.getPriority().val()
    } : this.getValue();
  }
  /** @inheritDoc */
  hash() {
    if (this.lazyHash_ === null) {
      let e = "";
      this.priorityNode_.isEmpty() || (e += "priority:" + y_(this.priorityNode_.val()) + ":");
      const n = typeof this.value_;
      e += n + ":", n === "number" ? e += Kg(this.value_) : e += this.value_, this.lazyHash_ = qg(e);
    }
    return this.lazyHash_;
  }
  /**
   * Returns the value of the leaf node.
   * @returns The value of the node.
   */
  getValue() {
    return this.value_;
  }
  compareTo(e) {
    return e === Ae.__childrenNodeConstructor.EMPTY_NODE ? 1 : e instanceof Ae.__childrenNodeConstructor ? -1 : (S(e.isLeafNode(), "Unknown node type"), this.compareToLeafNode_(e));
  }
  /**
   * Comparison specifically for two leaf nodes
   */
  compareToLeafNode_(e) {
    const n = typeof e.value_, s = typeof this.value_, r = Ae.VALUE_TYPE_ORDER.indexOf(n), i = Ae.VALUE_TYPE_ORDER.indexOf(s);
    return S(r >= 0, "Unknown leaf type: " + n), S(i >= 0, "Unknown leaf type: " + s), r === i ? s === "object" ? 0 : this.value_ < e.value_ ? -1 : this.value_ === e.value_ ? 0 : 1 : i - r;
  }
  withIndex() {
    return this;
  }
  isIndexed() {
    return !0;
  }
  equals(e) {
    if (e === this)
      return !0;
    if (e.isLeafNode()) {
      const n = e;
      return this.value_ === n.value_ && this.priorityNode_.equals(n.priorityNode_);
    } else
      return !1;
  }
}
Ae.VALUE_TYPE_ORDER = ["object", "boolean", "number", "string"];
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
let b_, v_;
function yA(t) {
  b_ = t;
}
function EA(t) {
  v_ = t;
}
class bA extends _c {
  compare(e, n) {
    const s = e.node.getPriority(), r = n.node.getPriority(), i = s.compareTo(r);
    return i === 0 ? Rs(e.name, n.name) : i;
  }
  isDefinedOn(e) {
    return !e.getPriority().isEmpty();
  }
  indexedValueChanged(e, n) {
    return !e.getPriority().equals(n.getPriority());
  }
  minPost() {
    return z.MIN;
  }
  maxPost() {
    return new z(Ss, new Ae("[PRIORITY-POST]", v_));
  }
  makePost(e, n) {
    const s = b_(e);
    return new z(n, new Ae("[PRIORITY-POST]", s));
  }
  /**
   * @returns String representation for inclusion in a query spec
   */
  toString() {
    return ".priority";
  }
}
const Ee = new bA();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const vA = Math.log(2);
class SA {
  constructor(e) {
    const n = (i) => (
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      parseInt(Math.log(i) / vA, 10)
    ), s = (i) => parseInt(Array(i + 1).join("1"), 2);
    this.count = n(e + 1), this.current_ = this.count - 1;
    const r = s(this.count);
    this.bits_ = e + 1 & r;
  }
  nextBitIsOne() {
    const e = !(this.bits_ & 1 << this.current_);
    return this.current_--, e;
  }
}
const ka = function(t, e, n, s) {
  t.sort(e);
  const r = function(c, l) {
    const d = l - c;
    let u, h;
    if (d === 0)
      return null;
    if (d === 1)
      return u = t[c], h = n ? n(u) : u, new Ne(h, u.node, Ne.BLACK, null, null);
    {
      const p = parseInt(d / 2, 10) + c, f = r(c, p), m = r(p + 1, l);
      return u = t[p], h = n ? n(u) : u, new Ne(h, u.node, Ne.BLACK, f, m);
    }
  }, i = function(c) {
    let l = null, d = null, u = t.length;
    const h = function(f, m) {
      const g = u - f, y = u;
      u -= f;
      const I = r(g + 1, y), A = t[g], T = n ? n(A) : A;
      p(new Ne(T, A.node, m, null, I));
    }, p = function(f) {
      l ? (l.left = f, l = f) : (d = f, l = f);
    };
    for (let f = 0; f < c.count; ++f) {
      const m = c.nextBitIsOne(), g = Math.pow(2, c.count - (f + 1));
      m ? h(g, Ne.BLACK) : (h(g, Ne.BLACK), h(g, Ne.RED));
    }
    return d;
  }, o = new SA(t.length), a = i(o);
  return new et(s || e, a);
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
let pl;
const Ys = {};
class Jt {
  constructor(e, n) {
    this.indexes_ = e, this.indexSet_ = n;
  }
  /**
   * The default IndexMap for nodes without a priority
   */
  static get Default() {
    return S(Ys && Ee, "ChildrenNode.ts has not been loaded"), pl = pl || new Jt({ ".priority": Ys }, { ".priority": Ee }), pl;
  }
  get(e) {
    const n = br(this.indexes_, e);
    if (!n)
      throw new Error("No index defined for " + e);
    return n instanceof et ? n : null;
  }
  hasIndex(e) {
    return $t(this.indexSet_, e.toString());
  }
  addIndex(e, n) {
    S(e !== hr, "KeyIndex always exists and isn't meant to be added to the IndexMap.");
    const s = [];
    let r = !1;
    const i = n.getIterator(z.Wrap);
    let o = i.getNext();
    for (; o; )
      r = r || e.isDefinedOn(o.node), s.push(o), o = i.getNext();
    let a;
    r ? a = ka(s, e.getCompare()) : a = Ys;
    const c = e.toString(), l = Object.assign({}, this.indexSet_);
    l[c] = e;
    const d = Object.assign({}, this.indexes_);
    return d[c] = a, new Jt(d, l);
  }
  /**
   * Ensure that this node is properly tracked in any indexes that we're maintaining
   */
  addToIndexes(e, n) {
    const s = _a(this.indexes_, (r, i) => {
      const o = br(this.indexSet_, i);
      if (S(o, "Missing index implementation for " + i), r === Ys)
        if (o.isDefinedOn(e.node)) {
          const a = [], c = n.getIterator(z.Wrap);
          let l = c.getNext();
          for (; l; )
            l.name !== e.name && a.push(l), l = c.getNext();
          return a.push(e), ka(a, o.getCompare());
        } else
          return Ys;
      else {
        const a = n.get(e.name);
        let c = r;
        return a && (c = c.remove(new z(e.name, a))), c.insert(e, e.node);
      }
    });
    return new Jt(s, this.indexSet_);
  }
  /**
   * Create a new IndexMap instance with the given value removed
   */
  removeFromIndexes(e, n) {
    const s = _a(this.indexes_, (r) => {
      if (r === Ys)
        return r;
      {
        const i = n.get(e.name);
        return i ? r.remove(new z(e.name, i)) : r;
      }
    });
    return new Jt(s, this.indexSet_);
  }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
let oi;
class P {
  /**
   * @param children_ - List of children of this node..
   * @param priorityNode_ - The priority of this node (as a snapshot node).
   */
  constructor(e, n, s) {
    this.children_ = e, this.priorityNode_ = n, this.indexMap_ = s, this.lazyHash_ = null, this.priorityNode_ && E_(this.priorityNode_), this.children_.isEmpty() && S(!this.priorityNode_ || this.priorityNode_.isEmpty(), "An empty node cannot have a priority");
  }
  static get EMPTY_NODE() {
    return oi || (oi = new P(new et(ku), null, Jt.Default));
  }
  /** @inheritDoc */
  isLeafNode() {
    return !1;
  }
  /** @inheritDoc */
  getPriority() {
    return this.priorityNode_ || oi;
  }
  /** @inheritDoc */
  updatePriority(e) {
    return this.children_.isEmpty() ? this : new P(this.children_, e, this.indexMap_);
  }
  /** @inheritDoc */
  getImmediateChild(e) {
    if (e === ".priority")
      return this.getPriority();
    {
      const n = this.children_.get(e);
      return n === null ? oi : n;
    }
  }
  /** @inheritDoc */
  getChild(e) {
    const n = X(e);
    return n === null ? this : this.getImmediateChild(n).getChild(ue(e));
  }
  /** @inheritDoc */
  hasChild(e) {
    return this.children_.get(e) !== null;
  }
  /** @inheritDoc */
  updateImmediateChild(e, n) {
    if (S(n, "We should always be passing snapshot nodes"), e === ".priority")
      return this.updatePriority(n);
    {
      const s = new z(e, n);
      let r, i;
      n.isEmpty() ? (r = this.children_.remove(e), i = this.indexMap_.removeFromIndexes(s, this.children_)) : (r = this.children_.insert(e, n), i = this.indexMap_.addToIndexes(s, this.children_));
      const o = r.isEmpty() ? oi : this.priorityNode_;
      return new P(r, o, i);
    }
  }
  /** @inheritDoc */
  updateChild(e, n) {
    const s = X(e);
    if (s === null)
      return n;
    {
      S(X(e) !== ".priority" || Un(e) === 1, ".priority must be the last token in a path");
      const r = this.getImmediateChild(s).updateChild(ue(e), n);
      return this.updateImmediateChild(s, r);
    }
  }
  /** @inheritDoc */
  isEmpty() {
    return this.children_.isEmpty();
  }
  /** @inheritDoc */
  numChildren() {
    return this.children_.count();
  }
  /** @inheritDoc */
  val(e) {
    if (this.isEmpty())
      return null;
    const n = {};
    let s = 0, r = 0, i = !0;
    if (this.forEachChild(Ee, (o, a) => {
      n[o] = a.val(e), s++, i && P.INTEGER_REGEXP_.test(o) ? r = Math.max(r, Number(o)) : i = !1;
    }), !e && i && r < 2 * s) {
      const o = [];
      for (const a in n)
        o[a] = n[a];
      return o;
    } else
      return e && !this.getPriority().isEmpty() && (n[".priority"] = this.getPriority().val()), n;
  }
  /** @inheritDoc */
  hash() {
    if (this.lazyHash_ === null) {
      let e = "";
      this.getPriority().isEmpty() || (e += "priority:" + y_(this.getPriority().val()) + ":"), this.forEachChild(Ee, (n, s) => {
        const r = s.hash();
        r !== "" && (e += ":" + n + ":" + r);
      }), this.lazyHash_ = e === "" ? "" : qg(e);
    }
    return this.lazyHash_;
  }
  /** @inheritDoc */
  getPredecessorChildName(e, n, s) {
    const r = this.resolveIndex_(s);
    if (r) {
      const i = r.getPredecessorKey(new z(e, n));
      return i ? i.name : null;
    } else
      return this.children_.getPredecessorKey(e);
  }
  getFirstChildName(e) {
    const n = this.resolveIndex_(e);
    if (n) {
      const s = n.minKey();
      return s && s.name;
    } else
      return this.children_.minKey();
  }
  getFirstChild(e) {
    const n = this.getFirstChildName(e);
    return n ? new z(n, this.children_.get(n)) : null;
  }
  /**
   * Given an index, return the key name of the largest value we have, according to that index
   */
  getLastChildName(e) {
    const n = this.resolveIndex_(e);
    if (n) {
      const s = n.maxKey();
      return s && s.name;
    } else
      return this.children_.maxKey();
  }
  getLastChild(e) {
    const n = this.getLastChildName(e);
    return n ? new z(n, this.children_.get(n)) : null;
  }
  forEachChild(e, n) {
    const s = this.resolveIndex_(e);
    return s ? s.inorderTraversal((r) => n(r.name, r.node)) : this.children_.inorderTraversal(n);
  }
  getIterator(e) {
    return this.getIteratorFrom(e.minPost(), e);
  }
  getIteratorFrom(e, n) {
    const s = this.resolveIndex_(n);
    if (s)
      return s.getIteratorFrom(e, (r) => r);
    {
      const r = this.children_.getIteratorFrom(e.name, z.Wrap);
      let i = r.peek();
      for (; i != null && n.compare(i, e) < 0; )
        r.getNext(), i = r.peek();
      return r;
    }
  }
  getReverseIterator(e) {
    return this.getReverseIteratorFrom(e.maxPost(), e);
  }
  getReverseIteratorFrom(e, n) {
    const s = this.resolveIndex_(n);
    if (s)
      return s.getReverseIteratorFrom(e, (r) => r);
    {
      const r = this.children_.getReverseIteratorFrom(e.name, z.Wrap);
      let i = r.peek();
      for (; i != null && n.compare(i, e) > 0; )
        r.getNext(), i = r.peek();
      return r;
    }
  }
  compareTo(e) {
    return this.isEmpty() ? e.isEmpty() ? 0 : -1 : e.isLeafNode() || e.isEmpty() ? 1 : e === ao ? -1 : 0;
  }
  withIndex(e) {
    if (e === hr || this.indexMap_.hasIndex(e))
      return this;
    {
      const n = this.indexMap_.addIndex(e, this.children_);
      return new P(this.children_, this.priorityNode_, n);
    }
  }
  isIndexed(e) {
    return e === hr || this.indexMap_.hasIndex(e);
  }
  equals(e) {
    if (e === this)
      return !0;
    if (e.isLeafNode())
      return !1;
    {
      const n = e;
      if (this.getPriority().equals(n.getPriority()))
        if (this.children_.count() === n.children_.count()) {
          const s = this.getIterator(Ee), r = n.getIterator(Ee);
          let i = s.getNext(), o = r.getNext();
          for (; i && o; ) {
            if (i.name !== o.name || !i.node.equals(o.node))
              return !1;
            i = s.getNext(), o = r.getNext();
          }
          return i === null && o === null;
        } else
          return !1;
      else return !1;
    }
  }
  /**
   * Returns a SortedMap ordered by index, or null if the default (by-key) ordering can be used
   * instead.
   *
   */
  resolveIndex_(e) {
    return e === hr ? null : this.indexMap_.get(e.toString());
  }
}
P.INTEGER_REGEXP_ = /^(0|[1-9]\d*)$/;
class wA extends P {
  constructor() {
    super(new et(ku), P.EMPTY_NODE, Jt.Default);
  }
  compareTo(e) {
    return e === this ? 0 : 1;
  }
  equals(e) {
    return e === this;
  }
  getPriority() {
    return this;
  }
  getImmediateChild(e) {
    return P.EMPTY_NODE;
  }
  isEmpty() {
    return !1;
  }
}
const ao = new wA();
Object.defineProperties(z, {
  MIN: {
    value: new z(Sr, P.EMPTY_NODE)
  },
  MAX: {
    value: new z(Ss, ao)
  }
});
__.__EMPTY_NODE = P.EMPTY_NODE;
Ae.__childrenNodeConstructor = P;
_A(ao);
EA(ao);
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const TA = !0;
function Te(t, e = null) {
  if (t === null)
    return P.EMPTY_NODE;
  if (typeof t == "object" && ".priority" in t && (e = t[".priority"]), S(e === null || typeof e == "string" || typeof e == "number" || typeof e == "object" && ".sv" in e, "Invalid priority type found: " + typeof e), typeof t == "object" && ".value" in t && t[".value"] !== null && (t = t[".value"]), typeof t != "object" || ".sv" in t) {
    const n = t;
    return new Ae(n, Te(e));
  }
  if (!(t instanceof Array) && TA) {
    const n = [];
    let s = !1;
    if (Me(t, (o, a) => {
      if (o.substring(0, 1) !== ".") {
        const c = Te(a);
        c.isEmpty() || (s = s || !c.getPriority().isEmpty(), n.push(new z(o, c)));
      }
    }), n.length === 0)
      return P.EMPTY_NODE;
    const i = ka(n, gA, (o) => o.name, ku);
    if (s) {
      const o = ka(n, Ee.getCompare());
      return new P(i, Te(e), new Jt({ ".priority": o }, { ".priority": Ee }));
    } else
      return new P(i, Te(e), Jt.Default);
  } else {
    let n = P.EMPTY_NODE;
    return Me(t, (s, r) => {
      if ($t(t, s) && s.substring(0, 1) !== ".") {
        const i = Te(r);
        (i.isLeafNode() || !i.isEmpty()) && (n = n.updateImmediateChild(s, i));
      }
    }), n.updatePriority(Te(e));
  }
}
yA(Te);
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class IA extends _c {
  constructor(e) {
    super(), this.indexPath_ = e, S(!K(e) && X(e) !== ".priority", "Can't create PathIndex with empty path or .priority key");
  }
  extractChild(e) {
    return e.getChild(this.indexPath_);
  }
  isDefinedOn(e) {
    return !e.getChild(this.indexPath_).isEmpty();
  }
  compare(e, n) {
    const s = this.extractChild(e.node), r = this.extractChild(n.node), i = s.compareTo(r);
    return i === 0 ? Rs(e.name, n.name) : i;
  }
  makePost(e, n) {
    const s = Te(e), r = P.EMPTY_NODE.updateChild(this.indexPath_, s);
    return new z(n, r);
  }
  maxPost() {
    const e = P.EMPTY_NODE.updateChild(this.indexPath_, ao);
    return new z(Ss, e);
  }
  toString() {
    return xi(this.indexPath_, 0).join("/");
  }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class CA extends _c {
  compare(e, n) {
    const s = e.node.compareTo(n.node);
    return s === 0 ? Rs(e.name, n.name) : s;
  }
  isDefinedOn(e) {
    return !0;
  }
  indexedValueChanged(e, n) {
    return !e.equals(n);
  }
  minPost() {
    return z.MIN;
  }
  maxPost() {
    return z.MAX;
  }
  makePost(e, n) {
    const s = Te(e);
    return new z(n, s);
  }
  /**
   * @returns String representation for inclusion in a query spec
   */
  toString() {
    return ".value";
  }
}
const FA = new CA();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function S_(t) {
  return { type: "value", snapshotNode: t };
}
function wr(t, e) {
  return { type: "child_added", snapshotNode: e, childName: t };
}
function Oi(t, e) {
  return { type: "child_removed", snapshotNode: e, childName: t };
}
function Pi(t, e, n) {
  return {
    type: "child_changed",
    snapshotNode: e,
    childName: t,
    oldSnap: n
  };
}
function kA(t, e) {
  return { type: "child_moved", snapshotNode: e, childName: t };
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class Au {
  constructor(e) {
    this.index_ = e;
  }
  updateChild(e, n, s, r, i, o) {
    S(e.isIndexed(this.index_), "A node must be indexed if only a child is updated");
    const a = e.getImmediateChild(n);
    return a.getChild(r).equals(s.getChild(r)) && a.isEmpty() === s.isEmpty() || (o != null && (s.isEmpty() ? e.hasChild(n) ? o.trackChildChange(Oi(n, a)) : S(e.isLeafNode(), "A child remove without an old child only makes sense on a leaf node") : a.isEmpty() ? o.trackChildChange(wr(n, s)) : o.trackChildChange(Pi(n, s, a))), e.isLeafNode() && s.isEmpty()) ? e : e.updateImmediateChild(n, s).withIndex(this.index_);
  }
  updateFullNode(e, n, s) {
    return s != null && (e.isLeafNode() || e.forEachChild(Ee, (r, i) => {
      n.hasChild(r) || s.trackChildChange(Oi(r, i));
    }), n.isLeafNode() || n.forEachChild(Ee, (r, i) => {
      if (e.hasChild(r)) {
        const o = e.getImmediateChild(r);
        o.equals(i) || s.trackChildChange(Pi(r, i, o));
      } else
        s.trackChildChange(wr(r, i));
    })), n.withIndex(this.index_);
  }
  updatePriority(e, n) {
    return e.isEmpty() ? P.EMPTY_NODE : e.updatePriority(n);
  }
  filtersNodes() {
    return !1;
  }
  getIndexedFilter() {
    return this;
  }
  getIndex() {
    return this.index_;
  }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class Mi {
  constructor(e) {
    this.indexedFilter_ = new Au(e.getIndex()), this.index_ = e.getIndex(), this.startPost_ = Mi.getStartPost_(e), this.endPost_ = Mi.getEndPost_(e), this.startIsInclusive_ = !e.startAfterSet_, this.endIsInclusive_ = !e.endBeforeSet_;
  }
  getStartPost() {
    return this.startPost_;
  }
  getEndPost() {
    return this.endPost_;
  }
  matches(e) {
    const n = this.startIsInclusive_ ? this.index_.compare(this.getStartPost(), e) <= 0 : this.index_.compare(this.getStartPost(), e) < 0, s = this.endIsInclusive_ ? this.index_.compare(e, this.getEndPost()) <= 0 : this.index_.compare(e, this.getEndPost()) < 0;
    return n && s;
  }
  updateChild(e, n, s, r, i, o) {
    return this.matches(new z(n, s)) || (s = P.EMPTY_NODE), this.indexedFilter_.updateChild(e, n, s, r, i, o);
  }
  updateFullNode(e, n, s) {
    n.isLeafNode() && (n = P.EMPTY_NODE);
    let r = n.withIndex(this.index_);
    r = r.updatePriority(P.EMPTY_NODE);
    const i = this;
    return n.forEachChild(Ee, (o, a) => {
      i.matches(new z(o, a)) || (r = r.updateImmediateChild(o, P.EMPTY_NODE));
    }), this.indexedFilter_.updateFullNode(e, r, s);
  }
  updatePriority(e, n) {
    return e;
  }
  filtersNodes() {
    return !0;
  }
  getIndexedFilter() {
    return this.indexedFilter_;
  }
  getIndex() {
    return this.index_;
  }
  static getStartPost_(e) {
    if (e.hasStart()) {
      const n = e.getIndexStartName();
      return e.getIndex().makePost(e.getIndexStartValue(), n);
    } else
      return e.getIndex().minPost();
  }
  static getEndPost_(e) {
    if (e.hasEnd()) {
      const n = e.getIndexEndName();
      return e.getIndex().makePost(e.getIndexEndValue(), n);
    } else
      return e.getIndex().maxPost();
  }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class AA {
  constructor(e) {
    this.withinDirectionalStart = (n) => this.reverse_ ? this.withinEndPost(n) : this.withinStartPost(n), this.withinDirectionalEnd = (n) => this.reverse_ ? this.withinStartPost(n) : this.withinEndPost(n), this.withinStartPost = (n) => {
      const s = this.index_.compare(this.rangedFilter_.getStartPost(), n);
      return this.startIsInclusive_ ? s <= 0 : s < 0;
    }, this.withinEndPost = (n) => {
      const s = this.index_.compare(n, this.rangedFilter_.getEndPost());
      return this.endIsInclusive_ ? s <= 0 : s < 0;
    }, this.rangedFilter_ = new Mi(e), this.index_ = e.getIndex(), this.limit_ = e.getLimit(), this.reverse_ = !e.isViewFromLeft(), this.startIsInclusive_ = !e.startAfterSet_, this.endIsInclusive_ = !e.endBeforeSet_;
  }
  updateChild(e, n, s, r, i, o) {
    return this.rangedFilter_.matches(new z(n, s)) || (s = P.EMPTY_NODE), e.getImmediateChild(n).equals(s) ? e : e.numChildren() < this.limit_ ? this.rangedFilter_.getIndexedFilter().updateChild(e, n, s, r, i, o) : this.fullLimitUpdateChild_(e, n, s, i, o);
  }
  updateFullNode(e, n, s) {
    let r;
    if (n.isLeafNode() || n.isEmpty())
      r = P.EMPTY_NODE.withIndex(this.index_);
    else if (this.limit_ * 2 < n.numChildren() && n.isIndexed(this.index_)) {
      r = P.EMPTY_NODE.withIndex(this.index_);
      let i;
      this.reverse_ ? i = n.getReverseIteratorFrom(this.rangedFilter_.getEndPost(), this.index_) : i = n.getIteratorFrom(this.rangedFilter_.getStartPost(), this.index_);
      let o = 0;
      for (; i.hasNext() && o < this.limit_; ) {
        const a = i.getNext();
        if (this.withinDirectionalStart(a))
          if (this.withinDirectionalEnd(a))
            r = r.updateImmediateChild(a.name, a.node), o++;
          else
            break;
        else continue;
      }
    } else {
      r = n.withIndex(this.index_), r = r.updatePriority(P.EMPTY_NODE);
      let i;
      this.reverse_ ? i = r.getReverseIterator(this.index_) : i = r.getIterator(this.index_);
      let o = 0;
      for (; i.hasNext(); ) {
        const a = i.getNext();
        o < this.limit_ && this.withinDirectionalStart(a) && this.withinDirectionalEnd(a) ? o++ : r = r.updateImmediateChild(a.name, P.EMPTY_NODE);
      }
    }
    return this.rangedFilter_.getIndexedFilter().updateFullNode(e, r, s);
  }
  updatePriority(e, n) {
    return e;
  }
  filtersNodes() {
    return !0;
  }
  getIndexedFilter() {
    return this.rangedFilter_.getIndexedFilter();
  }
  getIndex() {
    return this.index_;
  }
  fullLimitUpdateChild_(e, n, s, r, i) {
    let o;
    if (this.reverse_) {
      const u = this.index_.getCompare();
      o = (h, p) => u(p, h);
    } else
      o = this.index_.getCompare();
    const a = e;
    S(a.numChildren() === this.limit_, "");
    const c = new z(n, s), l = this.reverse_ ? a.getFirstChild(this.index_) : a.getLastChild(this.index_), d = this.rangedFilter_.matches(c);
    if (a.hasChild(n)) {
      const u = a.getImmediateChild(n);
      let h = r.getChildAfterChild(this.index_, l, this.reverse_);
      for (; h != null && (h.name === n || a.hasChild(h.name)); )
        h = r.getChildAfterChild(this.index_, h, this.reverse_);
      const p = h == null ? 1 : o(h, c);
      if (d && !s.isEmpty() && p >= 0)
        return i != null && i.trackChildChange(Pi(n, s, u)), a.updateImmediateChild(n, s);
      {
        i != null && i.trackChildChange(Oi(n, u));
        const m = a.updateImmediateChild(n, P.EMPTY_NODE);
        return h != null && this.rangedFilter_.matches(h) ? (i != null && i.trackChildChange(wr(h.name, h.node)), m.updateImmediateChild(h.name, h.node)) : m;
      }
    } else return s.isEmpty() ? e : d && o(l, c) >= 0 ? (i != null && (i.trackChildChange(Oi(l.name, l.node)), i.trackChildChange(wr(n, s))), a.updateImmediateChild(n, s).updateImmediateChild(l.name, P.EMPTY_NODE)) : e;
  }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class Nu {
  constructor() {
    this.limitSet_ = !1, this.startSet_ = !1, this.startNameSet_ = !1, this.startAfterSet_ = !1, this.endSet_ = !1, this.endNameSet_ = !1, this.endBeforeSet_ = !1, this.limit_ = 0, this.viewFrom_ = "", this.indexStartValue_ = null, this.indexStartName_ = "", this.indexEndValue_ = null, this.indexEndName_ = "", this.index_ = Ee;
  }
  hasStart() {
    return this.startSet_;
  }
  /**
   * @returns True if it would return from left.
   */
  isViewFromLeft() {
    return this.viewFrom_ === "" ? this.startSet_ : this.viewFrom_ === "l";
  }
  /**
   * Only valid to call if hasStart() returns true
   */
  getIndexStartValue() {
    return S(this.startSet_, "Only valid if start has been set"), this.indexStartValue_;
  }
  /**
   * Only valid to call if hasStart() returns true.
   * Returns the starting key name for the range defined by these query parameters
   */
  getIndexStartName() {
    return S(this.startSet_, "Only valid if start has been set"), this.startNameSet_ ? this.indexStartName_ : Sr;
  }
  hasEnd() {
    return this.endSet_;
  }
  /**
   * Only valid to call if hasEnd() returns true.
   */
  getIndexEndValue() {
    return S(this.endSet_, "Only valid if end has been set"), this.indexEndValue_;
  }
  /**
   * Only valid to call if hasEnd() returns true.
   * Returns the end key name for the range defined by these query parameters
   */
  getIndexEndName() {
    return S(this.endSet_, "Only valid if end has been set"), this.endNameSet_ ? this.indexEndName_ : Ss;
  }
  hasLimit() {
    return this.limitSet_;
  }
  /**
   * @returns True if a limit has been set and it has been explicitly anchored
   */
  hasAnchoredLimit() {
    return this.limitSet_ && this.viewFrom_ !== "";
  }
  /**
   * Only valid to call if hasLimit() returns true
   */
  getLimit() {
    return S(this.limitSet_, "Only valid if limit has been set"), this.limit_;
  }
  getIndex() {
    return this.index_;
  }
  loadsAllData() {
    return !(this.startSet_ || this.endSet_ || this.limitSet_);
  }
  isDefault() {
    return this.loadsAllData() && this.index_ === Ee;
  }
  copy() {
    const e = new Nu();
    return e.limitSet_ = this.limitSet_, e.limit_ = this.limit_, e.startSet_ = this.startSet_, e.startAfterSet_ = this.startAfterSet_, e.indexStartValue_ = this.indexStartValue_, e.startNameSet_ = this.startNameSet_, e.indexStartName_ = this.indexStartName_, e.endSet_ = this.endSet_, e.endBeforeSet_ = this.endBeforeSet_, e.indexEndValue_ = this.indexEndValue_, e.endNameSet_ = this.endNameSet_, e.indexEndName_ = this.indexEndName_, e.index_ = this.index_, e.viewFrom_ = this.viewFrom_, e;
  }
}
function NA(t) {
  return t.loadsAllData() ? new Au(t.getIndex()) : t.hasLimit() ? new AA(t) : new Mi(t);
}
function lf(t) {
  const e = {};
  if (t.isDefault())
    return e;
  let n;
  if (t.index_ === Ee ? n = "$priority" : t.index_ === FA ? n = "$value" : t.index_ === hr ? n = "$key" : (S(t.index_ instanceof IA, "Unrecognized index type!"), n = t.index_.toString()), e.orderBy = Ie(n), t.startSet_) {
    const s = t.startAfterSet_ ? "startAfter" : "startAt";
    e[s] = Ie(t.indexStartValue_), t.startNameSet_ && (e[s] += "," + Ie(t.indexStartName_));
  }
  if (t.endSet_) {
    const s = t.endBeforeSet_ ? "endBefore" : "endAt";
    e[s] = Ie(t.indexEndValue_), t.endNameSet_ && (e[s] += "," + Ie(t.indexEndName_));
  }
  return t.limitSet_ && (t.isViewFromLeft() ? e.limitToFirst = t.limit_ : e.limitToLast = t.limit_), e;
}
function df(t) {
  const e = {};
  if (t.startSet_ && (e.sp = t.indexStartValue_, t.startNameSet_ && (e.sn = t.indexStartName_), e.sin = !t.startAfterSet_), t.endSet_ && (e.ep = t.indexEndValue_, t.endNameSet_ && (e.en = t.indexEndName_), e.ein = !t.endBeforeSet_), t.limitSet_) {
    e.l = t.limit_;
    let n = t.viewFrom_;
    n === "" && (t.isViewFromLeft() ? n = "l" : n = "r"), e.vf = n;
  }
  return t.index_ !== Ee && (e.i = t.index_.toString()), e;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class Aa extends h_ {
  /**
   * @param repoInfo_ - Data about the namespace we are connecting to
   * @param onDataUpdate_ - A callback for new data from the server
   */
  constructor(e, n, s, r) {
    super(), this.repoInfo_ = e, this.onDataUpdate_ = n, this.authTokenProvider_ = s, this.appCheckTokenProvider_ = r, this.log_ = oo("p:rest:"), this.listens_ = {};
  }
  reportStats(e) {
    throw new Error("Method not implemented.");
  }
  static getListenId_(e, n) {
    return n !== void 0 ? "tag$" + n : (S(e._queryParams.isDefault(), "should have a tag if it's not a default query."), e._path.toString());
  }
  /** @inheritDoc */
  listen(e, n, s, r) {
    const i = e._path.toString();
    this.log_("Listen called for " + i + " " + e._queryIdentifier);
    const o = Aa.getListenId_(e, s), a = {};
    this.listens_[o] = a;
    const c = lf(e._queryParams);
    this.restRequest_(i + ".json", c, (l, d) => {
      let u = d;
      if (l === 404 && (u = null, l = null), l === null && this.onDataUpdate_(
        i,
        u,
        /*isMerge=*/
        !1,
        s
      ), br(this.listens_, o) === a) {
        let h;
        l ? l === 401 ? h = "permission_denied" : h = "rest_error:" + l : h = "ok", r(h, null);
      }
    });
  }
  /** @inheritDoc */
  unlisten(e, n) {
    const s = Aa.getListenId_(e, n);
    delete this.listens_[s];
  }
  get(e) {
    const n = lf(e._queryParams), s = e._path.toString(), r = new Zi();
    return this.restRequest_(s + ".json", n, (i, o) => {
      let a = o;
      i === 404 && (a = null, i = null), i === null ? (this.onDataUpdate_(
        s,
        a,
        /*isMerge=*/
        !1,
        /*tag=*/
        null
      ), r.resolve(a)) : r.reject(new Error(a));
    }), r.promise;
  }
  /** @inheritDoc */
  refreshAuthToken(e) {
  }
  /**
   * Performs a REST request to the given path, with the provided query string parameters,
   * and any auth credentials we have.
   */
  restRequest_(e, n = {}, s) {
    return n.format = "export", Promise.all([
      this.authTokenProvider_.getToken(
        /*forceRefresh=*/
        !1
      ),
      this.appCheckTokenProvider_.getToken(
        /*forceRefresh=*/
        !1
      )
    ]).then(([r, i]) => {
      r && r.accessToken && (n.auth = r.accessToken), i && i.token && (n.ac = i.token);
      const o = (this.repoInfo_.secure ? "https://" : "http://") + this.repoInfo_.host + e + "?ns=" + this.repoInfo_.namespace + Ur(n);
      this.log_("Sending REST request for " + o);
      const a = new XMLHttpRequest();
      a.onreadystatechange = () => {
        if (s && a.readyState === 4) {
          this.log_("REST Response for " + o + " received. status:", a.status, "response:", a.responseText);
          let c = null;
          if (a.status >= 200 && a.status < 300) {
            try {
              c = Fi(a.responseText);
            } catch {
              ze("Failed to parse JSON response for " + o + ": " + a.responseText);
            }
            s(null, c);
          } else
            a.status !== 401 && a.status !== 404 && ze("Got unsuccessful REST response for " + o + " Status: " + a.status), s(a.status);
          s = null;
        }
      }, a.open(
        "GET",
        o,
        /*asynchronous=*/
        !0
      ), a.send();
    });
  }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class LA {
  constructor() {
    this.rootNode_ = P.EMPTY_NODE;
  }
  getNode(e) {
    return this.rootNode_.getChild(e);
  }
  updateSnapshot(e, n) {
    this.rootNode_ = this.rootNode_.updateChild(e, n);
  }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function Na() {
  return {
    value: null,
    children: /* @__PURE__ */ new Map()
  };
}
function w_(t, e, n) {
  if (K(e))
    t.value = n, t.children.clear();
  else if (t.value !== null)
    t.value = t.value.updateChild(e, n);
  else {
    const s = X(e);
    t.children.has(s) || t.children.set(s, Na());
    const r = t.children.get(s);
    e = ue(e), w_(r, e, n);
  }
}
function Xl(t, e, n) {
  t.value !== null ? n(e, t.value) : RA(t, (s, r) => {
    const i = new oe(e.toString() + "/" + s);
    Xl(r, i, n);
  });
}
function RA(t, e) {
  t.children.forEach((n, s) => {
    e(s, n);
  });
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class xA {
  constructor(e) {
    this.collection_ = e, this.last_ = null;
  }
  get() {
    const e = this.collection_.get(), n = Object.assign({}, e);
    return this.last_ && Me(this.last_, (s, r) => {
      n[s] = n[s] - r;
    }), this.last_ = e, n;
  }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const uf = 10 * 1e3, OA = 30 * 1e3, PA = 5 * 60 * 1e3;
class MA {
  constructor(e, n) {
    this.server_ = n, this.statsToReport_ = {}, this.statsListener_ = new xA(e);
    const s = uf + (OA - uf) * Math.random();
    _i(this.reportStats_.bind(this), Math.floor(s));
  }
  reportStats_() {
    const e = this.statsListener_.get(), n = {};
    let s = !1;
    Me(e, (r, i) => {
      i > 0 && $t(this.statsToReport_, r) && (n[r] = i, s = !0);
    }), s && this.server_.reportStats(n), _i(this.reportStats_.bind(this), Math.floor(Math.random() * 2 * PA));
  }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var Tt;
(function(t) {
  t[t.OVERWRITE = 0] = "OVERWRITE", t[t.MERGE = 1] = "MERGE", t[t.ACK_USER_WRITE = 2] = "ACK_USER_WRITE", t[t.LISTEN_COMPLETE = 3] = "LISTEN_COMPLETE";
})(Tt || (Tt = {}));
function Lu() {
  return {
    fromUser: !0,
    fromServer: !1,
    queryId: null,
    tagged: !1
  };
}
function Ru() {
  return {
    fromUser: !1,
    fromServer: !0,
    queryId: null,
    tagged: !1
  };
}
function xu(t) {
  return {
    fromUser: !1,
    fromServer: !0,
    queryId: t,
    tagged: !0
  };
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class La {
  /**
   * @param affectedTree - A tree containing true for each affected path. Affected paths can't overlap.
   */
  constructor(e, n, s) {
    this.path = e, this.affectedTree = n, this.revert = s, this.type = Tt.ACK_USER_WRITE, this.source = Lu();
  }
  operationForChild(e) {
    if (K(this.path)) {
      if (this.affectedTree.value != null)
        return S(this.affectedTree.children.isEmpty(), "affectedTree should not have overlapping affected paths."), this;
      {
        const n = this.affectedTree.subtree(new oe(e));
        return new La(se(), n, this.revert);
      }
    } else return S(X(this.path) === e, "operationForChild called for unrelated child."), new La(ue(this.path), this.affectedTree, this.revert);
  }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class Di {
  constructor(e, n) {
    this.source = e, this.path = n, this.type = Tt.LISTEN_COMPLETE;
  }
  operationForChild(e) {
    return K(this.path) ? new Di(this.source, se()) : new Di(this.source, ue(this.path));
  }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class ws {
  constructor(e, n, s) {
    this.source = e, this.path = n, this.snap = s, this.type = Tt.OVERWRITE;
  }
  operationForChild(e) {
    return K(this.path) ? new ws(this.source, se(), this.snap.getImmediateChild(e)) : new ws(this.source, ue(this.path), this.snap);
  }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class Tr {
  constructor(e, n, s) {
    this.source = e, this.path = n, this.children = s, this.type = Tt.MERGE;
  }
  operationForChild(e) {
    if (K(this.path)) {
      const n = this.children.subtree(new oe(e));
      return n.isEmpty() ? null : n.value ? new ws(this.source, se(), n.value) : new Tr(this.source, se(), n);
    } else
      return S(X(this.path) === e, "Can't get a merge for a child not on the path of the operation"), new Tr(this.source, ue(this.path), this.children);
  }
  toString() {
    return "Operation(" + this.path + ": " + this.source.toString() + " merge: " + this.children.toString() + ")";
  }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class Hn {
  constructor(e, n, s) {
    this.node_ = e, this.fullyInitialized_ = n, this.filtered_ = s;
  }
  /**
   * Returns whether this node was fully initialized with either server data or a complete overwrite by the client
   */
  isFullyInitialized() {
    return this.fullyInitialized_;
  }
  /**
   * Returns whether this node is potentially missing children due to a filter applied to the node
   */
  isFiltered() {
    return this.filtered_;
  }
  isCompleteForPath(e) {
    if (K(e))
      return this.isFullyInitialized() && !this.filtered_;
    const n = X(e);
    return this.isCompleteForChild(n);
  }
  isCompleteForChild(e) {
    return this.isFullyInitialized() && !this.filtered_ || this.node_.hasChild(e);
  }
  getNode() {
    return this.node_;
  }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class DA {
  constructor(e) {
    this.query_ = e, this.index_ = this.query_._queryParams.getIndex();
  }
}
function GA(t, e, n, s) {
  const r = [], i = [];
  return e.forEach((o) => {
    o.type === "child_changed" && t.index_.indexedValueChanged(o.oldSnap, o.snapshotNode) && i.push(kA(o.childName, o.snapshotNode));
  }), ai(t, r, "child_removed", e, s, n), ai(t, r, "child_added", e, s, n), ai(t, r, "child_moved", i, s, n), ai(t, r, "child_changed", e, s, n), ai(t, r, "value", e, s, n), r;
}
function ai(t, e, n, s, r, i) {
  const o = s.filter((a) => a.type === n);
  o.sort((a, c) => $A(t, a, c)), o.forEach((a) => {
    const c = BA(t, a, i);
    r.forEach((l) => {
      l.respondsTo(a.type) && e.push(l.createEvent(c, t.query_));
    });
  });
}
function BA(t, e, n) {
  return e.type === "value" || e.type === "child_removed" || (e.prevName = n.getPredecessorChildName(e.childName, e.snapshotNode, t.index_)), e;
}
function $A(t, e, n) {
  if (e.childName == null || n.childName == null)
    throw Vr("Should only compare child_ events.");
  const s = new z(e.childName, e.snapshotNode), r = new z(n.childName, n.snapshotNode);
  return t.index_.compare(s, r);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function yc(t, e) {
  return { eventCache: t, serverCache: e };
}
function yi(t, e, n, s) {
  return yc(new Hn(e, n, s), t.serverCache);
}
function T_(t, e, n, s) {
  return yc(t.eventCache, new Hn(e, n, s));
}
function Ra(t) {
  return t.eventCache.isFullyInitialized() ? t.eventCache.getNode() : null;
}
function Ts(t) {
  return t.serverCache.isFullyInitialized() ? t.serverCache.getNode() : null;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
let fl;
const VA = () => (fl || (fl = new et(Ik)), fl);
class de {
  constructor(e, n = VA()) {
    this.value = e, this.children = n;
  }
  static fromObject(e) {
    let n = new de(null);
    return Me(e, (s, r) => {
      n = n.set(new oe(s), r);
    }), n;
  }
  /**
   * True if the value is empty and there are no children
   */
  isEmpty() {
    return this.value === null && this.children.isEmpty();
  }
  /**
   * Given a path and predicate, return the first node and the path to that node
   * where the predicate returns true.
   *
   * TODO Do a perf test -- If we're creating a bunch of `{path: value:}`
   * objects on the way back out, it may be better to pass down a pathSoFar obj.
   *
   * @param relativePath - The remainder of the path
   * @param predicate - The predicate to satisfy to return a node
   */
  findRootMostMatchingPathAndValue(e, n) {
    if (this.value != null && n(this.value))
      return { path: se(), value: this.value };
    if (K(e))
      return null;
    {
      const s = X(e), r = this.children.get(s);
      if (r !== null) {
        const i = r.findRootMostMatchingPathAndValue(ue(e), n);
        return i != null ? { path: ye(new oe(s), i.path), value: i.value } : null;
      } else
        return null;
    }
  }
  /**
   * Find, if it exists, the shortest subpath of the given path that points a defined
   * value in the tree
   */
  findRootMostValueAndPath(e) {
    return this.findRootMostMatchingPathAndValue(e, () => !0);
  }
  /**
   * @returns The subtree at the given path
   */
  subtree(e) {
    if (K(e))
      return this;
    {
      const n = X(e), s = this.children.get(n);
      return s !== null ? s.subtree(ue(e)) : new de(null);
    }
  }
  /**
   * Sets a value at the specified path.
   *
   * @param relativePath - Path to set value at.
   * @param toSet - Value to set.
   * @returns Resulting tree.
   */
  set(e, n) {
    if (K(e))
      return new de(n, this.children);
    {
      const s = X(e), i = (this.children.get(s) || new de(null)).set(ue(e), n), o = this.children.insert(s, i);
      return new de(this.value, o);
    }
  }
  /**
   * Removes the value at the specified path.
   *
   * @param relativePath - Path to value to remove.
   * @returns Resulting tree.
   */
  remove(e) {
    if (K(e))
      return this.children.isEmpty() ? new de(null) : new de(null, this.children);
    {
      const n = X(e), s = this.children.get(n);
      if (s) {
        const r = s.remove(ue(e));
        let i;
        return r.isEmpty() ? i = this.children.remove(n) : i = this.children.insert(n, r), this.value === null && i.isEmpty() ? new de(null) : new de(this.value, i);
      } else
        return this;
    }
  }
  /**
   * Gets a value from the tree.
   *
   * @param relativePath - Path to get value for.
   * @returns Value at path, or null.
   */
  get(e) {
    if (K(e))
      return this.value;
    {
      const n = X(e), s = this.children.get(n);
      return s ? s.get(ue(e)) : null;
    }
  }
  /**
   * Replace the subtree at the specified path with the given new tree.
   *
   * @param relativePath - Path to replace subtree for.
   * @param newTree - New tree.
   * @returns Resulting tree.
   */
  setTree(e, n) {
    if (K(e))
      return n;
    {
      const s = X(e), i = (this.children.get(s) || new de(null)).setTree(ue(e), n);
      let o;
      return i.isEmpty() ? o = this.children.remove(s) : o = this.children.insert(s, i), new de(this.value, o);
    }
  }
  /**
   * Performs a depth first fold on this tree. Transforms a tree into a single
   * value, given a function that operates on the path to a node, an optional
   * current value, and a map of child names to folded subtrees
   */
  fold(e) {
    return this.fold_(se(), e);
  }
  /**
   * Recursive helper for public-facing fold() method
   */
  fold_(e, n) {
    const s = {};
    return this.children.inorderTraversal((r, i) => {
      s[r] = i.fold_(ye(e, r), n);
    }), n(e, this.value, s);
  }
  /**
   * Find the first matching value on the given path. Return the result of applying f to it.
   */
  findOnPath(e, n) {
    return this.findOnPath_(e, se(), n);
  }
  findOnPath_(e, n, s) {
    const r = this.value ? s(n, this.value) : !1;
    if (r)
      return r;
    if (K(e))
      return null;
    {
      const i = X(e), o = this.children.get(i);
      return o ? o.findOnPath_(ue(e), ye(n, i), s) : null;
    }
  }
  foreachOnPath(e, n) {
    return this.foreachOnPath_(e, se(), n);
  }
  foreachOnPath_(e, n, s) {
    if (K(e))
      return this;
    {
      this.value && s(n, this.value);
      const r = X(e), i = this.children.get(r);
      return i ? i.foreachOnPath_(ue(e), ye(n, r), s) : new de(null);
    }
  }
  /**
   * Calls the given function for each node in the tree that has a value.
   *
   * @param f - A function to be called with the path from the root of the tree to
   * a node, and the value at that node. Called in depth-first order.
   */
  foreach(e) {
    this.foreach_(se(), e);
  }
  foreach_(e, n) {
    this.children.inorderTraversal((s, r) => {
      r.foreach_(ye(e, s), n);
    }), this.value && n(e, this.value);
  }
  foreachChild(e) {
    this.children.inorderTraversal((n, s) => {
      s.value && e(n, s.value);
    });
  }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class It {
  constructor(e) {
    this.writeTree_ = e;
  }
  static empty() {
    return new It(new de(null));
  }
}
function Ei(t, e, n) {
  if (K(e))
    return new It(new de(n));
  {
    const s = t.writeTree_.findRootMostValueAndPath(e);
    if (s != null) {
      const r = s.path;
      let i = s.value;
      const o = He(r, e);
      return i = i.updateChild(o, n), new It(t.writeTree_.set(r, i));
    } else {
      const r = new de(n), i = t.writeTree_.setTree(e, r);
      return new It(i);
    }
  }
}
function Jl(t, e, n) {
  let s = t;
  return Me(n, (r, i) => {
    s = Ei(s, ye(e, r), i);
  }), s;
}
function hf(t, e) {
  if (K(e))
    return It.empty();
  {
    const n = t.writeTree_.setTree(e, new de(null));
    return new It(n);
  }
}
function Ql(t, e) {
  return xs(t, e) != null;
}
function xs(t, e) {
  const n = t.writeTree_.findRootMostValueAndPath(e);
  return n != null ? t.writeTree_.get(n.path).getChild(He(n.path, e)) : null;
}
function pf(t) {
  const e = [], n = t.writeTree_.value;
  return n != null ? n.isLeafNode() || n.forEachChild(Ee, (s, r) => {
    e.push(new z(s, r));
  }) : t.writeTree_.children.inorderTraversal((s, r) => {
    r.value != null && e.push(new z(s, r.value));
  }), e;
}
function On(t, e) {
  if (K(e))
    return t;
  {
    const n = xs(t, e);
    return n != null ? new It(new de(n)) : new It(t.writeTree_.subtree(e));
  }
}
function Zl(t) {
  return t.writeTree_.isEmpty();
}
function Ir(t, e) {
  return I_(se(), t.writeTree_, e);
}
function I_(t, e, n) {
  if (e.value != null)
    return n.updateChild(t, e.value);
  {
    let s = null;
    return e.children.inorderTraversal((r, i) => {
      r === ".priority" ? (S(i.value !== null, "Priority writes must always be leaf nodes"), s = i.value) : n = I_(ye(t, r), i, n);
    }), !n.getChild(t).isEmpty() && s !== null && (n = n.updateChild(ye(t, ".priority"), s)), n;
  }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function Ec(t, e) {
  return A_(e, t);
}
function UA(t, e, n, s, r) {
  S(s > t.lastWriteId, "Stacking an older write on top of newer ones"), r === void 0 && (r = !0), t.allWrites.push({
    path: e,
    snap: n,
    writeId: s,
    visible: r
  }), r && (t.visibleWrites = Ei(t.visibleWrites, e, n)), t.lastWriteId = s;
}
function HA(t, e, n, s) {
  S(s > t.lastWriteId, "Stacking an older merge on top of newer ones"), t.allWrites.push({
    path: e,
    children: n,
    writeId: s,
    visible: !0
  }), t.visibleWrites = Jl(t.visibleWrites, e, n), t.lastWriteId = s;
}
function jA(t, e) {
  for (let n = 0; n < t.allWrites.length; n++) {
    const s = t.allWrites[n];
    if (s.writeId === e)
      return s;
  }
  return null;
}
function WA(t, e) {
  const n = t.allWrites.findIndex((a) => a.writeId === e);
  S(n >= 0, "removeWrite called with nonexistent writeId.");
  const s = t.allWrites[n];
  t.allWrites.splice(n, 1);
  let r = s.visible, i = !1, o = t.allWrites.length - 1;
  for (; r && o >= 0; ) {
    const a = t.allWrites[o];
    a.visible && (o >= n && zA(a, s.path) ? r = !1 : ut(s.path, a.path) && (i = !0)), o--;
  }
  if (r) {
    if (i)
      return qA(t), !0;
    if (s.snap)
      t.visibleWrites = hf(t.visibleWrites, s.path);
    else {
      const a = s.children;
      Me(a, (c) => {
        t.visibleWrites = hf(t.visibleWrites, ye(s.path, c));
      });
    }
    return !0;
  } else return !1;
}
function zA(t, e) {
  if (t.snap)
    return ut(t.path, e);
  for (const n in t.children)
    if (t.children.hasOwnProperty(n) && ut(ye(t.path, n), e))
      return !0;
  return !1;
}
function qA(t) {
  t.visibleWrites = C_(t.allWrites, YA, se()), t.allWrites.length > 0 ? t.lastWriteId = t.allWrites[t.allWrites.length - 1].writeId : t.lastWriteId = -1;
}
function YA(t) {
  return t.visible;
}
function C_(t, e, n) {
  let s = It.empty();
  for (let r = 0; r < t.length; ++r) {
    const i = t[r];
    if (e(i)) {
      const o = i.path;
      let a;
      if (i.snap)
        ut(n, o) ? (a = He(n, o), s = Ei(s, a, i.snap)) : ut(o, n) && (a = He(o, n), s = Ei(s, se(), i.snap.getChild(a)));
      else if (i.children) {
        if (ut(n, o))
          a = He(n, o), s = Jl(s, a, i.children);
        else if (ut(o, n))
          if (a = He(o, n), K(a))
            s = Jl(s, se(), i.children);
          else {
            const c = br(i.children, X(a));
            if (c) {
              const l = c.getChild(ue(a));
              s = Ei(s, se(), l);
            }
          }
      } else
        throw Vr("WriteRecord should have .snap or .children");
    }
  }
  return s;
}
function F_(t, e, n, s, r) {
  if (!s && !r) {
    const i = xs(t.visibleWrites, e);
    if (i != null)
      return i;
    {
      const o = On(t.visibleWrites, e);
      if (Zl(o))
        return n;
      if (n == null && !Ql(o, se()))
        return null;
      {
        const a = n || P.EMPTY_NODE;
        return Ir(o, a);
      }
    }
  } else {
    const i = On(t.visibleWrites, e);
    if (!r && Zl(i))
      return n;
    if (!r && n == null && !Ql(i, se()))
      return null;
    {
      const o = function(l) {
        return (l.visible || r) && (!s || !~s.indexOf(l.writeId)) && (ut(l.path, e) || ut(e, l.path));
      }, a = C_(t.allWrites, o, e), c = n || P.EMPTY_NODE;
      return Ir(a, c);
    }
  }
}
function KA(t, e, n) {
  let s = P.EMPTY_NODE;
  const r = xs(t.visibleWrites, e);
  if (r)
    return r.isLeafNode() || r.forEachChild(Ee, (i, o) => {
      s = s.updateImmediateChild(i, o);
    }), s;
  if (n) {
    const i = On(t.visibleWrites, e);
    return n.forEachChild(Ee, (o, a) => {
      const c = Ir(On(i, new oe(o)), a);
      s = s.updateImmediateChild(o, c);
    }), pf(i).forEach((o) => {
      s = s.updateImmediateChild(o.name, o.node);
    }), s;
  } else {
    const i = On(t.visibleWrites, e);
    return pf(i).forEach((o) => {
      s = s.updateImmediateChild(o.name, o.node);
    }), s;
  }
}
function XA(t, e, n, s, r) {
  S(s || r, "Either existingEventSnap or existingServerSnap must exist");
  const i = ye(e, n);
  if (Ql(t.visibleWrites, i))
    return null;
  {
    const o = On(t.visibleWrites, i);
    return Zl(o) ? r.getChild(n) : Ir(o, r.getChild(n));
  }
}
function JA(t, e, n, s) {
  const r = ye(e, n), i = xs(t.visibleWrites, r);
  if (i != null)
    return i;
  if (s.isCompleteForChild(n)) {
    const o = On(t.visibleWrites, r);
    return Ir(o, s.getNode().getImmediateChild(n));
  } else
    return null;
}
function QA(t, e) {
  return xs(t.visibleWrites, e);
}
function ZA(t, e, n, s, r, i, o) {
  let a;
  const c = On(t.visibleWrites, e), l = xs(c, se());
  if (l != null)
    a = l;
  else if (n != null)
    a = Ir(c, n);
  else
    return [];
  if (a = a.withIndex(o), !a.isEmpty() && !a.isLeafNode()) {
    const d = [], u = o.getCompare(), h = i ? a.getReverseIteratorFrom(s, o) : a.getIteratorFrom(s, o);
    let p = h.getNext();
    for (; p && d.length < r; )
      u(p, s) !== 0 && d.push(p), p = h.getNext();
    return d;
  } else
    return [];
}
function eN() {
  return {
    visibleWrites: It.empty(),
    allWrites: [],
    lastWriteId: -1
  };
}
function xa(t, e, n, s) {
  return F_(t.writeTree, t.treePath, e, n, s);
}
function Ou(t, e) {
  return KA(t.writeTree, t.treePath, e);
}
function ff(t, e, n, s) {
  return XA(t.writeTree, t.treePath, e, n, s);
}
function Oa(t, e) {
  return QA(t.writeTree, ye(t.treePath, e));
}
function tN(t, e, n, s, r, i) {
  return ZA(t.writeTree, t.treePath, e, n, s, r, i);
}
function Pu(t, e, n) {
  return JA(t.writeTree, t.treePath, e, n);
}
function k_(t, e) {
  return A_(ye(t.treePath, e), t.writeTree);
}
function A_(t, e) {
  return {
    treePath: t,
    writeTree: e
  };
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class nN {
  constructor() {
    this.changeMap = /* @__PURE__ */ new Map();
  }
  trackChildChange(e) {
    const n = e.type, s = e.childName;
    S(n === "child_added" || n === "child_changed" || n === "child_removed", "Only child changes supported for tracking"), S(s !== ".priority", "Only non-priority child changes can be tracked.");
    const r = this.changeMap.get(s);
    if (r) {
      const i = r.type;
      if (n === "child_added" && i === "child_removed")
        this.changeMap.set(s, Pi(s, e.snapshotNode, r.snapshotNode));
      else if (n === "child_removed" && i === "child_added")
        this.changeMap.delete(s);
      else if (n === "child_removed" && i === "child_changed")
        this.changeMap.set(s, Oi(s, r.oldSnap));
      else if (n === "child_changed" && i === "child_added")
        this.changeMap.set(s, wr(s, e.snapshotNode));
      else if (n === "child_changed" && i === "child_changed")
        this.changeMap.set(s, Pi(s, e.snapshotNode, r.oldSnap));
      else
        throw Vr("Illegal combination of changes: " + e + " occurred after " + r);
    } else
      this.changeMap.set(s, e);
  }
  getChanges() {
    return Array.from(this.changeMap.values());
  }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class sN {
  getCompleteChild(e) {
    return null;
  }
  getChildAfterChild(e, n, s) {
    return null;
  }
}
const N_ = new sN();
class Mu {
  constructor(e, n, s = null) {
    this.writes_ = e, this.viewCache_ = n, this.optCompleteServerCache_ = s;
  }
  getCompleteChild(e) {
    const n = this.viewCache_.eventCache;
    if (n.isCompleteForChild(e))
      return n.getNode().getImmediateChild(e);
    {
      const s = this.optCompleteServerCache_ != null ? new Hn(this.optCompleteServerCache_, !0, !1) : this.viewCache_.serverCache;
      return Pu(this.writes_, e, s);
    }
  }
  getChildAfterChild(e, n, s) {
    const r = this.optCompleteServerCache_ != null ? this.optCompleteServerCache_ : Ts(this.viewCache_), i = tN(this.writes_, r, n, 1, s, e);
    return i.length === 0 ? null : i[0];
  }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function rN(t) {
  return { filter: t };
}
function iN(t, e) {
  S(e.eventCache.getNode().isIndexed(t.filter.getIndex()), "Event snap not indexed"), S(e.serverCache.getNode().isIndexed(t.filter.getIndex()), "Server snap not indexed");
}
function oN(t, e, n, s, r) {
  const i = new nN();
  let o, a;
  if (n.type === Tt.OVERWRITE) {
    const l = n;
    l.source.fromUser ? o = ed(t, e, l.path, l.snap, s, r, i) : (S(l.source.fromServer, "Unknown source."), a = l.source.tagged || e.serverCache.isFiltered() && !K(l.path), o = Pa(t, e, l.path, l.snap, s, r, a, i));
  } else if (n.type === Tt.MERGE) {
    const l = n;
    l.source.fromUser ? o = cN(t, e, l.path, l.children, s, r, i) : (S(l.source.fromServer, "Unknown source."), a = l.source.tagged || e.serverCache.isFiltered(), o = td(t, e, l.path, l.children, s, r, a, i));
  } else if (n.type === Tt.ACK_USER_WRITE) {
    const l = n;
    l.revert ? o = uN(t, e, l.path, s, r, i) : o = lN(t, e, l.path, l.affectedTree, s, r, i);
  } else if (n.type === Tt.LISTEN_COMPLETE)
    o = dN(t, e, n.path, s, i);
  else
    throw Vr("Unknown operation type: " + n.type);
  const c = i.getChanges();
  return aN(e, o, c), { viewCache: o, changes: c };
}
function aN(t, e, n) {
  const s = e.eventCache;
  if (s.isFullyInitialized()) {
    const r = s.getNode().isLeafNode() || s.getNode().isEmpty(), i = Ra(t);
    (n.length > 0 || !t.eventCache.isFullyInitialized() || r && !s.getNode().equals(i) || !s.getNode().getPriority().equals(i.getPriority())) && n.push(S_(Ra(e)));
  }
}
function L_(t, e, n, s, r, i) {
  const o = e.eventCache;
  if (Oa(s, n) != null)
    return e;
  {
    let a, c;
    if (K(n))
      if (S(e.serverCache.isFullyInitialized(), "If change path is empty, we must have complete server data"), e.serverCache.isFiltered()) {
        const l = Ts(e), d = l instanceof P ? l : P.EMPTY_NODE, u = Ou(s, d);
        a = t.filter.updateFullNode(e.eventCache.getNode(), u, i);
      } else {
        const l = xa(s, Ts(e));
        a = t.filter.updateFullNode(e.eventCache.getNode(), l, i);
      }
    else {
      const l = X(n);
      if (l === ".priority") {
        S(Un(n) === 1, "Can't have a priority with additional path components");
        const d = o.getNode();
        c = e.serverCache.getNode();
        const u = ff(s, n, d, c);
        u != null ? a = t.filter.updatePriority(d, u) : a = o.getNode();
      } else {
        const d = ue(n);
        let u;
        if (o.isCompleteForChild(l)) {
          c = e.serverCache.getNode();
          const h = ff(s, n, o.getNode(), c);
          h != null ? u = o.getNode().getImmediateChild(l).updateChild(d, h) : u = o.getNode().getImmediateChild(l);
        } else
          u = Pu(s, l, e.serverCache);
        u != null ? a = t.filter.updateChild(o.getNode(), l, u, d, r, i) : a = o.getNode();
      }
    }
    return yi(e, a, o.isFullyInitialized() || K(n), t.filter.filtersNodes());
  }
}
function Pa(t, e, n, s, r, i, o, a) {
  const c = e.serverCache;
  let l;
  const d = o ? t.filter : t.filter.getIndexedFilter();
  if (K(n))
    l = d.updateFullNode(c.getNode(), s, null);
  else if (d.filtersNodes() && !c.isFiltered()) {
    const p = c.getNode().updateChild(n, s);
    l = d.updateFullNode(c.getNode(), p, null);
  } else {
    const p = X(n);
    if (!c.isCompleteForPath(n) && Un(n) > 1)
      return e;
    const f = ue(n), g = c.getNode().getImmediateChild(p).updateChild(f, s);
    p === ".priority" ? l = d.updatePriority(c.getNode(), g) : l = d.updateChild(c.getNode(), p, g, f, N_, null);
  }
  const u = T_(e, l, c.isFullyInitialized() || K(n), d.filtersNodes()), h = new Mu(r, u, i);
  return L_(t, u, n, r, h, a);
}
function ed(t, e, n, s, r, i, o) {
  const a = e.eventCache;
  let c, l;
  const d = new Mu(r, e, i);
  if (K(n))
    l = t.filter.updateFullNode(e.eventCache.getNode(), s, o), c = yi(e, l, !0, t.filter.filtersNodes());
  else {
    const u = X(n);
    if (u === ".priority")
      l = t.filter.updatePriority(e.eventCache.getNode(), s), c = yi(e, l, a.isFullyInitialized(), a.isFiltered());
    else {
      const h = ue(n), p = a.getNode().getImmediateChild(u);
      let f;
      if (K(h))
        f = s;
      else {
        const m = d.getCompleteChild(u);
        m != null ? Cu(h) === ".priority" && m.getChild(f_(h)).isEmpty() ? f = m : f = m.updateChild(h, s) : f = P.EMPTY_NODE;
      }
      if (p.equals(f))
        c = e;
      else {
        const m = t.filter.updateChild(a.getNode(), u, f, h, d, o);
        c = yi(e, m, a.isFullyInitialized(), t.filter.filtersNodes());
      }
    }
  }
  return c;
}
function mf(t, e) {
  return t.eventCache.isCompleteForChild(e);
}
function cN(t, e, n, s, r, i, o) {
  let a = e;
  return s.foreach((c, l) => {
    const d = ye(n, c);
    mf(e, X(d)) && (a = ed(t, a, d, l, r, i, o));
  }), s.foreach((c, l) => {
    const d = ye(n, c);
    mf(e, X(d)) || (a = ed(t, a, d, l, r, i, o));
  }), a;
}
function gf(t, e, n) {
  return n.foreach((s, r) => {
    e = e.updateChild(s, r);
  }), e;
}
function td(t, e, n, s, r, i, o, a) {
  if (e.serverCache.getNode().isEmpty() && !e.serverCache.isFullyInitialized())
    return e;
  let c = e, l;
  K(n) ? l = s : l = new de(null).setTree(n, s);
  const d = e.serverCache.getNode();
  return l.children.inorderTraversal((u, h) => {
    if (d.hasChild(u)) {
      const p = e.serverCache.getNode().getImmediateChild(u), f = gf(t, p, h);
      c = Pa(t, c, new oe(u), f, r, i, o, a);
    }
  }), l.children.inorderTraversal((u, h) => {
    const p = !e.serverCache.isCompleteForChild(u) && h.value === null;
    if (!d.hasChild(u) && !p) {
      const f = e.serverCache.getNode().getImmediateChild(u), m = gf(t, f, h);
      c = Pa(t, c, new oe(u), m, r, i, o, a);
    }
  }), c;
}
function lN(t, e, n, s, r, i, o) {
  if (Oa(r, n) != null)
    return e;
  const a = e.serverCache.isFiltered(), c = e.serverCache;
  if (s.value != null) {
    if (K(n) && c.isFullyInitialized() || c.isCompleteForPath(n))
      return Pa(t, e, n, c.getNode().getChild(n), r, i, a, o);
    if (K(n)) {
      let l = new de(null);
      return c.getNode().forEachChild(hr, (d, u) => {
        l = l.set(new oe(d), u);
      }), td(t, e, n, l, r, i, a, o);
    } else
      return e;
  } else {
    let l = new de(null);
    return s.foreach((d, u) => {
      const h = ye(n, d);
      c.isCompleteForPath(h) && (l = l.set(d, c.getNode().getChild(h)));
    }), td(t, e, n, l, r, i, a, o);
  }
}
function dN(t, e, n, s, r) {
  const i = e.serverCache, o = T_(e, i.getNode(), i.isFullyInitialized() || K(n), i.isFiltered());
  return L_(t, o, n, s, N_, r);
}
function uN(t, e, n, s, r, i) {
  let o;
  if (Oa(s, n) != null)
    return e;
  {
    const a = new Mu(s, e, r), c = e.eventCache.getNode();
    let l;
    if (K(n) || X(n) === ".priority") {
      let d;
      if (e.serverCache.isFullyInitialized())
        d = xa(s, Ts(e));
      else {
        const u = e.serverCache.getNode();
        S(u instanceof P, "serverChildren would be complete if leaf node"), d = Ou(s, u);
      }
      d = d, l = t.filter.updateFullNode(c, d, i);
    } else {
      const d = X(n);
      let u = Pu(s, d, e.serverCache);
      u == null && e.serverCache.isCompleteForChild(d) && (u = c.getImmediateChild(d)), u != null ? l = t.filter.updateChild(c, d, u, ue(n), a, i) : e.eventCache.getNode().hasChild(d) ? l = t.filter.updateChild(c, d, P.EMPTY_NODE, ue(n), a, i) : l = c, l.isEmpty() && e.serverCache.isFullyInitialized() && (o = xa(s, Ts(e)), o.isLeafNode() && (l = t.filter.updateFullNode(l, o, i)));
    }
    return o = e.serverCache.isFullyInitialized() || Oa(s, se()) != null, yi(e, l, o, t.filter.filtersNodes());
  }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class hN {
  constructor(e, n) {
    this.query_ = e, this.eventRegistrations_ = [];
    const s = this.query_._queryParams, r = new Au(s.getIndex()), i = NA(s);
    this.processor_ = rN(i);
    const o = n.serverCache, a = n.eventCache, c = r.updateFullNode(P.EMPTY_NODE, o.getNode(), null), l = i.updateFullNode(P.EMPTY_NODE, a.getNode(), null), d = new Hn(c, o.isFullyInitialized(), r.filtersNodes()), u = new Hn(l, a.isFullyInitialized(), i.filtersNodes());
    this.viewCache_ = yc(u, d), this.eventGenerator_ = new DA(this.query_);
  }
  get query() {
    return this.query_;
  }
}
function pN(t) {
  return t.viewCache_.serverCache.getNode();
}
function fN(t) {
  return Ra(t.viewCache_);
}
function mN(t, e) {
  const n = Ts(t.viewCache_);
  return n && (t.query._queryParams.loadsAllData() || !K(e) && !n.getImmediateChild(X(e)).isEmpty()) ? n.getChild(e) : null;
}
function _f(t) {
  return t.eventRegistrations_.length === 0;
}
function gN(t, e) {
  t.eventRegistrations_.push(e);
}
function yf(t, e, n) {
  const s = [];
  if (n) {
    S(e == null, "A cancel should cancel all event registrations.");
    const r = t.query._path;
    t.eventRegistrations_.forEach((i) => {
      const o = i.createCancelEvent(n, r);
      o && s.push(o);
    });
  }
  if (e) {
    let r = [];
    for (let i = 0; i < t.eventRegistrations_.length; ++i) {
      const o = t.eventRegistrations_[i];
      if (!o.matches(e))
        r.push(o);
      else if (e.hasAnyCallback()) {
        r = r.concat(t.eventRegistrations_.slice(i + 1));
        break;
      }
    }
    t.eventRegistrations_ = r;
  } else
    t.eventRegistrations_ = [];
  return s;
}
function Ef(t, e, n, s) {
  e.type === Tt.MERGE && e.source.queryId !== null && (S(Ts(t.viewCache_), "We should always have a full cache before handling merges"), S(Ra(t.viewCache_), "Missing event cache, even though we have a server cache"));
  const r = t.viewCache_, i = oN(t.processor_, r, e, n, s);
  return iN(t.processor_, i.viewCache), S(i.viewCache.serverCache.isFullyInitialized() || !r.serverCache.isFullyInitialized(), "Once a server snap is complete, it should never go back"), t.viewCache_ = i.viewCache, R_(t, i.changes, i.viewCache.eventCache.getNode(), null);
}
function _N(t, e) {
  const n = t.viewCache_.eventCache, s = [];
  return n.getNode().isLeafNode() || n.getNode().forEachChild(Ee, (i, o) => {
    s.push(wr(i, o));
  }), n.isFullyInitialized() && s.push(S_(n.getNode())), R_(t, s, n.getNode(), e);
}
function R_(t, e, n, s) {
  const r = s ? [s] : t.eventRegistrations_;
  return GA(t.eventGenerator_, e, n, r);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
let Ma;
class x_ {
  constructor() {
    this.views = /* @__PURE__ */ new Map();
  }
}
function yN(t) {
  S(!Ma, "__referenceConstructor has already been defined"), Ma = t;
}
function EN() {
  return S(Ma, "Reference.ts has not been loaded"), Ma;
}
function bN(t) {
  return t.views.size === 0;
}
function Du(t, e, n, s) {
  const r = e.source.queryId;
  if (r !== null) {
    const i = t.views.get(r);
    return S(i != null, "SyncTree gave us an op for an invalid query."), Ef(i, e, n, s);
  } else {
    let i = [];
    for (const o of t.views.values())
      i = i.concat(Ef(o, e, n, s));
    return i;
  }
}
function O_(t, e, n, s, r) {
  const i = e._queryIdentifier, o = t.views.get(i);
  if (!o) {
    let a = xa(n, r ? s : null), c = !1;
    a ? c = !0 : s instanceof P ? (a = Ou(n, s), c = !1) : (a = P.EMPTY_NODE, c = !1);
    const l = yc(new Hn(a, c, !1), new Hn(s, r, !1));
    return new hN(e, l);
  }
  return o;
}
function vN(t, e, n, s, r, i) {
  const o = O_(t, e, s, r, i);
  return t.views.has(e._queryIdentifier) || t.views.set(e._queryIdentifier, o), gN(o, n), _N(o, n);
}
function SN(t, e, n, s) {
  const r = e._queryIdentifier, i = [];
  let o = [];
  const a = jn(t);
  if (r === "default")
    for (const [c, l] of t.views.entries())
      o = o.concat(yf(l, n, s)), _f(l) && (t.views.delete(c), l.query._queryParams.loadsAllData() || i.push(l.query));
  else {
    const c = t.views.get(r);
    c && (o = o.concat(yf(c, n, s)), _f(c) && (t.views.delete(r), c.query._queryParams.loadsAllData() || i.push(c.query)));
  }
  return a && !jn(t) && i.push(new (EN())(e._repo, e._path)), { removed: i, events: o };
}
function P_(t) {
  const e = [];
  for (const n of t.views.values())
    n.query._queryParams.loadsAllData() || e.push(n);
  return e;
}
function Pn(t, e) {
  let n = null;
  for (const s of t.views.values())
    n = n || mN(s, e);
  return n;
}
function M_(t, e) {
  if (e._queryParams.loadsAllData())
    return bc(t);
  {
    const s = e._queryIdentifier;
    return t.views.get(s);
  }
}
function D_(t, e) {
  return M_(t, e) != null;
}
function jn(t) {
  return bc(t) != null;
}
function bc(t) {
  for (const e of t.views.values())
    if (e.query._queryParams.loadsAllData())
      return e;
  return null;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
let Da;
function wN(t) {
  S(!Da, "__referenceConstructor has already been defined"), Da = t;
}
function TN() {
  return S(Da, "Reference.ts has not been loaded"), Da;
}
let IN = 1;
class bf {
  /**
   * @param listenProvider_ - Used by SyncTree to start / stop listening
   *   to server data.
   */
  constructor(e) {
    this.listenProvider_ = e, this.syncPointTree_ = new de(null), this.pendingWriteTree_ = eN(), this.tagToQueryMap = /* @__PURE__ */ new Map(), this.queryToTagMap = /* @__PURE__ */ new Map();
  }
}
function G_(t, e, n, s, r) {
  return UA(t.pendingWriteTree_, e, n, s, r), r ? zr(t, new ws(Lu(), e, n)) : [];
}
function CN(t, e, n, s) {
  HA(t.pendingWriteTree_, e, n, s);
  const r = de.fromObject(n);
  return zr(t, new Tr(Lu(), e, r));
}
function Nn(t, e, n = !1) {
  const s = jA(t.pendingWriteTree_, e);
  if (WA(t.pendingWriteTree_, e)) {
    let i = new de(null);
    return s.snap != null ? i = i.set(se(), !0) : Me(s.children, (o) => {
      i = i.set(new oe(o), !0);
    }), zr(t, new La(s.path, i, n));
  } else
    return [];
}
function co(t, e, n) {
  return zr(t, new ws(Ru(), e, n));
}
function FN(t, e, n) {
  const s = de.fromObject(n);
  return zr(t, new Tr(Ru(), e, s));
}
function kN(t, e) {
  return zr(t, new Di(Ru(), e));
}
function AN(t, e, n) {
  const s = Bu(t, n);
  if (s) {
    const r = $u(s), i = r.path, o = r.queryId, a = He(i, e), c = new Di(xu(o), a);
    return Vu(t, i, c);
  } else
    return [];
}
function B_(t, e, n, s, r = !1) {
  const i = e._path, o = t.syncPointTree_.get(i);
  let a = [];
  if (o && (e._queryIdentifier === "default" || D_(o, e))) {
    const c = SN(o, e, n, s);
    bN(o) && (t.syncPointTree_ = t.syncPointTree_.remove(i));
    const l = c.removed;
    if (a = c.events, !r) {
      const d = l.findIndex((h) => h._queryParams.loadsAllData()) !== -1, u = t.syncPointTree_.findOnPath(i, (h, p) => jn(p));
      if (d && !u) {
        const h = t.syncPointTree_.subtree(i);
        if (!h.isEmpty()) {
          const p = xN(h);
          for (let f = 0; f < p.length; ++f) {
            const m = p[f], g = m.query, y = H_(t, m);
            t.listenProvider_.startListening(bi(g), Gi(t, g), y.hashFn, y.onComplete);
          }
        }
      }
      !u && l.length > 0 && !s && (d ? t.listenProvider_.stopListening(bi(e), null) : l.forEach((h) => {
        const p = t.queryToTagMap.get(vc(h));
        t.listenProvider_.stopListening(bi(h), p);
      }));
    }
    ON(t, l);
  }
  return a;
}
function $_(t, e, n, s) {
  const r = Bu(t, s);
  if (r != null) {
    const i = $u(r), o = i.path, a = i.queryId, c = He(o, e), l = new ws(xu(a), c, n);
    return Vu(t, o, l);
  } else
    return [];
}
function NN(t, e, n, s) {
  const r = Bu(t, s);
  if (r) {
    const i = $u(r), o = i.path, a = i.queryId, c = He(o, e), l = de.fromObject(n), d = new Tr(xu(a), c, l);
    return Vu(t, o, d);
  } else
    return [];
}
function LN(t, e, n, s = !1) {
  const r = e._path;
  let i = null, o = !1;
  t.syncPointTree_.foreachOnPath(r, (h, p) => {
    const f = He(h, r);
    i = i || Pn(p, f), o = o || jn(p);
  });
  let a = t.syncPointTree_.get(r);
  a ? (o = o || jn(a), i = i || Pn(a, se())) : (a = new x_(), t.syncPointTree_ = t.syncPointTree_.set(r, a));
  let c;
  i != null ? c = !0 : (c = !1, i = P.EMPTY_NODE, t.syncPointTree_.subtree(r).foreachChild((p, f) => {
    const m = Pn(f, se());
    m && (i = i.updateImmediateChild(p, m));
  }));
  const l = D_(a, e);
  if (!l && !e._queryParams.loadsAllData()) {
    const h = vc(e);
    S(!t.queryToTagMap.has(h), "View does not exist, but we have a tag");
    const p = PN();
    t.queryToTagMap.set(h, p), t.tagToQueryMap.set(p, h);
  }
  const d = Ec(t.pendingWriteTree_, r);
  let u = vN(a, e, n, d, i, c);
  if (!l && !o && !s) {
    const h = M_(a, e);
    u = u.concat(MN(t, e, h));
  }
  return u;
}
function Gu(t, e, n) {
  const r = t.pendingWriteTree_, i = t.syncPointTree_.findOnPath(e, (o, a) => {
    const c = He(o, e), l = Pn(a, c);
    if (l)
      return l;
  });
  return F_(r, e, i, n, !0);
}
function RN(t, e) {
  const n = e._path;
  let s = null;
  t.syncPointTree_.foreachOnPath(n, (l, d) => {
    const u = He(l, n);
    s = s || Pn(d, u);
  });
  let r = t.syncPointTree_.get(n);
  r ? s = s || Pn(r, se()) : (r = new x_(), t.syncPointTree_ = t.syncPointTree_.set(n, r));
  const i = s != null, o = i ? new Hn(s, !0, !1) : null, a = Ec(t.pendingWriteTree_, e._path), c = O_(r, e, a, i ? o.getNode() : P.EMPTY_NODE, i);
  return fN(c);
}
function zr(t, e) {
  return V_(
    e,
    t.syncPointTree_,
    /*serverCache=*/
    null,
    Ec(t.pendingWriteTree_, se())
  );
}
function V_(t, e, n, s) {
  if (K(t.path))
    return U_(t, e, n, s);
  {
    const r = e.get(se());
    n == null && r != null && (n = Pn(r, se()));
    let i = [];
    const o = X(t.path), a = t.operationForChild(o), c = e.children.get(o);
    if (c && a) {
      const l = n ? n.getImmediateChild(o) : null, d = k_(s, o);
      i = i.concat(V_(a, c, l, d));
    }
    return r && (i = i.concat(Du(r, t, s, n))), i;
  }
}
function U_(t, e, n, s) {
  const r = e.get(se());
  n == null && r != null && (n = Pn(r, se()));
  let i = [];
  return e.children.inorderTraversal((o, a) => {
    const c = n ? n.getImmediateChild(o) : null, l = k_(s, o), d = t.operationForChild(o);
    d && (i = i.concat(U_(d, a, c, l)));
  }), r && (i = i.concat(Du(r, t, s, n))), i;
}
function H_(t, e) {
  const n = e.query, s = Gi(t, n);
  return {
    hashFn: () => (pN(e) || P.EMPTY_NODE).hash(),
    onComplete: (r) => {
      if (r === "ok")
        return s ? AN(t, n._path, s) : kN(t, n._path);
      {
        const i = kk(r, n);
        return B_(
          t,
          n,
          /*eventRegistration*/
          null,
          i
        );
      }
    }
  };
}
function Gi(t, e) {
  const n = vc(e);
  return t.queryToTagMap.get(n);
}
function vc(t) {
  return t._path.toString() + "$" + t._queryIdentifier;
}
function Bu(t, e) {
  return t.tagToQueryMap.get(e);
}
function $u(t) {
  const e = t.indexOf("$");
  return S(e !== -1 && e < t.length - 1, "Bad queryKey."), {
    queryId: t.substr(e + 1),
    path: new oe(t.substr(0, e))
  };
}
function Vu(t, e, n) {
  const s = t.syncPointTree_.get(e);
  S(s, "Missing sync point for query tag that we're tracking");
  const r = Ec(t.pendingWriteTree_, e);
  return Du(s, n, r, null);
}
function xN(t) {
  return t.fold((e, n, s) => {
    if (n && jn(n))
      return [bc(n)];
    {
      let r = [];
      return n && (r = P_(n)), Me(s, (i, o) => {
        r = r.concat(o);
      }), r;
    }
  });
}
function bi(t) {
  return t._queryParams.loadsAllData() && !t._queryParams.isDefault() ? new (TN())(t._repo, t._path) : t;
}
function ON(t, e) {
  for (let n = 0; n < e.length; ++n) {
    const s = e[n];
    if (!s._queryParams.loadsAllData()) {
      const r = vc(s), i = t.queryToTagMap.get(r);
      t.queryToTagMap.delete(r), t.tagToQueryMap.delete(i);
    }
  }
}
function PN() {
  return IN++;
}
function MN(t, e, n) {
  const s = e._path, r = Gi(t, e), i = H_(t, n), o = t.listenProvider_.startListening(bi(e), r, i.hashFn, i.onComplete), a = t.syncPointTree_.subtree(s);
  if (r)
    S(!jn(a.value), "If we're adding a query, it shouldn't be shadowed");
  else {
    const c = a.fold((l, d, u) => {
      if (!K(l) && d && jn(d))
        return [bc(d).query];
      {
        let h = [];
        return d && (h = h.concat(P_(d).map((p) => p.query))), Me(u, (p, f) => {
          h = h.concat(f);
        }), h;
      }
    });
    for (let l = 0; l < c.length; ++l) {
      const d = c[l];
      t.listenProvider_.stopListening(bi(d), Gi(t, d));
    }
  }
  return o;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class Uu {
  constructor(e) {
    this.node_ = e;
  }
  getImmediateChild(e) {
    const n = this.node_.getImmediateChild(e);
    return new Uu(n);
  }
  node() {
    return this.node_;
  }
}
class Hu {
  constructor(e, n) {
    this.syncTree_ = e, this.path_ = n;
  }
  getImmediateChild(e) {
    const n = ye(this.path_, e);
    return new Hu(this.syncTree_, n);
  }
  node() {
    return Gu(this.syncTree_, this.path_);
  }
}
const DN = function(t) {
  return t = t || {}, t.timestamp = t.timestamp || (/* @__PURE__ */ new Date()).getTime(), t;
}, vf = function(t, e, n) {
  if (!t || typeof t != "object")
    return t;
  if (S(".sv" in t, "Unexpected leaf node or priority contents"), typeof t[".sv"] == "string")
    return GN(t[".sv"], e, n);
  if (typeof t[".sv"] == "object")
    return BN(t[".sv"], e);
  S(!1, "Unexpected server value: " + JSON.stringify(t, null, 2));
}, GN = function(t, e, n) {
  switch (t) {
    case "timestamp":
      return n.timestamp;
    default:
      S(!1, "Unexpected server value: " + t);
  }
}, BN = function(t, e, n) {
  t.hasOwnProperty("increment") || S(!1, "Unexpected server value: " + JSON.stringify(t, null, 2));
  const s = t.increment;
  typeof s != "number" && S(!1, "Unexpected increment value: " + s);
  const r = e.node();
  if (S(r !== null && typeof r < "u", "Expected ChildrenNode.EMPTY_NODE for nulls"), !r.isLeafNode())
    return s;
  const o = r.getValue();
  return typeof o != "number" ? s : o + s;
}, j_ = function(t, e, n, s) {
  return ju(e, new Hu(n, t), s);
}, W_ = function(t, e, n) {
  return ju(t, new Uu(e), n);
};
function ju(t, e, n) {
  const s = t.getPriority().val(), r = vf(s, e.getImmediateChild(".priority"), n);
  let i;
  if (t.isLeafNode()) {
    const o = t, a = vf(o.getValue(), e, n);
    return a !== o.getValue() || r !== o.getPriority().val() ? new Ae(a, Te(r)) : t;
  } else {
    const o = t;
    return i = o, r !== o.getPriority().val() && (i = i.updatePriority(new Ae(r))), o.forEachChild(Ee, (a, c) => {
      const l = ju(c, e.getImmediateChild(a), n);
      l !== c && (i = i.updateImmediateChild(a, l));
    }), i;
  }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class Wu {
  /**
   * @param name - Optional name of the node.
   * @param parent - Optional parent node.
   * @param node - Optional node to wrap.
   */
  constructor(e = "", n = null, s = { children: {}, childCount: 0 }) {
    this.name = e, this.parent = n, this.node = s;
  }
}
function zu(t, e) {
  let n = e instanceof oe ? e : new oe(e), s = t, r = X(n);
  for (; r !== null; ) {
    const i = br(s.node.children, r) || {
      children: {},
      childCount: 0
    };
    s = new Wu(r, s, i), n = ue(n), r = X(n);
  }
  return s;
}
function qr(t) {
  return t.node.value;
}
function z_(t, e) {
  t.node.value = e, nd(t);
}
function q_(t) {
  return t.node.childCount > 0;
}
function $N(t) {
  return qr(t) === void 0 && !q_(t);
}
function Sc(t, e) {
  Me(t.node.children, (n, s) => {
    e(new Wu(n, t, s));
  });
}
function Y_(t, e, n, s) {
  n && !s && e(t), Sc(t, (r) => {
    Y_(r, e, !0, s);
  }), n && s && e(t);
}
function VN(t, e, n) {
  let s = t.parent;
  for (; s !== null; ) {
    if (e(s))
      return !0;
    s = s.parent;
  }
  return !1;
}
function lo(t) {
  return new oe(t.parent === null ? t.name : lo(t.parent) + "/" + t.name);
}
function nd(t) {
  t.parent !== null && UN(t.parent, t.name, t);
}
function UN(t, e, n) {
  const s = $N(n), r = $t(t.node.children, e);
  s && r ? (delete t.node.children[e], t.node.childCount--, nd(t)) : !s && !r && (t.node.children[e] = n.node, t.node.childCount++, nd(t));
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const HN = /[\[\].#$\/\u0000-\u001F\u007F]/, jN = /[\[\].#$\u0000-\u001F\u007F]/, ml = 10 * 1024 * 1024, qu = function(t) {
  return typeof t == "string" && t.length !== 0 && !HN.test(t);
}, K_ = function(t) {
  return typeof t == "string" && t.length !== 0 && !jN.test(t);
}, WN = function(t) {
  return t && (t = t.replace(/^\/*\.info(\/|$)/, "/")), K_(t);
}, zN = function(t) {
  return t === null || typeof t == "string" || typeof t == "number" && !vu(t) || t && typeof t == "object" && // eslint-disable-next-line @typescript-eslint/no-explicit-any
  $t(t, ".sv");
}, X_ = function(t, e, n, s) {
  s && e === void 0 || wc(hc(t, "value"), e, n);
}, wc = function(t, e, n) {
  const s = n instanceof oe ? new cA(n, t) : n;
  if (e === void 0)
    throw new Error(t + "contains undefined " + ss(s));
  if (typeof e == "function")
    throw new Error(t + "contains a function " + ss(s) + " with contents = " + e.toString());
  if (vu(e))
    throw new Error(t + "contains " + e.toString() + " " + ss(s));
  if (typeof e == "string" && e.length > ml / 3 && pc(e) > ml)
    throw new Error(t + "contains a string greater than " + ml + " utf8 bytes " + ss(s) + " ('" + e.substring(0, 50) + "...')");
  if (e && typeof e == "object") {
    let r = !1, i = !1;
    if (Me(e, (o, a) => {
      if (o === ".value")
        r = !0;
      else if (o !== ".priority" && o !== ".sv" && (i = !0, !qu(o)))
        throw new Error(t + " contains an invalid key (" + o + ") " + ss(s) + `.  Keys must be non-empty strings and can't contain ".", "#", "$", "/", "[", or "]"`);
      lA(s, o), wc(t, a, s), dA(s);
    }), r && i)
      throw new Error(t + ' contains ".value" child ' + ss(s) + " in addition to actual children.");
  }
}, qN = function(t, e) {
  let n, s;
  for (n = 0; n < e.length; n++) {
    s = e[n];
    const i = xi(s);
    for (let o = 0; o < i.length; o++)
      if (!(i[o] === ".priority" && o === i.length - 1)) {
        if (!qu(i[o]))
          throw new Error(t + "contains an invalid key (" + i[o] + ") in path " + s.toString() + `. Keys must be non-empty strings and can't contain ".", "#", "$", "/", "[", or "]"`);
      }
  }
  e.sort(aA);
  let r = null;
  for (n = 0; n < e.length; n++) {
    if (s = e[n], r !== null && ut(r, s))
      throw new Error(t + "contains a path " + r.toString() + " that is ancestor of another path " + s.toString());
    r = s;
  }
}, YN = function(t, e, n, s) {
  const r = hc(t, "values");
  if (!(e && typeof e == "object") || Array.isArray(e))
    throw new Error(r + " must be an object containing the children to replace.");
  const i = [];
  Me(e, (o, a) => {
    const c = new oe(o);
    if (wc(r, a, ye(n, c)), Cu(c) === ".priority" && !zN(a))
      throw new Error(r + "contains an invalid value for '" + c.toString() + "', which must be a valid Firebase priority (a string, finite number, server value, or null).");
    i.push(c);
  }), qN(r, i);
}, J_ = function(t, e, n, s) {
  if (!K_(n))
    throw new Error(hc(t, e) + 'was an invalid path = "' + n + `". Paths must be non-empty strings and can't contain ".", "#", "$", "[", or "]"`);
}, KN = function(t, e, n, s) {
  n && (n = n.replace(/^\/*\.info(\/|$)/, "/")), J_(t, e, n);
}, Yu = function(t, e) {
  if (X(e) === ".info")
    throw new Error(t + " failed = Can't modify data under /.info/");
}, XN = function(t, e) {
  const n = e.path.toString();
  if (typeof e.repoInfo.host != "string" || e.repoInfo.host.length === 0 || !qu(e.repoInfo.namespace) && e.repoInfo.host.split(":")[0] !== "localhost" || n.length !== 0 && !WN(n))
    throw new Error(hc(t, "url") + `must be a valid firebase URL and the path can't contain ".", "#", "$", "[", or "]".`);
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class JN {
  constructor() {
    this.eventLists_ = [], this.recursionDepth_ = 0;
  }
}
function Ku(t, e) {
  let n = null;
  for (let s = 0; s < e.length; s++) {
    const r = e[s], i = r.getPath();
    n !== null && !m_(i, n.path) && (t.eventLists_.push(n), n = null), n === null && (n = { events: [], path: i }), n.events.push(r);
  }
  n && t.eventLists_.push(n);
}
function gt(t, e, n) {
  Ku(t, n), QN(t, (s) => ut(s, e) || ut(e, s));
}
function QN(t, e) {
  t.recursionDepth_++;
  let n = !0;
  for (let s = 0; s < t.eventLists_.length; s++) {
    const r = t.eventLists_[s];
    if (r) {
      const i = r.path;
      e(i) ? (ZN(t.eventLists_[s]), t.eventLists_[s] = null) : n = !1;
    }
  }
  n && (t.eventLists_ = []), t.recursionDepth_--;
}
function ZN(t) {
  for (let e = 0; e < t.events.length; e++) {
    const n = t.events[e];
    if (n !== null) {
      t.events[e] = null;
      const s = n.getEventRunner();
      gi && Oe("event: " + n.toString()), Wr(s);
    }
  }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const eL = "repo_interrupt", tL = 25;
class nL {
  constructor(e, n, s, r) {
    this.repoInfo_ = e, this.forceRestClient_ = n, this.authTokenProvider_ = s, this.appCheckProvider_ = r, this.dataUpdateCount = 0, this.statsListener_ = null, this.eventQueue_ = new JN(), this.nextWriteId_ = 1, this.interceptServerDataCallback_ = null, this.onDisconnect_ = Na(), this.transactionQueueTree_ = new Wu(), this.persistentConnection_ = null, this.key = this.repoInfo_.toURLString();
  }
  /**
   * @returns The URL corresponding to the root of this Firebase.
   */
  toString() {
    return (this.repoInfo_.secure ? "https://" : "http://") + this.repoInfo_.host;
  }
}
function sL(t, e, n) {
  if (t.stats_ = Tu(t.repoInfo_), t.forceRestClient_ || Rk())
    t.server_ = new Aa(t.repoInfo_, (s, r, i, o) => {
      Sf(t, s, r, i, o);
    }, t.authTokenProvider_, t.appCheckProvider_), setTimeout(() => wf(
      t,
      /* connectStatus= */
      !0
    ), 0);
  else {
    if (typeof n < "u" && n !== null) {
      if (typeof n != "object")
        throw new Error("Only objects are supported for option databaseAuthVariableOverride");
      try {
        Ie(n);
      } catch (s) {
        throw new Error("Invalid authOverride provided: " + s);
      }
    }
    t.persistentConnection_ = new tn(t.repoInfo_, e, (s, r, i, o) => {
      Sf(t, s, r, i, o);
    }, (s) => {
      wf(t, s);
    }, (s) => {
      rL(t, s);
    }, t.authTokenProvider_, t.appCheckProvider_, n), t.server_ = t.persistentConnection_;
  }
  t.authTokenProvider_.addTokenChangeListener((s) => {
    t.server_.refreshAuthToken(s);
  }), t.appCheckProvider_.addTokenChangeListener((s) => {
    t.server_.refreshAppCheckToken(s.token);
  }), t.statsReporter_ = Dk(t.repoInfo_, () => new MA(t.stats_, t.server_)), t.infoData_ = new LA(), t.infoSyncTree_ = new bf({
    startListening: (s, r, i, o) => {
      let a = [];
      const c = t.infoData_.getNode(s._path);
      return c.isEmpty() || (a = co(t.infoSyncTree_, s._path, c), setTimeout(() => {
        o("ok");
      }, 0)), a;
    },
    stopListening: () => {
    }
  }), Xu(t, "connected", !1), t.serverSyncTree_ = new bf({
    startListening: (s, r, i, o) => (t.server_.listen(s, i, r, (a, c) => {
      const l = o(a, c);
      gt(t.eventQueue_, s._path, l);
    }), []),
    stopListening: (s, r) => {
      t.server_.unlisten(s, r);
    }
  });
}
function Q_(t) {
  const n = t.infoData_.getNode(new oe(".info/serverTimeOffset")).val() || 0;
  return (/* @__PURE__ */ new Date()).getTime() + n;
}
function Tc(t) {
  return DN({
    timestamp: Q_(t)
  });
}
function Sf(t, e, n, s, r) {
  t.dataUpdateCount++;
  const i = new oe(e);
  n = t.interceptServerDataCallback_ ? t.interceptServerDataCallback_(e, n) : n;
  let o = [];
  if (r)
    if (s) {
      const c = _a(n, (l) => Te(l));
      o = NN(t.serverSyncTree_, i, c, r);
    } else {
      const c = Te(n);
      o = $_(t.serverSyncTree_, i, c, r);
    }
  else if (s) {
    const c = _a(n, (l) => Te(l));
    o = FN(t.serverSyncTree_, i, c);
  } else {
    const c = Te(n);
    o = co(t.serverSyncTree_, i, c);
  }
  let a = i;
  o.length > 0 && (a = Cr(t, i)), gt(t.eventQueue_, a, o);
}
function wf(t, e) {
  Xu(t, "connected", e), e === !1 && cL(t);
}
function rL(t, e) {
  Me(e, (n, s) => {
    Xu(t, n, s);
  });
}
function Xu(t, e, n) {
  const s = new oe("/.info/" + e), r = Te(n);
  t.infoData_.updateSnapshot(s, r);
  const i = co(t.infoSyncTree_, s, r);
  gt(t.eventQueue_, s, i);
}
function Ju(t) {
  return t.nextWriteId_++;
}
function iL(t, e, n) {
  const s = RN(t.serverSyncTree_, e);
  return s != null ? Promise.resolve(s) : t.server_.get(e).then((r) => {
    const i = Te(r).withIndex(e._queryParams.getIndex());
    LN(t.serverSyncTree_, e, n, !0);
    let o;
    if (e._queryParams.loadsAllData())
      o = co(t.serverSyncTree_, e._path, i);
    else {
      const a = Gi(t.serverSyncTree_, e);
      o = $_(t.serverSyncTree_, e._path, i, a);
    }
    return gt(t.eventQueue_, e._path, o), B_(t.serverSyncTree_, e, n, null, !0), i;
  }, (r) => (uo(t, "get for query " + Ie(e) + " failed: " + r), Promise.reject(new Error(r))));
}
function oL(t, e, n, s, r) {
  uo(t, "set", {
    path: e.toString(),
    value: n,
    priority: s
  });
  const i = Tc(t), o = Te(n, s), a = Gu(t.serverSyncTree_, e), c = W_(o, a, i), l = Ju(t), d = G_(t.serverSyncTree_, e, c, l, !0);
  Ku(t.eventQueue_, d), t.server_.put(e.toString(), o.val(
    /*export=*/
    !0
  ), (h, p) => {
    const f = h === "ok";
    f || ze("set at " + e + " failed: " + h);
    const m = Nn(t.serverSyncTree_, l, !f);
    gt(t.eventQueue_, e, m), sd(t, r, h, p);
  });
  const u = Zu(t, e);
  Cr(t, u), gt(t.eventQueue_, u, []);
}
function aL(t, e, n, s) {
  uo(t, "update", { path: e.toString(), value: n });
  let r = !0;
  const i = Tc(t), o = {};
  if (Me(n, (a, c) => {
    r = !1, o[a] = j_(ye(e, a), Te(c), t.serverSyncTree_, i);
  }), r)
    Oe("update() called with empty data.  Don't do anything."), sd(t, s, "ok", void 0);
  else {
    const a = Ju(t), c = CN(t.serverSyncTree_, e, o, a);
    Ku(t.eventQueue_, c), t.server_.merge(e.toString(), n, (l, d) => {
      const u = l === "ok";
      u || ze("update at " + e + " failed: " + l);
      const h = Nn(t.serverSyncTree_, a, !u), p = h.length > 0 ? Cr(t, e) : e;
      gt(t.eventQueue_, p, h), sd(t, s, l, d);
    }), Me(n, (l) => {
      const d = Zu(t, ye(e, l));
      Cr(t, d);
    }), gt(t.eventQueue_, e, []);
  }
}
function cL(t) {
  uo(t, "onDisconnectEvents");
  const e = Tc(t), n = Na();
  Xl(t.onDisconnect_, se(), (r, i) => {
    const o = j_(r, i, t.serverSyncTree_, e);
    w_(n, r, o);
  });
  let s = [];
  Xl(n, se(), (r, i) => {
    s = s.concat(co(t.serverSyncTree_, r, i));
    const o = Zu(t, r);
    Cr(t, o);
  }), t.onDisconnect_ = Na(), gt(t.eventQueue_, se(), s);
}
function lL(t) {
  t.persistentConnection_ && t.persistentConnection_.interrupt(eL);
}
function uo(t, ...e) {
  let n = "";
  t.persistentConnection_ && (n = t.persistentConnection_.id + ":"), Oe(n, ...e);
}
function sd(t, e, n, s) {
  e && Wr(() => {
    if (n === "ok")
      e(null);
    else {
      const r = (n || "error").toUpperCase();
      let i = r;
      s && (i += ": " + s);
      const o = new Error(i);
      o.code = r, e(o);
    }
  });
}
function Z_(t, e, n) {
  return Gu(t.serverSyncTree_, e, n) || P.EMPTY_NODE;
}
function Qu(t, e = t.transactionQueueTree_) {
  if (e || Ic(t, e), qr(e)) {
    const n = ty(t, e);
    S(n.length > 0, "Sending zero length transaction queue"), n.every(
      (r) => r.status === 0
      /* TransactionStatus.RUN */
    ) && dL(t, lo(e), n);
  } else q_(e) && Sc(e, (n) => {
    Qu(t, n);
  });
}
function dL(t, e, n) {
  const s = n.map((l) => l.currentWriteId), r = Z_(t, e, s);
  let i = r;
  const o = r.hash();
  for (let l = 0; l < n.length; l++) {
    const d = n[l];
    S(d.status === 0, "tryToSendTransactionQueue_: items in queue should all be run."), d.status = 1, d.retryCount++;
    const u = He(e, d.path);
    i = i.updateChild(u, d.currentOutputSnapshotRaw);
  }
  const a = i.val(!0), c = e;
  t.server_.put(c.toString(), a, (l) => {
    uo(t, "transaction put response", {
      path: c.toString(),
      status: l
    });
    let d = [];
    if (l === "ok") {
      const u = [];
      for (let h = 0; h < n.length; h++)
        n[h].status = 2, d = d.concat(Nn(t.serverSyncTree_, n[h].currentWriteId)), n[h].onComplete && u.push(() => n[h].onComplete(null, !0, n[h].currentOutputSnapshotResolved)), n[h].unwatcher();
      Ic(t, zu(t.transactionQueueTree_, e)), Qu(t, t.transactionQueueTree_), gt(t.eventQueue_, e, d);
      for (let h = 0; h < u.length; h++)
        Wr(u[h]);
    } else {
      if (l === "datastale")
        for (let u = 0; u < n.length; u++)
          n[u].status === 3 ? n[u].status = 4 : n[u].status = 0;
      else {
        ze("transaction at " + c.toString() + " failed: " + l);
        for (let u = 0; u < n.length; u++)
          n[u].status = 4, n[u].abortReason = l;
      }
      Cr(t, e);
    }
  }, o);
}
function Cr(t, e) {
  const n = ey(t, e), s = lo(n), r = ty(t, n);
  return uL(t, r, s), s;
}
function uL(t, e, n) {
  if (e.length === 0)
    return;
  const s = [];
  let r = [];
  const o = e.filter((a) => a.status === 0).map((a) => a.currentWriteId);
  for (let a = 0; a < e.length; a++) {
    const c = e[a], l = He(n, c.path);
    let d = !1, u;
    if (S(l !== null, "rerunTransactionsUnderNode_: relativePath should not be null."), c.status === 4)
      d = !0, u = c.abortReason, r = r.concat(Nn(t.serverSyncTree_, c.currentWriteId, !0));
    else if (c.status === 0)
      if (c.retryCount >= tL)
        d = !0, u = "maxretry", r = r.concat(Nn(t.serverSyncTree_, c.currentWriteId, !0));
      else {
        const h = Z_(t, c.path, o);
        c.currentInputSnapshot = h;
        const p = e[a].update(h.val());
        if (p !== void 0) {
          wc("transaction failed: Data returned ", p, c.path);
          let f = Te(p);
          typeof p == "object" && p != null && $t(p, ".priority") || (f = f.updatePriority(h.getPriority()));
          const g = c.currentWriteId, y = Tc(t), I = W_(f, h, y);
          c.currentOutputSnapshotRaw = f, c.currentOutputSnapshotResolved = I, c.currentWriteId = Ju(t), o.splice(o.indexOf(g), 1), r = r.concat(G_(t.serverSyncTree_, c.path, I, c.currentWriteId, c.applyLocally)), r = r.concat(Nn(t.serverSyncTree_, g, !0));
        } else
          d = !0, u = "nodata", r = r.concat(Nn(t.serverSyncTree_, c.currentWriteId, !0));
      }
    gt(t.eventQueue_, n, r), r = [], d && (e[a].status = 2, function(h) {
      setTimeout(h, Math.floor(0));
    }(e[a].unwatcher), e[a].onComplete && (u === "nodata" ? s.push(() => e[a].onComplete(null, !1, e[a].currentInputSnapshot)) : s.push(() => e[a].onComplete(new Error(u), !1, null))));
  }
  Ic(t, t.transactionQueueTree_);
  for (let a = 0; a < s.length; a++)
    Wr(s[a]);
  Qu(t, t.transactionQueueTree_);
}
function ey(t, e) {
  let n, s = t.transactionQueueTree_;
  for (n = X(e); n !== null && qr(s) === void 0; )
    s = zu(s, n), e = ue(e), n = X(e);
  return s;
}
function ty(t, e) {
  const n = [];
  return ny(t, e, n), n.sort((s, r) => s.order - r.order), n;
}
function ny(t, e, n) {
  const s = qr(e);
  if (s)
    for (let r = 0; r < s.length; r++)
      n.push(s[r]);
  Sc(e, (r) => {
    ny(t, r, n);
  });
}
function Ic(t, e) {
  const n = qr(e);
  if (n) {
    let s = 0;
    for (let r = 0; r < n.length; r++)
      n[r].status !== 2 && (n[s] = n[r], s++);
    n.length = s, z_(e, n.length > 0 ? n : void 0);
  }
  Sc(e, (s) => {
    Ic(t, s);
  });
}
function Zu(t, e) {
  const n = lo(ey(t, e)), s = zu(t.transactionQueueTree_, e);
  return VN(s, (r) => {
    gl(t, r);
  }), gl(t, s), Y_(s, (r) => {
    gl(t, r);
  }), n;
}
function gl(t, e) {
  const n = qr(e);
  if (n) {
    const s = [];
    let r = [], i = -1;
    for (let o = 0; o < n.length; o++)
      n[o].status === 3 || (n[o].status === 1 ? (S(i === o - 1, "All SENT items should be at beginning of queue."), i = o, n[o].status = 3, n[o].abortReason = "set") : (S(n[o].status === 0, "Unexpected transaction status in abort"), n[o].unwatcher(), r = r.concat(Nn(t.serverSyncTree_, n[o].currentWriteId, !0)), n[o].onComplete && s.push(n[o].onComplete.bind(null, new Error("set"), !1, null))));
    i === -1 ? z_(e, void 0) : n.length = i + 1, gt(t.eventQueue_, lo(e), r);
    for (let o = 0; o < s.length; o++)
      Wr(s[o]);
  }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function hL(t) {
  let e = "";
  const n = t.split("/");
  for (let s = 0; s < n.length; s++)
    if (n[s].length > 0) {
      let r = n[s];
      try {
        r = decodeURIComponent(r.replace(/\+/g, " "));
      } catch {
      }
      e += "/" + r;
    }
  return e;
}
function pL(t) {
  const e = {};
  t.charAt(0) === "?" && (t = t.substring(1));
  for (const n of t.split("&")) {
    if (n.length === 0)
      continue;
    const s = n.split("=");
    s.length === 2 ? e[decodeURIComponent(s[0])] = decodeURIComponent(s[1]) : ze(`Invalid query segment '${n}' in query '${t}'`);
  }
  return e;
}
const Tf = function(t, e) {
  const n = fL(t), s = n.namespace;
  n.domain === "firebase.com" && cn(n.host + " is no longer supported. Please use <YOUR FIREBASE>.firebaseio.com instead"), (!s || s === "undefined") && n.domain !== "localhost" && cn("Cannot parse Firebase url. Please use https://<YOUR FIREBASE>.firebaseio.com"), n.secure || wk();
  const r = n.scheme === "ws" || n.scheme === "wss";
  return {
    repoInfo: new i_(
      n.host,
      n.secure,
      s,
      r,
      e,
      /*persistenceKey=*/
      "",
      /*includeNamespaceInQueryParams=*/
      s !== n.subdomain
    ),
    path: new oe(n.pathString)
  };
}, fL = function(t) {
  let e = "", n = "", s = "", r = "", i = "", o = !0, a = "https", c = 443;
  if (typeof t == "string") {
    let l = t.indexOf("//");
    l >= 0 && (a = t.substring(0, l - 1), t = t.substring(l + 2));
    let d = t.indexOf("/");
    d === -1 && (d = t.length);
    let u = t.indexOf("?");
    u === -1 && (u = t.length), e = t.substring(0, Math.min(d, u)), d < u && (r = hL(t.substring(d, u)));
    const h = pL(t.substring(Math.min(t.length, u)));
    l = e.indexOf(":"), l >= 0 ? (o = a === "https" || a === "wss", c = parseInt(e.substring(l + 1), 10)) : l = e.length;
    const p = e.slice(0, l);
    if (p.toLowerCase() === "localhost")
      n = "localhost";
    else if (p.split(".").length <= 2)
      n = p;
    else {
      const f = e.indexOf(".");
      s = e.substring(0, f).toLowerCase(), n = e.substring(f + 1), i = s;
    }
    "ns" in h && (i = h.ns);
  }
  return {
    host: e,
    port: c,
    domain: n,
    subdomain: s,
    secure: o,
    scheme: a,
    pathString: r,
    namespace: i
  };
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const If = "-0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ_abcdefghijklmnopqrstuvwxyz", mL = /* @__PURE__ */ function() {
  let t = 0;
  const e = [];
  return function(n) {
    const s = n === t;
    t = n;
    let r;
    const i = new Array(8);
    for (r = 7; r >= 0; r--)
      i[r] = If.charAt(n % 64), n = Math.floor(n / 64);
    S(n === 0, "Cannot push at time == 0");
    let o = i.join("");
    if (s) {
      for (r = 11; r >= 0 && e[r] === 63; r--)
        e[r] = 0;
      e[r]++;
    } else
      for (r = 0; r < 12; r++)
        e[r] = Math.floor(Math.random() * 64);
    for (r = 0; r < 12; r++)
      o += If.charAt(e[r]);
    return S(o.length === 20, "nextPushId: Length should be 20."), o;
  };
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class gL {
  /**
   * @param eventType - One of: value, child_added, child_changed, child_moved, child_removed
   * @param eventRegistration - The function to call to with the event data. User provided
   * @param snapshot - The data backing the event
   * @param prevName - Optional, the name of the previous child for child_* events.
   */
  constructor(e, n, s, r) {
    this.eventType = e, this.eventRegistration = n, this.snapshot = s, this.prevName = r;
  }
  getPath() {
    const e = this.snapshot.ref;
    return this.eventType === "value" ? e._path : e.parent._path;
  }
  getEventType() {
    return this.eventType;
  }
  getEventRunner() {
    return this.eventRegistration.getEventRunner(this);
  }
  toString() {
    return this.getPath().toString() + ":" + this.eventType + ":" + Ie(this.snapshot.exportVal());
  }
}
class _L {
  constructor(e, n, s) {
    this.eventRegistration = e, this.error = n, this.path = s;
  }
  getPath() {
    return this.path;
  }
  getEventType() {
    return "cancel";
  }
  getEventRunner() {
    return this.eventRegistration.getEventRunner(this);
  }
  toString() {
    return this.path.toString() + ":cancel";
  }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class yL {
  constructor(e, n) {
    this.snapshotCallback = e, this.cancelCallback = n;
  }
  onValue(e, n) {
    this.snapshotCallback.call(null, e, n);
  }
  onCancel(e) {
    return S(this.hasCancelCallback, "Raising a cancel event on a listener with no cancel callback"), this.cancelCallback.call(null, e);
  }
  get hasCancelCallback() {
    return !!this.cancelCallback;
  }
  matches(e) {
    return this.snapshotCallback === e.snapshotCallback || this.snapshotCallback.userCallback !== void 0 && this.snapshotCallback.userCallback === e.snapshotCallback.userCallback && this.snapshotCallback.context === e.snapshotCallback.context;
  }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class eh {
  /**
   * @hideconstructor
   */
  constructor(e, n, s, r) {
    this._repo = e, this._path = n, this._queryParams = s, this._orderByCalled = r;
  }
  get key() {
    return K(this._path) ? null : Cu(this._path);
  }
  get ref() {
    return new _n(this._repo, this._path);
  }
  get _queryIdentifier() {
    const e = df(this._queryParams), n = Su(e);
    return n === "{}" ? "default" : n;
  }
  /**
   * An object representation of the query parameters used by this Query.
   */
  get _queryObject() {
    return df(this._queryParams);
  }
  isEqual(e) {
    if (e = Ke(e), !(e instanceof eh))
      return !1;
    const n = this._repo === e._repo, s = m_(this._path, e._path), r = this._queryIdentifier === e._queryIdentifier;
    return n && s && r;
  }
  toJSON() {
    return this.toString();
  }
  toString() {
    return this._repo.toString() + oA(this._path);
  }
}
class _n extends eh {
  /** @hideconstructor */
  constructor(e, n) {
    super(e, n, new Nu(), !1);
  }
  get parent() {
    const e = f_(this._path);
    return e === null ? null : new _n(this._repo, e);
  }
  get root() {
    let e = this;
    for (; e.parent !== null; )
      e = e.parent;
    return e;
  }
}
class Bi {
  /**
   * @param _node - A SnapshotNode to wrap.
   * @param ref - The location this snapshot came from.
   * @param _index - The iteration order for this snapshot
   * @hideconstructor
   */
  constructor(e, n, s) {
    this._node = e, this.ref = n, this._index = s;
  }
  /**
   * Gets the priority value of the data in this `DataSnapshot`.
   *
   * Applications need not use priority but can order collections by
   * ordinary properties (see
   * {@link https://firebase.google.com/docs/database/web/lists-of-data#sorting_and_filtering_data |Sorting and filtering data}
   * ).
   */
  get priority() {
    return this._node.getPriority().val();
  }
  /**
   * The key (last part of the path) of the location of this `DataSnapshot`.
   *
   * The last token in a Database location is considered its key. For example,
   * "ada" is the key for the /users/ada/ node. Accessing the key on any
   * `DataSnapshot` will return the key for the location that generated it.
   * However, accessing the key on the root URL of a Database will return
   * `null`.
   */
  get key() {
    return this.ref.key;
  }
  /** Returns the number of child properties of this `DataSnapshot`. */
  get size() {
    return this._node.numChildren();
  }
  /**
   * Gets another `DataSnapshot` for the location at the specified relative path.
   *
   * Passing a relative path to the `child()` method of a DataSnapshot returns
   * another `DataSnapshot` for the location at the specified relative path. The
   * relative path can either be a simple child name (for example, "ada") or a
   * deeper, slash-separated path (for example, "ada/name/first"). If the child
   * location has no data, an empty `DataSnapshot` (that is, a `DataSnapshot`
   * whose value is `null`) is returned.
   *
   * @param path - A relative path to the location of child data.
   */
  child(e) {
    const n = new oe(e), s = Re(this.ref, e);
    return new Bi(this._node.getChild(n), s, Ee);
  }
  /**
   * Returns true if this `DataSnapshot` contains any data. It is slightly more
   * efficient than using `snapshot.val() !== null`.
   */
  exists() {
    return !this._node.isEmpty();
  }
  /**
   * Exports the entire contents of the DataSnapshot as a JavaScript object.
   *
   * The `exportVal()` method is similar to `val()`, except priority information
   * is included (if available), making it suitable for backing up your data.
   *
   * @returns The DataSnapshot's contents as a JavaScript value (Object,
   *   Array, string, number, boolean, or `null`).
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  exportVal() {
    return this._node.val(!0);
  }
  /**
   * Enumerates the top-level children in the `IteratedDataSnapshot`.
   *
   * Because of the way JavaScript objects work, the ordering of data in the
   * JavaScript object returned by `val()` is not guaranteed to match the
   * ordering on the server nor the ordering of `onChildAdded()` events. That is
   * where `forEach()` comes in handy. It guarantees the children of a
   * `DataSnapshot` will be iterated in their query order.
   *
   * If no explicit `orderBy*()` method is used, results are returned
   * ordered by key (unless priorities are used, in which case, results are
   * returned by priority).
   *
   * @param action - A function that will be called for each child DataSnapshot.
   * The callback can return true to cancel further enumeration.
   * @returns true if enumeration was canceled due to your callback returning
   * true.
   */
  forEach(e) {
    return this._node.isLeafNode() ? !1 : !!this._node.forEachChild(this._index, (s, r) => e(new Bi(r, Re(this.ref, s), Ee)));
  }
  /**
   * Returns true if the specified child path has (non-null) data.
   *
   * @param path - A relative path to the location of a potential child.
   * @returns `true` if data exists at the specified child path; else
   *  `false`.
   */
  hasChild(e) {
    const n = new oe(e);
    return !this._node.getChild(n).isEmpty();
  }
  /**
   * Returns whether or not the `DataSnapshot` has any non-`null` child
   * properties.
   *
   * You can use `hasChildren()` to determine if a `DataSnapshot` has any
   * children. If it does, you can enumerate them using `forEach()`. If it
   * doesn't, then either this snapshot contains a primitive value (which can be
   * retrieved with `val()`) or it is empty (in which case, `val()` will return
   * `null`).
   *
   * @returns true if this snapshot has any children; else false.
   */
  hasChildren() {
    return this._node.isLeafNode() ? !1 : !this._node.isEmpty();
  }
  /**
   * Returns a JSON-serializable representation of this object.
   */
  toJSON() {
    return this.exportVal();
  }
  /**
   * Extracts a JavaScript value from a `DataSnapshot`.
   *
   * Depending on the data in a `DataSnapshot`, the `val()` method may return a
   * scalar type (string, number, or boolean), an array, or an object. It may
   * also return null, indicating that the `DataSnapshot` is empty (contains no
   * data).
   *
   * @returns The DataSnapshot's contents as a JavaScript value (Object,
   *   Array, string, number, boolean, or `null`).
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  val() {
    return this._node.val();
  }
}
function be(t, e) {
  return t = Ke(t), t._checkNotDeleted("ref"), e !== void 0 ? Re(t._root, e) : t._root;
}
function Re(t, e) {
  return t = Ke(t), X(t._path) === null ? KN("child", "path", e) : J_("child", "path", e), new _n(t._repo, ye(t._path, e));
}
function _l(t, e) {
  t = Ke(t), Yu("push", t._path), X_("push", e, t._path, !0);
  const n = Q_(t._repo), s = mL(n), r = Re(t, s), i = Re(t, s);
  let o;
  return o = Promise.resolve(i), r.then = o.then.bind(o), r.catch = o.then.bind(o, void 0), r;
}
function Cf(t) {
  return Yu("remove", t._path), zt(t, null);
}
function zt(t, e) {
  t = Ke(t), Yu("set", t._path), X_("set", e, t._path, !1);
  const n = new Zi();
  return oL(
    t._repo,
    t._path,
    e,
    /*priority=*/
    null,
    n.wrapCallback(() => {
    })
  ), n.promise;
}
function Zs(t, e) {
  YN("update", e, t._path);
  const n = new Zi();
  return aL(t._repo, t._path, e, n.wrapCallback(() => {
  })), n.promise;
}
function rs(t) {
  t = Ke(t);
  const e = new yL(() => {
  }), n = new th(e);
  return iL(t._repo, t, n).then((s) => new Bi(s, new _n(t._repo, t._path), t._queryParams.getIndex()));
}
class th {
  constructor(e) {
    this.callbackContext = e;
  }
  respondsTo(e) {
    return e === "value";
  }
  createEvent(e, n) {
    const s = n._queryParams.getIndex();
    return new gL("value", this, new Bi(e.snapshotNode, new _n(n._repo, n._path), s));
  }
  getEventRunner(e) {
    return e.getEventType() === "cancel" ? () => this.callbackContext.onCancel(e.error) : () => this.callbackContext.onValue(e.snapshot, null);
  }
  createCancelEvent(e, n) {
    return this.callbackContext.hasCancelCallback ? new _L(this, e, n) : null;
  }
  matches(e) {
    return e instanceof th ? !e.callbackContext || !this.callbackContext ? !0 : e.callbackContext.matches(this.callbackContext) : !1;
  }
  hasAnyCallback() {
    return this.callbackContext !== null;
  }
}
yN(_n);
wN(_n);
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const EL = "FIREBASE_DATABASE_EMULATOR_HOST", rd = {};
let bL = !1;
function vL(t, e, n, s) {
  t.repoInfo_ = new i_(
    `${e}:${n}`,
    /* secure= */
    !1,
    t.repoInfo_.namespace,
    t.repoInfo_.webSocketOnly,
    t.repoInfo_.nodeAdmin,
    t.repoInfo_.persistenceKey,
    t.repoInfo_.includeNamespaceInQueryParams,
    /*isUsingEmulator=*/
    !0
  ), s && (t.authTokenProvider_ = s);
}
function SL(t, e, n, s, r) {
  let i = s || t.options.databaseURL;
  i === void 0 && (t.options.projectId || cn("Can't determine Firebase Database URL. Be sure to include  a Project ID when calling firebase.initializeApp()."), Oe("Using default host for project ", t.options.projectId), i = `${t.options.projectId}-default-rtdb.firebaseio.com`);
  let o = Tf(i, r), a = o.repoInfo, c;
  typeof process < "u" && process.env && (c = process.env[EL]), c ? (i = `http://${c}?ns=${a.namespace}`, o = Tf(i, r), a = o.repoInfo) : o.repoInfo.secure;
  const l = new Ok(t.name, t.options, e);
  XN("Invalid Firebase Database URL", o), K(o.path) || cn("Database URL must point to the root of a Firebase Database (not including a child path).");
  const d = TL(a, t, l, new xk(t.name, n));
  return new IL(d, t);
}
function wL(t, e) {
  const n = rd[e];
  (!n || n[t.key] !== t) && cn(`Database ${e}(${t.repoInfo_}) has already been deleted.`), lL(t), delete n[t.key];
}
function TL(t, e, n, s) {
  let r = rd[e.name];
  r || (r = {}, rd[e.name] = r);
  let i = r[t.toURLString()];
  return i && cn("Database initialized multiple times. Please make sure the format of the database URL matches with each database() call."), i = new nL(t, bL, n, s), r[t.toURLString()] = i, i;
}
class IL {
  /** @hideconstructor */
  constructor(e, n) {
    this._repoInternal = e, this.app = n, this.type = "database", this._instanceStarted = !1;
  }
  get _repo() {
    return this._instanceStarted || (sL(this._repoInternal, this.app.options.appId, this.app.options.databaseAuthVariableOverride), this._instanceStarted = !0), this._repoInternal;
  }
  get _root() {
    return this._rootInternal || (this._rootInternal = new _n(this._repo, se())), this._rootInternal;
  }
  _delete() {
    return this._rootInternal !== null && (wL(this._repo, this.app.name), this._repoInternal = null, this._rootInternal = null), Promise.resolve();
  }
  _checkNotDeleted(e) {
    this._rootInternal === null && cn("Cannot call " + e + " on a deleted database.");
  }
}
function ve(t = cg(), e) {
  const n = du(t, "database").getImmediate({
    identifier: e
  });
  if (!n._instanceStarted) {
    const s = OI("database");
    s && CL(n, ...s);
  }
  return n;
}
function CL(t, e, n, s = {}) {
  t = Ke(t), t._checkNotDeleted("useEmulator"), t._instanceStarted && cn("Cannot call useEmulator() after instance has already been initialized.");
  const r = t._repoInternal;
  let i;
  if (r.repoInfo_.nodeAdmin)
    s.mockUserToken && cn('mockUserToken is not supported by the Admin SDK. For client access with mock users, please use the "firebase" package instead of "firebase-admin".'), i = new na(na.OWNER);
  else if (s.mockUserToken) {
    const o = typeof s.mockUserToken == "string" ? s.mockUserToken : PI(s.mockUserToken, t.app.options.projectId);
    i = new na(o);
  }
  vL(r, e, n, i);
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function FL(t) {
  _k(Hr), vr(new ys(
    "database",
    (e, { instanceIdentifier: n }) => {
      const s = e.getProvider("app").getImmediate(), r = e.getProvider("auth-internal"), i = e.getProvider("app-check-internal");
      return SL(s, r, i, n);
    },
    "PUBLIC"
    /* ComponentType.PUBLIC */
  ).setMultipleInstances(!0)), xn(zp, qp, t), xn(zp, qp, "esm2017");
}
tn.prototype.simpleListen = function(t, e) {
  this.sendRequest("q", { p: t }, e);
};
tn.prototype.echo = function(t, e) {
  this.sendRequest("echo", { d: t }, e);
};
FL();
var kL = "firebase", AL = "10.7.1";
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
xn(kL, AL, "app");
const NL = {
  apiKey: "AIzaSyCtSfIQyZua3V5lpmthL-Q49trkv9phV4g",
  authDomain: "webstructrual.firebaseapp.com",
  databaseURL: "https://webstructrual.firebaseio.com",
  projectId: "webstructrual",
  storageBucket: "webstructrual.appspot.com",
  messagingSenderId: "157062586915"
};
let Fr = !1, Mn = !1;
uu(NL);
Be().setPersistence(Mg);
function LL() {
  Be().onAuthStateChanged((t) => {
    t ? (Fr = !0, document.dispatchEvent(new CustomEvent("customer-logged-in", { detail: t })), sy()) : (document.dispatchEvent(new CustomEvent("customer-logged-out")), Fr = !1, Mn = !1);
  });
}
function RL() {
  const e = Stripe("pk_live_2xaQxOvCEelcE2SQvmCtWQac");
  let n = e.elements();
  var s = {
    base: {
      // Add your base input styles here. For example:
      fontSize: "20px",
      color: "#32325d"
    }
  };
  if (typeof n > "u") {
    console.error("unable to create Stripe Card in initializeStripe(). elements undefined");
    return;
  }
  var r = n.create("card", { style: s });
  if (typeof r > "u") {
    console.error("unable to create Stripe Card in initializeStripe(). card undefined");
    return;
  }
  r.mount("#card-element"), r.addEventListener("change", function(o) {
    var a = document.getElementById("card-errors");
    o.error ? a.textContent = o.error.message : a.textContent = "";
  });
  var i = document.getElementById("payment-form");
  i.addEventListener("click", function(o) {
    o.preventDefault(), e.createToken(r).then(function(a) {
      if (a.error) {
        var c = document.getElementById("card-errors");
        c.textContent = a.error.message, console.error(a.error.message);
      } else
        xL(a.token);
    });
  });
}
function xL(t) {
  document.dispatchEvent(new CustomEvent("processing-payment"));
  var e = document.getElementById("payment-form"), n = document.createElement("input");
  n.setAttribute("type", "hidden"), n.setAttribute("name", "stripeToken"), n.setAttribute("value", t.id), e.appendChild(n);
  var s = Be().currentUser, r = s.uid, i = s.email, o = t.id, a = t.card.id, c = document.querySelector('input[name="plan"]:checked').value, l = { uid: r, email: i, token: o, card: a, plan: c };
  Be().currentUser.getIdToken().then(function(d) {
    fetch("https://us-central1-webstructrual.cloudfunctions.net/subscription", {
      method: "POST",
      cache: "no-cache",
      // *default, no-cache, reload, force-cache, only-if-cached
      headers: {
        "Content-Type": "application/json; charset=utf-8",
        Authorization: `Bearer ${d}`
      },
      body: JSON.stringify(l)
    }).then(() => {
      document.dispatchEvent(new CustomEvent("payment-succeeded")), sy();
    }).catch((u) => {
      document.dispatchEvent(new CustomEvent("payment-failed", { detail: u }));
    });
  });
}
function sy() {
  Be().currentUser.getIdToken().then(function(t) {
    fetch("https://us-central1-webstructrual.cloudfunctions.net/checkSubscription", {
      method: "POST",
      cache: "no-cache",
      // *default, no-cache, reload, force-cache, only-if-cached
      headers: {
        "Content-Type": "application/json; charset=utf-8",
        Authorization: `Bearer ${t}`
      }
    }).then((e) => {
      e.ok ? (Mn = !0, document.dispatchEvent(new CustomEvent("customer-logged-in-and-upgraded"))) : e.text().then((n) => {
        Mn = !1, n === "Subscription is: past_due" ? document.dispatchEvent(new CustomEvent("recurring-payment-failed")) : n === "Subscription is: canceled" ? document.dispatchEvent(new CustomEvent("subscription-previously-canceled")) : document.dispatchEvent(new CustomEvent("customer-logged-in-not-upgraded"));
      });
    }).catch((e) => {
      console.error(e), Mn = !1, document.dispatchEvent(new CustomEvent("customer-logged-in-not-upgraded"));
    });
  });
}
function OL() {
  Be().signOut().catch(function(t) {
    console.error(t), Mn = !1, Fr = !1;
  }), Mn = !1, Fr = !1;
}
function PL() {
  document.dispatchEvent(new CustomEvent("logging-in"));
  let t = document.getElementById("sign-in-email").value.trim(), e = document.getElementById("sign-in-password").value.trim();
  r1(Be(), t, e).then(() => {
    Fr = !0, document.dispatchEvent(new CustomEvent("login-succeeded"));
  }).catch((n) => {
    let s = n.code, i = n.message;
    s === "auth/missing-email" && (i = "Email is required."), s === "auth/wrong-password" && (i = "Invalid password."), s === "auth/user-not-found" && (i = "User not found."), document.dispatchEvent(new CustomEvent("login-failed", { detail: i }));
  });
}
function ML() {
  document.dispatchEvent(new CustomEvent("sending-forgot-password-link"));
  let t = document.getElementById("forgot-password-email").value.trim();
  n1(Be(), t).then(function() {
    document.dispatchEvent(new CustomEvent("forgot-password-link-sent"));
  }).catch(function(e) {
    document.dispatchEvent(new CustomEvent("forgot-password-link-failed", { detail: e.message }));
  });
}
function DL() {
  xg(Be().currentUser).then(function() {
    document.dispatchEvent(new CustomEvent("verify-email-link-sent"));
  }).catch(function(t) {
    console.error(t), alert("Verification email could not be sent. Please try again later.");
  });
}
function GL() {
  document.dispatchEvent(new CustomEvent("signing-up"));
  let t = document.getElementById("sign-up-first-last").value.trim(), e = document.getElementById("sign-up-email").value.trim(), n = document.getElementById("sign-up-password").value.trim();
  if (!t || !e || !n) {
    document.dispatchEvent(new CustomEvent("sign-up-failed", { detail: "All fields required." }));
    return;
  }
  s1(Be(), e, n).then((s) => {
    xg(Be().currentUser).catch((r) => {
      console.error(r), alert("Verification email could not be sent. Please try again later.");
    }), zt(be(ve(), "users/" + Be().currentUser.uid), { username: t }).then((r) => {
      document.dispatchEvent(new CustomEvent("sign-up-succeeded"));
    }).catch((r) => {
      console.error(r), document.dispatchEvent(new CustomEvent("sign-up-failed", { detail: r.message }));
    });
  }).catch((s) => {
    let r = s.message;
    s.code === "auth/email-already-in-use" && (r = "A user with that email address already exists."), document.dispatchEvent(new CustomEvent("sign-up-failed", { detail: r }));
  });
}
function Ga() {
  document.getElementById("modal-fullscreen-wait-message").innerHTML = "Redirecting to account page...", M.getOrCreateInstance("#modal-fullscreen-wait").show(), Be().currentUser.getIdToken().then((t) => {
    document.dispatchEvent(new CustomEvent("redirecting-to-customer-portal")), fetch("https://us-central1-webstructrual.cloudfunctions.net/customerPortal", {
      method: "POST",
      cache: "no-cache",
      // *default, no-cache, reload, force-cache, only-if-cached
      headers: {
        "Content-Type": "application/json; charset=utf-8",
        Authorization: `Bearer ${t}`
      }
    }).then((e) => {
      e.ok ? e.text().then((n) => {
        window.location.replace(n);
      }) : (document.dispatchEvent(new CustomEvent("redirect-to-customer-portal-failed")), M.getOrCreateInstance("#modal-fullscreen-wait").hide());
    }).catch((e) => {
      console.error(e), document.dispatchEvent(new CustomEvent("redirect-to-customer-portal-failed")), M.getOrCreateInstance("#modal-fullscreen-wait").hide();
    });
  });
}
function Ff() {
  let t = Be().currentUser;
  if (!t)
    return Promise.resolve();
  let e = t.uid;
  const n = be(ve());
  return rs(Re(n, `users/${e}`)).then((s) => {
    if (s.exists()) {
      if (s.val().companyName)
        return s.val().companyName;
    } else
      console.error("No data available");
  }).catch((s) => {
    console.error(s);
  });
}
function BL(t) {
  let e = Be().currentUser.uid;
  const n = ve();
  Zs(be(n, "users/" + e), { companyName: t });
}
class $L extends HTMLElement {
  constructor() {
    super(), this.titleText = "New Project", this.companyName = "Your Company Name", document.addEventListener("project-loaded", (e) => this.onProjectLoaded(e.detail)), document.addEventListener("project-modified", () => this.onProjectModified()), document.addEventListener("project-saved", (e) => this.onProjectSaved(e.detail)), Ff();
  }
  onProjectLoaded(e) {
    this.titleText = e.title, document.getElementById("project-header-project-title-input").value = this.titleText, document.getElementById("project-header-project-title").innerHTML = this.titleText, document.getElementById("project-header-project-needs-saved").innerHTML = String.raw`
      <small><em>Loading project...</span></em></small>`, document.getElementById("project-header-project-needs-saved").classList.remove("d-none"), setTimeout(() => {
      document.getElementById("project-header-project-needs-saved").classList.add("d-none");
    }, 1e3), this.companyName = "My Company Name", Ff().then((n) => {
      this.companyName = typeof n < "u" ? n : this.companyName, document.getElementById("project-header-company-name-input").value = this.companyName, document.getElementById("project-header-company-name").innerHTML = this.companyName;
    });
  }
  onProjectModified() {
    s3() === !0 && (document.getElementById("project-header-project-needs-saved").innerHTML = String.raw`
        <small><em>Project modified, save now? <i class="fa fa-save"></i></span></em></small>`, document.getElementById("project-header-project-needs-saved").classList.remove("d-none"));
  }
  onProjectSaved() {
    document.getElementById("project-header-project-needs-saved").innerHTML = String.raw`
      <small><em>All changes saved <i class="fa fa-save"></i></span></em></small>`, document.getElementById("project-header-project-needs-saved").classList.remove("d-none"), setTimeout(() => {
      document.getElementById("project-header-project-needs-saved").classList.add("d-none");
    }, 3e3);
  }
  onSaveProjectInfo() {
    if (Je()) {
      M.getOrCreateInstance("#modal-project-header-settings-dialog").hide();
      return;
    }
    let e = document.getElementById("project-header-project-title-input").value;
    if (e === "") {
      document.getElementById("modal-project-header-settings-error").classList.remove("d-none");
      return;
    }
    document.getElementById("modal-project-header-settings-error").classList.add("d-none"), this.titleText = e, document.getElementById("project-header-project-title").innerHTML = this.titleText, document.dispatchEvent(new CustomEvent("project-title-changed", { detail: this.titleText }));
    let n = document.getElementById("project-header-company-name-input").value;
    this.companyName = n, BL(this.companyName), M.getOrCreateInstance("#modal-project-header-settings-dialog").hide();
  }
  onUpdate(e) {
    this.titleText = e.title, document.getElementById("project-title-header-settings-text-input").value = this.titleText;
  }
  get projectTitleText() {
    return document.getElementById("project-title-header-settings-text-input").value;
  }
  connectedCallback() {
    this.innerHTML = String.raw`
      <!-- project header -->
      <div class="row my-2 align-items-end">
        <div class="col">
          <div id="top-design-summary-panel" class="px-3">
            <div class="d-flex align-items-end flex-wrap justify-content-between">
              <div class="d-flex align-items-end">
                <a href="#" class="fs-5 fw-bolder float-start text-muted align-bottom" style="text-decoration: none;" 
                  data-bs-toggle="modal" data-bs-target="#modal-project-header-settings-dialog">
                  <span id="project-header-project-title" >Untitled Project</span>

                  <span class="hidden-print mx-1">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-pencil" viewBox="0 0 16 16">
                      <path d="M12.146.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1 0 .708l-10 10a.5.5 0 0 1-.168.11l-5 2a.5.5 0 0 1-.65-.65l2-5a.5.5 0 0 1 .11-.168zM11.207 2.5 13.5 4.793 14.793 3.5 12.5 1.207zm1.586 3L10.5 3.207 4 9.707V10h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.293zm-9.761 5.175-.106.106-1.528 3.821 3.821-1.528.106-.106A.5.5 0 0 1 5 12.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.468-.325"/>
                    </svg>
                  </span>
                </a>
                <span class="fs-6 px-1 align-bottom d-flex align-items-end">
                  <a href="#" id="project-header-project-needs-saved" class="text-muted hidden-print d-none" style="cursor: pointer;"></a>
                </span>
              </div>
              <div class="d-flex align-items-end">
                <span class="float-end align-bottom d-flex align-items-end">
                  <a href="#" id="project-header-company-name" class="fw-bolder float-end text-muted align-bottom" style="text-decoration: none;" 
                    data-bs-toggle="modal" data-bs-target="#modal-project-header-settings-dialog">
                    Company Name Here
                  </a>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="modal fade" id="modal-project-header-settings-dialog" tabindex="-1" role="dialog">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header border-bottom-0">
              <h1 class="modal-title fs-5">Project Header Settings</h1>
              <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>

            <div class="modal-body">

              <div id="modal-project-header-settings-error" class="alert alert-danger d-none">
                Title can't be blank.
              </div>

              <div class="mb-3">
                <label for="project-header-project-title-input" class="form-label">Project Title</label>
                <input type="text" class="form-control" id="project-header-project-title-input" value="${this.titleText}">
              </div>

              <div class="mb-3">
                <label for="project-header-company-name-input" class="form-label">Your Company Name</label>
                <input type="text" class="form-control" id="project-header-company-name-input" value="${this.companyName}">
              </div>
              
              <div class="modal-footer">
                <button type="button" class="btn btn-primary" id="modal-project-header-settings-save-button">
                  Save
                </button>

                <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cancel</button>
              </div>
            </div>
          </div>
        </div>
      </div>
      `, document.getElementById("project-header-project-needs-saved").addEventListener("click", () => {
      document.dispatchEvent(new CustomEvent("save-project"));
    }), document.getElementById("modal-project-header-settings-save-button").addEventListener("click", this.onSaveProjectInfo);
  }
}
customElements.define("project-header-component", $L);
function hi(t, e, n) {
  document.getElementById("project-yes-no-modal-yes-button").onclick = n, document.getElementById("project-yes-no-modal-title").innerHTML = t, document.getElementById("project-yes-no-modal-body").innerHTML = e, M.getOrCreateInstance(document.getElementById("project-yes-no-modal")).show();
}
var VL = new RegExp(/^(\s{0,})(-{0,1})\d*(|\.\d*)(\s{0,1})(\"|in|inch|inches)(\s{0,})$/), ry = new RegExp(/(\"|in|inch|inches)/), UL = new RegExp(/^(\s{0,})(-{0,1})\d*\/\d*(\s{0,1})(\"|in|inch|inches)(\s{0,})$/), HL = new RegExp(/^(\s{0,})(-{0,1})\d*(|\.\d*)(\s{0,1})(\'|ft|feet)(\s{0,})$/), id = new RegExp(/(\'|ft|feet)/), jL = new RegExp(/^(\s{0,})(-{0,1})\d*(\s{0,1})(\'|ft|feet)(\s{0,})\d*((\s{0,})|(\s{0,1})(\"|in|inch|inches)(\s{0,}))$/), WL = new RegExp(/^(\s{0,})(-{0,1})\d*(\s{0,1})(\'|ft|feet)(\s{0,})\d*(\s{0,1})\d*\/\d*(\s{0,1})(\"|in|inch|inches)(\s{0,})$/), zL = new RegExp(/^(\s{0,})(-{0,1})\d*(\s{0,1})$/), qL = new RegExp(/^(\s{0,})(-{0,1})\d*(|\.\d*)(\s{0,1})$/), YL = new RegExp(/^(\s{0,})(-{0,1})\d*(|\.\d*)(\s{0,1})(m|meter|meters)(\s{0,})$/), KL = new RegExp(/(m|meter|meters)/), XL = new RegExp(/^(\s{0,})(-{0,1})\d*(|\.\d*)(\s{0,1})((cm)|(centimeter)|(centimeters))(\s{0,})$/), JL = new RegExp(/(cm|centimeter|centimeters)/), QL = new RegExp(/^(\s{0,})(-{0,1})\d*(|\.\d*)(\s{0,1})(mm|millimeter|millimeters)(\s{0,})$/), ZL = new RegExp(/(mm|millimeter|millimeters)/);
function od(t) {
  var e = t.split(ry);
  if (e.length <= 0 || isNaN(e[0]))
    throw "Error Parsing Inches: " + t;
  return Number(e[0]);
}
function kf(t) {
  var e = t.split(ry);
  if (e.length > 0 && (e = e[0].split(/\//), e.length > 1)) {
    var n = e[0], s = od(e[1]);
    if (!isNaN(n) && !isNaN(s))
      return Number(n) / Number(s);
  }
  throw "Error Parsing Inch Fraction: " + t;
}
function e5(t) {
  var e = t.split(id);
  if (e.length <= 0 || isNaN(e[0]))
    throw "Error Parsing Feet: " + t;
  return Number(e[0] * 12);
}
function t5(t, e) {
  if (t = t.replace(/[\u2018\u2019]/g, "'").replace(/[\u201C\u201D]/g, '"'), t.match(zL) || t.match(qL))
    return Number(t) * 12;
  if (t.match(VL))
    return od(t);
  if (t.match(UL))
    return kf(t);
  if (t.match(HL))
    return e5(t);
  if (t.match(jL)) {
    var n = t.split(id);
    try {
      var s = Number(n[0]), r = od(n[2]);
      return s * 12 + r;
    } catch (c) {
      return console.log(c), 0;
    }
  }
  if (t.match(WL)) {
    const c = t.split(id), l = Number(c[0]);
    let d = c[2].split(" ");
    d.length < 3 && d.unshift(" ");
    const u = Number(d[1]) || 0, h = kf(d[2]);
    return l * 12 + u + h;
  }
  if (t.match(YL)) {
    var n = t.split(KL), i = Number(n[0]);
    return Math.round(i * 39.370078 * 1e4) / 1e4;
  }
  if (t.match(XL)) {
    var n = t.split(JL), o = Number(n[0]);
    return o * 0.39370078;
  }
  if (t.match(QL)) {
    var n = t.split(ZL), a = Number(n[0]);
    return a * 0.039370078;
  }
  return NaN;
}
function ho(t) {
  const e = document.getElementById(t);
  if (e.value !== null && e.value.trim() !== "") {
    const n = document.getElementById(`${t}-error`);
    return n && n.remove(), !0;
  } else {
    const n = document.createElement("div");
    return n.id = `${t}-error`, n.innerHTML = "This field is required.", e.parentElement.appendChild(n), !1;
  }
}
function nh(t) {
  const e = document.getElementById(t);
  if (isNaN(t5(e.value))) {
    const n = document.createElement("div");
    return n.id = `${t}-error`, n.innerHTML = 'Please enter a valid length unit. For example <code>5 in</code>, <code>5 inches</code> or <code>5"</code>', e.parentElement.appendChild(n), !1;
  } else {
    const n = document.getElementById(`${t}-error`);
    return n && n.remove(), !0;
  }
}
function n5(t) {
  document.getElementById("rename-folder-folder-name").value = t.title, document.getElementById("rename-folder-save-button").addEventListener("click", () => {
    if (ho("rename-folder-folder-name")) {
      const e = document.getElementById("rename-folder-folder-name").value;
      document.dispatchEvent(new CustomEvent("rename-folder", { detail: { uuid: t.key, newName: e } })), M.getOrCreateInstance("#rename-folder-modal").hide();
    }
  }), M.getOrCreateInstance("#rename-folder-modal").show();
}
class s5 extends HTMLElement {
  constructor() {
    super(), document.addEventListener("projects-loaded", (e) => this.onProjectsLoaded(e.detail)), document.addEventListener("project-loaded", (e) => this.onProjectLoaded(e.detail));
  }
  onProjectLoaded(e) {
    document.getElementById("move-file-file-title").innerHTML = e.title;
  }
  onCreateFolderClick() {
    if (ho("folder-name")) {
      const e = document.getElementById("folder-name").value;
      document.dispatchEvent(new CustomEvent("create-folder", { detail: e })), M.getOrCreateInstance("#new-folder-modal").hide();
    }
  }
  onProjectsLoaded(e) {
    const n = e.folders, s = document.getElementById("modal-file-move-folder-list");
    if (typeof n > "u" || n.length <= 0) {
      s.innerHTML = "<em>Empty (add a folder to move this file)</em>";
      return;
    }
    let r = "<table class='table table-borderless table-hover' style='cursor:pointer;'>";
    r += `<tr id='home-modal-move-to-folder'><td><i class="fa fa-folder fa-fw me-3"></i> Home</td></tr>`, n.forEach((i) => {
      r += `<tr id='${i.key}-modal-move-to-folder'><td><i class="fa fa-folder fa-fw me-3"></i> ${i.title}</td></tr>`;
    }), r += "</table>", s.innerHTML = r, document.getElementById("home-modal-move-to-folder").onclick = () => {
      document.dispatchEvent(new CustomEvent("add-active-project-to-folder")), M.getOrCreateInstance("#move-file-to-folder-modal").hide();
    }, n.forEach((i) => {
      const o = document.getElementById(`${i.key}-modal-move-to-folder`);
      o.onclick = () => {
        document.dispatchEvent(new CustomEvent("add-active-project-to-folder", { detail: i.key })), M.getOrCreateInstance("#move-file-to-folder-modal").hide();
      };
    });
  }
  connectedCallback() {
    this.innerHTML = String.raw`
    <div class="modal" tabindex="-1" id="new-folder-modal">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Create a New Folder</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body" >
            <div class="mb-3">  
              <label for="folder-name">Folder Name</label>
              <input type="text" class="form-control" id="folder-name" aria-describedby="folder-name" value="New Folder">
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cancel</button>
            <button type="button" class="btn btn-primary" id="new-folder-create-button">Create</button>
          </div>
        </div>
      </div>
    </div>

    <div class="modal" tabindex="-1" id="rename-folder-modal">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Rename Folder</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body" >
            <div class="mb-3">  
              <label for="folder-name">New Name</label>
              <input type="text" class="form-control" id="rename-folder-folder-name" aria-describedby="folder-name" value="">
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cancel</button>
            <button type="button" class="btn btn-primary" id="rename-folder-save-button">Save</button>
          </div>
        </div>
      </div>
    </div>

    <div class="modal" tabindex="-1" id="move-file-to-folder-modal">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Move "<span id="move-file-file-title"></span>"</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body" >
            <div class="mb-3">  
              <div id="modal-file-move-folder-list">
                <em>Empty (add a folder to move this file)</em>
              </div>
            </div>
          </div>
          <div class="modal-footer justify-content-between">
            <div>
              <button type="button" class="btn btn-success pull-left" data-bs-dismiss="modal" id="move-file-new-folder-button"><i class="fa fa-plus"></i> New</button>
            </div>
            <div>
              <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cancel</button>
            </div>
          </div>
        </div>
      </div>
    </div>
    `, document.getElementById("new-folder-create-button").addEventListener("click", this.onCreateFolderClick);
  }
}
customElements.define("new-folder-component", s5);
class r5 extends HTMLElement {
  constructor() {
    super(), document.addEventListener("customer-logged-in-and-upgraded", () => this.onLoggedInAndUpgraded()), document.addEventListener("customer-logged-in-not-upgraded", () => this.onLoggedInNotUpgraded()), document.addEventListener("recurring-payment-failed", () => this.onLoggedInPaymentFailed()), document.addEventListener("subscription-previously-canceled", () => this.onLoggedInNotUpgraded()), document.addEventListener("customer-logged-out", () => this.onLogout()), document.addEventListener("projects-loaded", (e) => this.onProjectsLoaded(e.detail));
  }
  onLoggedInAndUpgraded() {
    document.getElementById("upgrade-list-item").classList.add("d-none"), document.getElementById("start-upgrade-list-item").classList.add("d-none"), document.getElementById("finish-upgrade-list-item").classList.add("d-none"), document.getElementById("manage-payment-list-item").classList.add("d-none"), document.getElementById("folder-1").classList.remove("d-none"), document.getElementById("project-list").classList.remove("d-none"), document.getElementById("project-list-folders").innerHTML = "", document.getElementById("project-list-folders").classList.remove("d-none"), document.getElementById("project-list").innerHTML = String.raw`

      <div class="list-group my-2">
        <div class="list-group-item">
          <div>
            <span class="spinner-border spinner-border-sm"></span>
            Loading...
          </div>
        </div>
      </div>
      `;
  }
  onLoggedInNotUpgraded() {
    document.getElementById("upgrade-list-item").classList.add("d-none"), document.getElementById("start-upgrade-list-item").classList.add("d-none"), document.getElementById("finish-upgrade-list-item").classList.remove("d-none"), document.getElementById("manage-payment-list-item").classList.add("d-none"), document.getElementById("project-list").innerHTML = "", document.getElementById("project-list").classList.add("d-none"), document.getElementById("folder-1").classList.add("d-none"), document.getElementById("project-list-folders").innerHTML = "", document.getElementById("project-list-folders").classList.add("d-none");
  }
  onLoggedInPaymentFailed() {
    document.getElementById("upgrade-list-item").classList.add("d-none"), document.getElementById("start-upgrade-list-item").classList.add("d-none"), document.getElementById("finish-upgrade-list-item").classList.add("d-none"), document.getElementById("manage-payment-list-item").classList.remove("d-none"), document.getElementById("project-list").innerHTML = "", document.getElementById("project-list").classList.add("d-none"), document.getElementById("folder-1").classList.add("d-none"), document.getElementById("project-list-folders").innerHTML = "", document.getElementById("project-list-folders").classList.add("d-none");
  }
  onLogout() {
    document.getElementById("upgrade-list-item").classList.remove("d-none"), document.getElementById("start-upgrade-list-item").classList.remove("d-none"), document.getElementById("finish-upgrade-list-item").classList.add("d-none"), document.getElementById("manage-payment-list-item").classList.add("d-none"), document.getElementById("project-list").classList.add("d-none"), document.getElementById("project-list").innerHTML = "", document.getElementById("folder-1").classList.add("d-none"), document.getElementById("project-list-folders").innerHTML = "", document.getElementById("project-list-folders").classList.add("d-none");
  }
  showDate(e) {
    return new Date(e).toDateString();
  }
  createFileNode(e) {
    return String.raw`
      <div id="project-${e.key}" class="card mb-3 project-card ${e.isActive ? "project-selected" : ""} text-center">
        <div class="card-body p-3">
          <i class="fa fa-file fa-fw fs-1 ${e.isActive ? "" : "text-muted"}"></i>
          <div class="project-title text-truncate" style="max-width: 220px;">${e.title}</div>
          <div class="project-meta small">Created ${this.showDate(e.createdAt)}</div>
          <div class="project-meta small">Modified ${this.showDate(e.modifiedAt)}</div>
        </div>
      </div>`;
  }
  createFolderNode(e) {
    return String.raw`
    <div class="accordion my-2" id="${e.key}">
      <div class="accordion-item">
        <h2 class="accordion-header" id="${e.key}-heading">
          <button class="accordion-button collapsed" type="button" id="${e.key}-button" data-bs-toggle="collapse" data-bs-target="#${e.key}-collapse" aria-expanded="false" aria-controls="${e.key}">
          <i class="fa fa-folder fa-fw me-3"></i> ${e.title}
          </button>
        </h2>
        <div id="${e.key}-collapse" class="accordion-collapse collapse" data-bs-parent="#${e.key}" aria-labelledby="${e.key}-heading">
          <div class="accordion-body" style="cursor:pointer;">
            <!-- edit folder -->
            <div class="navbar bg-light shadow-sm hidden-print">
              <div clas="dropdown">
                <a class="btn btn-sm " href="#" role="button" id="edit-folder-dropdown-${e.key}" data-bs-toggle="dropdown" aria-expanded="false">
                  Edit folder...
                </a>
                <ul class="dropdown-menu" aria-labelledby="edit-folder-dropdown-${e.key}">
                  <li><a class="dropdown-item" href="#" id="edit-folder-rename-${e.key}"><i class="fa fa-fw fa-edit"></i> Rename Folder...</a></li>
                  <li><a class="dropdown-item" href="#" id="edit-folder-delete-${e.key}"><i class="fa fa-fw fa-trash"></i> Delete Folder...</a></li>
                </ul>
              </div>
            </div>
          
            <!-- project list -->
            <div id="project-list-for-folder-${e.key}" style="cursor:pointer;">
              <div class="p-3"><em>Empty</em></div>
            </div>
             
          </div>
        </div>
      </div>
    </div>
    `;
  }
  onProjectsLoaded(e) {
    const n = e.projects, s = e.folders, r = {};
    n.forEach((a) => {
      r[a.key] = a;
    });
    let i = "";
    typeof s < "u" && (s.forEach((a) => {
      i += this.createFolderNode(a);
    }), document.getElementById("project-list-folders").innerHTML = i, s.forEach((a) => {
      const c = document.getElementById(`project-list-for-folder-${a.key}`);
      let l = "";
      typeof a.projects < "u" && (Object.keys(a.projects).forEach((u) => {
        if (u in r) {
          const h = r[u];
          l += this.createFileNode(h), h.isActive === !0 && (document.getElementById(`${a.key}-collapse`).classList.add("show"), document.getElementById(`${a.key}-button`).classList.remove("collapsed"), document.getElementById("folder-1-collapse").classList.remove("show"), document.getElementById("folder-1-button").classList.add("collapsed"));
        }
        delete r[u];
      }), c.innerHTML = l);
    }), s.forEach((a) => {
      const c = document.getElementById(`edit-folder-rename-${a.key}`), l = document.getElementById(`edit-folder-delete-${a.key}`);
      c && (c.onclick = () => {
        n5(a);
      }), l && (l.onclick = () => {
        hi("Delete Folder", `Delete folder ${a.title}? <br><small class="text-muted">Designs will be moved back to your Home folder</small>`, () => {
          document.dispatchEvent(new CustomEvent("delete-folder", { detail: a }));
        });
      });
    }));
    let o = "";
    n.forEach((a) => {
      a.key in r && (o += this.createFileNode(a), a.isActive === !0 && document.getElementById("folder-1-collapse").classList.add("show"));
    }), document.getElementById("project-list").innerHTML = o, n.forEach((a) => {
      if (!a.isActive) {
        const c = document.getElementById(`project-${a.key}`);
        c && (c.onclick = async () => {
          document.dispatchEvent(new CustomEvent("load-project", { detail: a }));
        });
      }
    }), M.getOrCreateInstance("#modal-fullscreen-wait").hide();
  }
  connectedCallback() {
    this.innerHTML = String.raw`

      <style>
        .project-card {
          border-radius: 0.75rem;
          transition: box-shadow 0.2s ease, transform 0.2s ease;
        }

        .project-card:hover {
          box-shadow: 0 4px 12px rgba(0,0,0,0.08);
          transform: translateY(-2px);
        }

        .project-selected {
          background-color: #e9f5ff;
          border: 1px solid #0d6efd;
        }

        .project-title {
          font-size: 1rem;
          font-weight: 600;
          color: #212529;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          margin-bottom: 4px;
        }

        .project-meta {
          font-size: 0.75rem;
          color: #6c757d;
        }
      </style>
      <!-- new project or folder -->

      <div class="list-group my-3 mx-1 ws-design-succeeded bg-white" style="cursor: pointer;">
        <div class="btn btn-success bg-opacity-25 " type="button" data-bs-toggle="dropdown" aria-expanded="false">
          <div class="text-center" >
          <i class="fa fa-plus"></i> New
          </div>
        </div>
        <ul class="dropdown-menu">
          <li id="project-list-new-project"><a class="dropdown-item" href="#"><i class="fa fa-file-o fa-fw me-3"></i> New Design</a></li>
          <li><hr class="dropdown-divider"></li>
          <li id="project-list-new-folder"><a class="dropdown-item" href="#"><i class="fa fa-folder-o fa-fw me-3"></i> New Folder</a></li>
        </ul>
      </div>

      <div class="accordion my-2" id="folder-1">
        <div class="accordion-item">
          <h2 class="accordion-header" id="folder-1-heading">
            <button class="accordion-button" type="button" id="folder-1-button" data-bs-toggle="collapse" data-bs-target="#folder-1-collapse" aria-expanded="true" aria-controls="folder-1">
            <i class="fa fa-folder fa-fw me-3"></i> Home
            </button>
          </h2>
          <div id="folder-1-collapse" class="accordion-collapse collapse" data-bs-parent="#folder-1" aria-labelledby="folder-1-heading">
            <div class="accordion-body">
              <!-- project list -->
              <div id="project-list" style="cursor:pointer;"></div>
            </div>
          </div>
        </div>
      </div>

      <div id="project-list-folders"></div>

      <!-- updgrade list item -->
      <div class="list-group d-none" id="upgrade-list-item">
        <a href="#" data-bs-toggle="modal" data-bs-target="#modal-sign-up-form">
          <div class="card shadow-sm border-0 mb-2">
            <div class="card-body">
              <h5 class="card-title fw-bold text-dark">Print and Save Projects</h5>
              <p class="card-text text-muted mb-0">Upgrade for <strong>$19/month or $199/year</strong></p>
            </div>
          </div>
        </a>
      </div>

      <!-- start upgrade button -->
      <div class="list-group my-2 mx-1 button-shadow" id="start-upgrade-list-item">
        <a href="#" class="btn btn-lg btn-success btn-block button-shadow" data-bs-toggle="modal" data-bs-target="#modal-sign-up-form">
          Upgrade
        </a>
      </div>

      <!-- start subscription button -->
      <div class="list-group my-2 mx-1 button-shadow" id="finish-upgrade-list-item">
        <a href="#" class="btn btn-lg btn-success btn-block" data-bs-toggle="modal"
          data-bs-target="#modal-finish-upgrade">Start Subscription
        </a>
      </div>

      <!-- payment failed button -->
      <div class="list-group my-2 mx-1 button-shadow d-none" id="manage-payment-list-item">
        <a href="#" class="btn btn-lg btn-warning btn-block">Manage Payment Method</a>
      </div>
      `, document.getElementById("manage-payment-list-item").addEventListener("click", Ga);
  }
}
customElements.define("project-list-component", r5);
const i5 = [
  { Grade: "1.3E", Type: "TimberStrand LSL", G: "81", E: "1300", Emin: "660750", Fb: "1700", Ft: "1300", "Fc perpendicular": "710", "Fc parallel": "1835", Fv: "425", SG: "0.5" },
  { Grade: "1.55E", Type: "TimberStrand LSL", G: "97", E: "1550", Emin: "787815", Fb: "2325", Ft: "1290", "Fc perpendicular": "900", "Fc parallel": "2170", Fv: "310", SG: "0.5" },
  { Grade: "2.0E", Type: "Microllam LVL", G: "125", E: "2000", Emin: "1016535", Fb: "2600", Ft: "1895", "Fc perpendicular": "750", "Fc parallel": "2510", Fv: "285", SG: "0.5" },
  { Grade: "2.0E", Type: "Parallam PSL", G: "125", E: "2000", Emin: "1016535", Fb: "2900", Ft: "2300", "Fc perpendicular": "625", "Fc parallel": "2900", Fv: "290", SG: "0.5" },
  { Grade: "2.1E 3100", Type: "LVL (East)", G: "125", E: "2100", Emin: "1100", Fb: "3100", Ft: "1950", "Fc perpendicular": "750", "Fc parallel": "3000", Fv: "285", SG: "0.5" },
  { Grade: "1.8E 2650", Type: "Stud LVL (East)", G: "100", E: "1800", Emin: "900", Fb: "2650", Ft: "1650", "Fc perpendicular": "750", "Fc parallel": "3000", Fv: "285", SG: "0.5" },
  { Grade: '2.1E 2800 1 3/4"', Type: "LVL (West)", G: "125", E: "2100", Emin: "1100", Fb: "2800", Ft: "1950", "Fc perpendicular": "750", "Fc parallel": "3000", Fv: "285", SG: "0.5" },
  { Grade: "2.1E 2800", Type: "LVL (West)", G: "125", E: "2100", Emin: "1100", Fb: "3100", Ft: "1950", "Fc perpendicular": "750", "Fc parallel": "3000", Fv: "285", SG: "0.5" },
  { Grade: "1.8E 2400", Type: "LVL (West)", G: "100", E: "1800", Emin: "900", Fb: "2400", Ft: "1500", "Fc perpendicular": "750", "Fc parallel": "3000", Fv: "285", SG: "0.5" },
  { Grade: "1.5E 1800", Type: "LVL (West)", G: "97", E: "1500", Emin: "700", Fb: "1800", Ft: "1100", "Fc perpendicular": "525", "Fc parallel": "2500", Fv: "225", SG: "0.5" },
  { Grade: "1.8E", Type: "Glulam 24F-V4 IJC", G: "100", E: "1800", Emin: "900", Fb: "2400", Ft: "1100", "Fc perpendicular": "650", "Fc parallel": "1650", Fv: "265", SG: "0.5" }
];
window.engineeredLumberMaterials = i5;
const Ba = [
  { Type: "Visually Graded Lumber", Species: "Alaska Cedar", Grade: "Select Structural", Fb: "1150.0", Ft: "625.0", Fv: "165.0", Fcp: "525.0", Fc: "1000.0", E: "1400000.0", Emin: "510000.0", G: "0.47" },
  { Type: "Visually Graded Lumber", Species: "Alaska Cedar", Grade: "No.1", Fb: "975.0", Ft: "525.0", Fv: "165.0", Fcp: "525.0", Fc: "900.0", E: "1400000.0", Emin: "470000.0", G: "0.47" },
  { Type: "Visually Graded Lumber", Species: "Alaska Cedar", Grade: "No.2", Fb: "800.0", Ft: "425.0", Fv: "165.0", Fcp: "252.0", Fc: "750.0", E: "1200000.0", Emin: "440000.0", G: "0.47" },
  { Type: "Visually Graded Lumber", Species: "Alaska Cedar", Grade: "No.3", Fb: "450.0", Ft: "250.0", Fv: "165.0", Fcp: "525.0", Fc: "425.0", E: "1100000.0", Emin: "400000.0", G: "0.47" },
  { Type: "Visually Graded Lumber", Species: "Alaska Cedar", Grade: "Stud", Fb: "625.0", Ft: "350.0", Fv: "165.0", Fcp: "525.0", Fc: "475.0", E: "1100000.0", Emin: "400000.0", G: "0.47" },
  { Type: "Visually Graded Lumber", Species: "Alaska Cedar", Grade: "Construction", Fb: "900.0", Ft: "500.0", Fv: "165.0", Fcp: "525.0", Fc: "950.0", E: "1200000.0", Emin: "440000.0", G: "0.47" },
  { Type: "Visually Graded Lumber", Species: "Alaska Cedar", Grade: "Standard", Fb: "500.0", Ft: "275.0", Fv: "165.0", Fcp: "525.0", Fc: "775.0", E: "1100000.0", Emin: "400000.0", G: "0.47" },
  { Type: "Visually Graded Lumber", Species: "Alaska Cedar", Grade: "Utility", Fb: "250.0", Ft: "125.0", Fv: "165.0", Fcp: "525.0", Fc: "500.0", E: "1000000.0", Emin: "370000.0", G: "0.47" },
  { Type: "Visually Graded Lumber", Species: "Alaska Hemlock", Grade: "Select Structural", Fb: "1300.0", Ft: "825.0", Fv: "185.0", Fcp: "440.0", Fc: "1200.0", E: "1700000.0", Emin: "620000.0", G: "0.46" },
  { Type: "Visually Graded Lumber", Species: "Alaska Hemlock", Grade: "No.1", Fb: "900.0", Ft: "550.0", Fv: "185.0", Fcp: "440.0", Fc: "1100.0", E: "1700000.0", Emin: "580000.0", G: "0.46" },
  { Type: "Visually Graded Lumber", Species: "Alaska Hemlock", Grade: "No.2", Fb: "825.0", Ft: "475.0", Fv: "185.0", Fcp: "440.0", Fc: "150.0", E: "1500000.0", Emin: "550000.0", G: "0.46" },
  { Type: "Visually Graded Lumber", Species: "Alaska Hemlock", Grade: "No.3", Fb: "475.0", Ft: "275.0", Fv: "185.0", Fcp: "440.0", Fc: "600.0", E: "1400000.0", Emin: "510000.0", G: "0.46" },
  { Type: "Visually Graded Lumber", Species: "Alaska Hemlock", Grade: "Stud", Fb: "650.0", Ft: "375.0", Fv: "185.0", Fcp: "440.0", Fc: "650.0", E: "1400000.0", Emin: "510000.0", G: "0.46" },
  { Type: "Visually Graded Lumber", Species: "Alaska Hemlock", Grade: "Construction", Fb: "950.0", Ft: "550.0", Fv: "185.0", Fcp: "440.0", Fc: "1250.0", E: "1400000.0", Emin: "510000.0", G: "0.46" },
  { Type: "Visually Graded Lumber", Species: "Alaska Hemlock", Grade: "Standard", Fb: "525.0", Ft: "300.0", Fv: "185.0", Fcp: "440.0", Fc: "1050.0", E: "1300000.0", Emin: "470000.0", G: "0.46" },
  { Type: "Visually Graded Lumber", Species: "Alaska Hemlock", Grade: "Utility", Fb: "250.0", Ft: "150.0", Fv: "185.0", Fcp: "440.0", Fc: "700.0", E: "1200000.0", Emin: "440000.0", G: "0.46" },
  { Type: "Visually Graded Lumber", Species: "Alaska Spruce", Grade: "Select Structural", Fb: "1400.0", Ft: "900.0", Fv: "160.0", Fcp: "330.0", Fc: "1200.0", E: "1600000.0", Emin: "580000.0", G: "0.41" },
  { Type: "Visually Graded Lumber", Species: "Alaska Spruce", Grade: "No.1", Fb: "950.0", Ft: "600.0", Fv: "160.0", Fcp: "330.0", Fc: "1100.0", E: "1600000.0", Emin: "550000.0", G: "0.41" },
  { Type: "Visually Graded Lumber", Species: "Alaska Spruce", Grade: "No.2", Fb: "875.0", Ft: "500.0", Fv: "160.0", Fcp: "330.0", Fc: "1050.0", E: "1400000.0", Emin: "510000.0", G: "0.41" },
  { Type: "Visually Graded Lumber", Species: "Alaska Spruce", Grade: "No.3", Fb: "500.0", Ft: "300.0", Fv: "160.0", Fcp: "330.0", Fc: "600.0", E: "1300000.0", Emin: "470000.0", G: "0.41" },
  { Type: "Visually Graded Lumber", Species: "Alaska Spruce", Grade: "Stud", Fb: "675.0", Ft: "400.0", Fv: "160.0", Fcp: "330.0", Fc: "675.0", E: "1300000.0", Emin: "470000.0", G: "0.41" },
  { Type: "Visually Graded Lumber", Species: "Alaska Spruce", Grade: "Construction", Fb: "1000.0", Ft: "575.0", Fv: "160.0", Fcp: "330.0", Fc: "1250.0", E: "1300000.0", Emin: "470000.0", G: "0.41" },
  { Type: "Visually Graded Lumber", Species: "Alaska Spruce", Grade: "Standard", Fb: "550.0", Ft: "325.0", Fv: "160.0", Fcp: "330.0", Fc: "1050.0", E: "1200000.0", Emin: "440000.0", G: "0.41" },
  { Type: "Visually Graded Lumber", Species: "Alaska Spruce", Grade: "Utility", Fb: "275.0", Ft: "150.0", Fv: "160.0", Fcp: "330.0", Fc: "700.0", E: "1100000.0", Emin: "400000.0", G: "0.41" },
  { Type: "Visually Graded Lumber", Species: "Alaska Yellow Cedar", Grade: "Select Structural", Fb: "1350.0", Ft: "800.0", Fv: "225.0", Fcp: "510.0", Fc: "1200.0", E: "1500000.0", Emin: "550000.0", G: "0.46" },
  { Type: "Visually Graded Lumber", Species: "Alaska Yellow Cedar", Grade: "No.1", Fb: "900.0", Ft: "525.0", Fv: "225.0", Fcp: "510.0", Fc: "1050.0", E: "1500000.0", Emin: "510000.0", G: "0.46" },
  { Type: "Visually Graded Lumber", Species: "Alaska Yellow Cedar", Grade: "No.2", Fb: "800.0", Ft: "450.0", Fv: "225.0", Fcp: "510.0", Fc: "1000.0", E: "1300000.0", Emin: "470000.0", G: "0.46" },
  { Type: "Visually Graded Lumber", Species: "Alaska Yellow Cedar", Grade: "No.3", Fb: "475.0", Ft: "250.0", Fv: "225.0", Fcp: "510.0", Fc: "575.0", E: "1200000.0", Emin: "440000.0", G: "0.46" },
  { Type: "Visually Graded Lumber", Species: "Alaska Yellow Cedar", Grade: "Stud", Fb: "625.0", Ft: "350.0", Fv: "225.0", Fcp: "510.0", Fc: "625.0", E: "1200000.0", Emin: "440000.0", G: "0.46" },
  { Type: "Visually Graded Lumber", Species: "Alaska Yellow Cedar", Grade: "Construction", Fb: "925.0", Ft: "500.0", Fv: "225.0", Fcp: "510.0", Fc: "1250.0", E: "1300000.0", Emin: "330000.0", G: "0.46" },
  { Type: "Visually Graded Lumber", Species: "Alaska Yellow Cedar", Grade: "Standard", Fb: "500.0", Ft: "275.0", Fv: "225.0", Fcp: "510.0", Fc: "1050.0", E: "1100000.0", Emin: "400000.0", G: "0.46" },
  { Type: "Visually Graded Lumber", Species: "Alaska Yellow Cedar", Grade: "Utility", Fb: "250.0", Ft: "125.0", Fv: "225.0", Fcp: "510.0", Fc: "675.0", E: "1100000.0", Emin: "400000.0", G: "0.46" },
  { Type: "Visually Graded Lumber", Species: "Aspen", Grade: "Select Structural", Fb: "875.0", Ft: "500.0", Fv: "120.0", Fcp: "265.0", Fc: "725.0", E: "1100000.0", Emin: "400000.0", G: "0.39" },
  { Type: "Visually Graded Lumber", Species: "Aspen", Grade: "No.1", Fb: "625.0", Ft: "375.0", Fv: "120.0", Fcp: "265.0", Fc: "600.0", E: "1100000.0", Emin: "400000.0", G: "0.39" },
  { Type: "Visually Graded Lumber", Species: "Aspen", Grade: "No.2", Fb: "600.0", Ft: "350.0", Fv: "120.0", Fcp: "265.0", Fc: "450.0", E: "1000000.0", Emin: "370000.0", G: "0.39" },
  { Type: "Visually Graded Lumber", Species: "Aspen", Grade: "No.3", Fb: "350.0", Ft: "200.0", Fv: "120.0", Fcp: "265.0", Fc: "275.0", E: "900000.0", Emin: "330000.0", G: "0.39" },
  { Type: "Visually Graded Lumber", Species: "Aspen", Grade: "Stud", Fb: "475.0", Ft: "275.0", Fv: "120.0", Fcp: "265.0", Fc: "300.0", E: "900000.0", Emin: "330000.0", G: "0.39" },
  { Type: "Visually Graded Lumber", Species: "Aspen", Grade: "Construction", Fb: "700.0", Ft: "400.0", Fv: "120.0", Fcp: "265.0", Fc: "625.0", E: "900000.0", Emin: "330000.0", G: "0.39" },
  { Type: "Visually Graded Lumber", Species: "Aspen", Grade: "Standard", Fb: "375.0", Ft: "225.0", Fv: "120.0", Fcp: "265.0", Fc: "475.0", E: "900000.0", Emin: "330000.0", G: "0.39" },
  { Type: "Visually Graded Lumber", Species: "Aspen", Grade: "Utility", Fb: "175.0", Ft: "100.0", Fv: "120.0", Fcp: "265.0", Fc: "300.0", E: "900000.0", Emin: "290000.0", G: "0.39" },
  { Type: "Visually Graded Lumber", Species: "Baldcypress", Grade: "Select Structural", Fb: "1200.0", Ft: "650.0", Fv: "160.0", Fcp: "615.0", Fc: "1200.0", E: "1400000.0", Emin: "510000.0", G: "0.46" },
  { Type: "Visually Graded Lumber", Species: "Baldcypress", Grade: "No.1", Fb: "1000.0", Ft: "550.0", Fv: "160.0", Fcp: "615.0", Fc: "1050.0", E: "1400000.0", Emin: "510000.0", G: "0.46" },
  { Type: "Visually Graded Lumber", Species: "Baldcypress", Grade: "No.2", Fb: "825.0", Ft: "450.0", Fv: "160.0", Fcp: "615.0", Fc: "900.0", E: "1300000.0", Emin: "470000.0", G: "0.46" },
  { Type: "Visually Graded Lumber", Species: "Baldcypress", Grade: "No.3", Fb: "475.0", Ft: "250.0", Fv: "160.0", Fcp: "615.0", Fc: "525.0", E: "1200000.0", Emin: "440000.0", G: "0.46" },
  { Type: "Visually Graded Lumber", Species: "Baldcypress", Grade: "Stud", Fb: "650.0", Ft: "350.0", Fv: "160.0", Fcp: "615.0", Fc: "575.0", E: "1200000.0", Emin: "440000.0", G: "0.46" },
  { Type: "Visually Graded Lumber", Species: "Baldcypress", Grade: "Construction", Fb: "925.0", Ft: "500.0", Fv: "160.0", Fcp: "615.0", Fc: "1100.0", E: "1200000.0", Emin: "440000.0", G: "0.46" },
  { Type: "Visually Graded Lumber", Species: "Baldcypress", Grade: "Standard", Fb: "525.0", Ft: "275.0", Fv: "160.0", Fcp: "615.0", Fc: "925.0", E: "1100000.0", Emin: "400000.0", G: "0.46" },
  { Type: "Visually Graded Lumber", Species: "Baldcypress", Grade: "Utility", Fb: "250.0", Ft: "125.0", Fv: "160.0", Fcp: "615.0", Fc: "600.0", E: "1000000.0", Emin: "370000.0", G: "0.46" },
  { Type: "Visually Graded Lumber", Species: "Beech-Birch-Hickory", Grade: "Select Structural", Fb: "1450.0", Ft: "850.0", Fv: "195.0", Fcp: "715.0", Fc: "1200.0", E: "1700000.0", Emin: "620000.0", G: "0.71" },
  { Type: "Visually Graded Lumber", Species: "Beech-Birch-Hickory", Grade: "No.1", Fb: "1050.0", Ft: "600.0", Fv: "195.0", Fcp: "715.0", Fc: "950.0", E: "1600000.0", Emin: "580000.0", G: "0.71" },
  { Type: "Visually Graded Lumber", Species: "Beech-Birch-Hickory", Grade: "No.2", Fb: "1000.0", Ft: "600.0", Fv: "195.0", Fcp: "715.0", Fc: "750.0", E: "1500000.0", Emin: "550000.0", G: "0.71" },
  { Type: "Visually Graded Lumber", Species: "Beech-Birch-Hickory", Grade: "No.3", Fb: "575.0", Ft: "350.0", Fv: "195.0", Fcp: "715.0", Fc: "425.0", E: "1300000.0", Emin: "470000.0", G: "0.71" },
  { Type: "Visually Graded Lumber", Species: "Beech-Birch-Hickory", Grade: "Stud", Fb: "775.0", Ft: "450.0", Fv: "195.0", Fcp: "715.0", Fc: "476.0", E: "1300000.0", Emin: "470000.0", G: "0.71" },
  { Type: "Visually Graded Lumber", Species: "Beech-Birch-Hickory", Grade: "Construction", Fb: "1150.0", Ft: "675.0", Fv: "195.0", Fcp: "715.0", Fc: "1000.0", E: "1400000.0", Emin: "510000.0", G: "0.71" },
  { Type: "Visually Graded Lumber", Species: "Beech-Birch-Hickory", Grade: "Standard", Fb: "650.0", Ft: "375.0", Fv: "195.0", Fcp: "715.0", Fc: "775.0", E: "1300000.0", Emin: "470000.0", G: "0.71" },
  { Type: "Visually Graded Lumber", Species: "Beech-Birch-Hickory", Grade: "Utility", Fb: "300.0", Ft: "175.0", Fv: "195.0", Fcp: "715.0", Fc: "500.0", E: "1200000.0", Emin: "440000.0", G: "0.71" },
  { Type: "Visually Graded Lumber", Species: "Cottonwood", Grade: "Select Structural", Fb: "875.0", Ft: "525.0", Fv: "125.0", Fcp: "320.0", Fc: "775.0", E: "1200000.0", Emin: "440000.0", G: "0.41" },
  { Type: "Visually Graded Lumber", Species: "Cottonwood", Grade: "No.1", Fb: "625.0", Ft: "375.0", Fv: "125.0", Fcp: "320.0", Fc: "625.0", E: "1200000.0", Emin: "440000.0", G: "0.41" },
  { Type: "Visually Graded Lumber", Species: "Cottonwood", Grade: "No.2", Fb: "625.0", Ft: "350.0", Fv: "125.0", Fcp: "320.0", Fc: "475.0", E: "1100000.0", Emin: "400000.0", G: "0.41" },
  { Type: "Visually Graded Lumber", Species: "Cottonwood", Grade: "No.3", Fb: "350.0", Ft: "200.0", Fv: "125.0", Fcp: "320.0", Fc: "275.0", E: "1000000.0", Emin: "370000.0", G: "0.41" },
  { Type: "Visually Graded Lumber", Species: "Cottonwood", Grade: "Stud", Fb: "475.0", Ft: "275.0", Fv: "125.0", Fcp: "320.0", Fc: "300.0", E: "1000000.0", Emin: "370000.0", G: "0.41" },
  { Type: "Visually Graded Lumber", Species: "Cottonwood", Grade: "Construction", Fb: "700.0", Ft: "400.0", Fv: "125.0", Fcp: "320.0", Fc: "650.0", E: "1000000.0", Emin: "370000.0", G: "0.41" },
  { Type: "Visually Graded Lumber", Species: "Cottonwood", Grade: "Standard", Fb: "400.0", Ft: "225.0", Fv: "125.0", Fcp: "320.0", Fc: "500.0", E: "900000.0", Emin: "330000.0", G: "0.41" },
  { Type: "Visually Graded Lumber", Species: "Cottonwood", Grade: "Utility", Fb: "175.0", Ft: "100.0", Fv: "125.0", Fcp: "320.0", Fc: "325.0", E: "900000.0", Emin: "330000.0", G: "0.41" },
  { Type: "Visually Graded Lumber", Species: "Douglas Fir-Larch", Grade: "Select Structural", Fb: "1500.0", Ft: "1000.0", Fv: "180.0", Fcp: "625.0", Fc: "1700.0", E: "1900000.0", Emin: "690000.0", G: "0.5" },
  { Type: "Visually Graded Lumber", Species: "Douglas Fir-Larch", Grade: "No.1", Fb: "1000.0", Ft: "675.0", Fv: "180.0", Fcp: "625.0", Fc: "1500.0", E: "1700000.0", Emin: "620000.0", G: "0.5" },
  { Type: "Visually Graded Lumber", Species: "Douglas Fir-Larch", Grade: "No.2", Fb: "900.0", Ft: "575.0", Fv: "180.0", Fcp: "625.0", Fc: "1350.0", E: "1600000.0", Emin: "580000.0", G: "0.5" },
  { Type: "Visually Graded Lumber", Species: "Douglas Fir-Larch", Grade: "No.3", Fb: "525.0", Ft: "325.0", Fv: "180.0", Fcp: "625.0", Fc: "775.0", E: "1400000.0", Emin: "510000.0", G: "0.5" },
  { Type: "Visually Graded Lumber", Species: "Douglas Fir-Larch", Grade: "Stud", Fb: "700.0", Ft: "450.0", Fv: "180.0", Fcp: "625.0", Fc: "850.0", E: "1400000.0", Emin: "510000.0", G: "0.5" },
  { Type: "Visually Graded Lumber", Species: "Douglas Fir-Larch", Grade: "Construction", Fb: "1000.0", Ft: "650.0", Fv: "180.0", Fcp: "625.0", Fc: "1650.0", E: "1500000.0", Emin: "550000.0", G: "0.5" },
  { Type: "Visually Graded Lumber", Species: "Douglas Fir-Larch", Grade: "Standard", Fb: "575.0", Ft: "375.0", Fv: "180.0", Fcp: "625.0", Fc: "1400.0", E: "1400000.0", Emin: "510000.0", G: "0.5" },
  { Type: "Visually Graded Lumber", Species: "Douglas Fir-Larch", Grade: "Utility", Fb: "275.0", Ft: "175.0", Fv: "180.0", Fcp: "625.0", Fc: "900.0", E: "1300000.0", Emin: "470000.0", G: "0.5" },
  { Type: "Visually Graded Lumber", Species: "Douglas Fir-Larch (North)", Grade: "Select Structural", Fb: "1350.0", Ft: "825.0", Fv: "180.0", Fcp: "625.0", Fc: "1900.0", E: "1900000.0", Emin: "690000.0", G: "0.49" },
  { Type: "Visually Graded Lumber", Species: "Douglas Fir-Larch (North)", Grade: "No.1 & Btr", Fb: "1150.0", Ft: "750.0", Fv: "180.0", Fcp: "625.0", Fc: "1900.0", E: "1800000.0", Emin: "660000.0", G: "0.49" },
  { Type: "Visually Graded Lumber", Species: "Douglas Fir-Larch (North)", Grade: "No.1/No.2", Fb: "850.0", Ft: "500.0", Fv: "180.0", Fcp: "625.0", Fc: "1400.0", E: "1600000.0", Emin: "580000.0", G: "0.49" },
  { Type: "Visually Graded Lumber", Species: "Douglas Fir-Larch (North)", Grade: "No.3", Fb: "475.0", Ft: "300.0", Fv: "180.0", Fcp: "625.0", Fc: "825.0", E: "1400000.0", Emin: "510000.0", G: "0.49" },
  { Type: "Visually Graded Lumber", Species: "Douglas Fir-Larch (North)", Grade: "Stud", Fb: "650.0", Ft: "400.0", Fv: "180.0", Fcp: "625.0", Fc: "900.0", E: "1400000.0", Emin: "510000.0", G: "0.49" },
  { Type: "Visually Graded Lumber", Species: "Douglas Fir-Larch (North)", Grade: "Construction", Fb: "950.0", Ft: "575.0", Fv: "180.0", Fcp: "625.0", Fc: "1800.0", E: "1500000.0", Emin: "550000.0", G: "0.49" },
  { Type: "Visually Graded Lumber", Species: "Douglas Fir-Larch (North)", Grade: "Standard", Fb: "525.0", Ft: "325.0", Fv: "180.0", Fcp: "625.0", Fc: "1450.0", E: "1400000.0", Emin: "510000.0", G: "0.49" },
  { Type: "Visually Graded Lumber", Species: "Douglas Fir-Larch (North)", Grade: "Utility", Fb: "250.0", Ft: "150.0", Fv: "180.0", Fcp: "625.0", Fc: "950.0", E: "1300000.0", Emin: "470000.0", G: "0.49" },
  { Type: "Visually Graded Lumber", Species: "Douglas Fir-South", Grade: "Select Structural", Fb: "1350.0", Ft: "900.0", Fv: "180.0", Fcp: "520.0", Fc: "1600.0", E: "1400000.0", Emin: "510000.0", G: "0.46" },
  { Type: "Visually Graded Lumber", Species: "Douglas Fir-South", Grade: "No.1", Fb: "925.0", Ft: "600.0", Fv: "180.0", Fcp: "520.0", Fc: "1450.0", E: "1300000.0", Emin: "470000.0", G: "0.46" },
  { Type: "Visually Graded Lumber", Species: "Douglas Fir-South", Grade: "No.2", Fb: "850.0", Ft: "525.0", Fv: "180.0", Fcp: "520.0", Fc: "1350.0", E: "1200000.0", Emin: "440000.0", G: "0.46" },
  { Type: "Visually Graded Lumber", Species: "Douglas Fir-South", Grade: "No.3", Fb: "500.0", Ft: "300.0", Fv: "180.0", Fcp: "520.0", Fc: "775.0", E: "1100000.0", Emin: "400000.0", G: "0.46" },
  { Type: "Visually Graded Lumber", Species: "Douglas Fir-South", Grade: "Stud", Fb: "675.0", Ft: "425.0", Fv: "180.0", Fcp: "520.0", Fc: "850.0", E: "1100000.0", Emin: "400000.0", G: "0.46" },
  { Type: "Visually Graded Lumber", Species: "Douglas Fir-South", Grade: "Construction", Fb: "975.0", Ft: "600.0", Fv: "180.0", Fcp: "520.0", Fc: "1650.0", E: "1200000.0", Emin: "440000.0", G: "0.46" },
  { Type: "Visually Graded Lumber", Species: "Douglas Fir-South", Grade: "Standard", Fb: "550.0", Ft: "350.0", Fv: "180.0", Fcp: "520.0", Fc: "1400.0", E: "1100000.0", Emin: "400000.0", G: "0.46" },
  { Type: "Visually Graded Lumber", Species: "Douglas Fir-South", Grade: "Utility", Fb: "250.0", Ft: "150.0", Fv: "180.0", Fcp: "520.0", Fc: "900.0", E: "1000000.0", Emin: "37000.0", G: "0.46" },
  { Type: "Visually Graded Lumber", Species: "Eastern Hemlock-Balsam Fir", Grade: "Select Structural", Fb: "1250.0", Ft: "575.0", Fv: "140.0", Fcp: "335.0", Fc: "1200.0", E: "1200000.0", Emin: "440000.0", G: "0.36" },
  { Type: "Visually Graded Lumber", Species: "Eastern Hemlock-Balsam Fir", Grade: "No.1", Fb: "775.0", Ft: "350.0", Fv: "140.0", Fcp: "335.0", Fc: "1000.0", E: "1100000.0", Emin: "400000.0", G: "0.36" },
  { Type: "Visually Graded Lumber", Species: "Eastern Hemlock-Balsam Fir", Grade: "No.2", Fb: "575.0", Ft: "275.0", Fv: "140.0", Fcp: "335.0", Fc: "825.0", E: "1100000.0", Emin: "400000.0", G: "0.36" },
  { Type: "Visually Graded Lumber", Species: "Eastern Hemlock-Balsam Fir", Grade: "No.3", Fb: "350.0", Ft: "150.0", Fv: "140.0", Fcp: "335.0", Fc: "475.0", E: "900000.0", Emin: "330000.0", G: "0.36" },
  { Type: "Visually Graded Lumber", Species: "Eastern Hemlock-Balsam Fir", Grade: "Stud", Fb: "450.0", Ft: "200.0", Fv: "140.0", Fcp: "335.0", Fc: "525.0", E: "900000.0", Emin: "330000.0", G: "0.36" },
  { Type: "Visually Graded Lumber", Species: "Eastern Hemlock-Balsam Fir", Grade: "Construction", Fb: "675.0", Ft: "300.0", Fv: "140.0", Fcp: "335.0", Fc: "1050.0", E: "1000000.0", Emin: "370000.0", G: "0.36" },
  { Type: "Visually Graded Lumber", Species: "Eastern Hemlock-Balsam Fir", Grade: "Standard", Fb: "375.0", Ft: "175.0", Fv: "140.0", Fcp: "335.0", Fc: "850.0", E: "900000.0", Emin: "330000.0", G: "0.36" },
  { Type: "Visually Graded Lumber", Species: "Eastern Hemlock-Balsam Fir", Grade: "Utility", Fb: "175.0", Ft: "75.0", Fv: "140.0", Fcp: "335.0", Fc: "550.0", E: "800000.0", Emin: "290000.0", G: "0.36" },
  { Type: "Visually Graded Lumber", Species: "Eastern Hemlock-Tamarack", Grade: "Select Structural", Fb: "1250.0", Ft: "575.0", Fv: "170.0", Fcp: "555.0", Fc: "1200.0", E: "1200000.0", Emin: "440000.0", G: "0.41" },
  { Type: "Visually Graded Lumber", Species: "Eastern Hemlock-Tamarack", Grade: "No.1", Fb: "775.0", Ft: "350.0", Fv: "170.0", Fcp: "555.0", Fc: "1000.0", E: "1100000.0", Emin: "400000.0", G: "0.41" },
  { Type: "Visually Graded Lumber", Species: "Eastern Hemlock-Tamarack", Grade: "No.2", Fb: "575.0", Ft: "275.0", Fv: "170.0", Fcp: "555.0", Fc: "825.0", E: "1100000.0", Emin: "400000.0", G: "0.41" },
  { Type: "Visually Graded Lumber", Species: "Eastern Hemlock-Tamarack", Grade: "No.3", Fb: "350.0", Ft: "150.0", Fv: "170.0", Fcp: "555.0", Fc: "475.0", E: "900000.0", Emin: "330000.0", G: "0.41" },
  { Type: "Visually Graded Lumber", Species: "Eastern Hemlock-Tamarack", Grade: "Stud", Fb: "450.0", Ft: "200.0", Fv: "170.0", Fcp: "555.0", Fc: "525.0", E: "900000.0", Emin: "330000.0", G: "0.41" },
  { Type: "Visually Graded Lumber", Species: "Eastern Hemlock-Tamarack", Grade: "Construction", Fb: "675.0", Ft: "300.0", Fv: "170.0", Fcp: "555.0", Fc: "1050.0", E: "1000000.0", Emin: "370000.0", G: "0.41" },
  { Type: "Visually Graded Lumber", Species: "Eastern Hemlock-Tamarack", Grade: "Standard", Fb: "375.0", Ft: "175.0", Fv: "170.0", Fcp: "555.0", Fc: "850.0", E: "900000.0", Emin: "330000.0", G: "0.41" },
  { Type: "Visually Graded Lumber", Species: "Eastern Hemlock-Tamarack", Grade: "Utility", Fb: "175.0", Ft: "75.0", Fv: "170.0", Fcp: "555.0", Fc: "550.0", E: "800000.0", Emin: "290000.0", G: "0.41" },
  { Type: "Visually Graded Lumber", Species: "Eastern Softwoods", Grade: "Select Structural", Fb: "1250.0", Ft: "575.0", Fv: "140.0", Fcp: "335.0", Fc: "1200.0", E: "1200000.0", Emin: "440000.0", G: "0.36" },
  { Type: "Visually Graded Lumber", Species: "Eastern Softwoods", Grade: "No.1", Fb: "775.0", Ft: "350.0", Fv: "140.0", Fcp: "335.0", Fc: "1000.0", E: "1100000.0", Emin: "400000.0", G: "0.36" },
  { Type: "Visually Graded Lumber", Species: "Eastern Softwoods", Grade: "No.2", Fb: "575.0", Ft: "275.0", Fv: "140.0", Fcp: "335.0", Fc: "825.0", E: "1100000.0", Emin: "400000.0", G: "0.36" },
  { Type: "Visually Graded Lumber", Species: "Eastern Softwoods", Grade: "No.3", Fb: "350.0", Ft: "150.0", Fv: "140.0", Fcp: "335.0", Fc: "475.0", E: "900000.0", Emin: "330000.0", G: "0.36" },
  { Type: "Visually Graded Lumber", Species: "Eastern Softwoods", Grade: "Stud", Fb: "450.0", Ft: "200.0", Fv: "140.0", Fcp: "335.0", Fc: "525.0", E: "900000.0", Emin: "330000.0", G: "0.36" },
  { Type: "Visually Graded Lumber", Species: "Eastern Softwoods", Grade: "Construction", Fb: "675.0", Ft: "300.0", Fv: "140.0", Fcp: "335.0", Fc: "1050.0", E: "1000000.0", Emin: "370000.0", G: "0.36" },
  { Type: "Visually Graded Lumber", Species: "Eastern Softwoods", Grade: "Standard", Fb: "375.0", Ft: "175.0", Fv: "140.0", Fcp: "335.0", Fc: "850.0", E: "900000.0", Emin: "330000.0", G: "0.36" },
  { Type: "Visually Graded Lumber", Species: "Eastern Softwoods", Grade: "Utility", Fb: "175.0", Ft: "75.0", Fv: "140.0", Fcp: "335.0", Fc: "550.0", E: "800000.0", Emin: "290000.0", G: "0.36" },
  { Type: "Visually Graded Lumber", Species: "Eastern White Pine", Grade: "Select Structural", Fb: "1250.0", Ft: "575.0", Fv: "135.0", Fcp: "350.0", Fc: "1200.0", E: "1200000.0", Emin: "440000.0", G: "0.36" },
  { Type: "Visually Graded Lumber", Species: "Eastern White Pine", Grade: "No.1", Fb: "775.0", Ft: "350.0", Fv: "135.0", Fcp: "350.0", Fc: "1000.0", E: "1100000.0", Emin: "400000.0", G: "0.36" },
  { Type: "Visually Graded Lumber", Species: "Eastern White Pine", Grade: "No.2", Fb: "575.0", Ft: "275.0", Fv: "135.0", Fcp: "350.0", Fc: "825.0", E: "1100000.0", Emin: "400000.0", G: "0.36" },
  { Type: "Visually Graded Lumber", Species: "Eastern White Pine", Grade: "No.3", Fb: "350.0", Ft: "150.0", Fv: "135.0", Fcp: "350.0", Fc: "475.0", E: "900000.0", Emin: "330000.0", G: "0.36" },
  { Type: "Visually Graded Lumber", Species: "Eastern White Pine", Grade: "Stud", Fb: "450.0", Ft: "200.0", Fv: "135.0", Fcp: "350.0", Fc: "525.0", E: "900000.0", Emin: "330000.0", G: "0.36" },
  { Type: "Visually Graded Lumber", Species: "Eastern White Pine", Grade: "Construction", Fb: "675.0", Ft: "300.0", Fv: "135.0", Fcp: "350.0", Fc: "1050.0", E: "1000000.0", Emin: "370000.0", G: "0.36" },
  { Type: "Visually Graded Lumber", Species: "Eastern White Pine", Grade: "Standard", Fb: "375.0", Ft: "175.0", Fv: "135.0", Fcp: "350.0", Fc: "850.0", E: "900000.0", Emin: "330000.0", G: "0.36" },
  { Type: "Visually Graded Lumber", Species: "Eastern White Pine", Grade: "Utility", Fb: "175.0", Ft: "75.0", Fv: "135.0", Fcp: "350.0", Fc: "550.0", E: "800000.0", Emin: "290000.0", G: "0.36" },
  { Type: "Visually Graded Lumber", Species: "Hem-Fir", Grade: "Select Structural", Fb: "1400.0", Ft: "925.0", Fv: "150.0", Fcp: "405.0", Fc: "1500.0", E: "1600000.0", Emin: "580000.0", G: "0.43" },
  { Type: "Visually Graded Lumber", Species: "Hem-Fir", Grade: "No.1 & Btr", Fb: "1100.0", Ft: "725.0", Fv: "150.0", Fcp: "405.0", Fc: "1350.0", E: "1500000.0", Emin: "550000.0", G: "0.43" },
  { Type: "Visually Graded Lumber", Species: "Hem-Fir", Grade: "No.1", Fb: "975.0", Ft: "625.0", Fv: "150.0", Fcp: "405.0", Fc: "1350.0", E: "1500000.0", Emin: "470000.0", G: "0.43" },
  { Type: "Visually Graded Lumber", Species: "Hem-Fir", Grade: "No.2", Fb: "850.0", Ft: "525.0", Fv: "150.0", Fcp: "405.0", Fc: "1300.0", E: "1300000.0", Emin: "470000.0", G: "0.43" },
  { Type: "Visually Graded Lumber", Species: "Hem-Fir", Grade: "No.3", Fb: "500.0", Ft: "300.0", Fv: "150.0", Fcp: "405.0", Fc: "725.0", E: "1200000.0", Emin: "440000.0", G: "0.43" },
  { Type: "Visually Graded Lumber", Species: "Hem-Fir", Grade: "Stud", Fb: "675.0", Ft: "400.0", Fv: "150.0", Fcp: "405.0", Fc: "800.0", E: "1200000.0", Emin: "440000.0", G: "0.43" },
  { Type: "Visually Graded Lumber", Species: "Hem-Fir", Grade: "Construction", Fb: "975.0", Ft: "600.0", Fv: "150.0", Fcp: "405.0", Fc: "1550.0", E: "1300000.0", Emin: "470000.0", G: "0.43" },
  { Type: "Visually Graded Lumber", Species: "Hem-Fir", Grade: "Standard", Fb: "550.0", Ft: "325.0", Fv: "150.0", Fcp: "405.0", Fc: "1300.0", E: "1200000.0", Emin: "440000.0", G: "0.43" },
  { Type: "Visually Graded Lumber", Species: "Hem-Fir", Grade: "Utility", Fb: "250.0", Ft: "150.0", Fv: "150.0", Fcp: "405.0", Fc: "850.0", E: "1100000.0", Emin: "400000.0", G: "0.43" },
  { Type: "Visually Graded Lumber", Species: "Hem-Fir (North)", Grade: "Select Structural", Fb: "1300.0", Ft: "775.0", Fv: "145.0", Fcp: "405.0", Fc: "1700.0", E: "1700000.0", Emin: "620000.0", G: "0.46" },
  { Type: "Visually Graded Lumber", Species: "Hem-Fir (North)", Grade: "No.1 & Btr", Fb: "1200.0", Ft: "725.0", Fv: "145.0", Fcp: "405.0", Fc: "1550.0", E: "1700000.0", Emin: "620000.0", G: "0.46" },
  { Type: "Visually Graded Lumber", Species: "Hem-Fir (North)", Grade: "No.1/No.2", Fb: "1000.0", Ft: "575.0", Fv: "145.0", Fcp: "405.0", Fc: "1450.0", E: "1700000.0", Emin: "580000.0", G: "0.46" },
  { Type: "Visually Graded Lumber", Species: "Hem-Fir (North)", Grade: "No.3", Fb: "575.0", Ft: "325.0", Fv: "145.0", Fcp: "405.0", Fc: "850.0", E: "1400000.0", Emin: "510000.0", G: "0.46" },
  { Type: "Visually Graded Lumber", Species: "Hem-Fir (North)", Grade: "Stud", Fb: "775.0", Ft: "450.0", Fv: "145.0", Fcp: "405.0", Fc: "925.0", E: "1400000.0", Emin: "510000.0", G: "0.46" },
  { Type: "Visually Graded Lumber", Species: "Hem-Fir (North)", Grade: "Construction", Fb: "1150.0", Ft: "650.0", Fv: "145.0", Fcp: "405.0", Fc: "1750.0", E: "1500000.0", Emin: "550000.0", G: "0.46" },
  { Type: "Visually Graded Lumber", Species: "Hem-Fir (North)", Grade: "Standard", Fb: "650.0", Ft: "350.0", Fv: "145.0", Fcp: "405.0", Fc: "1500.0", E: "1400000.0", Emin: "510000.0", G: "0.46" },
  { Type: "Visually Graded Lumber", Species: "Hem-Fir (North)", Grade: "Utility", Fb: "300.0", Ft: "175.0", Fv: "145.0", Fcp: "405.0", Fc: "975.0", E: "1300000.0", Emin: "470000.0", G: "0.46" },
  { Type: "Visually Graded Lumber", Species: "Mixed Maple", Grade: "Select Structural", Fb: "1000.0", Ft: "600.0", Fv: "195.0", Fcp: "620.0", Fc: "875.0", E: "1300000.0", Emin: "470000.0", G: "0.55" },
  { Type: "Visually Graded Lumber", Species: "Mixed Maple", Grade: "No.1", Fb: "725.0", Ft: "425.0", Fv: "195.0", Fcp: "620.0", Fc: "700.0", E: "1200000.0", Emin: "440000.0", G: "0.55" },
  { Type: "Visually Graded Lumber", Species: "Mixed Maple", Grade: "No.2", Fb: "700.0", Ft: "425.0", Fv: "195.0", Fcp: "620.0", Fc: "550.0", E: "1100000.0", Emin: "400000.0", G: "0.55" },
  { Type: "Visually Graded Lumber", Species: "Mixed Maple", Grade: "No.3", Fb: "400.0", Ft: "250.0", Fv: "195.0", Fcp: "620.0", Fc: "325.0", E: "1000000.0", Emin: "370000.0", G: "0.55" },
  { Type: "Visually Graded Lumber", Species: "Mixed Maple", Grade: "Stud", Fb: "550.0", Ft: "325.0", Fv: "195.0", Fcp: "620.0", Fc: "350.0", E: "1000000.0", Emin: "370000.0", G: "0.55" },
  { Type: "Visually Graded Lumber", Species: "Mixed Maple", Grade: "Construction", Fb: "800.0", Ft: "475.0", Fv: "195.0", Fcp: "620.0", Fc: "725.0", E: "1100000.0", Emin: "400000.0", G: "0.55" },
  { Type: "Visually Graded Lumber", Species: "Mixed Maple", Grade: "Standard", Fb: "450.0", Ft: "275.0", Fv: "195.0", Fcp: "620.0", Fc: "575.0", E: "1000000.0", Emin: "370000.0", G: "0.55" },
  { Type: "Visually Graded Lumber", Species: "Mixed Maple", Grade: "Utility", Fb: "225.0", Ft: "125.0", Fv: "195.0", Fcp: "620.0", Fc: "375.0", E: "900000.0", Emin: "330000.0", G: "0.55" },
  { Type: "Visually Graded Lumber", Species: "Mixed Oak", Grade: "Construction", Fb: "925.0", Ft: "550.0", Fv: "170.0", Fcp: "800.0", Fc: "850.0", E: "900000.0", Emin: "330000.0", G: "0.68" },
  { Type: "Visually Graded Lumber", Species: "Mixed Oak", Grade: "No.1", Fb: "825.0", Ft: "500.0", Fv: "170.0", Fcp: "800.0", Fc: "825.0", E: "1000000.0", Emin: "370000.0", G: "0.68" },
  { Type: "Visually Graded Lumber", Species: "Mixed Oak", Grade: "No.2", Fb: "800.0", Ft: "475.0", Fv: "170.0", Fcp: "800.0", Fc: "625.0", E: "900000.0", Emin: "330000.0", G: "0.68" },
  { Type: "Visually Graded Lumber", Species: "Mixed Oak", Grade: "No.3", Fb: "475.0", Ft: "275.0", Fv: "170.0", Fcp: "800.0", Fc: "375.0", E: "800000.0", Emin: "290000.0", G: "0.68" },
  { Type: "Visually Graded Lumber", Species: "Mixed Oak", Grade: "Select Structural", Fb: "1150.0", Ft: "675.0", Fv: "170.0", Fcp: "800.0", Fc: "1000.0", E: "1100000.0", Emin: "400000.0", G: "0.68" },
  { Type: "Visually Graded Lumber", Species: "Mixed Oak", Grade: "Standard", Fb: "525.0", Ft: "300.0", Fv: "170.0", Fcp: "800.0", Fc: "650.0", E: "800000.0", Emin: "290000.0", G: "0.68" },
  { Type: "Visually Graded Lumber", Species: "Mixed Oak", Grade: "Stud", Fb: "625.0", Ft: "375.0", Fv: "170.0", Fcp: "800.0", Fc: "400.0", E: "800000.0", Emin: "290000.0", G: "0.68" },
  { Type: "Visually Graded Lumber", Species: "Mixed Oak", Grade: "Utility", Fb: "250.0", Ft: "150.0", Fv: "170.0", Fcp: "800.0", Fc: "425.0", E: "800000.0", Emin: "290000.0", G: "0.68" },
  { Type: "Visually Graded Lumber", Species: 'Mixed Southern Pine (2"-4" wide)', Grade: "Select Structural", Fb: "2050.0", Ft: "1200.0", Fv: "175.0", Fcp: "565.0", Fc: "1800.0", E: "1600000.0", Emin: "580000.0", G: "0.51" },
  { Type: "Visually Graded Lumber", Species: 'Mixed Southern Pine (2"-4" wide)', Grade: "No.1", Fb: "1450.0", Ft: "875.0", Fv: "175.0", Fcp: "565.0", Fc: "1650.0", E: "1500000.0", Emin: "550000.0", G: "0.51" },
  { Type: "Visually Graded Lumber", Species: 'Mixed Southern Pine (2"-4" wide)', Grade: "No.2", Fb: "1300.0", Ft: "775.0", Fv: "175.0", Fcp: "565.0", Fc: "1650.0", E: "1400000.0", Emin: "510000.0", G: "0.51" },
  { Type: "Visually Graded Lumber", Species: 'Mixed Southern Pine (2"-4" wide)', Grade: "No.3 & Stud", Fb: "750.0", Ft: "450.0", Fv: "175.0", Fcp: "565.0", Fc: "950.0", E: "1200000.0", Emin: "440000.0", G: "0.51" },
  { Type: "Visually Graded Lumber", Species: 'Mixed Southern Pine (4" wide)', Grade: "Construction", Fb: "1000.0", Ft: "600.0", Fv: "175.0", Fcp: "565.0", Fc: "1700.0", E: "1300000.0", Emin: "470000.0", G: "0.51" },
  { Type: "Visually Graded Lumber", Species: 'Mixed Southern Pine (4" wide)', Grade: "Standard", Fb: "550.0", Ft: "325.0", Fv: "175.0", Fcp: "565.0", Fc: "1450.0", E: "1200000.0", Emin: "440000.0", G: "0.51" },
  { Type: "Visually Graded Lumber", Species: 'Mixed Southern Pine (4" wide)', Grade: "Utility", Fb: "275.0", Ft: "150.0", Fv: "175.0", Fcp: "565.0", Fc: "950.0", E: "1100000.0", Emin: "400000.0", G: "0.51" },
  { Type: "Visually Graded Lumber", Species: 'Mixed Southern Pine (5"-6" wide)', Grade: "Select Structural", Fb: "1850.0", Ft: "1100.0", Fv: "175.0", Fcp: "565.0", Fc: "1700.0", E: "1600000.0", Emin: "580000.0", G: "0.51" },
  { Type: "Visually Graded Lumber", Species: 'Mixed Southern Pine (5"-6" wide)', Grade: "No.1", Fb: "1300.0", Ft: "750.0", Fv: "175.0", Fcp: "565.0", Fc: "1550.0", E: "1500000.0", Emin: "550000.0", G: "0.51" },
  { Type: "Visually Graded Lumber", Species: 'Mixed Southern Pine (5"-6" wide)', Grade: "No.2", Fb: "1150.0", Ft: "675.0", Fv: "175.0", Fcp: "565.0", Fc: "1550.0", E: "1400000.0", Emin: "510000.0", G: "0.51" },
  { Type: "Visually Graded Lumber", Species: 'Mixed Southern Pine (5"-6" wide)', Grade: "No.3 & Stud", Fb: "675.0", Ft: "400.0", Fv: "175.0", Fcp: "565.0", Fc: "875.0", E: "1200000.0", Emin: "440000.0", G: "0.51" },
  { Type: "Visually Graded Lumber", Species: 'Mixed Southern Pine (8" wide)', Grade: "Select Structural", Fb: "1750.0", Ft: "1000.0", Fv: "175.0", Fcp: "565.0", Fc: "1600.0", E: "1600000.0", Emin: "580000.0", G: "0.51" },
  { Type: "Visually Graded Lumber", Species: 'Mixed Southern Pine (8" wide)', Grade: "No.1", Fb: "1200.0", Ft: "700.0", Fv: "175.0", Fcp: "565.0", Fc: "1450.0", E: "1500000.0", Emin: "550000.0", G: "0.51" },
  { Type: "Visually Graded Lumber", Species: 'Mixed Southern Pine (8" wide)', Grade: "No.2", Fb: "1050.0", Ft: "625.0", Fv: "175.0", Fcp: "565.0", Fc: "1450.0", E: "1400000.0", Emin: "510000.0", G: "0.51" },
  { Type: "Visually Graded Lumber", Species: 'Mixed Southern Pine (8" wide)', Grade: "No.3 & Stud", Fb: "625.0", Ft: "375.0", Fv: "175.0", Fcp: "565.0", Fc: "850.0", E: "1200000.0", Emin: "440000.0", G: "0.51" },
  { Type: "Visually Graded Lumber", Species: 'Mixed Southern Pine (10" wide)', Grade: "Select Structural", Fb: "1500.0", Ft: "875.0", Fv: "175.0", Fcp: "565.0", Fc: "1600.0", E: "1600000.0", Emin: "580000.0", G: "0.51" },
  { Type: "Visually Graded Lumber", Species: 'Mixed Southern Pine (10" wide)', Grade: "No.1", Fb: "1050.0", Ft: "600.0", Fv: "175.0", Fcp: "565.0", Fc: "1450.0", E: "1500000.0", Emin: "550000.0", G: "0.51" },
  { Type: "Visually Graded Lumber", Species: 'Mixed Southern Pine (10" wide)', Grade: "No.2", Fb: "925.0", Ft: "550.0", Fv: "175.0", Fcp: "565.0", Fc: "1450.0", E: "1400000.0", Emin: "510000.0", G: "0.51" },
  { Type: "Visually Graded Lumber", Species: 'Mixed Southern Pine (10" wide)', Grade: "No.3 & Stud", Fb: "525.0", Ft: "325.0", Fv: "175.0", Fcp: "565.0", Fc: "825.0", E: "1200000.0", Emin: "440000.0", G: "0.51" },
  { Type: "Visually Graded Lumber", Species: 'Mixed Southern Pine (12" wide)', Grade: "Select Structural", Fb: "1400.0", Ft: "825.0", Fv: "175.0", Fcp: "565.0", Fc: "1550.0", E: "1600000.0", Emin: "580000.0", G: "0.51" },
  { Type: "Visually Graded Lumber", Species: 'Mixed Southern Pine (12" wide)', Grade: "No.1", Fb: "975.0", Ft: "575.0", Fv: "175.0", Fcp: "565.0", Fc: "1400.0", E: "1500000.0", Emin: "550000.0", G: "0.51" },
  { Type: "Visually Graded Lumber", Species: 'Mixed Southern Pine (12" wide)', Grade: "No.2", Fb: "875.0", Ft: "525.0", Fv: "175.0", Fcp: "565.0", Fc: "1400.0", E: "1400000.0", Emin: "510000.0", G: "0.51" },
  { Type: "Visually Graded Lumber", Species: 'Mixed Southern Pine (12" wide)', Grade: "No.3 & Stud", Fb: "500.0", Ft: "300.0", Fv: "175.0", Fcp: "565.0", Fc: "800.0", E: "1200000.0", Emin: "440000.0", G: "0.51" },
  { Type: "Visually Graded Lumber", Species: "Northern Red Oak", Grade: "Select Structural", Fb: "1400.0", Ft: "800.0", Fv: "220.0", Fcp: "885.0", Fc: "1150.0", E: "1400000.0", Emin: "510000.0", G: "0.68" },
  { Type: "Visually Graded Lumber", Species: "Northern Red Oak", Grade: "No.1", Fb: "1000.0", Ft: "575.0", Fv: "220.0", Fcp: "885.0", Fc: "925.0", E: "1400000.0", Emin: "510000.0", G: "0.68" },
  { Type: "Visually Graded Lumber", Species: "Northern Red Oak", Grade: "No.2", Fb: "975.0", Ft: "575.0", Fv: "220.0", Fcp: "885.0", Fc: "725.0", E: "1300000.0", Emin: "470000.0", G: "0.68" },
  { Type: "Visually Graded Lumber", Species: "Northern Red Oak", Grade: "No.3", Fb: "550.0", Ft: "325.0", Fv: "220.0", Fcp: "885.0", Fc: "425.0", E: "1200000.0", Emin: "440000.0", G: "0.68" },
  { Type: "Visually Graded Lumber", Species: "Northern Red Oak", Grade: "Stud", Fb: "750.0", Ft: "450.0", Fv: "220.0", Fcp: "885.0", Fc: "450.0", E: "1200000.0", Emin: "440000.0", G: "0.68" },
  { Type: "Visually Graded Lumber", Species: "Northern Red Oak", Grade: "Construction", Fb: "1100.0", Ft: "650.0", Fv: "220.0", Fcp: "885.0", Fc: "975.0", E: "1200000.0", Emin: "440000.0", G: "0.68" },
  { Type: "Visually Graded Lumber", Species: "Northern Red Oak", Grade: "Standard", Fb: "625.0", Ft: "350.0", Fv: "220.0", Fcp: "885.0", Fc: "750.0", E: "1100000.0", Emin: "400000.0", G: "0.68" },
  { Type: "Visually Graded Lumber", Species: "Northern Red Oak", Grade: "Utility", Fb: "300.0", Ft: "175.0", Fv: "220.0", Fcp: "885.0", Fc: "500.0", E: "1000000.0", Emin: "370000.0", G: "0.68" },
  { Type: "Visually Graded Lumber", Species: "Northern Species", Grade: "Select Structural", Fb: "1000.0", Ft: "450.0", Fv: "110.0", Fcp: "350.0", Fc: "110.0", E: "1100000.0", Emin: "400000.0", G: "0.35" },
  { Type: "Visually Graded Lumber", Species: "Northern Species", Grade: "No.1/No.2", Fb: "1000.0", Ft: "450.0", Fv: "110.0", Fcp: "350.0", Fc: "110.0", E: "1100000.0", Emin: "400000.0", G: "0.35" },
  { Type: "Visually Graded Lumber", Species: "Northern Species", Grade: "No.3", Fb: "350.0", Ft: "150.0", Fv: "110.0", Fcp: "350.0", Fc: "500.0", E: "1000000.0", Emin: "370000.0", G: "0.35" },
  { Type: "Visually Graded Lumber", Species: "Northern Species", Grade: "Stud", Fb: "475.0", Ft: "225.0", Fv: "110.0", Fcp: "350.0", Fc: "550.0", E: "1000000.0", Emin: "370000.0", G: "0.35" },
  { Type: "Visually Graded Lumber", Species: "Northern Species", Grade: "Construction", Fb: "700.0", Ft: "300.0", Fv: "110.0", Fcp: "350.0", Fc: "1050.0", E: "1000000.0", Emin: "370000.0", G: "0.35" },
  { Type: "Visually Graded Lumber", Species: "Northern Species", Grade: "Standard", Fb: "400.0", Ft: "175.0", Fv: "110.0", Fcp: "350.0", Fc: "875.0", E: "900000.0", Emin: "330000.0", G: "0.35" },
  { Type: "Visually Graded Lumber", Species: "Northern Species", Grade: "Utility", Fb: "175.0", Ft: "75.0", Fv: "110.0", Fcp: "350.0", Fc: "575.0", E: "900000.0", Emin: "330000.0", G: "0.35" },
  { Type: "Visually Graded Lumber", Species: "Northern White Cedar", Grade: "Select Structural", Fb: "775.0", Ft: "450.0", Fv: "120.0", Fcp: "370.0", Fc: "750.0", E: "800000.0", Emin: "290000.0", G: "0.31" },
  { Type: "Visually Graded Lumber", Species: "Northern White Cedar", Grade: "No.1", Fb: "575.0", Ft: "325.0", Fv: "120.0", Fcp: "370.0", Fc: "600.0", E: "700000.0", Emin: "260000.0", G: "0.31" },
  { Type: "Visually Graded Lumber", Species: "Northern White Cedar", Grade: "No.2", Fb: "550.0", Ft: "325.0", Fv: "120.0", Fcp: "370.0", Fc: "475.0", E: "700000.0", Emin: "260000.0", G: "0.31" },
  { Type: "Visually Graded Lumber", Species: "Northern White Cedar", Grade: "No.3", Fb: "325.0", Ft: "175.0", Fv: "120.0", Fcp: "370.0", Fc: "275.0", E: "600000.0", Emin: "220000.0", G: "0.31" },
  { Type: "Visually Graded Lumber", Species: "Northern White Cedar", Grade: "Stud", Fb: "425.0", Ft: "250.0", Fv: "120.0", Fcp: "370.0", Fc: "300.0", E: "600000.0", Emin: "220000.0", G: "0.31" },
  { Type: "Visually Graded Lumber", Species: "Northern White Cedar", Grade: "Construction", Fb: "625.0", Ft: "375.0", Fv: "120.0", Fcp: "370.0", Fc: "625.0", E: "700000.0", Emin: "260000.0", G: "0.31" },
  { Type: "Visually Graded Lumber", Species: "Northern White Cedar", Grade: "Standard", Fb: "350.0", Ft: "200.0", Fv: "120.0", Fcp: "370.0", Fc: "475.0", E: "600000.0", Emin: "220000.0", G: "0.31" },
  { Type: "Visually Graded Lumber", Species: "Northern White Cedar", Grade: "Utility", Fb: "175.0", Ft: "100.0", Fv: "120.0", Fcp: "370.0", Fc: "325.0", E: "600000.0", Emin: "220000.0", G: "0.31" },
  { Type: "Visually Graded Lumber", Species: "Red Maple", Grade: "Select Structural", Fb: "1300.0", Ft: "750.0", Fv: "210.0", Fcp: "615.0", Fc: "1100.0", E: "1700000.0", Emin: "620000.0", G: "0.58" },
  { Type: "Visually Graded Lumber", Species: "Red Maple", Grade: "No.1", Fb: "925.0", Ft: "550.0", Fv: "210.0", Fcp: "615.0", Fc: "900.0", E: "1600000.0", Emin: "580000.0", G: "0.58" },
  { Type: "Visually Graded Lumber", Species: "Red Maple", Grade: "No.2", Fb: "900.0", Ft: "525.0", Fv: "210.0", Fcp: "615.0", Fc: "700.0", E: "1500000.0", Emin: "550000.0", G: "0.58" },
  { Type: "Visually Graded Lumber", Species: "Red Maple", Grade: "No.3", Fb: "525.0", Ft: "300.0", Fv: "210.0", Fcp: "615.0", Fc: "400.0", E: "1300000.0", Emin: "470000.0", G: "0.58" },
  { Type: "Visually Graded Lumber", Species: "Red Maple", Grade: "Stud", Fb: "700.0", Ft: "425.0", Fv: "210.0", Fcp: "615.0", Fc: "450.0", E: "1300000.0", Emin: "470000.0", G: "0.58" },
  { Type: "Visually Graded Lumber", Species: "Red Maple", Grade: "Construction", Fb: "1050.0", Ft: "600.0", Fv: "210.0", Fcp: "615.0", Fc: "925.0", E: "1400000.0", Emin: "510000.0", G: "0.58" },
  { Type: "Visually Graded Lumber", Species: "Red Maple", Grade: "Standard", Fb: "575.0", Ft: "325.0", Fv: "210.0", Fcp: "615.0", Fc: "725.0", E: "1300000.0", Emin: "470000.0", G: "0.58" },
  { Type: "Visually Graded Lumber", Species: "Red Maple", Grade: "Utility", Fb: "275.0", Ft: "150.0", Fv: "210.0", Fcp: "615.0", Fc: "475.0", E: "1200000.0", Emin: "440000.0", G: "0.58" },
  { Type: "Visually Graded Lumber", Species: "Red Oak", Grade: "Select Structural", Fb: "1150.0", Ft: "675.0", Fv: "170.0", Fcp: "820.0", Fc: "1000.0", E: "1400000.0", Emin: "510000.0", G: "0.67" },
  { Type: "Visually Graded Lumber", Species: "Red Oak", Grade: "No.1", Fb: "825.0", Ft: "500.0", Fv: "170.0", Fcp: "820.0", Fc: "825.0", E: "1300000.0", Emin: "470000.0", G: "0.67" },
  { Type: "Visually Graded Lumber", Species: "Red Oak", Grade: "No.2", Fb: "800.0", Ft: "475.0", Fv: "170.0", Fcp: "820.0", Fc: "625.0", E: "1200000.0", Emin: "440000.0", G: "0.67" },
  { Type: "Visually Graded Lumber", Species: "Red Oak", Grade: "No.3", Fb: "475.0", Ft: "275.0", Fv: "170.0", Fcp: "820.0", Fc: "375.0", E: "1100000.0", Emin: "400000.0", G: "0.67" },
  { Type: "Visually Graded Lumber", Species: "Red Oak", Grade: "Stud", Fb: "625.0", Ft: "375.0", Fv: "170.0", Fcp: "820.0", Fc: "400.0", E: "1100000.0", Emin: "400000.0", G: "0.67" },
  { Type: "Visually Graded Lumber", Species: "Red Oak", Grade: "Construction", Fb: "925.0", Ft: "550.0", Fv: "170.0", Fcp: "820.0", Fc: "850.0", E: "1200000.0", Emin: "440000.0", G: "0.67" },
  { Type: "Visually Graded Lumber", Species: "Red Oak", Grade: "Standard", Fb: "525.0", Ft: "300.0", Fv: "170.0", Fcp: "820.0", Fc: "650.0", E: "1100000.0", Emin: "400000.0", G: "0.67" },
  { Type: "Visually Graded Lumber", Species: "Red Oak", Grade: "Utility", Fb: "250.0", Ft: "150.0", Fv: "170.0", Fcp: "820.0", Fc: "425.0", E: "1000000.0", Emin: "370000.0", G: "0.67" },
  { Type: "Visually Graded Lumber", Species: "Redwood", Grade: "Clear Structural", Fb: "1750.0", Ft: "1000.0", Fv: "160.0", Fcp: "650.0", Fc: "1850.0", E: "1400000.0", Emin: "510000.0", G: "0.44" },
  { Type: "Visually Graded Lumber", Species: "Redwood", Grade: "Select Structural", Fb: "1350.0", Ft: "800.0", Fv: "160.0", Fcp: "650.0", Fc: "1500.0", E: "1400000.0", Emin: "510000.0", G: "0.44" },
  { Type: "Visually Graded Lumber", Species: "Redwood", Grade: "Select Structural, open grain", Fb: "1100.0", Ft: "625.0", Fv: "160.0", Fcp: "425.0", Fc: "1100.0", E: "1100000.0", Emin: "400000.0", G: "0.44" },
  { Type: "Visually Graded Lumber", Species: "Redwood", Grade: "No.1", Fb: "975.0", Ft: "575.0", Fv: "160.0", Fcp: "650.0", Fc: "1200.0", E: "1300000.0", Emin: "470000.0", G: "0.44" },
  { Type: "Visually Graded Lumber", Species: "Redwood", Grade: "No.1, open grain", Fb: "775.0", Ft: "450.0", Fv: "160.0", Fcp: "425.0", Fc: "900.0", E: "1100000.0", Emin: "400000.0", G: "0.44" },
  { Type: "Visually Graded Lumber", Species: "Redwood", Grade: "No.2", Fb: "925.0", Ft: "525.0", Fv: "160.0", Fcp: "650.0", Fc: "950.0", E: "1200000.0", Emin: "440000.0", G: "0.44" },
  { Type: "Visually Graded Lumber", Species: "Redwood", Grade: "No.2, open grain", Fb: "725.0", Ft: "425.0", Fv: "160.0", Fcp: "425.0", Fc: "700.0", E: "1000000.0", Emin: "370000.0", G: "0.44" },
  { Type: "Visually Graded Lumber", Species: "Redwood", Grade: "No.3", Fb: "525.0", Ft: "300.0", Fv: "160.0", Fcp: "650.0", Fc: "550.0", E: "1100000.0", Emin: "400000.0", G: "0.44" },
  { Type: "Visually Graded Lumber", Species: "Redwood", Grade: "No.3, open grain", Fb: "425.0", Ft: "25.0", Fv: "160.0", Fcp: "425.0", Fc: "400.0", E: "900000.0", Emin: "330000.0", G: "0.44" },
  { Type: "Visually Graded Lumber", Species: "Redwood", Grade: "Stud", Fb: "575.0", Ft: "325.0", Fv: "160.0", Fcp: "425.0", Fc: "450.0", E: "900000.0", Emin: "330000.0", G: "0.44" },
  { Type: "Visually Graded Lumber", Species: "Redwood", Grade: "Construction", Fb: "825.0", Ft: "475.0", Fv: "160.0", Fcp: "425.0", Fc: "925.0", E: "900000.0", Emin: "330000.0", G: "0.44" },
  { Type: "Visually Graded Lumber", Species: "Redwood", Grade: "Standard", Fb: "450.0", Ft: "275.0", Fv: "160.0", Fcp: "425.0", Fc: "725.0", E: "900000.0", Emin: "330000.0", G: "0.44" },
  { Type: "Visually Graded Lumber", Species: "Redwood", Grade: "Utility", Fb: "225.0", Ft: "125.0", Fv: "160.0", Fcp: "425.0", Fc: "475.0", E: "800000.0", Emin: "290000.0", G: "0.44" },
  { Type: "Visually Graded Lumber", Species: 'Southern Pine (2"-4" wide)', Grade: "Dense Select Structural", Fb: "3050.0", Ft: "1650.0", Fv: "175.0", Fcp: "660.0", Fc: "2250.0", E: "1900000.0", Emin: "690000.0", G: "0.55" },
  { Type: "Visually Graded Lumber", Species: 'Southern Pine (2"-4" wide)', Grade: "Select Structural", Fb: "2850.0", Ft: "1600.0", Fv: "175.0", Fcp: "565.0", Fc: "2100.0", E: "1800000.0", Emin: "660000.0", G: "0.55" },
  { Type: "Visually Graded Lumber", Species: 'Southern Pine (2"-4" wide)', Grade: "Non-Dense Select Structural", Fb: "2650.0", Ft: "1350.0", Fv: "175.0", Fcp: "480.0", Fc: "1950.0", E: "1700000.0", Emin: "620000.0", G: "0.55" },
  { Type: "Visually Graded Lumber", Species: 'Southern Pine (2"-4" wide)', Grade: "No.1 Dense", Fb: "2000.0", Ft: "1100.0", Fv: "175.0", Fcp: "660.0", Fc: "2000.0", E: "1800000.0", Emin: "660000.0", G: "0.55" },
  { Type: "Visually Graded Lumber", Species: 'Southern Pine (2"-4" wide)', Grade: "No.1", Fb: "1850.0", Ft: "1050.0", Fv: "175.0", Fcp: "565.0", Fc: "1850.0", E: "1700000.0", Emin: "620000.0", G: "0.55" },
  { Type: "Visually Graded Lumber", Species: 'Southern Pine (2"-4" wide)', Grade: "No.1 Non-Dense", Fb: "1700.0", Ft: "900.0", Fv: "175.0", Fcp: "480.0", Fc: "1700.0", E: "1600000.0", Emin: "580000.0", G: "0.55" },
  { Type: "Visually Graded Lumber", Species: 'Southern Pine (2"-4" wide)', Grade: "No.2 Dense", Fb: "1700.0", Ft: "875.0", Fv: "175.0", Fcp: "660.0", Fc: "1850.0", E: "1700000.0", Emin: "620000.0", G: "0.55" },
  { Type: "Visually Graded Lumber", Species: 'Southern Pine (2"-4" wide)', Grade: "No.2", Fb: "1500.0", Ft: "825.0", Fv: "175.0", Fcp: "565.0", Fc: "1650.0", E: "1600000.0", Emin: "580000.0", G: "0.55" },
  { Type: "Visually Graded Lumber", Species: 'Southern Pine (2"-4" wide)', Grade: "No.2 Non-Dense", Fb: "1350.0", Ft: "775.0", Fv: "175.0", Fcp: "480.0", Fc: "1600.0", E: "1400000.0", Emin: "510000.0", G: "0.55" },
  { Type: "Visually Graded Lumber", Species: 'Southern Pine (2"-4" wide)', Grade: "No.3 & Stud", Fb: "850.0", Ft: "475.0", Fv: "175.0", Fcp: "565.0", Fc: "975.0", E: "1400000.0", Emin: "510000.0", G: "0.55" },
  { Type: "Visually Graded Lumber", Species: 'Southern Pine (4" wide)', Grade: "Construction", Fb: "1100.0", Ft: "625.0", Fv: "175.0", Fcp: "565.0", Fc: "1800.0", E: "1500000.0", Emin: "550000.0", G: "0.55" },
  { Type: "Visually Graded Lumber", Species: 'Southern Pine (4" wide)', Grade: "Standard", Fb: "625.0", Ft: "350.0", Fv: "175.0", Fcp: "565.0", Fc: "1500.0", E: "1300000.0", Emin: "470000.0", G: "0.55" },
  { Type: "Visually Graded Lumber", Species: 'Southern Pine (4" wide)', Grade: "Utility", Fb: "300.0", Ft: "175.0", Fv: "175.0", Fcp: "565.0", Fc: "975.0", E: "1300000.0", Emin: "470000.0", G: "0.55" },
  { Type: "Visually Graded Lumber", Species: 'Southern Pine (5"-6" wide)', Grade: "Dense Select Structural", Fb: "2700.0", Ft: "1500.0", Fv: "175.0", Fcp: "660.0", Fc: "2150.0", E: "1900000.0", Emin: "690000.0", G: "0.55" },
  { Type: "Visually Graded Lumber", Species: 'Southern Pine (5"-6" wide)', Grade: "Select Structural", Fb: "2550.0", Ft: "1400.0", Fv: "175.0", Fcp: "565.0", Fc: "2000.0", E: "1800000.0", Emin: "660000.0", G: "0.55" },
  { Type: "Visually Graded Lumber", Species: 'Southern Pine (5"-6" wide)', Grade: "Non-Dense Select Structural", Fb: "2350.0", Ft: "1200.0", Fv: "175.0", Fcp: "480.0", Fc: "1850.0", E: "1700000.0", Emin: "620000.0", G: "0.55" },
  { Type: "Visually Graded Lumber", Species: 'Southern Pine (5"-6" wide)', Grade: "No.1 Dense", Fb: "1750.0", Ft: "950.0", Fv: "175.0", Fcp: "660.0", Fc: "1900.0", E: "1800000.0", Emin: "660000.0", G: "0.55" },
  { Type: "Visually Graded Lumber", Species: 'Southern Pine (5"-6" wide)', Grade: "No.1", Fb: "1650.0", Ft: "900.0", Fv: "175.0", Fcp: "565.0", Fc: "1750.0", E: "1700000.0", Emin: "620000.0", G: "0.55" },
  { Type: "Visually Graded Lumber", Species: 'Southern Pine (5"-6" wide)', Grade: "No.1 Non-Dense", Fb: "1500.0", Ft: "800.0", Fv: "175.0", Fcp: "480.0", Fc: "1600.0", E: "1600000.0", Emin: "580000.0", G: "0.55" },
  { Type: "Visually Graded Lumber", Species: 'Southern Pine (5"-6" wide)', Grade: "No.2 Dense", Fb: "1450.0", Ft: "775.0", Fv: "175.0", Fcp: "660.0", Fc: "1750.0", E: "1700000.0", Emin: "620000.0", G: "0.55" },
  { Type: "Visually Graded Lumber", Species: 'Southern Pine (5"-6" wide)', Grade: "No.2", Fb: "1250.0", Ft: "725.0", Fv: "175.0", Fcp: "565.0", Fc: "1600.0", E: "1600000.0", Emin: "580000.0", G: "0.55" },
  { Type: "Visually Graded Lumber", Species: 'Southern Pine (5"-6" wide)', Grade: "No.2 Non-Dense", Fb: "1150.0", Ft: "675.0", Fv: "175.0", Fcp: "480.0", Fc: "1500.0", E: "1400000.0", Emin: "510000.0", G: "0.55" },
  { Type: "Visually Graded Lumber", Species: 'Southern Pine (5"-6" wide)', Grade: "No.3 & Stud", Fb: "750.0", Ft: "425.0", Fv: "175.0", Fcp: "565.0", Fc: "925.0", E: "1400000.0", Emin: "510000.0", G: "0.55" },
  { Type: "Visually Graded Lumber", Species: 'Southern Pine (8" wide)', Grade: "Dense Select Structural", Fb: "2450.0", Ft: "1350.0", Fv: "175.0", Fcp: "660.0", Fc: "2050.0", E: "1900000.0", Emin: "690000.0", G: "0.55" },
  { Type: "Visually Graded Lumber", Species: 'Southern Pine (8" wide)', Grade: "Select Structural", Fb: "2300.0", Ft: "1300.0", Fv: "175.0", Fcp: "565.0", Fc: "1900.0", E: "1800000.0", Emin: "660000.0", G: "0.55" },
  { Type: "Visually Graded Lumber", Species: 'Southern Pine (8" wide)', Grade: "Non-Dense Select Structural", Fb: "2100.0", Ft: "1100.0", Fv: "175.0", Fcp: "480.0", Fc: "1750.0", E: "1700000.0", Emin: "620000.0", G: "0.55" },
  { Type: "Visually Graded Lumber", Species: 'Southern Pine (8" wide)', Grade: "No.1 Dense", Fb: "1650.0", Ft: "875.0", Fv: "175.0", Fcp: "660.0", Fc: "1800.0", E: "1800000.0", Emin: "660000.0", G: "0.55" },
  { Type: "Visually Graded Lumber", Species: 'Southern Pine (8" wide)', Grade: "No.1", Fb: "1500.0", Ft: "825.0", Fv: "175.0", Fcp: "565.0", Fc: "1650.0", E: "1700000.0", Emin: "620000.0", G: "0.55" },
  { Type: "Visually Graded Lumber", Species: 'Southern Pine (8" wide)', Grade: "No.1 Non-Dense", Fb: "1350.0", Ft: "725.0", Fv: "175.0", Fcp: "480.0", Fc: "1550.0", E: "1600000.0", Emin: "580000.0", G: "0.55" },
  { Type: "Visually Graded Lumber", Species: 'Southern Pine (8" wide)', Grade: "No.2 Dense", Fb: "1400.0", Ft: "675.0", Fv: "175.0", Fcp: "660.0", Fc: "1700.0", E: "1700000.0", Emin: "620000.0", G: "0.55" },
  { Type: "Visually Graded Lumber", Species: 'Southern Pine (8" wide)', Grade: "No.2", Fb: "1200.0", Ft: "650.0", Fv: "175.0", Fcp: "565.0", Fc: "1550.0", E: "1600000.0", Emin: "580000.0", G: "0.55" },
  { Type: "Visually Graded Lumber", Species: 'Southern Pine (8" wide)', Grade: "No.2 Non-Dense", Fb: "1100.0", Ft: "600.0", Fv: "175.0", Fcp: "480.0", Fc: "1450.0", E: "1400000.0", Emin: "510000.0", G: "0.55" },
  { Type: "Visually Graded Lumber", Species: 'Southern Pine (8" wide)', Grade: "No.3 & Stud", Fb: "700.0", Ft: "400.0", Fv: "175.0", Fcp: "565.0", Fc: "875.0", E: "1400000.0", Emin: "510000.0", G: "0.55" },
  { Type: "Visually Graded Lumber", Species: 'Southern Pine (10" wide)', Grade: "Dense Select Structural", Fb: "2150.0", Ft: "1200.0", Fv: "175.0", Fcp: "660.0", Fc: "2000.0", E: "1900000.0", Emin: "690000.0", G: "0.55" },
  { Type: "Visually Graded Lumber", Species: 'Southern Pine (10" wide)', Grade: "Select Structural", Fb: "2050.0", Ft: "1100.0", Fv: "175.0", Fcp: "565.0", Fc: "1850.0", E: "1800000.0", Emin: "660000.0", G: "0.55" },
  { Type: "Visually Graded Lumber", Species: 'Southern Pine (10" wide)', Grade: "Non-Dense Select Structural", Fb: "1850.0", Ft: "950.0", Fv: "175.0", Fcp: "480.0", Fc: "1750.0", E: "1700000.0", Emin: "620000.0", G: "0.55" },
  { Type: "Visually Graded Lumber", Species: 'Southern Pine (10" wide)', Grade: "No.1 Dense", Fb: "1450.0", Ft: "775.0", Fv: "175.0", Fcp: "660.0", Fc: "1750.0", E: "1800000.0", Emin: "660000.0", G: "0.55" },
  { Type: "Visually Graded Lumber", Species: 'Southern Pine (10" wide)', Grade: "No.1", Fb: "1300.0", Ft: "725.0", Fv: "175.0", Fcp: "565.0", Fc: "1600.0", E: "1700000.0", Emin: "620000.0", G: "0.55" },
  { Type: "Visually Graded Lumber", Species: 'Southern Pine (10" wide)', Grade: "No.1 Non-Dense", Fb: "1200.0", Ft: "650.0", Fv: "175.0", Fcp: "480.0", Fc: "1500.0", E: "1600000.0", Emin: "580000.0", G: "0.55" },
  { Type: "Visually Graded Lumber", Species: 'Southern Pine (10" wide)', Grade: "No.2 Dense", Fb: "1200.0", Ft: "625.0", Fv: "175.0", Fcp: "660.0", Fc: "1650.0", E: "1700000.0", Emin: "620000.0", G: "0.55" },
  { Type: "Visually Graded Lumber", Species: 'Southern Pine (10" wide)', Grade: "No.2", Fb: "1050.0", Ft: "575.0", Fv: "175.0", Fcp: "565.0", Fc: "1500.0", E: "1600000.0", Emin: "580000.0", G: "0.55" },
  { Type: "Visually Graded Lumber", Species: 'Southern Pine (10" wide)', Grade: "No.2 Non-Dense", Fb: "950.0", Ft: "550.0", Fv: "175.0", Fcp: "480.0", Fc: "1400.0", E: "1400000.0", Emin: "510000.0", G: "0.55" },
  { Type: "Visually Graded Lumber", Species: 'Southern Pine (10" wide)', Grade: "No.3 & Stud", Fb: "600.0", Ft: "325.0", Fv: "175.0", Fcp: "565.0", Fc: "850.0", E: "1400000.0", Emin: "510000.0", G: "0.55" },
  { Type: "Visually Graded Lumber", Species: 'Southern Pine (12" wide)', Grade: "Dense Select Structural", Fb: "2050.0", Ft: "1100.0", Fv: "175.0", Fcp: "660.0", Fc: "1950.0", E: "1900000.0", Emin: "690000.0", G: "0.55" },
  { Type: "Visually Graded Lumber", Species: 'Southern Pine (12" wide)', Grade: "Select Structural", Fb: "1900.0", Ft: "1050.0", Fv: "175.0", Fcp: "565.0", Fc: "1800.0", E: "1800000.0", Emin: "660000.0", G: "0.55" },
  { Type: "Visually Graded Lumber", Species: 'Southern Pine (12" wide)', Grade: "Non-Dense Select Structural", Fb: "1750.0", Ft: "900.0", Fv: "175.0", Fcp: "480.0", Fc: "1700.0", E: "1700000.0", Emin: "620000.0", G: "0.55" },
  { Type: "Visually Graded Lumber", Species: 'Southern Pine (12" wide)', Grade: "No.1 Dense", Fb: "1350.0", Ft: "725.0", Fv: "175.0", Fcp: "660.0", Fc: "1700.0", E: "1800000.0", Emin: "660000.0", G: "0.55" },
  { Type: "Visually Graded Lumber", Species: 'Southern Pine (12" wide)', Grade: "No.1", Fb: "1250.0", Ft: "675.0", Fv: "175.0", Fcp: "565.0", Fc: "1600.0", E: "1700000.0", Emin: "620000.0", G: "0.55" },
  { Type: "Visually Graded Lumber", Species: 'Southern Pine (12" wide)', Grade: "No.1 Non-Dense", Fb: "1150.0", Ft: "600.0", Fv: "175.0", Fcp: "480.0", Fc: "1500.0", E: "1600000.0", Emin: "580000.0", G: "0.55" },
  { Type: "Visually Graded Lumber", Species: 'Southern Pine (12" wide)', Grade: "No.2 Dense", Fb: "1150.0", Ft: "575.0", Fv: "175.0", Fcp: "660.0", Fc: "1600.0", E: "1700000.0", Emin: "620000.0", G: "0.55" },
  { Type: "Visually Graded Lumber", Species: 'Southern Pine (12" wide)', Grade: "No.2", Fb: "975.0", Ft: "550.0", Fv: "175.0", Fcp: "565.0", Fc: "1450.0", E: "1600000.0", Emin: "580000.0", G: "0.55" },
  { Type: "Visually Graded Lumber", Species: 'Southern Pine (12" wide)', Grade: "No.2 Non-Dense", Fb: "900.0", Ft: "525.0", Fv: "175.0", Fcp: "480.0", Fc: "1350.0", E: "1400000.0", Emin: "510000.0", G: "0.55" },
  { Type: "Visually Graded Lumber", Species: 'Southern Pine (12" wide)', Grade: "No.3 & Stud", Fb: "575.0", Ft: "325.0", Fv: "175.0", Fcp: "565.0", Fc: "825.0", E: "1400000.0", Emin: "510000.0", G: "0.55" },
  { Type: "Visually Graded Lumber", Species: "Southern Pine (Surfaced Dry)", Grade: "Dense Select Structural 86", Fb: "2600.0", Ft: "1750.0", Fv: "175.0", Fcp: "660.0", Fc: "2000.0", E: "1800000.0", Emin: "660000.0", G: "0.55" },
  { Type: "Visually Graded Lumber", Species: "Southern Pine (Surfaced Dry)", Grade: "Dense Select Structural 72", Fb: "2200.0", Ft: "1450.0", Fv: "175.0", Fcp: "660.0", Fc: "1650.0", E: "1800000.0", Emin: "660000.0", G: "0.55" },
  { Type: "Visually Graded Lumber", Species: "Southern Pine (Surfaced Dry)", Grade: "Dense Select Structural 65", Fb: "2000.0", Ft: "1300.0", Fv: "175.0", Fcp: "660.0", Fc: "1500.0", E: "1800000.0", Emin: "660000.0", G: "0.55" },
  { Type: "Visually Graded Lumber", Species: "Southern Pine (Surfaced Green)", Grade: "Dense Select Structural 86", Fb: "2100.0", Ft: "1400.0", Fv: "165.0", Fcp: "440.0", Fc: "1300.0", E: "1600000.0", Emin: "580000.0", G: "0.55" },
  { Type: "Visually Graded Lumber", Species: "Southern Pine (Surfaced Green)", Grade: "Dense Select Structural 72", Fb: "1750.0", Ft: "1200.0", Fv: "165.0", Fcp: "440.0", Fc: "1100.0", E: "1600000.0", Emin: "580000.0", G: "0.55" },
  { Type: "Visually Graded Lumber", Species: "Southern Pine (Surfaced Green)", Grade: "Dense Select Structural 65", Fb: "1600.0", Ft: "1050.0", Fv: "165.0", Fcp: "440.0", Fc: "1000.0", E: "1600000.0", Emin: "580000.0", G: "0.55" },
  { Type: "Visually Graded Lumber", Species: "Spruce-Pine-Fir", Grade: "Select Structural", Fb: "1250.0", Ft: "700.0", Fv: "135.0", Fcp: "425.0", Fc: "1400.0", E: "1500000.0", Emin: "550000.0", G: "0.42" },
  { Type: "Visually Graded Lumber", Species: "Spruce-Pine-Fir", Grade: "No.1/No.2", Fb: "875.0", Ft: "450.0", Fv: "135.0", Fcp: "425.0", Fc: "1150.0", E: "1400000.0", Emin: "510000.0", G: "0.42" },
  { Type: "Visually Graded Lumber", Species: "Spruce-Pine-Fir", Grade: "No.3", Fb: "500.0", Ft: "250.0", Fv: "135.0", Fcp: "425.0", Fc: "650.0", E: "1200000.0", Emin: "440000.0", G: "0.42" },
  { Type: "Visually Graded Lumber", Species: "Spruce-Pine-Fir", Grade: "Stud", Fb: "675.0", Ft: "350.0", Fv: "135.0", Fcp: "425.0", Fc: "725.0", E: "1200000.0", Emin: "440000.0", G: "0.42" },
  { Type: "Visually Graded Lumber", Species: "Spruce-Pine-Fir", Grade: "Construction", Fb: "1000.0", Ft: "500.0", Fv: "135.0", Fcp: "425.0", Fc: "1400.0", E: "1300000.0", Emin: "470000.0", G: "0.42" },
  { Type: "Visually Graded Lumber", Species: "Spruce-Pine-Fir", Grade: "Standard", Fb: "550.0", Ft: "275.0", Fv: "135.0", Fcp: "425.0", Fc: "1150.0", E: "1200000.0", Emin: "440000.0", G: "0.42" },
  { Type: "Visually Graded Lumber", Species: "Spruce-Pine-Fir", Grade: "Utility", Fb: "275.0", Ft: "125.0", Fv: "135.0", Fcp: "425.0", Fc: "750.0", E: "1100000.0", Emin: "400000.0", G: "0.42" },
  { Type: "Visually Graded Lumber", Species: "Spruce-Pine-Fir (South)", Grade: "Select Structural", Fb: "1300.0", Ft: "575.0", Fv: "135.0", Fcp: "335.0", Fc: "1200.0", E: "1300000.0", Emin: "450000.0", G: "0.36" },
  { Type: "Visually Graded Lumber", Species: "Spruce-Pine-Fir (South)", Grade: "No.1", Fb: "875.0", Ft: "400.0", Fv: "135.0", Fcp: "335.0", Fc: "1050.0", E: "1200000.0", Emin: "440000.0", G: "0.36" },
  { Type: "Visually Graded Lumber", Species: "Spruce-Pine-Fir (South)", Grade: "No.2", Fb: "775.0", Ft: "350.0", Fv: "135.0", Fcp: "335.0", Fc: "1000.0", E: "1100000.0", Emin: "400000.0", G: "0.36" },
  { Type: "Visually Graded Lumber", Species: "Spruce-Pine-Fir (South)", Grade: "No.3", Fb: "450.0", Ft: "200.0", Fv: "135.0", Fcp: "335.0", Fc: "575.0", E: "1000000.0", Emin: "370000.0", G: "0.36" },
  { Type: "Visually Graded Lumber", Species: "Spruce-Pine-Fir (South)", Grade: "Stud", Fb: "600.0", Ft: "275.0", Fv: "135.0", Fcp: "335.0", Fc: "625.0", E: "1000000.0", Emin: "370000.0", G: "0.36" },
  { Type: "Visually Graded Lumber", Species: "Spruce-Pine-Fir (South)", Grade: "Construction", Fb: "875.0", Ft: "400.0", Fv: "135.0", Fcp: "335.0", Fc: "1200.0", E: "1000000.0", Emin: "370000.0", G: "0.36" },
  { Type: "Visually Graded Lumber", Species: "Spruce-Pine-Fir (South)", Grade: "Standard", Fb: "500.0", Ft: "225.0", Fv: "135.0", Fcp: "335.0", Fc: "1000.0", E: "900000.0", Emin: "330000.0", G: "0.36" },
  { Type: "Visually Graded Lumber", Species: "Spruce-Pine-Fir (South)", Grade: "Utility", Fb: "225.0", Ft: "100.0", Fv: "135.0", Fcp: "335.0", Fc: "675.0", E: "900000.0", Emin: "330000.0", G: "0.36" },
  { Type: "Visually Graded Lumber", Species: "Western Cedars", Grade: "Select Structural", Fb: "1000.0", Ft: "600.0", Fv: "155.0", Fcp: "425.0", Fc: "1000.0", E: "1100000.0", Emin: "400000.0", G: "0.36" },
  { Type: "Visually Graded Lumber", Species: "Western Cedars", Grade: "No.1", Fb: "725.0", Ft: "425.0", Fv: "155.0", Fcp: "425.0", Fc: "825.0", E: "1000000.0", Emin: "370000.0", G: "0.36" },
  { Type: "Visually Graded Lumber", Species: "Western Cedars", Grade: "No.2", Fb: "700.0", Ft: "425.0", Fv: "155.0", Fcp: "425.0", Fc: "650.0", E: "1000000.0", Emin: "370000.0", G: "0.36" },
  { Type: "Visually Graded Lumber", Species: "Western Cedars", Grade: "No.3", Fb: "400.0", Ft: "250.0", Fv: "155.0", Fcp: "425.0", Fc: "375.0", E: "900000.0", Emin: "330000.0", G: "0.36" },
  { Type: "Visually Graded Lumber", Species: "Western Cedars", Grade: "Stud", Fb: "550.0", Ft: "325.0", Fv: "155.0", Fcp: "425.0", Fc: "400.0", E: "900000.0", Emin: "330000.0", G: "0.36" },
  { Type: "Visually Graded Lumber", Species: "Western Cedars", Grade: "Construction", Fb: "800.0", Ft: "475.0", Fv: "155.0", Fcp: "425.0", Fc: "850.0", E: "900000.0", Emin: "330000.0", G: "0.36" },
  { Type: "Visually Graded Lumber", Species: "Western Cedars", Grade: "Standard", Fb: "450.0", Ft: "275.0", Fv: "155.0", Fcp: "425.0", Fc: "650.0", E: "800000.0", Emin: "290000.0", G: "0.36" },
  { Type: "Visually Graded Lumber", Species: "Western Cedars", Grade: "Utility", Fb: "225.0", Ft: "125.0", Fv: "155.0", Fcp: "425.0", Fc: "425.0", E: "800000.0", Emin: "290000.0", G: "0.36" },
  { Type: "Visually Graded Lumber", Species: "Western Woods", Grade: "Select Structural", Fb: "900.0", Ft: "400.0", Fv: "135.0", Fcp: "335.0", Fc: "1050.0", E: "1200000.0", Emin: "440000.0", G: "0.36" },
  { Type: "Visually Graded Lumber", Species: "Western Woods", Grade: "No.1", Fb: "675.0", Ft: "300.0", Fv: "135.0", Fcp: "335.0", Fc: "950.0", E: "1100000.0", Emin: "400000.0", G: "0.36" },
  { Type: "Visually Graded Lumber", Species: "Western Woods", Grade: "No.2", Fb: "675.0", Ft: "300.0", Fv: "135.0", Fcp: "335.0", Fc: "900.0", E: "1000000.0", Emin: "370000.0", G: "0.36" },
  { Type: "Visually Graded Lumber", Species: "Western Woods", Grade: "No.3", Fb: "375.0", Ft: "175.0", Fv: "135.0", Fcp: "335.0", Fc: "525.0", E: "900000.0", Emin: "330000.0", G: "0.36" },
  { Type: "Visually Graded Lumber", Species: "Western Woods", Grade: "Stud", Fb: "525.0", Ft: "225.0", Fv: "135.0", Fcp: "335.0", Fc: "575.0", E: "900000.0", Emin: "330000.0", G: "0.36" },
  { Type: "Visually Graded Lumber", Species: "Western Woods", Grade: "Construction", Fb: "775.0", Ft: "350.0", Fv: "135.0", Fcp: "335.0", Fc: "1100.0", E: "1000000.0", Emin: "370000.0", G: "0.36" },
  { Type: "Visually Graded Lumber", Species: "Western Woods", Grade: "Standard", Fb: "425.0", Ft: "200.0", Fv: "135.0", Fcp: "335.0", Fc: "925.0", E: "900000.0", Emin: "330000.0", G: "0.36" },
  { Type: "Visually Graded Lumber", Species: "Western Woods", Grade: "Utility", Fb: "200.0", Ft: "100.0", Fv: "135.0", Fcp: "335.0", Fc: "600.0", E: "800000.0", Emin: "290000.0", G: "0.36" },
  { Type: "Visually Graded Lumber", Species: "White Oak", Grade: "Select Structural", Fb: "1200.0", Ft: "700.0", Fv: "220.0", Fcp: "800.0", Fc: "1100.0", E: "1100000.0", Emin: "400000.0", G: "0.73" },
  { Type: "Visually Graded Lumber", Species: "White Oak", Grade: "No.1", Fb: "875.0", Ft: "500.0", Fv: "220.0", Fcp: "800.0", Fc: "900.0", E: "1000000.0", Emin: "370000.0", G: "0.73" },
  { Type: "Visually Graded Lumber", Species: "White Oak", Grade: "No.2", Fb: "850.0", Ft: "500.0", Fv: "220.0", Fcp: "800.0", Fc: "700.0", E: "900000.0", Emin: "330000.0", G: "0.73" },
  { Type: "Visually Graded Lumber", Species: "White Oak", Grade: "No.3", Fb: "475.0", Ft: "275.0", Fv: "220.0", Fcp: "800.0", Fc: "400.0", E: "800000.0", Emin: "290000.0", G: "0.73" },
  { Type: "Visually Graded Lumber", Species: "White Oak", Grade: "Stud", Fb: "650.0", Ft: "375.0", Fv: "220.0", Fcp: "800.0", Fc: "450.0", E: "800000.0", Emin: "290000.0", G: "0.73" },
  { Type: "Visually Graded Lumber", Species: "White Oak", Grade: "Construction", Fb: "950.0", Ft: "550.0", Fv: "220.0", Fcp: "800.0", Fc: "925.0", E: "900000.0", Emin: "330000.0", G: "0.73" },
  { Type: "Visually Graded Lumber", Species: "White Oak", Grade: "Standard", Fb: "525.0", Ft: "325.0", Fv: "220.0", Fcp: "800.0", Fc: "725.0", E: "800000.0", Emin: "290000.0", G: "0.73" },
  { Type: "Visually Graded Lumber", Species: "White Oak", Grade: "Utility", Fb: "250.0", Ft: "150.0", Fv: "220.0", Fcp: "800.0", Fc: "475.0", E: "800000.0", Emin: "290000.0", G: "0.73" },
  { Type: "Visually Graded Lumber", Species: "Yellow Poplar", Grade: "Select Structural", Fb: "1000.0", Ft: "575.0", Fv: "145.0", Fcp: "420.0", Fc: "900.0", E: "1500000.0", Emin: "550000.0", G: "0.43" },
  { Type: "Visually Graded Lumber", Species: "Yellow Poplar", Grade: "No.1", Fb: "725.0", Ft: "425.0", Fv: "145.0", Fcp: "420.0", Fc: "725.0", E: "1400000.0", Emin: "510000.0", G: "0.43" },
  { Type: "Visually Graded Lumber", Species: "Yellow Poplar", Grade: "No.2", Fb: "700.0", Ft: "400.0", Fv: "145.0", Fcp: "420.0", Fc: "575.0", E: "1300000.0", Emin: "470000.0", G: "0.43" },
  { Type: "Visually Graded Lumber", Species: "Yellow Poplar", Grade: "No.3", Fb: "400.0", Ft: "225.0", Fv: "145.0", Fcp: "420.0", Fc: "325.0", E: "1200000.0", Emin: "440000.0", G: "0.43" },
  { Type: "Visually Graded Lumber", Species: "Yellow Poplar", Grade: "Stud", Fb: "550.0", Ft: "325.0", Fv: "145.0", Fcp: "420.0", Fc: "350.0", E: "1200000.0", Emin: "440000.0", G: "0.43" },
  { Type: "Visually Graded Lumber", Species: "Yellow Poplar", Grade: "Construction", Fb: "800.0", Ft: "475.0", Fv: "145.0", Fcp: "420.0", Fc: "750.0", E: "1300000.0", Emin: "470000.0", G: "0.43" },
  { Type: "Visually Graded Lumber", Species: "Yellow Poplar", Grade: "Standard", Fb: "450.0", Ft: "250.0", Fv: "145.0", Fcp: "420.0", Fc: "575.0", E: "1100000.0", Emin: "400000.0", G: "0.43" },
  { Type: "Visually Graded Lumber", Species: "Yellow Poplar", Grade: "Utility", Fb: "200.0", Ft: "125.0", Fv: "145.0", Fcp: "420.0", Fc: "375.0", E: "1100000.0", Emin: "400000.0", G: "0.43" }
];
window.woodVisual2to4MaterialJson = Ba;
class o5 extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    this.innerHTML = String.raw`
        <div id="wood-material-heading" class="bg-info  modal-body-shadow"></div>
        <div class="accordion material-selector-body" id="wood-material-accordion"></div>  
    `, c5();
  }
}
customElements.define("wood-material-selector-component", o5);
function a5(t) {
  document.getElementById("wood-material-heading").innerHTML = `
    <table class='table table-borderless'>
      <thead>
        <tr>
          <th>${t.Species}</th><th>Fb</th><th>Ft</th><th>Fv</th><th>Fc</th><th>E</th>
        </tr>
      </thead>
      <tr>
        <td>${t.Grade}</td>
        <td>${t.Fb}</td>
        <td>${t.Ft}</td>
        <td>${t.Fv}</td>
        <td>${t.Fc}</td>
        <td>${t.E}</td>
      </tr>
    </table>
  `, M.getOrCreateInstance("#modal-material-selector-dialog").hide();
}
function c5() {
  var t = Ba, e = "", n = [], s = [], r = "";
  for (var i in t) {
    let c = t[i];
    e !== c.Species && (e !== "" && (s.sort(function(l, d) {
      return l.text > d.text;
    }), n.push({ species: e, grades: s })), e = c.Species, s = []), s.push(c.Grade);
  }
  for (var o in n) {
    let c = n[o];
    r += `
    <div class="accordion-item">
      <h2 class="accordion-header">
        <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#wood-species-${o}">
          ${c.species}  
        </button>
      </h2>
      <div id="wood-species-${o}" class="accordion-collapse collapse" data-bs-parent="#wood-material-accordion">
        <div id="wood-species-${o}-body" class="accordion-body"></div>
      </div>
    </div>
    `;
  }
  document.getElementById("wood-material-accordion").innerHTML = r;
  let a = 0;
  for (var o in n) {
    let l = n[o];
    r = '<div class="list-group material-list-group">';
    for (let d in l.grades)
      r += `
      <a href="#" class="list-group-item list-group-item-action text-blue" onclick="onWoodGradeSelected(${a})">
        ${l.grades[d]}  
      </a>
      `, a++;
    r += "</div>", document.getElementById(`wood-species-${o}-body`).innerHTML = r;
  }
}
function l5(t) {
  d5(), document.dispatchEvent(new CustomEvent("wood-material-selected", { detail: Ba[t] })), a5(Ba[t]);
}
window.onWoodGradeSelected = l5;
function d5() {
  [
    "steel-material-table",
    "astm-steel-material-table",
    "european-steel-material-table",
    "wood-material-accordion",
    "aluminum-material-table"
  ].forEach((e) => {
    let n = document.getElementById(e).getElementsByTagName("tr");
    for (let s = 1; s < n.length; s++)
      n[s].classList.remove("material-table-row-selected");
  });
}
const u5 = [
  { Type: "AISC Steel", Name: "A36", E: "29000", Fy: "36", Fu: "58-80", Density: "0.284" },
  { Type: "AISC Steel", Name: "A500 Gr. B", E: "29000", Fy: "46", Fu: "58", Density: "0.284" },
  { Type: "AISC Steel", Name: "A500 Gr. B (HSS Rounds)", E: "29000", Fy: "42", Fu: "58", Density: "0.284" },
  { Type: "AISC Steel", Name: "A992", E: "29000", Fy: "50", Fu: "58", Density: "0.284" },
  { Type: "AISC Steel", Name: "A572 Gr. 50 (HPs)", E: "29000", Fy: "50", Fu: "58", Density: "0.284" }
], h5 = [
  { Type: "ASTM Steel", Name: "A570 Gr. 50", E: "29000", Fy: "50", Fu: "65.3", Density: "0.282" }
], p5 = [
  { Type: "Aluminum", Name: "6061 Alloy T6", E: "10000", Fy: "40", Fu: "45", Density: "0.0975" }
], f5 = [
  // European
  // E = GPA, Fy and Fu = MPa, Density = kg/m^3
  { Type: "European Steel", Name: "S235", E: "200", Fy: "235", Fu: "360", Density: "7800" },
  { Type: "European Steel", Name: "S275", E: "200", Fy: "275", Fu: "430", Density: "7800" },
  { Type: "European Steel", Name: "S355", E: "200", Fy: "355", Fu: "490", Density: "7800" }
];
class m5 extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    this.innerHTML = String.raw`
    <div class="modal fade" id="modal-material-selector-dialog" tabindex="-1" role="dialog">
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header border-bottom-0">
            <h1 class="modal-title fs-5">Select a Material - <span id="material-selected-shape"></span></h1>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body modal-body-shadow my-2" >
            <div class="text-center d-flex justify-content-center">
              <ul class="nav nav-pills selector-nav-pills mb-3" id="material-tabs" role="tablist">
                <li class="nav-item px-1" role="presentation">
                  <button type="button" role="tab" class="nav-link selector-nav-link active show" id="steel-material-tab"
                    data-bs-target="#steel-material-tab-pane" data-bs-toggle="pill">
                    Steel
                  </button>
                </li>
                <li class="nav-item px-1" role="presentation">
                  <button type="button" role="tab" class="nav-link selector-nav-link" id="astm-steel-material-tab"
                    data-bs-target="#astm-steel-material-tab-pane" data-bs-toggle="pill">
                    ASTM Steel
                  </button>
                </li>
                <li class="nav-item px-1" role="presentation">
                  <button type="button" role="tab" class="nav-link selector-nav-link" id="european-steel-material-tab"
                    data-bs-target="#european-steel-material-tab-pane" data-bs-toggle="pill">
                    European Steel
                  </button>
                </li>
                <li class="nav-item px-1" role="presentation">
                  <button type="button" role="tab" class="nav-link selector-nav-link" id="wood-material-tab"
                    data-bs-target="#wood-material-tab-pane" data-bs-toggle="pill">
                    Wood</a>
                </li>
                <li class="nav-item px-1" role="presentation">
                  <button type="button" role="tab" class="nav-link selector-nav-link" id="aluminum-material-tab"
                    data-bs-target="#aluminum-material-tab-pane" data-bs-toggle="pill">
                    Aluminum</a>
                </li>
              </ul>
            </div>
          </div>
          <div class="tab-content">
            <div class="tab-pane fade show active" role="tabpanel" id="steel-material-tab-pane">
              <div class="m-2">
                <div class="m-2">
                  <div id="steel-material-table"></div>
                </div>
              </div>
            </div>
            <div class="tab-pane fade" role="tabpanel" id="astm-steel-material-tab-pane">
              <div class="m-2">
                <div class="m-2">
                  <div id="astm-steel-material-table"></div>
                </div>
              </div>
            </div>
            <div class="tab-pane fade" role="tabpanel" id="european-steel-material-tab-pane">
              <div class="m-2">
                <div class="m-2">
                  <div id="european-steel-material-table"></div>
                </div>
              </div>
            </div>
            <div class="tab-pane fade" role="tabpanel" id="wood-material-tab-pane">
              <div class="m-2">
                <div class="m-2">
                  <wood-material-selector-component></wood-material-selector-component>
                </div>
              </div>
            </div>
            <div class="tab-pane fade" role="tabpanel" id="aluminum-material-tab-pane">
              <div class="m-2">
                <div class="m-2">
                  <div id="aluminum-material-table"></div>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
          </div>
        </div>
      </div>
    </div>`, _5();
  }
}
customElements.define("material-modal-component", m5);
function g5() {
  [
    "steel-material-table",
    "astm-steel-material-table",
    "european-steel-material-table",
    "wood-material-accordion",
    "aluminum-material-table"
  ].forEach((e) => {
    let n = document.getElementById(e).getElementsByTagName("tr");
    for (let s = 1; s < n.length; s++)
      n[s].classList.remove("material-table-row-selected");
  });
}
function Po(t, e, n) {
  const s = t;
  let r = "<table class='table material-table table-borderless table-hover'>";
  r += "<thead><tr><th>Name</th><th>Fy (ksi)</th><th>Elastic Modulus (ksi)</th></tr></thead>";
  for (let a in s)
    r += `<tr><td><span class="text-blue">${s[a].Name}</span></td><td><span class="text-blue">${s[a].Fy}</span></td><td><span class="text-blue">${s[a].E}</span></td></tr>`;
  r += "</table>";
  const i = document.getElementById(e);
  i.innerHTML = r;
  const o = i.getElementsByTagName("tr");
  for (let a = 1; a < o.length; a++)
    o[a].onclick = function() {
      g5(), o[a].classList.add("material-table-row-selected"), document.dispatchEvent(new CustomEvent(n, { detail: s[a - 1] })), M.getOrCreateInstance("#modal-material-selector-dialog").hide();
    };
}
function _5() {
  Po(u5, "steel-material-table", "north-american-steel-material-selected"), Po(f5, "european-steel-material-table", "european-steel-material-selected"), Po(h5, "astm-steel-material-table", "astm-steel-material-selected"), Po(p5, "aluminum-material-table", "aluminum-material-selected");
}
let fe = { A: 4.44, E: 29e3, Fy: 50, Ix: 48, Sx: 11.8, Name: "Custom Shape", W: 15, Type: "Custom" }, y5 = [
  { Name: '6.5" Aluminum Joist', A: 2.7, Ix: 17, Sx: 5.23, W: 4, Type: "Custom Aluminum", Mn: 94, Vn: 6.17, E: 10200, Fy: 18 },
  { Name: '7.5" Aluminum Stringer', A: 3.54, Ix: 34.82, Sx: 8.769, W: 5.2, Type: "Custom Aluminum", Mn: 158, Vn: 14.8, E: 10200, Fy: 18 },
  { Name: "HV Main Beam", A: 4.21, Ix: 14.16, Sx: 3.64, W: 5.11, Type: "Custom Aluminum", Mn: 66, Vn: 5.93, E: 10200, Fy: 18 },
  { Name: "HV Secondary Beam", A: 1.4, Ix: 4.21, Sx: 1.77, W: 2.1, Type: "Custom Aluminum", Mn: 32, Vn: 2.04, E: 10200, Fy: 18 },
  { Name: "ICS Stringer 225", A: 5.06, Ix: 54, Sx: 12.16, W: 5.72, Type: "Custom Aluminum" }
], E5 = [
  { Name: "Continuous Single Member", A: 4, Ix: 56.5, Sx: 12.56, Iy: 27.5, Sy: 6.12, W: 20, Type: "Dayton Superior Soldier", Mn: 314, Vn: 25, E: 29e3, Fy: 25 },
  { Name: "Two Continuous Stacked", A: 8, Ix: 270, Sx: 30, Iy: 55, Sy: 12.24, W: 40, Type: "Dayton Superior Soldier", Mn: 750, Vn: 40, E: 29e3, Fy: 25 },
  { Name: "Double C5 x 6.7", A: 3.94, Ix: 14.98, Sx: 6, W: 13.4, Type: "Dayton Superior Soldier", Mn: 108, Vn: 25, E: 29e3, Fy: 25 },
  { Name: '5" Versiform Waler', A: 3.94, Ix: 14.95, Sx: 5.98, Iy: 1.86, Sy: 0.744, W: 13.4, Type: "Dayton Superior Soldier", Mn: 108, Vn: 18, E: 29e3 },
  { Name: '8" Versiform Waler', A: 6.74, Ix: 65, Sx: 16.28, Iy: 6.2, Sy: 1.55, W: 23, Type: "Dayton Superior Soldier", Mn: 293, Vn: 18, E: 29e3 }
];
class b5 extends HTMLElement {
  constructor() {
    super(), this.shapeType = "custom-shape", document.addEventListener("custom-shapes-selected", () => this.onShapeCategorySelected()), document.addEventListener("project-loaded", (e) => this.onProjectLoaded(e.detail));
  }
  onProjectLoaded(e) {
    const n = document.getElementById("use-custom-shape"), s = document.getElementById("use-custom-shape-checkbox");
    if (n && (n.checked = e.isCustom), s && s.classList.remove("d-none"), e.isCustom) {
      fe = e.shape, yl();
      const r = document.getElementById("use-custom-shape-label"), i = document.getElementById("custom-shape-table");
      r && r.classList.remove("text-muted"), i && i.classList.remove("text-muted");
      let o = document.querySelector('custom-shapes-tab a[href="#custom-shapes"]');
      o && on.getInstance(o).show();
    } else {
      const r = document.getElementById("use-custom-shape-label"), i = document.getElementById("custom-shape-table");
      r && r.classList.add("text-muted"), i && i.classList.add("text-muted");
    }
  }
  onShapeCategorySelected() {
    this.onShapeFileClick(this.shapeType);
  }
  resetButton(e) {
    document.getElementById(e).classList.add("btn-default"), document.getElementById(e).classList.remove("btn-primary");
  }
  onShapeFileClick(e) {
    switch (this.shapeType = e, e) {
      case "custom-shape":
        yl();
        break;
      case "custom-aluminum-stringer-shapes":
        v5();
        break;
      case "custom-soldier-shapes":
        S5();
        break;
    }
    this.resetButton("custom-shape"), this.resetButton("custom-aluminum-stringer-shapes"), this.resetButton("custom-soldier-shapes"), document.getElementById(e).classList.add("btn-primary");
  }
  onUseCustomShapeClick() {
    if (Je()) {
      M.getOrCreateInstance("#modal-shape-selector-dialog").hide();
      const s = document.getElementById("use-custom-shape");
      s && (s.checked = !1);
      return;
    }
    const e = document.getElementById("use-custom-shape");
    if (!e)
      return;
    if (e.checked) {
      const s = document.getElementById("use-custom-shape-label"), r = document.getElementById("custom-shape-table");
      s && s.classList.remove("text-muted"), r && r.classList.remove("text-muted"), document.dispatchEvent(new CustomEvent("custom-shape-selected", { detail: w5() }));
    } else {
      const s = document.getElementById("use-custom-shape-label"), r = document.getElementById("custom-shape-table");
      s && s.classList.add("text-muted"), r && r.classList.add("text-muted"), document.dispatchEvent(new CustomEvent("custom-shape-unselected"));
    }
  }
  connectedCallback() {
    this.innerHTML = String.raw`
    <div class="my-2">
      <button class="btn btn-default button-shadow" id='custom-shape'>User Defined</button>
      <button class="btn btn-default button-shadow" id='custom-aluminum-stringer-shapes'>Custom Aluminum</button>
      <button class="btn btn-default button-shadow" id='custom-soldier-shapes'>Custom Steel Soldier</button>
    </div>

    <div class="row my-2">
      <div id="use-custom-shape-checkbox" class='text-left'>
        <label class="checkbox-inline" id="use-custom-shape-label">
          <input type="checkbox" id="use-custom-shape">
          Use this shape
        </label>
      </div>
    </div>

    <div class="card">
      <div class="card-body shapes-selector-body">
        <!-- Table -->
        <div id="custom-shape-table"></div>
      </div> 
    </div>
    `, document.getElementById("custom-shape").onclick = () => {
      this.onShapeFileClick("custom-shape");
    }, document.getElementById("custom-aluminum-stringer-shapes").onclick = () => {
      this.onShapeFileClick("custom-aluminum-stringer-shapes");
    }, document.getElementById("custom-soldier-shapes").onclick = () => {
      this.onShapeFileClick("custom-soldier-shapes");
    }, document.getElementById("use-custom-shape").onclick = () => {
      this.onUseCustomShapeClick();
    }, yl();
  }
}
customElements.define("custom-shape-component", b5);
function v5() {
  document.getElementById("use-custom-shape-checkbox").classList.add("d-none");
  let t = y5;
  if (t.length <= 0)
    return;
  document.getElementById("ply-selector-group").classList.add("d-none");
  var e = "";
  e = "<table class='table table-hover shape-table'>", e += "<thead><tr><th>Name</th><th>Area</th><th>Weight (lb/ft)</th>", e += "<th>Ix (in<sup>4</sup>)</th><th>Sx (in<sup>3</sup>)</th></tr>", e += "</thead>";
  for (var n = 0; n < t.length; n++)
    e += "<tr>", e += "<td>" + t[n].Name + "</td>", e += "<td>" + t[n].A + "</td>", e += "<td>" + Number(t[n].W).toFixed(2) + "</td>", e += "<td>" + parseFloat(Number(t[n].Ix).toFixed(3).toString()) + "</td>", e += "<td>" + parseFloat(Number(t[n].Sx).toFixed(3).toString()) + "</td>";
  e += "</table>";
  const s = document.getElementById("custom-shape-table");
  s.innerHTML = e, document.getElementById("shape-dialog-copywrite-info").innerHTML = "";
  const r = s.getElementsByTagName("tr");
  for (let i = 1; i < r.length; i++)
    r[i].onclick = function() {
      const o = new CustomEvent("custom-aluminum-shape-selected", { detail: t[i - 1] });
      document.dispatchEvent(o), document.getElementById("use-custom-shape").checked = !1, M.getOrCreateInstance("#modal-shape-selector-dialog").hide();
    };
}
function S5() {
  document.getElementById("use-custom-shape-checkbox").classList.add("d-none");
  let t = E5;
  if (t.length <= 0)
    return;
  document.getElementById("ply-selector-group").classList.add("d-none");
  let e = "<table class='table table-hover shape-table'>";
  e += "<thead><tr><th>Name</th><th>Area</th><th>Weight (lb/ft)</th>", e += "<th>Ix (in<sup>4</sup>)</th><th>Sx (in<sup>3</sup>)</th></tr>", e += "</thead>";
  for (var n = 0; n < t.length; n++)
    e += "<tr>", e += "<td>" + t[n].Name + "</td>", e += "<td>" + t[n].A + "</td>", e += "<td>" + Number(t[n].W).toFixed(2) + "</td>", e += "<td>" + parseFloat(Number(t[n].Ix).toFixed(3).toString()) + "</td>", e += "<td>" + parseFloat(Number(t[n].Sx).toFixed(3).toString()) + "</td>";
  e += "</table>";
  const s = document.getElementById("custom-shape-table");
  s.innerHTML = e, document.getElementById("shape-dialog-copywrite-info").innerHTML = "";
  const r = s.getElementsByTagName("tr");
  for (let i = 1; i < r.length; i++)
    r[i].onclick = function() {
      const o = new CustomEvent("custom-soldier-shape-selected", { detail: t[i - 1] });
      document.dispatchEvent(o), document.getElementById("use-custom-shape").checked = !1, M.getOrCreateInstance("#modal-shape-selector-dialog").hide();
    };
}
function yl() {
  document.getElementById("use-custom-shape-checkbox").classList.remove("d-none");
  let t = "<div id='custom-shape-input-form' class='form-control'>";
  t += '<div class="mb-3">', t += '<label for="custom-shape-name">Name</label>', t += '<input type="text" class="form-control" id="custom-shape-name" value="' + fe.Name + '">', t += "</div>", t += '<div class="mb-3">', t += '<label for="custom-shape-moment-of-inertia">Moment of Inertia, Ixx (in<sup>4</sup>)</label>', t += '<input type="text" class="form-control" id="custom-shape-moment-of-inertia" value="' + fe.Ix + '">', t += "</div>", t += '<div class="mb-3">', t += '<label for="custom-shape-section-modulus">Section Modulus, Sx (in<sup>3</sup>)</label>', t += '<input type="text" class="form-control" id="custom-shape-section-modulus" aria-describedby="basic-addon3" value="' + fe.Sx + '">', t += "</div>", t += '<div class="mb-3">', t += '<label for="custom-shape-area">Area, A (in<sup>2</sup>)</label>', t += '<input type="text" class="form-control" id="custom-shape-area" aria-describedby="basic-addon3" value="' + fe.A + '">', t += "</div>", t += '<div class="mb-3">', t += '<label for="custom-shape-weight">Weight, W (lb/ft)</label>', t += '<input type="text" class="form-control" id="custom-shape-weight" aria-describedby="basic-addon3" value="' + fe.W + '">', t += "</div>", t += '<div class="mb-3">', t += '<label for="custom-shape-modulus-of-elasticity">Modulus of Elasticity, E (ksi)</label>', t += '<input type="text" class="form-control" id="custom-shape-modulus-of-elasticity" aria-describedby="basic-addon3" value="' + fe.E + '">', t += "</div>", t += '<div class="mb-3">', t += '<label for="custom-shape-yield-stress">Tensile Yield Stress, Fy (ksi)</label>', t += '<input type="text" class="form-control" id="custom-shape-yield-stress" aria-describedby="basic-addon3" value="' + fe.Fy + '">', t += "</div>", t += "</div>";
  const e = document.getElementById("custom-shape-table");
  e && (e.innerHTML = t);
  const n = document.getElementById("custom-shape-name"), s = document.getElementById("custom-shape-moment-of-inertia"), r = document.getElementById("custom-shape-section-modulus"), i = document.getElementById("custom-shape-area"), o = document.getElementById("custom-shape-weight"), a = document.getElementById("custom-shape-modulus-of-elasticity"), c = document.getElementById("custom-shape-yield-stress");
  n && (n.onchange = () => {
    ts();
  }), s && (s.onchange = () => {
    ts();
  }), r && (r.onchange = () => {
    ts();
  }), i && (i.onchange = () => {
    ts();
  }), o && (o.onchange = () => {
    ts();
  }), a && (a.onchange = () => {
    ts();
  }), c && (c.onchange = () => {
    ts();
  });
}
function Qe(t) {
  const e = document.getElementById(t);
  return e ? e.value : "";
}
function w5() {
  return fe.Name = Qe("custom-shape-name"), fe.Ix = parseFloat(Qe("custom-shape-moment-of-inertia")), fe.Sx = parseFloat(Qe("custom-shape-section-modulus")), fe.A = parseFloat(Qe("custom-shape-area")), fe.W = parseFloat(Qe("custom-shape-weight")), fe.E = parseFloat(Qe("custom-shape-modulus-of-elasticity")), fe.Fy = parseFloat(Qe("custom-shape-yield-stress")), fe.Type = "Custom", fe;
}
function ts() {
  fe.Name = Qe("custom-shape-name"), fe.Ix = parseFloat(Qe("custom-shape-moment-of-inertia")), fe.Sx = parseFloat(Qe("custom-shape-section-modulus")), fe.A = parseFloat(Qe("custom-shape-area")), fe.W = parseFloat(Qe("custom-shape-weight")), fe.E = parseFloat(Qe("custom-shape-modulus-of-elasticity")), fe.Fy = parseFloat(Qe("custom-shape-yield-stress"));
  const t = document.getElementById("use-custom-shape");
  (t ? t.checked : !1) && document.dispatchEvent(new CustomEvent("custom-shape-selected", { detail: fe }));
}
const El = {};
function $a(t) {
  return t in El ? Promise.resolve(El[t]) : fetch(`shape-data/${t}`).then((e) => e.json()).then((e) => (El[t] = e, e));
}
class T5 extends HTMLElement {
  constructor() {
    super(), this.shapeType = "he-shape", this.selectedShape = "HE 1000 x 584", this.shapeFiles = {
      "he-shape": "European/HE-2020.json",
      "ipe-shape": "European/IPE-2020.json",
      "ub-shape": "European/UB-2020.json",
      "upe-shape": "European/UPE-2020.json",
      "upn-shape": "European/UPN-2020.json",
      "pfc-shape": "European/PFC-2020.json"
    };
  }
  onShapeCategorySelected() {
    this.onShapeFileClick(this.shapeType);
  }
  resetButton(e) {
    document.getElementById(e).classList.add("btn-default"), document.getElementById(e).classList.remove("btn-primary");
  }
  onShapeFileClick(e) {
    this.shapeType = e, $a(this.shapeFiles[e]).then((n) => {
      I5(n);
    }), this.resetButton("he-shape"), this.resetButton("ipe-shape"), this.resetButton("ub-shape"), this.resetButton("upe-shape"), this.resetButton("upn-shape"), this.resetButton("pfc-shape"), document.getElementById(e).classList.add("btn-primary");
  }
  connectedCallback() {
    this.innerHTML = String.raw`
    <div class="my-2">
      <button class="btn btn-default button-shadow" id='he-shape'>HE</button>
      <button class="btn btn-default button-shadow" id='ipe-shape'>IPE</button>
      <button class="btn btn-default button-shadow" id='ub-shape'>UB</button>
      <button class="btn btn-default button-shadow" id='upe-shape'>UPE</button>
      <button class="btn btn-default button-shadow" id='upn-shape'>UPN</button>
      <button class="btn btn-default button-shadow" id='pfc-shape'>PFC</button>
    </div>

    <div class="card">
      <div class="card-body shapes-selector-body">
        <!-- Table -->
        <div id="european-steel-shape-table"></div>
      </div> 
    </div>
    `, document.getElementById("he-shape").onclick = () => this.onShapeFileClick("he-shape"), document.getElementById("ipe-shape").onclick = () => this.onShapeFileClick("ipe-shape"), document.getElementById("ub-shape").onclick = () => this.onShapeFileClick("ub-shape"), document.getElementById("upe-shape").onclick = () => this.onShapeFileClick("upe-shape"), document.getElementById("upn-shape").onclick = () => this.onShapeFileClick("upn-shape"), document.getElementById("pfc-shape").onclick = () => this.onShapeFileClick("pfc-shape"), this.onShapeFileClick("he-shape");
  }
}
customElements.define("european-steel-shape-selector-component", T5);
function I5(t) {
  if (t.length <= 0)
    return;
  let e = "<table class='table table-hover shape-table'><thead>";
  e += "<tr><th>Name</th><th>Area mm<sup>2</sup></th><th>Weight (kg/m)</th>", e += "<th>Iz (cm<sup>4</sup>)</th><th>Iy (cm<sup>4</sup>)</th></tr>", e += "</thead>";
  for (let r = 0; r < t.length; r++)
    e += "<tr>", e += "<td>" + t[r].Profile + "</td>", e += "<td>" + (parseFloat(t[r].A) * 1e3 * 1e3).toFixed(0) + "</td>", e += "<td>" + Number(t[r].W).toFixed(2) + "</td>", e += "<td>" + parseFloat(Number(t[r].Ix) * Math.pow(100, 4)).toFixed(2).toString() + "</td>", e += "<td>" + parseFloat(Number(t[r].Iy) * Math.pow(100, 4)).toFixed(2).toString() + "</td>";
  e += "</table>";
  const n = document.getElementById("european-steel-shape-table");
  n.innerHTML = e;
  const s = n.getElementsByTagName("tr");
  for (let r = 1; r < s.length; r++)
    s[r].onclick = function() {
      document.dispatchEvent(new CustomEvent("european-steel-shape-selected", { detail: t[r - 1] })), M.getOrCreateInstance("#modal-shape-selector-dialog").hide();
    };
}
class C5 extends HTMLElement {
  constructor() {
    super(), this.shapeType = "w-shape", this.selectedShape = "W8X15", this.shapeFiles = {
      "w-shape": "AISC/W-shapes.json",
      "m-shape": "AISC/M-shapes.json",
      "s-shape": "AISC/S-shapes.json",
      "hp-shape": "AISC/HP-shapes.json",
      "c-shape": "AISC/C-shapes.json",
      "mc-shape": "AISC/MC-shapes.json",
      "wt-shape": "AISC/WT-shapes.json",
      "mt-shape": "AISC/MT-shapes.json",
      "st-shape": "AISC/ST-shapes.json",
      "l-shape": "AISC/L-shapes.json",
      "hss-square-shape": "AISC/HSS-Square-shapes.json",
      "hss-rectangle-shape": "AISC/HSS-Rectangle-shapes.json",
      "hss-round-shape": "AISC/HSS-Round-shapes.json",
      "pipe-shape": "AISC/PIPE-shapes.json"
    }, document.addEventListener("north-american-steel-shapes-selected", () => this.onShapeCategorySelected());
  }
  onShapeCategorySelected() {
    this.onShapeFileClick(this.shapeType);
  }
  resetButton(e) {
    document.getElementById(e).classList.add("btn-default"), document.getElementById(e).classList.remove("btn-primary");
  }
  onShapeFileClick(e) {
    this.shapeType = e, $a(this.shapeFiles[e]).then((n) => {
      F5(n);
    }), this.resetButton("w-shape"), this.resetButton("m-shape"), this.resetButton("s-shape"), this.resetButton("hp-shape"), this.resetButton("c-shape"), this.resetButton("mc-shape"), this.resetButton("wt-shape"), this.resetButton("mt-shape"), this.resetButton("st-shape"), this.resetButton("l-shape"), this.resetButton("hss-square-shape"), this.resetButton("hss-round-shape"), this.resetButton("hss-rectangle-shape"), this.resetButton("pipe-shape"), document.getElementById(e).classList.add("btn-primary");
  }
  connectedCallback() {
    this.innerHTML = String.raw`
    <div class="my-2">
      <button class="btn btn-default button-shadow" id='w-shape'>W</button>
      <button class="btn btn-default button-shadow" id='m-shape'>M</button>
      <button class="btn btn-default button-shadow" id='s-shape'>S</button>
      <button class="btn btn-default button-shadow" id='hp-shape'>HP</button>
      <button class="btn btn-default button-shadow" id='c-shape'>C</button>
      <button class="btn btn-default button-shadow" id='mc-shape'>MC</button>
      <button class="btn btn-default button-shadow" id='wt-shape'>WT</button>
      <button class="btn btn-default button-shadow" id='mt-shape'>MT</button>
      <button class="btn btn-default button-shadow" id='st-shape'>ST</button>
      <button class="btn btn-default button-shadow" id='l-shape'>L</button>
    </div>
    <div  class="my-2">
      <button class="btn btn-default button-shadow" id='hss-square-shape'>HSS Square</button>
      <button class="btn btn-default button-shadow" id='hss-rectangle-shape'>HSS Rectangle</button>
      <button class="btn btn-default button-shadow" id='hss-round-shape'>HSS Round</button>
      <button class="btn btn-default button-shadow" id='pipe-shape'>Pipe</button>
    </div>

    <div class="card">
      <div class="card-body shapes-selector-body">
        <!-- Table -->
        <div id="north-american-steel-shape-table"></div>
      </div> 
    </div>
    `, document.getElementById("w-shape").onclick = () => this.onShapeFileClick("w-shape"), document.getElementById("m-shape").onclick = () => this.onShapeFileClick("m-shape"), document.getElementById("s-shape").onclick = () => this.onShapeFileClick("s-shape"), document.getElementById("hp-shape").onclick = () => this.onShapeFileClick("hp-shape"), document.getElementById("c-shape").onclick = () => this.onShapeFileClick("c-shape"), document.getElementById("mc-shape").onclick = () => this.onShapeFileClick("mc-shape"), document.getElementById("wt-shape").onclick = () => this.onShapeFileClick("wt-shape"), document.getElementById("mt-shape").onclick = () => this.onShapeFileClick("mt-shape"), document.getElementById("st-shape").onclick = () => this.onShapeFileClick("st-shape"), document.getElementById("l-shape").onclick = () => this.onShapeFileClick("l-shape"), document.getElementById("hss-square-shape").onclick = () => this.onShapeFileClick("hss-square-shape"), document.getElementById("hss-rectangle-shape").onclick = () => this.onShapeFileClick("hss-rectangle-shape"), document.getElementById("hss-round-shape").onclick = () => this.onShapeFileClick("hss-round-shape"), document.getElementById("pipe-shape").onclick = () => this.onShapeFileClick("pipe-shape"), this.onShapeFileClick("w-shape");
  }
}
function F5(t) {
  if (t.length <= 0)
    return;
  let e = "<table class='table table-hover shape-table'>";
  e += "<thead><tr><th>Name</th><th>Area</th><th>Weight (lbs/ft)</th>", e += "<th>Iz (in<sup>4</sup>)</th><th>Iy (in<sup>4</sup>)</th></tr>", e += "</thead>";
  for (var n = 0; n < t.length; n++)
    e += "<tr>", e += "<td>" + t[n].AISC_Manual_Label + "</td>", e += "<td>" + t[n].A + "</td>", e += "<td>" + Number(t[n].W).toFixed(2) + "</td>", e += "<td>" + parseFloat(Number(t[n].Ix).toFixed(3).toString()) + "</td>", e += "<td>" + parseFloat(Number(t[n].Iy).toFixed(3).toString()) + "</td>", e += "</tr>";
  e += "</table>";
  const s = document.getElementById("north-american-steel-shape-table");
  s.innerHTML = e;
  const r = s.getElementsByTagName("tr");
  for (let i = 1; i < r.length; i++)
    r[i].onclick = function() {
      const o = new CustomEvent("north-american-steel-shape-selected", { detail: t[i - 1] });
      document.dispatchEvent(o), M.getOrCreateInstance("#modal-shape-selector-dialog").hide();
    };
}
customElements.define("north-american-steel-shape-selector-component", C5);
var k5 = new RegExp(/^(\s{0,})(-{0,1})\d*(|\.\d*)(\s{0,1})(\"|in|inch|inches)(\s{0,})$/), iy = new RegExp(/(\"|in|inch|inches)/), A5 = new RegExp(/^(\s{0,})(-{0,1})\d*\/\d*(\s{0,1})(\"|in|inch|inches)(\s{0,})$/), N5 = new RegExp(/^(\s{0,})(-{0,1})\d*(|\.\d*)(\s{0,1})(\'|ft|feet)(\s{0,})$/), ad = new RegExp(/(\'|ft|feet)/), L5 = new RegExp(/^(\s{0,})(-{0,1})\d*(\s{0,1})(\'|ft|feet)(\s{0,})\d*((\s{0,})|(\s{0,1})(\"|in|inch|inches)(\s{0,}))$/), R5 = new RegExp(/^(\s{0,})(-{0,1})\d*(\s{0,1})(\'|ft|feet)(\s{0,})\d*(\s{0,1})\d*\/\d*(\s{0,1})(\"|in|inch|inches)(\s{0,})$/), x5 = new RegExp(/^(\s{0,})(-{0,1})\d*(\s{0,1})$/), O5 = new RegExp(/^(\s{0,})(-{0,1})\d*(|\.\d*)(\s{0,1})$/), P5 = new RegExp(/^(\s{0,})(-{0,1})\d*(|\.\d*)(\s{0,1})(m|meter|meters)(\s{0,})$/), M5 = new RegExp(/(m|meter|meters)/), D5 = new RegExp(/^(\s{0,})(-{0,1})\d*(|\.\d*)(\s{0,1})((cm)|(centimeter)|(centimeters))(\s{0,})$/), G5 = new RegExp(/(cm|centimeter|centimeters)/), B5 = new RegExp(/^(\s{0,})(-{0,1})\d*(|\.\d*)(\s{0,1})(mm|millimeter|millimeters)(\s{0,})$/), $5 = new RegExp(/(mm|millimeter|millimeters)/);
function cd(t) {
  var e = t.split(iy);
  if (e.length <= 0 || isNaN(e[0]))
    throw "Error Parsing Inches: " + t;
  return Number(e[0]);
}
function Af(t) {
  var e = t.split(iy);
  if (e.length > 0 && (e = e[0].split(/\//), e.length > 1)) {
    var n = e[0], s = cd(e[1]);
    if (!isNaN(n) && !isNaN(s))
      return Number(n) / Number(s);
  }
  throw "Error Parsing Inch Fraction: " + t;
}
function V5(t) {
  var e = t.split(ad);
  if (e.length <= 0 || isNaN(e[0]))
    throw "Error Parsing Feet: " + t;
  return Number(e[0] * 12);
}
function kr(t, e) {
  if (t = t.replace(/[\u2018\u2019]/g, "'").replace(/[\u201C\u201D]/g, '"'), t.match(x5) || t.match(O5))
    return e && (e === "inches" || e === "in") ? Number(t) : Number(t) * 12;
  if (t.match(k5))
    return cd(t);
  if (t.match(A5))
    return Af(t);
  if (t.match(N5))
    return V5(t);
  if (t.match(L5)) {
    var n = t.split(ad);
    try {
      var s = Number(n[0]), r = cd(n[2]);
      return s * 12 + r;
    } catch (c) {
      return console.log(c), 0;
    }
  }
  if (t.match(R5)) {
    const c = t.split(ad), l = Number(c[0]);
    let d = c[2].split(" ");
    d.length < 3 && d.unshift(" ");
    const u = Number(d[1]) || 0, h = Af(d[2]);
    return l * 12 + u + h;
  }
  if (t.match(P5)) {
    var n = t.split(M5), i = Number(n[0]);
    return Math.round(i * 39.370078 * 1e4) / 1e4;
  }
  if (t.match(D5)) {
    var n = t.split(G5), o = Number(n[0]);
    return o * 0.39370078;
  }
  if (t.match(B5)) {
    var n = t.split($5), a = Number(n[0]);
    return a * 0.039370078;
  }
  return NaN;
}
class U5 extends HTMLElement {
  constructor() {
    super(), this.shapeType = "lumber-shape", this.shapeFiles = {
      "lumber-shape": "Wood/Lumber-single-ply.json",
      "trus-joist-shape": "engineered-lumber/trus-joist-shapes.json",
      "other-vendors-east-joist-shape": "engineered-lumber/other-vendors-east-shapes.json",
      "other-vendors-west-joist-shape": "engineered-lumber/other-vendors-west-shapes.json",
      "boise-glulam-shape": "engineered-lumber/boise-cascade-glulam-shapes.json"
    }, document.addEventListener("wood-shapes-selected", () => this.onShapeCategorySelected()), document.addEventListener("configure-flitch-form", (e) => this.onConfigureFlitchBeamForm(e.detail)), document.addEventListener("project-loaded", (e) => this.onProjectLoaded(e.detail));
  }
  onProjectLoaded(e) {
    document.getElementById("ply-selector").selectedIndex = e.numberOfPlys - 1, this.onConfigureFlitchBeamForm(e);
  }
  onShapeCategorySelected() {
    this.onShapeFileClick(this.shapeType);
  }
  resetButton(e) {
    document.getElementById(e).classList.add("btn-default"), document.getElementById(e).classList.remove("btn-primary");
  }
  onShapeFileClick(e) {
    this.shapeType = e, e === "lumber-shape" ? $a(this.shapeFiles[e]).then((n) => {
      H5(n);
    }) : $a(this.shapeFiles[e]).then((n) => {
      j5(n);
    }), this.resetButton("lumber-shape"), this.resetButton("trus-joist-shape"), this.resetButton("other-vendors-east-joist-shape"), this.resetButton("other-vendors-west-joist-shape"), this.resetButton("boise-glulam-shape"), document.getElementById(e).classList.add("btn-primary");
  }
  onConfigureFlitchBeamForm(e) {
    let n = document.getElementById("has-steel-checkbox");
    e.shape.flitch ? (n.checked = !0, document.getElementById("steel-plate-div").classList.remove("d-none"), document.getElementById("plate-thickness").value = e.shape.flitch.plateThickness, document.getElementById("plate-height").value = e.shape.flitch.plateHeight, document.getElementById("number-plates-selector").value = e.shape.flitch.numberOfPlates) : (n.checked = !1, document.getElementById("steel-plate-div").classList.add("d-none"));
  }
  connectedCallback() {
    this.innerHTML = String.raw`
    <div id="engineered-wood-vendors">
      <button class="btn btn-default button-shadow d-none" id='lumber-shape'>Lumber</button>
      <button class="btn btn-default button-shadow" id='trus-joist-shape'>TrusJoist</button>
      <button class="btn btn-default button-shadow" id='other-vendors-east-joist-shape'>Other Vendor LVL (east)</button>
      <button class="btn btn-default button-shadow" id='other-vendors-west-joist-shape'>Other Vendor LVL (west)</button>
      <button class="btn btn-default button-shadow" id='boise-glulam-shape'>Boise Glulam</button>
    </div>

    <div class="text-left my-2">
      <div id="ply-selector-group" class="form-group">
        <label>Number of Plys</label>
        <select id="ply-selector" class="form-control">
          <option>1</option>
          <option>2</option>
          <option>3</option>
          <option>4</option>
          <option>5</option>
        </select>
      </div>
    </div>

    <div id="flitch-input-form" class="row text-left my-2 d-none">
      <div  class="bg-primary-subtle modal-body-shadow col mx-2">
        <label style="margin:10px;">
          <input id="has-steel-checkbox" type="checkbox" > 
          Add steel plates (Flitch Beam)
        </label> 
        <div id="steel-plate-div" class="d-none" style="padding:10px;">
          <table>
            <tr>
              <td style="padding:10px;">Plate Thickness, <em>t</em> (inches)</td>
              <td><input type="text" class="form-control" style="width:100px;" id="plate-thickness" value="0.375"></td>
            </tr>
            <tr>
              <td style="padding:10px;">Plate Height, <em>h</em> (inches)</td>
              <td><input type="text" class="form-control" style="width:100px;" id="plate-height" value="7.25"></td>
            </tr>
            <tr>
              <td style="padding:10px;">Number of Plates</td>
              <td>
                <select id="number-plates-selector" class="form-control">
                  <option>1</option>
                  <option>2</option>
                  <option>3</option>
                  <option>4</option>
                </select>
              </td>
            </tr>
          </table>
        </div>
      </div>
    </div>

    <div class="card">
      <div class="card-body shapes-selector-body">
        <!-- Table -->
        <div id="wood-shape-table"></div>
      </div> 
      <div id="shape-dialog-copywrite-info" class="small m-2"></div>
    </div>
    `, document.getElementById("wood-shapes-button").onclick = () => {
      document.getElementById("engineered-wood-vendors").classList.add("d-none"), this.onShapeFileClick("lumber-shape");
    }, document.getElementById("engineered-wood-shapes-button").onclick = () => {
      document.getElementById("engineered-wood-vendors").classList.remove("d-none"), this.onShapeFileClick("trus-joist-shape");
    }, document.getElementById("lumber-shape").onclick = () => this.onShapeFileClick("lumber-shape"), document.getElementById("trus-joist-shape").onclick = () => this.onShapeFileClick("trus-joist-shape"), document.getElementById("other-vendors-east-joist-shape").onclick = () => this.onShapeFileClick("other-vendors-east-joist-shape"), document.getElementById("other-vendors-west-joist-shape").onclick = () => this.onShapeFileClick("other-vendors-west-joist-shape"), document.getElementById("boise-glulam-shape").onclick = () => this.onShapeFileClick("boise-glulam-shape"), document.getElementById("has-steel-checkbox").onchange = () => W5(), document.getElementById("plate-thickness").onchange = () => sa(), document.getElementById("plate-height").onchange = () => sa(), document.getElementById("number-plates-selector").onchange = () => sa(), document.getElementById("ply-selector").onchange = () => z5(), this.onShapeFileClick("lumber-shape"), document.querySelectorAll('button[data-bs-toggle="tab"]').forEach((e) => {
      e.addEventListener("shown.bs.tab", (n) => {
        n.target.id === "engineered-wood-shapes-button" ? this.onShapeFileClick("trus-joist-shape") : n.target.id === "wood-shapes-button" && this.onShapeFileClick("lumber-shape");
      });
    });
  }
}
customElements.define("wood-shape-selector-component", U5);
function H5(t) {
  if (t.length <= 0)
    return;
  document.getElementById("flitch-input-form").classList.remove("d-none"), document.getElementById("ply-selector-group").classList.remove("d-none"), document.getElementById("shape-dialog-copywrite-info").innerHTML = "";
  let e = "<table class='table table-hover shape-table'><thead>";
  e += "<tr><th>Name</th><th>Area</th><th>Iz (in<sup>4</sup>)</th>", e += "<th>Iy (in<sup>4</sup>)</th></tr></thead>";
  for (var n = 0; n < t.length; n++)
    e += "<tr>", e += "<td>" + t[n].Name + "</td>", e += "<td>" + t[n].A + "</td>", e += "<td>" + parseFloat(Number(t[n].Ix).toFixed(3).toString()) + "</td>", e += "<td>" + parseFloat(Number(t[n].Iy).toFixed(3).toString()) + "</td>";
  e += "</table>";
  let s = document.getElementById("wood-shape-table");
  s.innerHTML = e;
  var r = s.getElementsByTagName("tr");
  for (let o = 1; o < r.length; o++) {
    var i = r[o];
    i.onclick = function() {
      let a = t[o - 1];
      document.getElementById("has-steel-checkbox").checked ? ho("plate-thickness") && nh("plate-thickness") && (a.flitch = {
        plateThickness: kr(document.getElementById("plate-thickness").value, "inches"),
        plateHeight: kr(document.getElementById("plate-height").value, "inches"),
        numberOfPlates: parseInt(document.getElementById("number-plates-selector").value)
      }) : delete a.flitch;
      const l = new CustomEvent("wood-shape-selected", { detail: a });
      document.dispatchEvent(l), M.getOrCreateInstance("#modal-shape-selector-dialog").hide();
    };
  }
}
function j5(t) {
  if (t.length <= 0)
    return;
  document.getElementById("flitch-input-form").classList.remove("d-none"), document.getElementById("ply-selector-group").classList.remove("d-none"), document.getElementById("shape-dialog-copywrite-info").innerHTML = "TrusJoist, Microllam LVL, Parallam PSL and TimberStrand LSL are registered trademarks of Weyerhaeuser Company. Glulam registered trademark of Boise Cascade Company. Other trademarks are the property of their respective owners. <br> <small>Data provided by Weyerhaeuser Company and Boise Cascade Company.</small>";
  const e = document.getElementById("ply-selector").selectedIndex + 1;
  let n = "<table class='table table-hover shape-table'><thead>";
  n += "<tr><th>Name</th><th>Grade</th><th>Width</th>", n += "<th>Height</th><th>Moment (ft-lbs)</th>", n += "<th>Shear (lbs)</th></thead>";
  for (var s = 0; s < t.length; s++)
    n += "<tr>", n += "<td>" + t[s].Type + "</td>", n += "<td>" + t[s].Grade + "</td>", n += "<td>" + t[s].Width + "</td>", n += "<td>" + t[s].Height + "</td>", n += "<td>" + parseFloat(t[s].Moment) * e + "</td>", n += "<td>" + parseFloat(t[s].Shear) * e + "</td>";
  n += "</table>";
  const r = document.getElementById("wood-shape-table");
  r.innerHTML = n;
  const i = r.getElementsByTagName("tr");
  for (let o = 1; o < i.length; o++)
    i[o].onclick = function() {
      let a = t[o - 1];
      document.getElementById("has-steel-checkbox").checked ? ho("plate-thickness") && nh("plate-thickness") && (a.flitch = {
        plateThickness: kr(document.getElementById("plate-thickness").value, "inches"),
        plateHeight: kr(document.getElementById("plate-height").value, "inches"),
        numberOfPlates: parseInt(document.getElementById("number-plates-selector").value)
      }) : delete a.flitch;
      const l = new CustomEvent("engineered-lumber-shape-selected", { detail: a });
      document.dispatchEvent(l), M.getOrCreateInstance("#modal-shape-selector-dialog").hide();
    };
}
function W5() {
  if (Je()) {
    const n = document.getElementById("has-steel-checkbox");
    n.checked = !1, M.getOrCreateInstance("#modal-shape-selector-dialog").hide();
  }
  const t = document.getElementById("has-steel-checkbox"), e = document.getElementById("steel-plate-div");
  if (t.checked ? e.classList.remove("d-none") : e.classList.add("d-none"), t.checked)
    sa();
  else {
    const n = new CustomEvent("flitch-updated");
    document.dispatchEvent(n);
  }
}
function sa() {
  if (ho("plate-thickness") && nh("plate-thickness")) {
    const t = {
      plateThickness: kr(document.getElementById("plate-thickness").value, "inches"),
      plateHeight: kr(document.getElementById("plate-height").value, "inches"),
      numberOfPlates: parseInt(document.getElementById("number-plates-selector").value)
    }, e = new CustomEvent("flitch-updated", { detail: t });
    document.dispatchEvent(e);
  }
}
function z5() {
  if (Je()) {
    M.getOrCreateInstance("#modal-shape-selector-dialog").hide();
    return;
  }
  const t = document.getElementById("ply-selector").selectedIndex + 1;
  document.dispatchEvent(new CustomEvent("plies-changed", { detail: t })), M.getOrCreateInstance("#modal-shape-selector-dialog").hide();
}
class q5 extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    this.innerHTML = String.raw`
    <div class="modal fade" id="modal-shape-selector-dialog" tabindex="-1" role="dialog">
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header border-bottom-0">
            <h1 class="modal-title fs-5">Select a Shape - <span id="current-selected-shape"></span></h1>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body modal-body-shadow">
            <!-- Top row shape (category) buttons -->
            <div class="text-center d-flex justify-content-center">
              
              <ul class="nav nav-pills selector-nav-pills mb-3" id="pills-tab" role="tablist">
                <li class="nav-item px-1" role="presentation">
                  <button type="button" role="tab" class="nav-link selector-nav-link active show" id="north-american-shapes-button"
                    data-bs-target="#north-american-steel-shapes" data-bs-toggle="tab">
                    North American Steel
                  </button>
                </li>
                <li class="nav-item px-1" role="presentation">
                  <button type="button" role="tab" class="nav-link selector-nav-link" id="wood-shapes-button" 
                    data-bs-target="#wood-shapes" data-bs-toggle="tab">
                    Dimensional Lumber
                  </button>
                </li>
                <li class="nav-item px-1" role="presentation">
                  <button type="button" role="tab" class="nav-link selector-nav-link" id="engineered-wood-shapes-button" 
                    data-bs-target="#wood-shapes" data-bs-toggle="tab">
                    Engineered Wood
                  </button>
                </li>
                <li class="nav-item px-1" role="presentation">
                  <button type="button" role="tab" class="nav-link selector-nav-link" id="european-shapes-button" 
                    data-bs-target="#european-shapes" data-bs-toggle="tab">
                    European Steel
                  </button>
                </li>
                <li class="nav-item px-1" role="presentation">
                  <button type="button" role="tab" class="nav-link selector-nav-link" id="custom-shapes-button" 
                    data-bs-target="#custom-shapes" data-bs-toggle="tab">
                    Custom
                  </button>
                </li>
              </ul>
            </div>
          </div>

          <div class="modal-body">
            <div class="tab-content">
              <!-- North American Shapes -->
              <div class="tab-pane fade active show" role="tabpanel" id="north-american-steel-shapes">
                <north-american-steel-shape-selector-component></north-american-steel-shape-selector-component>
              </div>

              <!-- Wood Shapes -->
              <div class="tab-pane fade" role="tabpanel" id="wood-shapes">
                <wood-shape-selector-component></wood-shape-selector-component>
              </div>

              <!-- European Shapes -->
              <div class="tab-pane fade" role="tabpanel" id="european-shapes">
                <european-steel-shape-selector-component></european-steel-shape-selector-component>
              </div>

              <!-- Custom Shapes -->
              <div class="tab-pane fade" role="tabpanel" id="custom-shapes">
                <custom-shape-component></custom-shape-component>
              </div>
            </div>
          </div>

          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
          </div>
        </div>
      </div>
    </div>`;
  }
}
customElements.define("shape-modal-component", q5);
const oy = Object.prototype.toString;
function sh(t) {
  switch (oy.call(t)) {
    case "[object Error]":
    case "[object Exception]":
    case "[object DOMException]":
    case "[object WebAssembly.Exception]":
      return !0;
    default:
      return ln(t, Error);
  }
}
function Yr(t, e) {
  return oy.call(t) === `[object ${e}]`;
}
function ay(t) {
  return Yr(t, "ErrorEvent");
}
function Nf(t) {
  return Yr(t, "DOMError");
}
function Y5(t) {
  return Yr(t, "DOMException");
}
function nn(t) {
  return Yr(t, "String");
}
function rh(t) {
  return typeof t == "object" && t !== null && "__sentry_template_string__" in t && "__sentry_template_values__" in t;
}
function ih(t) {
  return t === null || rh(t) || typeof t != "object" && typeof t != "function";
}
function Ar(t) {
  return Yr(t, "Object");
}
function Cc(t) {
  return typeof Event < "u" && ln(t, Event);
}
function K5(t) {
  return typeof Element < "u" && ln(t, Element);
}
function X5(t) {
  return Yr(t, "RegExp");
}
function Fc(t) {
  return !!(t && t.then && typeof t.then == "function");
}
function J5(t) {
  return Ar(t) && "nativeEvent" in t && "preventDefault" in t && "stopPropagation" in t;
}
function ln(t, e) {
  try {
    return t instanceof e;
  } catch {
    return !1;
  }
}
function cy(t) {
  return !!(typeof t == "object" && t !== null && (t.__isVue || t._isVue));
}
function pr(t, e = 0) {
  return typeof t != "string" || e === 0 || t.length <= e ? t : `${t.slice(0, e)}...`;
}
function Lf(t, e) {
  if (!Array.isArray(t))
    return "";
  const n = [];
  for (let s = 0; s < t.length; s++) {
    const r = t[s];
    try {
      cy(r) ? n.push("[VueViewModel]") : n.push(String(r));
    } catch {
      n.push("[value cannot be serialized]");
    }
  }
  return n.join(e);
}
function Q5(t, e, n = !1) {
  return nn(t) ? X5(e) ? e.test(t) : nn(e) ? n ? t === e : t.includes(e) : !1 : !1;
}
function Dn(t, e = [], n = !1) {
  return e.some((s) => Q5(t, s, n));
}
function Z5(t, e, n = 250, s, r, i, o) {
  if (!i.exception || !i.exception.values || !o || !ln(o.originalException, Error))
    return;
  const a = i.exception.values.length > 0 ? i.exception.values[i.exception.values.length - 1] : void 0;
  a && (i.exception.values = eR(
    ld(
      t,
      e,
      r,
      o.originalException,
      s,
      i.exception.values,
      a,
      0
    ),
    n
  ));
}
function ld(t, e, n, s, r, i, o, a) {
  if (i.length >= n + 1)
    return i;
  let c = [...i];
  if (ln(s[r], Error)) {
    Rf(o, a);
    const l = t(e, s[r]), d = c.length;
    xf(l, r, d, a), c = ld(
      t,
      e,
      n,
      s[r],
      r,
      [l, ...c],
      l,
      d
    );
  }
  return Array.isArray(s.errors) && s.errors.forEach((l, d) => {
    if (ln(l, Error)) {
      Rf(o, a);
      const u = t(e, l), h = c.length;
      xf(u, `errors[${d}]`, h, a), c = ld(
        t,
        e,
        n,
        l,
        r,
        [u, ...c],
        u,
        h
      );
    }
  }), c;
}
function Rf(t, e) {
  t.mechanism = t.mechanism || { type: "generic", handled: !0 }, t.mechanism = {
    ...t.mechanism,
    ...t.type === "AggregateError" && { is_exception_group: !0 },
    exception_id: e
  };
}
function xf(t, e, n, s) {
  t.mechanism = t.mechanism || { type: "generic", handled: !0 }, t.mechanism = {
    ...t.mechanism,
    type: "chained",
    source: e,
    exception_id: n,
    parent_id: s
  };
}
function eR(t, e) {
  return t.map((n) => (n.value && (n.value = pr(n.value, e)), n));
}
function ly(t) {
  if (t !== void 0)
    return t >= 400 && t < 500 ? "warning" : t >= 500 ? "error" : void 0;
}
const hs = "8.37.1", Z = globalThis;
function kc(t, e, n) {
  const s = n || Z, r = s.__SENTRY__ = s.__SENTRY__ || {}, i = r[hs] = r[hs] || {};
  return i[t] || (i[t] = e());
}
const fr = Z, tR = 80;
function dn(t, e = {}) {
  if (!t)
    return "<unknown>";
  try {
    let n = t;
    const s = 5, r = [];
    let i = 0, o = 0;
    const a = " > ", c = a.length;
    let l;
    const d = Array.isArray(e) ? e : e.keyAttrs, u = !Array.isArray(e) && e.maxStringLength || tR;
    for (; n && i++ < s && (l = nR(n, d), !(l === "html" || i > 1 && o + r.length * c + l.length >= u)); )
      r.push(l), o += l.length, n = n.parentNode;
    return r.reverse().join(a);
  } catch {
    return "<unknown>";
  }
}
function nR(t, e) {
  const n = t, s = [];
  if (!n || !n.tagName)
    return "";
  if (fr.HTMLElement && n instanceof HTMLElement && n.dataset) {
    if (n.dataset.sentryComponent)
      return n.dataset.sentryComponent;
    if (n.dataset.sentryElement)
      return n.dataset.sentryElement;
  }
  s.push(n.tagName.toLowerCase());
  const r = e && e.length ? e.filter((o) => n.getAttribute(o)).map((o) => [o, n.getAttribute(o)]) : null;
  if (r && r.length)
    r.forEach((o) => {
      s.push(`[${o[0]}="${o[1]}"]`);
    });
  else {
    n.id && s.push(`#${n.id}`);
    const o = n.className;
    if (o && nn(o)) {
      const a = o.split(/\s+/);
      for (const c of a)
        s.push(`.${c}`);
    }
  }
  const i = ["aria-label", "type", "name", "title", "alt"];
  for (const o of i) {
    const a = n.getAttribute(o);
    a && s.push(`[${o}="${a}"]`);
  }
  return s.join("");
}
function dy() {
  try {
    return fr.document.location.href;
  } catch {
    return "";
  }
}
function sR(t) {
  return fr.document && fr.document.querySelector ? fr.document.querySelector(t) : null;
}
function uy(t) {
  if (!fr.HTMLElement)
    return null;
  let e = t;
  const n = 5;
  for (let s = 0; s < n; s++) {
    if (!e)
      return null;
    if (e instanceof HTMLElement) {
      if (e.dataset.sentryComponent)
        return e.dataset.sentryComponent;
      if (e.dataset.sentryElement)
        return e.dataset.sentryElement;
    }
    e = e.parentNode;
  }
  return null;
}
const Os = typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__, rR = "Sentry Logger ", dd = [
  "debug",
  "info",
  "warn",
  "error",
  "log",
  "assert",
  "trace"
], Va = {};
function Kr(t) {
  if (!("console" in Z))
    return t();
  const e = Z.console, n = {}, s = Object.keys(Va);
  s.forEach((r) => {
    const i = Va[r];
    n[r] = e[r], e[r] = i;
  });
  try {
    return t();
  } finally {
    s.forEach((r) => {
      e[r] = n[r];
    });
  }
}
function iR() {
  let t = !1;
  const e = {
    enable: () => {
      t = !0;
    },
    disable: () => {
      t = !1;
    },
    isEnabled: () => t
  };
  return Os ? dd.forEach((n) => {
    e[n] = (...s) => {
      t && Kr(() => {
        Z.console[n](`${rR}[${n}]:`, ...s);
      });
    };
  }) : dd.forEach((n) => {
    e[n] = () => {
    };
  }), e;
}
const w = kc("logger", iR), oR = /^(?:(\w+):)\/\/(?:(\w+)(?::(\w+)?)?@)([\w.-]+)(?::(\d+))?\/(.+)/;
function aR(t) {
  return t === "http" || t === "https";
}
function po(t, e = !1) {
  const { host: n, path: s, pass: r, port: i, projectId: o, protocol: a, publicKey: c } = t;
  return `${a}://${c}${e && r ? `:${r}` : ""}@${n}${i ? `:${i}` : ""}/${s && `${s}/`}${o}`;
}
function cR(t) {
  const e = oR.exec(t);
  if (!e) {
    Kr(() => {
      console.error(`Invalid Sentry Dsn: ${t}`);
    });
    return;
  }
  const [n, s, r = "", i = "", o = "", a = ""] = e.slice(1);
  let c = "", l = a;
  const d = l.split("/");
  if (d.length > 1 && (c = d.slice(0, -1).join("/"), l = d.pop()), l) {
    const u = l.match(/^\d+/);
    u && (l = u[0]);
  }
  return hy({ host: i, pass: r, path: c, projectId: l, port: o, protocol: n, publicKey: s });
}
function hy(t) {
  return {
    protocol: t.protocol,
    publicKey: t.publicKey || "",
    pass: t.pass || "",
    host: t.host,
    port: t.port || "",
    path: t.path || "",
    projectId: t.projectId
  };
}
function lR(t) {
  if (!Os)
    return !0;
  const { port: e, projectId: n, protocol: s } = t;
  return ["protocol", "publicKey", "host", "projectId"].find((o) => t[o] ? !1 : (w.error(`Invalid Sentry Dsn: ${o} missing`), !0)) ? !1 : n.match(/^\d+$/) ? aR(s) ? e && isNaN(parseInt(e, 10)) ? (w.error(`Invalid Sentry Dsn: Invalid port ${e}`), !1) : !0 : (w.error(`Invalid Sentry Dsn: Invalid protocol ${s}`), !1) : (w.error(`Invalid Sentry Dsn: Invalid projectId ${n}`), !1);
}
function dR(t) {
  const e = typeof t == "string" ? cR(t) : hy(t);
  if (!(!e || !lR(e)))
    return e;
}
class xt extends Error {
  /** Display name of this error instance. */
  constructor(e, n = "warn") {
    super(e), this.message = e, this.name = new.target.prototype.constructor.name, Object.setPrototypeOf(this, new.target.prototype), this.logLevel = n;
  }
}
function tt(t, e, n) {
  if (!(e in t))
    return;
  const s = t[e], r = n(s);
  typeof r == "function" && py(r, s), t[e] = r;
}
function _t(t, e, n) {
  try {
    Object.defineProperty(t, e, {
      // enumerable: false, // the default, so we can save on bundle size by not explicitly setting it
      value: n,
      writable: !0,
      configurable: !0
    });
  } catch {
    Os && w.log(`Failed to add non-enumerable property "${e}" to object`, t);
  }
}
function py(t, e) {
  try {
    const n = e.prototype || {};
    t.prototype = e.prototype = n, _t(t, "__sentry_original__", e);
  } catch {
  }
}
function oh(t) {
  return t.__sentry_original__;
}
function uR(t) {
  return Object.keys(t).map((e) => `${encodeURIComponent(e)}=${encodeURIComponent(t[e])}`).join("&");
}
function fy(t) {
  if (sh(t))
    return {
      message: t.message,
      name: t.name,
      stack: t.stack,
      ...Pf(t)
    };
  if (Cc(t)) {
    const e = {
      type: t.type,
      target: Of(t.target),
      currentTarget: Of(t.currentTarget),
      ...Pf(t)
    };
    return typeof CustomEvent < "u" && ln(t, CustomEvent) && (e.detail = t.detail), e;
  } else
    return t;
}
function Of(t) {
  try {
    return K5(t) ? dn(t) : Object.prototype.toString.call(t);
  } catch {
    return "<unknown>";
  }
}
function Pf(t) {
  if (typeof t == "object" && t !== null) {
    const e = {};
    for (const n in t)
      Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
    return e;
  } else
    return {};
}
function hR(t, e = 40) {
  const n = Object.keys(fy(t));
  n.sort();
  const s = n[0];
  if (!s)
    return "[object has no keys]";
  if (s.length >= e)
    return pr(s, e);
  for (let r = n.length; r > 0; r--) {
    const i = n.slice(0, r).join(", ");
    if (!(i.length > e))
      return r === n.length ? i : pr(i, e);
  }
  return "";
}
function Ce(t) {
  return ud(t, /* @__PURE__ */ new Map());
}
function ud(t, e) {
  if (pR(t)) {
    const n = e.get(t);
    if (n !== void 0)
      return n;
    const s = {};
    e.set(t, s);
    for (const r of Object.getOwnPropertyNames(t))
      typeof t[r] < "u" && (s[r] = ud(t[r], e));
    return s;
  }
  if (Array.isArray(t)) {
    const n = e.get(t);
    if (n !== void 0)
      return n;
    const s = [];
    return e.set(t, s), t.forEach((r) => {
      s.push(ud(r, e));
    }), s;
  }
  return t;
}
function pR(t) {
  if (!Ar(t))
    return !1;
  try {
    const e = Object.getPrototypeOf(t).constructor.name;
    return !e || e === "Object";
  } catch {
    return !0;
  }
}
const my = 50, Is = "?", Mf = /\(error: (.*)\)/, Df = /captureMessage|captureException/;
function gy(...t) {
  const e = t.sort((n, s) => n[0] - s[0]).map((n) => n[1]);
  return (n, s = 0, r = 0) => {
    const i = [], o = n.split(`
`);
    for (let a = s; a < o.length; a++) {
      const c = o[a];
      if (c.length > 1024)
        continue;
      const l = Mf.test(c) ? c.replace(Mf, "$1") : c;
      if (!l.match(/\S*Error: /)) {
        for (const d of e) {
          const u = d(l);
          if (u) {
            i.push(u);
            break;
          }
        }
        if (i.length >= my + r)
          break;
      }
    }
    return mR(i.slice(r));
  };
}
function fR(t) {
  return Array.isArray(t) ? gy(...t) : t;
}
function mR(t) {
  if (!t.length)
    return [];
  const e = Array.from(t);
  return /sentryWrapped/.test(Mo(e).function || "") && e.pop(), e.reverse(), Df.test(Mo(e).function || "") && (e.pop(), Df.test(Mo(e).function || "") && e.pop()), e.slice(0, my).map((n) => ({
    ...n,
    filename: n.filename || Mo(e).filename,
    function: n.function || Is
  }));
}
function Mo(t) {
  return t[t.length - 1] || {};
}
const bl = "<anonymous>";
function un(t) {
  try {
    return !t || typeof t != "function" ? bl : t.name || bl;
  } catch {
    return bl;
  }
}
function Gf(t) {
  const e = t.exception;
  if (e) {
    const n = [];
    try {
      return e.values.forEach((s) => {
        s.stacktrace.frames && n.push(...s.stacktrace.frames);
      }), n;
    } catch {
      return;
    }
  }
}
const ra = {}, Bf = {};
function Jn(t, e) {
  ra[t] = ra[t] || [], ra[t].push(e);
}
function Qn(t, e) {
  if (!Bf[t]) {
    Bf[t] = !0;
    try {
      e();
    } catch (n) {
      Os && w.error(`Error while instrumenting ${t}`, n);
    }
  }
}
function pt(t, e) {
  const n = t && ra[t];
  if (n)
    for (const s of n)
      try {
        s(e);
      } catch (r) {
        Os && w.error(
          `Error while triggering instrumentation handler.
Type: ${t}
Name: ${un(s)}
Error:`,
          r
        );
      }
}
function gR(t) {
  const e = "console";
  Jn(e, t), Qn(e, _R);
}
function _R() {
  "console" in Z && dd.forEach(function(t) {
    t in Z.console && tt(Z.console, t, function(e) {
      return Va[t] = e, function(...n) {
        pt("console", { args: n, level: t });
        const r = Va[t];
        r && r.apply(Z.console, n);
      };
    });
  });
}
const hd = Z;
function _y() {
  if (!("fetch" in hd))
    return !1;
  try {
    return new Headers(), new Request("http://www.example.com"), new Response(), !0;
  } catch {
    return !1;
  }
}
function pd(t) {
  return t && /^function\s+\w+\(\)\s+\{\s+\[native code\]\s+\}$/.test(t.toString());
}
function yR() {
  if (typeof EdgeRuntime == "string")
    return !0;
  if (!_y())
    return !1;
  if (pd(hd.fetch))
    return !0;
  let t = !1;
  const e = hd.document;
  if (e && typeof e.createElement == "function")
    try {
      const n = e.createElement("iframe");
      n.hidden = !0, e.head.appendChild(n), n.contentWindow && n.contentWindow.fetch && (t = pd(n.contentWindow.fetch)), e.head.removeChild(n);
    } catch (n) {
      Os && w.warn("Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ", n);
    }
  return t;
}
const yy = 1e3;
function fo() {
  return Date.now() / yy;
}
function ER() {
  const { performance: t } = Z;
  if (!t || !t.now)
    return fo;
  const e = Date.now() - t.now(), n = t.timeOrigin == null ? e : t.timeOrigin;
  return () => (n + t.now()) / yy;
}
const qe = ER(), Ye = (() => {
  const { performance: t } = Z;
  if (!t || !t.now)
    return;
  const e = 3600 * 1e3, n = t.now(), s = Date.now(), r = t.timeOrigin ? Math.abs(t.timeOrigin + n - s) : e, i = r < e, o = t.timing && t.timing.navigationStart, c = typeof o == "number" ? Math.abs(o + n - s) : e, l = c < e;
  return i || l ? r <= c ? t.timeOrigin : o : s;
})();
function Ey(t, e) {
  const n = "fetch";
  Jn(n, t), Qn(n, () => by(void 0, e));
}
function bR(t) {
  const e = "fetch-body-resolved";
  Jn(e, t), Qn(e, () => by(SR));
}
function by(t, e = !1) {
  e && !yR() || tt(Z, "fetch", function(n) {
    return function(...s) {
      const { method: r, url: i } = wR(s), o = {
        args: s,
        fetchData: {
          method: r,
          url: i
        },
        startTimestamp: qe() * 1e3
      };
      t || pt("fetch", {
        ...o
      });
      const a = new Error().stack;
      return n.apply(Z, s).then(
        async (c) => (t ? t(c) : pt("fetch", {
          ...o,
          endTimestamp: qe() * 1e3,
          response: c
        }), c),
        (c) => {
          throw pt("fetch", {
            ...o,
            endTimestamp: qe() * 1e3,
            error: c
          }), sh(c) && c.stack === void 0 && (c.stack = a, _t(c, "framesToPop", 1)), c;
        }
      );
    };
  });
}
async function vR(t, e) {
  if (t && t.body) {
    const n = t.body, s = n.getReader(), r = setTimeout(
      () => {
        n.cancel().then(null, () => {
        });
      },
      90 * 1e3
      // 90s
    );
    let i = !0;
    for (; i; ) {
      let o;
      try {
        o = setTimeout(() => {
          n.cancel().then(null, () => {
          });
        }, 5e3);
        const { done: a } = await s.read();
        clearTimeout(o), a && (e(), i = !1);
      } catch {
        i = !1;
      } finally {
        clearTimeout(o);
      }
    }
    clearTimeout(r), s.releaseLock(), n.cancel().then(null, () => {
    });
  }
}
function SR(t) {
  let e;
  try {
    e = t.clone();
  } catch {
    return;
  }
  vR(e, () => {
    pt("fetch-body-resolved", {
      endTimestamp: qe() * 1e3,
      response: t
    });
  });
}
function fd(t, e) {
  return !!t && typeof t == "object" && !!t[e];
}
function $f(t) {
  return typeof t == "string" ? t : t ? fd(t, "url") ? t.url : t.toString ? t.toString() : "" : "";
}
function wR(t) {
  if (t.length === 0)
    return { method: "GET", url: "" };
  if (t.length === 2) {
    const [n, s] = t;
    return {
      url: $f(n),
      method: fd(s, "method") ? String(s.method).toUpperCase() : "GET"
    };
  }
  const e = t[0];
  return {
    url: $f(e),
    method: fd(e, "method") ? String(e.method).toUpperCase() : "GET"
  };
}
let Do = null;
function vy(t) {
  const e = "error";
  Jn(e, t), Qn(e, TR);
}
function TR() {
  Do = Z.onerror, Z.onerror = function(t, e, n, s, r) {
    return pt("error", {
      column: s,
      error: r,
      line: n,
      msg: t,
      url: e
    }), Do && !Do.__SENTRY_LOADER__ ? Do.apply(this, arguments) : !1;
  }, Z.onerror.__SENTRY_INSTRUMENTED__ = !0;
}
let Go = null;
function Sy(t) {
  const e = "unhandledrejection";
  Jn(e, t), Qn(e, IR);
}
function IR() {
  Go = Z.onunhandledrejection, Z.onunhandledrejection = function(t) {
    return pt("unhandledrejection", t), Go && !Go.__SENTRY_LOADER__ ? Go.apply(this, arguments) : !0;
  }, Z.onunhandledrejection.__SENTRY_INSTRUMENTED__ = !0;
}
function CR() {
  return typeof __SENTRY_BROWSER_BUNDLE__ < "u" && !!__SENTRY_BROWSER_BUNDLE__;
}
function FR() {
  return "npm";
}
function kR() {
  return !CR() && Object.prototype.toString.call(typeof process < "u" ? process : 0) === "[object process]";
}
function Vf() {
  return typeof window < "u" && (!kR() || AR());
}
function AR() {
  return (
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-explicit-any
    Z.process !== void 0 && Z.process.type === "renderer"
  );
}
function NR() {
  const t = typeof WeakSet == "function", e = t ? /* @__PURE__ */ new WeakSet() : [];
  function n(r) {
    if (t)
      return e.has(r) ? !0 : (e.add(r), !1);
    for (let i = 0; i < e.length; i++)
      if (e[i] === r)
        return !0;
    return e.push(r), !1;
  }
  function s(r) {
    if (t)
      e.delete(r);
    else
      for (let i = 0; i < e.length; i++)
        if (e[i] === r) {
          e.splice(i, 1);
          break;
        }
  }
  return [n, s];
}
function me() {
  const t = Z, e = t.crypto || t.msCrypto;
  let n = () => Math.random() * 16;
  try {
    if (e && e.randomUUID)
      return e.randomUUID().replace(/-/g, "");
    e && e.getRandomValues && (n = () => {
      const s = new Uint8Array(1);
      return e.getRandomValues(s), s[0];
    });
  } catch {
  }
  return ("10000000100040008000" + 1e11).replace(
    /[018]/g,
    (s) => (
      // eslint-disable-next-line no-bitwise
      (s ^ (n() & 15) >> s / 4).toString(16)
    )
  );
}
function wy(t) {
  return t.exception && t.exception.values ? t.exception.values[0] : void 0;
}
function vn(t) {
  const { message: e, event_id: n } = t;
  if (e)
    return e;
  const s = wy(t);
  return s ? s.type && s.value ? `${s.type}: ${s.value}` : s.type || s.value || n || "<unknown>" : n || "<unknown>";
}
function md(t, e, n) {
  const s = t.exception = t.exception || {}, r = s.values = s.values || [], i = r[0] = r[0] || {};
  i.value || (i.value = e || ""), i.type || (i.type = "Error");
}
function $i(t, e) {
  const n = wy(t);
  if (!n)
    return;
  const s = { type: "generic", handled: !0 }, r = n.mechanism;
  if (n.mechanism = { ...s, ...r, ...e }, e && "data" in e) {
    const i = { ...r && r.data, ...e.data };
    n.mechanism.data = i;
  }
}
function Uf(t) {
  if (t && t.__sentry_captured__)
    return !0;
  try {
    _t(t, "__sentry_captured__", !0);
  } catch {
  }
  return !1;
}
function Ty(t) {
  return Array.isArray(t) ? t : [t];
}
function Rt(t, e = 100, n = 1 / 0) {
  try {
    return gd("", t, e, n);
  } catch (s) {
    return { ERROR: `**non-serializable** (${s})` };
  }
}
function Iy(t, e = 3, n = 100 * 1024) {
  const s = Rt(t, e);
  return OR(s) > n ? Iy(t, e - 1, n) : s;
}
function gd(t, e, n = 1 / 0, s = 1 / 0, r = NR()) {
  const [i, o] = r;
  if (e == null || // this matches null and undefined -> eqeq not eqeqeq
  ["boolean", "string"].includes(typeof e) || typeof e == "number" && Number.isFinite(e))
    return e;
  const a = LR(t, e);
  if (!a.startsWith("[object "))
    return a;
  if (e.__sentry_skip_normalization__)
    return e;
  const c = typeof e.__sentry_override_normalization_depth__ == "number" ? e.__sentry_override_normalization_depth__ : n;
  if (c === 0)
    return a.replace("object ", "");
  if (i(e))
    return "[Circular ~]";
  const l = e;
  if (l && typeof l.toJSON == "function")
    try {
      const p = l.toJSON();
      return gd("", p, c - 1, s, r);
    } catch {
    }
  const d = Array.isArray(e) ? [] : {};
  let u = 0;
  const h = fy(e);
  for (const p in h) {
    if (!Object.prototype.hasOwnProperty.call(h, p))
      continue;
    if (u >= s) {
      d[p] = "[MaxProperties ~]";
      break;
    }
    const f = h[p];
    d[p] = gd(p, f, c - 1, s, r), u++;
  }
  return o(e), d;
}
function LR(t, e) {
  try {
    if (t === "domain" && e && typeof e == "object" && e._events)
      return "[Domain]";
    if (t === "domainEmitter")
      return "[DomainEmitter]";
    if (typeof global < "u" && e === global)
      return "[Global]";
    if (typeof window < "u" && e === window)
      return "[Window]";
    if (typeof document < "u" && e === document)
      return "[Document]";
    if (cy(e))
      return "[VueViewModel]";
    if (J5(e))
      return "[SyntheticEvent]";
    if (typeof e == "number" && !Number.isFinite(e))
      return `[${e}]`;
    if (typeof e == "function")
      return `[Function: ${un(e)}]`;
    if (typeof e == "symbol")
      return `[${String(e)}]`;
    if (typeof e == "bigint")
      return `[BigInt: ${String(e)}]`;
    const n = RR(e);
    return /^HTML(\w*)Element$/.test(n) ? `[HTMLElement: ${n}]` : `[object ${n}]`;
  } catch (n) {
    return `**non-serializable** (${n})`;
  }
}
function RR(t) {
  const e = Object.getPrototypeOf(t);
  return e ? e.constructor.name : "null prototype";
}
function xR(t) {
  return ~-encodeURI(t).split(/%..|./).length;
}
function OR(t) {
  return xR(JSON.stringify(t));
}
var qt;
(function(t) {
  t[t.PENDING = 0] = "PENDING";
  const n = 1;
  t[t.RESOLVED = n] = "RESOLVED";
  const s = 2;
  t[t.REJECTED = s] = "REJECTED";
})(qt || (qt = {}));
function hn(t) {
  return new dt((e) => {
    e(t);
  });
}
function Ua(t) {
  return new dt((e, n) => {
    n(t);
  });
}
class dt {
  constructor(e) {
    dt.prototype.__init.call(this), dt.prototype.__init2.call(this), dt.prototype.__init3.call(this), dt.prototype.__init4.call(this), this._state = qt.PENDING, this._handlers = [];
    try {
      e(this._resolve, this._reject);
    } catch (n) {
      this._reject(n);
    }
  }
  /** JSDoc */
  then(e, n) {
    return new dt((s, r) => {
      this._handlers.push([
        !1,
        (i) => {
          if (!e)
            s(i);
          else
            try {
              s(e(i));
            } catch (o) {
              r(o);
            }
        },
        (i) => {
          if (!n)
            r(i);
          else
            try {
              s(n(i));
            } catch (o) {
              r(o);
            }
        }
      ]), this._executeHandlers();
    });
  }
  /** JSDoc */
  catch(e) {
    return this.then((n) => n, e);
  }
  /** JSDoc */
  finally(e) {
    return new dt((n, s) => {
      let r, i;
      return this.then(
        (o) => {
          i = !1, r = o, e && e();
        },
        (o) => {
          i = !0, r = o, e && e();
        }
      ).then(() => {
        if (i) {
          s(r);
          return;
        }
        n(r);
      });
    });
  }
  /** JSDoc */
  __init() {
    this._resolve = (e) => {
      this._setResult(qt.RESOLVED, e);
    };
  }
  /** JSDoc */
  __init2() {
    this._reject = (e) => {
      this._setResult(qt.REJECTED, e);
    };
  }
  /** JSDoc */
  __init3() {
    this._setResult = (e, n) => {
      if (this._state === qt.PENDING) {
        if (Fc(n)) {
          n.then(this._resolve, this._reject);
          return;
        }
        this._state = e, this._value = n, this._executeHandlers();
      }
    };
  }
  /** JSDoc */
  __init4() {
    this._executeHandlers = () => {
      if (this._state === qt.PENDING)
        return;
      const e = this._handlers.slice();
      this._handlers = [], e.forEach((n) => {
        n[0] || (this._state === qt.RESOLVED && n[1](this._value), this._state === qt.REJECTED && n[2](this._value), n[0] = !0);
      });
    };
  }
}
function PR(t) {
  const e = [];
  function n() {
    return t === void 0 || e.length < t;
  }
  function s(o) {
    return e.splice(e.indexOf(o), 1)[0] || Promise.resolve(void 0);
  }
  function r(o) {
    if (!n())
      return Ua(new xt("Not adding Promise because buffer limit was reached."));
    const a = o();
    return e.indexOf(a) === -1 && e.push(a), a.then(() => s(a)).then(
      null,
      () => s(a).then(null, () => {
      })
    ), a;
  }
  function i(o) {
    return new dt((a, c) => {
      let l = e.length;
      if (!l)
        return a(!0);
      const d = setTimeout(() => {
        o && o > 0 && a(!1);
      }, o);
      e.forEach((u) => {
        hn(u).then(() => {
          --l || (clearTimeout(d), a(!0));
        }, c);
      });
    });
  }
  return {
    $: e,
    add: r,
    drain: i
  };
}
function ps(t) {
  if (!t)
    return {};
  const e = t.match(/^(([^:/?#]+):)?(\/\/([^/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?$/);
  if (!e)
    return {};
  const n = e[6] || "", s = e[8] || "";
  return {
    host: e[4],
    path: e[5],
    protocol: e[2],
    search: n,
    hash: s,
    relative: e[5] + n + s
    // everything minus origin
  };
}
const MR = ["fatal", "error", "warning", "log", "info", "debug"];
function Cy(t) {
  return t === "warn" ? "warning" : MR.includes(t) ? t : "log";
}
const er = "baggage", ah = "sentry-", DR = /^sentry-/, GR = 8192;
function Fy(t) {
  const e = BR(t);
  if (!e)
    return;
  const n = Object.entries(e).reduce((s, [r, i]) => {
    if (r.match(DR)) {
      const o = r.slice(ah.length);
      s[o] = i;
    }
    return s;
  }, {});
  if (Object.keys(n).length > 0)
    return n;
}
function ky(t) {
  if (!t)
    return;
  const e = Object.entries(t).reduce(
    (n, [s, r]) => (r && (n[`${ah}${s}`] = r), n),
    {}
  );
  return $R(e);
}
function BR(t) {
  if (!(!t || !nn(t) && !Array.isArray(t)))
    return Array.isArray(t) ? t.reduce((e, n) => {
      const s = Hf(n);
      return Object.entries(s).forEach(([r, i]) => {
        e[r] = i;
      }), e;
    }, {}) : Hf(t);
}
function Hf(t) {
  return t.split(",").map((e) => e.split("=").map((n) => decodeURIComponent(n.trim()))).reduce((e, [n, s]) => (n && s && (e[n] = s), e), {});
}
function $R(t) {
  if (Object.keys(t).length !== 0)
    return Object.entries(t).reduce((e, [n, s], r) => {
      const i = `${encodeURIComponent(n)}=${encodeURIComponent(s)}`, o = r === 0 ? i : `${e},${i}`;
      return o.length > GR ? (Os && w.warn(
        `Not adding key: ${n} with val: ${s} to baggage header due to exceeding baggage size limits.`
      ), e) : o;
    }, "");
}
const VR = new RegExp(
  "^[ \\t]*([0-9a-f]{32})?-?([0-9a-f]{16})?-?([01])?[ \\t]*$"
  // whitespace
);
function UR(t) {
  if (!t)
    return;
  const e = t.match(VR);
  if (!e)
    return;
  let n;
  return e[3] === "1" ? n = !0 : e[3] === "0" && (n = !1), {
    traceId: e[1],
    parentSampled: n,
    parentSpanId: e[2]
  };
}
function HR(t, e) {
  const n = UR(t), s = Fy(e), { traceId: r, parentSpanId: i, parentSampled: o } = n || {};
  return n ? {
    traceId: r || me(),
    parentSpanId: i || me().substring(16),
    spanId: me().substring(16),
    sampled: o,
    dsc: s || {}
    // If we have traceparent data but no DSC it means we are not head of trace and we must freeze it
  } : {
    traceId: r || me(),
    spanId: me().substring(16)
  };
}
function ch(t = me(), e = me().substring(16), n) {
  let s = "";
  return n !== void 0 && (s = n ? "-1" : "-0"), `${t}-${e}${s}`;
}
function Ps(t, e = []) {
  return [t, e];
}
function jR(t, e) {
  const [n, s] = t;
  return [n, [...s, e]];
}
function jf(t, e) {
  const n = t[1];
  for (const s of n) {
    const r = s[0].type;
    if (e(s, r))
      return !0;
  }
  return !1;
}
function _d(t) {
  return Z.__SENTRY__ && Z.__SENTRY__.encodePolyfill ? Z.__SENTRY__.encodePolyfill(t) : new TextEncoder().encode(t);
}
function WR(t) {
  const [e, n] = t;
  let s = JSON.stringify(e);
  function r(i) {
    typeof s == "string" ? s = typeof i == "string" ? s + i : [_d(s), i] : s.push(typeof i == "string" ? _d(i) : i);
  }
  for (const i of n) {
    const [o, a] = i;
    if (r(`
${JSON.stringify(o)}
`), typeof a == "string" || a instanceof Uint8Array)
      r(a);
    else {
      let c;
      try {
        c = JSON.stringify(a);
      } catch {
        c = JSON.stringify(Rt(a));
      }
      r(c);
    }
  }
  return typeof s == "string" ? s : zR(s);
}
function zR(t) {
  const e = t.reduce((r, i) => r + i.length, 0), n = new Uint8Array(e);
  let s = 0;
  for (const r of t)
    n.set(r, s), s += r.length;
  return n;
}
function qR(t) {
  return [{
    type: "span"
  }, t];
}
function YR(t) {
  const e = typeof t.data == "string" ? _d(t.data) : t.data;
  return [
    Ce({
      type: "attachment",
      length: e.length,
      filename: t.filename,
      content_type: t.contentType,
      attachment_type: t.attachmentType
    }),
    e
  ];
}
const KR = {
  session: "session",
  sessions: "session",
  attachment: "attachment",
  transaction: "transaction",
  event: "error",
  client_report: "internal",
  user_report: "default",
  profile: "profile",
  profile_chunk: "profile",
  replay_event: "replay",
  replay_recording: "replay",
  check_in: "monitor",
  feedback: "feedback",
  span: "span",
  statsd: "metric_bucket"
};
function Wf(t) {
  return KR[t];
}
function lh(t) {
  if (!t || !t.sdk)
    return;
  const { name: e, version: n } = t.sdk;
  return { name: e, version: n };
}
function Ay(t, e, n, s) {
  const r = t.sdkProcessingMetadata && t.sdkProcessingMetadata.dynamicSamplingContext;
  return {
    event_id: t.event_id,
    sent_at: (/* @__PURE__ */ new Date()).toISOString(),
    ...e && { sdk: e },
    ...!!n && s && { dsn: po(s) },
    ...r && {
      trace: Ce({ ...r })
    }
  };
}
function XR(t, e, n) {
  const s = [
    { type: "client_report" },
    {
      timestamp: fo(),
      discarded_events: t
    }
  ];
  return Ps(e ? { dsn: e } : {}, [s]);
}
const JR = 60 * 1e3;
function QR(t, e = Date.now()) {
  const n = parseInt(`${t}`, 10);
  if (!isNaN(n))
    return n * 1e3;
  const s = Date.parse(`${t}`);
  return isNaN(s) ? JR : s - e;
}
function ZR(t, e) {
  return t[e] || t.all || 0;
}
function Ny(t, e, n = Date.now()) {
  return ZR(t, e) > n;
}
function Ly(t, { statusCode: e, headers: n }, s = Date.now()) {
  const r = {
    ...t
  }, i = n && n["x-sentry-rate-limits"], o = n && n["retry-after"];
  if (i)
    for (const a of i.trim().split(",")) {
      const [c, l, , , d] = a.split(":", 5), u = parseInt(c, 10), h = (isNaN(u) ? 60 : u) * 1e3;
      if (!l)
        r.all = s + h;
      else
        for (const p of l.split(";"))
          p === "metric_bucket" ? (!d || d.split(";").includes("custom")) && (r[p] = s + h) : r[p] = s + h;
    }
  else o ? r.all = s + QR(o, s) : e === 429 && (r.all = s + 60 * 1e3);
  return r;
}
function ex(t, e) {
  return t ?? e();
}
function st(t) {
  let e, n = t[0], s = 1;
  for (; s < t.length; ) {
    const r = t[s], i = t[s + 1];
    if (s += 2, (r === "optionalAccess" || r === "optionalCall") && n == null)
      return;
    r === "access" || r === "optionalAccess" ? (e = n, n = i(n)) : (r === "call" || r === "optionalCall") && (n = i((...o) => n.call(e, ...o)), e = void 0);
  }
  return n;
}
function Ha() {
  return {
    traceId: me(),
    spanId: me().substring(16)
  };
}
const Bo = Z;
function tx() {
  const t = Bo.chrome, e = t && t.app && t.app.runtime, n = "history" in Bo && !!Bo.history.pushState && !!Bo.history.replaceState;
  return !e && n;
}
const H = typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__;
function Xr() {
  return dh(Z), Z;
}
function dh(t) {
  const e = t.__SENTRY__ = t.__SENTRY__ || {};
  return e.version = e.version || hs, e[hs] = e[hs] || {};
}
function nx(t) {
  const e = qe(), n = {
    sid: me(),
    init: !0,
    timestamp: e,
    started: e,
    duration: 0,
    status: "ok",
    errors: 0,
    ignoreDuration: !1,
    toJSON: () => rx(n)
  };
  return t && Nr(n, t), n;
}
function Nr(t, e = {}) {
  if (e.user && (!t.ipAddress && e.user.ip_address && (t.ipAddress = e.user.ip_address), !t.did && !e.did && (t.did = e.user.id || e.user.email || e.user.username)), t.timestamp = e.timestamp || qe(), e.abnormal_mechanism && (t.abnormal_mechanism = e.abnormal_mechanism), e.ignoreDuration && (t.ignoreDuration = e.ignoreDuration), e.sid && (t.sid = e.sid.length === 32 ? e.sid : me()), e.init !== void 0 && (t.init = e.init), !t.did && e.did && (t.did = `${e.did}`), typeof e.started == "number" && (t.started = e.started), t.ignoreDuration)
    t.duration = void 0;
  else if (typeof e.duration == "number")
    t.duration = e.duration;
  else {
    const n = t.timestamp - t.started;
    t.duration = n >= 0 ? n : 0;
  }
  e.release && (t.release = e.release), e.environment && (t.environment = e.environment), !t.ipAddress && e.ipAddress && (t.ipAddress = e.ipAddress), !t.userAgent && e.userAgent && (t.userAgent = e.userAgent), typeof e.errors == "number" && (t.errors = e.errors), e.status && (t.status = e.status);
}
function sx(t, e) {
  let n = {};
  t.status === "ok" && (n = { status: "exited" }), Nr(t, n);
}
function rx(t) {
  return Ce({
    sid: `${t.sid}`,
    init: t.init,
    // Make sure that sec is converted to ms for date constructor
    started: new Date(t.started * 1e3).toISOString(),
    timestamp: new Date(t.timestamp * 1e3).toISOString(),
    status: t.status,
    errors: t.errors,
    did: typeof t.did == "number" || typeof t.did == "string" ? `${t.did}` : void 0,
    duration: t.duration,
    abnormal_mechanism: t.abnormal_mechanism,
    attrs: {
      release: t.release,
      environment: t.environment,
      ip_address: t.ipAddress,
      user_agent: t.userAgent
    }
  });
}
const yd = "_sentrySpan";
function Vi(t, e) {
  e ? _t(t, yd, e) : delete t[yd];
}
function ja(t) {
  return t[yd];
}
const ix = 100;
class uh {
  /** Flag if notifying is happening. */
  /** Callback for client to receive scope changes. */
  /** Callback list that will be called during event processing. */
  /** Array of breadcrumbs. */
  /** User */
  /** Tags */
  /** Extra */
  /** Contexts */
  /** Attachments */
  /** Propagation Context for distributed tracing */
  /**
   * A place to stash data which is needed at some point in the SDK's event processing pipeline but which shouldn't get
   * sent to Sentry
   */
  /** Fingerprint */
  /** Severity */
  /**
   * Transaction Name
   *
   * IMPORTANT: The transaction name on the scope has nothing to do with root spans/transaction objects.
   * It's purpose is to assign a transaction to the scope that's added to non-transaction events.
   */
  /** Session */
  /** Request Mode Session Status */
  /** The client on this scope */
  /** Contains the last event id of a captured event.  */
  // NOTE: Any field which gets added here should get added not only to the constructor but also to the `clone` method.
  constructor() {
    this._notifyingListeners = !1, this._scopeListeners = [], this._eventProcessors = [], this._breadcrumbs = [], this._attachments = [], this._user = {}, this._tags = {}, this._extra = {}, this._contexts = {}, this._sdkProcessingMetadata = {}, this._propagationContext = Ha();
  }
  /**
   * @inheritDoc
   */
  clone() {
    const e = new uh();
    return e._breadcrumbs = [...this._breadcrumbs], e._tags = { ...this._tags }, e._extra = { ...this._extra }, e._contexts = { ...this._contexts }, e._user = this._user, e._level = this._level, e._session = this._session, e._transactionName = this._transactionName, e._fingerprint = this._fingerprint, e._eventProcessors = [...this._eventProcessors], e._requestSession = this._requestSession, e._attachments = [...this._attachments], e._sdkProcessingMetadata = { ...this._sdkProcessingMetadata }, e._propagationContext = { ...this._propagationContext }, e._client = this._client, e._lastEventId = this._lastEventId, Vi(e, ja(this)), e;
  }
  /**
   * @inheritDoc
   */
  setClient(e) {
    this._client = e;
  }
  /**
   * @inheritDoc
   */
  setLastEventId(e) {
    this._lastEventId = e;
  }
  /**
   * @inheritDoc
   */
  getClient() {
    return this._client;
  }
  /**
   * @inheritDoc
   */
  lastEventId() {
    return this._lastEventId;
  }
  /**
   * @inheritDoc
   */
  addScopeListener(e) {
    this._scopeListeners.push(e);
  }
  /**
   * @inheritDoc
   */
  addEventProcessor(e) {
    return this._eventProcessors.push(e), this;
  }
  /**
   * @inheritDoc
   */
  setUser(e) {
    return this._user = e || {
      email: void 0,
      id: void 0,
      ip_address: void 0,
      username: void 0
    }, this._session && Nr(this._session, { user: e }), this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  getUser() {
    return this._user;
  }
  /**
   * @inheritDoc
   */
  getRequestSession() {
    return this._requestSession;
  }
  /**
   * @inheritDoc
   */
  setRequestSession(e) {
    return this._requestSession = e, this;
  }
  /**
   * @inheritDoc
   */
  setTags(e) {
    return this._tags = {
      ...this._tags,
      ...e
    }, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setTag(e, n) {
    return this._tags = { ...this._tags, [e]: n }, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setExtras(e) {
    return this._extra = {
      ...this._extra,
      ...e
    }, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setExtra(e, n) {
    return this._extra = { ...this._extra, [e]: n }, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setFingerprint(e) {
    return this._fingerprint = e, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setLevel(e) {
    return this._level = e, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setTransactionName(e) {
    return this._transactionName = e, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setContext(e, n) {
    return n === null ? delete this._contexts[e] : this._contexts[e] = n, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setSession(e) {
    return e ? this._session = e : delete this._session, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  getSession() {
    return this._session;
  }
  /**
   * @inheritDoc
   */
  update(e) {
    if (!e)
      return this;
    const n = typeof e == "function" ? e(this) : e, [s, r] = n instanceof Cs ? [n.getScopeData(), n.getRequestSession()] : Ar(n) ? [e, e.requestSession] : [], { tags: i, extra: o, user: a, contexts: c, level: l, fingerprint: d = [], propagationContext: u } = s || {};
    return this._tags = { ...this._tags, ...i }, this._extra = { ...this._extra, ...o }, this._contexts = { ...this._contexts, ...c }, a && Object.keys(a).length && (this._user = a), l && (this._level = l), d.length && (this._fingerprint = d), u && (this._propagationContext = u), r && (this._requestSession = r), this;
  }
  /**
   * @inheritDoc
   */
  clear() {
    return this._breadcrumbs = [], this._tags = {}, this._extra = {}, this._user = {}, this._contexts = {}, this._level = void 0, this._transactionName = void 0, this._fingerprint = void 0, this._requestSession = void 0, this._session = void 0, Vi(this, void 0), this._attachments = [], this._propagationContext = Ha(), this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  addBreadcrumb(e, n) {
    const s = typeof n == "number" ? n : ix;
    if (s <= 0)
      return this;
    const r = {
      timestamp: fo(),
      ...e
    }, i = this._breadcrumbs;
    return i.push(r), this._breadcrumbs = i.length > s ? i.slice(-s) : i, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  getLastBreadcrumb() {
    return this._breadcrumbs[this._breadcrumbs.length - 1];
  }
  /**
   * @inheritDoc
   */
  clearBreadcrumbs() {
    return this._breadcrumbs = [], this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  addAttachment(e) {
    return this._attachments.push(e), this;
  }
  /**
   * @inheritDoc
   */
  clearAttachments() {
    return this._attachments = [], this;
  }
  /** @inheritDoc */
  getScopeData() {
    return {
      breadcrumbs: this._breadcrumbs,
      attachments: this._attachments,
      contexts: this._contexts,
      tags: this._tags,
      extra: this._extra,
      user: this._user,
      level: this._level,
      fingerprint: this._fingerprint || [],
      eventProcessors: this._eventProcessors,
      propagationContext: this._propagationContext,
      sdkProcessingMetadata: this._sdkProcessingMetadata,
      transactionName: this._transactionName,
      span: ja(this)
    };
  }
  /**
   * @inheritDoc
   */
  setSDKProcessingMetadata(e) {
    return this._sdkProcessingMetadata = { ...this._sdkProcessingMetadata, ...e }, this;
  }
  /**
   * @inheritDoc
   */
  setPropagationContext(e) {
    return this._propagationContext = e, this;
  }
  /**
   * @inheritDoc
   */
  getPropagationContext() {
    return this._propagationContext;
  }
  /**
   * @inheritDoc
   */
  captureException(e, n) {
    const s = n && n.event_id ? n.event_id : me();
    if (!this._client)
      return w.warn("No client configured on scope - will not capture exception!"), s;
    const r = new Error("Sentry syntheticException");
    return this._client.captureException(
      e,
      {
        originalException: e,
        syntheticException: r,
        ...n,
        event_id: s
      },
      this
    ), s;
  }
  /**
   * @inheritDoc
   */
  captureMessage(e, n, s) {
    const r = s && s.event_id ? s.event_id : me();
    if (!this._client)
      return w.warn("No client configured on scope - will not capture message!"), r;
    const i = new Error(e);
    return this._client.captureMessage(
      e,
      n,
      {
        originalException: e,
        syntheticException: i,
        ...s,
        event_id: r
      },
      this
    ), r;
  }
  /**
   * @inheritDoc
   */
  captureEvent(e, n) {
    const s = n && n.event_id ? n.event_id : me();
    return this._client ? (this._client.captureEvent(e, { ...n, event_id: s }, this), s) : (w.warn("No client configured on scope - will not capture event!"), s);
  }
  /**
   * This will be called on every set call.
   */
  _notifyScopeListeners() {
    this._notifyingListeners || (this._notifyingListeners = !0, this._scopeListeners.forEach((e) => {
      e(this);
    }), this._notifyingListeners = !1);
  }
}
const Cs = uh;
function ox() {
  return kc("defaultCurrentScope", () => new Cs());
}
function ax() {
  return kc("defaultIsolationScope", () => new Cs());
}
class cx {
  constructor(e, n) {
    let s;
    e ? s = e : s = new Cs();
    let r;
    n ? r = n : r = new Cs(), this._stack = [{ scope: s }], this._isolationScope = r;
  }
  /**
   * Fork a scope for the stack.
   */
  withScope(e) {
    const n = this._pushScope();
    let s;
    try {
      s = e(n);
    } catch (r) {
      throw this._popScope(), r;
    }
    return Fc(s) ? s.then(
      (r) => (this._popScope(), r),
      (r) => {
        throw this._popScope(), r;
      }
    ) : (this._popScope(), s);
  }
  /**
   * Get the client of the stack.
   */
  getClient() {
    return this.getStackTop().client;
  }
  /**
   * Returns the scope of the top stack.
   */
  getScope() {
    return this.getStackTop().scope;
  }
  /**
   * Get the isolation scope for the stack.
   */
  getIsolationScope() {
    return this._isolationScope;
  }
  /**
   * Returns the topmost scope layer in the order domain > local > process.
   */
  getStackTop() {
    return this._stack[this._stack.length - 1];
  }
  /**
   * Push a scope to the stack.
   */
  _pushScope() {
    const e = this.getScope().clone();
    return this._stack.push({
      client: this.getClient(),
      scope: e
    }), e;
  }
  /**
   * Pop a scope from the stack.
   */
  _popScope() {
    return this._stack.length <= 1 ? !1 : !!this._stack.pop();
  }
}
function Lr() {
  const t = Xr(), e = dh(t);
  return e.stack = e.stack || new cx(ox(), ax());
}
function lx(t) {
  return Lr().withScope(t);
}
function dx(t, e) {
  const n = Lr();
  return n.withScope(() => (n.getStackTop().scope = t, e(t)));
}
function zf(t) {
  return Lr().withScope(() => t(Lr().getIsolationScope()));
}
function ux() {
  return {
    withIsolationScope: zf,
    withScope: lx,
    withSetScope: dx,
    withSetIsolationScope: (t, e) => zf(e),
    getCurrentScope: () => Lr().getScope(),
    getIsolationScope: () => Lr().getIsolationScope()
  };
}
function mo(t) {
  const e = dh(t);
  return e.acs ? e.acs : ux();
}
function he() {
  const t = Xr();
  return mo(t).getCurrentScope();
}
function Et() {
  const t = Xr();
  return mo(t).getIsolationScope();
}
function hx() {
  return kc("globalScope", () => new Cs());
}
function hh(...t) {
  const e = Xr(), n = mo(e);
  if (t.length === 2) {
    const [s, r] = t;
    return s ? n.withSetScope(s, r) : n.withScope(r);
  }
  return n.withScope(t[0]);
}
function J() {
  return he().getClient();
}
const px = "_sentryMetrics";
function Ed(t) {
  const e = t[px];
  if (!e)
    return;
  const n = {};
  for (const [, [s, r]] of e)
    (n[s] || (n[s] = [])).push(Ce(r));
  return n;
}
const Qt = "sentry.source", Ry = "sentry.sample_rate", Fs = "sentry.op", Le = "sentry.origin", bd = "sentry.idle_span_finish_reason", Ac = "sentry.measurement_unit", Nc = "sentry.measurement_value", fx = "sentry.profile_id", ph = "sentry.exclusive_time", mx = 0, xy = 1, ke = 2;
function gx(t) {
  if (t < 400 && t >= 100)
    return { code: xy };
  if (t >= 400 && t < 500)
    switch (t) {
      case 401:
        return { code: ke, message: "unauthenticated" };
      case 403:
        return { code: ke, message: "permission_denied" };
      case 404:
        return { code: ke, message: "not_found" };
      case 409:
        return { code: ke, message: "already_exists" };
      case 413:
        return { code: ke, message: "failed_precondition" };
      case 429:
        return { code: ke, message: "resource_exhausted" };
      case 499:
        return { code: ke, message: "cancelled" };
      default:
        return { code: ke, message: "invalid_argument" };
    }
  if (t >= 500 && t < 600)
    switch (t) {
      case 501:
        return { code: ke, message: "unimplemented" };
      case 503:
        return { code: ke, message: "unavailable" };
      case 504:
        return { code: ke, message: "deadline_exceeded" };
      default:
        return { code: ke, message: "internal_error" };
    }
  return { code: ke, message: "unknown_error" };
}
function Oy(t, e) {
  t.setAttribute("http.response.status_code", e);
  const n = gx(e);
  n.message !== "unknown_error" && t.setStatus(n);
}
const Py = 0, My = 1;
function _x(t) {
  const { spanId: e, traceId: n } = t.spanContext(), { data: s, op: r, parent_span_id: i, status: o, origin: a } = ne(t);
  return Ce({
    parent_span_id: i,
    span_id: e,
    trace_id: n,
    data: s,
    op: r,
    status: o,
    origin: a
  });
}
function yx(t) {
  const { spanId: e, traceId: n } = t.spanContext(), { parent_span_id: s } = ne(t);
  return Ce({ parent_span_id: s, span_id: e, trace_id: n });
}
function Dy(t) {
  const { traceId: e, spanId: n } = t.spanContext(), s = Ms(t);
  return ch(e, n, s);
}
function fs(t) {
  return typeof t == "number" ? qf(t) : Array.isArray(t) ? t[0] + t[1] / 1e9 : t instanceof Date ? qf(t.getTime()) : qe();
}
function qf(t) {
  return t > 9999999999 ? t / 1e3 : t;
}
function ne(t) {
  if (bx(t))
    return t.getSpanJSON();
  try {
    const { spanId: e, traceId: n } = t.spanContext();
    if (Ex(t)) {
      const { attributes: s, startTime: r, name: i, endTime: o, parentSpanId: a, status: c } = t;
      return Ce({
        span_id: e,
        trace_id: n,
        data: s,
        description: i,
        parent_span_id: a,
        start_timestamp: fs(r),
        // This is [0,0] by default in OTEL, in which case we want to interpret this as no end time
        timestamp: fs(o) || void 0,
        status: Gy(c),
        op: s[Fs],
        origin: s[Le],
        _metrics_summary: Ed(t)
      });
    }
    return {
      span_id: e,
      trace_id: n
    };
  } catch {
    return {};
  }
}
function Ex(t) {
  const e = t;
  return !!e.attributes && !!e.startTime && !!e.name && !!e.endTime && !!e.status;
}
function bx(t) {
  return typeof t.getSpanJSON == "function";
}
function Ms(t) {
  const { traceFlags: e } = t.spanContext();
  return e === My;
}
function Gy(t) {
  if (!(!t || t.code === mx))
    return t.code === xy ? "ok" : t.message || "unknown_error";
}
const ms = "_sentryChildSpans", vd = "_sentryRootSpan";
function By(t, e) {
  const n = t[vd] || t;
  _t(e, vd, n), t[ms] ? t[ms].add(e) : _t(t, ms, /* @__PURE__ */ new Set([e]));
}
function vx(t, e) {
  t[ms] && t[ms].delete(e);
}
function ia(t) {
  const e = /* @__PURE__ */ new Set();
  function n(s) {
    if (!e.has(s) && Ms(s)) {
      e.add(s);
      const r = s[ms] ? Array.from(s[ms]) : [];
      for (const i of r)
        n(i);
    }
  }
  return n(t), Array.from(e);
}
function Pe(t) {
  return t[vd] || t;
}
function De() {
  const t = Xr(), e = mo(t);
  return e.getActiveSpan ? e.getActiveSpan() : ja(he());
}
let Yf = !1;
function Sx() {
  Yf || (Yf = !0, vy(Sd), Sy(Sd));
}
function Sd() {
  const t = De(), e = t && Pe(t);
  if (e) {
    const n = "internal_error";
    H && w.log(`[Tracing] Root span: ${n} -> Global error occurred`), e.setStatus({ code: ke, message: n });
  }
}
Sd.tag = "sentry_tracingErrorCallback";
const $y = "_sentryScope", Vy = "_sentryIsolationScope";
function wx(t, e, n) {
  t && (_t(t, Vy, n), _t(t, $y, e));
}
function Kf(t) {
  return {
    scope: t[$y],
    isolationScope: t[Vy]
  };
}
function pn(t) {
  if (typeof __SENTRY_TRACING__ == "boolean" && !__SENTRY_TRACING__)
    return !1;
  const e = J(), n = t || e && e.getOptions();
  return !!n && (n.enableTracing || "tracesSampleRate" in n || "tracesSampler" in n);
}
class Jr {
  constructor(e = {}) {
    this._traceId = e.traceId || me(), this._spanId = e.spanId || me().substring(16);
  }
  /** @inheritdoc */
  spanContext() {
    return {
      spanId: this._spanId,
      traceId: this._traceId,
      traceFlags: Py
    };
  }
  /** @inheritdoc */
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  end(e) {
  }
  /** @inheritdoc */
  setAttribute(e, n) {
    return this;
  }
  /** @inheritdoc */
  setAttributes(e) {
    return this;
  }
  /** @inheritdoc */
  setStatus(e) {
    return this;
  }
  /** @inheritdoc */
  updateName(e) {
    return this;
  }
  /** @inheritdoc */
  isRecording() {
    return !1;
  }
  /** @inheritdoc */
  addEvent(e, n, s) {
    return this;
  }
  /**
   * This should generally not be used,
   * but we need it for being compliant with the OTEL Span interface.
   *
   * @hidden
   * @internal
   */
  addLink(e) {
    return this;
  }
  /**
   * This should generally not be used,
   * but we need it for being compliant with the OTEL Span interface.
   *
   * @hidden
   * @internal
   */
  addLinks(e) {
    return this;
  }
  /**
   * This should generally not be used,
   * but we need it for being compliant with the OTEL Span interface.
   *
   * @hidden
   * @internal
   */
  recordException(e, n) {
  }
}
const fh = "production", Uy = "_frozenDsc";
function Xf(t, e) {
  _t(t, Uy, e);
}
function Lc(t, e) {
  const n = e.getOptions(), { publicKey: s } = e.getDsn() || {}, r = Ce({
    environment: n.environment || fh,
    release: n.release,
    public_key: s,
    trace_id: t
  });
  return e.emit("createDsc", r), r;
}
function Zn(t) {
  const e = J();
  if (!e)
    return {};
  const n = Lc(ne(t).trace_id || "", e), s = Pe(t), r = s[Uy];
  if (r)
    return r;
  const i = s.spanContext().traceState, o = i && i.get("sentry.dsc"), a = o && Fy(o);
  if (a)
    return a;
  const c = ne(s), l = c.data || {}, d = l[Ry];
  d != null && (n.sample_rate = `${d}`);
  const u = l[Qt], h = c.description;
  return u !== "url" && h && (n.transaction = h), pn() && (n.sampled = String(Ms(s))), e.emit("createDsc", n, s), n;
}
function Tx(t) {
  if (!H) return;
  const { description: e = "< unknown name >", op: n = "< unknown op >", parent_span_id: s } = ne(t), { spanId: r } = t.spanContext(), i = Ms(t), o = Pe(t), a = o === t, c = `[Tracing] Starting ${i ? "sampled" : "unsampled"} ${a ? "root " : ""}span`, l = [`op: ${n}`, `name: ${e}`, `ID: ${r}`];
  if (s && l.push(`parent ID: ${s}`), !a) {
    const { op: d, description: u } = ne(o);
    l.push(`root ID: ${o.spanContext().spanId}`), d && l.push(`root op: ${d}`), u && l.push(`root description: ${u}`);
  }
  w.log(`${c}
  ${l.join(`
  `)}`);
}
function Ix(t) {
  if (!H) return;
  const { description: e = "< unknown name >", op: n = "< unknown op >" } = ne(t), { spanId: s } = t.spanContext(), i = Pe(t) === t, o = `[Tracing] Finishing "${n}" ${i ? "root " : ""}span "${e}" with ID ${s}`;
  w.log(o);
}
function Wa(t) {
  if (typeof t == "boolean")
    return Number(t);
  const e = typeof t == "string" ? parseFloat(t) : t;
  if (typeof e != "number" || isNaN(e) || e < 0 || e > 1) {
    H && w.warn(
      `[Tracing] Given sample rate is invalid. Sample rate must be a boolean or a number between 0 and 1. Got ${JSON.stringify(
        t
      )} of type ${JSON.stringify(typeof t)}.`
    );
    return;
  }
  return e;
}
function Cx(t, e) {
  if (!pn(t))
    return [!1];
  let n;
  typeof t.tracesSampler == "function" ? n = t.tracesSampler(e) : e.parentSampled !== void 0 ? n = e.parentSampled : typeof t.tracesSampleRate < "u" ? n = t.tracesSampleRate : n = 1;
  const s = Wa(n);
  return s === void 0 ? (H && w.warn("[Tracing] Discarding transaction because of invalid sample rate."), [!1]) : s ? Math.random() < s ? [!0, s] : (H && w.log(
    `[Tracing] Discarding transaction because it's not included in the random sample (sampling rate = ${Number(
      n
    )})`
  ), [!1, s]) : (H && w.log(
    `[Tracing] Discarding transaction because ${typeof t.tracesSampler == "function" ? "tracesSampler returned 0 or false" : "a negative sampling decision was inherited or tracesSampleRate is set to 0"}`
  ), [!1, s]);
}
function Fx(t, e) {
  return e && (t.sdk = t.sdk || {}, t.sdk.name = t.sdk.name || e.name, t.sdk.version = t.sdk.version || e.version, t.sdk.integrations = [...t.sdk.integrations || [], ...e.integrations || []], t.sdk.packages = [...t.sdk.packages || [], ...e.packages || []]), t;
}
function kx(t, e, n, s) {
  const r = lh(n), i = {
    sent_at: (/* @__PURE__ */ new Date()).toISOString(),
    ...r && { sdk: r },
    ...!!s && e && { dsn: po(e) }
  }, o = "aggregates" in t ? [{ type: "sessions" }, t] : [{ type: "session" }, t.toJSON()];
  return Ps(i, [o]);
}
function Ax(t, e, n, s) {
  const r = lh(n), i = t.type && t.type !== "replay_event" ? t.type : "event";
  Fx(t, n && n.sdk);
  const o = Ay(t, r, s, e);
  return delete t.sdkProcessingMetadata, Ps(o, [[{ type: i }, t]]);
}
function Nx(t, e) {
  function n(d) {
    return !!d.trace_id && !!d.public_key;
  }
  const s = Zn(t[0]), r = e && e.getDsn(), i = e && e.getOptions().tunnel, o = {
    sent_at: (/* @__PURE__ */ new Date()).toISOString(),
    ...n(s) && { trace: s },
    ...!!i && r && { dsn: po(r) }
  }, a = e && e.getOptions().beforeSendSpan, c = a ? (d) => a(ne(d)) : (d) => ne(d), l = [];
  for (const d of t) {
    const u = c(d);
    u && l.push(qR(u));
  }
  return Ps(o, l);
}
function Lx(t, e, n, s = De()) {
  const r = s && Pe(s);
  r && r.addEvent(t, {
    [Nc]: e,
    [Ac]: n
  });
}
function Jf(t) {
  if (!t || t.length === 0)
    return;
  const e = {};
  return t.forEach((n) => {
    const s = n.attributes || {}, r = s[Ac], i = s[Nc];
    typeof r == "string" && typeof i == "number" && (e[n.name] = { value: i, unit: r });
  }), e;
}
const Qf = 1e3;
class mh {
  /** Epoch timestamp in seconds when the span started. */
  /** Epoch timestamp in seconds when the span ended. */
  /** Internal keeper of the status */
  /** The timed events added to this span. */
  /** if true, treat span as a standalone span (not part of a transaction) */
  /**
   * You should never call the constructor manually, always use `Sentry.startSpan()`
   * or other span methods.
   * @internal
   * @hideconstructor
   * @hidden
   */
  constructor(e = {}) {
    this._traceId = e.traceId || me(), this._spanId = e.spanId || me().substring(16), this._startTime = e.startTimestamp || qe(), this._attributes = {}, this.setAttributes({
      [Le]: "manual",
      [Fs]: e.op,
      ...e.attributes
    }), this._name = e.name, e.parentSpanId && (this._parentSpanId = e.parentSpanId), "sampled" in e && (this._sampled = e.sampled), e.endTimestamp && (this._endTime = e.endTimestamp), this._events = [], this._isStandaloneSpan = e.isStandalone, this._endTime && this._onSpanEnded();
  }
  /**
   * This should generally not be used,
   * but it is needed for being compliant with the OTEL Span interface.
   *
   * @hidden
   * @internal
   */
  addLink(e) {
    return this;
  }
  /**
   * This should generally not be used,
   * but it is needed for being compliant with the OTEL Span interface.
   *
   * @hidden
   * @internal
   */
  addLinks(e) {
    return this;
  }
  /**
   * This should generally not be used,
   * but it is needed for being compliant with the OTEL Span interface.
   *
   * @hidden
   * @internal
   */
  recordException(e, n) {
  }
  /** @inheritdoc */
  spanContext() {
    const { _spanId: e, _traceId: n, _sampled: s } = this;
    return {
      spanId: e,
      traceId: n,
      traceFlags: s ? My : Py
    };
  }
  /** @inheritdoc */
  setAttribute(e, n) {
    return n === void 0 ? delete this._attributes[e] : this._attributes[e] = n, this;
  }
  /** @inheritdoc */
  setAttributes(e) {
    return Object.keys(e).forEach((n) => this.setAttribute(n, e[n])), this;
  }
  /**
   * This should generally not be used,
   * but we need it for browser tracing where we want to adjust the start time afterwards.
   * USE THIS WITH CAUTION!
   *
   * @hidden
   * @internal
   */
  updateStartTime(e) {
    this._startTime = fs(e);
  }
  /**
   * @inheritDoc
   */
  setStatus(e) {
    return this._status = e, this;
  }
  /**
   * @inheritDoc
   */
  updateName(e) {
    return this._name = e, this;
  }
  /** @inheritdoc */
  end(e) {
    this._endTime || (this._endTime = fs(e), Ix(this), this._onSpanEnded());
  }
  /**
   * Get JSON representation of this span.
   *
   * @hidden
   * @internal This method is purely for internal purposes and should not be used outside
   * of SDK code. If you need to get a JSON representation of a span,
   * use `spanToJSON(span)` instead.
   */
  getSpanJSON() {
    return Ce({
      data: this._attributes,
      description: this._name,
      op: this._attributes[Fs],
      parent_span_id: this._parentSpanId,
      span_id: this._spanId,
      start_timestamp: this._startTime,
      status: Gy(this._status),
      timestamp: this._endTime,
      trace_id: this._traceId,
      origin: this._attributes[Le],
      _metrics_summary: Ed(this),
      profile_id: this._attributes[fx],
      exclusive_time: this._attributes[ph],
      measurements: Jf(this._events),
      is_segment: this._isStandaloneSpan && Pe(this) === this || void 0,
      segment_id: this._isStandaloneSpan ? Pe(this).spanContext().spanId : void 0
    });
  }
  /** @inheritdoc */
  isRecording() {
    return !this._endTime && !!this._sampled;
  }
  /**
   * @inheritdoc
   */
  addEvent(e, n, s) {
    H && w.log("[Tracing] Adding an event to span:", e);
    const r = Zf(n) ? n : s || qe(), i = Zf(n) ? {} : n || {}, o = {
      name: e,
      time: fs(r),
      attributes: i
    };
    return this._events.push(o), this;
  }
  /**
   * This method should generally not be used,
   * but for now we need a way to publicly check if the `_isStandaloneSpan` flag is set.
   * USE THIS WITH CAUTION!
   * @internal
   * @hidden
   * @experimental
   */
  isStandaloneSpan() {
    return !!this._isStandaloneSpan;
  }
  /** Emit `spanEnd` when the span is ended. */
  _onSpanEnded() {
    const e = J();
    if (e && e.emit("spanEnd", this), !(this._isStandaloneSpan || this === Pe(this)))
      return;
    if (this._isStandaloneSpan) {
      this._sampled ? xx(Nx([this], e)) : (H && w.log("[Tracing] Discarding standalone span because its trace was not chosen to be sampled."), e && e.recordDroppedEvent("sample_rate", "span"));
      return;
    }
    const s = this._convertSpanToTransaction();
    s && (Kf(this).scope || he()).captureEvent(s);
  }
  /**
   * Finish the transaction & prepare the event to send to Sentry.
   */
  _convertSpanToTransaction() {
    if (!em(ne(this)))
      return;
    this._name || (H && w.warn("Transaction has no name, falling back to `<unlabeled transaction>`."), this._name = "<unlabeled transaction>");
    const { scope: e, isolationScope: n } = Kf(this), r = (e || he()).getClient() || J();
    if (this._sampled !== !0) {
      H && w.log("[Tracing] Discarding transaction because its trace was not chosen to be sampled."), r && r.recordDroppedEvent("sample_rate", "transaction");
      return;
    }
    const o = ia(this).filter((u) => u !== this && !Rx(u)).map((u) => ne(u)).filter(em), a = this._attributes[Qt], c = {
      contexts: {
        trace: _x(this)
      },
      spans: (
        // spans.sort() mutates the array, but `spans` is already a copy so we can safely do this here
        // we do not use spans anymore after this point
        o.length > Qf ? o.sort((u, h) => u.start_timestamp - h.start_timestamp).slice(0, Qf) : o
      ),
      start_timestamp: this._startTime,
      timestamp: this._endTime,
      transaction: this._name,
      type: "transaction",
      sdkProcessingMetadata: {
        capturedSpanScope: e,
        capturedSpanIsolationScope: n,
        ...Ce({
          dynamicSamplingContext: Zn(this)
        })
      },
      _metrics_summary: Ed(this),
      ...a && {
        transaction_info: {
          source: a
        }
      }
    }, l = Jf(this._events);
    return l && Object.keys(l).length && (H && w.log(
      "[Measurements] Adding measurements to transaction event",
      JSON.stringify(l, void 0, 2)
    ), c.measurements = l), c;
  }
}
function Zf(t) {
  return t && typeof t == "number" || t instanceof Date || Array.isArray(t);
}
function em(t) {
  return !!t.start_timestamp && !!t.timestamp && !!t.span_id && !!t.trace_id;
}
function Rx(t) {
  return t instanceof mh && t.isStandaloneSpan();
}
function xx(t) {
  const e = J();
  if (!e)
    return;
  const n = t[1];
  if (!n || n.length === 0) {
    e.recordDroppedEvent("before_send", "span");
    return;
  }
  e.sendEnvelope(t);
}
const Hy = "__SENTRY_SUPPRESS_TRACING__";
function Ds(t) {
  const e = Wy();
  if (e.startInactiveSpan)
    return e.startInactiveSpan(t);
  const n = Px(t), { forceTransaction: s, parentSpan: r } = t;
  return (t.scope ? (o) => hh(t.scope, o) : r !== void 0 ? (o) => jy(r, o) : (o) => o())(() => {
    const o = he(), a = Dx(o);
    return t.onlyIfParent && !a ? new Jr() : Ox({
      parentSpan: a,
      spanArguments: n,
      forceTransaction: s,
      scope: o
    });
  });
}
function jy(t, e) {
  const n = Wy();
  return n.withActiveSpan ? n.withActiveSpan(t, e) : hh((s) => (Vi(s, t || void 0), e(s)));
}
function Ox({
  parentSpan: t,
  spanArguments: e,
  forceTransaction: n,
  scope: s
}) {
  if (!pn())
    return new Jr();
  const r = Et();
  let i;
  if (t && !n)
    i = Mx(t, s, e), By(t, i);
  else if (t) {
    const o = Zn(t), { traceId: a, spanId: c } = t.spanContext(), l = Ms(t);
    i = tm(
      {
        traceId: a,
        parentSpanId: c,
        ...e
      },
      s,
      l
    ), Xf(i, o);
  } else {
    const {
      traceId: o,
      dsc: a,
      parentSpanId: c,
      sampled: l
    } = {
      ...r.getPropagationContext(),
      ...s.getPropagationContext()
    };
    i = tm(
      {
        traceId: o,
        parentSpanId: c,
        ...e
      },
      s,
      l
    ), a && Xf(i, a);
  }
  return Tx(i), wx(i, s, r), i;
}
function Px(t) {
  const n = {
    isStandalone: (t.experimental || {}).standalone,
    ...t
  };
  if (t.startTime) {
    const s = { ...n };
    return s.startTimestamp = fs(t.startTime), delete s.startTime, s;
  }
  return n;
}
function Wy() {
  const t = Xr();
  return mo(t);
}
function tm(t, e, n) {
  const s = J(), r = s && s.getOptions() || {}, { name: i = "", attributes: o } = t, [a, c] = e.getScopeData().sdkProcessingMetadata[Hy] ? [!1] : Cx(r, {
    name: i,
    parentSampled: n,
    attributes: o,
    transactionContext: {
      name: i,
      parentSampled: n
    }
  }), l = new mh({
    ...t,
    attributes: {
      [Qt]: "custom",
      ...t.attributes
    },
    sampled: a
  });
  return c !== void 0 && l.setAttribute(Ry, c), s && s.emit("spanStart", l), l;
}
function Mx(t, e, n) {
  const { spanId: s, traceId: r } = t.spanContext(), i = e.getScopeData().sdkProcessingMetadata[Hy] ? !1 : Ms(t), o = i ? new mh({
    ...n,
    parentSpanId: s,
    traceId: r,
    sampled: i
  }) : new Jr({ traceId: r });
  By(t, o);
  const a = J();
  return a && (a.emit("spanStart", o), n.endTimestamp && a.emit("spanEnd", o)), o;
}
function Dx(t) {
  const e = ja(t);
  if (!e)
    return;
  const n = J();
  return (n ? n.getOptions() : {}).parentSpanIsAlwaysRootSpan ? Pe(e) : e;
}
const oa = {
  idleTimeout: 1e3,
  finalTimeout: 3e4,
  childSpanTimeout: 15e3
}, Gx = "heartbeatFailed", Bx = "idleTimeout", $x = "finalTimeout", Vx = "externalFinish";
function zy(t, e = {}) {
  const n = /* @__PURE__ */ new Map();
  let s = !1, r, i = Vx, o = !e.disableAutoFinish;
  const a = [], {
    idleTimeout: c = oa.idleTimeout,
    finalTimeout: l = oa.finalTimeout,
    childSpanTimeout: d = oa.childSpanTimeout,
    beforeSpanEnd: u
  } = e, h = J();
  if (!h || !pn())
    return new Jr();
  const p = he(), f = De(), m = Ux(t);
  m.end = new Proxy(m.end, {
    apply(_, E, C) {
      u && u(m);
      const [N, ...v] = C, k = N || qe(), L = fs(k), $ = ia(m).filter((q) => q !== m);
      if (!$.length)
        return F(L), Reflect.apply(_, E, [L, ...v]);
      const ee = $.map((q) => ne(q).timestamp).filter((q) => !!q), pe = ee.length ? Math.max(...ee) : void 0, R = ne(m).start_timestamp, re = Math.min(
        R ? R + l / 1e3 : 1 / 0,
        Math.max(R || -1 / 0, Math.min(L, pe || 1 / 0))
      );
      return F(re), Reflect.apply(_, E, [re, ...v]);
    }
  });
  function g() {
    r && (clearTimeout(r), r = void 0);
  }
  function y(_) {
    g(), r = setTimeout(() => {
      !s && n.size === 0 && o && (i = Bx, m.end(_));
    }, c);
  }
  function I(_) {
    r = setTimeout(() => {
      !s && o && (i = Gx, m.end(_));
    }, d);
  }
  function A(_) {
    g(), n.set(_, !0);
    const E = qe();
    I(E + d / 1e3);
  }
  function T(_) {
    if (n.has(_) && n.delete(_), n.size === 0) {
      const E = qe();
      y(E + c / 1e3);
    }
  }
  function F(_) {
    s = !0, n.clear(), a.forEach((L) => L()), Vi(p, f);
    const E = ne(m), { start_timestamp: C } = E;
    if (!C)
      return;
    (E.data || {})[bd] || m.setAttribute(bd, i), w.log(`[Tracing] Idle span "${E.op}" finished`);
    const v = ia(m).filter((L) => L !== m);
    let k = 0;
    v.forEach((L) => {
      L.isRecording() && (L.setStatus({ code: ke, message: "cancelled" }), L.end(_), H && w.log("[Tracing] Cancelling span since span ended early", JSON.stringify(L, void 0, 2)));
      const $ = ne(L), { timestamp: ee = 0, start_timestamp: pe = 0 } = $, R = pe <= _, re = (l + c) / 1e3, q = ee - pe <= re;
      if (H) {
        const ge = JSON.stringify(L, void 0, 2);
        R ? q || w.log("[Tracing] Discarding span since it finished after idle span final timeout", ge) : w.log("[Tracing] Discarding span since it happened after idle span was finished", ge);
      }
      (!q || !R) && (vx(m, L), k++);
    }), k > 0 && m.setAttribute("sentry.idle_span_discarded_spans", k);
  }
  return a.push(
    h.on("spanStart", (_) => {
      if (s || _ === m || ne(_).timestamp)
        return;
      ia(m).includes(_) && A(_.spanContext().spanId);
    })
  ), a.push(
    h.on("spanEnd", (_) => {
      s || T(_.spanContext().spanId);
    })
  ), a.push(
    h.on("idleSpanEnableAutoFinish", (_) => {
      _ === m && (o = !0, y(), n.size && I());
    })
  ), e.disableAutoFinish || y(), setTimeout(() => {
    s || (m.setStatus({ code: ke, message: "deadline_exceeded" }), i = $x, m.end());
  }, l), m;
}
function Ux(t) {
  const e = Ds(t);
  return Vi(he(), e), H && w.log("[Tracing] Started span is an idle span"), e;
}
function wd(t, e, n, s = 0) {
  return new dt((r, i) => {
    const o = t[s];
    if (e === null || typeof o != "function")
      r(e);
    else {
      const a = o({ ...e }, n);
      H && o.id && a === null && w.log(`Event processor "${o.id}" dropped event`), Fc(a) ? a.then((c) => wd(t, c, n, s + 1).then(r)).then(null, i) : wd(t, a, n, s + 1).then(r).then(null, i);
    }
  });
}
function Hx(t, e) {
  const { fingerprint: n, span: s, breadcrumbs: r, sdkProcessingMetadata: i } = e;
  jx(t, e), s && qx(t, s), Yx(t, n), Wx(t, r), zx(t, i);
}
function nm(t, e) {
  const {
    extra: n,
    tags: s,
    user: r,
    contexts: i,
    level: o,
    sdkProcessingMetadata: a,
    breadcrumbs: c,
    fingerprint: l,
    eventProcessors: d,
    attachments: u,
    propagationContext: h,
    transactionName: p,
    span: f
  } = e;
  ci(t, "extra", n), ci(t, "tags", s), ci(t, "user", r), ci(t, "contexts", i), ci(t, "sdkProcessingMetadata", a), o && (t.level = o), p && (t.transactionName = p), f && (t.span = f), c.length && (t.breadcrumbs = [...t.breadcrumbs, ...c]), l.length && (t.fingerprint = [...t.fingerprint, ...l]), d.length && (t.eventProcessors = [...t.eventProcessors, ...d]), u.length && (t.attachments = [...t.attachments, ...u]), t.propagationContext = { ...t.propagationContext, ...h };
}
function ci(t, e, n) {
  if (n && Object.keys(n).length) {
    t[e] = { ...t[e] };
    for (const s in n)
      Object.prototype.hasOwnProperty.call(n, s) && (t[e][s] = n[s]);
  }
}
function jx(t, e) {
  const { extra: n, tags: s, user: r, contexts: i, level: o, transactionName: a } = e, c = Ce(n);
  c && Object.keys(c).length && (t.extra = { ...c, ...t.extra });
  const l = Ce(s);
  l && Object.keys(l).length && (t.tags = { ...l, ...t.tags });
  const d = Ce(r);
  d && Object.keys(d).length && (t.user = { ...d, ...t.user });
  const u = Ce(i);
  u && Object.keys(u).length && (t.contexts = { ...u, ...t.contexts }), o && (t.level = o), a && t.type !== "transaction" && (t.transaction = a);
}
function Wx(t, e) {
  const n = [...t.breadcrumbs || [], ...e];
  t.breadcrumbs = n.length ? n : void 0;
}
function zx(t, e) {
  t.sdkProcessingMetadata = {
    ...t.sdkProcessingMetadata,
    ...e
  };
}
function qx(t, e) {
  t.contexts = {
    trace: yx(e),
    ...t.contexts
  }, t.sdkProcessingMetadata = {
    dynamicSamplingContext: Zn(e),
    ...t.sdkProcessingMetadata
  };
  const n = Pe(e), s = ne(n).description;
  s && !t.transaction && t.type === "transaction" && (t.transaction = s);
}
function Yx(t, e) {
  t.fingerprint = t.fingerprint ? Ty(t.fingerprint) : [], e && (t.fingerprint = t.fingerprint.concat(e)), t.fingerprint && !t.fingerprint.length && delete t.fingerprint;
}
function qy(t, e, n, s, r, i) {
  const { normalizeDepth: o = 3, normalizeMaxBreadth: a = 1e3 } = t, c = {
    ...e,
    event_id: e.event_id || n.event_id || me(),
    timestamp: e.timestamp || fo()
  }, l = n.integrations || t.integrations.map((g) => g.name);
  Kx(c, t), Qx(c, l), r && r.emit("applyFrameMetadata", e), e.type === void 0 && Xx(c, t.stackParser);
  const d = eO(s, n.captureContext);
  n.mechanism && $i(c, n.mechanism);
  const u = r ? r.getEventProcessors() : [], h = hx().getScopeData();
  if (i) {
    const g = i.getScopeData();
    nm(h, g);
  }
  if (d) {
    const g = d.getScopeData();
    nm(h, g);
  }
  const p = [...n.attachments || [], ...h.attachments];
  p.length && (n.attachments = p), Hx(c, h);
  const f = [
    ...u,
    // Run scope event processors _after_ all other processors
    ...h.eventProcessors
  ];
  return wd(f, c, n).then((g) => (g && Jx(g), typeof o == "number" && o > 0 ? Zx(g, o, a) : g));
}
function Kx(t, e) {
  const { environment: n, release: s, dist: r, maxValueLength: i = 250 } = e;
  "environment" in t || (t.environment = "environment" in e ? n : fh), t.release === void 0 && s !== void 0 && (t.release = s), t.dist === void 0 && r !== void 0 && (t.dist = r), t.message && (t.message = pr(t.message, i));
  const o = t.exception && t.exception.values && t.exception.values[0];
  o && o.value && (o.value = pr(o.value, i));
  const a = t.request;
  a && a.url && (a.url = pr(a.url, i));
}
const sm = /* @__PURE__ */ new WeakMap();
function Xx(t, e) {
  const n = Z._sentryDebugIds;
  if (!n)
    return;
  let s;
  const r = sm.get(e);
  r ? s = r : (s = /* @__PURE__ */ new Map(), sm.set(e, s));
  const i = Object.entries(n).reduce(
    (o, [a, c]) => {
      let l;
      const d = s.get(a);
      d ? l = d : (l = e(a), s.set(a, l));
      for (let u = l.length - 1; u >= 0; u--) {
        const h = l[u];
        if (h.filename) {
          o[h.filename] = c;
          break;
        }
      }
      return o;
    },
    {}
  );
  try {
    t.exception.values.forEach((o) => {
      o.stacktrace.frames.forEach((a) => {
        a.filename && (a.debug_id = i[a.filename]);
      });
    });
  } catch {
  }
}
function Jx(t) {
  const e = {};
  try {
    t.exception.values.forEach((s) => {
      s.stacktrace.frames.forEach((r) => {
        r.debug_id && (r.abs_path ? e[r.abs_path] = r.debug_id : r.filename && (e[r.filename] = r.debug_id), delete r.debug_id);
      });
    });
  } catch {
  }
  if (Object.keys(e).length === 0)
    return;
  t.debug_meta = t.debug_meta || {}, t.debug_meta.images = t.debug_meta.images || [];
  const n = t.debug_meta.images;
  Object.entries(e).forEach(([s, r]) => {
    n.push({
      type: "sourcemap",
      code_file: s,
      debug_id: r
    });
  });
}
function Qx(t, e) {
  e.length > 0 && (t.sdk = t.sdk || {}, t.sdk.integrations = [...t.sdk.integrations || [], ...e]);
}
function Zx(t, e, n) {
  if (!t)
    return null;
  const s = {
    ...t,
    ...t.breadcrumbs && {
      breadcrumbs: t.breadcrumbs.map((r) => ({
        ...r,
        ...r.data && {
          data: Rt(r.data, e, n)
        }
      }))
    },
    ...t.user && {
      user: Rt(t.user, e, n)
    },
    ...t.contexts && {
      contexts: Rt(t.contexts, e, n)
    },
    ...t.extra && {
      extra: Rt(t.extra, e, n)
    }
  };
  return t.contexts && t.contexts.trace && s.contexts && (s.contexts.trace = t.contexts.trace, t.contexts.trace.data && (s.contexts.trace.data = Rt(t.contexts.trace.data, e, n))), t.spans && (s.spans = t.spans.map((r) => ({
    ...r,
    ...r.data && {
      data: Rt(r.data, e, n)
    }
  }))), s;
}
function eO(t, e) {
  if (!e)
    return t;
  const n = t ? t.clone() : new Cs();
  return n.update(e), n;
}
function Yy(t, e) {
  return he().captureException(t, void 0);
}
function Ky(t, e) {
  return he().captureEvent(t, e);
}
function tO(t, e) {
  Et().setContext(t, e);
}
function nO(t) {
  Et().addEventProcessor(t);
}
function rm(t) {
  const e = J(), n = Et(), s = he(), { release: r, environment: i = fh } = e && e.getOptions() || {}, { userAgent: o } = Z.navigator || {}, a = nx({
    release: r,
    environment: i,
    user: s.getUser() || n.getUser(),
    ...o && { userAgent: o },
    ...t
  }), c = n.getSession();
  return c && c.status === "ok" && Nr(c, { status: "exited" }), Xy(), n.setSession(a), s.setSession(a), a;
}
function Xy() {
  const t = Et(), e = he(), n = e.getSession() || t.getSession();
  n && sx(n), Jy(), t.setSession(), e.setSession();
}
function Jy() {
  const t = Et(), e = he(), n = J(), s = e.getSession() || t.getSession();
  s && n && n.captureSession(s);
}
function im(t = !1) {
  if (t) {
    Xy();
    return;
  }
  Jy();
}
const sO = "7";
function rO(t) {
  const e = t.protocol ? `${t.protocol}:` : "", n = t.port ? `:${t.port}` : "";
  return `${e}//${t.host}${n}${t.path ? `/${t.path}` : ""}/api/`;
}
function iO(t) {
  return `${rO(t)}${t.projectId}/envelope/`;
}
function oO(t, e) {
  return uR({
    // We send only the minimum set of required information. See
    // https://github.com/getsentry/sentry-javascript/issues/2572.
    sentry_key: t.publicKey,
    sentry_version: sO,
    ...e && { sentry_client: `${e.name}/${e.version}` }
  });
}
function aO(t, e, n) {
  return e || `${iO(t)}?${oO(t, n)}`;
}
const om = [];
function cO(t) {
  const e = {};
  return t.forEach((n) => {
    const { name: s } = n, r = e[s];
    r && !r.isDefaultInstance && n.isDefaultInstance || (e[s] = n);
  }), Object.values(e);
}
function lO(t) {
  const e = t.defaultIntegrations || [], n = t.integrations;
  e.forEach((o) => {
    o.isDefaultInstance = !0;
  });
  let s;
  Array.isArray(n) ? s = [...e, ...n] : typeof n == "function" ? s = Ty(n(e)) : s = e;
  const r = cO(s), i = r.findIndex((o) => o.name === "Debug");
  if (i > -1) {
    const [o] = r.splice(i, 1);
    r.push(o);
  }
  return r;
}
function dO(t, e) {
  const n = {};
  return e.forEach((s) => {
    s && Qy(t, s, n);
  }), n;
}
function am(t, e) {
  for (const n of e)
    n && n.afterAllSetup && n.afterAllSetup(t);
}
function Qy(t, e, n) {
  if (n[e.name]) {
    H && w.log(`Integration skipped because it was already installed: ${e.name}`);
    return;
  }
  if (n[e.name] = e, om.indexOf(e.name) === -1 && typeof e.setupOnce == "function" && (e.setupOnce(), om.push(e.name)), e.setup && typeof e.setup == "function" && e.setup(t), typeof e.preprocessEvent == "function") {
    const s = e.preprocessEvent.bind(e);
    t.on("preprocessEvent", (r, i) => s(r, i, t));
  }
  if (typeof e.processEvent == "function") {
    const s = e.processEvent.bind(e), r = Object.assign((i, o) => s(i, o, t), {
      id: e.name
    });
    t.addEventProcessor(r);
  }
  H && w.log(`Integration installed: ${e.name}`);
}
const cm = "Not capturing exception because it's already been captured.";
class uO {
  /** Options passed to the SDK. */
  /** The client Dsn, if specified in options. Without this Dsn, the SDK will be disabled. */
  /** Array of set up integrations. */
  /** Number of calls being processed */
  /** Holds flushable  */
  // eslint-disable-next-line @typescript-eslint/ban-types
  /**
   * Initializes this client instance.
   *
   * @param options Options for the client.
   */
  constructor(e) {
    if (this._options = e, this._integrations = {}, this._numProcessing = 0, this._outcomes = {}, this._hooks = {}, this._eventProcessors = [], e.dsn ? this._dsn = dR(e.dsn) : H && w.warn("No DSN provided, client will not send events."), this._dsn) {
      const n = aO(
        this._dsn,
        e.tunnel,
        e._metadata ? e._metadata.sdk : void 0
      );
      this._transport = e.transport({
        tunnel: this._options.tunnel,
        recordDroppedEvent: this.recordDroppedEvent.bind(this),
        ...e.transportOptions,
        url: n
      });
    }
  }
  /**
   * @inheritDoc
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  captureException(e, n, s) {
    const r = me();
    if (Uf(e))
      return H && w.log(cm), r;
    const i = {
      event_id: r,
      ...n
    };
    return this._process(
      this.eventFromException(e, i).then(
        (o) => this._captureEvent(o, i, s)
      )
    ), i.event_id;
  }
  /**
   * @inheritDoc
   */
  captureMessage(e, n, s, r) {
    const i = {
      event_id: me(),
      ...s
    }, o = rh(e) ? e : String(e), a = ih(e) ? this.eventFromMessage(o, n, i) : this.eventFromException(e, i);
    return this._process(a.then((c) => this._captureEvent(c, i, r))), i.event_id;
  }
  /**
   * @inheritDoc
   */
  captureEvent(e, n, s) {
    const r = me();
    if (n && n.originalException && Uf(n.originalException))
      return H && w.log(cm), r;
    const i = {
      event_id: r,
      ...n
    }, a = (e.sdkProcessingMetadata || {}).capturedSpanScope;
    return this._process(this._captureEvent(e, i, a || s)), i.event_id;
  }
  /**
   * @inheritDoc
   */
  captureSession(e) {
    typeof e.release != "string" ? H && w.warn("Discarded session because of missing or non-string release") : (this.sendSession(e), Nr(e, { init: !1 }));
  }
  /**
   * @inheritDoc
   */
  getDsn() {
    return this._dsn;
  }
  /**
   * @inheritDoc
   */
  getOptions() {
    return this._options;
  }
  /**
   * @see SdkMetadata in @sentry/types
   *
   * @return The metadata of the SDK
   */
  getSdkMetadata() {
    return this._options._metadata;
  }
  /**
   * @inheritDoc
   */
  getTransport() {
    return this._transport;
  }
  /**
   * @inheritDoc
   */
  flush(e) {
    const n = this._transport;
    return n ? (this.emit("flush"), this._isClientDoneProcessing(e).then((s) => n.flush(e).then((r) => s && r))) : hn(!0);
  }
  /**
   * @inheritDoc
   */
  close(e) {
    return this.flush(e).then((n) => (this.getOptions().enabled = !1, this.emit("close"), n));
  }
  /** Get all installed event processors. */
  getEventProcessors() {
    return this._eventProcessors;
  }
  /** @inheritDoc */
  addEventProcessor(e) {
    this._eventProcessors.push(e);
  }
  /** @inheritdoc */
  init() {
    (this._isEnabled() || // Force integrations to be setup even if no DSN was set when we have
    // Spotlight enabled. This is particularly important for browser as we
    // don't support the `spotlight` option there and rely on the users
    // adding the `spotlightBrowserIntegration()` to their integrations which
    // wouldn't get initialized with the check below when there's no DSN set.
    this._options.integrations.some(({ name: e }) => e.startsWith("Spotlight"))) && this._setupIntegrations();
  }
  /**
   * Gets an installed integration by its name.
   *
   * @returns The installed integration or `undefined` if no integration with that `name` was installed.
   */
  getIntegrationByName(e) {
    return this._integrations[e];
  }
  /**
   * @inheritDoc
   */
  addIntegration(e) {
    const n = this._integrations[e.name];
    Qy(this, e, this._integrations), n || am(this, [e]);
  }
  /**
   * @inheritDoc
   */
  sendEvent(e, n = {}) {
    this.emit("beforeSendEvent", e, n);
    let s = Ax(e, this._dsn, this._options._metadata, this._options.tunnel);
    for (const i of n.attachments || [])
      s = jR(s, YR(i));
    const r = this.sendEnvelope(s);
    r && r.then((i) => this.emit("afterSendEvent", e, i), null);
  }
  /**
   * @inheritDoc
   */
  sendSession(e) {
    const n = kx(e, this._dsn, this._options._metadata, this._options.tunnel);
    this.sendEnvelope(n);
  }
  /**
   * @inheritDoc
   */
  recordDroppedEvent(e, n, s) {
    if (this._options.sendClientReports) {
      const r = typeof s == "number" ? s : 1, i = `${e}:${n}`;
      H && w.log(`Recording outcome: "${i}"${r > 1 ? ` (${r} times)` : ""}`), this._outcomes[i] = (this._outcomes[i] || 0) + r;
    }
  }
  // Keep on() & emit() signatures in sync with types' client.ts interface
  /* eslint-disable @typescript-eslint/unified-signatures */
  /** @inheritdoc */
  /** @inheritdoc */
  on(e, n) {
    const s = this._hooks[e] = this._hooks[e] || [];
    return s.push(n), () => {
      const r = s.indexOf(n);
      r > -1 && s.splice(r, 1);
    };
  }
  /** @inheritdoc */
  /** @inheritdoc */
  emit(e, ...n) {
    const s = this._hooks[e];
    s && s.forEach((r) => r(...n));
  }
  /**
   * @inheritdoc
   */
  sendEnvelope(e) {
    return this.emit("beforeEnvelope", e), this._isEnabled() && this._transport ? this._transport.send(e).then(null, (n) => (H && w.error("Error while sending envelope:", n), n)) : (H && w.error("Transport disabled"), hn({}));
  }
  /* eslint-enable @typescript-eslint/unified-signatures */
  /** Setup integrations for this client. */
  _setupIntegrations() {
    const { integrations: e } = this._options;
    this._integrations = dO(this, e), am(this, e);
  }
  /** Updates existing session based on the provided event */
  _updateSessionFromEvent(e, n) {
    let s = !1, r = !1;
    const i = n.exception && n.exception.values;
    if (i) {
      r = !0;
      for (const c of i) {
        const l = c.mechanism;
        if (l && l.handled === !1) {
          s = !0;
          break;
        }
      }
    }
    const o = e.status === "ok";
    (o && e.errors === 0 || o && s) && (Nr(e, {
      ...s && { status: "crashed" },
      errors: e.errors || Number(r || s)
    }), this.captureSession(e));
  }
  /**
   * Determine if the client is finished processing. Returns a promise because it will wait `timeout` ms before saying
   * "no" (resolving to `false`) in order to give the client a chance to potentially finish first.
   *
   * @param timeout The time, in ms, after which to resolve to `false` if the client is still busy. Passing `0` (or not
   * passing anything) will make the promise wait as long as it takes for processing to finish before resolving to
   * `true`.
   * @returns A promise which will resolve to `true` if processing is already done or finishes before the timeout, and
   * `false` otherwise
   */
  _isClientDoneProcessing(e) {
    return new dt((n) => {
      let s = 0;
      const r = 1, i = setInterval(() => {
        this._numProcessing == 0 ? (clearInterval(i), n(!0)) : (s += r, e && s >= e && (clearInterval(i), n(!1)));
      }, r);
    });
  }
  /** Determines whether this SDK is enabled and a transport is present. */
  _isEnabled() {
    return this.getOptions().enabled !== !1 && this._transport !== void 0;
  }
  /**
   * Adds common information to events.
   *
   * The information includes release and environment from `options`,
   * breadcrumbs and context (extra, tags and user) from the scope.
   *
   * Information that is already present in the event is never overwritten. For
   * nested objects, such as the context, keys are merged.
   *
   * @param event The original event.
   * @param hint May contain additional information about the original exception.
   * @param currentScope A scope containing event metadata.
   * @returns A new event with more information.
   */
  _prepareEvent(e, n, s, r = Et()) {
    const i = this.getOptions(), o = Object.keys(this._integrations);
    return !n.integrations && o.length > 0 && (n.integrations = o), this.emit("preprocessEvent", e, n), e.type || r.setLastEventId(e.event_id || n.event_id), qy(i, e, n, s, this, r).then((a) => {
      if (a === null)
        return a;
      const c = {
        ...r.getPropagationContext(),
        ...s ? s.getPropagationContext() : void 0
      };
      if (!(a.contexts && a.contexts.trace) && c) {
        const { traceId: d, spanId: u, parentSpanId: h, dsc: p } = c;
        a.contexts = {
          trace: Ce({
            trace_id: d,
            span_id: u,
            parent_span_id: h
          }),
          ...a.contexts
        };
        const f = p || Lc(d, this);
        a.sdkProcessingMetadata = {
          dynamicSamplingContext: f,
          ...a.sdkProcessingMetadata
        };
      }
      return a;
    });
  }
  /**
   * Processes the event and logs an error in case of rejection
   * @param event
   * @param hint
   * @param scope
   */
  _captureEvent(e, n = {}, s) {
    return this._processEvent(e, n, s).then(
      (r) => r.event_id,
      (r) => {
        if (H) {
          const i = r;
          i.logLevel === "log" ? w.log(i.message) : w.warn(i);
        }
      }
    );
  }
  /**
   * Processes an event (either error or message) and sends it to Sentry.
   *
   * This also adds breadcrumbs and context information to the event. However,
   * platform specific meta data (such as the User's IP address) must be added
   * by the SDK implementor.
   *
   *
   * @param event The event to send to Sentry.
   * @param hint May contain additional information about the original exception.
   * @param currentScope A scope containing event metadata.
   * @returns A SyncPromise that resolves with the event or rejects in case event was/will not be send.
   */
  _processEvent(e, n, s) {
    const r = this.getOptions(), { sampleRate: i } = r, o = eE(e), a = Zy(e), c = e.type || "error", l = `before send for type \`${c}\``, d = typeof i > "u" ? void 0 : Wa(i);
    if (a && typeof d == "number" && Math.random() > d)
      return this.recordDroppedEvent("sample_rate", "error", e), Ua(
        new xt(
          `Discarding event because it's not included in the random sample (sampling rate = ${i})`,
          "log"
        )
      );
    const u = c === "replay_event" ? "replay" : c, p = (e.sdkProcessingMetadata || {}).capturedSpanIsolationScope;
    return this._prepareEvent(e, n, s, p).then((f) => {
      if (f === null)
        throw this.recordDroppedEvent("event_processor", u, e), new xt("An event processor returned `null`, will not send event.", "log");
      if (n.data && n.data.__sentry__ === !0)
        return f;
      const g = pO(this, r, f, n);
      return hO(g, l);
    }).then((f) => {
      if (f === null) {
        if (this.recordDroppedEvent("before_send", u, e), o) {
          const I = 1 + (e.spans || []).length;
          this.recordDroppedEvent("before_send", "span", I);
        }
        throw new xt(`${l} returned \`null\`, will not send event.`, "log");
      }
      const m = s && s.getSession();
      if (!o && m && this._updateSessionFromEvent(m, f), o) {
        const y = f.sdkProcessingMetadata && f.sdkProcessingMetadata.spanCountBeforeProcessing || 0, I = f.spans ? f.spans.length : 0, A = y - I;
        A > 0 && this.recordDroppedEvent("before_send", "span", A);
      }
      const g = f.transaction_info;
      if (o && g && f.transaction !== e.transaction) {
        const y = "custom";
        f.transaction_info = {
          ...g,
          source: y
        };
      }
      return this.sendEvent(f, n), f;
    }).then(null, (f) => {
      throw f instanceof xt ? f : (this.captureException(f, {
        data: {
          __sentry__: !0
        },
        originalException: f
      }), new xt(
        `Event processing pipeline threw an error, original event will not be sent. Details have been sent as a new event.
Reason: ${f}`
      ));
    });
  }
  /**
   * Occupies the client with processing and event
   */
  _process(e) {
    this._numProcessing++, e.then(
      (n) => (this._numProcessing--, n),
      (n) => (this._numProcessing--, n)
    );
  }
  /**
   * Clears outcomes on this client and returns them.
   */
  _clearOutcomes() {
    const e = this._outcomes;
    return this._outcomes = {}, Object.entries(e).map(([n, s]) => {
      const [r, i] = n.split(":");
      return {
        reason: r,
        category: i,
        quantity: s
      };
    });
  }
  /**
   * Sends client reports as an envelope.
   */
  _flushOutcomes() {
    H && w.log("Flushing outcomes...");
    const e = this._clearOutcomes();
    if (e.length === 0) {
      H && w.log("No outcomes to send");
      return;
    }
    if (!this._dsn) {
      H && w.log("No dsn provided, will not send outcomes");
      return;
    }
    H && w.log("Sending outcomes:", e);
    const n = XR(e, this._options.tunnel && po(this._dsn));
    this.sendEnvelope(n);
  }
  /**
   * @inheritDoc
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
}
function hO(t, e) {
  const n = `${e} must return \`null\` or a valid event.`;
  if (Fc(t))
    return t.then(
      (s) => {
        if (!Ar(s) && s !== null)
          throw new xt(n);
        return s;
      },
      (s) => {
        throw new xt(`${e} rejected with ${s}`);
      }
    );
  if (!Ar(t) && t !== null)
    throw new xt(n);
  return t;
}
function pO(t, e, n, s) {
  const { beforeSend: r, beforeSendTransaction: i, beforeSendSpan: o } = e;
  if (Zy(n) && r)
    return r(n, s);
  if (eE(n)) {
    if (n.spans && o) {
      const a = [];
      for (const c of n.spans) {
        const l = o(c);
        l ? a.push(l) : t.recordDroppedEvent("before_send", "span");
      }
      n.spans = a;
    }
    if (i) {
      if (n.spans) {
        const a = n.spans.length;
        n.sdkProcessingMetadata = {
          ...n.sdkProcessingMetadata,
          spanCountBeforeProcessing: a
        };
      }
      return i(n, s);
    }
  }
  return n;
}
function Zy(t) {
  return t.type === void 0;
}
function eE(t) {
  return t.type === "transaction";
}
function fO(t, e) {
  e.debug === !0 && (H ? w.enable() : Kr(() => {
    console.warn("[Sentry] Cannot initialize SDK with `debug` option using a non-debug bundle.");
  })), he().update(e.initialScope);
  const s = new t(e);
  return mO(s), s.init(), s;
}
function mO(t) {
  he().setClient(t);
}
const gO = 64;
function _O(t, e, n = PR(
  t.bufferSize || gO
)) {
  let s = {};
  const r = (o) => n.drain(o);
  function i(o) {
    const a = [];
    if (jf(o, (u, h) => {
      const p = Wf(h);
      if (Ny(s, p)) {
        const f = lm(u, h);
        t.recordDroppedEvent("ratelimit_backoff", p, f);
      } else
        a.push(u);
    }), a.length === 0)
      return hn({});
    const c = Ps(o[0], a), l = (u) => {
      jf(c, (h, p) => {
        const f = lm(h, p);
        t.recordDroppedEvent(u, Wf(p), f);
      });
    }, d = () => e({ body: WR(c) }).then(
      (u) => (u.statusCode !== void 0 && (u.statusCode < 200 || u.statusCode >= 300) && H && w.warn(`Sentry responded with status code ${u.statusCode} to sent event.`), s = Ly(s, u), u),
      (u) => {
        throw l("network_error"), u;
      }
    );
    return n.add(d).then(
      (u) => u,
      (u) => {
        if (u instanceof xt)
          return H && w.error("Skipped sending event because buffer is full."), l("queue_overflow"), hn({});
        throw u;
      }
    );
  }
  return {
    send: i,
    flush: r
  };
}
function lm(t, e) {
  if (!(e !== "event" && e !== "transaction"))
    return Array.isArray(t) ? t[1] : void 0;
}
function yO(t, e) {
  const n = e && e.getDsn(), s = e && e.getOptions().tunnel;
  return bO(t, n) || EO(t, s);
}
function EO(t, e) {
  return e ? dm(t) === dm(e) : !1;
}
function bO(t, e) {
  return e ? t.includes(e.host) : !1;
}
function dm(t) {
  return t[t.length - 1] === "/" ? t.slice(0, -1) : t;
}
function vO(t, e, n = [e], s = "npm") {
  const r = t._metadata || {};
  r.sdk || (r.sdk = {
    name: `sentry.javascript.${e}`,
    packages: n.map((i) => ({
      name: `${s}:@sentry/${i}`,
      version: hs
    })),
    version: hs
  }), t._metadata = r;
}
const SO = 100;
function Wn(t, e) {
  const n = J(), s = Et();
  if (!n) return;
  const { beforeBreadcrumb: r = null, maxBreadcrumbs: i = SO } = n.getOptions();
  if (i <= 0) return;
  const a = { timestamp: fo(), ...t }, c = r ? Kr(() => r(a, e)) : a;
  c !== null && (n.emit && n.emit("beforeAddBreadcrumb", c, e), s.addBreadcrumb(c, i));
}
let um;
const wO = "FunctionToString", hm = /* @__PURE__ */ new WeakMap(), TO = () => ({
  name: wO,
  setupOnce() {
    um = Function.prototype.toString;
    try {
      Function.prototype.toString = function(...t) {
        const e = oh(this), n = hm.has(J()) && e !== void 0 ? e : this;
        return um.apply(n, t);
      };
    } catch {
    }
  },
  setup(t) {
    hm.set(t, !0);
  }
}), IO = TO, CO = [
  /^Script error\.?$/,
  /^Javascript error: Script error\.? on line 0$/,
  /^ResizeObserver loop completed with undelivered notifications.$/,
  // The browser logs this when a ResizeObserver handler takes a bit longer. Usually this is not an actual issue though. It indicates slowness.
  /^Cannot redefine property: googletag$/,
  // This is thrown when google tag manager is used in combination with an ad blocker
  "undefined is not an object (evaluating 'a.L')",
  // Random error that happens but not actionable or noticeable to end-users.
  `can't redefine non-configurable property "solana"`,
  // Probably a browser extension or custom browser (Brave) throwing this error
  "vv().getRestrictions is not a function. (In 'vv().getRestrictions(1,a)', 'vv().getRestrictions' is undefined)",
  // Error thrown by GTM, seemingly not affecting end-users
  "Can't find variable: _AutofillCallbackHandler"
  // Unactionable error in instagram webview https://developers.facebook.com/community/threads/320013549791141/
], FO = "InboundFilters", kO = (t = {}) => ({
  name: FO,
  processEvent(e, n, s) {
    const r = s.getOptions(), i = NO(t, r);
    return LO(e, i) ? null : e;
  }
}), AO = kO;
function NO(t = {}, e = {}) {
  return {
    allowUrls: [...t.allowUrls || [], ...e.allowUrls || []],
    denyUrls: [...t.denyUrls || [], ...e.denyUrls || []],
    ignoreErrors: [
      ...t.ignoreErrors || [],
      ...e.ignoreErrors || [],
      ...t.disableErrorDefaults ? [] : CO
    ],
    ignoreTransactions: [...t.ignoreTransactions || [], ...e.ignoreTransactions || []],
    ignoreInternal: t.ignoreInternal !== void 0 ? t.ignoreInternal : !0
  };
}
function LO(t, e) {
  return e.ignoreInternal && DO(t) ? (H && w.warn(`Event dropped due to being internal Sentry Error.
Event: ${vn(t)}`), !0) : RO(t, e.ignoreErrors) ? (H && w.warn(
    `Event dropped due to being matched by \`ignoreErrors\` option.
Event: ${vn(t)}`
  ), !0) : BO(t) ? (H && w.warn(
    `Event dropped due to not having an error message, error type or stacktrace.
Event: ${vn(
      t
    )}`
  ), !0) : xO(t, e.ignoreTransactions) ? (H && w.warn(
    `Event dropped due to being matched by \`ignoreTransactions\` option.
Event: ${vn(t)}`
  ), !0) : OO(t, e.denyUrls) ? (H && w.warn(
    `Event dropped due to being matched by \`denyUrls\` option.
Event: ${vn(
      t
    )}.
Url: ${za(t)}`
  ), !0) : PO(t, e.allowUrls) ? !1 : (H && w.warn(
    `Event dropped due to not being matched by \`allowUrls\` option.
Event: ${vn(
      t
    )}.
Url: ${za(t)}`
  ), !0);
}
function RO(t, e) {
  return t.type || !e || !e.length ? !1 : MO(t).some((n) => Dn(n, e));
}
function xO(t, e) {
  if (t.type !== "transaction" || !e || !e.length)
    return !1;
  const n = t.transaction;
  return n ? Dn(n, e) : !1;
}
function OO(t, e) {
  if (!e || !e.length)
    return !1;
  const n = za(t);
  return n ? Dn(n, e) : !1;
}
function PO(t, e) {
  if (!e || !e.length)
    return !0;
  const n = za(t);
  return n ? Dn(n, e) : !0;
}
function MO(t) {
  const e = [];
  t.message && e.push(t.message);
  let n;
  try {
    n = t.exception.values[t.exception.values.length - 1];
  } catch {
  }
  return n && n.value && (e.push(n.value), n.type && e.push(`${n.type}: ${n.value}`)), e;
}
function DO(t) {
  try {
    return t.exception.values[0].type === "SentryError";
  } catch {
  }
  return !1;
}
function GO(t = []) {
  for (let e = t.length - 1; e >= 0; e--) {
    const n = t[e];
    if (n && n.filename !== "<anonymous>" && n.filename !== "[native code]")
      return n.filename || null;
  }
  return null;
}
function za(t) {
  try {
    let e;
    try {
      e = t.exception.values[0].stacktrace.frames;
    } catch {
    }
    return e ? GO(e) : null;
  } catch {
    return H && w.error(`Cannot extract url for event ${vn(t)}`), null;
  }
}
function BO(t) {
  return t.type || !t.exception || !t.exception.values || t.exception.values.length === 0 ? !1 : (
    // No top-level message
    !t.message && // There are no exception values that have a stacktrace, a non-generic-Error type or value
    !t.exception.values.some((e) => e.stacktrace || e.type && e.type !== "Error" || e.value)
  );
}
const $O = "Dedupe", VO = () => {
  let t;
  return {
    name: $O,
    processEvent(e) {
      if (e.type)
        return e;
      try {
        if (HO(e, t))
          return H && w.warn("Event dropped due to being a duplicate of previously captured event."), null;
      } catch {
      }
      return t = e;
    }
  };
}, UO = VO;
function HO(t, e) {
  return e ? !!(jO(t, e) || WO(t, e)) : !1;
}
function jO(t, e) {
  const n = t.message, s = e.message;
  return !(!n && !s || n && !s || !n && s || n !== s || !nE(t, e) || !tE(t, e));
}
function WO(t, e) {
  const n = pm(e), s = pm(t);
  return !(!n || !s || n.type !== s.type || n.value !== s.value || !nE(t, e) || !tE(t, e));
}
function tE(t, e) {
  let n = Gf(t), s = Gf(e);
  if (!n && !s)
    return !0;
  if (n && !s || !n && s || (n = n, s = s, s.length !== n.length))
    return !1;
  for (let r = 0; r < s.length; r++) {
    const i = s[r], o = n[r];
    if (i.filename !== o.filename || i.lineno !== o.lineno || i.colno !== o.colno || i.function !== o.function)
      return !1;
  }
  return !0;
}
function nE(t, e) {
  let n = t.fingerprint, s = e.fingerprint;
  if (!n && !s)
    return !0;
  if (n && !s || !n && s)
    return !1;
  n = n, s = s;
  try {
    return n.join("") === s.join("");
  } catch {
    return !1;
  }
}
function pm(t) {
  return t.exception && t.exception.values && t.exception.values[0];
}
function zO(t, e, n, s, r = "auto.http.browser") {
  if (!t.fetchData)
    return;
  const i = pn() && e(t.fetchData.url);
  if (t.endTimestamp && i) {
    const f = t.fetchData.__span;
    if (!f) return;
    const m = s[f];
    m && (KO(m, t), delete s[f]);
    return;
  }
  const o = he(), a = J(), { method: c, url: l } = t.fetchData, d = YO(l), u = d ? ps(d).host : void 0, h = !!De(), p = i && h ? Ds({
    name: `${c} ${l}`,
    attributes: {
      url: l,
      type: "fetch",
      "http.method": c,
      "http.url": d,
      "server.address": u,
      [Le]: r,
      [Fs]: "http.client"
    }
  }) : new Jr();
  if (t.fetchData.__span = p.spanContext().spanId, s[p.spanContext().spanId] = p, n(t.fetchData.url) && a) {
    const f = t.args[0];
    t.args[1] = t.args[1] || {};
    const m = t.args[1];
    m.headers = qO(
      f,
      a,
      o,
      m,
      // If performance is disabled (TWP) or there's no active root span (pageload/navigation/interaction),
      // we do not want to use the span as base for the trace headers,
      // which means that the headers will be generated from the scope and the sampling decision is deferred
      pn() && h ? p : void 0
    );
  }
  return p;
}
function qO(t, e, n, s, r) {
  const i = Et(), { traceId: o, spanId: a, sampled: c, dsc: l } = {
    ...i.getPropagationContext(),
    ...n.getPropagationContext()
  }, d = r ? Dy(r) : ch(o, a, c), u = ky(
    l || (r ? Zn(r) : Lc(o, e))
  ), h = s.headers || (typeof Request < "u" && ln(t, Request) ? t.headers : void 0);
  if (h)
    if (typeof Headers < "u" && ln(h, Headers)) {
      const p = new Headers(h);
      if (p.set("sentry-trace", d), u) {
        const f = p.get(er);
        if (f) {
          const m = $o(f);
          p.set(
            er,
            // If there are non-sentry entries (i.e. if the stripped string is non-empty/truthy) combine the stripped header and sentry baggage header
            // otherwise just set the sentry baggage header
            m ? `${m},${u}` : u
          );
        } else
          p.set(er, u);
      }
      return p;
    } else if (Array.isArray(h)) {
      const p = [
        ...h.filter((f) => !(Array.isArray(f) && f[0] === "sentry-trace")).map((f) => {
          if (Array.isArray(f) && f[0] === er && typeof f[1] == "string") {
            const [m, g, ...y] = f;
            return [m, $o(g), ...y];
          } else
            return f;
        }),
        // Attach the new sentry-trace header
        ["sentry-trace", d]
      ];
      return u && p.push([er, u]), p;
    } else {
      const p = "baggage" in h ? h.baggage : void 0;
      let f = [];
      return Array.isArray(p) ? f = p.map(
        (m) => typeof m == "string" ? $o(m) : m
      ).filter((m) => m === "") : p && f.push($o(p)), u && f.push(u), {
        ...h,
        "sentry-trace": d,
        baggage: f.length > 0 ? f.join(",") : void 0
      };
    }
  else return { "sentry-trace": d, baggage: u };
}
function YO(t) {
  try {
    return new URL(t).href;
  } catch {
    return;
  }
}
function KO(t, e) {
  if (e.response) {
    Oy(t, e.response.status);
    const n = e.response && e.response.headers && e.response.headers.get("content-length");
    if (n) {
      const s = parseInt(n);
      s > 0 && t.setAttribute("http.response_content_length", s);
    }
  } else e.error && t.setStatus({ code: ke, message: "internal_error" });
  t.end();
}
function $o(t) {
  return t.split(",").filter((e) => !e.split("=")[0].startsWith(ah)).join(",");
}
const U = Z;
let Td = 0;
function sE() {
  return Td > 0;
}
function XO() {
  Td++, setTimeout(() => {
    Td--;
  });
}
function Rr(t, e = {}, n) {
  if (typeof t != "function")
    return t;
  try {
    const r = t.__sentry_wrapped__;
    if (r)
      return typeof r == "function" ? r : t;
    if (oh(t))
      return t;
  } catch {
    return t;
  }
  const s = function() {
    const r = Array.prototype.slice.call(arguments);
    try {
      const i = r.map((o) => Rr(o, e));
      return t.apply(this, i);
    } catch (i) {
      throw XO(), hh((o) => {
        o.addEventProcessor((a) => (e.mechanism && (md(a, void 0), $i(a, e.mechanism)), a.extra = {
          ...a.extra,
          arguments: r
        }, a)), Yy(i);
      }), i;
    }
  };
  try {
    for (const r in t)
      Object.prototype.hasOwnProperty.call(t, r) && (s[r] = t[r]);
  } catch {
  }
  py(s, t), _t(t, "__sentry_wrapped__", s);
  try {
    Object.getOwnPropertyDescriptor(s, "name").configurable && Object.defineProperty(s, "name", {
      get() {
        return t.name;
      }
    });
  } catch {
  }
  return s;
}
const Ft = typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__;
function gh(t, e) {
  const n = _h(t, e), s = {
    type: tP(e),
    value: nP(e)
  };
  return n.length && (s.stacktrace = { frames: n }), s.type === void 0 && s.value === "" && (s.value = "Unrecoverable error caught"), s;
}
function JO(t, e, n, s) {
  const r = J(), i = r && r.getOptions().normalizeDepth, o = aP(e), a = {
    __serialized__: Iy(e, i)
  };
  if (o)
    return {
      exception: {
        values: [gh(t, o)]
      },
      extra: a
    };
  const c = {
    exception: {
      values: [
        {
          type: Cc(e) ? e.constructor.name : s ? "UnhandledRejection" : "Error",
          value: iP(e, { isUnhandledRejection: s })
        }
      ]
    },
    extra: a
  };
  if (n) {
    const l = _h(t, n);
    l.length && (c.exception.values[0].stacktrace = { frames: l });
  }
  return c;
}
function vl(t, e) {
  return {
    exception: {
      values: [gh(t, e)]
    }
  };
}
function _h(t, e) {
  const n = e.stacktrace || e.stack || "", s = ZO(e), r = eP(e);
  try {
    return t(n, s, r);
  } catch {
  }
  return [];
}
const QO = /Minified React error #\d+;/i;
function ZO(t) {
  return t && QO.test(t.message) ? 1 : 0;
}
function eP(t) {
  return typeof t.framesToPop == "number" ? t.framesToPop : 0;
}
function rE(t) {
  return typeof WebAssembly < "u" && typeof WebAssembly.Exception < "u" ? t instanceof WebAssembly.Exception : !1;
}
function tP(t) {
  const e = t && t.name;
  return !e && rE(t) ? t.message && Array.isArray(t.message) && t.message.length == 2 ? t.message[0] : "WebAssembly.Exception" : e;
}
function nP(t) {
  const e = t && t.message;
  return e ? e.error && typeof e.error.message == "string" ? e.error.message : rE(t) && Array.isArray(t.message) && t.message.length == 2 ? t.message[1] : e : "No error message";
}
function sP(t, e, n, s) {
  const r = n && n.syntheticException || void 0, i = yh(t, e, r, s);
  return $i(i), i.level = "error", n && n.event_id && (i.event_id = n.event_id), hn(i);
}
function rP(t, e, n = "info", s, r) {
  const i = s && s.syntheticException || void 0, o = Id(t, e, i, r);
  return o.level = n, s && s.event_id && (o.event_id = s.event_id), hn(o);
}
function yh(t, e, n, s, r) {
  let i;
  if (ay(e) && e.error)
    return vl(t, e.error);
  if (Nf(e) || Y5(e)) {
    const o = e;
    if ("stack" in e)
      i = vl(t, e);
    else {
      const a = o.name || (Nf(o) ? "DOMError" : "DOMException"), c = o.message ? `${a}: ${o.message}` : a;
      i = Id(t, c, n, s), md(i, c);
    }
    return "code" in o && (i.tags = { ...i.tags, "DOMException.code": `${o.code}` }), i;
  }
  return sh(e) ? vl(t, e) : Ar(e) || Cc(e) ? (i = JO(t, e, n, r), $i(i, {
    synthetic: !0
  }), i) : (i = Id(t, e, n, s), md(i, `${e}`), $i(i, {
    synthetic: !0
  }), i);
}
function Id(t, e, n, s) {
  const r = {};
  if (s && n) {
    const i = _h(t, n);
    i.length && (r.exception = {
      values: [{ value: e, stacktrace: { frames: i } }]
    });
  }
  if (rh(e)) {
    const { __sentry_template_string__: i, __sentry_template_values__: o } = e;
    return r.logentry = {
      message: i,
      params: o
    }, r;
  }
  return r.message = e, r;
}
function iP(t, { isUnhandledRejection: e }) {
  const n = hR(t), s = e ? "promise rejection" : "exception";
  return ay(t) ? `Event \`ErrorEvent\` captured as ${s} with message \`${t.message}\`` : Cc(t) ? `Event \`${oP(t)}\` (type=${t.type}) captured as ${s}` : `Object captured as ${s} with keys: ${n}`;
}
function oP(t) {
  try {
    const e = Object.getPrototypeOf(t);
    return e ? e.constructor.name : void 0;
  } catch {
  }
}
function aP(t) {
  for (const e in t)
    if (Object.prototype.hasOwnProperty.call(t, e)) {
      const n = t[e];
      if (n instanceof Error)
        return n;
    }
}
function cP(t, {
  metadata: e,
  tunnel: n,
  dsn: s
}) {
  const r = {
    event_id: t.event_id,
    sent_at: (/* @__PURE__ */ new Date()).toISOString(),
    ...e && e.sdk && {
      sdk: {
        name: e.sdk.name,
        version: e.sdk.version
      }
    },
    ...!!n && !!s && { dsn: po(s) }
  }, i = lP(t);
  return Ps(r, [i]);
}
function lP(t) {
  return [{
    type: "user_report"
  }, t];
}
class dP extends uO {
  /**
   * Creates a new Browser SDK instance.
   *
   * @param options Configuration options for this SDK.
   */
  constructor(e) {
    const n = {
      // We default this to true, as it is the safer scenario
      parentSpanIsAlwaysRootSpan: !0,
      ...e
    }, s = U.SENTRY_SDK_SOURCE || FR();
    vO(n, "browser", ["browser"], s), super(n), n.sendClientReports && U.document && U.document.addEventListener("visibilitychange", () => {
      U.document.visibilityState === "hidden" && this._flushOutcomes();
    });
  }
  /**
   * @inheritDoc
   */
  eventFromException(e, n) {
    return sP(this._options.stackParser, e, n, this._options.attachStacktrace);
  }
  /**
   * @inheritDoc
   */
  eventFromMessage(e, n = "info", s) {
    return rP(this._options.stackParser, e, n, s, this._options.attachStacktrace);
  }
  /**
   * Sends user feedback to Sentry.
   *
   * @deprecated Use `captureFeedback` instead.
   */
  captureUserFeedback(e) {
    if (!this._isEnabled()) {
      Ft && w.warn("SDK not enabled, will not capture user feedback.");
      return;
    }
    const n = cP(e, {
      metadata: this.getSdkMetadata(),
      dsn: this.getDsn(),
      tunnel: this.getOptions().tunnel
    });
    this.sendEnvelope(n);
  }
  /**
   * @inheritDoc
   */
  _prepareEvent(e, n, s) {
    return e.platform = e.platform || "javascript", super._prepareEvent(e, n, s);
  }
}
const rt = typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__, uP = (t, e) => t > e[1] ? "poor" : t > e[0] ? "needs-improvement" : "good", Qr = (t, e, n, s) => {
  let r, i;
  return (o) => {
    e.value >= 0 && (o || s) && (i = e.value - (r || 0), (i || r === void 0) && (r = e.value, e.delta = i, e.rating = uP(e.value, n), t(e)));
  };
}, B = Z, hP = () => `v3-${Date.now()}-${Math.floor(Math.random() * (9e12 - 1)) + 1e12}`, go = () => B.performance && performance.getEntriesByType && performance.getEntriesByType("navigation")[0], _o = () => {
  const t = go();
  return t && t.activationStart || 0;
}, Zr = (t, e) => {
  const n = go();
  let s = "navigate";
  return n && (B.document && B.document.prerendering || _o() > 0 ? s = "prerender" : B.document && B.document.wasDiscarded ? s = "restore" : n.type && (s = n.type.replace(/_/g, "-"))), {
    name: t,
    value: typeof e > "u" ? -1 : e,
    rating: "good",
    // If needed, will be updated when reported. `const` to keep the type from widening to `string`.
    delta: 0,
    entries: [],
    id: hP(),
    navigationType: s
  };
}, Gs = (t, e, n) => {
  try {
    if (PerformanceObserver.supportedEntryTypes.includes(t)) {
      const s = new PerformanceObserver((r) => {
        Promise.resolve().then(() => {
          e(r.getEntries());
        });
      });
      return s.observe(
        Object.assign(
          {
            type: t,
            buffered: !0
          },
          n || {}
        )
      ), s;
    }
  } catch {
  }
}, yo = (t) => {
  const e = (n) => {
    (n.type === "pagehide" || B.document && B.document.visibilityState === "hidden") && t(n);
  };
  B.document && (addEventListener("visibilitychange", e, !0), addEventListener("pagehide", e, !0));
}, Eh = (t) => {
  let e = !1;
  return (n) => {
    e || (t(n), e = !0);
  };
};
let Ui = -1;
const pP = () => {
  Ui = B.document.visibilityState === "hidden" && !B.document.prerendering ? 0 : 1 / 0;
}, qa = (t) => {
  B.document.visibilityState === "hidden" && Ui > -1 && (Ui = t.type === "visibilitychange" ? t.timeStamp : 0, removeEventListener("visibilitychange", qa, !0), removeEventListener("prerenderingchange", qa, !0));
}, fP = () => {
  addEventListener("visibilitychange", qa, !0), addEventListener("prerenderingchange", qa, !0);
}, Rc = () => (B.document && Ui < 0 && (pP(), fP()), {
  get firstHiddenTime() {
    return Ui;
  }
}), Eo = (t) => {
  B.document && B.document.prerendering ? addEventListener("prerenderingchange", () => t(), !0) : t();
}, mP = [1800, 3e3], gP = (t, e = {}) => {
  Eo(() => {
    const n = Rc(), s = Zr("FCP");
    let r;
    const o = Gs("paint", (a) => {
      a.forEach((c) => {
        c.name === "first-contentful-paint" && (o.disconnect(), c.startTime < n.firstHiddenTime && (s.value = Math.max(c.startTime - _o(), 0), s.entries.push(c), r(!0)));
      });
    });
    o && (r = Qr(t, s, mP, e.reportAllChanges));
  });
}, _P = [0.1, 0.25], yP = (t, e = {}) => {
  gP(
    Eh(() => {
      const n = Zr("CLS", 0);
      let s, r = 0, i = [];
      const o = (c) => {
        c.forEach((l) => {
          if (!l.hadRecentInput) {
            const d = i[0], u = i[i.length - 1];
            r && d && u && l.startTime - u.startTime < 1e3 && l.startTime - d.startTime < 5e3 ? (r += l.value, i.push(l)) : (r = l.value, i = [l]);
          }
        }), r > n.value && (n.value = r, n.entries = i, s());
      }, a = Gs("layout-shift", o);
      a && (s = Qr(t, n, _P, e.reportAllChanges), yo(() => {
        o(a.takeRecords()), s(!0);
      }), setTimeout(s, 0));
    })
  );
}, EP = [100, 300], bP = (t, e = {}) => {
  Eo(() => {
    const n = Rc(), s = Zr("FID");
    let r;
    const i = (c) => {
      c.startTime < n.firstHiddenTime && (s.value = c.processingStart - c.startTime, s.entries.push(c), r(!0));
    }, o = (c) => {
      c.forEach(i);
    }, a = Gs("first-input", o);
    r = Qr(t, s, EP, e.reportAllChanges), a && yo(
      Eh(() => {
        o(a.takeRecords()), a.disconnect();
      })
    );
  });
};
let iE = 0, Sl = 1 / 0, Vo = 0;
const vP = (t) => {
  t.forEach((e) => {
    e.interactionId && (Sl = Math.min(Sl, e.interactionId), Vo = Math.max(Vo, e.interactionId), iE = Vo ? (Vo - Sl) / 7 + 1 : 0);
  });
};
let Cd;
const SP = () => Cd ? iE : performance.interactionCount || 0, wP = () => {
  "interactionCount" in performance || Cd || (Cd = Gs("event", vP, {
    type: "event",
    buffered: !0,
    durationThreshold: 0
  }));
}, TP = [200, 500], IP = 0, oE = () => SP() - IP, fm = 10, Yt = [], wl = {}, mm = (t) => {
  const e = Yt[Yt.length - 1], n = wl[t.interactionId];
  if (n || Yt.length < fm || e && t.duration > e.latency) {
    if (n)
      n.entries.push(t), n.latency = Math.max(n.latency, t.duration);
    else {
      const s = {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        id: t.interactionId,
        latency: t.duration,
        entries: [t]
      };
      wl[s.id] = s, Yt.push(s);
    }
    Yt.sort((s, r) => r.latency - s.latency), Yt.splice(fm).forEach((s) => {
      delete wl[s.id];
    });
  }
}, CP = () => {
  const t = Math.min(
    Yt.length - 1,
    Math.floor(oE() / 50)
  );
  return Yt[t];
}, FP = (t, e = {}) => {
  Eo(() => {
    wP();
    const n = Zr("INP");
    let s;
    const r = (o) => {
      o.forEach((c) => {
        c.interactionId && mm(c), c.entryType === "first-input" && !Yt.some((d) => d.entries.some((u) => c.duration === u.duration && c.startTime === u.startTime)) && mm(c);
      });
      const a = CP();
      a && a.latency !== n.value && (n.value = a.latency, n.entries = a.entries, s());
    }, i = Gs("event", r, {
      // Event Timing entries have their durations rounded to the nearest 8ms,
      // so a duration of 40ms would be any event that spans 2.5 or more frames
      // at 60Hz. This threshold is chosen to strike a balance between usefulness
      // and performance. Running this callback for any interaction that spans
      // just one or two frames is likely not worth the insight that could be
      // gained.
      durationThreshold: e.durationThreshold != null ? e.durationThreshold : 40
    });
    s = Qr(t, n, TP, e.reportAllChanges), i && ("PerformanceEventTiming" in B && "interactionId" in PerformanceEventTiming.prototype && i.observe({ type: "first-input", buffered: !0 }), yo(() => {
      r(i.takeRecords()), n.value < 0 && oE() > 0 && (n.value = 0, n.entries = []), s(!0);
    }));
  });
}, kP = [2500, 4e3], gm = {}, AP = (t, e = {}) => {
  Eo(() => {
    const n = Rc(), s = Zr("LCP");
    let r;
    const i = (a) => {
      const c = a[a.length - 1];
      c && c.startTime < n.firstHiddenTime && (s.value = Math.max(c.startTime - _o(), 0), s.entries = [c], r());
    }, o = Gs("largest-contentful-paint", i);
    if (o) {
      r = Qr(t, s, kP, e.reportAllChanges);
      const a = Eh(() => {
        gm[s.id] || (i(o.takeRecords()), o.disconnect(), gm[s.id] = !0, r(!0));
      });
      ["keydown", "click"].forEach((c) => {
        B.document && addEventListener(c, () => setTimeout(a, 0), !0);
      }), yo(a);
    }
  });
}, NP = [800, 1800], Fd = (t) => {
  B.document && B.document.prerendering ? Eo(() => Fd(t)) : B.document && B.document.readyState !== "complete" ? addEventListener("load", () => Fd(t), !0) : setTimeout(t, 0);
}, LP = (t, e = {}) => {
  const n = Zr("TTFB"), s = Qr(t, n, NP, e.reportAllChanges);
  Fd(() => {
    const r = go();
    if (r) {
      const i = r.responseStart;
      if (i <= 0 || i > performance.now()) return;
      n.value = Math.max(i - _o(), 0), n.entries = [r], s(!0);
    }
  });
}, vi = {}, Ya = {};
let aE, cE, lE, dE, uE;
function bh(t, e = !1) {
  return bo("cls", t, xP, aE, e);
}
function hE(t, e = !1) {
  return bo("lcp", t, PP, lE, e);
}
function pE(t) {
  return bo("fid", t, OP, cE);
}
function RP(t) {
  return bo("ttfb", t, MP, dE);
}
function fE(t) {
  return bo("inp", t, DP, uE);
}
function xr(t, e) {
  return mE(t, e), Ya[t] || (GP(t), Ya[t] = !0), gE(t, e);
}
function ei(t, e) {
  const n = vi[t];
  if (!(!n || !n.length))
    for (const s of n)
      try {
        s(e);
      } catch (r) {
        rt && w.error(
          `Error while triggering instrumentation handler.
Type: ${t}
Name: ${un(s)}
Error:`,
          r
        );
      }
}
function xP() {
  return yP(
    (t) => {
      ei("cls", {
        metric: t
      }), aE = t;
    },
    // We want the callback to be called whenever the CLS value updates.
    // By default, the callback is only called when the tab goes to the background.
    { reportAllChanges: !0 }
  );
}
function OP() {
  return bP((t) => {
    ei("fid", {
      metric: t
    }), cE = t;
  });
}
function PP() {
  return AP(
    (t) => {
      ei("lcp", {
        metric: t
      }), lE = t;
    },
    // We want the callback to be called whenever the LCP value updates.
    // By default, the callback is only called when the tab goes to the background.
    { reportAllChanges: !0 }
  );
}
function MP() {
  return LP((t) => {
    ei("ttfb", {
      metric: t
    }), dE = t;
  });
}
function DP() {
  return FP((t) => {
    ei("inp", {
      metric: t
    }), uE = t;
  });
}
function bo(t, e, n, s, r = !1) {
  mE(t, e);
  let i;
  return Ya[t] || (i = n(), Ya[t] = !0), s && e({ metric: s }), gE(t, e, r ? i : void 0);
}
function GP(t) {
  const e = {};
  t === "event" && (e.durationThreshold = 0), Gs(
    t,
    (n) => {
      ei(t, { entries: n });
    },
    e
  );
}
function mE(t, e) {
  vi[t] = vi[t] || [], vi[t].push(e);
}
function gE(t, e, n) {
  return () => {
    n && n();
    const s = vi[t];
    if (!s)
      return;
    const r = s.indexOf(e);
    r !== -1 && s.splice(r, 1);
  };
}
function BP(t) {
  return "duration" in t;
}
function Tl(t) {
  return typeof t == "number" && isFinite(t);
}
function ks(t, e, n, { ...s }) {
  const r = ne(t).start_timestamp;
  return r && r > e && typeof t.updateStartTime == "function" && t.updateStartTime(e), jy(t, () => {
    const i = Ds({
      startTime: e,
      ...s
    });
    return i && i.end(n), i;
  });
}
function _E(t) {
  const e = J();
  if (!e)
    return;
  const { name: n, transaction: s, attributes: r, startTime: i } = t, { release: o, environment: a } = e.getOptions(), c = e.getIntegrationByName("Replay"), l = c && c.getReplayId(), d = he(), u = d.getUser(), h = u !== void 0 ? u.email || u.id || u.ip_address : void 0;
  let p;
  try {
    p = d.getScopeData().contexts.profile.profile_id;
  } catch {
  }
  const f = {
    release: o,
    environment: a,
    user: h || void 0,
    profile_id: p || void 0,
    replay_id: l || void 0,
    transaction: s,
    // Web vital score calculation relies on the user agent to account for different
    // browsers setting different thresholds for what is considered a good/meh/bad value.
    // For example: Chrome vs. Chrome Mobile
    "user_agent.original": B.navigator && B.navigator.userAgent,
    ...r
  };
  return Ds({
    name: n,
    attributes: f,
    startTime: i,
    experimental: {
      standalone: !0
    }
  });
}
function vh() {
  return B && B.addEventListener && B.performance;
}
function Se(t) {
  return t / 1e3;
}
function $P() {
  let t = 0, e, n;
  if (!UP())
    return;
  let s = !1;
  function r() {
    s || (s = !0, n && VP(t, e, n), i());
  }
  const i = bh(({ metric: o }) => {
    const a = o.entries[o.entries.length - 1];
    a && (t = o.value, e = a);
  }, !0);
  yo(() => {
    r();
  }), setTimeout(() => {
    const o = J(), a = st([o, "optionalAccess", (u) => u.on, "call", (u) => u("startNavigationSpan", () => {
      r(), a && a();
    })]), c = De(), l = c && Pe(c), d = l && ne(l);
    d && d.op === "pageload" && (n = l.spanContext().spanId);
  }, 0);
}
function VP(t, e, n) {
  rt && w.log(`Sending CLS span (${t})`);
  const s = Se((Ye || 0) + (st([e, "optionalAccess", (c) => c.startTime]) || 0)), r = he().getScopeData().transactionName, i = e ? dn(st([e, "access", (c) => c.sources, "access", (c) => c[0], "optionalAccess", (c) => c.node])) : "Layout shift", o = Ce({
    [Le]: "auto.http.browser.cls",
    [Fs]: "ui.webvital.cls",
    [ph]: st([e, "optionalAccess", (c) => c.duration]) || 0,
    // attach the pageload span id to the CLS span so that we can link them in the UI
    "sentry.pageload.span_id": n
  }), a = _E({
    name: i,
    transaction: r,
    attributes: o,
    startTime: s
  });
  st([a, "optionalAccess", (c) => c.addEvent, "call", (c) => c("cls", {
    [Ac]: "",
    [Nc]: t
  })]), st([a, "optionalAccess", (c) => c.end, "call", (c) => c(s)]);
}
function UP() {
  try {
    return st([PerformanceObserver, "access", (t) => t.supportedEntryTypes, "optionalAccess", (t) => t.includes, "call", (t) => t("layout-shift")]);
  } catch {
    return !1;
  }
}
const HP = 2147483647;
let _m = 0, xe = {}, Lt, Si;
function jP({ recordClsStandaloneSpans: t }) {
  const e = vh();
  if (e && Ye) {
    e.mark && B.performance.mark("sentry-tracing-init");
    const n = XP(), s = KP(), r = JP(), i = t ? $P() : YP();
    return () => {
      n(), s(), r(), i && i();
    };
  }
  return () => {
  };
}
function WP() {
  xr("longtask", ({ entries: t }) => {
    const e = De();
    if (!e)
      return;
    const { op: n, start_timestamp: s } = ne(e);
    for (const r of t) {
      const i = Se(Ye + r.startTime), o = Se(r.duration);
      n === "navigation" && s && i < s || ks(e, i, i + o, {
        name: "Main UI thread blocked",
        op: "ui.long-task",
        attributes: {
          [Le]: "auto.ui.browser.metrics"
        }
      });
    }
  });
}
function zP() {
  new PerformanceObserver((e) => {
    if (De())
      for (const n of e.getEntries()) {
        if (!n.scripts[0])
          continue;
        const s = Se(Ye + n.startTime), r = Se(n.duration), i = {
          [Le]: "auto.ui.browser.metrics"
        }, o = n.scripts[0], { invoker: a, invokerType: c, sourceURL: l, sourceFunctionName: d, sourceCharPosition: u } = o;
        i["browser.script.invoker"] = a, i["browser.script.invoker_type"] = c, l && (i["code.filepath"] = l), d && (i["code.function"] = d), u !== -1 && (i["browser.script.source_char_position"] = u);
        const h = Ds({
          name: "Main UI thread blocked",
          op: "ui.long-animation-frame",
          startTime: s,
          attributes: i
        });
        h && h.end(s + r);
      }
  }).observe({ type: "long-animation-frame", buffered: !0 });
}
function qP() {
  xr("event", ({ entries: t }) => {
    if (De()) {
      for (const e of t)
        if (e.name === "click") {
          const n = Se(Ye + e.startTime), s = Se(e.duration), r = {
            name: dn(e.target),
            op: `ui.interaction.${e.name}`,
            startTime: n,
            attributes: {
              [Le]: "auto.ui.browser.metrics"
            }
          }, i = uy(e.target);
          i && (r.attributes["ui.component_name"] = i);
          const o = Ds(r);
          o && o.end(n + s);
        }
    }
  });
}
function YP() {
  return bh(({ metric: t }) => {
    const e = t.entries[t.entries.length - 1];
    e && (rt && w.log(`[Measurements] Adding CLS ${t.value}`), xe.cls = { value: t.value, unit: "" }, Si = e);
  }, !0);
}
function KP() {
  return hE(({ metric: t }) => {
    const e = t.entries[t.entries.length - 1];
    e && (rt && w.log("[Measurements] Adding LCP"), xe.lcp = { value: t.value, unit: "millisecond" }, Lt = e);
  }, !0);
}
function XP() {
  return pE(({ metric: t }) => {
    const e = t.entries[t.entries.length - 1];
    if (!e)
      return;
    const n = Se(Ye), s = Se(e.startTime);
    rt && w.log("[Measurements] Adding FID"), xe.fid = { value: t.value, unit: "millisecond" }, xe["mark.fid"] = { value: n + s, unit: "second" };
  });
}
function JP() {
  return RP(({ metric: t }) => {
    t.entries[t.entries.length - 1] && (rt && w.log("[Measurements] Adding TTFB"), xe.ttfb = { value: t.value, unit: "millisecond" });
  });
}
function QP(t, e) {
  const n = vh();
  if (!n || !B.performance.getEntries || !Ye)
    return;
  rt && w.log("[Tracing] Adding & adjusting spans using Performance API");
  const s = Se(Ye), r = n.getEntries(), { op: i, start_timestamp: o } = ne(t);
  if (r.slice(_m).forEach((a) => {
    const c = Se(a.startTime), l = Se(
      // Inexplicably, Chrome sometimes emits a negative duration. We need to work around this.
      // There is a SO post attempting to explain this, but it leaves one with open questions: https://stackoverflow.com/questions/23191918/peformance-getentries-and-negative-duration-display
      // The way we clamp the value is probably not accurate, since we have observed this happen for things that may take a while to load, like for example the replay worker.
      // TODO: Investigate why this happens and how to properly mitigate. For now, this is a workaround to prevent transactions being dropped due to negative duration spans.
      Math.max(0, a.duration)
    );
    if (!(i === "navigation" && o && s + c < o))
      switch (a.entryType) {
        case "navigation": {
          eM(t, a, s);
          break;
        }
        case "mark":
        case "paint":
        case "measure": {
          ZP(t, a, c, l, s);
          const d = Rc(), u = a.startTime < d.firstHiddenTime;
          a.name === "first-paint" && u && (rt && w.log("[Measurements] Adding FP"), xe.fp = { value: a.startTime, unit: "millisecond" }), a.name === "first-contentful-paint" && u && (rt && w.log("[Measurements] Adding FCP"), xe.fcp = { value: a.startTime, unit: "millisecond" });
          break;
        }
        case "resource": {
          nM(t, a, a.name, c, l, s);
          break;
        }
      }
  }), _m = Math.max(r.length - 1, 0), sM(t), i === "pageload") {
    iM(xe);
    const a = xe["mark.fid"];
    a && xe.fid && (ks(t, a.value, a.value + Se(xe.fid.value), {
      name: "first input delay",
      op: "ui.action",
      attributes: {
        [Le]: "auto.ui.browser.metrics"
      }
    }), delete xe["mark.fid"]), (!("fcp" in xe) || !e.recordClsOnPageloadSpan) && delete xe.cls, Object.entries(xe).forEach(([c, l]) => {
      Lx(c, l.value, l.unit);
    }), t.setAttribute("performance.timeOrigin", s), t.setAttribute("performance.activationStart", _o()), rM(t);
  }
  Lt = void 0, Si = void 0, xe = {};
}
function ZP(t, e, n, s, r) {
  const i = go(), o = Se(i ? i.requestStart : 0), a = r + Math.max(n, o), c = r + n, l = c + s, d = {
    [Le]: "auto.resource.browser.metrics"
  };
  return a !== c && (d["sentry.browser.measure_happened_before_request"] = !0, d["sentry.browser.measure_start_time"] = a), ks(t, a, l, {
    name: e.name,
    op: e.entryType,
    attributes: d
  }), a;
}
function eM(t, e, n) {
  ["unloadEvent", "redirect", "domContentLoadedEvent", "loadEvent", "connect"].forEach((s) => {
    Uo(t, e, s, n);
  }), Uo(t, e, "secureConnection", n, "TLS/SSL", "connectEnd"), Uo(t, e, "fetch", n, "cache", "domainLookupStart"), Uo(t, e, "domainLookup", n, "DNS"), tM(t, e, n);
}
function Uo(t, e, n, s, r, i) {
  const o = i ? e[i] : e[`${n}End`], a = e[`${n}Start`];
  !a || !o || ks(t, s + Se(a), s + Se(o), {
    op: `browser.${r || n}`,
    name: e.name,
    attributes: {
      [Le]: "auto.ui.browser.metrics"
    }
  });
}
function tM(t, e, n) {
  const s = n + Se(e.requestStart), r = n + Se(e.responseEnd), i = n + Se(e.responseStart);
  e.responseEnd && (ks(t, s, r, {
    op: "browser.request",
    name: e.name,
    attributes: {
      [Le]: "auto.ui.browser.metrics"
    }
  }), ks(t, i, r, {
    op: "browser.response",
    name: e.name,
    attributes: {
      [Le]: "auto.ui.browser.metrics"
    }
  }));
}
function nM(t, e, n, s, r, i) {
  if (e.initiatorType === "xmlhttprequest" || e.initiatorType === "fetch")
    return;
  const o = ps(n), a = {
    [Le]: "auto.resource.browser.metrics"
  };
  Il(a, e, "transferSize", "http.response_transfer_size"), Il(a, e, "encodedBodySize", "http.response_content_length"), Il(a, e, "decodedBodySize", "http.decoded_response_content_length"), e.deliveryType != null && (a["http.response_delivery_type"] = e.deliveryType), "renderBlockingStatus" in e && (a["resource.render_blocking_status"] = e.renderBlockingStatus), o.protocol && (a["url.scheme"] = o.protocol.split(":").pop()), o.host && (a["server.address"] = o.host), a["url.same_origin"] = n.includes(B.location.origin);
  const c = i + s, l = c + r;
  ks(t, c, l, {
    name: n.replace(B.location.origin, ""),
    op: e.initiatorType ? `resource.${e.initiatorType}` : "resource.other",
    attributes: a
  });
}
function sM(t) {
  const e = B.navigator;
  if (!e)
    return;
  const n = e.connection;
  n && (n.effectiveType && t.setAttribute("effectiveConnectionType", n.effectiveType), n.type && t.setAttribute("connectionType", n.type), Tl(n.rtt) && (xe["connection.rtt"] = { value: n.rtt, unit: "millisecond" })), Tl(e.deviceMemory) && t.setAttribute("deviceMemory", `${e.deviceMemory} GB`), Tl(e.hardwareConcurrency) && t.setAttribute("hardwareConcurrency", String(e.hardwareConcurrency));
}
function rM(t) {
  Lt && (rt && w.log("[Measurements] Adding LCP Data"), Lt.element && t.setAttribute("lcp.element", dn(Lt.element)), Lt.id && t.setAttribute("lcp.id", Lt.id), Lt.url && t.setAttribute("lcp.url", Lt.url.trim().slice(0, 200)), t.setAttribute("lcp.size", Lt.size)), Si && Si.sources && (rt && w.log("[Measurements] Adding CLS Data"), Si.sources.forEach(
    (e, n) => t.setAttribute(`cls.source.${n + 1}`, dn(e.node))
  ));
}
function Il(t, e, n, s) {
  const r = e[n];
  r != null && r < HP && (t[s] = r);
}
function iM(t) {
  const e = go();
  if (!e)
    return;
  const { responseStart: n, requestStart: s } = e;
  s <= n && (rt && w.log("[Measurements] Adding TTFB Request Time"), t["ttfb.requestTime"] = {
    value: n - s,
    unit: "millisecond"
  });
}
const oM = 1e3;
let ym, kd, Ad;
function yE(t) {
  const e = "dom";
  Jn(e, t), Qn(e, aM);
}
function aM() {
  if (!B.document)
    return;
  const t = pt.bind(null, "dom"), e = Em(t, !0);
  B.document.addEventListener("click", e, !1), B.document.addEventListener("keypress", e, !1), ["EventTarget", "Node"].forEach((n) => {
    const s = B[n] && B[n].prototype;
    !s || !s.hasOwnProperty || !s.hasOwnProperty("addEventListener") || (tt(s, "addEventListener", function(r) {
      return function(i, o, a) {
        if (i === "click" || i == "keypress")
          try {
            const c = this, l = c.__sentry_instrumentation_handlers__ = c.__sentry_instrumentation_handlers__ || {}, d = l[i] = l[i] || { refCount: 0 };
            if (!d.handler) {
              const u = Em(t);
              d.handler = u, r.call(this, i, u, a);
            }
            d.refCount++;
          } catch {
          }
        return r.call(this, i, o, a);
      };
    }), tt(
      s,
      "removeEventListener",
      function(r) {
        return function(i, o, a) {
          if (i === "click" || i == "keypress")
            try {
              const c = this, l = c.__sentry_instrumentation_handlers__ || {}, d = l[i];
              d && (d.refCount--, d.refCount <= 0 && (r.call(this, i, d.handler, a), d.handler = void 0, delete l[i]), Object.keys(l).length === 0 && delete c.__sentry_instrumentation_handlers__);
            } catch {
            }
          return r.call(this, i, o, a);
        };
      }
    ));
  });
}
function cM(t) {
  if (t.type !== kd)
    return !1;
  try {
    if (!t.target || t.target._sentryId !== Ad)
      return !1;
  } catch {
  }
  return !0;
}
function lM(t, e) {
  return t !== "keypress" ? !1 : !e || !e.tagName ? !0 : !(e.tagName === "INPUT" || e.tagName === "TEXTAREA" || e.isContentEditable);
}
function Em(t, e = !1) {
  return (n) => {
    if (!n || n._sentryCaptured)
      return;
    const s = dM(n);
    if (lM(n.type, s))
      return;
    _t(n, "_sentryCaptured", !0), s && !s._sentryId && _t(s, "_sentryId", me());
    const r = n.type === "keypress" ? "input" : n.type;
    cM(n) || (t({ event: n, name: r, global: e }), kd = n.type, Ad = s ? s._sentryId : void 0), clearTimeout(ym), ym = B.setTimeout(() => {
      Ad = void 0, kd = void 0;
    }, oM);
  };
}
function dM(t) {
  try {
    return t.target;
  } catch {
    return null;
  }
}
let Ho;
function xc(t) {
  const e = "history";
  Jn(e, t), Qn(e, uM);
}
function uM() {
  if (!tx())
    return;
  const t = B.onpopstate;
  B.onpopstate = function(...n) {
    const s = B.location.href, r = Ho;
    if (Ho = s, pt("history", { from: r, to: s }), t)
      try {
        return t.apply(this, n);
      } catch {
      }
  };
  function e(n) {
    return function(...s) {
      const r = s.length > 2 ? s[2] : void 0;
      if (r) {
        const i = Ho, o = String(r);
        Ho = o, pt("history", { from: i, to: o });
      }
      return n.apply(this, s);
    };
  }
  tt(B.history, "pushState", e), tt(B.history, "replaceState", e);
}
const aa = {};
function EE(t) {
  const e = aa[t];
  if (e)
    return e;
  let n = B[t];
  if (pd(n))
    return aa[t] = n.bind(B);
  const s = B.document;
  if (s && typeof s.createElement == "function")
    try {
      const r = s.createElement("iframe");
      r.hidden = !0, s.head.appendChild(r);
      const i = r.contentWindow;
      i && i[t] && (n = i[t]), s.head.removeChild(r);
    } catch (r) {
      rt && w.warn(`Could not create sandbox iframe for ${t} check, bailing to window.${t}: `, r);
    }
  return n && (aa[t] = n.bind(B));
}
function bm(t) {
  aa[t] = void 0;
}
function Or(...t) {
  return EE("setTimeout")(...t);
}
const cs = "__sentry_xhr_v3__";
function bE(t) {
  const e = "xhr";
  Jn(e, t), Qn(e, hM);
}
function hM() {
  if (!B.XMLHttpRequest)
    return;
  const t = XMLHttpRequest.prototype;
  t.open = new Proxy(t.open, {
    apply(e, n, s) {
      const r = qe() * 1e3, i = nn(s[0]) ? s[0].toUpperCase() : void 0, o = pM(s[1]);
      if (!i || !o)
        return e.apply(n, s);
      n[cs] = {
        method: i,
        url: o,
        request_headers: {}
      }, i === "POST" && o.match(/sentry_key/) && (n.__sentry_own_request__ = !0);
      const a = () => {
        const c = n[cs];
        if (c && n.readyState === 4) {
          try {
            c.status_code = n.status;
          } catch {
          }
          const l = {
            endTimestamp: qe() * 1e3,
            startTimestamp: r,
            xhr: n
          };
          pt("xhr", l);
        }
      };
      return "onreadystatechange" in n && typeof n.onreadystatechange == "function" ? n.onreadystatechange = new Proxy(n.onreadystatechange, {
        apply(c, l, d) {
          return a(), c.apply(l, d);
        }
      }) : n.addEventListener("readystatechange", a), n.setRequestHeader = new Proxy(n.setRequestHeader, {
        apply(c, l, d) {
          const [u, h] = d, p = l[cs];
          return p && nn(u) && nn(h) && (p.request_headers[u.toLowerCase()] = h), c.apply(l, d);
        }
      }), e.apply(n, s);
    }
  }), t.send = new Proxy(t.send, {
    apply(e, n, s) {
      const r = n[cs];
      if (!r)
        return e.apply(n, s);
      s[0] !== void 0 && (r.body = s[0]);
      const i = {
        startTimestamp: qe() * 1e3,
        xhr: n
      };
      return pt("xhr", i), e.apply(n, s);
    }
  });
}
function pM(t) {
  if (nn(t))
    return t;
  try {
    return t.toString();
  } catch {
  }
}
const Cl = [], ca = /* @__PURE__ */ new Map();
function fM() {
  if (vh() && Ye) {
    const e = mM();
    return () => {
      e();
    };
  }
  return () => {
  };
}
const vm = {
  click: "click",
  pointerdown: "click",
  pointerup: "click",
  mousedown: "click",
  mouseup: "click",
  touchstart: "click",
  touchend: "click",
  mouseover: "hover",
  mouseout: "hover",
  mouseenter: "hover",
  mouseleave: "hover",
  pointerover: "hover",
  pointerout: "hover",
  pointerenter: "hover",
  pointerleave: "hover",
  dragstart: "drag",
  dragend: "drag",
  drag: "drag",
  dragenter: "drag",
  dragleave: "drag",
  dragover: "drag",
  drop: "drag",
  keydown: "press",
  keyup: "press",
  keypress: "press",
  input: "press"
};
function mM() {
  return fE(({ metric: t }) => {
    if (t.value == null)
      return;
    const e = t.entries.find((f) => f.duration === t.value && vm[f.name]);
    if (!e)
      return;
    const { interactionId: n } = e, s = vm[e.name], r = Se(Ye + e.startTime), i = Se(t.value), o = De(), a = o ? Pe(o) : void 0, l = (n != null ? ca.get(n) : void 0) || a, d = l ? ne(l).description : he().getScopeData().transactionName, u = dn(e.target), h = Ce({
      [Le]: "auto.http.browser.inp",
      [Fs]: `ui.interaction.${s}`,
      [ph]: e.duration
    }), p = _E({
      name: u,
      transaction: d,
      attributes: h,
      startTime: r
    });
    st([p, "optionalAccess", (f) => f.addEvent, "call", (f) => f("inp", {
      [Ac]: "millisecond",
      [Nc]: t.value
    })]), st([p, "optionalAccess", (f) => f.end, "call", (f) => f(r + i)]);
  });
}
function gM(t) {
  const e = ({ entries: n }) => {
    const s = De(), r = s && Pe(s);
    n.forEach((i) => {
      if (!BP(i) || !r)
        return;
      const o = i.interactionId;
      if (o != null && !ca.has(o)) {
        if (Cl.length > 10) {
          const a = Cl.shift();
          ca.delete(a);
        }
        Cl.push(o), ca.set(o, r);
      }
    });
  };
  xr("event", e), xr("first-input", e);
}
function _M(t, e = EE("fetch")) {
  let n = 0, s = 0;
  function r(i) {
    const o = i.body.length;
    n += o, s++;
    const a = {
      body: i.body,
      method: "POST",
      referrerPolicy: "origin",
      headers: t.headers,
      // Outgoing requests are usually cancelled when navigating to a different page, causing a "TypeError: Failed to
      // fetch" error and sending a "network_error" client-outcome - in Chrome, the request status shows "(cancelled)".
      // The `keepalive` flag keeps outgoing requests alive, even when switching pages. We want this since we're
      // frequently sending events right before the user is switching pages (eg. when finishing navigation transactions).
      // Gotchas:
      // - `keepalive` isn't supported by Firefox
      // - As per spec (https://fetch.spec.whatwg.org/#http-network-or-cache-fetch):
      //   If the sum of contentLength and inflightKeepaliveBytes is greater than 64 kibibytes, then return a network error.
      //   We will therefore only activate the flag when we're below that limit.
      // There is also a limit of requests that can be open at the same time, so we also limit this to 15
      // See https://github.com/getsentry/sentry-javascript/pull/7553 for details
      keepalive: n <= 6e4 && s < 15,
      ...t.fetchOptions
    };
    if (!e)
      return bm("fetch"), Ua("No fetch implementation available");
    try {
      return e(t.url, a).then((c) => (n -= o, s--, {
        statusCode: c.status,
        headers: {
          "x-sentry-rate-limits": c.headers.get("X-Sentry-Rate-Limits"),
          "retry-after": c.headers.get("Retry-After")
        }
      }));
    } catch (c) {
      return bm("fetch"), n -= o, s--, Ua(c);
    }
  }
  return _O(t, r);
}
const yM = 30, EM = 50;
function Nd(t, e, n, s) {
  const r = {
    filename: t,
    function: e === "<anonymous>" ? Is : e,
    in_app: !0
    // All browser frames are considered in_app
  };
  return n !== void 0 && (r.lineno = n), s !== void 0 && (r.colno = s), r;
}
const bM = /^\s*at (\S+?)(?::(\d+))(?::(\d+))\s*$/i, vM = /^\s*at (?:(.+?\)(?: \[.+\])?|.*?) ?\((?:address at )?)?(?:async )?((?:<anonymous>|[-a-z]+:|.*bundle|\/)?.*?)(?::(\d+))?(?::(\d+))?\)?\s*$/i, SM = /\((\S*)(?::(\d+))(?::(\d+))\)/, wM = (t) => {
  const e = bM.exec(t);
  if (e) {
    const [, s, r, i] = e;
    return Nd(s, Is, +r, +i);
  }
  const n = vM.exec(t);
  if (n) {
    if (n[2] && n[2].indexOf("eval") === 0) {
      const o = SM.exec(n[2]);
      o && (n[2] = o[1], n[3] = o[2], n[4] = o[3]);
    }
    const [r, i] = vE(n[1] || Is, n[2]);
    return Nd(i, r, n[3] ? +n[3] : void 0, n[4] ? +n[4] : void 0);
  }
}, TM = [yM, wM], IM = /^\s*(.*?)(?:\((.*?)\))?(?:^|@)?((?:[-a-z]+)?:\/.*?|\[native code\]|[^@]*(?:bundle|\d+\.js)|\/[\w\-. /=]+)(?::(\d+))?(?::(\d+))?\s*$/i, CM = /(\S+) line (\d+)(?: > eval line \d+)* > eval/i, FM = (t) => {
  const e = IM.exec(t);
  if (e) {
    if (e[3] && e[3].indexOf(" > eval") > -1) {
      const i = CM.exec(e[3]);
      i && (e[1] = e[1] || "eval", e[3] = i[1], e[4] = i[2], e[5] = "");
    }
    let s = e[3], r = e[1] || Is;
    return [r, s] = vE(r, s), Nd(s, r, e[4] ? +e[4] : void 0, e[5] ? +e[5] : void 0);
  }
}, kM = [EM, FM], AM = [TM, kM], NM = gy(...AM), vE = (t, e) => {
  const n = t.indexOf("safari-extension") !== -1, s = t.indexOf("safari-web-extension") !== -1;
  return n || s ? [
    t.indexOf("@") !== -1 ? t.split("@")[0] : Is,
    n ? `safari-extension:${e}` : `safari-web-extension:${e}`
  ] : [t, e];
}, jo = 1024, LM = "Breadcrumbs", RM = (t = {}) => {
  const e = {
    console: !0,
    dom: !0,
    fetch: !0,
    history: !0,
    sentry: !0,
    xhr: !0,
    ...t
  };
  return {
    name: LM,
    setup(n) {
      e.console && gR(MM(n)), e.dom && yE(PM(n, e.dom)), e.xhr && bE(DM(n)), e.fetch && Ey(GM(n)), e.history && xc(BM(n)), e.sentry && n.on("beforeSendEvent", OM(n));
    }
  };
}, xM = RM;
function OM(t) {
  return function(n) {
    J() === t && Wn(
      {
        category: `sentry.${n.type === "transaction" ? "transaction" : "event"}`,
        event_id: n.event_id,
        level: n.level,
        message: vn(n)
      },
      {
        event: n
      }
    );
  };
}
function PM(t, e) {
  return function(s) {
    if (J() !== t)
      return;
    let r, i, o = typeof e == "object" ? e.serializeAttribute : void 0, a = typeof e == "object" && typeof e.maxStringLength == "number" ? e.maxStringLength : void 0;
    a && a > jo && (Ft && w.warn(
      `\`dom.maxStringLength\` cannot exceed ${jo}, but a value of ${a} was configured. Sentry will use ${jo} instead.`
    ), a = jo), typeof o == "string" && (o = [o]);
    try {
      const l = s.event, d = $M(l) ? l.target : l;
      r = dn(d, { keyAttrs: o, maxStringLength: a }), i = uy(d);
    } catch {
      r = "<unknown>";
    }
    if (r.length === 0)
      return;
    const c = {
      category: `ui.${s.name}`,
      message: r
    };
    i && (c.data = { "ui.component_name": i }), Wn(c, {
      event: s.event,
      name: s.name,
      global: s.global
    });
  };
}
function MM(t) {
  return function(n) {
    if (J() !== t)
      return;
    const s = {
      category: "console",
      data: {
        arguments: n.args,
        logger: "console"
      },
      level: Cy(n.level),
      message: Lf(n.args, " ")
    };
    if (n.level === "assert")
      if (n.args[0] === !1)
        s.message = `Assertion failed: ${Lf(n.args.slice(1), " ") || "console.assert"}`, s.data.arguments = n.args.slice(1);
      else
        return;
    Wn(s, {
      input: n.args,
      level: n.level
    });
  };
}
function DM(t) {
  return function(n) {
    if (J() !== t)
      return;
    const { startTimestamp: s, endTimestamp: r } = n, i = n.xhr[cs];
    if (!s || !r || !i)
      return;
    const { method: o, url: a, status_code: c, body: l } = i, d = {
      method: o,
      url: a,
      status_code: c
    }, u = {
      xhr: n.xhr,
      input: l,
      startTimestamp: s,
      endTimestamp: r
    }, h = ly(c);
    Wn(
      {
        category: "xhr",
        data: d,
        type: "http",
        level: h
      },
      u
    );
  };
}
function GM(t) {
  return function(n) {
    if (J() !== t)
      return;
    const { startTimestamp: s, endTimestamp: r } = n;
    if (r && !(n.fetchData.url.match(/sentry_key/) && n.fetchData.method === "POST"))
      if (n.error) {
        const i = n.fetchData, o = {
          data: n.error,
          input: n.args,
          startTimestamp: s,
          endTimestamp: r
        };
        Wn(
          {
            category: "fetch",
            data: i,
            level: "error",
            type: "http"
          },
          o
        );
      } else {
        const i = n.response, o = {
          ...n.fetchData,
          status_code: i && i.status
        }, a = {
          input: n.args,
          response: i,
          startTimestamp: s,
          endTimestamp: r
        }, c = ly(o.status_code);
        Wn(
          {
            category: "fetch",
            data: o,
            type: "http",
            level: c
          },
          a
        );
      }
  };
}
function BM(t) {
  return function(n) {
    if (J() !== t)
      return;
    let s = n.from, r = n.to;
    const i = ps(U.location.href);
    let o = s ? ps(s) : void 0;
    const a = ps(r);
    (!o || !o.path) && (o = i), i.protocol === a.protocol && i.host === a.host && (r = a.relative), i.protocol === o.protocol && i.host === o.host && (s = o.relative), Wn({
      category: "navigation",
      data: {
        from: s,
        to: r
      }
    });
  };
}
function $M(t) {
  return !!t && !!t.target;
}
const VM = [
  "EventTarget",
  "Window",
  "Node",
  "ApplicationCache",
  "AudioTrackList",
  "BroadcastChannel",
  "ChannelMergerNode",
  "CryptoOperation",
  "EventSource",
  "FileReader",
  "HTMLUnknownElement",
  "IDBDatabase",
  "IDBRequest",
  "IDBTransaction",
  "KeyOperation",
  "MediaController",
  "MessagePort",
  "ModalWindow",
  "Notification",
  "SVGElementInstance",
  "Screen",
  "SharedWorker",
  "TextTrack",
  "TextTrackCue",
  "TextTrackList",
  "WebSocket",
  "WebSocketWorker",
  "Worker",
  "XMLHttpRequest",
  "XMLHttpRequestEventTarget",
  "XMLHttpRequestUpload"
], UM = "BrowserApiErrors", HM = (t = {}) => {
  const e = {
    XMLHttpRequest: !0,
    eventTarget: !0,
    requestAnimationFrame: !0,
    setInterval: !0,
    setTimeout: !0,
    ...t
  };
  return {
    name: UM,
    // TODO: This currently only works for the first client this is setup
    // We may want to adjust this to check for client etc.
    setupOnce() {
      e.setTimeout && tt(U, "setTimeout", Sm), e.setInterval && tt(U, "setInterval", Sm), e.requestAnimationFrame && tt(U, "requestAnimationFrame", WM), e.XMLHttpRequest && "XMLHttpRequest" in U && tt(XMLHttpRequest.prototype, "send", zM);
      const n = e.eventTarget;
      n && (Array.isArray(n) ? n : VM).forEach(qM);
    }
  };
}, jM = HM;
function Sm(t) {
  return function(...e) {
    const n = e[0];
    return e[0] = Rr(n, {
      mechanism: {
        data: { function: un(t) },
        handled: !1,
        type: "instrument"
      }
    }), t.apply(this, e);
  };
}
function WM(t) {
  return function(e) {
    return t.apply(this, [
      Rr(e, {
        mechanism: {
          data: {
            function: "requestAnimationFrame",
            handler: un(t)
          },
          handled: !1,
          type: "instrument"
        }
      })
    ]);
  };
}
function zM(t) {
  return function(...e) {
    const n = this;
    return ["onload", "onerror", "onprogress", "onreadystatechange"].forEach((r) => {
      r in n && typeof n[r] == "function" && tt(n, r, function(i) {
        const o = {
          mechanism: {
            data: {
              function: r,
              handler: un(i)
            },
            handled: !1,
            type: "instrument"
          }
        }, a = oh(i);
        return a && (o.mechanism.data.handler = un(a)), Rr(i, o);
      });
    }), t.apply(this, e);
  };
}
function qM(t) {
  const e = U, n = e[t] && e[t].prototype;
  !n || !n.hasOwnProperty || !n.hasOwnProperty("addEventListener") || (tt(n, "addEventListener", function(s) {
    return function(r, i, o) {
      try {
        typeof i.handleEvent == "function" && (i.handleEvent = Rr(i.handleEvent, {
          mechanism: {
            data: {
              function: "handleEvent",
              handler: un(i),
              target: t
            },
            handled: !1,
            type: "instrument"
          }
        }));
      } catch {
      }
      return s.apply(this, [
        r,
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Rr(i, {
          mechanism: {
            data: {
              function: "addEventListener",
              handler: un(i),
              target: t
            },
            handled: !1,
            type: "instrument"
          }
        }),
        o
      ]);
    };
  }), tt(
    n,
    "removeEventListener",
    function(s) {
      return function(r, i, o) {
        const a = i;
        try {
          const c = a && a.__sentry_wrapped__;
          c && s.call(this, r, c, o);
        } catch {
        }
        return s.call(this, r, a, o);
      };
    }
  ));
}
const YM = "GlobalHandlers", KM = (t = {}) => {
  const e = {
    onerror: !0,
    onunhandledrejection: !0,
    ...t
  };
  return {
    name: YM,
    setupOnce() {
      Error.stackTraceLimit = 50;
    },
    setup(n) {
      e.onerror && (JM(n), wm("onerror")), e.onunhandledrejection && (QM(n), wm("onunhandledrejection"));
    }
  };
}, XM = KM;
function JM(t) {
  vy((e) => {
    const { stackParser: n, attachStacktrace: s } = SE();
    if (J() !== t || sE())
      return;
    const { msg: r, url: i, line: o, column: a, error: c } = e, l = tD(
      yh(n, c || r, void 0, s, !1),
      i,
      o,
      a
    );
    l.level = "error", Ky(l, {
      originalException: c,
      mechanism: {
        handled: !1,
        type: "onerror"
      }
    });
  });
}
function QM(t) {
  Sy((e) => {
    const { stackParser: n, attachStacktrace: s } = SE();
    if (J() !== t || sE())
      return;
    const r = ZM(e), i = ih(r) ? eD(r) : yh(n, r, void 0, s, !0);
    i.level = "error", Ky(i, {
      originalException: r,
      mechanism: {
        handled: !1,
        type: "onunhandledrejection"
      }
    });
  });
}
function ZM(t) {
  if (ih(t))
    return t;
  try {
    if ("reason" in t)
      return t.reason;
    if ("detail" in t && "reason" in t.detail)
      return t.detail.reason;
  } catch {
  }
  return t;
}
function eD(t) {
  return {
    exception: {
      values: [
        {
          type: "UnhandledRejection",
          // String() is needed because the Primitive type includes symbols (which can't be automatically stringified)
          value: `Non-Error promise rejection captured with value: ${String(t)}`
        }
      ]
    }
  };
}
function tD(t, e, n, s) {
  const r = t.exception = t.exception || {}, i = r.values = r.values || [], o = i[0] = i[0] || {}, a = o.stacktrace = o.stacktrace || {}, c = a.frames = a.frames || [], l = isNaN(parseInt(s, 10)) ? void 0 : s, d = isNaN(parseInt(n, 10)) ? void 0 : n, u = nn(e) && e.length > 0 ? e : dy();
  return c.length === 0 && c.push({
    colno: l,
    filename: u,
    function: Is,
    in_app: !0,
    lineno: d
  }), t;
}
function wm(t) {
  Ft && w.log(`Global Handler attached: ${t}`);
}
function SE() {
  const t = J();
  return t && t.getOptions() || {
    stackParser: () => [],
    attachStacktrace: !1
  };
}
const nD = () => ({
  name: "HttpContext",
  preprocessEvent(t) {
    if (!U.navigator && !U.location && !U.document)
      return;
    const e = t.request && t.request.url || U.location && U.location.href, { referrer: n } = U.document || {}, { userAgent: s } = U.navigator || {}, r = {
      ...t.request && t.request.headers,
      ...n && { Referer: n },
      ...s && { "User-Agent": s }
    }, i = { ...t.request, ...e && { url: e }, headers: r };
    t.request = i;
  }
}), sD = "cause", rD = 5, iD = "LinkedErrors", oD = (t = {}) => {
  const e = t.limit || rD, n = t.key || sD;
  return {
    name: iD,
    preprocessEvent(s, r, i) {
      const o = i.getOptions();
      Z5(
        // This differs from the LinkedErrors integration in core by using a different exceptionFromError function
        gh,
        o.stackParser,
        o.maxValueLength,
        n,
        e,
        s,
        r
      );
    }
  };
}, aD = oD;
function cD(t) {
  return [
    AO(),
    IO(),
    jM(),
    xM(),
    XM(),
    aD(),
    UO(),
    nD()
  ];
}
function lD(t = {}) {
  const e = {
    defaultIntegrations: cD(),
    release: typeof __SENTRY_RELEASE__ == "string" ? __SENTRY_RELEASE__ : U.SENTRY_RELEASE && U.SENTRY_RELEASE.id ? U.SENTRY_RELEASE.id : void 0,
    autoSessionTracking: !0,
    sendClientReports: !0
  };
  return t.defaultIntegrations == null && delete t.defaultIntegrations, { ...e, ...t };
}
function dD() {
  const t = typeof U.window < "u" && U;
  if (!t)
    return !1;
  const e = t.chrome ? "chrome" : "browser", n = t[e], s = n && n.runtime && n.runtime.id, r = U.location && U.location.href || "", i = ["chrome-extension:", "moz-extension:", "ms-browser-extension:", "safari-web-extension:"], o = !!s && U === U.top && i.some((c) => r.startsWith(`${c}//`)), a = typeof t.nw < "u";
  return !!s && !o && !a;
}
function uD(t = {}) {
  const e = lD(t);
  if (!e.skipBrowserExtensionCheck && dD()) {
    Kr(() => {
      console.error(
        "[Sentry] You cannot run Sentry this way in a browser extension, check: https://docs.sentry.io/platforms/javascript/best-practices/browser-extensions/"
      );
    });
    return;
  }
  Ft && (_y() || w.warn(
    "No Fetch API detected. The Sentry SDK requires a Fetch API compatible environment to send events. Please add a Fetch API polyfill."
  ));
  const n = {
    ...e,
    stackParser: fR(e.stackParser || NM),
    integrations: lO(e),
    transport: e.transport || _M
  }, s = fO(dP, n);
  return e.autoSessionTracking && hD(), s;
}
function hD() {
  if (typeof U.document > "u") {
    Ft && w.warn("Session tracking in non-browser environment with @sentry/browser is not supported.");
    return;
  }
  rm({ ignoreDuration: !0 }), im(), xc(({ from: t, to: e }) => {
    t !== void 0 && t !== e && (rm({ ignoreDuration: !0 }), im());
  });
}
const le = Z, Sh = "sentryReplaySession", pD = "replay_event", wh = "Unable to send Replay", fD = 3e5, mD = 9e5, gD = 5e3, _D = 5500, yD = 6e4, ED = 5e3, bD = 3, Tm = 15e4, Wo = 5e3, vD = 3e3, SD = 300, Th = 2e7, wD = 4999, TD = 15e3, Im = 36e5;
function Ld(t, e) {
  return t ?? e();
}
function Hi(t) {
  let e, n = t[0], s = 1;
  for (; s < t.length; ) {
    const r = t[s], i = t[s + 1];
    if (s += 2, (r === "optionalAccess" || r === "optionalCall") && n == null)
      return;
    r === "access" || r === "optionalAccess" ? (e = n, n = i(n)) : (r === "call" || r === "optionalCall") && (n = i((...o) => n.call(e, ...o)), e = void 0);
  }
  return n;
}
var we;
(function(t) {
  t[t.Document = 0] = "Document", t[t.DocumentType = 1] = "DocumentType", t[t.Element = 2] = "Element", t[t.Text = 3] = "Text", t[t.CDATA = 4] = "CDATA", t[t.Comment = 5] = "Comment";
})(we || (we = {}));
function ID(t) {
  return t.nodeType === t.ELEMENT_NODE;
}
function wi(t) {
  const e = Hi([t, "optionalAccess", (n) => n.host]);
  return Hi([e, "optionalAccess", (n) => n.shadowRoot]) === t;
}
function Ti(t) {
  return Object.prototype.toString.call(t) === "[object ShadowRoot]";
}
function CD(t) {
  return t.includes(" background-clip: text;") && !t.includes(" -webkit-background-clip: text;") && (t = t.replace(/\sbackground-clip:\s*text;/g, " -webkit-background-clip: text; background-clip: text;")), t;
}
function FD(t) {
  const { cssText: e } = t;
  if (e.split('"').length < 3)
    return e;
  const n = ["@import", `url(${JSON.stringify(t.href)})`];
  return t.layerName === "" ? n.push("layer") : t.layerName && n.push(`layer(${t.layerName})`), t.supportsText && n.push(`supports(${t.supportsText})`), t.media.length && n.push(t.media.mediaText), n.join(" ") + ";";
}
function Ka(t) {
  try {
    const e = t.rules || t.cssRules;
    return e ? CD(Array.from(e, wE).join("")) : null;
  } catch {
    return null;
  }
}
function wE(t) {
  let e;
  if (AD(t))
    try {
      e = Ka(t.styleSheet) || FD(t);
    } catch {
    }
  else if (ND(t) && t.selectorText.includes(":"))
    return kD(t.cssText);
  return e || t.cssText;
}
function kD(t) {
  const e = /(\[(?:[\w-]+)[^\\])(:(?:[\w-]+)\])/gm;
  return t.replace(e, "$1\\$2");
}
function AD(t) {
  return "styleSheet" in t;
}
function ND(t) {
  return "selectorText" in t;
}
class TE {
  constructor() {
    this.idNodeMap = /* @__PURE__ */ new Map(), this.nodeMetaMap = /* @__PURE__ */ new WeakMap();
  }
  getId(e) {
    if (!e)
      return -1;
    const n = Hi([this, "access", (s) => s.getMeta, "call", (s) => s(e), "optionalAccess", (s) => s.id]);
    return Ld(n, () => -1);
  }
  getNode(e) {
    return this.idNodeMap.get(e) || null;
  }
  getIds() {
    return Array.from(this.idNodeMap.keys());
  }
  getMeta(e) {
    return this.nodeMetaMap.get(e) || null;
  }
  removeNodeFromMap(e) {
    const n = this.getId(e);
    this.idNodeMap.delete(n), e.childNodes && e.childNodes.forEach((s) => this.removeNodeFromMap(s));
  }
  has(e) {
    return this.idNodeMap.has(e);
  }
  hasNode(e) {
    return this.nodeMetaMap.has(e);
  }
  add(e, n) {
    const s = n.id;
    this.idNodeMap.set(s, e), this.nodeMetaMap.set(e, n);
  }
  replace(e, n) {
    const s = this.getNode(e);
    if (s) {
      const r = this.nodeMetaMap.get(s);
      r && this.nodeMetaMap.set(n, r);
    }
    this.idNodeMap.set(e, n);
  }
  reset() {
    this.idNodeMap = /* @__PURE__ */ new Map(), this.nodeMetaMap = /* @__PURE__ */ new WeakMap();
  }
}
function LD() {
  return new TE();
}
function Oc({ maskInputOptions: t, tagName: e, type: n }) {
  return e === "OPTION" && (e = "SELECT"), !!(t[e.toLowerCase()] || n && t[n] || n === "password" || e === "INPUT" && !n && t.text);
}
function ji({ isMasked: t, element: e, value: n, maskInputFn: s }) {
  let r = n || "";
  return t ? (s && (r = s(r, e)), "*".repeat(r.length)) : r;
}
function Pr(t) {
  return t.toLowerCase();
}
function Rd(t) {
  return t.toUpperCase();
}
const Cm = "__rrweb_original__";
function RD(t) {
  const e = t.getContext("2d");
  if (!e)
    return !0;
  const n = 50;
  for (let s = 0; s < t.width; s += n)
    for (let r = 0; r < t.height; r += n) {
      const i = e.getImageData, o = Cm in i ? i[Cm] : i;
      if (new Uint32Array(o.call(e, s, r, Math.min(n, t.width - s), Math.min(n, t.height - r)).data.buffer).some((c) => c !== 0))
        return !1;
    }
  return !0;
}
function Ih(t) {
  const e = t.type;
  return t.hasAttribute("data-rr-is-password") ? "password" : e ? Pr(e) : null;
}
function Xa(t, e, n) {
  return e === "INPUT" && (n === "radio" || n === "checkbox") ? t.getAttribute("value") || "" : t.value;
}
function IE(t, e) {
  let n;
  try {
    n = new URL(t, Ld(e, () => window.location.href));
  } catch {
    return null;
  }
  const s = /\.([0-9a-z]+)(?:$)/i, r = n.pathname.match(s);
  return Ld(Hi([r, "optionalAccess", (i) => i[1]]), () => null);
}
const Fm = {};
function CE(t) {
  const e = Fm[t];
  if (e)
    return e;
  const n = window.document;
  let s = window[t];
  if (n && typeof n.createElement == "function")
    try {
      const r = n.createElement("iframe");
      r.hidden = !0, n.head.appendChild(r);
      const i = r.contentWindow;
      i && i[t] && (s = i[t]), n.head.removeChild(r);
    } catch {
    }
  return Fm[t] = s.bind(window);
}
function xd(...t) {
  return CE("setTimeout")(...t);
}
function FE(...t) {
  return CE("clearTimeout")(...t);
}
let xD = 1;
const OD = new RegExp("[^a-z0-9-_:]"), Wi = -2;
function Ch() {
  return xD++;
}
function PD(t) {
  if (t instanceof HTMLFormElement)
    return "form";
  const e = Pr(t.tagName);
  return OD.test(e) ? "div" : e;
}
function MD(t) {
  let e = "";
  return t.indexOf("//") > -1 ? e = t.split("/").slice(0, 3).join("/") : e = t.split("/")[0], e = e.split("?")[0], e;
}
let Ks, km;
const DD = /url\((?:(')([^']*)'|(")(.*?)"|([^)]*))\)/gm, GD = /^(?:[a-z+]+:)?\/\//i, BD = /^www\..*/i, $D = /^(data:)([^,]*),(.*)/i;
function Ja(t, e) {
  return (t || "").replace(DD, (n, s, r, i, o, a) => {
    const c = r || o || a, l = s || i || "";
    if (!c)
      return n;
    if (GD.test(c) || BD.test(c))
      return `url(${l}${c}${l})`;
    if ($D.test(c))
      return `url(${l}${c}${l})`;
    if (c[0] === "/")
      return `url(${l}${MD(e) + c}${l})`;
    const d = e.split("/"), u = c.split("/");
    d.pop();
    for (const h of u)
      h !== "." && (h === ".." ? d.pop() : d.push(h));
    return `url(${l}${d.join("/")}${l})`;
  });
}
const VD = /^[^ \t\n\r\u000c]+/, UD = /^[, \t\n\r\u000c]+/;
function HD(t, e) {
  if (e.trim() === "")
    return e;
  let n = 0;
  function s(i) {
    let o;
    const a = i.exec(e.substring(n));
    return a ? (o = a[0], n += o.length, o) : "";
  }
  const r = [];
  for (; s(UD), !(n >= e.length); ) {
    let i = s(VD);
    if (i.slice(-1) === ",")
      i = ir(t, i.substring(0, i.length - 1)), r.push(i);
    else {
      let o = "";
      i = ir(t, i);
      let a = !1;
      for (; ; ) {
        const c = e.charAt(n);
        if (c === "") {
          r.push((i + o).trim());
          break;
        } else if (a)
          c === ")" && (a = !1);
        else if (c === ",") {
          n += 1, r.push((i + o).trim());
          break;
        } else c === "(" && (a = !0);
        o += c, n += 1;
      }
    }
  }
  return r.join(", ");
}
const Am = /* @__PURE__ */ new WeakMap();
function ir(t, e) {
  return !e || e.trim() === "" ? e : Pc(t, e);
}
function jD(t) {
  return !!(t.tagName === "svg" || t.ownerSVGElement);
}
function Pc(t, e) {
  let n = Am.get(t);
  if (n || (n = t.createElement("a"), Am.set(t, n)), !e)
    e = "";
  else if (e.startsWith("blob:") || e.startsWith("data:"))
    return e;
  return n.setAttribute("href", e), n.href;
}
function kE(t, e, n, s, r, i) {
  return s && (n === "src" || n === "href" && !(e === "use" && s[0] === "#") || n === "xlink:href" && s[0] !== "#" || n === "background" && (e === "table" || e === "td" || e === "th") ? ir(t, s) : n === "srcset" ? HD(t, s) : n === "style" ? Ja(s, Pc(t)) : e === "object" && n === "data" ? ir(t, s) : typeof i == "function" ? i(n, s, r) : s);
}
function AE(t, e, n) {
  return (t === "video" || t === "audio") && e === "autoplay";
}
function WD(t, e, n, s) {
  try {
    if (s && t.matches(s))
      return !1;
    if (typeof e == "string") {
      if (t.classList.contains(e))
        return !0;
    } else
      for (let r = t.classList.length; r--; ) {
        const i = t.classList[r];
        if (e.test(i))
          return !0;
      }
    if (n)
      return t.matches(n);
  } catch {
  }
  return !1;
}
function zD(t, e) {
  for (let n = t.classList.length; n--; ) {
    const s = t.classList[n];
    if (e.test(s))
      return !0;
  }
  return !1;
}
function ls(t, e, n = 1 / 0, s = 0) {
  return !t || t.nodeType !== t.ELEMENT_NODE || s > n ? -1 : e(t) ? s : ls(t.parentNode, e, n, s + 1);
}
function or(t, e) {
  return (n) => {
    const s = n;
    if (s === null)
      return !1;
    try {
      if (t) {
        if (typeof t == "string") {
          if (s.matches(`.${t}`))
            return !0;
        } else if (zD(s, t))
          return !0;
      }
      return !!(e && s.matches(e));
    } catch {
      return !1;
    }
  };
}
function Mr(t, e, n, s, r, i) {
  try {
    const o = t.nodeType === t.ELEMENT_NODE ? t : t.parentElement;
    if (o === null)
      return !1;
    if (o.tagName === "INPUT") {
      const l = o.getAttribute("autocomplete");
      if ([
        "current-password",
        "new-password",
        "cc-number",
        "cc-exp",
        "cc-exp-month",
        "cc-exp-year",
        "cc-csc"
      ].includes(l))
        return !0;
    }
    let a = -1, c = -1;
    if (i) {
      if (c = ls(o, or(s, r)), c < 0)
        return !0;
      a = ls(o, or(e, n), c >= 0 ? c : 1 / 0);
    } else {
      if (a = ls(o, or(e, n)), a < 0)
        return !1;
      c = ls(o, or(s, r), a >= 0 ? a : 1 / 0);
    }
    return a >= 0 ? c >= 0 ? a <= c : !0 : c >= 0 ? !1 : !!i;
  } catch {
  }
  return !!i;
}
function qD(t, e, n) {
  const s = t.contentWindow;
  if (!s)
    return;
  let r = !1, i;
  try {
    i = s.document.readyState;
  } catch {
    return;
  }
  if (i !== "complete") {
    const a = xd(() => {
      r || (e(), r = !0);
    }, n);
    t.addEventListener("load", () => {
      FE(a), r = !0, e();
    });
    return;
  }
  const o = "about:blank";
  if (s.location.href !== o || t.src === o || t.src === "")
    return xd(e, 0), t.addEventListener("load", e);
  t.addEventListener("load", e);
}
function YD(t, e, n) {
  let s = !1, r;
  try {
    r = t.sheet;
  } catch {
    return;
  }
  if (r)
    return;
  const i = xd(() => {
    s || (e(), s = !0);
  }, n);
  t.addEventListener("load", () => {
    FE(i), s = !0, e();
  });
}
function KD(t, e) {
  const { doc: n, mirror: s, blockClass: r, blockSelector: i, unblockSelector: o, maskAllText: a, maskAttributeFn: c, maskTextClass: l, unmaskTextClass: d, maskTextSelector: u, unmaskTextSelector: h, inlineStylesheet: p, maskInputOptions: f = {}, maskTextFn: m, maskInputFn: g, dataURLOptions: y = {}, inlineImages: I, recordCanvas: A, keepIframeSrcFn: T, newlyAddedElement: F = !1 } = e, _ = XD(n, s);
  switch (t.nodeType) {
    case t.DOCUMENT_NODE:
      return t.compatMode !== "CSS1Compat" ? {
        type: we.Document,
        childNodes: [],
        compatMode: t.compatMode
      } : {
        type: we.Document,
        childNodes: []
      };
    case t.DOCUMENT_TYPE_NODE:
      return {
        type: we.DocumentType,
        name: t.name,
        publicId: t.publicId,
        systemId: t.systemId,
        rootId: _
      };
    case t.ELEMENT_NODE:
      return QD(t, {
        doc: n,
        blockClass: r,
        blockSelector: i,
        unblockSelector: o,
        inlineStylesheet: p,
        maskAttributeFn: c,
        maskInputOptions: f,
        maskInputFn: g,
        dataURLOptions: y,
        inlineImages: I,
        recordCanvas: A,
        keepIframeSrcFn: T,
        newlyAddedElement: F,
        rootId: _,
        maskAllText: a,
        maskTextClass: l,
        unmaskTextClass: d,
        maskTextSelector: u,
        unmaskTextSelector: h
      });
    case t.TEXT_NODE:
      return JD(t, {
        doc: n,
        maskAllText: a,
        maskTextClass: l,
        unmaskTextClass: d,
        maskTextSelector: u,
        unmaskTextSelector: h,
        maskTextFn: m,
        maskInputOptions: f,
        maskInputFn: g,
        rootId: _
      });
    case t.CDATA_SECTION_NODE:
      return {
        type: we.CDATA,
        textContent: "",
        rootId: _
      };
    case t.COMMENT_NODE:
      return {
        type: we.Comment,
        textContent: t.textContent || "",
        rootId: _
      };
    default:
      return !1;
  }
}
function XD(t, e) {
  if (!e.hasNode(t))
    return;
  const n = e.getId(t);
  return n === 1 ? void 0 : n;
}
function JD(t, e) {
  const { maskAllText: n, maskTextClass: s, unmaskTextClass: r, maskTextSelector: i, unmaskTextSelector: o, maskTextFn: a, maskInputOptions: c, maskInputFn: l, rootId: d } = e, u = t.parentNode && t.parentNode.tagName;
  let h = t.textContent;
  const p = u === "STYLE" ? !0 : void 0, f = u === "SCRIPT" ? !0 : void 0, m = u === "TEXTAREA" ? !0 : void 0;
  if (p && h) {
    try {
      t.nextSibling || t.previousSibling || Hi([t, "access", (y) => y.parentNode, "access", (y) => y.sheet, "optionalAccess", (y) => y.cssRules]) && (h = Ka(t.parentNode.sheet));
    } catch (y) {
      console.warn(`Cannot get CSS styles from text's parentNode. Error: ${y}`, t);
    }
    h = Ja(h, Pc(e.doc));
  }
  f && (h = "SCRIPT_PLACEHOLDER");
  const g = Mr(t, s, i, r, o, n);
  if (!p && !f && !m && h && g && (h = a ? a(h, t.parentElement) : h.replace(/[\S]/g, "*")), m && h && (c.textarea || g) && (h = l ? l(h, t.parentNode) : h.replace(/[\S]/g, "*")), u === "OPTION" && h) {
    const y = Oc({
      type: null,
      tagName: u,
      maskInputOptions: c
    });
    h = ji({
      isMasked: Mr(t, s, i, r, o, y),
      element: t,
      value: h,
      maskInputFn: l
    });
  }
  return {
    type: we.Text,
    textContent: h || "",
    isStyle: p,
    rootId: d
  };
}
function QD(t, e) {
  const { doc: n, blockClass: s, blockSelector: r, unblockSelector: i, inlineStylesheet: o, maskInputOptions: a = {}, maskAttributeFn: c, maskInputFn: l, dataURLOptions: d = {}, inlineImages: u, recordCanvas: h, keepIframeSrcFn: p, newlyAddedElement: f = !1, rootId: m, maskAllText: g, maskTextClass: y, unmaskTextClass: I, maskTextSelector: A, unmaskTextSelector: T } = e, F = WD(t, s, r, i), _ = PD(t);
  let E = {};
  const C = t.attributes.length;
  for (let v = 0; v < C; v++) {
    const k = t.attributes[v];
    k.name && !AE(_, k.name, k.value) && (E[k.name] = kE(n, _, Pr(k.name), k.value, t, c));
  }
  if (_ === "link" && o) {
    const v = Array.from(n.styleSheets).find((L) => L.href === t.href);
    let k = null;
    v && (k = Ka(v)), k && (delete E.rel, delete E.href, E._cssText = Ja(k, v.href));
  }
  if (_ === "style" && t.sheet && !(t.innerText || t.textContent || "").trim().length) {
    const v = Ka(t.sheet);
    v && (E._cssText = Ja(v, Pc(n)));
  }
  if (_ === "input" || _ === "textarea" || _ === "select" || _ === "option") {
    const v = t, k = Ih(v), L = Xa(v, Rd(_), k), $ = v.checked;
    if (k !== "submit" && k !== "button" && L) {
      const ee = Mr(v, y, A, I, T, Oc({
        type: k,
        tagName: Rd(_),
        maskInputOptions: a
      }));
      E.value = ji({
        isMasked: ee,
        element: v,
        value: L,
        maskInputFn: l
      });
    }
    $ && (E.checked = $);
  }
  if (_ === "option" && (t.selected && !a.select ? E.selected = !0 : delete E.selected), _ === "canvas" && h) {
    if (t.__context === "2d")
      RD(t) || (E.rr_dataURL = t.toDataURL(d.type, d.quality));
    else if (!("__context" in t)) {
      const v = t.toDataURL(d.type, d.quality), k = n.createElement("canvas");
      k.width = t.width, k.height = t.height;
      const L = k.toDataURL(d.type, d.quality);
      v !== L && (E.rr_dataURL = v);
    }
  }
  if (_ === "img" && u) {
    Ks || (Ks = n.createElement("canvas"), km = Ks.getContext("2d"));
    const v = t, k = v.currentSrc || v.getAttribute("src") || "<unknown-src>", L = v.crossOrigin, $ = () => {
      v.removeEventListener("load", $);
      try {
        Ks.width = v.naturalWidth, Ks.height = v.naturalHeight, km.drawImage(v, 0, 0), E.rr_dataURL = Ks.toDataURL(d.type, d.quality);
      } catch (ee) {
        if (v.crossOrigin !== "anonymous") {
          v.crossOrigin = "anonymous", v.complete && v.naturalWidth !== 0 ? $() : v.addEventListener("load", $);
          return;
        } else
          console.warn(`Cannot inline img src=${k}! Error: ${ee}`);
      }
      v.crossOrigin === "anonymous" && (L ? E.crossOrigin = L : v.removeAttribute("crossorigin"));
    };
    v.complete && v.naturalWidth !== 0 ? $() : v.addEventListener("load", $);
  }
  if ((_ === "audio" || _ === "video") && (E.rr_mediaState = t.paused ? "paused" : "played", E.rr_mediaCurrentTime = t.currentTime), f || (t.scrollLeft && (E.rr_scrollLeft = t.scrollLeft), t.scrollTop && (E.rr_scrollTop = t.scrollTop)), F) {
    const { width: v, height: k } = t.getBoundingClientRect();
    E = {
      class: E.class,
      rr_width: `${v}px`,
      rr_height: `${k}px`
    };
  }
  _ === "iframe" && !p(E.src) && (!F && !t.contentDocument && (E.rr_src = E.src), delete E.src);
  let N;
  try {
    customElements.get(_) && (N = !0);
  } catch {
  }
  return {
    type: we.Element,
    tagName: _,
    attributes: E,
    childNodes: [],
    isSVG: jD(t) || void 0,
    needBlock: F,
    rootId: m,
    isCustom: N
  };
}
function ce(t) {
  return t == null ? "" : t.toLowerCase();
}
function ZD(t, e) {
  if (e.comment && t.type === we.Comment)
    return !0;
  if (t.type === we.Element) {
    if (e.script && (t.tagName === "script" || t.tagName === "link" && (t.attributes.rel === "preload" || t.attributes.rel === "modulepreload") && t.attributes.as === "script" || t.tagName === "link" && t.attributes.rel === "prefetch" && typeof t.attributes.href == "string" && IE(t.attributes.href) === "js"))
      return !0;
    if (e.headFavicon && (t.tagName === "link" && t.attributes.rel === "shortcut icon" || t.tagName === "meta" && (ce(t.attributes.name).match(/^msapplication-tile(image|color)$/) || ce(t.attributes.name) === "application-name" || ce(t.attributes.rel) === "icon" || ce(t.attributes.rel) === "apple-touch-icon" || ce(t.attributes.rel) === "shortcut icon")))
      return !0;
    if (t.tagName === "meta") {
      if (e.headMetaDescKeywords && ce(t.attributes.name).match(/^description|keywords$/))
        return !0;
      if (e.headMetaSocial && (ce(t.attributes.property).match(/^(og|twitter|fb):/) || ce(t.attributes.name).match(/^(og|twitter):/) || ce(t.attributes.name) === "pinterest"))
        return !0;
      if (e.headMetaRobots && (ce(t.attributes.name) === "robots" || ce(t.attributes.name) === "googlebot" || ce(t.attributes.name) === "bingbot"))
        return !0;
      if (e.headMetaHttpEquiv && t.attributes["http-equiv"] !== void 0)
        return !0;
      if (e.headMetaAuthorship && (ce(t.attributes.name) === "author" || ce(t.attributes.name) === "generator" || ce(t.attributes.name) === "framework" || ce(t.attributes.name) === "publisher" || ce(t.attributes.name) === "progid" || ce(t.attributes.property).match(/^article:/) || ce(t.attributes.property).match(/^product:/)))
        return !0;
      if (e.headMetaVerification && (ce(t.attributes.name) === "google-site-verification" || ce(t.attributes.name) === "yandex-verification" || ce(t.attributes.name) === "csrf-token" || ce(t.attributes.name) === "p:domain_verify" || ce(t.attributes.name) === "verify-v1" || ce(t.attributes.name) === "verification" || ce(t.attributes.name) === "shopify-checkout-api-token"))
        return !0;
    }
  }
  return !1;
}
function ar(t, e) {
  const { doc: n, mirror: s, blockClass: r, blockSelector: i, unblockSelector: o, maskAllText: a, maskTextClass: c, unmaskTextClass: l, maskTextSelector: d, unmaskTextSelector: u, skipChild: h = !1, inlineStylesheet: p = !0, maskInputOptions: f = {}, maskAttributeFn: m, maskTextFn: g, maskInputFn: y, slimDOMOptions: I, dataURLOptions: A = {}, inlineImages: T = !1, recordCanvas: F = !1, onSerialize: _, onIframeLoad: E, iframeLoadTimeout: C = 5e3, onStylesheetLoad: N, stylesheetLoadTimeout: v = 5e3, keepIframeSrcFn: k = () => !1, newlyAddedElement: L = !1 } = e;
  let { preserveWhiteSpace: $ = !0 } = e;
  const ee = KD(t, {
    doc: n,
    mirror: s,
    blockClass: r,
    blockSelector: i,
    maskAllText: a,
    unblockSelector: o,
    maskTextClass: c,
    unmaskTextClass: l,
    maskTextSelector: d,
    unmaskTextSelector: u,
    inlineStylesheet: p,
    maskInputOptions: f,
    maskAttributeFn: m,
    maskTextFn: g,
    maskInputFn: y,
    dataURLOptions: A,
    inlineImages: T,
    recordCanvas: F,
    keepIframeSrcFn: k,
    newlyAddedElement: L
  });
  if (!ee)
    return console.warn(t, "not serialized"), null;
  let pe;
  s.hasNode(t) ? pe = s.getId(t) : ZD(ee, I) || !$ && ee.type === we.Text && !ee.isStyle && !ee.textContent.replace(/^\s+|\s+$/gm, "").length ? pe = Wi : pe = Ch();
  const R = Object.assign(ee, { id: pe });
  if (s.add(t, R), pe === Wi)
    return null;
  _ && _(t);
  let re = !h;
  if (R.type === we.Element) {
    re = re && !R.needBlock, delete R.needBlock;
    const q = t.shadowRoot;
    q && Ti(q) && (R.isShadowHost = !0);
  }
  if ((R.type === we.Document || R.type === we.Element) && re) {
    I.headWhitespace && R.type === we.Element && R.tagName === "head" && ($ = !1);
    const q = {
      doc: n,
      mirror: s,
      blockClass: r,
      blockSelector: i,
      maskAllText: a,
      unblockSelector: o,
      maskTextClass: c,
      unmaskTextClass: l,
      maskTextSelector: d,
      unmaskTextSelector: u,
      skipChild: h,
      inlineStylesheet: p,
      maskInputOptions: f,
      maskAttributeFn: m,
      maskTextFn: g,
      maskInputFn: y,
      slimDOMOptions: I,
      dataURLOptions: A,
      inlineImages: T,
      recordCanvas: F,
      preserveWhiteSpace: $,
      onSerialize: _,
      onIframeLoad: E,
      iframeLoadTimeout: C,
      onStylesheetLoad: N,
      stylesheetLoadTimeout: v,
      keepIframeSrcFn: k
    };
    for (const ge of Array.from(t.childNodes)) {
      const Xe = ar(ge, q);
      Xe && R.childNodes.push(Xe);
    }
    if (ID(t) && t.shadowRoot)
      for (const ge of Array.from(t.shadowRoot.childNodes)) {
        const Xe = ar(ge, q);
        Xe && (Ti(t.shadowRoot) && (Xe.isShadow = !0), R.childNodes.push(Xe));
      }
  }
  return t.parentNode && wi(t.parentNode) && Ti(t.parentNode) && (R.isShadow = !0), R.type === we.Element && R.tagName === "iframe" && qD(t, () => {
    const q = t.contentDocument;
    if (q && E) {
      const ge = ar(q, {
        doc: q,
        mirror: s,
        blockClass: r,
        blockSelector: i,
        unblockSelector: o,
        maskAllText: a,
        maskTextClass: c,
        unmaskTextClass: l,
        maskTextSelector: d,
        unmaskTextSelector: u,
        skipChild: !1,
        inlineStylesheet: p,
        maskInputOptions: f,
        maskAttributeFn: m,
        maskTextFn: g,
        maskInputFn: y,
        slimDOMOptions: I,
        dataURLOptions: A,
        inlineImages: T,
        recordCanvas: F,
        preserveWhiteSpace: $,
        onSerialize: _,
        onIframeLoad: E,
        iframeLoadTimeout: C,
        onStylesheetLoad: N,
        stylesheetLoadTimeout: v,
        keepIframeSrcFn: k
      });
      ge && E(t, ge);
    }
  }, C), R.type === we.Element && R.tagName === "link" && typeof R.attributes.rel == "string" && (R.attributes.rel === "stylesheet" || R.attributes.rel === "preload" && typeof R.attributes.href == "string" && IE(R.attributes.href) === "css") && YD(t, () => {
    if (N) {
      const q = ar(t, {
        doc: n,
        mirror: s,
        blockClass: r,
        blockSelector: i,
        unblockSelector: o,
        maskAllText: a,
        maskTextClass: c,
        unmaskTextClass: l,
        maskTextSelector: d,
        unmaskTextSelector: u,
        skipChild: !1,
        inlineStylesheet: p,
        maskInputOptions: f,
        maskAttributeFn: m,
        maskTextFn: g,
        maskInputFn: y,
        slimDOMOptions: I,
        dataURLOptions: A,
        inlineImages: T,
        recordCanvas: F,
        preserveWhiteSpace: $,
        onSerialize: _,
        onIframeLoad: E,
        iframeLoadTimeout: C,
        onStylesheetLoad: N,
        stylesheetLoadTimeout: v,
        keepIframeSrcFn: k
      });
      q && N(t, q);
    }
  }, v), R;
}
function eG(t, e) {
  const { mirror: n = new TE(), blockClass: s = "rr-block", blockSelector: r = null, unblockSelector: i = null, maskAllText: o = !1, maskTextClass: a = "rr-mask", unmaskTextClass: c = null, maskTextSelector: l = null, unmaskTextSelector: d = null, inlineStylesheet: u = !0, inlineImages: h = !1, recordCanvas: p = !1, maskAllInputs: f = !1, maskAttributeFn: m, maskTextFn: g, maskInputFn: y, slimDOM: I = !1, dataURLOptions: A, preserveWhiteSpace: T, onSerialize: F, onIframeLoad: _, iframeLoadTimeout: E, onStylesheetLoad: C, stylesheetLoadTimeout: N, keepIframeSrcFn: v = () => !1 } = e || {};
  return ar(t, {
    doc: t,
    mirror: n,
    blockClass: s,
    blockSelector: r,
    unblockSelector: i,
    maskAllText: o,
    maskTextClass: a,
    unmaskTextClass: c,
    maskTextSelector: l,
    unmaskTextSelector: d,
    skipChild: !1,
    inlineStylesheet: u,
    maskInputOptions: f === !0 ? {
      color: !0,
      date: !0,
      "datetime-local": !0,
      email: !0,
      month: !0,
      number: !0,
      range: !0,
      search: !0,
      tel: !0,
      text: !0,
      time: !0,
      url: !0,
      week: !0,
      textarea: !0,
      select: !0
    } : f === !1 ? {} : f,
    maskAttributeFn: m,
    maskTextFn: g,
    maskInputFn: y,
    slimDOMOptions: I === !0 || I === "all" ? {
      script: !0,
      comment: !0,
      headFavicon: !0,
      headWhitespace: !0,
      headMetaDescKeywords: I === "all",
      headMetaSocial: !0,
      headMetaRobots: !0,
      headMetaHttpEquiv: !0,
      headMetaAuthorship: !0,
      headMetaVerification: !0
    } : I === !1 ? {} : I,
    dataURLOptions: A,
    inlineImages: h,
    recordCanvas: p,
    preserveWhiteSpace: T,
    onSerialize: F,
    onIframeLoad: _,
    iframeLoadTimeout: E,
    onStylesheetLoad: C,
    stylesheetLoadTimeout: N,
    keepIframeSrcFn: v,
    newlyAddedElement: !1
  });
}
function Sn(t) {
  let e, n = t[0], s = 1;
  for (; s < t.length; ) {
    const r = t[s], i = t[s + 1];
    if (s += 2, (r === "optionalAccess" || r === "optionalCall") && n == null)
      return;
    r === "access" || r === "optionalAccess" ? (e = n, n = i(n)) : (r === "call" || r === "optionalCall") && (n = i((...o) => n.call(e, ...o)), e = void 0);
  }
  return n;
}
function Ue(t, e, n = document) {
  const s = { capture: !0, passive: !0 };
  return n.addEventListener(t, e, s), () => n.removeEventListener(t, e, s);
}
const tr = `Please stop import mirror directly. Instead of that,\r
now you can use replayer.getMirror() to access the mirror instance of a replayer,\r
or you can use record.mirror to access the mirror instance during recording.`;
let Nm = {
  map: {},
  getId() {
    return console.error(tr), -1;
  },
  getNode() {
    return console.error(tr), null;
  },
  removeNodeFromMap() {
    console.error(tr);
  },
  has() {
    return console.error(tr), !1;
  },
  reset() {
    console.error(tr);
  }
};
typeof window < "u" && window.Proxy && window.Reflect && (Nm = new Proxy(Nm, {
  get(t, e, n) {
    return e === "map" && console.error(tr), Reflect.get(t, e, n);
  }
}));
function zi(t, e, n = {}) {
  let s = null, r = 0;
  return function(...i) {
    const o = Date.now();
    !r && n.leading === !1 && (r = o);
    const a = e - (o - r), c = this;
    a <= 0 || a > e ? (s && (aG(s), s = null), r = o, t.apply(c, i)) : !s && n.trailing !== !1 && (s = Mc(() => {
      r = n.leading === !1 ? 0 : Date.now(), s = null, t.apply(c, i);
    }, a));
  };
}
function NE(t, e, n, s, r = window) {
  const i = r.Object.getOwnPropertyDescriptor(t, e);
  return r.Object.defineProperty(t, e, s ? n : {
    set(o) {
      Mc(() => {
        n.set.call(this, o);
      }, 0), i && i.set && i.set.call(this, o);
    }
  }), () => NE(t, e, i || {}, !0);
}
function Fh(t, e, n) {
  try {
    if (!(e in t))
      return () => {
      };
    const s = t[e], r = n(s);
    return typeof r == "function" && (r.prototype = r.prototype || {}, Object.defineProperties(r, {
      __rrweb_original__: {
        enumerable: !1,
        value: s
      }
    })), t[e] = r, () => {
      t[e] = s;
    };
  } catch {
    return () => {
    };
  }
}
let Qa = Date.now;
/[1-9][0-9]{12}/.test(Date.now().toString()) || (Qa = () => (/* @__PURE__ */ new Date()).getTime());
function LE(t) {
  const e = t.document;
  return {
    left: e.scrollingElement ? e.scrollingElement.scrollLeft : t.pageXOffset !== void 0 ? t.pageXOffset : Sn([e, "optionalAccess", (n) => n.documentElement, "access", (n) => n.scrollLeft]) || Sn([e, "optionalAccess", (n) => n.body, "optionalAccess", (n) => n.parentElement, "optionalAccess", (n) => n.scrollLeft]) || Sn([e, "optionalAccess", (n) => n.body, "optionalAccess", (n) => n.scrollLeft]) || 0,
    top: e.scrollingElement ? e.scrollingElement.scrollTop : t.pageYOffset !== void 0 ? t.pageYOffset : Sn([e, "optionalAccess", (n) => n.documentElement, "access", (n) => n.scrollTop]) || Sn([e, "optionalAccess", (n) => n.body, "optionalAccess", (n) => n.parentElement, "optionalAccess", (n) => n.scrollTop]) || Sn([e, "optionalAccess", (n) => n.body, "optionalAccess", (n) => n.scrollTop]) || 0
  };
}
function RE() {
  return window.innerHeight || document.documentElement && document.documentElement.clientHeight || document.body && document.body.clientHeight;
}
function xE() {
  return window.innerWidth || document.documentElement && document.documentElement.clientWidth || document.body && document.body.clientWidth;
}
function OE(t) {
  return t ? t.nodeType === t.ELEMENT_NODE ? t : t.parentElement : null;
}
function nt(t, e, n, s, r) {
  if (!t)
    return !1;
  const i = OE(t);
  if (!i)
    return !1;
  const o = or(e, n);
  if (!r) {
    const l = s && i.matches(s);
    return o(i) && !l;
  }
  const a = ls(i, o);
  let c = -1;
  return a < 0 ? !1 : (s && (c = ls(i, or(null, s))), a > -1 && c < 0 ? !0 : a < c);
}
function tG(t, e) {
  return e.getId(t) !== -1;
}
function Fl(t, e) {
  return e.getId(t) === Wi;
}
function PE(t, e) {
  if (wi(t))
    return !1;
  const n = e.getId(t);
  return e.has(n) ? t.parentNode && t.parentNode.nodeType === t.DOCUMENT_NODE ? !1 : t.parentNode ? PE(t.parentNode, e) : !0 : !0;
}
function Od(t) {
  return !!t.changedTouches;
}
function nG(t = window) {
  "NodeList" in t && !t.NodeList.prototype.forEach && (t.NodeList.prototype.forEach = Array.prototype.forEach), "DOMTokenList" in t && !t.DOMTokenList.prototype.forEach && (t.DOMTokenList.prototype.forEach = Array.prototype.forEach), Node.prototype.contains || (Node.prototype.contains = (...e) => {
    let n = e[0];
    if (!(0 in e))
      throw new TypeError("1 argument is required");
    do
      if (this === n)
        return !0;
    while (n = n && n.parentNode);
    return !1;
  });
}
function ME(t, e) {
  return !!(t.nodeName === "IFRAME" && e.getMeta(t));
}
function DE(t, e) {
  return !!(t.nodeName === "LINK" && t.nodeType === t.ELEMENT_NODE && t.getAttribute && t.getAttribute("rel") === "stylesheet" && e.getMeta(t));
}
function Pd(t) {
  return !!Sn([t, "optionalAccess", (e) => e.shadowRoot]);
}
class sG {
  constructor() {
    this.id = 1, this.styleIDMap = /* @__PURE__ */ new WeakMap(), this.idStyleMap = /* @__PURE__ */ new Map();
  }
  getId(e) {
    return ex(this.styleIDMap.get(e), () => -1);
  }
  has(e) {
    return this.styleIDMap.has(e);
  }
  add(e, n) {
    if (this.has(e))
      return this.getId(e);
    let s;
    return n === void 0 ? s = this.id++ : s = n, this.styleIDMap.set(e, s), this.idStyleMap.set(s, e), s;
  }
  getStyle(e) {
    return this.idStyleMap.get(e) || null;
  }
  reset() {
    this.styleIDMap = /* @__PURE__ */ new WeakMap(), this.idStyleMap = /* @__PURE__ */ new Map(), this.id = 1;
  }
  generateId() {
    return this.id++;
  }
}
function GE(t) {
  let e = null;
  return Sn([t, "access", (n) => n.getRootNode, "optionalCall", (n) => n(), "optionalAccess", (n) => n.nodeType]) === Node.DOCUMENT_FRAGMENT_NODE && t.getRootNode().host && (e = t.getRootNode().host), e;
}
function rG(t) {
  let e = t, n;
  for (; n = GE(e); )
    e = n;
  return e;
}
function iG(t) {
  const e = t.ownerDocument;
  if (!e)
    return !1;
  const n = rG(t);
  return e.contains(n);
}
function BE(t) {
  const e = t.ownerDocument;
  return e ? e.contains(t) || iG(t) : !1;
}
const Lm = {};
function kh(t) {
  const e = Lm[t];
  if (e)
    return e;
  const n = window.document;
  let s = window[t];
  if (n && typeof n.createElement == "function")
    try {
      const r = n.createElement("iframe");
      r.hidden = !0, n.head.appendChild(r);
      const i = r.contentWindow;
      i && i[t] && (s = i[t]), n.head.removeChild(r);
    } catch {
    }
  return Lm[t] = s.bind(window);
}
function oG(...t) {
  return kh("requestAnimationFrame")(...t);
}
function Mc(...t) {
  return kh("setTimeout")(...t);
}
function aG(...t) {
  return kh("clearTimeout")(...t);
}
var W = /* @__PURE__ */ ((t) => (t[t.DomContentLoaded = 0] = "DomContentLoaded", t[t.Load = 1] = "Load", t[t.FullSnapshot = 2] = "FullSnapshot", t[t.IncrementalSnapshot = 3] = "IncrementalSnapshot", t[t.Meta = 4] = "Meta", t[t.Custom = 5] = "Custom", t[t.Plugin = 6] = "Plugin", t))(W || {}), V = /* @__PURE__ */ ((t) => (t[t.Mutation = 0] = "Mutation", t[t.MouseMove = 1] = "MouseMove", t[t.MouseInteraction = 2] = "MouseInteraction", t[t.Scroll = 3] = "Scroll", t[t.ViewportResize = 4] = "ViewportResize", t[t.Input = 5] = "Input", t[t.TouchMove = 6] = "TouchMove", t[t.MediaInteraction = 7] = "MediaInteraction", t[t.StyleSheetRule = 8] = "StyleSheetRule", t[t.CanvasMutation = 9] = "CanvasMutation", t[t.Font = 10] = "Font", t[t.Log = 11] = "Log", t[t.Drag = 12] = "Drag", t[t.StyleDeclaration = 13] = "StyleDeclaration", t[t.Selection = 14] = "Selection", t[t.AdoptedStyleSheet = 15] = "AdoptedStyleSheet", t[t.CustomElement = 16] = "CustomElement", t))(V || {}), Ve = /* @__PURE__ */ ((t) => (t[t.MouseUp = 0] = "MouseUp", t[t.MouseDown = 1] = "MouseDown", t[t.Click = 2] = "Click", t[t.ContextMenu = 3] = "ContextMenu", t[t.DblClick = 4] = "DblClick", t[t.Focus = 5] = "Focus", t[t.Blur = 6] = "Blur", t[t.TouchStart = 7] = "TouchStart", t[t.TouchMove_Departed = 8] = "TouchMove_Departed", t[t.TouchEnd = 9] = "TouchEnd", t[t.TouchCancel = 10] = "TouchCancel", t))(Ve || {}), Wt = /* @__PURE__ */ ((t) => (t[t.Mouse = 0] = "Mouse", t[t.Pen = 1] = "Pen", t[t.Touch = 2] = "Touch", t))(Wt || {});
function cG(t) {
  let e, n = t[0], s = 1;
  for (; s < t.length; ) {
    const r = t[s], i = t[s + 1];
    if (s += 2, (r === "optionalAccess" || r === "optionalCall") && n == null)
      return;
    r === "access" || r === "optionalAccess" ? (e = n, n = i(n)) : (r === "call" || r === "optionalCall") && (n = i((...o) => n.call(e, ...o)), e = void 0);
  }
  return n;
}
function Rm(t) {
  return "__ln" in t;
}
class lG {
  constructor() {
    this.length = 0, this.head = null, this.tail = null;
  }
  get(e) {
    if (e >= this.length)
      throw new Error("Position outside of list range");
    let n = this.head;
    for (let s = 0; s < e; s++)
      n = cG([n, "optionalAccess", (r) => r.next]) || null;
    return n;
  }
  addNode(e) {
    const n = {
      value: e,
      previous: null,
      next: null
    };
    if (e.__ln = n, e.previousSibling && Rm(e.previousSibling)) {
      const s = e.previousSibling.__ln.next;
      n.next = s, n.previous = e.previousSibling.__ln, e.previousSibling.__ln.next = n, s && (s.previous = n);
    } else if (e.nextSibling && Rm(e.nextSibling) && e.nextSibling.__ln.previous) {
      const s = e.nextSibling.__ln.previous;
      n.previous = s, n.next = e.nextSibling.__ln, e.nextSibling.__ln.previous = n, s && (s.next = n);
    } else
      this.head && (this.head.previous = n), n.next = this.head, this.head = n;
    n.next === null && (this.tail = n), this.length++;
  }
  removeNode(e) {
    const n = e.__ln;
    this.head && (n.previous ? (n.previous.next = n.next, n.next ? n.next.previous = n.previous : this.tail = n.previous) : (this.head = n.next, this.head ? this.head.previous = null : this.tail = null), e.__ln && delete e.__ln, this.length--);
  }
}
const xm = (t, e) => `${t}@${e}`;
class dG {
  constructor() {
    this.frozen = !1, this.locked = !1, this.texts = [], this.attributes = [], this.attributeMap = /* @__PURE__ */ new WeakMap(), this.removes = [], this.mapRemoves = [], this.movedMap = {}, this.addedSet = /* @__PURE__ */ new Set(), this.movedSet = /* @__PURE__ */ new Set(), this.droppedSet = /* @__PURE__ */ new Set(), this.processMutations = (e) => {
      e.forEach(this.processMutation), this.emit();
    }, this.emit = () => {
      if (this.frozen || this.locked)
        return;
      const e = [], n = /* @__PURE__ */ new Set(), s = new lG(), r = (c) => {
        let l = c, d = Wi;
        for (; d === Wi; )
          l = l && l.nextSibling, d = l && this.mirror.getId(l);
        return d;
      }, i = (c) => {
        if (!c.parentNode || !BE(c))
          return;
        const l = wi(c.parentNode) ? this.mirror.getId(GE(c)) : this.mirror.getId(c.parentNode), d = r(c);
        if (l === -1 || d === -1)
          return s.addNode(c);
        const u = ar(c, {
          doc: this.doc,
          mirror: this.mirror,
          blockClass: this.blockClass,
          blockSelector: this.blockSelector,
          maskAllText: this.maskAllText,
          unblockSelector: this.unblockSelector,
          maskTextClass: this.maskTextClass,
          unmaskTextClass: this.unmaskTextClass,
          maskTextSelector: this.maskTextSelector,
          unmaskTextSelector: this.unmaskTextSelector,
          skipChild: !0,
          newlyAddedElement: !0,
          inlineStylesheet: this.inlineStylesheet,
          maskInputOptions: this.maskInputOptions,
          maskAttributeFn: this.maskAttributeFn,
          maskTextFn: this.maskTextFn,
          maskInputFn: this.maskInputFn,
          slimDOMOptions: this.slimDOMOptions,
          dataURLOptions: this.dataURLOptions,
          recordCanvas: this.recordCanvas,
          inlineImages: this.inlineImages,
          onSerialize: (h) => {
            ME(h, this.mirror) && !nt(h, this.blockClass, this.blockSelector, this.unblockSelector, !1) && this.iframeManager.addIframe(h), DE(h, this.mirror) && this.stylesheetManager.trackLinkElement(h), Pd(c) && this.shadowDomManager.addShadowRoot(c.shadowRoot, this.doc);
          },
          onIframeLoad: (h, p) => {
            nt(h, this.blockClass, this.blockSelector, this.unblockSelector, !1) || (this.iframeManager.attachIframe(h, p), h.contentWindow && this.canvasManager.addWindow(h.contentWindow), this.shadowDomManager.observeAttachShadow(h));
          },
          onStylesheetLoad: (h, p) => {
            this.stylesheetManager.attachLinkElement(h, p);
          }
        });
        u && (e.push({
          parentId: l,
          nextId: d,
          node: u
        }), n.add(u.id));
      };
      for (; this.mapRemoves.length; )
        this.mirror.removeNodeFromMap(this.mapRemoves.shift());
      for (const c of this.movedSet)
        Om(this.removes, c, this.mirror) && !this.movedSet.has(c.parentNode) || i(c);
      for (const c of this.addedSet)
        !Pm(this.droppedSet, c) && !Om(this.removes, c, this.mirror) || Pm(this.movedSet, c) ? i(c) : this.droppedSet.add(c);
      let o = null;
      for (; s.length; ) {
        let c = null;
        if (o) {
          const l = this.mirror.getId(o.value.parentNode), d = r(o.value);
          l !== -1 && d !== -1 && (c = o);
        }
        if (!c) {
          let l = s.tail;
          for (; l; ) {
            const d = l;
            if (l = l.previous, d) {
              const u = this.mirror.getId(d.value.parentNode);
              if (r(d.value) === -1)
                continue;
              if (u !== -1) {
                c = d;
                break;
              } else {
                const p = d.value;
                if (p.parentNode && p.parentNode.nodeType === Node.DOCUMENT_FRAGMENT_NODE) {
                  const f = p.parentNode.host;
                  if (this.mirror.getId(f) !== -1) {
                    c = d;
                    break;
                  }
                }
              }
            }
          }
        }
        if (!c) {
          for (; s.head; )
            s.removeNode(s.head.value);
          break;
        }
        o = c.previous, s.removeNode(c.value), i(c.value);
      }
      const a = {
        texts: this.texts.map((c) => ({
          id: this.mirror.getId(c.node),
          value: c.value
        })).filter((c) => !n.has(c.id)).filter((c) => this.mirror.has(c.id)),
        attributes: this.attributes.map((c) => {
          const { attributes: l } = c;
          if (typeof l.style == "string") {
            const d = JSON.stringify(c.styleDiff), u = JSON.stringify(c._unchangedStyles);
            d.length < l.style.length && (d + u).split("var(").length === l.style.split("var(").length && (l.style = c.styleDiff);
          }
          return {
            id: this.mirror.getId(c.node),
            attributes: l
          };
        }).filter((c) => !n.has(c.id)).filter((c) => this.mirror.has(c.id)),
        removes: this.removes,
        adds: e
      };
      !a.texts.length && !a.attributes.length && !a.removes.length && !a.adds.length || (this.texts = [], this.attributes = [], this.attributeMap = /* @__PURE__ */ new WeakMap(), this.removes = [], this.addedSet = /* @__PURE__ */ new Set(), this.movedSet = /* @__PURE__ */ new Set(), this.droppedSet = /* @__PURE__ */ new Set(), this.movedMap = {}, this.mutationCb(a));
    }, this.processMutation = (e) => {
      if (!Fl(e.target, this.mirror))
        switch (e.type) {
          case "characterData": {
            const n = e.target.textContent;
            !nt(e.target, this.blockClass, this.blockSelector, this.unblockSelector, !1) && n !== e.oldValue && this.texts.push({
              value: Mr(e.target, this.maskTextClass, this.maskTextSelector, this.unmaskTextClass, this.unmaskTextSelector, this.maskAllText) && n ? this.maskTextFn ? this.maskTextFn(n, OE(e.target)) : n.replace(/[\S]/g, "*") : n,
              node: e.target
            });
            break;
          }
          case "attributes": {
            const n = e.target;
            let s = e.attributeName, r = e.target.getAttribute(s);
            if (s === "value") {
              const o = Ih(n), a = n.tagName;
              r = Xa(n, a, o);
              const c = Oc({
                maskInputOptions: this.maskInputOptions,
                tagName: a,
                type: o
              }), l = Mr(e.target, this.maskTextClass, this.maskTextSelector, this.unmaskTextClass, this.unmaskTextSelector, c);
              r = ji({
                isMasked: l,
                element: n,
                value: r,
                maskInputFn: this.maskInputFn
              });
            }
            if (nt(e.target, this.blockClass, this.blockSelector, this.unblockSelector, !1) || r === e.oldValue)
              return;
            let i = this.attributeMap.get(e.target);
            if (n.tagName === "IFRAME" && s === "src" && !this.keepIframeSrcFn(r))
              if (!n.contentDocument)
                s = "rr_src";
              else
                return;
            if (i || (i = {
              node: e.target,
              attributes: {},
              styleDiff: {},
              _unchangedStyles: {}
            }, this.attributes.push(i), this.attributeMap.set(e.target, i)), s === "type" && n.tagName === "INPUT" && (e.oldValue || "").toLowerCase() === "password" && n.setAttribute("data-rr-is-password", "true"), !AE(n.tagName, s) && (i.attributes[s] = kE(this.doc, Pr(n.tagName), Pr(s), r, n, this.maskAttributeFn), s === "style")) {
              if (!this.unattachedDoc)
                try {
                  this.unattachedDoc = document.implementation.createHTMLDocument();
                } catch {
                  this.unattachedDoc = this.doc;
                }
              const o = this.unattachedDoc.createElement("span");
              e.oldValue && o.setAttribute("style", e.oldValue);
              for (const a of Array.from(n.style)) {
                const c = n.style.getPropertyValue(a), l = n.style.getPropertyPriority(a);
                c !== o.style.getPropertyValue(a) || l !== o.style.getPropertyPriority(a) ? l === "" ? i.styleDiff[a] = c : i.styleDiff[a] = [c, l] : i._unchangedStyles[a] = [c, l];
              }
              for (const a of Array.from(o.style))
                n.style.getPropertyValue(a) === "" && (i.styleDiff[a] = !1);
            }
            break;
          }
          case "childList": {
            if (nt(e.target, this.blockClass, this.blockSelector, this.unblockSelector, !0))
              return;
            e.addedNodes.forEach((n) => this.genAdds(n, e.target)), e.removedNodes.forEach((n) => {
              const s = this.mirror.getId(n), r = wi(e.target) ? this.mirror.getId(e.target.host) : this.mirror.getId(e.target);
              nt(e.target, this.blockClass, this.blockSelector, this.unblockSelector, !1) || Fl(n, this.mirror) || !tG(n, this.mirror) || (this.addedSet.has(n) ? (Md(this.addedSet, n), this.droppedSet.add(n)) : this.addedSet.has(e.target) && s === -1 || PE(e.target, this.mirror) || (this.movedSet.has(n) && this.movedMap[xm(s, r)] ? Md(this.movedSet, n) : this.removes.push({
                parentId: r,
                id: s,
                isShadow: wi(e.target) && Ti(e.target) ? !0 : void 0
              })), this.mapRemoves.push(n));
            });
            break;
          }
        }
    }, this.genAdds = (e, n) => {
      if (!this.processedNodeManager.inOtherBuffer(e, this) && !(this.addedSet.has(e) || this.movedSet.has(e))) {
        if (this.mirror.hasNode(e)) {
          if (Fl(e, this.mirror))
            return;
          this.movedSet.add(e);
          let s = null;
          n && this.mirror.hasNode(n) && (s = this.mirror.getId(n)), s && s !== -1 && (this.movedMap[xm(this.mirror.getId(e), s)] = !0);
        } else
          this.addedSet.add(e), this.droppedSet.delete(e);
        nt(e, this.blockClass, this.blockSelector, this.unblockSelector, !1) || (e.childNodes.forEach((s) => this.genAdds(s)), Pd(e) && e.shadowRoot.childNodes.forEach((s) => {
          this.processedNodeManager.add(s, this), this.genAdds(s, e);
        }));
      }
    };
  }
  init(e) {
    [
      "mutationCb",
      "blockClass",
      "blockSelector",
      "unblockSelector",
      "maskAllText",
      "maskTextClass",
      "unmaskTextClass",
      "maskTextSelector",
      "unmaskTextSelector",
      "inlineStylesheet",
      "maskInputOptions",
      "maskAttributeFn",
      "maskTextFn",
      "maskInputFn",
      "keepIframeSrcFn",
      "recordCanvas",
      "inlineImages",
      "slimDOMOptions",
      "dataURLOptions",
      "doc",
      "mirror",
      "iframeManager",
      "stylesheetManager",
      "shadowDomManager",
      "canvasManager",
      "processedNodeManager"
    ].forEach((n) => {
      this[n] = e[n];
    });
  }
  freeze() {
    this.frozen = !0, this.canvasManager.freeze();
  }
  unfreeze() {
    this.frozen = !1, this.canvasManager.unfreeze(), this.emit();
  }
  isFrozen() {
    return this.frozen;
  }
  lock() {
    this.locked = !0, this.canvasManager.lock();
  }
  unlock() {
    this.locked = !1, this.canvasManager.unlock(), this.emit();
  }
  reset() {
    this.shadowDomManager.reset(), this.canvasManager.reset();
  }
}
function Md(t, e) {
  t.delete(e), e.childNodes.forEach((n) => Md(t, n));
}
function Om(t, e, n) {
  return t.length === 0 ? !1 : uG(t, e, n);
}
function uG(t, e, n) {
  let s = e.parentNode;
  for (; s; ) {
    const r = n.getId(s);
    if (t.some((i) => i.id === r))
      return !0;
    s = s.parentNode;
  }
  return !1;
}
function Pm(t, e) {
  return t.size === 0 ? !1 : $E(t, e);
}
function $E(t, e) {
  const { parentNode: n } = e;
  return n ? t.has(n) ? !0 : $E(t, n) : !1;
}
let Ii;
function hG(t) {
  Ii = t;
}
function pG() {
  Ii = void 0;
}
const te = (t) => Ii ? (...n) => {
  try {
    return t(...n);
  } catch (s) {
    if (Ii && Ii(s) === !0)
      return () => {
      };
    throw s;
  }
} : t;
function St(t) {
  let e, n = t[0], s = 1;
  for (; s < t.length; ) {
    const r = t[s], i = t[s + 1];
    if (s += 2, (r === "optionalAccess" || r === "optionalCall") && n == null)
      return;
    r === "access" || r === "optionalAccess" ? (e = n, n = i(n)) : (r === "call" || r === "optionalCall") && (n = i((...o) => n.call(e, ...o)), e = void 0);
  }
  return n;
}
const cr = [];
function vo(t) {
  try {
    if ("composedPath" in t) {
      const e = t.composedPath();
      if (e.length)
        return e[0];
    } else if ("path" in t && t.path.length)
      return t.path[0];
  } catch {
  }
  return t && t.target;
}
function VE(t, e) {
  const n = new dG();
  cr.push(n), n.init(t);
  let s = window.MutationObserver || window.__rrMutationObserver;
  const r = St([window, "optionalAccess", (o) => o.Zone, "optionalAccess", (o) => o.__symbol__, "optionalCall", (o) => o("MutationObserver")]);
  r && window[r] && (s = window[r]);
  const i = new s(te((o) => {
    t.onMutation && t.onMutation(o) === !1 || n.processMutations.bind(n)(o);
  }));
  return i.observe(e, {
    attributes: !0,
    attributeOldValue: !0,
    characterData: !0,
    characterDataOldValue: !0,
    childList: !0,
    subtree: !0
  }), i;
}
function fG({ mousemoveCb: t, sampling: e, doc: n, mirror: s }) {
  if (e.mousemove === !1)
    return () => {
    };
  const r = typeof e.mousemove == "number" ? e.mousemove : 50, i = typeof e.mousemoveCallback == "number" ? e.mousemoveCallback : 500;
  let o = [], a;
  const c = zi(te((u) => {
    const h = Date.now() - a;
    t(o.map((p) => (p.timeOffset -= h, p)), u), o = [], a = null;
  }), i), l = te(zi(te((u) => {
    const h = vo(u), { clientX: p, clientY: f } = Od(u) ? u.changedTouches[0] : u;
    a || (a = Qa()), o.push({
      x: p,
      y: f,
      id: s.getId(h),
      timeOffset: Qa() - a
    }), c(typeof DragEvent < "u" && u instanceof DragEvent ? V.Drag : u instanceof MouseEvent ? V.MouseMove : V.TouchMove);
  }), r, {
    trailing: !1
  })), d = [
    Ue("mousemove", l, n),
    Ue("touchmove", l, n),
    Ue("drag", l, n)
  ];
  return te(() => {
    d.forEach((u) => u());
  });
}
function mG({ mouseInteractionCb: t, doc: e, mirror: n, blockClass: s, blockSelector: r, unblockSelector: i, sampling: o }) {
  if (o.mouseInteraction === !1)
    return () => {
    };
  const a = o.mouseInteraction === !0 || o.mouseInteraction === void 0 ? {} : o.mouseInteraction, c = [];
  let l = null;
  const d = (u) => (h) => {
    const p = vo(h);
    if (nt(p, s, r, i, !0))
      return;
    let f = null, m = u;
    if ("pointerType" in h) {
      switch (h.pointerType) {
        case "mouse":
          f = Wt.Mouse;
          break;
        case "touch":
          f = Wt.Touch;
          break;
        case "pen":
          f = Wt.Pen;
          break;
      }
      f === Wt.Touch ? Ve[u] === Ve.MouseDown ? m = "TouchStart" : Ve[u] === Ve.MouseUp && (m = "TouchEnd") : Wt.Pen;
    } else Od(h) && (f = Wt.Touch);
    f !== null ? (l = f, (m.startsWith("Touch") && f === Wt.Touch || m.startsWith("Mouse") && f === Wt.Mouse) && (f = null)) : Ve[u] === Ve.Click && (f = l, l = null);
    const g = Od(h) ? h.changedTouches[0] : h;
    if (!g)
      return;
    const y = n.getId(p), { clientX: I, clientY: A } = g;
    te(t)({
      type: Ve[m],
      id: y,
      x: I,
      y: A,
      ...f !== null && { pointerType: f }
    });
  };
  return Object.keys(Ve).filter((u) => Number.isNaN(Number(u)) && !u.endsWith("_Departed") && a[u] !== !1).forEach((u) => {
    let h = Pr(u);
    const p = d(u);
    if (window.PointerEvent)
      switch (Ve[u]) {
        case Ve.MouseDown:
        case Ve.MouseUp:
          h = h.replace("mouse", "pointer");
          break;
        case Ve.TouchStart:
        case Ve.TouchEnd:
          return;
      }
    c.push(Ue(h, p, e));
  }), te(() => {
    c.forEach((u) => u());
  });
}
function UE({ scrollCb: t, doc: e, mirror: n, blockClass: s, blockSelector: r, unblockSelector: i, sampling: o }) {
  const a = te(zi(te((c) => {
    const l = vo(c);
    if (!l || nt(l, s, r, i, !0))
      return;
    const d = n.getId(l);
    if (l === e && e.defaultView) {
      const u = LE(e.defaultView);
      t({
        id: d,
        x: u.left,
        y: u.top
      });
    } else
      t({
        id: d,
        x: l.scrollLeft,
        y: l.scrollTop
      });
  }), o.scroll || 100));
  return Ue("scroll", a, e);
}
function gG({ viewportResizeCb: t }, { win: e }) {
  let n = -1, s = -1;
  const r = te(zi(te(() => {
    const i = RE(), o = xE();
    (n !== i || s !== o) && (t({
      width: Number(o),
      height: Number(i)
    }), n = i, s = o);
  }), 200));
  return Ue("resize", r, e);
}
const _G = ["INPUT", "TEXTAREA", "SELECT"], Mm = /* @__PURE__ */ new WeakMap();
function yG({ inputCb: t, doc: e, mirror: n, blockClass: s, blockSelector: r, unblockSelector: i, ignoreClass: o, ignoreSelector: a, maskInputOptions: c, maskInputFn: l, sampling: d, userTriggeredOnInput: u, maskTextClass: h, unmaskTextClass: p, maskTextSelector: f, unmaskTextSelector: m }) {
  function g(E) {
    let C = vo(E);
    const N = E.isTrusted, v = C && Rd(C.tagName);
    if (v === "OPTION" && (C = C.parentElement), !C || !v || _G.indexOf(v) < 0 || nt(C, s, r, i, !0))
      return;
    const k = C;
    if (k.classList.contains(o) || a && k.matches(a))
      return;
    const L = Ih(C);
    let $ = Xa(k, v, L), ee = !1;
    const pe = Oc({
      maskInputOptions: c,
      tagName: v,
      type: L
    }), R = Mr(C, h, f, p, m, pe);
    (L === "radio" || L === "checkbox") && (ee = C.checked), $ = ji({
      isMasked: R,
      element: C,
      value: $,
      maskInputFn: l
    }), y(C, u ? { text: $, isChecked: ee, userTriggered: N } : { text: $, isChecked: ee });
    const re = C.name;
    L === "radio" && re && ee && e.querySelectorAll(`input[type="radio"][name="${re}"]`).forEach((q) => {
      if (q !== C) {
        const ge = ji({
          isMasked: R,
          element: q,
          value: Xa(q, v, L),
          maskInputFn: l
        });
        y(q, u ? { text: ge, isChecked: !ee, userTriggered: !1 } : { text: ge, isChecked: !ee });
      }
    });
  }
  function y(E, C) {
    const N = Mm.get(E);
    if (!N || N.text !== C.text || N.isChecked !== C.isChecked) {
      Mm.set(E, C);
      const v = n.getId(E);
      te(t)({
        ...C,
        id: v
      });
    }
  }
  const A = (d.input === "last" ? ["change"] : ["input", "change"]).map((E) => Ue(E, te(g), e)), T = e.defaultView;
  if (!T)
    return () => {
      A.forEach((E) => E());
    };
  const F = T.Object.getOwnPropertyDescriptor(T.HTMLInputElement.prototype, "value"), _ = [
    [T.HTMLInputElement.prototype, "value"],
    [T.HTMLInputElement.prototype, "checked"],
    [T.HTMLSelectElement.prototype, "value"],
    [T.HTMLTextAreaElement.prototype, "value"],
    [T.HTMLSelectElement.prototype, "selectedIndex"],
    [T.HTMLOptionElement.prototype, "selected"]
  ];
  return F && F.set && A.push(..._.map((E) => NE(E[0], E[1], {
    set() {
      te(g)({
        target: this,
        isTrusted: !1
      });
    }
  }, !1, T))), te(() => {
    A.forEach((E) => E());
  });
}
function Za(t) {
  const e = [];
  function n(s, r) {
    if (zo("CSSGroupingRule") && s.parentRule instanceof CSSGroupingRule || zo("CSSMediaRule") && s.parentRule instanceof CSSMediaRule || zo("CSSSupportsRule") && s.parentRule instanceof CSSSupportsRule || zo("CSSConditionRule") && s.parentRule instanceof CSSConditionRule) {
      const o = Array.from(s.parentRule.cssRules).indexOf(s);
      r.unshift(o);
    } else if (s.parentStyleSheet) {
      const o = Array.from(s.parentStyleSheet.cssRules).indexOf(s);
      r.unshift(o);
    }
    return r;
  }
  return n(t, e);
}
function wn(t, e, n) {
  let s, r;
  return t ? (t.ownerNode ? s = e.getId(t.ownerNode) : r = n.getId(t), {
    styleId: r,
    id: s
  }) : {};
}
function EG({ styleSheetRuleCb: t, mirror: e, stylesheetManager: n }, { win: s }) {
  if (!s.CSSStyleSheet || !s.CSSStyleSheet.prototype)
    return () => {
    };
  const r = s.CSSStyleSheet.prototype.insertRule;
  s.CSSStyleSheet.prototype.insertRule = new Proxy(r, {
    apply: te((d, u, h) => {
      const [p, f] = h, { id: m, styleId: g } = wn(u, e, n.styleMirror);
      return (m && m !== -1 || g && g !== -1) && t({
        id: m,
        styleId: g,
        adds: [{ rule: p, index: f }]
      }), d.apply(u, h);
    })
  });
  const i = s.CSSStyleSheet.prototype.deleteRule;
  s.CSSStyleSheet.prototype.deleteRule = new Proxy(i, {
    apply: te((d, u, h) => {
      const [p] = h, { id: f, styleId: m } = wn(u, e, n.styleMirror);
      return (f && f !== -1 || m && m !== -1) && t({
        id: f,
        styleId: m,
        removes: [{ index: p }]
      }), d.apply(u, h);
    })
  });
  let o;
  s.CSSStyleSheet.prototype.replace && (o = s.CSSStyleSheet.prototype.replace, s.CSSStyleSheet.prototype.replace = new Proxy(o, {
    apply: te((d, u, h) => {
      const [p] = h, { id: f, styleId: m } = wn(u, e, n.styleMirror);
      return (f && f !== -1 || m && m !== -1) && t({
        id: f,
        styleId: m,
        replace: p
      }), d.apply(u, h);
    })
  }));
  let a;
  s.CSSStyleSheet.prototype.replaceSync && (a = s.CSSStyleSheet.prototype.replaceSync, s.CSSStyleSheet.prototype.replaceSync = new Proxy(a, {
    apply: te((d, u, h) => {
      const [p] = h, { id: f, styleId: m } = wn(u, e, n.styleMirror);
      return (f && f !== -1 || m && m !== -1) && t({
        id: f,
        styleId: m,
        replaceSync: p
      }), d.apply(u, h);
    })
  }));
  const c = {};
  qo("CSSGroupingRule") ? c.CSSGroupingRule = s.CSSGroupingRule : (qo("CSSMediaRule") && (c.CSSMediaRule = s.CSSMediaRule), qo("CSSConditionRule") && (c.CSSConditionRule = s.CSSConditionRule), qo("CSSSupportsRule") && (c.CSSSupportsRule = s.CSSSupportsRule));
  const l = {};
  return Object.entries(c).forEach(([d, u]) => {
    l[d] = {
      insertRule: u.prototype.insertRule,
      deleteRule: u.prototype.deleteRule
    }, u.prototype.insertRule = new Proxy(l[d].insertRule, {
      apply: te((h, p, f) => {
        const [m, g] = f, { id: y, styleId: I } = wn(p.parentStyleSheet, e, n.styleMirror);
        return (y && y !== -1 || I && I !== -1) && t({
          id: y,
          styleId: I,
          adds: [
            {
              rule: m,
              index: [
                ...Za(p),
                g || 0
              ]
            }
          ]
        }), h.apply(p, f);
      })
    }), u.prototype.deleteRule = new Proxy(l[d].deleteRule, {
      apply: te((h, p, f) => {
        const [m] = f, { id: g, styleId: y } = wn(p.parentStyleSheet, e, n.styleMirror);
        return (g && g !== -1 || y && y !== -1) && t({
          id: g,
          styleId: y,
          removes: [
            { index: [...Za(p), m] }
          ]
        }), h.apply(p, f);
      })
    });
  }), te(() => {
    s.CSSStyleSheet.prototype.insertRule = r, s.CSSStyleSheet.prototype.deleteRule = i, o && (s.CSSStyleSheet.prototype.replace = o), a && (s.CSSStyleSheet.prototype.replaceSync = a), Object.entries(c).forEach(([d, u]) => {
      u.prototype.insertRule = l[d].insertRule, u.prototype.deleteRule = l[d].deleteRule;
    });
  });
}
function HE({ mirror: t, stylesheetManager: e }, n) {
  let s = null;
  n.nodeName === "#document" ? s = t.getId(n) : s = t.getId(n.host);
  const r = n.nodeName === "#document" ? St([n, "access", (o) => o.defaultView, "optionalAccess", (o) => o.Document]) : St([n, "access", (o) => o.ownerDocument, "optionalAccess", (o) => o.defaultView, "optionalAccess", (o) => o.ShadowRoot]), i = St([r, "optionalAccess", (o) => o.prototype]) ? Object.getOwnPropertyDescriptor(St([r, "optionalAccess", (o) => o.prototype]), "adoptedStyleSheets") : void 0;
  return s === null || s === -1 || !r || !i ? () => {
  } : (Object.defineProperty(n, "adoptedStyleSheets", {
    configurable: i.configurable,
    enumerable: i.enumerable,
    get() {
      return St([i, "access", (o) => o.get, "optionalAccess", (o) => o.call, "call", (o) => o(this)]);
    },
    set(o) {
      const a = St([i, "access", (c) => c.set, "optionalAccess", (c) => c.call, "call", (c) => c(this, o)]);
      if (s !== null && s !== -1)
        try {
          e.adoptStyleSheets(o, s);
        } catch {
        }
      return a;
    }
  }), te(() => {
    Object.defineProperty(n, "adoptedStyleSheets", {
      configurable: i.configurable,
      enumerable: i.enumerable,
      get: i.get,
      set: i.set
    });
  }));
}
function bG({ styleDeclarationCb: t, mirror: e, ignoreCSSAttributes: n, stylesheetManager: s }, { win: r }) {
  const i = r.CSSStyleDeclaration.prototype.setProperty;
  r.CSSStyleDeclaration.prototype.setProperty = new Proxy(i, {
    apply: te((a, c, l) => {
      const [d, u, h] = l;
      if (n.has(d))
        return i.apply(c, [d, u, h]);
      const { id: p, styleId: f } = wn(St([c, "access", (m) => m.parentRule, "optionalAccess", (m) => m.parentStyleSheet]), e, s.styleMirror);
      return (p && p !== -1 || f && f !== -1) && t({
        id: p,
        styleId: f,
        set: {
          property: d,
          value: u,
          priority: h
        },
        index: Za(c.parentRule)
      }), a.apply(c, l);
    })
  });
  const o = r.CSSStyleDeclaration.prototype.removeProperty;
  return r.CSSStyleDeclaration.prototype.removeProperty = new Proxy(o, {
    apply: te((a, c, l) => {
      const [d] = l;
      if (n.has(d))
        return o.apply(c, [d]);
      const { id: u, styleId: h } = wn(St([c, "access", (p) => p.parentRule, "optionalAccess", (p) => p.parentStyleSheet]), e, s.styleMirror);
      return (u && u !== -1 || h && h !== -1) && t({
        id: u,
        styleId: h,
        remove: {
          property: d
        },
        index: Za(c.parentRule)
      }), a.apply(c, l);
    })
  }), te(() => {
    r.CSSStyleDeclaration.prototype.setProperty = i, r.CSSStyleDeclaration.prototype.removeProperty = o;
  });
}
function vG({ mediaInteractionCb: t, blockClass: e, blockSelector: n, unblockSelector: s, mirror: r, sampling: i, doc: o }) {
  const a = te((l) => zi(te((d) => {
    const u = vo(d);
    if (!u || nt(u, e, n, s, !0))
      return;
    const { currentTime: h, volume: p, muted: f, playbackRate: m } = u;
    t({
      type: l,
      id: r.getId(u),
      currentTime: h,
      volume: p,
      muted: f,
      playbackRate: m
    });
  }), i.media || 500)), c = [
    Ue("play", a(0), o),
    Ue("pause", a(1), o),
    Ue("seeked", a(2), o),
    Ue("volumechange", a(3), o),
    Ue("ratechange", a(4), o)
  ];
  return te(() => {
    c.forEach((l) => l());
  });
}
function SG({ fontCb: t, doc: e }) {
  const n = e.defaultView;
  if (!n)
    return () => {
    };
  const s = [], r = /* @__PURE__ */ new WeakMap(), i = n.FontFace;
  n.FontFace = function(c, l, d) {
    const u = new i(c, l, d);
    return r.set(u, {
      family: c,
      buffer: typeof l != "string",
      descriptors: d,
      fontSource: typeof l == "string" ? l : JSON.stringify(Array.from(new Uint8Array(l)))
    }), u;
  };
  const o = Fh(e.fonts, "add", function(a) {
    return function(c) {
      return Mc(te(() => {
        const l = r.get(c);
        l && (t(l), r.delete(c));
      }), 0), a.apply(this, [c]);
    };
  });
  return s.push(() => {
    n.FontFace = i;
  }), s.push(o), te(() => {
    s.forEach((a) => a());
  });
}
function wG(t) {
  const { doc: e, mirror: n, blockClass: s, blockSelector: r, unblockSelector: i, selectionCb: o } = t;
  let a = !0;
  const c = te(() => {
    const l = e.getSelection();
    if (!l || a && St([l, "optionalAccess", (h) => h.isCollapsed]))
      return;
    a = l.isCollapsed || !1;
    const d = [], u = l.rangeCount || 0;
    for (let h = 0; h < u; h++) {
      const p = l.getRangeAt(h), { startContainer: f, startOffset: m, endContainer: g, endOffset: y } = p;
      nt(f, s, r, i, !0) || nt(g, s, r, i, !0) || d.push({
        start: n.getId(f),
        startOffset: m,
        end: n.getId(g),
        endOffset: y
      });
    }
    o({ ranges: d });
  });
  return c(), Ue("selectionchange", c);
}
function TG({ doc: t, customElementCb: e }) {
  const n = t.defaultView;
  return !n || !n.customElements ? () => {
  } : Fh(n.customElements, "define", function(r) {
    return function(i, o, a) {
      try {
        e({
          define: {
            name: i
          }
        });
      } catch {
      }
      return r.apply(this, [i, o, a]);
    };
  });
}
function IG(t, e = {}) {
  const n = t.doc.defaultView;
  if (!n)
    return () => {
    };
  let s;
  t.recordDOM && (s = VE(t, t.doc));
  const r = fG(t), i = mG(t), o = UE(t), a = gG(t, {
    win: n
  }), c = yG(t), l = vG(t);
  let d = () => {
  }, u = () => {
  }, h = () => {
  }, p = () => {
  };
  t.recordDOM && (d = EG(t, { win: n }), u = HE(t, t.doc), h = bG(t, {
    win: n
  }), t.collectFonts && (p = SG(t)));
  const f = wG(t), m = TG(t), g = [];
  for (const y of t.plugins)
    g.push(y.observer(y.callback, n, y.options));
  return te(() => {
    cr.forEach((y) => y.reset()), St([s, "optionalAccess", (y) => y.disconnect, "call", (y) => y()]), r(), i(), o(), a(), c(), l(), d(), u(), h(), p(), f(), m(), g.forEach((y) => y());
  });
}
function zo(t) {
  return typeof window[t] < "u";
}
function qo(t) {
  return !!(typeof window[t] < "u" && window[t].prototype && "insertRule" in window[t].prototype && "deleteRule" in window[t].prototype);
}
class Dd {
  constructor(e) {
    this.generateIdFn = e, this.iframeIdToRemoteIdMap = /* @__PURE__ */ new WeakMap(), this.iframeRemoteIdToIdMap = /* @__PURE__ */ new WeakMap();
  }
  getId(e, n, s, r) {
    const i = s || this.getIdToRemoteIdMap(e), o = r || this.getRemoteIdToIdMap(e);
    let a = i.get(n);
    return a || (a = this.generateIdFn(), i.set(n, a), o.set(a, n)), a;
  }
  getIds(e, n) {
    const s = this.getIdToRemoteIdMap(e), r = this.getRemoteIdToIdMap(e);
    return n.map((i) => this.getId(e, i, s, r));
  }
  getRemoteId(e, n, s) {
    const r = s || this.getRemoteIdToIdMap(e);
    if (typeof n != "number")
      return n;
    const i = r.get(n);
    return i || -1;
  }
  getRemoteIds(e, n) {
    const s = this.getRemoteIdToIdMap(e);
    return n.map((r) => this.getRemoteId(e, r, s));
  }
  reset(e) {
    if (!e) {
      this.iframeIdToRemoteIdMap = /* @__PURE__ */ new WeakMap(), this.iframeRemoteIdToIdMap = /* @__PURE__ */ new WeakMap();
      return;
    }
    this.iframeIdToRemoteIdMap.delete(e), this.iframeRemoteIdToIdMap.delete(e);
  }
  getIdToRemoteIdMap(e) {
    let n = this.iframeIdToRemoteIdMap.get(e);
    return n || (n = /* @__PURE__ */ new Map(), this.iframeIdToRemoteIdMap.set(e, n)), n;
  }
  getRemoteIdToIdMap(e) {
    let n = this.iframeRemoteIdToIdMap.get(e);
    return n || (n = /* @__PURE__ */ new Map(), this.iframeRemoteIdToIdMap.set(e, n)), n;
  }
}
function Dm(t) {
  let e, n = t[0], s = 1;
  for (; s < t.length; ) {
    const r = t[s], i = t[s + 1];
    if (s += 2, (r === "optionalAccess" || r === "optionalCall") && n == null)
      return;
    r === "access" || r === "optionalAccess" ? (e = n, n = i(n)) : (r === "call" || r === "optionalCall") && (n = i((...o) => n.call(e, ...o)), e = void 0);
  }
  return n;
}
class CG {
  constructor() {
    this.crossOriginIframeMirror = new Dd(Ch), this.crossOriginIframeRootIdMap = /* @__PURE__ */ new WeakMap();
  }
  addIframe() {
  }
  addLoadListener() {
  }
  attachIframe() {
  }
}
class FG {
  constructor(e) {
    this.iframes = /* @__PURE__ */ new WeakMap(), this.crossOriginIframeMap = /* @__PURE__ */ new WeakMap(), this.crossOriginIframeMirror = new Dd(Ch), this.crossOriginIframeRootIdMap = /* @__PURE__ */ new WeakMap(), this.mutationCb = e.mutationCb, this.wrappedEmit = e.wrappedEmit, this.stylesheetManager = e.stylesheetManager, this.recordCrossOriginIframes = e.recordCrossOriginIframes, this.crossOriginIframeStyleMirror = new Dd(this.stylesheetManager.styleMirror.generateId.bind(this.stylesheetManager.styleMirror)), this.mirror = e.mirror, this.recordCrossOriginIframes && window.addEventListener("message", this.handleMessage.bind(this));
  }
  addIframe(e) {
    this.iframes.set(e, !0), e.contentWindow && this.crossOriginIframeMap.set(e.contentWindow, e);
  }
  addLoadListener(e) {
    this.loadListener = e;
  }
  attachIframe(e, n) {
    this.mutationCb({
      adds: [
        {
          parentId: this.mirror.getId(e),
          nextId: null,
          node: n
        }
      ],
      removes: [],
      texts: [],
      attributes: [],
      isAttachIframe: !0
    }), Dm([this, "access", (s) => s.loadListener, "optionalCall", (s) => s(e)]), e.contentDocument && e.contentDocument.adoptedStyleSheets && e.contentDocument.adoptedStyleSheets.length > 0 && this.stylesheetManager.adoptStyleSheets(e.contentDocument.adoptedStyleSheets, this.mirror.getId(e.contentDocument));
  }
  handleMessage(e) {
    const n = e;
    if (n.data.type !== "rrweb" || n.origin !== n.data.origin || !e.source)
      return;
    const r = this.crossOriginIframeMap.get(e.source);
    if (!r)
      return;
    const i = this.transformCrossOriginEvent(r, n.data.event);
    i && this.wrappedEmit(i, n.data.isCheckout);
  }
  transformCrossOriginEvent(e, n) {
    switch (n.type) {
      case W.FullSnapshot: {
        this.crossOriginIframeMirror.reset(e), this.crossOriginIframeStyleMirror.reset(e), this.replaceIdOnNode(n.data.node, e);
        const s = n.data.node.id;
        return this.crossOriginIframeRootIdMap.set(e, s), this.patchRootIdOnNode(n.data.node, s), {
          timestamp: n.timestamp,
          type: W.IncrementalSnapshot,
          data: {
            source: V.Mutation,
            adds: [
              {
                parentId: this.mirror.getId(e),
                nextId: null,
                node: n.data.node
              }
            ],
            removes: [],
            texts: [],
            attributes: [],
            isAttachIframe: !0
          }
        };
      }
      case W.Meta:
      case W.Load:
      case W.DomContentLoaded:
        return !1;
      case W.Plugin:
        return n;
      case W.Custom:
        return this.replaceIds(n.data.payload, e, ["id", "parentId", "previousId", "nextId"]), n;
      case W.IncrementalSnapshot:
        switch (n.data.source) {
          case V.Mutation:
            return n.data.adds.forEach((s) => {
              this.replaceIds(s, e, [
                "parentId",
                "nextId",
                "previousId"
              ]), this.replaceIdOnNode(s.node, e);
              const r = this.crossOriginIframeRootIdMap.get(e);
              r && this.patchRootIdOnNode(s.node, r);
            }), n.data.removes.forEach((s) => {
              this.replaceIds(s, e, ["parentId", "id"]);
            }), n.data.attributes.forEach((s) => {
              this.replaceIds(s, e, ["id"]);
            }), n.data.texts.forEach((s) => {
              this.replaceIds(s, e, ["id"]);
            }), n;
          case V.Drag:
          case V.TouchMove:
          case V.MouseMove:
            return n.data.positions.forEach((s) => {
              this.replaceIds(s, e, ["id"]);
            }), n;
          case V.ViewportResize:
            return !1;
          case V.MediaInteraction:
          case V.MouseInteraction:
          case V.Scroll:
          case V.CanvasMutation:
          case V.Input:
            return this.replaceIds(n.data, e, ["id"]), n;
          case V.StyleSheetRule:
          case V.StyleDeclaration:
            return this.replaceIds(n.data, e, ["id"]), this.replaceStyleIds(n.data, e, ["styleId"]), n;
          case V.Font:
            return n;
          case V.Selection:
            return n.data.ranges.forEach((s) => {
              this.replaceIds(s, e, ["start", "end"]);
            }), n;
          case V.AdoptedStyleSheet:
            return this.replaceIds(n.data, e, ["id"]), this.replaceStyleIds(n.data, e, ["styleIds"]), Dm([n, "access", (s) => s.data, "access", (s) => s.styles, "optionalAccess", (s) => s.forEach, "call", (s) => s((r) => {
              this.replaceStyleIds(r, e, ["styleId"]);
            })]), n;
        }
    }
    return !1;
  }
  replace(e, n, s, r) {
    for (const i of r)
      !Array.isArray(n[i]) && typeof n[i] != "number" || (Array.isArray(n[i]) ? n[i] = e.getIds(s, n[i]) : n[i] = e.getId(s, n[i]));
    return n;
  }
  replaceIds(e, n, s) {
    return this.replace(this.crossOriginIframeMirror, e, n, s);
  }
  replaceStyleIds(e, n, s) {
    return this.replace(this.crossOriginIframeStyleMirror, e, n, s);
  }
  replaceIdOnNode(e, n) {
    this.replaceIds(e, n, ["id", "rootId"]), "childNodes" in e && e.childNodes.forEach((s) => {
      this.replaceIdOnNode(s, n);
    });
  }
  patchRootIdOnNode(e, n) {
    e.type !== we.Document && !e.rootId && (e.rootId = n), "childNodes" in e && e.childNodes.forEach((s) => {
      this.patchRootIdOnNode(s, n);
    });
  }
}
class kG {
  init() {
  }
  addShadowRoot() {
  }
  observeAttachShadow() {
  }
  reset() {
  }
}
class AG {
  constructor(e) {
    this.shadowDoms = /* @__PURE__ */ new WeakSet(), this.restoreHandlers = [], this.mutationCb = e.mutationCb, this.scrollCb = e.scrollCb, this.bypassOptions = e.bypassOptions, this.mirror = e.mirror, this.init();
  }
  init() {
    this.reset(), this.patchAttachShadow(Element, document);
  }
  addShadowRoot(e, n) {
    if (!Ti(e) || this.shadowDoms.has(e))
      return;
    this.shadowDoms.add(e), this.bypassOptions.canvasManager.addShadowRoot(e);
    const s = VE({
      ...this.bypassOptions,
      doc: n,
      mutationCb: this.mutationCb,
      mirror: this.mirror,
      shadowDomManager: this
    }, e);
    this.restoreHandlers.push(() => s.disconnect()), this.restoreHandlers.push(UE({
      ...this.bypassOptions,
      scrollCb: this.scrollCb,
      doc: e,
      mirror: this.mirror
    })), Mc(() => {
      e.adoptedStyleSheets && e.adoptedStyleSheets.length > 0 && this.bypassOptions.stylesheetManager.adoptStyleSheets(e.adoptedStyleSheets, this.mirror.getId(e.host)), this.restoreHandlers.push(HE({
        mirror: this.mirror,
        stylesheetManager: this.bypassOptions.stylesheetManager
      }, e));
    }, 0);
  }
  observeAttachShadow(e) {
    !e.contentWindow || !e.contentDocument || this.patchAttachShadow(e.contentWindow.Element, e.contentDocument);
  }
  patchAttachShadow(e, n) {
    const s = this;
    this.restoreHandlers.push(Fh(e.prototype, "attachShadow", function(r) {
      return function(i) {
        const o = r.call(this, i);
        return this.shadowRoot && BE(this) && s.addShadowRoot(this.shadowRoot, n), o;
      };
    }));
  }
  reset() {
    this.restoreHandlers.forEach((e) => {
      try {
        e();
      } catch {
      }
    }), this.restoreHandlers = [], this.shadowDoms = /* @__PURE__ */ new WeakSet(), this.bypassOptions.canvasManager.resetShadowRoots();
  }
}
class Gm {
  reset() {
  }
  freeze() {
  }
  unfreeze() {
  }
  lock() {
  }
  unlock() {
  }
  snapshot() {
  }
  addWindow() {
  }
  addShadowRoot() {
  }
  resetShadowRoots() {
  }
}
class NG {
  constructor(e) {
    this.trackedLinkElements = /* @__PURE__ */ new WeakSet(), this.styleMirror = new sG(), this.mutationCb = e.mutationCb, this.adoptedStyleSheetCb = e.adoptedStyleSheetCb;
  }
  attachLinkElement(e, n) {
    "_cssText" in n.attributes && this.mutationCb({
      adds: [],
      removes: [],
      texts: [],
      attributes: [
        {
          id: n.id,
          attributes: n.attributes
        }
      ]
    }), this.trackLinkElement(e);
  }
  trackLinkElement(e) {
    this.trackedLinkElements.has(e) || (this.trackedLinkElements.add(e), this.trackStylesheetInLinkElement(e));
  }
  adoptStyleSheets(e, n) {
    if (e.length === 0)
      return;
    const s = {
      id: n,
      styleIds: []
    }, r = [];
    for (const i of e) {
      let o;
      this.styleMirror.has(i) ? o = this.styleMirror.getId(i) : (o = this.styleMirror.add(i), r.push({
        styleId: o,
        rules: Array.from(i.rules || CSSRule, (a, c) => ({
          rule: wE(a),
          index: c
        }))
      })), s.styleIds.push(o);
    }
    r.length > 0 && (s.styles = r), this.adoptedStyleSheetCb(s);
  }
  reset() {
    this.styleMirror.reset(), this.trackedLinkElements = /* @__PURE__ */ new WeakSet();
  }
  trackStylesheetInLinkElement(e) {
  }
}
class LG {
  constructor() {
    this.nodeMap = /* @__PURE__ */ new WeakMap(), this.active = !1;
  }
  inOtherBuffer(e, n) {
    const s = this.nodeMap.get(e);
    return s && Array.from(s).some((r) => r !== n);
  }
  add(e, n) {
    this.active || (this.active = !0, oG(() => {
      this.nodeMap = /* @__PURE__ */ new WeakMap(), this.active = !1;
    })), this.nodeMap.set(e, (this.nodeMap.get(e) || /* @__PURE__ */ new Set()).add(n));
  }
  destroy() {
  }
}
let _e, ec;
try {
  if (Array.from([1], (t) => t * 2)[0] !== 2) {
    const t = document.createElement("iframe");
    document.body.appendChild(t), Array.from = st([t, "access", (e) => e.contentWindow, "optionalAccess", (e) => e.Array, "access", (e) => e.from]) || Array.from, document.body.removeChild(t);
  }
} catch (t) {
  console.debug("Unable to override Array.from", t);
}
const vt = LD();
function sn(t = {}) {
  const { emit: e, checkoutEveryNms: n, checkoutEveryNth: s, blockClass: r = "rr-block", blockSelector: i = null, unblockSelector: o = null, ignoreClass: a = "rr-ignore", ignoreSelector: c = null, maskAllText: l = !1, maskTextClass: d = "rr-mask", unmaskTextClass: u = null, maskTextSelector: h = null, unmaskTextSelector: p = null, inlineStylesheet: f = !0, maskAllInputs: m, maskInputOptions: g, slimDOMOptions: y, maskAttributeFn: I, maskInputFn: A, maskTextFn: T, maxCanvasSize: F = null, packFn: _, sampling: E = {}, dataURLOptions: C = {}, mousemoveWait: N, recordDOM: v = !0, recordCanvas: k = !1, recordCrossOriginIframes: L = !1, recordAfter: $ = t.recordAfter === "DOMContentLoaded" ? t.recordAfter : "load", userTriggeredOnInput: ee = !1, collectFonts: pe = !1, inlineImages: R = !1, plugins: re, keepIframeSrcFn: q = () => !1, ignoreCSSAttributes: ge = /* @__PURE__ */ new Set([]), errorHandler: Xe, onMutation: Bs, getCanvasManager: es } = t;
  hG(Xe);
  const Vt = L ? window.parent === window : !0;
  let ct = !1;
  if (!Vt)
    try {
      window.parent.document && (ct = !1);
    } catch {
      ct = !0;
    }
  if (Vt && !e)
    throw new Error("emit function is required");
  if (!Vt && !ct)
    return () => {
    };
  N !== void 0 && E.mousemove === void 0 && (E.mousemove = N), vt.reset();
  const lt = m === !0 ? {
    color: !0,
    date: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0,
    textarea: !0,
    select: !0,
    radio: !0,
    checkbox: !0
  } : g !== void 0 ? g : {}, Ut = y === !0 || y === "all" ? {
    script: !0,
    comment: !0,
    headFavicon: !0,
    headWhitespace: !0,
    headMetaSocial: !0,
    headMetaRobots: !0,
    headMetaHttpEquiv: !0,
    headMetaVerification: !0,
    headMetaAuthorship: y === "all",
    headMetaDescKeywords: y === "all"
  } : y || {};
  nG();
  let yn, bt = 0;
  const $s = (j) => {
    for (const Ge of re || [])
      Ge.eventProcessor && (j = Ge.eventProcessor(j));
    return _ && !ct && (j = _(j)), j;
  };
  _e = (j, Ge) => {
    const Y = j;
    if (Y.timestamp = Qa(), st([cr, "access", (ae) => ae[0], "optionalAccess", (ae) => ae.isFrozen, "call", (ae) => ae()]) && Y.type !== W.FullSnapshot && !(Y.type === W.IncrementalSnapshot && Y.data.source === V.Mutation) && cr.forEach((ae) => ae.unfreeze()), Vt)
      st([e, "optionalCall", (ae) => ae($s(Y), Ge)]);
    else if (ct) {
      const ae = {
        type: "rrweb",
        event: $s(Y),
        origin: window.location.origin,
        isCheckout: Ge
      };
      window.parent.postMessage(ae, "*");
    }
    if (Y.type === W.FullSnapshot)
      yn = Y, bt = 0;
    else if (Y.type === W.IncrementalSnapshot) {
      if (Y.data.source === V.Mutation && Y.data.isAttachIframe)
        return;
      bt++;
      const ae = s && bt >= s, Q = n && yn && Y.timestamp - yn.timestamp > n;
      (ae || Q) && ti(!0);
    }
  };
  const Vs = (j) => {
    _e({
      type: W.IncrementalSnapshot,
      data: {
        source: V.Mutation,
        ...j
      }
    });
  }, Us = (j) => _e({
    type: W.IncrementalSnapshot,
    data: {
      source: V.Scroll,
      ...j
    }
  }), Vc = (j) => _e({
    type: W.IncrementalSnapshot,
    data: {
      source: V.CanvasMutation,
      ...j
    }
  }), wo = (j) => _e({
    type: W.IncrementalSnapshot,
    data: {
      source: V.AdoptedStyleSheet,
      ...j
    }
  }), Ht = new NG({
    mutationCb: Vs,
    adoptedStyleSheetCb: wo
  }), jt = typeof __RRWEB_EXCLUDE_IFRAME__ == "boolean" && __RRWEB_EXCLUDE_IFRAME__ ? new CG() : new FG({
    mirror: vt,
    mutationCb: Vs,
    stylesheetManager: Ht,
    recordCrossOriginIframes: L,
    wrappedEmit: _e
  });
  for (const j of re || [])
    j.getMirror && j.getMirror({
      nodeMirror: vt,
      crossOriginIframeMirror: jt.crossOriginIframeMirror,
      crossOriginIframeStyleMirror: jt.crossOriginIframeStyleMirror
    });
  const Hs = new LG(), js = xG(es, {
    mirror: vt,
    win: window,
    mutationCb: (j) => _e({
      type: W.IncrementalSnapshot,
      data: {
        source: V.CanvasMutation,
        ...j
      }
    }),
    recordCanvas: k,
    blockClass: r,
    blockSelector: i,
    unblockSelector: o,
    maxCanvasSize: F,
    sampling: E.canvas,
    dataURLOptions: C,
    errorHandler: Xe
  }), Ws = typeof __RRWEB_EXCLUDE_SHADOW_DOM__ == "boolean" && __RRWEB_EXCLUDE_SHADOW_DOM__ ? new kG() : new AG({
    mutationCb: Vs,
    scrollCb: Us,
    bypassOptions: {
      onMutation: Bs,
      blockClass: r,
      blockSelector: i,
      unblockSelector: o,
      maskAllText: l,
      maskTextClass: d,
      unmaskTextClass: u,
      maskTextSelector: h,
      unmaskTextSelector: p,
      inlineStylesheet: f,
      maskInputOptions: lt,
      dataURLOptions: C,
      maskAttributeFn: I,
      maskTextFn: T,
      maskInputFn: A,
      recordCanvas: k,
      inlineImages: R,
      sampling: E,
      slimDOMOptions: Ut,
      iframeManager: jt,
      stylesheetManager: Ht,
      canvasManager: js,
      keepIframeSrcFn: q,
      processedNodeManager: Hs
    },
    mirror: vt
  }), ti = (j = !1) => {
    if (!v)
      return;
    _e({
      type: W.Meta,
      data: {
        href: window.location.href,
        width: xE(),
        height: RE()
      }
    }, j), Ht.reset(), Ws.init(), cr.forEach((Y) => Y.lock());
    const Ge = eG(document, {
      mirror: vt,
      blockClass: r,
      blockSelector: i,
      unblockSelector: o,
      maskAllText: l,
      maskTextClass: d,
      unmaskTextClass: u,
      maskTextSelector: h,
      unmaskTextSelector: p,
      inlineStylesheet: f,
      maskAllInputs: lt,
      maskAttributeFn: I,
      maskInputFn: A,
      maskTextFn: T,
      slimDOM: Ut,
      dataURLOptions: C,
      recordCanvas: k,
      inlineImages: R,
      onSerialize: (Y) => {
        ME(Y, vt) && jt.addIframe(Y), DE(Y, vt) && Ht.trackLinkElement(Y), Pd(Y) && Ws.addShadowRoot(Y.shadowRoot, document);
      },
      onIframeLoad: (Y, ae) => {
        jt.attachIframe(Y, ae), Y.contentWindow && js.addWindow(Y.contentWindow), Ws.observeAttachShadow(Y);
      },
      onStylesheetLoad: (Y, ae) => {
        Ht.attachLinkElement(Y, ae);
      },
      keepIframeSrcFn: q
    });
    if (!Ge)
      return console.warn("Failed to snapshot the document");
    _e({
      type: W.FullSnapshot,
      data: {
        node: Ge,
        initialOffset: LE(window)
      }
    }), cr.forEach((Y) => Y.unlock()), document.adoptedStyleSheets && document.adoptedStyleSheets.length > 0 && Ht.adoptStyleSheets(document.adoptedStyleSheets, vt.getId(document));
  };
  ec = ti;
  try {
    const j = [], Ge = (ae) => te(IG)({
      onMutation: Bs,
      mutationCb: Vs,
      mousemoveCb: (Q, At) => _e({
        type: W.IncrementalSnapshot,
        data: {
          source: At,
          positions: Q
        }
      }),
      mouseInteractionCb: (Q) => _e({
        type: W.IncrementalSnapshot,
        data: {
          source: V.MouseInteraction,
          ...Q
        }
      }),
      scrollCb: Us,
      viewportResizeCb: (Q) => _e({
        type: W.IncrementalSnapshot,
        data: {
          source: V.ViewportResize,
          ...Q
        }
      }),
      inputCb: (Q) => _e({
        type: W.IncrementalSnapshot,
        data: {
          source: V.Input,
          ...Q
        }
      }),
      mediaInteractionCb: (Q) => _e({
        type: W.IncrementalSnapshot,
        data: {
          source: V.MediaInteraction,
          ...Q
        }
      }),
      styleSheetRuleCb: (Q) => _e({
        type: W.IncrementalSnapshot,
        data: {
          source: V.StyleSheetRule,
          ...Q
        }
      }),
      styleDeclarationCb: (Q) => _e({
        type: W.IncrementalSnapshot,
        data: {
          source: V.StyleDeclaration,
          ...Q
        }
      }),
      canvasMutationCb: Vc,
      fontCb: (Q) => _e({
        type: W.IncrementalSnapshot,
        data: {
          source: V.Font,
          ...Q
        }
      }),
      selectionCb: (Q) => {
        _e({
          type: W.IncrementalSnapshot,
          data: {
            source: V.Selection,
            ...Q
          }
        });
      },
      customElementCb: (Q) => {
        _e({
          type: W.IncrementalSnapshot,
          data: {
            source: V.CustomElement,
            ...Q
          }
        });
      },
      blockClass: r,
      ignoreClass: a,
      ignoreSelector: c,
      maskAllText: l,
      maskTextClass: d,
      unmaskTextClass: u,
      maskTextSelector: h,
      unmaskTextSelector: p,
      maskInputOptions: lt,
      inlineStylesheet: f,
      sampling: E,
      recordDOM: v,
      recordCanvas: k,
      inlineImages: R,
      userTriggeredOnInput: ee,
      collectFonts: pe,
      doc: ae,
      maskAttributeFn: I,
      maskInputFn: A,
      maskTextFn: T,
      keepIframeSrcFn: q,
      blockSelector: i,
      unblockSelector: o,
      slimDOMOptions: Ut,
      dataURLOptions: C,
      mirror: vt,
      iframeManager: jt,
      stylesheetManager: Ht,
      shadowDomManager: Ws,
      processedNodeManager: Hs,
      canvasManager: js,
      ignoreCSSAttributes: ge,
      plugins: st([
        re,
        "optionalAccess",
        (Q) => Q.filter,
        "call",
        (Q) => Q((At) => At.observer),
        "optionalAccess",
        (Q) => Q.map,
        "call",
        (Q) => Q((At) => ({
          observer: At.observer,
          options: At.options,
          callback: (To) => _e({
            type: W.Plugin,
            data: {
              plugin: At.name,
              payload: To
            }
          })
        }))
      ]) || []
    }, {});
    jt.addLoadListener((ae) => {
      try {
        j.push(Ge(ae.contentDocument));
      } catch (Q) {
        console.warn(Q);
      }
    });
    const Y = () => {
      ti(), j.push(Ge(document));
    };
    return document.readyState === "interactive" || document.readyState === "complete" ? Y() : (j.push(Ue("DOMContentLoaded", () => {
      _e({
        type: W.DomContentLoaded,
        data: {}
      }), $ === "DOMContentLoaded" && Y();
    })), j.push(Ue("load", () => {
      _e({
        type: W.Load,
        data: {}
      }), $ === "load" && Y();
    }, window))), () => {
      j.forEach((ae) => ae()), Hs.destroy(), ec = void 0, pG();
    };
  } catch (j) {
    console.warn(j);
  }
}
function RG(t) {
  if (!ec)
    throw new Error("please take full snapshot after start recording");
  ec(t);
}
sn.mirror = vt;
sn.takeFullSnapshot = RG;
function xG(t, e) {
  try {
    return t ? t(e) : new Gm();
  } catch {
    return console.warn("Unable to initialize CanvasManager"), new Gm();
  }
}
const O = typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__, Bm = ["info", "warn", "error", "log"], la = "[Replay] ";
function kl(t, e = "info") {
  Wn(
    {
      category: "console",
      data: {
        logger: "replay"
      },
      level: e,
      message: `${la}${t}`
    },
    { level: e }
  );
}
function OG() {
  let t = !1, e = !1;
  const n = {
    exception: () => {
    },
    infoTick: () => {
    },
    setConfig: (s) => {
      t = s.captureExceptions, e = s.traceInternals;
    }
  };
  return O ? (Bm.forEach((s) => {
    n[s] = (...r) => {
      w[s](la, ...r), e && kl(r.join(""), Cy(s));
    };
  }), n.exception = (s, ...r) => {
    r.length && n.error && n.error(...r), w.error(la, s), t ? Yy(s) : e && kl(s, "error");
  }, n.infoTick = (...s) => {
    w.info(la, ...s), e && setTimeout(() => kl(s[0]), 0);
  }) : Bm.forEach((s) => {
    n[s] = () => {
    };
  }), n;
}
const D = OG(), PG = 3, MG = 5;
function Ah(t) {
  return t > 9999999999 ? t : t * 1e3;
}
function Al(t) {
  return t > 9999999999 ? t / 1e3 : t;
}
function So(t, e) {
  e.category !== "sentry.transaction" && (["ui.click", "ui.input"].includes(e.category) ? t.triggerUserActivity() : t.checkAndHandleExpiredSession(), t.addUpdate(() => (t.throttledAddEvent({
    type: W.Custom,
    // TODO: We were converting from ms to seconds for breadcrumbs, spans,
    // but maybe we should just keep them as milliseconds
    timestamp: (e.timestamp || 0) * 1e3,
    data: {
      tag: "breadcrumb",
      // normalize to max. 10 depth and 1_000 properties per object
      payload: Rt(e, 10, 1e3)
    }
  }), e.category === "console")));
}
const DG = "button,a";
function jE(t) {
  return t.closest(DG) || t;
}
function WE(t) {
  const e = zE(t);
  return !e || !(e instanceof Element) ? e : jE(e);
}
function zE(t) {
  return GG(t) ? t.target : t;
}
function GG(t) {
  return typeof t == "object" && !!t && "target" in t;
}
let Tn;
function BG(t) {
  return Tn || (Tn = [], $G()), Tn.push(t), () => {
    const e = Tn ? Tn.indexOf(t) : -1;
    e > -1 && Tn.splice(e, 1);
  };
}
function $G() {
  tt(le, "open", function(t) {
    return function(...e) {
      if (Tn)
        try {
          Tn.forEach((n) => n());
        } catch {
        }
      return t.apply(le, e);
    };
  });
}
const VG = /* @__PURE__ */ new Set([
  V.Mutation,
  V.StyleSheetRule,
  V.StyleDeclaration,
  V.AdoptedStyleSheet,
  V.CanvasMutation,
  V.Selection,
  V.MediaInteraction
]);
function UG(t, e, n) {
  t.handleClick(e, n);
}
class HG {
  // protected for testing
  constructor(e, n, s = So) {
    this._lastMutation = 0, this._lastScroll = 0, this._clicks = [], this._timeout = n.timeout / 1e3, this._threshold = n.threshold / 1e3, this._scrollTimeout = n.scrollTimeout / 1e3, this._replay = e, this._ignoreSelector = n.ignoreSelector, this._addBreadcrumbEvent = s;
  }
  /** Register click detection handlers on mutation or scroll. */
  addListeners() {
    const e = BG(() => {
      this._lastMutation = $m();
    });
    this._teardown = () => {
      e(), this._clicks = [], this._lastMutation = 0, this._lastScroll = 0;
    };
  }
  /** Clean up listeners. */
  removeListeners() {
    this._teardown && this._teardown(), this._checkClickTimeout && clearTimeout(this._checkClickTimeout);
  }
  /** @inheritDoc */
  handleClick(e, n) {
    if (WG(n, this._ignoreSelector) || !zG(e))
      return;
    const s = {
      timestamp: Al(e.timestamp),
      clickBreadcrumb: e,
      // Set this to 0 so we know it originates from the click breadcrumb
      clickCount: 0,
      node: n
    };
    this._clicks.some((r) => r.node === s.node && Math.abs(r.timestamp - s.timestamp) < 1) || (this._clicks.push(s), this._clicks.length === 1 && this._scheduleCheckClicks());
  }
  /** @inheritDoc */
  registerMutation(e = Date.now()) {
    this._lastMutation = Al(e);
  }
  /** @inheritDoc */
  registerScroll(e = Date.now()) {
    this._lastScroll = Al(e);
  }
  /** @inheritDoc */
  registerClick(e) {
    const n = jE(e);
    this._handleMultiClick(n);
  }
  /** Count multiple clicks on elements. */
  _handleMultiClick(e) {
    this._getClicks(e).forEach((n) => {
      n.clickCount++;
    });
  }
  /** Get all pending clicks for a given node. */
  _getClicks(e) {
    return this._clicks.filter((n) => n.node === e);
  }
  /** Check the clicks that happened. */
  _checkClicks() {
    const e = [], n = $m();
    this._clicks.forEach((s) => {
      !s.mutationAfter && this._lastMutation && (s.mutationAfter = s.timestamp <= this._lastMutation ? this._lastMutation - s.timestamp : void 0), !s.scrollAfter && this._lastScroll && (s.scrollAfter = s.timestamp <= this._lastScroll ? this._lastScroll - s.timestamp : void 0), s.timestamp + this._timeout <= n && e.push(s);
    });
    for (const s of e) {
      const r = this._clicks.indexOf(s);
      r > -1 && (this._generateBreadcrumbs(s), this._clicks.splice(r, 1));
    }
    this._clicks.length && this._scheduleCheckClicks();
  }
  /** Generate matching breadcrumb(s) for the click. */
  _generateBreadcrumbs(e) {
    const n = this._replay, s = e.scrollAfter && e.scrollAfter <= this._scrollTimeout, r = e.mutationAfter && e.mutationAfter <= this._threshold, i = !s && !r, { clickCount: o, clickBreadcrumb: a } = e;
    if (i) {
      const c = Math.min(e.mutationAfter || this._timeout, this._timeout) * 1e3, l = c < this._timeout * 1e3 ? "mutation" : "timeout", d = {
        type: "default",
        message: a.message,
        timestamp: a.timestamp,
        category: "ui.slowClickDetected",
        data: {
          ...a.data,
          url: le.location.href,
          route: n.getCurrentRoute(),
          timeAfterClickMs: c,
          endReason: l,
          // If clickCount === 0, it means multiClick was not correctly captured here
          // - we still want to send 1 in this case
          clickCount: o || 1
        }
      };
      this._addBreadcrumbEvent(n, d);
      return;
    }
    if (o > 1) {
      const c = {
        type: "default",
        message: a.message,
        timestamp: a.timestamp,
        category: "ui.multiClick",
        data: {
          ...a.data,
          url: le.location.href,
          route: n.getCurrentRoute(),
          clickCount: o,
          metric: !0
        }
      };
      this._addBreadcrumbEvent(n, c);
    }
  }
  /** Schedule to check current clicks. */
  _scheduleCheckClicks() {
    this._checkClickTimeout && clearTimeout(this._checkClickTimeout), this._checkClickTimeout = Or(() => this._checkClicks(), 1e3);
  }
}
const jG = ["A", "BUTTON", "INPUT"];
function WG(t, e) {
  return !!(!jG.includes(t.tagName) || t.tagName === "INPUT" && !["submit", "button"].includes(t.getAttribute("type") || "") || t.tagName === "A" && (t.hasAttribute("download") || t.hasAttribute("target") && t.getAttribute("target") !== "_self") || e && t.matches(e));
}
function zG(t) {
  return !!(t.data && typeof t.data.nodeId == "number" && t.timestamp);
}
function $m() {
  return Date.now() / 1e3;
}
function qG(t, e) {
  try {
    if (!YG(e))
      return;
    const { source: n } = e.data;
    if (VG.has(n) && t.registerMutation(e.timestamp), n === V.Scroll && t.registerScroll(e.timestamp), KG(e)) {
      const { type: s, id: r } = e.data, i = sn.mirror.getNode(r);
      i instanceof HTMLElement && s === Ve.Click && t.registerClick(i);
    }
  } catch {
  }
}
function YG(t) {
  return t.type === PG;
}
function KG(t) {
  return t.data.source === V.MouseInteraction;
}
function Ot(t) {
  return {
    timestamp: Date.now() / 1e3,
    type: "default",
    ...t
  };
}
var tc;
(function(t) {
  t[t.Document = 0] = "Document", t[t.DocumentType = 1] = "DocumentType", t[t.Element = 2] = "Element", t[t.Text = 3] = "Text", t[t.CDATA = 4] = "CDATA", t[t.Comment = 5] = "Comment";
})(tc || (tc = {}));
const XG = /* @__PURE__ */ new Set([
  "id",
  "class",
  "aria-label",
  "role",
  "name",
  "alt",
  "title",
  "data-test-id",
  "data-testid",
  "disabled",
  "aria-disabled",
  "data-sentry-component"
]);
function JG(t) {
  const e = {};
  !t["data-sentry-component"] && t["data-sentry-element"] && (t["data-sentry-component"] = t["data-sentry-element"]);
  for (const n in t)
    if (XG.has(n)) {
      let s = n;
      (n === "data-testid" || n === "data-test-id") && (s = "testId"), e[s] = t[n];
    }
  return e;
}
const QG = (t) => (e) => {
  if (!t.isEnabled())
    return;
  const n = ZG(e);
  if (!n)
    return;
  const s = e.name === "click", r = s ? e.event : void 0;
  s && t.clickDetector && r && r.target && !r.altKey && !r.metaKey && !r.ctrlKey && !r.shiftKey && UG(
    t.clickDetector,
    n,
    WE(e.event)
  ), So(t, n);
};
function qE(t, e) {
  const n = sn.mirror.getId(t), s = n && sn.mirror.getNode(n), r = s && sn.mirror.getMeta(s), i = r && t2(r) ? r : null;
  return {
    message: e,
    data: i ? {
      nodeId: n,
      node: {
        id: n,
        tagName: i.tagName,
        textContent: Array.from(i.childNodes).map((o) => o.type === tc.Text && o.textContent).filter(Boolean).map((o) => o.trim()).join(""),
        attributes: JG(i.attributes)
      }
    } : {}
  };
}
function ZG(t) {
  const { target: e, message: n } = e2(t);
  return Ot({
    category: `ui.${t.name}`,
    ...qE(e, n)
  });
}
function e2(t) {
  const e = t.name === "click";
  let n, s = null;
  try {
    s = e ? WE(t.event) : zE(t.event), n = dn(s, { maxStringLength: 200 }) || "<unknown>";
  } catch {
    n = "<unknown>";
  }
  return { target: s, message: n };
}
function t2(t) {
  return t.type === tc.Element;
}
function n2(t, e) {
  if (!t.isEnabled())
    return;
  t.updateUserActivity();
  const n = s2(e);
  n && So(t, n);
}
function s2(t) {
  const { metaKey: e, shiftKey: n, ctrlKey: s, altKey: r, key: i, target: o } = t;
  if (!o || r2(o) || !i)
    return null;
  const a = e || s || r, c = i.length === 1;
  if (!a && c)
    return null;
  const l = dn(o, { maxStringLength: 200 }) || "<unknown>", d = qE(o, l);
  return Ot({
    category: "ui.keyDown",
    message: l,
    data: {
      ...d.data,
      metaKey: e,
      shiftKey: n,
      ctrlKey: s,
      altKey: r,
      key: i
    }
  });
}
function r2(t) {
  return t.tagName === "INPUT" || t.tagName === "TEXTAREA" || t.isContentEditable;
}
const i2 = {
  // @ts-expect-error TODO: entry type does not fit the create* functions entry type
  resource: d2,
  paint: c2,
  // @ts-expect-error TODO: entry type does not fit the create* functions entry type
  navigation: l2
};
function Yo(t, e) {
  return ({ metric: n }) => void e.replayPerformanceEntries.push(t(n));
}
function o2(t) {
  return t.map(a2).filter(Boolean);
}
function a2(t) {
  const e = i2[t.entryType];
  return e ? e(t) : null;
}
function Dr(t) {
  return ((Ye || le.performance.timeOrigin) + t) / 1e3;
}
function c2(t) {
  const { duration: e, entryType: n, name: s, startTime: r } = t, i = Dr(r);
  return {
    type: n,
    name: s,
    start: i,
    end: i + e,
    data: void 0
  };
}
function l2(t) {
  const {
    entryType: e,
    name: n,
    decodedBodySize: s,
    duration: r,
    domComplete: i,
    encodedBodySize: o,
    domContentLoadedEventStart: a,
    domContentLoadedEventEnd: c,
    domInteractive: l,
    loadEventStart: d,
    loadEventEnd: u,
    redirectCount: h,
    startTime: p,
    transferSize: f,
    type: m
  } = t;
  return r === 0 ? null : {
    type: `${e}.${m}`,
    start: Dr(p),
    end: Dr(i),
    name: n,
    data: {
      size: f,
      decodedBodySize: s,
      encodedBodySize: o,
      duration: r,
      domInteractive: l,
      domContentLoadedEventStart: a,
      domContentLoadedEventEnd: c,
      loadEventStart: d,
      loadEventEnd: u,
      domComplete: i,
      redirectCount: h
    }
  };
}
function d2(t) {
  const {
    entryType: e,
    initiatorType: n,
    name: s,
    responseEnd: r,
    startTime: i,
    decodedBodySize: o,
    encodedBodySize: a,
    responseStatus: c,
    transferSize: l
  } = t;
  return ["fetch", "xmlhttprequest"].includes(n) ? null : {
    type: `${e}.${n}`,
    start: Dr(i),
    end: Dr(r),
    name: s,
    data: {
      size: l,
      statusCode: c,
      decodedBodySize: o,
      encodedBodySize: a
    }
  };
}
function u2(t) {
  const e = t.entries[t.entries.length - 1], n = e && e.element ? [e.element] : void 0;
  return Dc(t, "largest-contentful-paint", n);
}
function h2(t) {
  return t.sources !== void 0;
}
function p2(t) {
  const e = [], n = [];
  for (const s of t.entries)
    if (h2(s)) {
      const r = [];
      for (const i of s.sources)
        if (i.node) {
          n.push(i.node);
          const o = sn.mirror.getId(i.node);
          o && r.push(o);
        }
      e.push({ value: s.value, nodeIds: r.length ? r : void 0 });
    }
  return Dc(t, "cumulative-layout-shift", n, e);
}
function f2(t) {
  const e = t.entries[t.entries.length - 1], n = e && e.target ? [e.target] : void 0;
  return Dc(t, "first-input-delay", n);
}
function m2(t) {
  const e = t.entries[t.entries.length - 1], n = e && e.target ? [e.target] : void 0;
  return Dc(t, "interaction-to-next-paint", n);
}
function Dc(t, e, n, s) {
  const r = t.value, i = t.rating, o = Dr(r);
  return {
    type: "web-vital",
    name: e,
    start: o,
    end: o,
    data: {
      value: r,
      size: r,
      rating: i,
      nodeIds: n ? n.map((a) => sn.mirror.getId(a)) : void 0,
      attributions: s
    }
  };
}
function g2(t) {
  function e(r) {
    t.performanceEntries.includes(r) || t.performanceEntries.push(r);
  }
  function n({ entries: r }) {
    r.forEach(e);
  }
  const s = [];
  return ["navigation", "paint", "resource"].forEach((r) => {
    s.push(xr(r, n));
  }), s.push(
    hE(Yo(u2, t)),
    bh(Yo(p2, t)),
    pE(Yo(f2, t)),
    fE(Yo(m2, t))
  ), () => {
    s.forEach((r) => r());
  };
}
const _2 = 'var t=Uint8Array,n=Uint16Array,r=Int32Array,e=new t([0,0,0,0,0,0,0,0,1,1,1,1,2,2,2,2,3,3,3,3,4,4,4,4,5,5,5,5,0,0,0,0]),i=new t([0,0,0,0,1,1,2,2,3,3,4,4,5,5,6,6,7,7,8,8,9,9,10,10,11,11,12,12,13,13,0,0]),a=new t([16,17,18,0,8,7,9,6,10,5,11,4,12,3,13,2,14,1,15]),s=function(t,e){for(var i=new n(31),a=0;a<31;++a)i[a]=e+=1<<t[a-1];var s=new r(i[30]);for(a=1;a<30;++a)for(var o=i[a];o<i[a+1];++o)s[o]=o-i[a]<<5|a;return{b:i,r:s}},o=s(e,2),f=o.b,h=o.r;f[28]=258,h[258]=28;for(var l=s(i,0).r,u=new n(32768),c=0;c<32768;++c){var v=(43690&c)>>1|(21845&c)<<1;v=(61680&(v=(52428&v)>>2|(13107&v)<<2))>>4|(3855&v)<<4,u[c]=((65280&v)>>8|(255&v)<<8)>>1}var d=function(t,r,e){for(var i=t.length,a=0,s=new n(r);a<i;++a)t[a]&&++s[t[a]-1];var o,f=new n(r);for(a=1;a<r;++a)f[a]=f[a-1]+s[a-1]<<1;if(e){o=new n(1<<r);var h=15-r;for(a=0;a<i;++a)if(t[a])for(var l=a<<4|t[a],c=r-t[a],v=f[t[a]-1]++<<c,d=v|(1<<c)-1;v<=d;++v)o[u[v]>>h]=l}else for(o=new n(i),a=0;a<i;++a)t[a]&&(o[a]=u[f[t[a]-1]++]>>15-t[a]);return o},g=new t(288);for(c=0;c<144;++c)g[c]=8;for(c=144;c<256;++c)g[c]=9;for(c=256;c<280;++c)g[c]=7;for(c=280;c<288;++c)g[c]=8;var w=new t(32);for(c=0;c<32;++c)w[c]=5;var p=d(g,9,0),y=d(w,5,0),m=function(t){return(t+7)/8|0},b=function(n,r,e){return(null==e||e>n.length)&&(e=n.length),new t(n.subarray(r,e))},M=["unexpected EOF","invalid block type","invalid length/literal","invalid distance","stream finished","no stream handler",,"no callback","invalid UTF-8 data","extra field too long","date not in range 1980-2099","filename too long","stream finishing","invalid zip data"],E=function(t,n,r){var e=new Error(n||M[t]);if(e.code=t,Error.captureStackTrace&&Error.captureStackTrace(e,E),!r)throw e;return e},z=function(t,n,r){r<<=7&n;var e=n/8|0;t[e]|=r,t[e+1]|=r>>8},_=function(t,n,r){r<<=7&n;var e=n/8|0;t[e]|=r,t[e+1]|=r>>8,t[e+2]|=r>>16},x=function(r,e){for(var i=[],a=0;a<r.length;++a)r[a]&&i.push({s:a,f:r[a]});var s=i.length,o=i.slice();if(!s)return{t:F,l:0};if(1==s){var f=new t(i[0].s+1);return f[i[0].s]=1,{t:f,l:1}}i.sort((function(t,n){return t.f-n.f})),i.push({s:-1,f:25001});var h=i[0],l=i[1],u=0,c=1,v=2;for(i[0]={s:-1,f:h.f+l.f,l:h,r:l};c!=s-1;)h=i[i[u].f<i[v].f?u++:v++],l=i[u!=c&&i[u].f<i[v].f?u++:v++],i[c++]={s:-1,f:h.f+l.f,l:h,r:l};var d=o[0].s;for(a=1;a<s;++a)o[a].s>d&&(d=o[a].s);var g=new n(d+1),w=A(i[c-1],g,0);if(w>e){a=0;var p=0,y=w-e,m=1<<y;for(o.sort((function(t,n){return g[n.s]-g[t.s]||t.f-n.f}));a<s;++a){var b=o[a].s;if(!(g[b]>e))break;p+=m-(1<<w-g[b]),g[b]=e}for(p>>=y;p>0;){var M=o[a].s;g[M]<e?p-=1<<e-g[M]++-1:++a}for(;a>=0&&p;--a){var E=o[a].s;g[E]==e&&(--g[E],++p)}w=e}return{t:new t(g),l:w}},A=function(t,n,r){return-1==t.s?Math.max(A(t.l,n,r+1),A(t.r,n,r+1)):n[t.s]=r},D=function(t){for(var r=t.length;r&&!t[--r];);for(var e=new n(++r),i=0,a=t[0],s=1,o=function(t){e[i++]=t},f=1;f<=r;++f)if(t[f]==a&&f!=r)++s;else{if(!a&&s>2){for(;s>138;s-=138)o(32754);s>2&&(o(s>10?s-11<<5|28690:s-3<<5|12305),s=0)}else if(s>3){for(o(a),--s;s>6;s-=6)o(8304);s>2&&(o(s-3<<5|8208),s=0)}for(;s--;)o(a);s=1,a=t[f]}return{c:e.subarray(0,i),n:r}},T=function(t,n){for(var r=0,e=0;e<n.length;++e)r+=t[e]*n[e];return r},k=function(t,n,r){var e=r.length,i=m(n+2);t[i]=255&e,t[i+1]=e>>8,t[i+2]=255^t[i],t[i+3]=255^t[i+1];for(var a=0;a<e;++a)t[i+a+4]=r[a];return 8*(i+4+e)},U=function(t,r,s,o,f,h,l,u,c,v,m){z(r,m++,s),++f[256];for(var b=x(f,15),M=b.t,E=b.l,A=x(h,15),U=A.t,C=A.l,F=D(M),I=F.c,S=F.n,L=D(U),O=L.c,j=L.n,q=new n(19),B=0;B<I.length;++B)++q[31&I[B]];for(B=0;B<O.length;++B)++q[31&O[B]];for(var G=x(q,7),H=G.t,J=G.l,K=19;K>4&&!H[a[K-1]];--K);var N,P,Q,R,V=v+5<<3,W=T(f,g)+T(h,w)+l,X=T(f,M)+T(h,U)+l+14+3*K+T(q,H)+2*q[16]+3*q[17]+7*q[18];if(c>=0&&V<=W&&V<=X)return k(r,m,t.subarray(c,c+v));if(z(r,m,1+(X<W)),m+=2,X<W){N=d(M,E,0),P=M,Q=d(U,C,0),R=U;var Y=d(H,J,0);z(r,m,S-257),z(r,m+5,j-1),z(r,m+10,K-4),m+=14;for(B=0;B<K;++B)z(r,m+3*B,H[a[B]]);m+=3*K;for(var Z=[I,O],$=0;$<2;++$){var tt=Z[$];for(B=0;B<tt.length;++B){var nt=31&tt[B];z(r,m,Y[nt]),m+=H[nt],nt>15&&(z(r,m,tt[B]>>5&127),m+=tt[B]>>12)}}}else N=p,P=g,Q=y,R=w;for(B=0;B<u;++B){var rt=o[B];if(rt>255){_(r,m,N[(nt=rt>>18&31)+257]),m+=P[nt+257],nt>7&&(z(r,m,rt>>23&31),m+=e[nt]);var et=31&rt;_(r,m,Q[et]),m+=R[et],et>3&&(_(r,m,rt>>5&8191),m+=i[et])}else _(r,m,N[rt]),m+=P[rt]}return _(r,m,N[256]),m+P[256]},C=new r([65540,131080,131088,131104,262176,1048704,1048832,2114560,2117632]),F=new t(0),I=function(){for(var t=new Int32Array(256),n=0;n<256;++n){for(var r=n,e=9;--e;)r=(1&r&&-306674912)^r>>>1;t[n]=r}return t}(),S=function(){var t=-1;return{p:function(n){for(var r=t,e=0;e<n.length;++e)r=I[255&r^n[e]]^r>>>8;t=r},d:function(){return~t}}},L=function(){var t=1,n=0;return{p:function(r){for(var e=t,i=n,a=0|r.length,s=0;s!=a;){for(var o=Math.min(s+2655,a);s<o;++s)i+=e+=r[s];e=(65535&e)+15*(e>>16),i=(65535&i)+15*(i>>16)}t=e,n=i},d:function(){return(255&(t%=65521))<<24|(65280&t)<<8|(255&(n%=65521))<<8|n>>8}}},O=function(a,s,o,f,u){if(!u&&(u={l:1},s.dictionary)){var c=s.dictionary.subarray(-32768),v=new t(c.length+a.length);v.set(c),v.set(a,c.length),a=v,u.w=c.length}return function(a,s,o,f,u,c){var v=c.z||a.length,d=new t(f+v+5*(1+Math.ceil(v/7e3))+u),g=d.subarray(f,d.length-u),w=c.l,p=7&(c.r||0);if(s){p&&(g[0]=c.r>>3);for(var y=C[s-1],M=y>>13,E=8191&y,z=(1<<o)-1,_=c.p||new n(32768),x=c.h||new n(z+1),A=Math.ceil(o/3),D=2*A,T=function(t){return(a[t]^a[t+1]<<A^a[t+2]<<D)&z},F=new r(25e3),I=new n(288),S=new n(32),L=0,O=0,j=c.i||0,q=0,B=c.w||0,G=0;j+2<v;++j){var H=T(j),J=32767&j,K=x[H];if(_[J]=K,x[H]=J,B<=j){var N=v-j;if((L>7e3||q>24576)&&(N>423||!w)){p=U(a,g,0,F,I,S,O,q,G,j-G,p),q=L=O=0,G=j;for(var P=0;P<286;++P)I[P]=0;for(P=0;P<30;++P)S[P]=0}var Q=2,R=0,V=E,W=J-K&32767;if(N>2&&H==T(j-W))for(var X=Math.min(M,N)-1,Y=Math.min(32767,j),Z=Math.min(258,N);W<=Y&&--V&&J!=K;){if(a[j+Q]==a[j+Q-W]){for(var $=0;$<Z&&a[j+$]==a[j+$-W];++$);if($>Q){if(Q=$,R=W,$>X)break;var tt=Math.min(W,$-2),nt=0;for(P=0;P<tt;++P){var rt=j-W+P&32767,et=rt-_[rt]&32767;et>nt&&(nt=et,K=rt)}}}W+=(J=K)-(K=_[J])&32767}if(R){F[q++]=268435456|h[Q]<<18|l[R];var it=31&h[Q],at=31&l[R];O+=e[it]+i[at],++I[257+it],++S[at],B=j+Q,++L}else F[q++]=a[j],++I[a[j]]}}for(j=Math.max(j,B);j<v;++j)F[q++]=a[j],++I[a[j]];p=U(a,g,w,F,I,S,O,q,G,j-G,p),w||(c.r=7&p|g[p/8|0]<<3,p-=7,c.h=x,c.p=_,c.i=j,c.w=B)}else{for(j=c.w||0;j<v+w;j+=65535){var st=j+65535;st>=v&&(g[p/8|0]=w,st=v),p=k(g,p+1,a.subarray(j,st))}c.i=v}return b(d,0,f+m(p)+u)}(a,null==s.level?6:s.level,null==s.mem?Math.ceil(1.5*Math.max(8,Math.min(13,Math.log(a.length)))):12+s.mem,o,f,u)},j=function(t,n,r){for(;r;++n)t[n]=r,r>>>=8},q=function(t,n){var r=n.filename;if(t[0]=31,t[1]=139,t[2]=8,t[8]=n.level<2?4:9==n.level?2:0,t[9]=3,0!=n.mtime&&j(t,4,Math.floor(new Date(n.mtime||Date.now())/1e3)),r){t[3]=8;for(var e=0;e<=r.length;++e)t[e+10]=r.charCodeAt(e)}},B=function(t){return 10+(t.filename?t.filename.length+1:0)},G=function(){function n(n,r){if("function"==typeof n&&(r=n,n={}),this.ondata=r,this.o=n||{},this.s={l:0,i:32768,w:32768,z:32768},this.b=new t(98304),this.o.dictionary){var e=this.o.dictionary.subarray(-32768);this.b.set(e,32768-e.length),this.s.i=32768-e.length}}return n.prototype.p=function(t,n){this.ondata(O(t,this.o,0,0,this.s),n)},n.prototype.push=function(n,r){this.ondata||E(5),this.s.l&&E(4);var e=n.length+this.s.z;if(e>this.b.length){if(e>2*this.b.length-32768){var i=new t(-32768&e);i.set(this.b.subarray(0,this.s.z)),this.b=i}var a=this.b.length-this.s.z;a&&(this.b.set(n.subarray(0,a),this.s.z),this.s.z=this.b.length,this.p(this.b,!1)),this.b.set(this.b.subarray(-32768)),this.b.set(n.subarray(a),32768),this.s.z=n.length-a+32768,this.s.i=32766,this.s.w=32768}else this.b.set(n,this.s.z),this.s.z+=n.length;this.s.l=1&r,(this.s.z>this.s.w+8191||r)&&(this.p(this.b,r||!1),this.s.w=this.s.i,this.s.i-=2)},n}();var H=function(){function t(t,n){this.c=L(),this.v=1,G.call(this,t,n)}return t.prototype.push=function(t,n){this.c.p(t),G.prototype.push.call(this,t,n)},t.prototype.p=function(t,n){var r=O(t,this.o,this.v&&(this.o.dictionary?6:2),n&&4,this.s);this.v&&(function(t,n){var r=n.level,e=0==r?0:r<6?1:9==r?3:2;if(t[0]=120,t[1]=e<<6|(n.dictionary&&32),t[1]|=31-(t[0]<<8|t[1])%31,n.dictionary){var i=L();i.p(n.dictionary),j(t,2,i.d())}}(r,this.o),this.v=0),n&&j(r,r.length-4,this.c.d()),this.ondata(r,n)},t}(),J="undefined"!=typeof TextEncoder&&new TextEncoder,K="undefined"!=typeof TextDecoder&&new TextDecoder;try{K.decode(F,{stream:!0})}catch(t){}var N=function(){function t(t){this.ondata=t}return t.prototype.push=function(t,n){this.ondata||E(5),this.d&&E(4),this.ondata(P(t),this.d=n||!1)},t}();function P(n,r){if(J)return J.encode(n);for(var e=n.length,i=new t(n.length+(n.length>>1)),a=0,s=function(t){i[a++]=t},o=0;o<e;++o){if(a+5>i.length){var f=new t(a+8+(e-o<<1));f.set(i),i=f}var h=n.charCodeAt(o);h<128||r?s(h):h<2048?(s(192|h>>6),s(128|63&h)):h>55295&&h<57344?(s(240|(h=65536+(1047552&h)|1023&n.charCodeAt(++o))>>18),s(128|h>>12&63),s(128|h>>6&63),s(128|63&h)):(s(224|h>>12),s(128|h>>6&63),s(128|63&h))}return b(i,0,a)}function Q(t){return function(t,n){n||(n={});var r=S(),e=t.length;r.p(t);var i=O(t,n,B(n),8),a=i.length;return q(i,n),j(i,a-8,r.d()),j(i,a-4,e),i}(P(t))}const R=new class{constructor(){this._init()}clear(){this._init()}addEvent(t){if(!t)throw new Error("Adding invalid event");const n=this._hasEvents?",":"";this.stream.push(n+t),this._hasEvents=!0}finish(){this.stream.push("]",!0);const t=function(t){let n=0;for(const r of t)n+=r.length;const r=new Uint8Array(n);for(let n=0,e=0,i=t.length;n<i;n++){const i=t[n];r.set(i,e),e+=i.length}return r}(this._deflatedData);return this._init(),t}_init(){this._hasEvents=!1,this._deflatedData=[],this.deflate=new H,this.deflate.ondata=(t,n)=>{this._deflatedData.push(t)},this.stream=new N(((t,n)=>{this.deflate.push(t,n)})),this.stream.push("[")}},V={clear:()=>{R.clear()},addEvent:t=>R.addEvent(t),finish:()=>R.finish(),compress:t=>Q(t)};addEventListener("message",(function(t){const n=t.data.method,r=t.data.id,e=t.data.arg;if(n in V&&"function"==typeof V[n])try{const t=V[n](e);postMessage({id:r,method:n,success:!0,response:t})}catch(t){postMessage({id:r,method:n,success:!1,response:t.message}),console.error(t)}})),postMessage({id:void 0,method:"init",success:!0,response:void 0});';
function y2() {
  const t = new Blob([_2]);
  return URL.createObjectURL(t);
}
class Nh extends Error {
  constructor() {
    super(`Event buffer exceeded maximum size of ${Th}.`);
  }
}
class YE {
  /** All the events that are buffered to be sent. */
  /** @inheritdoc */
  constructor() {
    this.events = [], this._totalSize = 0, this.hasCheckout = !1;
  }
  /** @inheritdoc */
  get hasEvents() {
    return this.events.length > 0;
  }
  /** @inheritdoc */
  get type() {
    return "sync";
  }
  /** @inheritdoc */
  destroy() {
    this.events = [];
  }
  /** @inheritdoc */
  async addEvent(e) {
    const n = JSON.stringify(e).length;
    if (this._totalSize += n, this._totalSize > Th)
      throw new Nh();
    this.events.push(e);
  }
  /** @inheritdoc */
  finish() {
    return new Promise((e) => {
      const n = this.events;
      this.clear(), e(JSON.stringify(n));
    });
  }
  /** @inheritdoc */
  clear() {
    this.events = [], this._totalSize = 0, this.hasCheckout = !1;
  }
  /** @inheritdoc */
  getEarliestTimestamp() {
    const e = this.events.map((n) => n.timestamp).sort()[0];
    return e ? Ah(e) : null;
  }
}
class E2 {
  constructor(e) {
    this._worker = e, this._id = 0;
  }
  /**
   * Ensure the worker is ready (or not).
   * This will either resolve when the worker is ready, or reject if an error occurred.
   */
  ensureReady() {
    return this._ensureReadyPromise ? this._ensureReadyPromise : (this._ensureReadyPromise = new Promise((e, n) => {
      this._worker.addEventListener(
        "message",
        ({ data: s }) => {
          s.success ? e() : n();
        },
        { once: !0 }
      ), this._worker.addEventListener(
        "error",
        (s) => {
          n(s);
        },
        { once: !0 }
      );
    }), this._ensureReadyPromise);
  }
  /**
   * Destroy the worker.
   */
  destroy() {
    O && D.info("Destroying compression worker"), this._worker.terminate();
  }
  /**
   * Post message to worker and wait for response before resolving promise.
   */
  postMessage(e, n) {
    const s = this._getAndIncrementId();
    return new Promise((r, i) => {
      const o = ({ data: a }) => {
        const c = a;
        if (c.method === e && c.id === s) {
          if (this._worker.removeEventListener("message", o), !c.success) {
            O && D.error("Error in compression worker: ", c.response), i(new Error("Error in compression worker"));
            return;
          }
          r(c.response);
        }
      };
      this._worker.addEventListener("message", o), this._worker.postMessage({ id: s, method: e, arg: n });
    });
  }
  /** Get the current ID and increment it for the next call. */
  _getAndIncrementId() {
    return this._id++;
  }
}
class b2 {
  /** @inheritdoc */
  constructor(e) {
    this._worker = new E2(e), this._earliestTimestamp = null, this._totalSize = 0, this.hasCheckout = !1;
  }
  /** @inheritdoc */
  get hasEvents() {
    return !!this._earliestTimestamp;
  }
  /** @inheritdoc */
  get type() {
    return "worker";
  }
  /**
   * Ensure the worker is ready (or not).
   * This will either resolve when the worker is ready, or reject if an error occurred.
   */
  ensureReady() {
    return this._worker.ensureReady();
  }
  /**
   * Destroy the event buffer.
   */
  destroy() {
    this._worker.destroy();
  }
  /**
   * Add an event to the event buffer.
   *
   * Returns true if event was successfully received and processed by worker.
   */
  addEvent(e) {
    const n = Ah(e.timestamp);
    (!this._earliestTimestamp || n < this._earliestTimestamp) && (this._earliestTimestamp = n);
    const s = JSON.stringify(e);
    return this._totalSize += s.length, this._totalSize > Th ? Promise.reject(new Nh()) : this._sendEventToWorker(s);
  }
  /**
   * Finish the event buffer and return the compressed data.
   */
  finish() {
    return this._finishRequest();
  }
  /** @inheritdoc */
  clear() {
    this._earliestTimestamp = null, this._totalSize = 0, this.hasCheckout = !1, this._worker.postMessage("clear").then(null, (e) => {
      O && D.exception(e, 'Sending "clear" message to worker failed', e);
    });
  }
  /** @inheritdoc */
  getEarliestTimestamp() {
    return this._earliestTimestamp;
  }
  /**
   * Send the event to the worker.
   */
  _sendEventToWorker(e) {
    return this._worker.postMessage("addEvent", e);
  }
  /**
   * Finish the request and return the compressed data from the worker.
   */
  async _finishRequest() {
    const e = await this._worker.postMessage("finish");
    return this._earliestTimestamp = null, this._totalSize = 0, e;
  }
}
class v2 {
  constructor(e) {
    this._fallback = new YE(), this._compression = new b2(e), this._used = this._fallback, this._ensureWorkerIsLoadedPromise = this._ensureWorkerIsLoaded();
  }
  /** @inheritdoc */
  get type() {
    return this._used.type;
  }
  /** @inheritDoc */
  get hasEvents() {
    return this._used.hasEvents;
  }
  /** @inheritdoc */
  get hasCheckout() {
    return this._used.hasCheckout;
  }
  /** @inheritdoc */
  set hasCheckout(e) {
    this._used.hasCheckout = e;
  }
  /** @inheritDoc */
  destroy() {
    this._fallback.destroy(), this._compression.destroy();
  }
  /** @inheritdoc */
  clear() {
    return this._used.clear();
  }
  /** @inheritdoc */
  getEarliestTimestamp() {
    return this._used.getEarliestTimestamp();
  }
  /**
   * Add an event to the event buffer.
   *
   * Returns true if event was successfully added.
   */
  addEvent(e) {
    return this._used.addEvent(e);
  }
  /** @inheritDoc */
  async finish() {
    return await this.ensureWorkerIsLoaded(), this._used.finish();
  }
  /** Ensure the worker has loaded. */
  ensureWorkerIsLoaded() {
    return this._ensureWorkerIsLoadedPromise;
  }
  /** Actually check if the worker has been loaded. */
  async _ensureWorkerIsLoaded() {
    try {
      await this._compression.ensureReady();
    } catch (e) {
      O && D.exception(e, "Failed to load the compression worker, falling back to simple buffer");
      return;
    }
    await this._switchToCompressionWorker();
  }
  /** Switch the used buffer to the compression worker. */
  async _switchToCompressionWorker() {
    const { events: e, hasCheckout: n } = this._fallback, s = [];
    for (const r of e)
      s.push(this._compression.addEvent(r));
    this._compression.hasCheckout = n, this._used = this._compression;
    try {
      await Promise.all(s), this._fallback.clear();
    } catch (r) {
      O && D.exception(r, "Failed to add events when switching buffers.");
    }
  }
}
function S2({
  useCompression: t,
  workerUrl: e
}) {
  if (t && // eslint-disable-next-line no-restricted-globals
  window.Worker) {
    const n = w2(e);
    if (n)
      return n;
  }
  return O && D.info("Using simple buffer"), new YE();
}
function w2(t) {
  try {
    const e = t || T2();
    if (!e)
      return;
    O && D.info(`Using compression worker${t ? ` from ${t}` : ""}`);
    const n = new Worker(e);
    return new v2(n);
  } catch (e) {
    O && D.exception(e, "Failed to create compression worker");
  }
}
function T2() {
  return typeof __SENTRY_EXCLUDE_REPLAY_WORKER__ > "u" || !__SENTRY_EXCLUDE_REPLAY_WORKER__ ? y2() : "";
}
function Lh() {
  try {
    return "sessionStorage" in le && !!le.sessionStorage;
  } catch {
    return !1;
  }
}
function I2(t) {
  C2(), t.session = void 0;
}
function C2() {
  if (Lh())
    try {
      le.sessionStorage.removeItem(Sh);
    } catch {
    }
}
function KE(t) {
  return t === void 0 ? !1 : Math.random() < t;
}
function XE(t) {
  const e = Date.now(), n = t.id || me(), s = t.started || e, r = t.lastActivity || e, i = t.segmentId || 0, o = t.sampled, a = t.previousSessionId;
  return {
    id: n,
    started: s,
    lastActivity: r,
    segmentId: i,
    sampled: o,
    previousSessionId: a
  };
}
function Rh(t) {
  if (Lh())
    try {
      le.sessionStorage.setItem(Sh, JSON.stringify(t));
    } catch {
    }
}
function F2(t, e) {
  return KE(t) ? "session" : e ? "buffer" : !1;
}
function Vm({ sessionSampleRate: t, allowBuffering: e, stickySession: n = !1 }, { previousSessionId: s } = {}) {
  const r = F2(t, e), i = XE({
    sampled: r,
    previousSessionId: s
  });
  return n && Rh(i), i;
}
function k2() {
  if (!Lh())
    return null;
  try {
    const t = le.sessionStorage.getItem(Sh);
    if (!t)
      return null;
    const e = JSON.parse(t);
    return O && D.infoTick("Loading existing session"), XE(e);
  } catch {
    return null;
  }
}
function Gd(t, e, n = +/* @__PURE__ */ new Date()) {
  return t === null || e === void 0 || e < 0 ? !0 : e === 0 ? !1 : t + e <= n;
}
function JE(t, {
  maxReplayDuration: e,
  sessionIdleExpire: n,
  targetTime: s = Date.now()
}) {
  return (
    // First, check that maximum session length has not been exceeded
    Gd(t.started, e, s) || // check that the idle timeout has not been exceeded (i.e. user has
    // performed an action within the last `sessionIdleExpire` ms)
    Gd(t.lastActivity, n, s)
  );
}
function QE(t, { sessionIdleExpire: e, maxReplayDuration: n }) {
  return !(!JE(t, { sessionIdleExpire: e, maxReplayDuration: n }) || t.sampled === "buffer" && t.segmentId === 0);
}
function Nl({
  sessionIdleExpire: t,
  maxReplayDuration: e,
  previousSessionId: n
}, s) {
  const r = s.stickySession && k2();
  return r ? QE(r, { sessionIdleExpire: t, maxReplayDuration: e }) ? (O && D.infoTick("Session in sessionStorage is expired, creating new one..."), Vm(s, { previousSessionId: r.id })) : r : (O && D.infoTick("Creating new session"), Vm(s, { previousSessionId: n }));
}
function A2(t) {
  return t.type === W.Custom;
}
function xh(t, e, n) {
  return eb(t, e) ? (ZE(t, e, n), !0) : !1;
}
function N2(t, e, n) {
  return eb(t, e) ? ZE(t, e, n) : Promise.resolve(null);
}
async function ZE(t, e, n) {
  if (!t.eventBuffer)
    return null;
  try {
    n && t.recordingMode === "buffer" && t.eventBuffer.clear(), n && (t.eventBuffer.hasCheckout = !0);
    const s = t.getOptions(), r = L2(e, s.beforeAddRecordingEvent);
    return r ? await t.eventBuffer.addEvent(r) : void 0;
  } catch (s) {
    const r = s && s instanceof Nh ? "addEventSizeExceeded" : "addEvent";
    t.handleException(s), await t.stop({ reason: r });
    const i = J();
    i && i.recordDroppedEvent("internal_sdk_error", "replay");
  }
}
function eb(t, e) {
  if (!t.eventBuffer || t.isPaused() || !t.isEnabled())
    return !1;
  const n = Ah(e.timestamp);
  return n + t.timeouts.sessionIdlePause < Date.now() ? !1 : n > t.getContext().initialTimestamp + t.getOptions().maxReplayDuration ? (O && D.infoTick(`Skipping event with timestamp ${n} because it is after maxReplayDuration`), !1) : !0;
}
function L2(t, e) {
  try {
    if (typeof e == "function" && A2(t))
      return e(t);
  } catch (n) {
    return O && D.exception(n, "An error occurred in the `beforeAddRecordingEvent` callback, skipping the event..."), null;
  }
  return t;
}
function Oh(t) {
  return !t.type;
}
function Bd(t) {
  return t.type === "transaction";
}
function R2(t) {
  return t.type === "replay_event";
}
function Um(t) {
  return t.type === "feedback";
}
function x2(t) {
  return (e, n) => {
    if (!t.isEnabled() || !Oh(e) && !Bd(e))
      return;
    const s = n && n.statusCode;
    if (!(!s || s < 200 || s >= 300)) {
      if (Bd(e)) {
        O2(t, e);
        return;
      }
      P2(t, e);
    }
  };
}
function O2(t, e) {
  const n = t.getContext();
  e.contexts && e.contexts.trace && e.contexts.trace.trace_id && n.traceIds.size < 100 && n.traceIds.add(e.contexts.trace.trace_id);
}
function P2(t, e) {
  const n = t.getContext();
  if (e.event_id && n.errorIds.size < 100 && n.errorIds.add(e.event_id), t.recordingMode !== "buffer" || !e.tags || !e.tags.replayId)
    return;
  const { beforeErrorSampling: s } = t.getOptions();
  typeof s == "function" && !s(e) || Or(async () => {
    try {
      await t.sendBufferedReplayOrFlush();
    } catch (r) {
      t.handleException(r);
    }
  });
}
function M2(t) {
  return (e) => {
    !t.isEnabled() || !Oh(e) || D2(t, e);
  };
}
function D2(t, e) {
  const n = e.exception && e.exception.values && e.exception.values[0] && e.exception.values[0].value;
  if (typeof n == "string" && // Only matches errors in production builds of react-dom
  // Example https://reactjs.org/docs/error-decoder.html?invariant=423
  // With newer React versions, the messages changed to a different website https://react.dev/errors/418
  (n.match(
    /(reactjs\.org\/docs\/error-decoder\.html\?invariant=|react\.dev\/errors\/)(418|419|422|423|425)/
  ) || // Development builds of react-dom
  // Error 1: Hydration failed because the initial UI does not match what was rendered on the server.
  // Error 2: Text content does not match server-rendered HTML. Warning: Text content did not match.
  n.match(/(does not match server-rendered HTML|Hydration failed because)/i))) {
    const s = Ot({
      category: "replay.hydrate-error",
      data: {
        url: dy()
      }
    });
    So(t, s);
  }
}
function G2(t) {
  const e = J();
  e && e.on("beforeAddBreadcrumb", (n) => B2(t, n));
}
function B2(t, e) {
  if (!t.isEnabled() || !tb(e))
    return;
  const n = $2(e);
  n && So(t, n);
}
function $2(t) {
  return !tb(t) || [
    // fetch & xhr are handled separately,in handleNetworkBreadcrumbs
    "fetch",
    "xhr",
    // These two are breadcrumbs for emitted sentry events, we don't care about them
    "sentry.event",
    "sentry.transaction"
  ].includes(t.category) || // We capture UI breadcrumbs separately
  t.category.startsWith("ui.") ? null : t.category === "console" ? V2(t) : Ot(t);
}
function V2(t) {
  const e = t.data && t.data.arguments;
  if (!Array.isArray(e) || e.length === 0)
    return Ot(t);
  let n = !1;
  const s = e.map((r) => {
    if (!r)
      return r;
    if (typeof r == "string")
      return r.length > Wo ? (n = !0, `${r.slice(0, Wo)}…`) : r;
    if (typeof r == "object")
      try {
        const i = Rt(r, 7);
        return JSON.stringify(i).length > Wo ? (n = !0, `${JSON.stringify(i, null, 2).slice(0, Wo)}…`) : i;
      } catch {
      }
    return r;
  });
  return Ot({
    ...t,
    data: {
      ...t.data,
      arguments: s,
      ...n ? { _meta: { warnings: ["CONSOLE_ARG_TRUNCATED"] } } : {}
    }
  });
}
function tb(t) {
  return !!t.category;
}
function U2(t, e) {
  return t.type || !t.exception || !t.exception.values || !t.exception.values.length ? !1 : !!(e.originalException && e.originalException.__rrweb__);
}
function H2(t, e) {
  t.triggerUserActivity(), t.addUpdate(() => e.timestamp ? (t.throttledAddEvent({
    type: W.Custom,
    timestamp: e.timestamp * 1e3,
    data: {
      tag: "breadcrumb",
      payload: {
        timestamp: e.timestamp,
        type: "default",
        category: "sentry.feedback",
        data: {
          feedbackId: e.event_id
        }
      }
    }
  }), !1) : !0);
}
function j2(t, e) {
  return t.recordingMode !== "buffer" || e.message === wh || !e.exception || e.type ? !1 : KE(t.getOptions().errorSampleRate);
}
function W2(t) {
  return Object.assign(
    (e, n) => !t.isEnabled() || t.isPaused() ? e : R2(e) ? (delete e.breadcrumbs, e) : !Oh(e) && !Bd(e) && !Um(e) || !t.checkAndHandleExpiredSession() ? e : Um(e) ? (t.flush(), e.contexts.feedback.replay_id = t.getSessionId(), H2(t, e), e) : U2(e, n) && !t.getOptions()._experiments.captureExceptions ? (O && D.log("Ignoring error from rrweb internals", e), null) : ((j2(t, e) || t.recordingMode === "session") && (e.tags = { ...e.tags, replayId: t.getSessionId() }), e),
    { id: "Replay" }
  );
}
function Gc(t, e) {
  return e.map(({ type: n, start: s, end: r, name: i, data: o }) => {
    const a = t.throttledAddEvent({
      type: W.Custom,
      timestamp: s,
      data: {
        tag: "performanceSpan",
        payload: {
          op: n,
          description: i,
          startTimestamp: s,
          endTimestamp: r,
          data: o
        }
      }
    });
    return typeof a == "string" ? Promise.resolve(null) : a;
  });
}
function z2(t) {
  const { from: e, to: n } = t, s = Date.now() / 1e3;
  return {
    type: "navigation.push",
    start: s,
    end: s,
    name: n,
    data: {
      previous: e
    }
  };
}
function q2(t) {
  return (e) => {
    if (!t.isEnabled())
      return;
    const n = z2(e);
    n !== null && (t.getContext().urls.push(n.name), t.triggerUserActivity(), t.addUpdate(() => (Gc(t, [n]), !1)));
  };
}
function Y2(t, e) {
  return O && t.getOptions()._experiments.traceInternals ? !1 : yO(e, J());
}
function nb(t, e) {
  t.isEnabled() && e !== null && (Y2(t, e.name) || t.addUpdate(() => (Gc(t, [e]), !0)));
}
function Bc(t) {
  if (!t)
    return;
  const e = new TextEncoder();
  try {
    if (typeof t == "string")
      return e.encode(t).length;
    if (t instanceof URLSearchParams)
      return e.encode(t.toString()).length;
    if (t instanceof FormData) {
      const n = ob(t);
      return e.encode(n).length;
    }
    if (t instanceof Blob)
      return t.size;
    if (t instanceof ArrayBuffer)
      return t.byteLength;
  } catch {
  }
}
function sb(t) {
  if (!t)
    return;
  const e = parseInt(t, 10);
  return isNaN(e) ? void 0 : e;
}
function rb(t) {
  try {
    if (typeof t == "string")
      return [t];
    if (t instanceof URLSearchParams)
      return [t.toString()];
    if (t instanceof FormData)
      return [ob(t)];
    if (!t)
      return [void 0];
  } catch (e) {
    return O && D.exception(e, "Failed to serialize body", t), [void 0, "BODY_PARSE_ERROR"];
  }
  return O && D.info("Skipping network body because of body type", t), [void 0, "UNPARSEABLE_BODY_TYPE"];
}
function nc(t, e) {
  if (!t)
    return {
      headers: {},
      size: void 0,
      _meta: {
        warnings: [e]
      }
    };
  const n = { ...t._meta }, s = n.warnings || [];
  return n.warnings = [...s, e], t._meta = n, t;
}
function ib(t, e) {
  if (!e)
    return null;
  const { startTimestamp: n, endTimestamp: s, url: r, method: i, statusCode: o, request: a, response: c } = e;
  return {
    type: t,
    start: n / 1e3,
    end: s / 1e3,
    name: r,
    data: Ce({
      method: i,
      statusCode: o,
      request: a,
      response: c
    })
  };
}
function qi(t) {
  return {
    headers: {},
    size: t,
    _meta: {
      warnings: ["URL_SKIPPED"]
    }
  };
}
function Gn(t, e, n) {
  if (!e && Object.keys(t).length === 0)
    return;
  if (!e)
    return {
      headers: t
    };
  if (!n)
    return {
      headers: t,
      size: e
    };
  const s = {
    headers: t,
    size: e
  }, { body: r, warnings: i } = K2(n);
  return s.body = r, i && i.length > 0 && (s._meta = {
    warnings: i
  }), s;
}
function $d(t, e) {
  return Object.entries(t).reduce((n, [s, r]) => {
    const i = s.toLowerCase();
    return e.includes(i) && t[s] && (n[i] = r), n;
  }, {});
}
function ob(t) {
  return new URLSearchParams(t).toString();
}
function K2(t) {
  if (!t || typeof t != "string")
    return {
      body: t
    };
  const e = t.length > Tm, n = X2(t);
  if (e) {
    const s = t.slice(0, Tm);
    return n ? {
      body: s,
      warnings: ["MAYBE_JSON_TRUNCATED"]
    } : {
      body: `${s}…`,
      warnings: ["TEXT_TRUNCATED"]
    };
  }
  if (n)
    try {
      return {
        body: JSON.parse(t)
      };
    } catch {
    }
  return {
    body: t
  };
}
function X2(t) {
  const e = t[0], n = t[t.length - 1];
  return e === "[" && n === "]" || e === "{" && n === "}";
}
function sc(t, e) {
  const n = J2(t);
  return Dn(n, e);
}
function J2(t, e = le.document.baseURI) {
  if (t.startsWith("http://") || t.startsWith("https://") || t.startsWith(le.location.origin))
    return t;
  const n = new URL(t, e);
  if (n.origin !== new URL(e).origin)
    return t;
  const s = n.href;
  return !t.endsWith("/") && s.endsWith("/") ? s.slice(0, -1) : s;
}
async function Q2(t, e, n) {
  try {
    const s = await eB(t, e, n), r = ib("resource.fetch", s);
    nb(n.replay, r);
  } catch (s) {
    O && D.exception(s, "Failed to capture fetch breadcrumb");
  }
}
function Z2(t, e) {
  const { input: n, response: s } = e, r = n ? ab(n) : void 0, i = Bc(r), o = s ? sb(s.headers.get("content-length")) : void 0;
  i !== void 0 && (t.data.request_body_size = i), o !== void 0 && (t.data.response_body_size = o);
}
async function eB(t, e, n) {
  const s = Date.now(), { startTimestamp: r = s, endTimestamp: i = s } = e, {
    url: o,
    method: a,
    status_code: c = 0,
    request_body_size: l,
    response_body_size: d
  } = t.data, u = sc(o, n.networkDetailAllowUrls) && !sc(o, n.networkDetailDenyUrls), h = u ? tB(n, e.input, l) : qi(l), p = await nB(u, n, e.response, d);
  return {
    startTimestamp: r,
    endTimestamp: i,
    url: o,
    method: a,
    statusCode: c,
    request: h,
    response: p
  };
}
function tB({ networkCaptureBodies: t, networkRequestHeaders: e }, n, s) {
  const r = n ? iB(n, e) : {};
  if (!t)
    return Gn(r, s, void 0);
  const i = ab(n), [o, a] = rb(i), c = Gn(r, s, o);
  return a ? nc(c, a) : c;
}
async function nB(t, {
  networkCaptureBodies: e,
  networkResponseHeaders: n
}, s, r) {
  if (!t && r !== void 0)
    return qi(r);
  const i = s ? cb(s.headers, n) : {};
  if (!s || !e && r !== void 0)
    return Gn(i, r, void 0);
  const [o, a] = await rB(s), c = sB(o, {
    networkCaptureBodies: e,
    responseBodySize: r,
    captureDetails: t,
    headers: i
  });
  return a ? nc(c, a) : c;
}
function sB(t, {
  networkCaptureBodies: e,
  responseBodySize: n,
  captureDetails: s,
  headers: r
}) {
  try {
    const i = t && t.length && n === void 0 ? Bc(t) : n;
    return s ? e ? Gn(r, i, t) : Gn(r, i, void 0) : qi(i);
  } catch (i) {
    return O && D.exception(i, "Failed to serialize response body"), Gn(r, n, void 0);
  }
}
async function rB(t) {
  const e = oB(t);
  if (!e)
    return [void 0, "BODY_PARSE_ERROR"];
  try {
    return [await aB(e)];
  } catch (n) {
    return n instanceof Error && n.message.indexOf("Timeout") > -1 ? (O && D.warn("Parsing text body from response timed out"), [void 0, "BODY_PARSE_TIMEOUT"]) : (O && D.exception(n, "Failed to get text body from response"), [void 0, "BODY_PARSE_ERROR"]);
  }
}
function ab(t = []) {
  if (!(t.length !== 2 || typeof t[1] != "object"))
    return t[1].body;
}
function cb(t, e) {
  const n = {};
  return e.forEach((s) => {
    t.get(s) && (n[s] = t.get(s));
  }), n;
}
function iB(t, e) {
  return t.length === 1 && typeof t[0] != "string" ? Hm(t[0], e) : t.length === 2 ? Hm(t[1], e) : {};
}
function Hm(t, e) {
  if (!t)
    return {};
  const n = t.headers;
  return n ? n instanceof Headers ? cb(n, e) : Array.isArray(n) ? {} : $d(n, e) : {};
}
function oB(t) {
  try {
    return t.clone();
  } catch (e) {
    O && D.exception(e, "Failed to clone response body");
  }
}
function aB(t) {
  return new Promise((e, n) => {
    const s = Or(() => n(new Error("Timeout while trying to read response body")), 500);
    cB(t).then(
      (r) => e(r),
      (r) => n(r)
    ).finally(() => clearTimeout(s));
  });
}
async function cB(t) {
  return await t.text();
}
async function lB(t, e, n) {
  try {
    const s = uB(t, e, n), r = ib("resource.xhr", s);
    nb(n.replay, r);
  } catch (s) {
    O && D.exception(s, "Failed to capture xhr breadcrumb");
  }
}
function dB(t, e) {
  const { xhr: n, input: s } = e;
  if (!n)
    return;
  const r = Bc(s), i = n.getResponseHeader("content-length") ? sb(n.getResponseHeader("content-length")) : mB(n.response, n.responseType);
  r !== void 0 && (t.data.request_body_size = r), i !== void 0 && (t.data.response_body_size = i);
}
function uB(t, e, n) {
  const s = Date.now(), { startTimestamp: r = s, endTimestamp: i = s, input: o, xhr: a } = e, {
    url: c,
    method: l,
    status_code: d = 0,
    request_body_size: u,
    response_body_size: h
  } = t.data;
  if (!c)
    return null;
  if (!a || !sc(c, n.networkDetailAllowUrls) || sc(c, n.networkDetailDenyUrls)) {
    const _ = qi(u), E = qi(h);
    return {
      startTimestamp: r,
      endTimestamp: i,
      url: c,
      method: l,
      statusCode: d,
      request: _,
      response: E
    };
  }
  const p = a[cs], f = p ? $d(p.request_headers, n.networkRequestHeaders) : {}, m = $d(hB(a), n.networkResponseHeaders), [g, y] = n.networkCaptureBodies ? rb(o) : [void 0], [I, A] = n.networkCaptureBodies ? pB(a) : [void 0], T = Gn(f, u, g), F = Gn(m, h, I);
  return {
    startTimestamp: r,
    endTimestamp: i,
    url: c,
    method: l,
    statusCode: d,
    request: y ? nc(T, y) : T,
    response: A ? nc(F, A) : F
  };
}
function hB(t) {
  const e = t.getAllResponseHeaders();
  return e ? e.split(`\r
`).reduce((n, s) => {
    const [r, i] = s.split(": ");
    return i && (n[r.toLowerCase()] = i), n;
  }, {}) : {};
}
function pB(t) {
  const e = [];
  try {
    return [t.responseText];
  } catch (n) {
    e.push(n);
  }
  try {
    return fB(t.response, t.responseType);
  } catch (n) {
    e.push(n);
  }
  return O && D.warn("Failed to get xhr response body", ...e), [void 0];
}
function fB(t, e) {
  try {
    if (typeof t == "string")
      return [t];
    if (t instanceof Document)
      return [t.body.outerHTML];
    if (e === "json" && t && typeof t == "object")
      return [JSON.stringify(t)];
    if (!t)
      return [void 0];
  } catch (n) {
    return O && D.exception(n, "Failed to serialize body", t), [void 0, "BODY_PARSE_ERROR"];
  }
  return O && D.info("Skipping network body because of body type", t), [void 0, "UNPARSEABLE_BODY_TYPE"];
}
function mB(t, e) {
  try {
    const n = e === "json" && t && typeof t == "object" ? JSON.stringify(t) : t;
    return Bc(n);
  } catch {
    return;
  }
}
function gB(t) {
  const e = J();
  try {
    const {
      networkDetailAllowUrls: n,
      networkDetailDenyUrls: s,
      networkCaptureBodies: r,
      networkRequestHeaders: i,
      networkResponseHeaders: o
    } = t.getOptions(), a = {
      replay: t,
      networkDetailAllowUrls: n,
      networkDetailDenyUrls: s,
      networkCaptureBodies: r,
      networkRequestHeaders: i,
      networkResponseHeaders: o
    };
    e && e.on("beforeAddBreadcrumb", (c, l) => _B(a, c, l));
  } catch {
  }
}
function _B(t, e, n) {
  if (e.data)
    try {
      yB(e) && bB(n) && (dB(e, n), lB(e, n, t)), EB(e) && vB(n) && (Z2(e, n), Q2(e, n, t));
    } catch (s) {
      O && D.exception(s, "Error when enriching network breadcrumb");
    }
}
function yB(t) {
  return t.category === "xhr";
}
function EB(t) {
  return t.category === "fetch";
}
function bB(t) {
  return t && t.xhr;
}
function vB(t) {
  return t && t.response;
}
function SB(t) {
  const e = J();
  yE(QG(t)), xc(q2(t)), G2(t), gB(t);
  const n = W2(t);
  nO(n), e && (e.on("beforeSendEvent", M2(t)), e.on("afterSendEvent", x2(t)), e.on("createDsc", (s) => {
    const r = t.getSessionId();
    r && t.isEnabled() && t.recordingMode === "session" && t.checkAndHandleExpiredSession() && (s.replay_id = r);
  }), e.on("spanStart", (s) => {
    t.lastActiveSpan = s;
  }), e.on("spanEnd", (s) => {
    t.lastActiveSpan = s;
  }), e.on("beforeSendFeedback", (s, r) => {
    const i = t.getSessionId();
    r && r.includeReplay && t.isEnabled() && i && s.contexts && s.contexts.feedback && (s.contexts.feedback.replay_id = i);
  }));
}
async function wB(t) {
  try {
    return Promise.all(
      Gc(t, [
        // @ts-expect-error memory doesn't exist on type Performance as the API is non-standard (we check that it exists above)
        TB(le.performance.memory)
      ])
    );
  } catch {
    return [];
  }
}
function TB(t) {
  const { jsHeapSizeLimit: e, totalJSHeapSize: n, usedJSHeapSize: s } = t, r = Date.now() / 1e3;
  return {
    type: "memory",
    name: "memory",
    start: r,
    end: r,
    data: {
      memory: {
        jsHeapSizeLimit: e,
        totalJSHeapSize: n,
        usedJSHeapSize: s
      }
    }
  };
}
function IB(t, e, n) {
  let s, r, i;
  const o = n && n.maxWait ? Math.max(n.maxWait, e) : 0;
  function a() {
    return c(), s = t(), s;
  }
  function c() {
    r !== void 0 && clearTimeout(r), i !== void 0 && clearTimeout(i), r = i = void 0;
  }
  function l() {
    return r !== void 0 || i !== void 0 ? a() : s;
  }
  function d() {
    return r && clearTimeout(r), r = Or(a, e), o && i === void 0 && (i = Or(a, o)), s;
  }
  return d.cancel = c, d.flush = l, d;
}
function CB(t) {
  let e = !1;
  return (n, s) => {
    if (!t.checkAndHandleExpiredSession()) {
      O && D.warn("Received replay event after session expired.");
      return;
    }
    const r = s || !e;
    e = !0, t.clickDetector && qG(t.clickDetector, n), t.addUpdate(() => {
      if (t.recordingMode === "buffer" && r && t.setInitialState(), !xh(t, n, r))
        return !0;
      if (!r)
        return !1;
      const i = t.session;
      if (kB(t, r), t.recordingMode === "buffer" && i && t.eventBuffer) {
        const o = t.eventBuffer.getEarliestTimestamp();
        o && (O && D.info(`Updating session start time to earliest event in buffer to ${new Date(o)}`), i.started = o, t.getOptions().stickySession && Rh(i));
      }
      return i && i.previousSessionId || t.recordingMode === "session" && t.flush(), !0;
    });
  };
}
function FB(t) {
  const e = t.getOptions();
  return {
    type: W.Custom,
    timestamp: Date.now(),
    data: {
      tag: "options",
      payload: {
        shouldRecordCanvas: t.isRecordingCanvas(),
        sessionSampleRate: e.sessionSampleRate,
        errorSampleRate: e.errorSampleRate,
        useCompressionOption: e.useCompression,
        blockAllMedia: e.blockAllMedia,
        maskAllText: e.maskAllText,
        maskAllInputs: e.maskAllInputs,
        useCompression: t.eventBuffer ? t.eventBuffer.type === "worker" : !1,
        networkDetailHasUrls: e.networkDetailAllowUrls.length > 0,
        networkCaptureBodies: e.networkCaptureBodies,
        networkRequestHasHeaders: e.networkRequestHeaders.length > 0,
        networkResponseHasHeaders: e.networkResponseHeaders.length > 0
      }
    }
  };
}
function kB(t, e) {
  !e || !t.session || t.session.segmentId !== 0 || xh(t, FB(t), !1);
}
function AB() {
  const t = he().getPropagationContext().dsc;
  t && delete t.replay_id;
  const e = De();
  if (e) {
    const n = Zn(e);
    delete n.replay_id;
  }
}
function NB(t, e, n, s) {
  return Ps(
    Ay(t, lh(t), s, n),
    [
      [{ type: "replay_event" }, t],
      [
        {
          type: "replay_recording",
          // If string then we need to encode to UTF8, otherwise will have
          // wrong size. TextEncoder has similar browser support to
          // MutationObserver, although it does not accept IE11.
          length: typeof e == "string" ? new TextEncoder().encode(e).length : e.length
        },
        e
      ]
    ]
  );
}
function LB({
  recordingData: t,
  headers: e
}) {
  let n;
  const s = `${JSON.stringify(e)}
`;
  if (typeof t == "string")
    n = `${s}${t}`;
  else {
    const i = new TextEncoder().encode(s);
    n = new Uint8Array(i.length + t.length), n.set(i), n.set(t, i.length);
  }
  return n;
}
async function RB({
  client: t,
  scope: e,
  replayId: n,
  event: s
}) {
  const r = typeof t._integrations == "object" && t._integrations !== null && !Array.isArray(t._integrations) ? Object.keys(t._integrations) : void 0, i = { event_id: n, integrations: r };
  t.emit("preprocessEvent", s, i);
  const o = await qy(
    t.getOptions(),
    s,
    i,
    e,
    t,
    Et()
  );
  if (!o)
    return null;
  o.platform = o.platform || "javascript";
  const a = t.getSdkMetadata(), { name: c, version: l } = a && a.sdk || {};
  return o.sdk = {
    ...o.sdk,
    name: c || "sentry.javascript.unknown",
    version: l || "0.0.0"
  }, o;
}
async function xB({
  recordingData: t,
  replayId: e,
  segmentId: n,
  eventContext: s,
  timestamp: r,
  session: i
}) {
  const o = LB({
    recordingData: t,
    headers: {
      segment_id: n
    }
  }), { urls: a, errorIds: c, traceIds: l, initialTimestamp: d } = s, u = J(), h = he(), p = u && u.getTransport(), f = u && u.getDsn();
  if (!u || !p || !f || !i.sampled)
    return hn({});
  const m = {
    type: pD,
    replay_start_timestamp: d / 1e3,
    timestamp: r / 1e3,
    error_ids: c,
    trace_ids: l,
    urls: a,
    replay_id: e,
    segment_id: n,
    replay_type: i.sampled
  }, g = await RB({ scope: h, client: u, replayId: e, event: m });
  if (!g)
    return u.recordDroppedEvent("event_processor", "replay", m), O && D.info("An event processor returned `null`, will not send event."), hn({});
  delete g.sdkProcessingMetadata;
  const y = NB(g, o, f, u.getOptions().tunnel);
  let I;
  try {
    I = await p.send(y);
  } catch (T) {
    const F = new Error(wh);
    try {
      F.cause = T;
    } catch {
    }
    throw F;
  }
  if (typeof I.statusCode == "number" && (I.statusCode < 200 || I.statusCode >= 300))
    throw new lb(I.statusCode);
  const A = Ly({}, I);
  if (Ny(A, "replay"))
    throw new Ph(A);
  return I;
}
class lb extends Error {
  constructor(e) {
    super(`Transport returned status code ${e}`);
  }
}
class Ph extends Error {
  constructor(e) {
    super("Rate limit hit"), this.rateLimits = e;
  }
}
async function db(t, e = {
  count: 0,
  interval: ED
}) {
  const { recordingData: n, onError: s } = t;
  if (n.length)
    try {
      return await xB(t), !0;
    } catch (r) {
      if (r instanceof lb || r instanceof Ph)
        throw r;
      if (tO("Replays", {
        _retryCount: e.count
      }), s && s(r), e.count >= bD) {
        const i = new Error(`${wh} - max retries exceeded`);
        try {
          i.cause = r;
        } catch {
        }
        throw i;
      }
      return e.interval *= ++e.count, new Promise((i, o) => {
        Or(async () => {
          try {
            await db(t, e), i(!0);
          } catch (a) {
            o(a);
          }
        }, e.interval);
      });
    }
}
const ub = "__THROTTLED", OB = "__SKIPPED";
function PB(t, e, n) {
  const s = /* @__PURE__ */ new Map(), r = (a) => {
    const c = a - n;
    s.forEach((l, d) => {
      d < c && s.delete(d);
    });
  }, i = () => [...s.values()].reduce((a, c) => a + c, 0);
  let o = !1;
  return (...a) => {
    const c = Math.floor(Date.now() / 1e3);
    if (r(c), i() >= e) {
      const d = o;
      return o = !0, d ? OB : ub;
    }
    o = !1;
    const l = s.get(c) || 0;
    return s.set(c, l + 1), t(...a);
  };
}
class In {
  /**
   * Recording can happen in one of two modes:
   *   - session: Record the whole session, sending it continuously
   *   - buffer: Always keep the last 60s of recording, requires:
   *     - having replaysOnErrorSampleRate > 0 to capture replay when an error occurs
   *     - or calling `flush()` to send the replay
   */
  /**
   * The current or last active span.
   * This is only available when performance is enabled.
   */
  /**
   * These are here so we can overwrite them in tests etc.
   * @hidden
   */
  /** The replay has to be manually started, because no sample rate (neither session or error) was provided. */
  /**
   * Options to pass to `rrweb.record()`
   */
  /**
   * Timestamp of the last user activity. This lives across sessions.
   */
  /**
   * Is the integration currently active?
   */
  /**
   * Paused is a state where:
   * - DOM Recording is not listening at all
   * - Nothing will be added to event buffer (e.g. core SDK events)
   */
  /**
   * Have we attached listeners to the core SDK?
   * Note we have to track this as there is no way to remove instrumentation handlers.
   */
  /**
   * Function to stop recording
   */
  /**
   * Internal use for canvas recording options
   */
  constructor({
    options: e,
    recordingOptions: n
  }) {
    In.prototype.__init.call(this), In.prototype.__init2.call(this), In.prototype.__init3.call(this), In.prototype.__init4.call(this), In.prototype.__init5.call(this), In.prototype.__init6.call(this), this.eventBuffer = null, this.performanceEntries = [], this.replayPerformanceEntries = [], this.recordingMode = "session", this.timeouts = {
      sessionIdlePause: fD,
      sessionIdleExpire: mD
    }, this._lastActivity = Date.now(), this._isEnabled = !1, this._isPaused = !1, this._requiresManualStart = !1, this._hasInitializedCoreListeners = !1, this._context = {
      errorIds: /* @__PURE__ */ new Set(),
      traceIds: /* @__PURE__ */ new Set(),
      urls: [],
      initialTimestamp: Date.now(),
      initialUrl: ""
    }, this._recordingOptions = n, this._options = e, this._debouncedFlush = IB(() => this._flush(), this._options.flushMinDelay, {
      maxWait: this._options.flushMaxDelay
    }), this._throttledAddEvent = PB(
      (o, a) => N2(this, o, a),
      // Max 300 events...
      300,
      // ... per 5s
      5
    );
    const { slowClickTimeout: s, slowClickIgnoreSelectors: r } = this.getOptions(), i = s ? {
      threshold: Math.min(vD, s),
      timeout: s,
      scrollTimeout: SD,
      ignoreSelector: r ? r.join(",") : ""
    } : void 0;
    if (i && (this.clickDetector = new HG(this, i)), O) {
      const o = e._experiments;
      D.setConfig({
        captureExceptions: !!o.captureExceptions,
        traceInternals: !!o.traceInternals
      });
    }
  }
  /** Get the event context. */
  getContext() {
    return this._context;
  }
  /** If recording is currently enabled. */
  isEnabled() {
    return this._isEnabled;
  }
  /** If recording is currently paused. */
  isPaused() {
    return this._isPaused;
  }
  /**
   * Determine if canvas recording is enabled
   */
  isRecordingCanvas() {
    return !!this._canvas;
  }
  /** Get the replay integration options. */
  getOptions() {
    return this._options;
  }
  /** A wrapper to conditionally capture exceptions. */
  handleException(e) {
    O && D.exception(e), this._options.onError && this._options.onError(e);
  }
  /**
   * Initializes the plugin based on sampling configuration. Should not be
   * called outside of constructor.
   */
  initializeSampling(e) {
    const { errorSampleRate: n, sessionSampleRate: s } = this._options, r = n <= 0 && s <= 0;
    if (this._requiresManualStart = r, !r) {
      if (this._initializeSessionForSampling(e), !this.session) {
        O && D.exception(new Error("Unable to initialize and create session"));
        return;
      }
      this.session.sampled !== !1 && (this.recordingMode = this.session.sampled === "buffer" && this.session.segmentId === 0 ? "buffer" : "session", O && D.infoTick(`Starting replay in ${this.recordingMode} mode`), this._initializeRecording());
    }
  }
  /**
   * Start a replay regardless of sampling rate. Calling this will always
   * create a new session. Will log a message if replay is already in progress.
   *
   * Creates or loads a session, attaches listeners to varying events (DOM,
   * _performanceObserver, Recording, Sentry SDK, etc)
   */
  start() {
    if (this._isEnabled && this.recordingMode === "session") {
      O && D.info("Recording is already in progress");
      return;
    }
    if (this._isEnabled && this.recordingMode === "buffer") {
      O && D.info("Buffering is in progress, call `flush()` to save the replay");
      return;
    }
    O && D.infoTick("Starting replay in session mode"), this._updateUserActivity();
    const e = Nl(
      {
        maxReplayDuration: this._options.maxReplayDuration,
        sessionIdleExpire: this.timeouts.sessionIdleExpire
      },
      {
        stickySession: this._options.stickySession,
        // This is intentional: create a new session-based replay when calling `start()`
        sessionSampleRate: 1,
        allowBuffering: !1
      }
    );
    this.session = e, this._initializeRecording();
  }
  /**
   * Start replay buffering. Buffers until `flush()` is called or, if
   * `replaysOnErrorSampleRate` > 0, an error occurs.
   */
  startBuffering() {
    if (this._isEnabled) {
      O && D.info("Buffering is in progress, call `flush()` to save the replay");
      return;
    }
    O && D.infoTick("Starting replay in buffer mode");
    const e = Nl(
      {
        sessionIdleExpire: this.timeouts.sessionIdleExpire,
        maxReplayDuration: this._options.maxReplayDuration
      },
      {
        stickySession: this._options.stickySession,
        sessionSampleRate: 0,
        allowBuffering: !0
      }
    );
    this.session = e, this.recordingMode = "buffer", this._initializeRecording();
  }
  /**
   * Start recording.
   *
   * Note that this will cause a new DOM checkout
   */
  startRecording() {
    try {
      const e = this._canvas;
      this._stopRecording = sn({
        ...this._recordingOptions,
        // When running in error sampling mode, we need to overwrite `checkoutEveryNms`
        // Without this, it would record forever, until an error happens, which we don't want
        // instead, we'll always keep the last 60 seconds of replay before an error happened
        ...this.recordingMode === "buffer" ? { checkoutEveryNms: yD } : (
          // Otherwise, use experimental option w/ min checkout time of 6 minutes
          // This is to improve playback seeking as there could potentially be
          // less mutations to process in the worse cases.
          //
          // checkout by "N" events is probably ideal, but means we have less
          // control about the number of checkouts we make (which generally
          // increases replay size)
          this._options._experiments.continuousCheckout && {
            // Minimum checkout time is 6 minutes
            checkoutEveryNms: Math.max(36e4, this._options._experiments.continuousCheckout)
          }
        ),
        emit: CB(this),
        onMutation: this._onMutationHandler,
        ...e ? {
          recordCanvas: e.recordCanvas,
          getCanvasManager: e.getCanvasManager,
          sampling: e.sampling,
          dataURLOptions: e.dataURLOptions
        } : {}
      });
    } catch (e) {
      this.handleException(e);
    }
  }
  /**
   * Stops the recording, if it was running.
   *
   * Returns true if it was previously stopped, or is now stopped,
   * otherwise false.
   */
  stopRecording() {
    try {
      return this._stopRecording && (this._stopRecording(), this._stopRecording = void 0), !0;
    } catch (e) {
      return this.handleException(e), !1;
    }
  }
  /**
   * Currently, this needs to be manually called (e.g. for tests). Sentry SDK
   * does not support a teardown
   */
  async stop({ forceFlush: e = !1, reason: n } = {}) {
    if (this._isEnabled) {
      this._isEnabled = !1;
      try {
        O && D.info(`Stopping Replay${n ? ` triggered by ${n}` : ""}`), AB(), this._removeListeners(), this.stopRecording(), this._debouncedFlush.cancel(), e && await this._flush({ force: !0 }), this.eventBuffer && this.eventBuffer.destroy(), this.eventBuffer = null, I2(this);
      } catch (s) {
        this.handleException(s);
      }
    }
  }
  /**
   * Pause some replay functionality. See comments for `_isPaused`.
   * This differs from stop as this only stops DOM recording, it is
   * not as thorough of a shutdown as `stop()`.
   */
  pause() {
    this._isPaused || (this._isPaused = !0, this.stopRecording(), O && D.info("Pausing replay"));
  }
  /**
   * Resumes recording, see notes for `pause().
   *
   * Note that calling `startRecording()` here will cause a
   * new DOM checkout.`
   */
  resume() {
    !this._isPaused || !this._checkSession() || (this._isPaused = !1, this.startRecording(), O && D.info("Resuming replay"));
  }
  /**
   * If not in "session" recording mode, flush event buffer which will create a new replay.
   * Unless `continueRecording` is false, the replay will continue to record and
   * behave as a "session"-based replay.
   *
   * Otherwise, queue up a flush.
   */
  async sendBufferedReplayOrFlush({ continueRecording: e = !0 } = {}) {
    if (this.recordingMode === "session")
      return this.flushImmediate();
    const n = Date.now();
    O && D.info("Converting buffer to session"), await this.flushImmediate();
    const s = this.stopRecording();
    !e || !s || this.recordingMode !== "session" && (this.recordingMode = "session", this.session && (this._updateUserActivity(n), this._updateSessionActivity(n), this._maybeSaveSession()), this.startRecording());
  }
  /**
   * We want to batch uploads of replay events. Save events only if
   * `<flushMinDelay>` milliseconds have elapsed since the last event
   * *OR* if `<flushMaxDelay>` milliseconds have elapsed.
   *
   * Accepts a callback to perform side-effects and returns true to stop batch
   * processing and hand back control to caller.
   */
  addUpdate(e) {
    const n = e();
    this.recordingMode !== "buffer" && n !== !0 && this._debouncedFlush();
  }
  /**
   * Updates the user activity timestamp and resumes recording. This should be
   * called in an event handler for a user action that we consider as the user
   * being "active" (e.g. a mouse click).
   */
  triggerUserActivity() {
    if (this._updateUserActivity(), !this._stopRecording) {
      if (!this._checkSession())
        return;
      this.resume();
      return;
    }
    this.checkAndHandleExpiredSession(), this._updateSessionActivity();
  }
  /**
   * Updates the user activity timestamp *without* resuming
   * recording. Some user events (e.g. keydown) can be create
   * low-value replays that only contain the keypress as a
   * breadcrumb. Instead this would require other events to
   * create a new replay after a session has expired.
   */
  updateUserActivity() {
    this._updateUserActivity(), this._updateSessionActivity();
  }
  /**
   * Only flush if `this.recordingMode === 'session'`
   */
  conditionalFlush() {
    return this.recordingMode === "buffer" ? Promise.resolve() : this.flushImmediate();
  }
  /**
   * Flush using debounce flush
   */
  flush() {
    return this._debouncedFlush();
  }
  /**
   * Always flush via `_debouncedFlush` so that we do not have flushes triggered
   * from calling both `flush` and `_debouncedFlush`. Otherwise, there could be
   * cases of multiple flushes happening closely together.
   */
  flushImmediate() {
    return this._debouncedFlush(), this._debouncedFlush.flush();
  }
  /**
   * Cancels queued up flushes.
   */
  cancelFlush() {
    this._debouncedFlush.cancel();
  }
  /** Get the current session (=replay) ID */
  getSessionId() {
    return this.session && this.session.id;
  }
  /**
   * Checks if recording should be stopped due to user inactivity. Otherwise
   * check if session is expired and create a new session if so. Triggers a new
   * full snapshot on new session.
   *
   * Returns true if session is not expired, false otherwise.
   * @hidden
   */
  checkAndHandleExpiredSession() {
    if (this._lastActivity && Gd(this._lastActivity, this.timeouts.sessionIdlePause) && this.session && this.session.sampled === "session") {
      this.pause();
      return;
    }
    return !!this._checkSession();
  }
  /**
   * Capture some initial state that can change throughout the lifespan of the
   * replay. This is required because otherwise they would be captured at the
   * first flush.
   */
  setInitialState() {
    const e = `${le.location.pathname}${le.location.hash}${le.location.search}`, n = `${le.location.origin}${e}`;
    this.performanceEntries = [], this.replayPerformanceEntries = [], this._clearContext(), this._context.initialUrl = n, this._context.initialTimestamp = Date.now(), this._context.urls.push(n);
  }
  /**
   * Add a breadcrumb event, that may be throttled.
   * If it was throttled, we add a custom breadcrumb to indicate that.
   */
  throttledAddEvent(e, n) {
    const s = this._throttledAddEvent(e, n);
    if (s === ub) {
      const r = Ot({
        category: "replay.throttled"
      });
      this.addUpdate(() => !xh(this, {
        type: MG,
        timestamp: r.timestamp || 0,
        data: {
          tag: "breadcrumb",
          payload: r,
          metric: !0
        }
      }));
    }
    return s;
  }
  /**
   * This will get the parametrized route name of the current page.
   * This is only available if performance is enabled, and if an instrumented router is used.
   */
  getCurrentRoute() {
    const e = this.lastActiveSpan || De(), n = e && Pe(e), r = (n && ne(n).data || {})[Qt];
    if (!(!n || !r || !["route", "custom"].includes(r)))
      return ne(n).description;
  }
  /**
   * Initialize and start all listeners to varying events (DOM,
   * Performance Observer, Recording, Sentry SDK, etc)
   */
  _initializeRecording() {
    this.setInitialState(), this._updateSessionActivity(), this.eventBuffer = S2({
      useCompression: this._options.useCompression,
      workerUrl: this._options.workerUrl
    }), this._removeListeners(), this._addListeners(), this._isEnabled = !0, this._isPaused = !1, this.startRecording();
  }
  /**
   * Loads (or refreshes) the current session.
   */
  _initializeSessionForSampling(e) {
    const n = this._options.errorSampleRate > 0, s = Nl(
      {
        sessionIdleExpire: this.timeouts.sessionIdleExpire,
        maxReplayDuration: this._options.maxReplayDuration,
        previousSessionId: e
      },
      {
        stickySession: this._options.stickySession,
        sessionSampleRate: this._options.sessionSampleRate,
        allowBuffering: n
      }
    );
    this.session = s;
  }
  /**
   * Checks and potentially refreshes the current session.
   * Returns false if session is not recorded.
   */
  _checkSession() {
    if (!this.session)
      return !1;
    const e = this.session;
    return QE(e, {
      sessionIdleExpire: this.timeouts.sessionIdleExpire,
      maxReplayDuration: this._options.maxReplayDuration
    }) ? (this._refreshSession(e), !1) : !0;
  }
  /**
   * Refresh a session with a new one.
   * This stops the current session (without forcing a flush, as that would never work since we are expired),
   * and then does a new sampling based on the refreshed session.
   */
  async _refreshSession(e) {
    this._isEnabled && (await this.stop({ reason: "refresh session" }), this.initializeSampling(e.id));
  }
  /**
   * Adds listeners to record events for the replay
   */
  _addListeners() {
    try {
      le.document.addEventListener("visibilitychange", this._handleVisibilityChange), le.addEventListener("blur", this._handleWindowBlur), le.addEventListener("focus", this._handleWindowFocus), le.addEventListener("keydown", this._handleKeyboardEvent), this.clickDetector && this.clickDetector.addListeners(), this._hasInitializedCoreListeners || (SB(this), this._hasInitializedCoreListeners = !0);
    } catch (e) {
      this.handleException(e);
    }
    this._performanceCleanupCallback = g2(this);
  }
  /**
   * Cleans up listeners that were created in `_addListeners`
   */
  _removeListeners() {
    try {
      le.document.removeEventListener("visibilitychange", this._handleVisibilityChange), le.removeEventListener("blur", this._handleWindowBlur), le.removeEventListener("focus", this._handleWindowFocus), le.removeEventListener("keydown", this._handleKeyboardEvent), this.clickDetector && this.clickDetector.removeListeners(), this._performanceCleanupCallback && this._performanceCleanupCallback();
    } catch (e) {
      this.handleException(e);
    }
  }
  /**
   * Handle when visibility of the page content changes. Opening a new tab will
   * cause the state to change to hidden because of content of current page will
   * be hidden. Likewise, moving a different window to cover the contents of the
   * page will also trigger a change to a hidden state.
   */
  __init() {
    this._handleVisibilityChange = () => {
      le.document.visibilityState === "visible" ? this._doChangeToForegroundTasks() : this._doChangeToBackgroundTasks();
    };
  }
  /**
   * Handle when page is blurred
   */
  __init2() {
    this._handleWindowBlur = () => {
      const e = Ot({
        category: "ui.blur"
      });
      this._doChangeToBackgroundTasks(e);
    };
  }
  /**
   * Handle when page is focused
   */
  __init3() {
    this._handleWindowFocus = () => {
      const e = Ot({
        category: "ui.focus"
      });
      this._doChangeToForegroundTasks(e);
    };
  }
  /** Ensure page remains active when a key is pressed. */
  __init4() {
    this._handleKeyboardEvent = (e) => {
      n2(this, e);
    };
  }
  /**
   * Tasks to run when we consider a page to be hidden (via blurring and/or visibility)
   */
  _doChangeToBackgroundTasks(e) {
    !this.session || JE(this.session, {
      maxReplayDuration: this._options.maxReplayDuration,
      sessionIdleExpire: this.timeouts.sessionIdleExpire
    }) || (e && this._createCustomBreadcrumb(e), this.conditionalFlush());
  }
  /**
   * Tasks to run when we consider a page to be visible (via focus and/or visibility)
   */
  _doChangeToForegroundTasks(e) {
    if (!this.session)
      return;
    if (!this.checkAndHandleExpiredSession()) {
      O && D.info("Document has become active, but session has expired");
      return;
    }
    e && this._createCustomBreadcrumb(e);
  }
  /**
   * Update user activity (across session lifespans)
   */
  _updateUserActivity(e = Date.now()) {
    this._lastActivity = e;
  }
  /**
   * Updates the session's last activity timestamp
   */
  _updateSessionActivity(e = Date.now()) {
    this.session && (this.session.lastActivity = e, this._maybeSaveSession());
  }
  /**
   * Helper to create (and buffer) a replay breadcrumb from a core SDK breadcrumb
   */
  _createCustomBreadcrumb(e) {
    this.addUpdate(() => {
      this.throttledAddEvent({
        type: W.Custom,
        timestamp: e.timestamp || 0,
        data: {
          tag: "breadcrumb",
          payload: e
        }
      });
    });
  }
  /**
   * Observed performance events are added to `this.performanceEntries`. These
   * are included in the replay event before it is finished and sent to Sentry.
   */
  _addPerformanceEntries() {
    let e = o2(this.performanceEntries).concat(this.replayPerformanceEntries);
    if (this.performanceEntries = [], this.replayPerformanceEntries = [], this._requiresManualStart) {
      const n = this._context.initialTimestamp / 1e3;
      e = e.filter((s) => s.start >= n);
    }
    return Promise.all(Gc(this, e));
  }
  /**
   * Clear _context
   */
  _clearContext() {
    this._context.errorIds.clear(), this._context.traceIds.clear(), this._context.urls = [];
  }
  /** Update the initial timestamp based on the buffer content. */
  _updateInitialTimestampFromEventBuffer() {
    const { session: e, eventBuffer: n } = this;
    if (!e || !n || this._requiresManualStart || e.segmentId)
      return;
    const s = n.getEarliestTimestamp();
    s && s < this._context.initialTimestamp && (this._context.initialTimestamp = s);
  }
  /**
   * Return and clear _context
   */
  _popEventContext() {
    const e = {
      initialTimestamp: this._context.initialTimestamp,
      initialUrl: this._context.initialUrl,
      errorIds: Array.from(this._context.errorIds),
      traceIds: Array.from(this._context.traceIds),
      urls: this._context.urls
    };
    return this._clearContext(), e;
  }
  /**
   * Flushes replay event buffer to Sentry.
   *
   * Performance events are only added right before flushing - this is
   * due to the buffered performance observer events.
   *
   * Should never be called directly, only by `flush`
   */
  async _runFlush() {
    const e = this.getSessionId();
    if (!this.session || !this.eventBuffer || !e) {
      O && D.error("No session or eventBuffer found to flush.");
      return;
    }
    if (await this._addPerformanceEntries(), !(!this.eventBuffer || !this.eventBuffer.hasEvents) && (await wB(this), !!this.eventBuffer && e === this.getSessionId()))
      try {
        this._updateInitialTimestampFromEventBuffer();
        const n = Date.now();
        if (n - this._context.initialTimestamp > this._options.maxReplayDuration + 3e4)
          throw new Error("Session is too long, not sending replay");
        const s = this._popEventContext(), r = this.session.segmentId++;
        this._maybeSaveSession();
        const i = await this.eventBuffer.finish();
        await db({
          replayId: e,
          recordingData: i,
          segmentId: r,
          eventContext: s,
          session: this.session,
          timestamp: n,
          onError: (o) => this.handleException(o)
        });
      } catch (n) {
        this.handleException(n), this.stop({ reason: "sendReplay" });
        const s = J();
        if (s) {
          const r = n instanceof Ph ? "ratelimit_backoff" : "send_error";
          s.recordDroppedEvent(r, "replay");
        }
      }
  }
  /**
   * Flush recording data to Sentry. Creates a lock so that only a single flush
   * can be active at a time. Do not call this directly.
   */
  __init5() {
    this._flush = async ({
      force: e = !1
    } = {}) => {
      if (!this._isEnabled && !e)
        return;
      if (!this.checkAndHandleExpiredSession()) {
        O && D.error("Attempting to finish replay event after session expired.");
        return;
      }
      if (!this.session)
        return;
      const n = this.session.started, r = Date.now() - n;
      this._debouncedFlush.cancel();
      const i = r < this._options.minReplayDuration, o = r > this._options.maxReplayDuration + 5e3;
      if (i || o) {
        O && D.info(
          `Session duration (${Math.floor(r / 1e3)}s) is too ${i ? "short" : "long"}, not sending replay.`
        ), i && this._debouncedFlush();
        return;
      }
      const a = this.eventBuffer;
      a && this.session.segmentId === 0 && !a.hasCheckout && O && D.info("Flushing initial segment without checkout.");
      const c = !!this._flushLock;
      this._flushLock || (this._flushLock = this._runFlush());
      try {
        await this._flushLock;
      } catch (l) {
        this.handleException(l);
      } finally {
        this._flushLock = void 0, c && this._debouncedFlush();
      }
    };
  }
  /** Save the session, if it is sticky */
  _maybeSaveSession() {
    this.session && this._options.stickySession && Rh(this.session);
  }
  /** Handler for rrweb.record.onMutation */
  __init6() {
    this._onMutationHandler = (e) => {
      const n = e.length, s = this._options.mutationLimit, r = this._options.mutationBreadcrumbLimit, i = s && n > s;
      if (n > r || i) {
        const o = Ot({
          category: "replay.mutations",
          data: {
            count: n,
            limit: i
          }
        });
        this._createCustomBreadcrumb(o);
      }
      return i ? (this.stop({ reason: "mutationLimit", forceFlush: this.recordingMode === "session" }), !1) : !0;
    };
  }
}
function li(t, e) {
  return [
    ...t,
    // sentry defaults
    ...e
  ].join(",");
}
function MB({ mask: t, unmask: e, block: n, unblock: s, ignore: r }) {
  const i = ['base[href="/"]'], o = li(t, [".sentry-mask", "[data-sentry-mask]"]), a = li(e, []);
  return {
    // We are making the decision to make text and input selectors the same
    maskTextSelector: o,
    unmaskTextSelector: a,
    blockSelector: li(n, [".sentry-block", "[data-sentry-block]", ...i]),
    unblockSelector: li(s, []),
    ignoreSelector: li(r, [".sentry-ignore", "[data-sentry-ignore]", 'input[type="file"]'])
  };
}
function DB({
  el: t,
  key: e,
  maskAttributes: n,
  maskAllText: s,
  privacyOptions: r,
  value: i
}) {
  return !s || r.unmaskTextSelector && t.matches(r.unmaskTextSelector) ? i : n.includes(e) || // Need to mask `value` attribute for `<input>` if it's a button-like
  // type
  e === "value" && t.tagName === "INPUT" && ["submit", "button"].includes(t.getAttribute("type") || "") ? i.replace(/[\S]/g, "*") : i;
}
const jm = 'img,image,svg,video,object,picture,embed,map,audio,link[rel="icon"],link[rel="apple-touch-icon"]', GB = ["content-length", "content-type", "accept"];
let Wm = !1;
const BB = (t) => new $c(t);
class $c {
  /**
   * @inheritDoc
   */
  static __initStatic() {
    this.id = "Replay";
  }
  /**
   * @inheritDoc
   */
  /**
   * Options to pass to `rrweb.record()`
   */
  /**
   * Initial options passed to the replay integration, merged with default values.
   * Note: `sessionSampleRate` and `errorSampleRate` are not required here, as they
   * can only be finally set when setupOnce() is called.
   *
   * @private
   */
  constructor({
    flushMinDelay: e = gD,
    flushMaxDelay: n = _D,
    minReplayDuration: s = wD,
    maxReplayDuration: r = Im,
    stickySession: i = !0,
    useCompression: o = !0,
    workerUrl: a,
    _experiments: c = {},
    maskAllText: l = !0,
    maskAllInputs: d = !0,
    blockAllMedia: u = !0,
    mutationBreadcrumbLimit: h = 750,
    mutationLimit: p = 1e4,
    slowClickTimeout: f = 7e3,
    slowClickIgnoreSelectors: m = [],
    networkDetailAllowUrls: g = [],
    networkDetailDenyUrls: y = [],
    networkCaptureBodies: I = !0,
    networkRequestHeaders: A = [],
    networkResponseHeaders: T = [],
    mask: F = [],
    maskAttributes: _ = ["title", "placeholder"],
    unmask: E = [],
    block: C = [],
    unblock: N = [],
    ignore: v = [],
    maskFn: k,
    beforeAddRecordingEvent: L,
    beforeErrorSampling: $,
    onError: ee
  } = {}) {
    this.name = $c.id;
    const pe = MB({
      mask: F,
      unmask: E,
      block: C,
      unblock: N,
      ignore: v
    });
    if (this._recordingOptions = {
      maskAllInputs: d,
      maskAllText: l,
      maskInputOptions: { password: !0 },
      maskTextFn: k,
      maskInputFn: k,
      maskAttributeFn: (R, re, q) => DB({
        maskAttributes: _,
        maskAllText: l,
        privacyOptions: pe,
        key: R,
        value: re,
        el: q
      }),
      ...pe,
      // Our defaults
      slimDOMOptions: "all",
      inlineStylesheet: !0,
      // Disable inline images as it will increase segment/replay size
      inlineImages: !1,
      // collect fonts, but be aware that `sentry.io` needs to be an allowed
      // origin for playback
      collectFonts: !0,
      errorHandler: (R) => {
        try {
          R.__rrweb__ = !0;
        } catch {
        }
      }
    }, this._initialOptions = {
      flushMinDelay: e,
      flushMaxDelay: n,
      minReplayDuration: Math.min(s, TD),
      maxReplayDuration: Math.min(r, Im),
      stickySession: i,
      useCompression: o,
      workerUrl: a,
      blockAllMedia: u,
      maskAllInputs: d,
      maskAllText: l,
      mutationBreadcrumbLimit: h,
      mutationLimit: p,
      slowClickTimeout: f,
      slowClickIgnoreSelectors: m,
      networkDetailAllowUrls: g,
      networkDetailDenyUrls: y,
      networkCaptureBodies: I,
      networkRequestHeaders: zm(A),
      networkResponseHeaders: zm(T),
      beforeAddRecordingEvent: L,
      beforeErrorSampling: $,
      onError: ee,
      _experiments: c
    }, this._initialOptions.blockAllMedia && (this._recordingOptions.blockSelector = this._recordingOptions.blockSelector ? `${this._recordingOptions.blockSelector},${jm}` : jm), this._isInitialized && Vf())
      throw new Error("Multiple Sentry Session Replay instances are not supported");
    this._isInitialized = !0;
  }
  /** If replay has already been initialized */
  get _isInitialized() {
    return Wm;
  }
  /** Update _isInitialized */
  set _isInitialized(e) {
    Wm = e;
  }
  /**
   * Setup and initialize replay container
   */
  afterAllSetup(e) {
    !Vf() || this._replay || (this._setup(e), this._initialize(e));
  }
  /**
   * Start a replay regardless of sampling rate. Calling this will always
   * create a new session. Will log a message if replay is already in progress.
   *
   * Creates or loads a session, attaches listeners to varying events (DOM,
   * PerformanceObserver, Recording, Sentry SDK, etc)
   */
  start() {
    this._replay && this._replay.start();
  }
  /**
   * Start replay buffering. Buffers until `flush()` is called or, if
   * `replaysOnErrorSampleRate` > 0, until an error occurs.
   */
  startBuffering() {
    this._replay && this._replay.startBuffering();
  }
  /**
   * Currently, this needs to be manually called (e.g. for tests). Sentry SDK
   * does not support a teardown
   */
  stop() {
    return this._replay ? this._replay.stop({ forceFlush: this._replay.recordingMode === "session" }) : Promise.resolve();
  }
  /**
   * If not in "session" recording mode, flush event buffer which will create a new replay.
   * If replay is not enabled, a new session replay is started.
   * Unless `continueRecording` is false, the replay will continue to record and
   * behave as a "session"-based replay.
   *
   * Otherwise, queue up a flush.
   */
  flush(e) {
    return this._replay ? this._replay.isEnabled() ? this._replay.sendBufferedReplayOrFlush(e) : (this._replay.start(), Promise.resolve()) : Promise.resolve();
  }
  /**
   * Get the current session ID.
   */
  getReplayId() {
    if (!(!this._replay || !this._replay.isEnabled()))
      return this._replay.getSessionId();
  }
  /**
   * Get the current recording mode. This can be either `session` or `buffer`.
   *
   * `session`: Recording the whole session, sending it continuously
   * `buffer`: Always keeping the last 60s of recording, requires:
   *   - having replaysOnErrorSampleRate > 0 to capture replay when an error occurs
   *   - or calling `flush()` to send the replay
   */
  getRecordingMode() {
    if (!(!this._replay || !this._replay.isEnabled()))
      return this._replay.recordingMode;
  }
  /**
   * Initializes replay.
   */
  _initialize(e) {
    this._replay && (this._maybeLoadFromReplayCanvasIntegration(e), this._replay.initializeSampling());
  }
  /** Setup the integration. */
  _setup(e) {
    const n = $B(this._initialOptions, e);
    this._replay = new In({
      options: n,
      recordingOptions: this._recordingOptions
    });
  }
  /** Get canvas options from ReplayCanvas integration, if it is also added. */
  _maybeLoadFromReplayCanvasIntegration(e) {
    try {
      const n = e.getIntegrationByName("ReplayCanvas");
      if (!n)
        return;
      this._replay._canvas = n.getOptions();
    } catch {
    }
  }
}
$c.__initStatic();
function $B(t, e) {
  const n = e.getOptions(), s = {
    sessionSampleRate: 0,
    errorSampleRate: 0,
    ...Ce(t)
  }, r = Wa(n.replaysSessionSampleRate), i = Wa(n.replaysOnErrorSampleRate);
  return r == null && i == null && Kr(() => {
    console.warn(
      "Replay is disabled because neither `replaysSessionSampleRate` nor `replaysOnErrorSampleRate` are set."
    );
  }), r != null && (s.sessionSampleRate = r), i != null && (s.errorSampleRate = i), s;
}
function zm(t) {
  return [...GB, ...t.map((e) => e.toLowerCase())];
}
const qm = /* @__PURE__ */ new WeakMap(), Ll = /* @__PURE__ */ new Map(), da = {
  traceFetch: !0,
  traceXHR: !0,
  enableHTTPTimings: !0,
  trackFetchStreamPerformance: !1
};
function VB(t, e) {
  const {
    traceFetch: n,
    traceXHR: s,
    trackFetchStreamPerformance: r,
    shouldCreateSpanForRequest: i,
    enableHTTPTimings: o,
    tracePropagationTargets: a
  } = {
    traceFetch: da.traceFetch,
    traceXHR: da.traceXHR,
    trackFetchStreamPerformance: da.trackFetchStreamPerformance,
    ...e
  }, c = typeof i == "function" ? i : (u) => !0, l = (u) => WB(u, a), d = {};
  n && (t.addEventProcessor((u) => (u.type === "transaction" && u.spans && u.spans.forEach((h) => {
    if (h.op === "http.client") {
      const p = Ll.get(h.span_id);
      p && (h.timestamp = p / 1e3, Ll.delete(h.span_id));
    }
  }), u)), r && bR((u) => {
    if (u.response) {
      const h = qm.get(u.response);
      h && u.endTimestamp && Ll.set(h, u.endTimestamp);
    }
  }), Ey((u) => {
    const h = zO(u, c, l, d);
    if (u.response && u.fetchData.__span && qm.set(u.response, u.fetchData.__span), h) {
      const p = hb(u.fetchData.url), f = p ? ps(p).host : void 0;
      h.setAttributes({
        "http.url": p,
        "server.address": f
      });
    }
    o && h && Ym(h);
  })), s && bE((u) => {
    const h = zB(u, c, l, d);
    o && h && Ym(h);
  });
}
function UB(t) {
  return t.entryType === "resource" && "initiatorType" in t && typeof t.nextHopProtocol == "string" && (t.initiatorType === "fetch" || t.initiatorType === "xmlhttprequest");
}
function Ym(t) {
  const { url: e } = ne(t).data || {};
  if (!e || typeof e != "string")
    return;
  const n = xr("resource", ({ entries: s }) => {
    s.forEach((r) => {
      UB(r) && r.name.endsWith(e) && (jB(r).forEach((o) => t.setAttribute(...o)), setTimeout(n));
    });
  });
}
function HB(t) {
  let e = "unknown", n = "unknown", s = "";
  for (const r of t) {
    if (r === "/") {
      [e, n] = t.split("/");
      break;
    }
    if (!isNaN(Number(r))) {
      e = s === "h" ? "http" : s, n = t.split(s)[1];
      break;
    }
    s += r;
  }
  return s === t && (e = s), { name: e, version: n };
}
function Nt(t = 0) {
  return ((Ye || performance.timeOrigin) + t) / 1e3;
}
function jB(t) {
  const { name: e, version: n } = HB(t.nextHopProtocol), s = [];
  return s.push(["network.protocol.version", n], ["network.protocol.name", e]), Ye ? [
    ...s,
    ["http.request.redirect_start", Nt(t.redirectStart)],
    ["http.request.fetch_start", Nt(t.fetchStart)],
    ["http.request.domain_lookup_start", Nt(t.domainLookupStart)],
    ["http.request.domain_lookup_end", Nt(t.domainLookupEnd)],
    ["http.request.connect_start", Nt(t.connectStart)],
    ["http.request.secure_connection_start", Nt(t.secureConnectionStart)],
    ["http.request.connection_end", Nt(t.connectEnd)],
    ["http.request.request_start", Nt(t.requestStart)],
    ["http.request.response_start", Nt(t.responseStart)],
    ["http.request.response_end", Nt(t.responseEnd)]
  ] : s;
}
function WB(t, e) {
  const n = U.location && U.location.href;
  if (n) {
    let s, r;
    try {
      s = new URL(t, n), r = new URL(n).origin;
    } catch {
      return !1;
    }
    const i = s.origin === r;
    return e ? Dn(s.toString(), e) || i && Dn(s.pathname, e) : i;
  } else {
    const s = !!t.match(/^\/(?!\/)/);
    return e ? Dn(t, e) : s;
  }
}
function zB(t, e, n, s) {
  const r = t.xhr, i = r && r[cs];
  if (!r || r.__sentry_own_request__ || !i)
    return;
  const o = pn() && e(i.url);
  if (t.endTimestamp && o) {
    const h = r.__sentry_xhr_span_id__;
    if (!h) return;
    const p = s[h];
    p && i.status_code !== void 0 && (Oy(p, i.status_code), p.end(), delete s[h]);
    return;
  }
  const a = hb(i.url), c = a ? ps(a).host : void 0, l = !!De(), d = o && l ? Ds({
    name: `${i.method} ${i.url}`,
    attributes: {
      type: "xhr",
      "http.method": i.method,
      "http.url": a,
      url: i.url,
      "server.address": c,
      [Le]: "auto.http.browser",
      [Fs]: "http.client"
    }
  }) : new Jr();
  r.__sentry_xhr_span_id__ = d.spanContext().spanId, s[r.__sentry_xhr_span_id__] = d;
  const u = J();
  return r.setRequestHeader && n(i.url) && u && qB(
    r,
    u,
    // If performance is disabled (TWP) or there's no active root span (pageload/navigation/interaction),
    // we do not want to use the span as base for the trace headers,
    // which means that the headers will be generated from the scope and the sampling decision is deferred
    pn() && l ? d : void 0
  ), d;
}
function qB(t, e, n) {
  const s = he(), r = Et(), { traceId: i, spanId: o, sampled: a, dsc: c } = {
    ...r.getPropagationContext(),
    ...s.getPropagationContext()
  }, l = n && pn() ? Dy(n) : ch(i, o, a), d = ky(
    c || (n ? Zn(n) : Lc(i, e))
  );
  YB(t, l, d);
}
function YB(t, e, n) {
  try {
    t.setRequestHeader("sentry-trace", e), n && t.setRequestHeader(er, n);
  } catch {
  }
}
function hb(t) {
  try {
    return new URL(t, U.location.origin).href;
  } catch {
    return;
  }
}
function KB() {
  U && U.document ? U.document.addEventListener("visibilitychange", () => {
    const t = De();
    if (!t)
      return;
    const e = Pe(t);
    if (U.document.hidden && e) {
      const n = "cancelled", { op: s, status: r } = ne(e);
      Ft && w.log(`[Tracing] Transaction: ${n} -> since tab moved to the background, op: ${s}`), r || e.setStatus({ code: ke, message: n }), e.setAttribute("sentry.cancellation_reason", "document.hidden"), e.end();
    }
  }) : Ft && w.warn("[Tracing] Could not set up background tab detection due to lack of global document");
}
const XB = "BrowserTracing", JB = {
  ...oa,
  instrumentNavigation: !0,
  instrumentPageLoad: !0,
  markBackgroundSpan: !0,
  enableLongTask: !0,
  enableLongAnimationFrame: !0,
  enableInp: !0,
  _experiments: {},
  ...da
}, QB = (t = {}) => {
  Sx();
  const {
    enableInp: e,
    enableLongTask: n,
    enableLongAnimationFrame: s,
    _experiments: { enableInteractions: r, enableStandaloneClsSpans: i },
    beforeStartSpan: o,
    idleTimeout: a,
    finalTimeout: c,
    childSpanTimeout: l,
    markBackgroundSpan: d,
    traceFetch: u,
    traceXHR: h,
    trackFetchStreamPerformance: p,
    shouldCreateSpanForRequest: f,
    enableHTTPTimings: m,
    instrumentPageLoad: g,
    instrumentNavigation: y
  } = {
    ...JB,
    ...t
  }, I = jP({ recordClsStandaloneSpans: i || !1 });
  e && fM(), s && Z.PerformanceObserver && PerformanceObserver.supportedEntryTypes && PerformanceObserver.supportedEntryTypes.includes("long-animation-frame") ? zP() : n && WP(), r && qP();
  const A = {
    name: void 0,
    source: void 0
  };
  function T(F, _) {
    const E = _.op === "pageload", C = o ? o(_) : _, N = C.attributes || {};
    _.name !== C.name && (N[Qt] = "custom", C.attributes = N), A.name = C.name, A.source = N[Qt];
    const v = zy(C, {
      idleTimeout: a,
      finalTimeout: c,
      childSpanTimeout: l,
      // should wait for finish signal if it's a pageload transaction
      disableAutoFinish: E,
      beforeSpanEnd: (L) => {
        I(), QP(L, { recordClsOnPageloadSpan: !i });
      }
    });
    function k() {
      ["interactive", "complete"].includes(U.document.readyState) && F.emit("idleSpanEnableAutoFinish", v);
    }
    return E && U.document && (U.document.addEventListener("readystatechange", () => {
      k();
    }), k()), v;
  }
  return {
    name: XB,
    afterAllSetup(F) {
      let _, E = U.location && U.location.href;
      F.on("startNavigationSpan", (C) => {
        J() === F && (_ && !ne(_).timestamp && (Ft && w.log(`[Tracing] Finishing current root span with op: ${ne(_).op}`), _.end()), _ = T(F, {
          op: "navigation",
          ...C
        }));
      }), F.on("startPageLoadSpan", (C, N = {}) => {
        if (J() !== F)
          return;
        _ && !ne(_).timestamp && (Ft && w.log(`[Tracing] Finishing current root span with op: ${ne(_).op}`), _.end());
        const v = N.sentryTrace || Km("sentry-trace"), k = N.baggage || Km("baggage"), L = HR(v, k);
        he().setPropagationContext(L), _ = T(F, {
          op: "pageload",
          ...C
        });
      }), F.on("spanEnd", (C) => {
        const N = ne(C).op;
        if (C !== Pe(C) || N !== "navigation" && N !== "pageload")
          return;
        const v = he(), k = v.getPropagationContext();
        v.setPropagationContext({
          ...k,
          sampled: k.sampled !== void 0 ? k.sampled : Ms(C),
          dsc: k.dsc || Zn(C)
        });
      }), U.location && (g && ZB(F, {
        name: U.location.pathname,
        // pageload should always start at timeOrigin (and needs to be in s, not ms)
        startTime: Ye ? Ye / 1e3 : void 0,
        attributes: {
          [Qt]: "url",
          [Le]: "auto.pageload.browser"
        }
      }), y && xc(({ to: C, from: N }) => {
        if (N === void 0 && E && E.indexOf(C) !== -1) {
          E = void 0;
          return;
        }
        N !== C && (E = void 0, e3(F, {
          name: U.location.pathname,
          attributes: {
            [Qt]: "url",
            [Le]: "auto.navigation.browser"
          }
        }));
      })), d && KB(), r && t3(a, c, l, A), e && gM(), VB(F, {
        traceFetch: u,
        traceXHR: h,
        trackFetchStreamPerformance: p,
        tracePropagationTargets: F.getOptions().tracePropagationTargets,
        shouldCreateSpanForRequest: f,
        enableHTTPTimings: m
      });
    }
  };
};
function ZB(t, e, n) {
  t.emit("startPageLoadSpan", e, n), he().setTransactionName(e.name);
  const s = De();
  return (s && ne(s).op) === "pageload" ? s : void 0;
}
function e3(t, e) {
  Et().setPropagationContext(Ha()), he().setPropagationContext(Ha()), t.emit("startNavigationSpan", e), he().setTransactionName(e.name);
  const n = De();
  return (n && ne(n).op) === "navigation" ? n : void 0;
}
function Km(t) {
  const e = sR(`meta[name=${t}]`);
  return e ? e.getAttribute("content") : void 0;
}
function t3(t, e, n, s) {
  let r;
  const i = () => {
    const o = "ui.action.click", a = De(), c = a && Pe(a);
    if (c) {
      const l = ne(c).op;
      if (["navigation", "pageload"].includes(l)) {
        Ft && w.warn(`[Tracing] Did not create ${o} span because a pageload or navigation span is in progress.`);
        return;
      }
    }
    if (r && (r.setAttribute(bd, "interactionInterrupted"), r.end(), r = void 0), !s.name) {
      Ft && w.warn(`[Tracing] Did not create ${o} transaction because _latestRouteName is missing.`);
      return;
    }
    r = zy(
      {
        name: s.name,
        op: o,
        attributes: {
          [Qt]: s.source || "url"
        }
      },
      {
        idleTimeout: t,
        finalTimeout: e,
        childSpanTimeout: n
      }
    );
  };
  U.document && addEventListener("click", i, { once: !1, capture: !0 });
}
uD({
  dsn: "https://5f486891e49f472aafc90c419f35d58c@o4505025638039552.ingest.us.sentry.io/4505025640595456",
  // Alternatively, use `process.env.npm_package_version` for a dynamic release version
  // if your build tool supports it.
  release: "beam-designer",
  integrations: [
    QB(),
    BB()
  ],
  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for tracing.
  // We recommend adjusting this value in production
  tracesSampleRate: 1,
  // Set `tracePropagationTargets` to control for which URLs trace propagation should be enabled
  tracePropagationTargets: [
    "localhost",
    /^https:\/\/webstructural\.com\/beam-design.html/
  ],
  // Capture Replay for 10% of all sessions,
  // plus for 100% of sessions with an error
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1
});
function i3(t) {
  on.getOrCreateInstance(`#${t}`).show();
}
function o3(t) {
  M.getOrCreateInstance(`#${t}`).show();
}
function a3(t) {
  M.getOrCreateInstance(`#${t}`).hide();
}
function c3(t) {
  const e = document.getElementById(t);
  e && new on(e).show();
}
function l3() {
  [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]')).map(function(e) {
    return new Ns(e);
  });
}
const n3 = {
  apiKey: "AIzaSyCtSfIQyZua3V5lpmthL-Q49trkv9phV4g",
  authDomain: "webstructrual.firebaseapp.com",
  databaseURL: "https://webstructrual.firebaseio.com",
  projectId: "webstructrual",
  storageBucket: "webstructrual.appspot.com",
  messagingSenderId: "157062586915"
};
uu(n3);
LL();
try {
  RL();
} catch (t) {
  console.error(t);
}
const Fe = Be();
function s3() {
  return Mn === !0;
}
function Je() {
  return Fr === !1 ? (M.getOrCreateInstance(document.getElementById("modal-sign-up-form")).show(), !0) : Mn === !1 ? (M.getOrCreateInstance(document.getElementById("modal-finish-upgrade")).show(), !0) : !1;
}
class d3 {
  constructor(e) {
    this.projectRoot = e, this.activeProject = null, this.projects = [];
  }
  initialize(e) {
    this.activeProject = e, document.addEventListener("customer-logged-in-and-upgraded", () => {
      this.enablePrinting(), this.getProjectsFromDatabaseAndUpdateProjectList();
    }), document.addEventListener("customer-logged-in-not-upgraded", async () => {
      this.disablePrinting();
    }), document.addEventListener("recurring-payment-failed", () => {
      this.disablePrinting();
    }), document.addEventListener("subscription-previously-canceled", () => {
      this.disablePrinting();
    }), document.addEventListener("customer-logged-out", () => {
      this.disablePrinting();
    }), document.addEventListener("project-loaded", () => {
      this.activeProject.updateDesign(), this.draw(this.activeProject);
    }), document.addEventListener("project-title-changed", (n) => {
      this.activeProject.title = n.detail, this.saveProject();
    }), document.addEventListener("save-project", () => {
      this.saveProject();
    }), document.addEventListener("load-project", (n) => {
      const s = n.detail;
      this.onLoadProjectClick(s.key);
    }), document.addEventListener("project-modified", () => {
      this.activeProject.updateDesign();
    }), document.addEventListener("create-folder", (n) => {
      this.createNewFolder(n.detail);
    }), document.addEventListener("add-active-project-to-folder", (n) => {
      this.addActiveProjectToFolder(n.detail);
    }), document.addEventListener("rename-folder", (n) => {
      this.renameFolder(n.detail.uuid, n.detail.newName);
    }), document.addEventListener("delete-folder", (n) => {
      this.deleteFolder(n.detail);
    });
  }
  /********************************************
   * Virtual functions: Implemented by module
   *******************************************/
  draw(e, n) {
    console.error("not implemented");
  }
  deserialize(e) {
    console.error("not implemented");
  }
  newProject() {
    console.error("not implemented");
  }
  copyProject() {
    console.error("not implemented");
  }
  openFileExplorer() {
    console.error("not implemented");
  }
  /********************************************
   * File Management
   *******************************************/
  onNewProjectClick() {
    if (Je())
      return;
    const e = this.activeProject.isModified ? "Current project not saved. Continue anyway?" : "Create a new project now?";
    hi("New Project", e, () => {
      this.createNewProject();
    });
  }
  createNewProject() {
    let e = {};
    this.projects.forEach((n) => {
      n.isActive && (n.isActive = !1, e[`/projects/${Fe.currentUser.uid}/${this.projectRoot}/${n.key}/isActive`] = !1);
    }), Zs(be(ve()), e), this.activeProject = this.newProject(), this.activeProject.isActive = !0, this.saveProject();
  }
  onOpenFileExplorerClick() {
    Je() || this.openFileExplorer();
  }
  onSaveProjectClick() {
    Je() || this.saveProject();
  }
  /**
   * Writes a project to the database. If project.key does not exist
   * we generate a new key. otherwise we use the key stored in the project.
   **/
  saveProject() {
    const e = be(ve(), "projects");
    this.activeProject.key === null && (this.activeProject.key = _l(e).key), this.activeProject.modifiedAt = Date.now(), this.activeProject.isActive = !0;
    const n = Re(e, `/${Fe.currentUser.uid}/${this.projectRoot}/${this.activeProject.key}`);
    zt(n, this.activeProject.serialize()).then(() => {
      this.getProjectsFromDatabaseAndUpdateProjectList("Project saved."), this.activeProject.isModified = !1, document.dispatchEvent(new CustomEvent("project-saved"));
    });
  }
  onRenameProjectClick() {
    Je() || M.getOrCreateInstance(document.getElementById("modal-project-header-settings-dialog")).show();
  }
  onCopyFileClick() {
    if (Je())
      return;
    const e = this.activeProject.isModified ? "Current project not saved. Continue anyway?" : "Create a copy project now?";
    hi("Create a Copy", e, () => {
      this.createCopy();
    });
  }
  createCopy() {
    const e = be(ve(), "projects");
    let n = {};
    this.projects.forEach((r) => {
      r.isActive && (r.isActive = !1, n[`/projects/${Fe.currentUser.uid}/${this.projectRoot}/${r.key}/isActive`] = !1);
    }), Zs(be(ve()), n), this.activeProject = this.copyProject(), document.dispatchEvent(new CustomEvent("project-loaded", { detail: this.activeProject }));
    const s = Re(e, `/${Fe.currentUser.uid}/${this.projectRoot}/${this.activeProject.key}`);
    zt(s, this.activeProject.serialize()).then(() => {
      this.getProjectsFromDatabaseAndUpdateProjectList("Project copied."), this.activeProject.isModified = !1, document.dispatchEvent(new CustomEvent("project-copied"));
    });
  }
  onPrintProject() {
    Je() || window.print();
  }
  onDeleteProjectClick() {
    Je() || hi("Delete Project", "Delete this project?", () => {
      this.deleteProject();
    });
  }
  deleteProject() {
    const e = be(ve(), "projects"), n = Re(e, `/${Fe.currentUser.uid}/${this.projectRoot}/${this.activeProject.key}`);
    Cf(n).then(() => {
      this.getProjectsFromDatabaseAndUpdateProjectList("Project deleted.");
    });
  }
  onNewFolderClick() {
    Je() || M.getOrCreateInstance(document.getElementById("new-folder-modal")).show();
  }
  createNewFolder(e) {
    const n = be(ve(), "folders"), s = _l(n).key, r = Re(n, `/${Fe.currentUser.uid}/${s}`), i = new r3(e, s);
    zt(r, i).then(() => {
      this.getProjectsFromDatabaseAndUpdateProjectList("New folder created."), document.dispatchEvent(new CustomEvent("folder-created", { detail: s }));
    }).catch((o) => {
      console.error(o.message);
    });
  }
  renameFolder(e, n) {
    const s = be(ve(), "folders"), r = Re(s, `/${Fe.currentUser.uid}/${e}`);
    Zs(r, { title: n, modifiedAt: Date.now() }).then(() => {
      this.getProjectsFromDatabaseAndUpdateProjectList("Folder name updated.");
    });
  }
  getFilesForFolder(e) {
    const n = be(ve(), "folders"), s = Re(n, `/${Fe.currentUser.uid}/${e}`);
    return rs(s).then((r) => {
      if (r.exists()) {
        const o = r.val().projects ?? {};
        return console.log(o), o;
      }
    }).catch((r) => {
      console.error(r.message);
    });
  }
  deleteFolder(e) {
    const n = e.key;
    this.getFilesForFolder(n).then((s) => {
      const r = {};
      Object.keys(s).forEach((i) => {
        r[`/projects/${Fe.currentUser.uid}/${this.projectRoot}/${i}/folderKey`] = null;
      }), Zs(be(ve()), r);
    }).then(() => {
      const s = be(ve(), "folders"), r = Re(s, `/${Fe.currentUser.uid}/${n}`);
      Cf(r).then(() => {
        this.getProjectsFromDatabaseAndUpdateProjectList("Folder deleted.");
      });
    }).catch((s) => {
      console.error(s.message);
    });
  }
  onMoveFileClick() {
    Je() || (document.getElementById("move-file-file-title").innerHTML = this.activeProject.title, M.getOrCreateInstance("#move-file-to-folder-modal").show());
  }
  addActiveProjectToFolder(e) {
    const n = be(ve(), "folders"), s = Re(n, `/${Fe.currentUser.uid}/${e ?? ""}`);
    console.log(s.toString());
    let r = [];
    if (this.activeProject.key === null) {
      const o = be(ve(), "projects");
      this.activeProject.key = _l(o).key;
    }
    const i = this.activeProject.key;
    this.activeProject.modifiedAt = Date.now(), this.activeProject.isActive = !0, zt(Re(be(ve()), `projects/${Fe.currentUser.uid}/${this.projectRoot}/${i}`), this.activeProject).then(() => {
      this.activeProject.isModified = !1, this.removeFileFromAnyFolder(i).then(() => {
        e !== null && rs(s).then((o) => {
          if (o.exists()) {
            const a = o.val();
            r = a.projects ?? {}, r[i] = i, a.projects = r, this.activeProject.folderKey = e, zt(s, a), this.getProjectsFromDatabaseAndUpdateProjectList(`File added to folder ${a.title}`);
          }
        });
      });
    }).catch((o) => {
      console.error(o.message);
    });
  }
  removeFileFromAnyFolder(e) {
    const n = be(ve(), `folders/${Fe.currentUser.uid}`);
    return rs(n).then((s) => {
      s.exists() && s.forEach((r) => {
        const i = r.val();
        let o = i.projects ?? {};
        if (e in o) {
          delete this.activeProject.folderKey, delete o[e], i.projects = o;
          const a = Re(n, `${i.key}`);
          zt(a, i), this.getProjectsFromDatabaseAndUpdateProjectList(`File removed from folder ${i.title}`);
        }
      });
    }).catch((s) => {
      console.error(s.message);
    });
  }
  removeFileFromFolder(e, n) {
    const s = be(ve(), "folders"), r = Re(s, `/${Fe.currentUser.uid}/${n}`);
    rs(r).then((i) => {
      if (i.exists()) {
        const o = i.val(), a = o.projects ?? {};
        e in a && (delete a[e], o.projects = a, zt(r, o), this.getProjectsFromDatabaseAndUpdateProjectList(`File removed from folder ${o.title}`));
      }
    }).catch((i) => {
      console.error(i.message);
    });
  }
  /**
   * Gets projects from the realtime database and updates the project list.
   * Sets the active project if one is not set otherwise it assumes the first
   * active project (isActive) it finds is the active one.
   **/
  getProjectsFromDatabaseAndUpdateProjectList(e) {
    document.getElementById("modal-fullscreen-wait-message").innerHTML = "Loading projects...", M.getOrCreateInstance("#modal-fullscreen-wait").show();
    const n = be(ve(), `projects/${Fe.currentUser.uid}/${this.projectRoot}/`);
    rs(n).then((s) => {
      s.exists() && (this.projects = [], s.forEach((function(i) {
        let o = i.val();
        try {
          let a = this.deserialize(o);
          this.projects.push(a);
        } catch (a) {
          console.error(a);
        }
      }).bind(this)));
      let r = this.projects.findIndex((i) => i.isActive === !0);
      if (r < 0 && this.projects.length > 0 && (r = 0, this.projects[0].isActive = !0), this.projects.length > 0) {
        let i = this.projects[r].key;
        this.loadProject(i, e);
      } else
        document.getElementById("project-list").innerHTML = "", document.dispatchEvent(new CustomEvent("project-loaded", { detail: this.activeProject }));
    }).then(() => {
      const s = be(ve(), `folders/${Fe.currentUser.uid}`);
      rs(s).then((r) => {
        r.exists() && (this.folders = [], r.forEach((function(i) {
          let o = i.val();
          this.folders.push(o);
        }).bind(this)));
      }).then(() => {
        document.dispatchEvent(new CustomEvent("projects-loaded", { detail: { projects: this.projects, folders: this.folders } })), M.getOrCreateInstance("#modal-fullscreen-wait").hide();
      });
    }).catch((s) => {
      console.error(s), M.getOrCreateInstance("#modal-fullscreen-wait").hide();
    });
  }
  onLoadProjectClick(e) {
    if (!Je()) {
      if (this.activeProject.dirty) {
        hi("Load Project", "Current project not saved. Continue anyway?", () => this.loadProject(e, "Project loaded."));
        return;
      }
      this.loadProject(e);
    }
  }
  loadProject(e) {
    const n = {};
    this.projects.forEach((s) => {
      (s.isActive === !0 || s.isActive === void 0) && s.key !== e ? (s.isActive = !1, s.key !== void 0 && s.key !== null && (n[`/projects/${Fe.currentUser.uid}/${this.projectRoot}/${s.key}/isActive`] = !1)) : s.key === e && (s.isActive = !0, s.key !== void 0 && s.key !== null && (n[`/projects/${Fe.currentUser.uid}/${this.projectRoot}/${s.key}/isActive`] = !0), this.activeProject = s, document.dispatchEvent(new CustomEvent("project-loaded", { detail: this.activeProject })));
    }), document.dispatchEvent(new CustomEvent("projects-loaded", { detail: { projects: this.projects, folders: this.folders } })), Zs(be(ve()), n);
  }
  disablePrinting() {
    console.error("not implemented");
  }
  enablePrinting() {
    console.error("not implemented");
  }
}
class r3 {
  constructor(e, n = null) {
    this.title = e, this.createdAt = Date.now(), this.modifiedAt = Date.now(), this.key = n, this.projects = [];
  }
}
export {
  d3 as App,
  s3 as checkIsUpgraded,
  Je as featureGate,
  $a as getShapes,
  a3 as hideBootstrapModal,
  l3 as initializeTooltips,
  c3 as setActivePill,
  o3 as showBootstrapModal,
  i3 as showBootstrapTab
};
